export type LanguageCode = 'id' | 'en' | 'zh';

export interface LanguageMeta {
  code: LanguageCode;
  label: string;
  flag: string;
}

export const LANGUAGES: LanguageMeta[] = [
  { code: 'id', label: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
];

type TranslationDict = Record<string, string>;

const id: TranslationDict = {
  // ---- Pembaruan aplikasi ----
  'appUpdate.title': 'Versi baru tersedia',
  'appUpdate.message':
    'Pembaruan ini diperlukan agar Jarvis tetap berjalan dengan benar. Muat ulang halaman untuk melanjutkan.',
  'appUpdate.reload': 'Muat Ulang Sekarang',
  'appUpdate.banner.lead': 'Versi baru Jarvis tersedia.',
  'appUpdate.banner.detail': 'Simpan pekerjaan Anda, lalu muat ulang saat siap.',
  'appUpdate.banner.reload': 'Muat ulang',
  'appUpdate.banner.dismiss': 'Tutup',
  'appUpdate.header.tooltip': 'Versi baru tersedia · klik untuk muat ulang',

  // ---- Pengaturan (personal + perusahaan) ----
  'settings.title': 'Pengaturan',
  'settings.subtitle': 'Sesuaikan pengalaman Jarvis sesuai kebutuhan kerja Anda.',
  'settings.sectionPersonal': 'Preferensi Saya',
  'settings.sectionCompany': 'Pengaturan Perusahaan',
  'settings.docDetection': 'Deteksi Tipe Dokumen Otomatis',
  'settings.docDetectionDesc':
    'Sistem membaca setiap dokumen yang diunggah dan mengisi tipenya untuk Anda. Matikan jika Anda lebih suka memilih tipe dokumen sendiri.',
  'settings.docDetectionNote':
    'Berlaku pada langkah unggah dokumen PIB. Tebakan dari nama berkas tetap berjalan meski deteksi dimatikan.',
  'settings.docDetectionLockedNote':
    'Pengaturan ini dikunci oleh admin perusahaan Anda. Hubungi admin jika Anda memerlukan perubahan.',
  'settings.lockedByCompany': 'Dikunci perusahaan',
  'settings.professionalMode': 'Profesional Mode',
  'settings.professionalModeDesc':
    'Aktifkan untuk menyembunyikan Stamp Duty, Mini Games, dan Trivia Game pada alur pemrosesan.',
  'settings.professionalModeNote':
    'Perubahan mode akan memuat ulang halaman agar antarmuka mengikuti preferensi terbaru Anda.',
  'settings.companyDocDetection': 'Default deteksi untuk seluruh perusahaan',
  'settings.companyDocDetectionDesc': 'Posisi awal deteksi otomatis bagi anggota yang belum pernah mengatur sendiri.',
  'settings.companyLock': 'Kunci pilihan ini',
  'settings.companyLockDesc':
    'Anggota tidak dapat mengubah deteksi otomatis selama dikunci. Pilihan mereka tersimpan dan kembali berlaku setelah kunci dibuka.',
  'settings.companyNote': 'Hanya admin perusahaan yang melihat bagian ini.',
  'settings.saveFailed': 'Gagal menyimpan',
  'settings.saveFailedMsg': 'Pengaturan perusahaan belum tersimpan. Silakan coba lagi.',
  // Language switcher
  'language.switcher': 'Bahasa',
  'language.indonesia': 'Bahasa Indonesia',
  'language.english': 'English',
  'language.chinese': '中文',

  // Sidebar menus
  'menu.mgmtDashboard': 'Dashboard Manajemen',
  'menu.manifest': 'Manifest',
  'menu.dashboard': 'Dasbor',
  'menu.buatAju': 'Buat Aju',
  'menu.draft': 'Draft',
  'menu.docManifes': 'Dok Manifes',
  'menu.theGuardian': 'The Guardian',
  'menu.radar': 'Radar',
  'menu.kepabeanan': 'Kepabeanan',
  'menu.docPabean': 'Dok Pabean',
  'menu.monitoringBlokir': 'Monitoring Blokir',
  'menu.respon': 'Respon',
  'menu.databaseBarang': 'Database Barang',
  'menu.ppftz': 'PPFTZ',
  'menu.kuotaImporEkspor': 'Kuota Impor / Ekspor',
  'menu.shipmentQuota': 'Kuota Pengiriman',
  'menu.hargaReferensi': 'Harga Referensi',
  'menu.cukai': 'Cukai',
  'menu.tutorial': 'Tutorial',
  'menu.suratJalan': 'Surat Jalan',
  'menu.dokumenCk': 'Dokumen CK',
  'menu.billOfMaterial': 'Bill of Material',
  'menu.inventori': 'Inventori',
  'menu.riskSelfCheck': 'Pemeriksaan Mandiri Risiko',
  'menu.customerApproval': 'Persetujuan Pelanggan',
  'menu.approvalRequests': 'Permintaan Persetujuan',
  'menu.emailGroups': 'Grup Email',
  'menu.reviewers': 'Peninjau',
  'menu.rolesPermissions': 'Role & Permission',
  'menu.creditTopup': 'Topup Kredit',
  'menu.langganan': 'Langganan',
  'menu.berita': 'Berita',
  'menu.antaraNews': 'Antara News',
  'menu.cnnIndonesia': 'CNN Indonesia',
  'menu.cnbcIndonesia': 'CNBC Indonesia',
  'menu.republikaNews': 'Republika News',
  'menu.kumparanNews': 'Kumparan News',
  'menu.voaNews': 'VOA News',
  'menu.layananLainnya': 'Layanan Lainnya',
  'menu.stampDuty': 'Stamp',
  'menu.miniGames': 'Mini Games',
  'menu.fileCompress': 'Kompres File',
  'menu.splitPdf': 'Pisah PDF',
  'menu.pengaturan': 'Pengaturan',
  'menu.master': 'Master',
  'menu.ceisaUser': 'Pengguna Ceisa',
  'menu.user': 'Pengguna',
  'menu.seaCarriers': 'Perusahaan Pelayaran',
  'menu.email': 'Email',
  'menu.customerEmailForwarding': 'Penerusan Email Pelanggan',
  'menu.statement': 'Pernyataan',
  'menu.manifestReminder': 'Pengingat Manifest',
  'menu.revokeAccess': 'Cabut Akses',
  'menu.exportBank': 'Export Bank',
  'menu.riwayatPembaruan': 'Riwayat Pembaruan',

  // Sidebar badges
  'badge.new': 'Baru',
  'badge.bod': 'BOD',
  'badge.mulai': 'Mulai',
  'badge.aiReady': 'AI Siap',

  // Sidebar footer / search
  'sidebar.manageAccount': 'Kelola akun',
  'sidebar.impersonate': 'Jadikan Pengguna',
  'sidebar.impersonating': 'Meniru Pengguna',
  'sidebar.changeTheme': 'Ganti Tema',
  'sidebar.theme': 'Tema',
  'theme.jarvis': 'JARVIS',
  'theme.jarvisNight': 'JARVIS Night',
  'theme.horizon': 'Horizon',
  'theme.horizonNight': 'Horizon Night',
  'theme.horizonDawn': 'Horizon Dawn',
  'theme.horizonDusk': 'Horizon Dusk',
  'theme.horizonMist': 'Horizon Mist',
  'sidebar.logout': 'Keluar',
  'sidebar.loggingOut': 'Keluar...',
  'sidebar.collapse': 'Ciutkan sidebar',
  'sidebar.expand': 'Perluas sidebar',
  'sidebar.quickSearch': 'Cari cepat...',
  'sidebar.noMatches': 'Tidak ada hasil',

  // Login
  'auth.welcome': 'Selamat datang! Masuk untuk mengakses akun Anda',
  'auth.email': 'Alamat email',
  'auth.emailPlaceholder': 'contoh@mail.com',
  'auth.password': 'Kata sandi',
  'auth.passwordPlaceholder': 'Kata sandi Anda',
  'auth.signIn': 'Masuk',
  'auth.or': 'atau',
  'auth.cubeLogin': 'Masuk dengan Akun CUBEforall',
  'auth.reviewerLogin': 'Masuk sebagai Reviewer',
  'auth.cubeErrorTitle': 'Login CUBEforall gagal',
  'auth.demoEndedTitle': 'Masa akun demo telah berakhir',
  'auth.sessionInconsistent': 'Sesi tidak konsisten, silakan masuk kembali.',
  'auth.switchUserEnded': 'Sesi switch user Anda telah berakhir.',
  'docpabean.draft.noAccess': 'Draft ini tidak dapat dibuka dengan akun ini.',
  'demo.badge': 'Akun demo',
  'demo.endsIn': 'berakhir dalam',
  'demo.quotaHint': 'Dokumen yang sudah diproses (ekstraksi) dari kuota akun demo',
  'demo.contactSales': 'Hubungi sales',
  'demo.salesMessage': 'Halo, saya sedang mencoba akun demo Jarvis dan ingin tahu lebih lanjut.',
  'auth.demoEndedMessage':
    'Terima kasih telah mencoba Jarvis. Hubungi tim Jarvis untuk memperpanjang demo atau mulai berlangganan.',

  // Login showcase (right panel of the login page)
  'auth.showcase.headline': 'Dokumen pabean selesai dalam hitungan menit, bukan jam.',
  'auth.showcase.ariaLabel': 'Fitur JARVIS',
  'auth.showcase.play': 'Putar',
  'auth.showcase.pause': 'Jeda',
  'auth.showcase.segBrand': 'JARVIS',
  'auth.showcase.segExtract': 'Ekstraksi AI',
  'auth.showcase.segHs': 'HS & Lartas',
  'auth.showcase.segCeisa': 'CEISA',
  'auth.showcase.segRadar': 'Radar',
  'auth.showcase.segUpload': 'Upload',
  'auth.showcase.extractTitle': 'Ekstraksi AI',
  'auth.showcase.extractDesc': 'Invoice dan packing list dibaca, setiap nilai diberi skor keyakinan.',
  'auth.showcase.tabBarang': 'Barang',
  'auth.showcase.itemsDetected': '{n} item terdeteksi',
  'auth.showcase.reading': 'Membaca dokumen',
  'auth.showcase.draftReady': 'Draft PIB siap ditinjau',
  'auth.showcase.verified': 'Verified',
  'auth.showcase.sampleData': 'Data contoh',
  'auth.showcase.tipVerified': 'Verified',
  'auth.showcase.tipCheck': 'Check',
  'auth.showcase.tipAutoVerified': 'Terverifikasi otomatis dari sumber',
  'auth.showcase.tipClickReview': 'Klik untuk meninjau terhadap sumber',
  'auth.showcase.tipHsConfidence': 'Keyakinan ekstraksi HS code',
  'auth.showcase.hsTitle': 'Validasi HS code dan Lartas',
  'auth.showcase.hsDesc': 'HS code dicek ke INSW, status Lartas dan tarif dihitung otomatis.',
  'auth.showcase.hsCode': 'Kode',
  'auth.showcase.hsNormalized': 'Kode normalisasi',
  'auth.showcase.hsUraian': 'Uraian (ID)',
  'auth.showcase.hsInswYear': 'Tahun INSW',
  'auth.showcase.no': 'Tidak',
  'auth.showcase.tipNoLartas': 'Tidak memerlukan izin Lartas',
  'auth.showcase.tipBm': 'Bea Masuk, tarif MFN',
  'auth.showcase.tipPpn': 'Pajak Pertambahan Nilai',
  'auth.showcase.tipPph': 'PPh Pasal 22 impor, dengan API',
  'auth.showcase.tipPostel': 'Perlu sertifikat Postel',
  'auth.showcase.ceisaTitle': 'Submit ke CEISA 4.0',
  'auth.showcase.ceisaDesc': 'Satu klik kirim, riwayat status mengalir kembali ke JARVIS.',
  'auth.showcase.sent': 'Terkirim',
  'auth.showcase.tipDraft': 'Draft tersimpan di JARVIS',
  'auth.showcase.tipSubmitted': 'Dikirim ke CEISA 4.0',
  'auth.showcase.tipUmum': 'Diterima, penjaluran berjalan',
  'auth.showcase.tipSppb': 'Surat Persetujuan Pengeluaran Barang',
  'auth.showcase.radarTitle': 'Radar manifest',
  'auth.showcase.radarDesc': 'Manifest masuk dan keluar dipantau sebelum kapal tiba.',
  'auth.showcase.vessel': 'Kapal',
  'auth.showcase.remaining': 'Sisa',
  'auth.showcase.uploadTitle': 'Upload hingga 50 dokumen',
  'auth.showcase.uploadDesc': 'Jenis dokumen dikenali otomatis dan dikelompokkan.',
  'auth.showcase.dropHint': 'Tarik dan lepas dokumen',
  'auth.showcase.typesDetected': '{n} jenis dokumen terdeteksi',

  // ---- Sinkron data historis ----
  'syncHistorical.npwpMissingTitleImport': 'NPWP importir belum diisi',
  'syncHistorical.npwpMissingTitleExport': 'NPWP eksportir belum diisi',
  'syncHistorical.npwpMissingBodyImport':
    'Data historis dicari berdasarkan NPWP importir. Lengkapi NPWP importir di tab Entitas, simpan, lalu buka kembali fitur ini.',
  'syncHistorical.npwpMissingBodyExport':
    'Data historis dicari berdasarkan NPWP eksportir. Lengkapi NPWP eksportir di tab Entitas, simpan, lalu buka kembali fitur ini.',

  // Doc Pabean page
  'docpabean.errorLoad': 'Gagal memuat data Dokumen Pabean.',
  'docpabean.retry': 'Coba lagi',
  'docpabean.allStatus': 'Semua Status',
  'docpabean.sortPlaceholder': 'Urutkan',
  'docpabean.filterStatus': 'Filter Status',
  'docpabean.filterBranch': 'Filter Cabang',
  'docpabean.branchMine': 'Cabang Saya',
  'docpabean.branchAll': 'Semua Cabang',
  'docpabean.sortNewest': 'Urutkan: Terbaru',
  'docpabean.sortAjuAsc': 'Nomor Aju (A-Z)',
  'docpabean.sortAjuDesc': 'Nomor Aju (Z-A)',
  'docpabean.sortShipperAsc': 'Nama Shipper (A-Z)',
  'docpabean.sortShipperDesc': 'Nama Shipper (Z-A)',
  'docpabean.sortDateOldest': 'Tanggal Submit AJU (Terlama)',
  'docpabean.sortDateNewest': 'Tanggal Submit AJU (Terbaru)',
  'docpabean.sortItemLeast': 'Total Item (Tersedikit)',
  'docpabean.sortItemMost': 'Total Item (Terbanyak)',
  'docpabean.downloadUsage': 'Unduh Laporan Penggunaan',
  'docpabean.downloadReport': 'Unduh Laporan',
  'docpabean.startDate': 'Tanggal Mulai',
  'docpabean.endDate': 'Tanggal Akhir',
  'docpabean.selectStartDate': 'Pilih tanggal mulai',
  'docpabean.selectEndDate': 'Pilih tanggal akhir',
  'docpabean.docType': 'Jenis Dokumen',
  'docpabean.all': 'Semua',
  'docpabean.cancel': 'Batal',
  'docpabean.download': 'Unduh',
  'docpabean.errSelectDates': 'Pilih tanggal mulai dan tanggal akhir',
  'docpabean.successDownloaded': 'Laporan penggunaan berhasil diunduh',
  'docpabean.errDownload': 'Gagal mengunduh laporan penggunaan',
  'docpabean.errorTitle': 'Error',

  // Doc Pabean credits banner
  'docpabean.remainingCredits': 'Sisa kredit',
  'docpabean.errLoadBalance': 'Gagal memuat saldo',
  'docpabean.viewSubscription': 'Lihat langganan',
  'docpabean.usageThisMonth': 'Penggunaan bulan ini',

  // Doc Pabean download modal
  'docpabean.downloadModalTitle': 'Unduh Laporan',
  'docpabean.loadingOptions': 'Memuat opsi...',
  'docpabean.filterHint':
    'Filter riwayat ekspor berdasarkan nama perusahaan dan/atau rentang tanggal. Nama drafter bersifat opsional.',
  'docpabean.drafterName': 'Nama Drafter (opsional)',
  'docpabean.drafterPlaceholder': 'Cari dan pilih drafter...',
  'docpabean.noDrafters': 'Tidak ada drafter ditemukan',
  'docpabean.companyName': 'Nama Perusahaan',
  'docpabean.companyPlaceholder': 'Cari dan pilih perusahaan...',
  'docpabean.noCompanies': 'Tidak ada perusahaan ditemukan',
  'docpabean.errSelectCompanyDates': 'Pilih perusahaan dan/atau rentang tanggal (nama drafter opsional)',
  'docpabean.errDateRequiredCompany': 'Tanggal mulai dan akhir wajib diisi untuk {company} (DD-MM-YYYY)',
  'docpabean.errEndBeforeStart': 'Tanggal akhir harus sama atau setelah tanggal mulai',
  'docpabean.successReportDownloaded': 'Laporan berhasil diunduh',
  'docpabean.errReportDownload': 'Gagal mengunduh laporan',

  // Doc Pabean table
  'docpabean.colNomorAju': 'Nomor Aju',
  'docpabean.colShipper': 'Nama Shipper',
  'docpabean.colBuyer': 'Nama Buyer',
  'docpabean.colDate': 'Tanggal Submit AJU',
  'docpabean.colRespon': 'Respon',
  'docpabean.colStatus': 'Status',
  'docpabean.colType': 'Type',
  'docpabean.colJenisKategori': 'Jenis | Kategori Ekspor',
  'docpabean.colDrafter': 'Drafter',
  'docpabean.colTotalItem': 'Total Item',
  'docpabean.colApproval': 'Approval',
  'docpabean.colActions': 'Actions',
  'docpabean.colVesselVoy': 'Vessel & Voy',
  'docpabean.colTglTibaEkspor': 'Tanggal ETA / ETD',
  'docpabean.incompleteTitle': 'Sebagian data belum termuat',
  'docpabean.incompleteBody': 'Kolom {list} tidak dapat dimuat saat ini. Data dokumen Anda tidak berubah.',
  'docpabean.incompleteReload': 'Muat ulang',
  'docpabean.incompleteCell': 'Gagal dimuat',
  'docpabean.incompleteCellTooltip': 'Data tidak dapat dimuat. Klik Muat ulang di atas.',
  'docpabean.incompleteFiles': 'Berkas',
  'docpabean.tooltipTglTiba': 'Perkiraan tanggal tiba',
  'docpabean.tooltipTglEkspor': 'Tanggal ekspor',
  'docpabean.sortTglTibaEksporNearest': 'Tanggal ETA/ETD terdekat',
  'docpabean.sortTglTibaEksporFarthest': 'Tanggal ETA/ETD terjauh',
  'docpabean.cardVessel': 'Vessel',
  'docpabean.cardTibaEkspor': 'ETA/ETD',
  'docpabean.kolom.button': 'Kolom',
  'docpabean.kolom.title': 'Tampilkan kolom',
  'docpabean.kolom.alwaysShown': 'Nomor Aju dan Actions selalu tampil.',
  'docpabean.kolom.display': 'Tampilan',
  'docpabean.kolom.showLogos': 'Tampilkan logo / inisial perusahaan',
  'docpabean.kolom.showFlags': 'Tampilkan bendera negara',
  'docpabean.kolom.reset': 'Reset ke default',
  'docpabean.filterShipmentType': 'Jenis Pengiriman',
  'docpabean.filterNamaPerusahaan': 'Nama Perusahaan',
  'docpabean.filterDrafter': 'Nama Drafter',
  'docpabean.filterMotType': 'Tipe MOT',
  'docpabean.motSea': 'Angkutan laut',
  'docpabean.motAir': 'Angkutan udara',
  'docpabean.filterCountry': 'Negara Shipper/Konsinyi',
  'docpabean.statusHistory': 'Riwayat Status',
  'docpabean.latest': 'Terbaru',
  'docpabean.respon': 'Respon',
  'docpabean.tooltipVerified': 'Lengkap: Invoice + BL/AWB',
  'docpabean.tooltipView': 'Lihat',
  'docpabean.tooltipViewEdit': 'Lihat / Edit',
  'docpabean.tooltipEdit': 'Edit',
  'docpabean.tooltipCopy': 'Salin',
  'docpabean.tooltipUpload': 'Unggah Berkas',
  'docpabean.tooltipSyncRespon': 'Sinkron Respon',
  'docpabean.tooltipDelete': 'Hapus',
  'docpabean.tooltipPreviewPdf': 'Pratinjau PDF',
  'docpabean.tooltipPreviewPdfNoAju': 'Nomor AJU belum tersedia',
  'docpabean.pdfPreview.title': 'Pratinjau {doc}',
  'docpabean.pdfPreview.kindFinal': 'Final (NOPEN)',
  'docpabean.pdfPreview.kindDraft': 'Draft CEISA',
  'docpabean.pdfPreview.fallbackTitle': 'Dokumen final belum bisa diambil',
  'docpabean.pdfPreview.fallbackBody':
    'Dokumen ini sudah mendapat NPE/SPPB, tetapi formulir final gagal diambil dari CEISA. Yang ditampilkan adalah draft CEISA.',
  'docpabean.pdfPreview.loading': 'Mengambil dokumen dari CEISA…',
  'docpabean.pdfPreview.loadingHint':
    'Jika dokumen belum pernah dibuat, CEISA perlu waktu untuk menyiapkannya — bisa sampai sekitar satu menit saat CEISA sedang lambat.',
  'docpabean.pdfPreview.docGeneric': 'Dokumen',
  'docpabean.pdfPreview.refreshDraft': 'Perbarui Draft',
  'docpabean.pdfPreview.download': 'Unduh',
  'docpabean.pdfPreview.openNewTab': 'Buka di Tab Baru',
  'docpabean.pdfPreview.errorTitle': 'Dokumen tidak dapat ditampilkan',
  'docpabean.pdfPreview.errorGeneric': 'Gagal mengambil dokumen. Silakan coba lagi.',
  'docpabean.pdfPreview.errorBilling': 'Langganan belum dibayar / kredit tidak cukup — preview tidak dapat dibuka.',
  'docpabean.pdfPreview.retry': 'Coba Lagi',
  'docpabean.deleteConfirm':
    'Hapus dokumen {nomor} dari daftar? Dokumen yang sudah terkirim ke CEISA tidak terpengaruh.',
  'docpabean.deleteCancel': 'Batal',
  'docpabean.deleteFiledWarning':
    'Dokumen ini sudah terdaftar di CEISA. Menghapus hanya menyembunyikannya dari Jarvis — dokumen tetap ada di CEISA.',
  'docpabean.showDeleted': 'Tampilkan yang dihapus',
  'docpabean.deletedBadge': 'Dihapus',
  'docpabean.tooltipRestore': 'Pulihkan',
  'docpabean.restoreConfirm': 'Pulihkan dokumen {nomor} ke daftar?',
  'docpabean.restore': 'Pulihkan',
  'docpabean.delete': 'Hapus',
  'docpabean.loadingData': 'Memuat data...',
  'docpabean.emptyFilter': 'Tidak ada dokumen untuk filter saat ini.',
  'docpabean.page': 'Hal',
  'docpabean.company': 'Perusahaan',
  'docpabean.proses': 'Proses',
  'docpabean.totalItemLabel': 'Total Item',
  'docpabean.country': 'Negara',
  'docpabean.export': 'Ekspor',
  'docpabean.import': 'Impor',
  'docpabean.justNow': 'baru saja',
  'docpabean.ago': 'yang lalu',
  'docpabean.approved': 'Disetujui',
  'docpabean.waiting': 'Menunggu',
  'docpabean.needRevision': 'Perlu Revisi',
  'docpabean.rejected': 'Ditolak',
  'docpabean.cancelled': 'Dibatalkan',
  'docpabean.scheduled': 'Dijadwalkan',
  // Submit gate: Incoterm FOB/FCA declared with Freight 0 (issue #234)
  'docpabean.freightZero.title': 'Freight 0 — Periksa Komponen Biaya',
  'docpabean.freightZero.body':
    'Incoterm {incoterm} mengharuskan Freight diisi sebagai komponen biaya terpisah, karena biaya angkut tidak termasuk dalam harga invoice. Freight saat ini masih 0, sehingga nilai pabean yang dilaporkan bisa salah.',
  'docpabean.freightZero.hint':
    'Isi Biaya Transportasi (Freight) pada Informasi Komponen Biaya, lalu simpan. Setelah Freight lebih besar dari 0, dokumen dapat dikirim ke CEISA.',
  'docpabean.freightZero.cta': 'Buka Komponen Biaya',
  'docpabean.freightZero.cancel': 'Batal',
  // Upload freight screenshot → extract value + currency (issue #235)
  'docpabean.freightUpload.dropTitle': 'Unggah screenshot atau PDF freight',
  'docpabean.freightUpload.dropHint':
    'Tarik dan lepas gambar atau PDF dari email atau WhatsApp ke sini, klik untuk memilih file, atau tempel dengan {paste}',
  'docpabean.freightUpload.ofUploaded': 'Dokumen Ocean Freight (OF) sudah diunggah',
  'docpabean.freightUpload.ofUploadedFiles': 'Nilai freight sudah dibaca dari {files} saat PIB dibuat.',
  'docpabean.freightUpload.ofUploadedHint': 'Nilai freight sudah dibaca dari dokumen tersebut saat PIB dibuat.',
  'docpabean.freightUpload.ofUploadedOverride':
    'Unggah screenshot atau PDF di bawah ini hanya jika nilai freight perlu diganti.',
  'docpabean.freightUpload.ofReading.converted':
    'Terbaca {from} {amount}, dikonversi ke {to} {converted} dengan kurs NDPBM ({kurs}) karena valuta transaksi {to}.',
  'docpabean.freightUpload.ofReading.sameCurrency': 'Terbaca {from} {amount}, sama dengan valuta transaksi.',
  'docpabean.freightUpload.ofReading.kursUnavailable':
    'Terbaca {from} {amount}, belum dikonversi ke {to} karena kurs NDPBM tidak tersedia saat PIB dibuat — periksa nilai freight.',
  'docpabean.freightUpload.ofReading.checkCurrency': 'Terbaca {amount}; mata uangnya perlu diperiksa.',
  'docpabean.freightUpload.ofReading.read': 'Terbaca {amount}.',
  'docpabean.freightUpload.ofReading.kurs': '1 {code} = Rp {rate}',
  'docpabean.freightUpload.reading': 'Membaca file...',
  'docpabean.freightUpload.readingHint': 'Biasanya hanya perlu beberapa detik',
  'docpabean.freightUpload.detected': 'Freight terdeteksi: {currency} {amount}',
  'docpabean.freightUpload.detectedSub': 'Dibaca otomatis dari file ({pct}% yakin, {method})',
  'docpabean.freightUpload.detectedSubNoPct': 'Dibaca otomatis dari file ({method})',
  'docpabean.freightUpload.mismatchInline':
    'Freight terdeteksi: {currency} {amount}, berbeda dari mata uang transaksi ({txn})',
  'docpabean.freightUpload.use': 'Gunakan nilai ini',
  'docpabean.freightUpload.useAs': 'Gunakan sebagai {currency}',
  'docpabean.freightUpload.review': 'Tinjau konversi',
  'docpabean.freightUpload.retry': 'Coba lagi',
  'docpabean.freightUpload.dismiss': 'Tutup',
  'docpabean.freightUpload.lowConfidence': 'Keyakinan rendah ({pct}%). Periksa nilai ini sebelum digunakan.',
  'docpabean.freightUpload.notFound': 'Freight tidak terbaca dari file ini',
  'docpabean.freightUpload.notFoundHint':
    'Coba file lain yang memuat nilai freight, atau isi manual pada Informasi Komponen Biaya.',
  'docpabean.freightUpload.currencyUnknown':
    'Nilai {amount} terbaca, tetapi mata uangnya tidak dapat dipastikan dari gambar.',
  'docpabean.freightUpload.invalidType': 'File harus berupa gambar (JPEG/PNG/WebP) atau PDF.',
  'docpabean.freightUpload.tooLarge': 'Ukuran file maksimal 10 MB.',
  'docpabean.freightUpload.failed': 'Gagal membaca file: {message}',
  'docpabean.freightUpload.applyFailed': 'Gagal menyimpan freight: {message}',
  'docpabean.freightUpload.applied': 'Freight {currency} {amount} tersimpan ke Informasi Komponen Biaya',
  'docpabean.freightUpload.appliedInline': 'Freight {value} digunakan',
  'docpabean.freightUpload.appliedHintField': 'Tersimpan ke Informasi Komponen Biaya',
  'docpabean.freightUpload.appliedFrom.converted': 'Dari {currency} {amount}, dikonversi ke {txn} dengan kurs NDPBM',
  'docpabean.freightUpload.appliedFrom.original':
    'Angka {amount} dimasukkan apa adanya sebagai {txn} (terbaca sebagai {currency})',
  'docpabean.freightUpload.appliedFrom.assumed':
    'Angka {amount} dianggap sebagai {txn}; mata uang tidak terbaca dari file',
  'docpabean.freightUpload.appliedHintRow': 'Terisi di baris ini. Klik Simpan untuk menyimpan.',
  'docpabean.freightUpload.method.ocr': 'OCR',
  'docpabean.freightUpload.method.gemini': 'AI',
  'docpabean.freightUpload.method.pdf-text': 'teks PDF',
  'docpabean.freightUpload.method.pdf-ocr': 'OCR halaman PDF',
  'docpabean.freightUpload.mismatch.title': 'Mata uang freight berbeda',
  'docpabean.freightUpload.mismatch.body':
    'Freight terdeteksi dalam {detected} ({detected} {detectedAmount}). Transaksi ini berdenominasi {txn}. Kami akan mengonversi {detected} → {txn} menjadi ±{converted} {txn} menggunakan kurs NDPBM. Gunakan hasil konversi ini?',
  'docpabean.freightUpload.mismatch.bodyNoRate':
    'Freight terdeteksi dalam {detected} ({detected} {detectedAmount}), sedangkan transaksi ini berdenominasi {txn}.',
  'docpabean.freightUpload.mismatch.rate':
    'Kurs NDPBM {detected}: 1 {detected} = Rp {ndpbmSrc}\nKurs NDPBM {txn}: 1 {txn} = Rp {ndpbmTxn}\nHasil: 1 {detected} ≈ {rate} {txn}',
  'docpabean.freightUpload.mismatch.noRate':
    'Kurs NDPBM untuk konversi tidak tersedia saat ini, sehingga hasil konversi tidak dapat dihitung. Anda dapat memakai nilai asli atau mengisi manual.',
  'docpabean.freightUpload.mismatch.valutaHint':
    'Jika invoice memang dalam {detected}, ubah Valuta pada kartu Harga terlebih dahulu, lalu unggah ulang gambarnya.',
  'docpabean.freightUpload.mismatch.useConverted': 'Gunakan hasil konversi',
  'docpabean.freightUpload.mismatch.useOriginal': 'Masukkan {amount} sebagai {txn}',
  'docpabean.freightUpload.mismatch.cancel': 'Batal',

  // Status / Respon history modal
  'statushistory.title': 'Riwayat Status',
  'statushistory.loading': 'Memuat...',
  'statushistory.document': 'Dokumen',
  'statushistory.by': 'oleh',
  'statushistory.totalItems': 'Total Item',
  'statushistory.item': 'item',
  'statushistory.items': 'items',
  'statushistory.country': 'Negara',
  'statushistory.file': 'File',
  'statushistory.totalTime': 'Total Waktu',
  'statushistory.noData': 'Tidak ada data tersedia',
  'statushistory.viewResponHistory': 'Lihat Riwayat Respon',
  'statushistory.errFetch': 'Gagal memuat riwayat status',
  'statushistory.errGeneric': 'Kesalahan memuat riwayat status',

  // Buat Aju page
  'buataju.import': 'Import',
  'buataju.importDesc': 'Buat dokumen pabean untuk impor barang ke Indonesia.',
  'buataju.export': 'Export',
  'buataju.exportDesc': 'Buat dokumen pabean untuk ekspor barang dari Indonesia.',
  'buataju.bc33Desc':
    'Pemberitahuan Ekspor Barang Melalui atau Dari PLB — untuk ekspor melalui/dari Pusat Logistik Berikat.',
  'buataju.ppftzDesc': 'Buat dokumen FTZ (511) dari Invoice, Packing List, dan B/L dengan AI, atau isi manual.',
  'buataju.bc16Desc': 'Pemasukan barang impor ke Pusat Logistik Berikat (PLB).',
  'buataju.bc23Desc': 'Pemasukan barang impor ke TPB dari kawasan pabean atau TPS.',
  'buataju.bc25Desc': 'Pengeluaran barang impor dari TPB ke TLDDP untuk impor dipakai.',
  'buataju.bc261Desc': 'Pengeluaran sementara barang dari TPB ke TLDDP dengan jaminan.',
  'buataju.bc262Desc': 'Pemasukan kembali barang eks pengeluaran sementara ke TPB.',
  'buataju.bc27Desc': 'Pemindahan barang antar TPB, ke KEK, atau ke kawasan bebas.',
  'buataju.bc28Desc': 'Pengeluaran barang dari PLB untuk impor dipakai atau sementara.',
  'buataju.bc40Desc': 'Pemasukan barang asal TLDDP ke Tempat Penimbunan Berikat.',
  'buataju.bc41Desc': 'Pengeluaran barang asal TLDDP dari TPB kembali ke TLDDP.',
  'buataju.bcp3betDesc': 'Dokumen pemberitahuan untuk kegiatan pameran berikat (P3BET).',
  'buataju.popular': 'Populer',
  'buataju.limitedAccess': 'Akses Terbatas',
  'buataju.comingSoon': 'Segera Hadir',
  'buataju.new': 'Baru',
  'buataju.locked': 'Terkunci',
  'buataju.start': 'Mulai',
  'buataju.badge': 'Proses Dokumen Pabean dengan Mudah',
  'buataju.title': 'Pilih Jenis Dokumen',
  'buataju.subtitle':
    'Mulai perjalanan Anda dengan memilih jenis dokumen pabean yang sesuai dengan kebutuhan bisnis Anda.',
  'buataju.typesAvailable': 'jenis tersedia',
  'buataju.tpb': 'TPB',
  'buataju.tpbDesc': 'Tempat Penimbunan Berikat',
  'buataju.codeImport': 'Import',
  'buataju.codeExport': 'Export',
  'buataju.codeEkspor': 'Ekspor',
  'buataju.codePpftz': 'PPFTZ',
  'buataju.codeTpb': 'TPB',

  // Doc Pabean Upload page
  'upload.back': 'Kembali',
  'upload.title': 'Upload Dokumen',
  'upload.subtitle': 'Upload dan kelompokkan dokumen pabean Anda.',
  'upload.backToWizard': 'Kembali ke alur wizard 3 langkah',
  'upload.useWizard': 'Pakai Wizard',
  'upload.documents': 'Dokumen',
  'upload.processing': 'Memproses...',
  'upload.grouped': 'Telah dikelompokkan',
  'upload.readyToProcess': 'Siap diproses',
  'upload.successCount': '{n} berhasil',
  'upload.failedCount': '{n} gagal',
  'upload.reset': 'Reset',
  'upload.continueReview': 'Lanjut ke Review',
  'upload.uploadDocs': 'Upload {n} Dokumen',
  'upload.processDocs': 'Process Dokumen',
  'upload.uploading': 'Uploading... {p}%',
  'upload.groupingDocs': 'Mengelompokkan dokumen berdasarkan jenis...',
  'upload.resultsTitle': 'Hasil Upload Dokumen',
  'upload.total': 'Total',
  'upload.success': 'Berhasil',
  'upload.failed': 'Gagal',
  'upload.caution': 'Perhatian',
  'upload.cautionMsg':
    'Beberapa dokumen gagal diupload. Anda dapat mencoba kembali atau melanjutkan dengan dokumen yang berhasil.',
  'upload.successDocs': 'Dokumen Berhasil ({n})',
  'upload.failedDocs': 'Dokumen Gagal ({n})',
  'upload.docType': 'Jenis: {type}',
  'upload.noDocType': 'Tanpa jenis dokumen',
  'upload.errorLabel': 'Error: {msg}',
  'upload.reUpload': 'Upload Ulang',
  'upload.continue': 'Lanjutkan',
  'upload.errRequiredTransport': 'Wajib ada dokumen BL, AWB, MBL, atau MAWB',
  'upload.errCeisaCombine': 'Excel CEISA tidak bisa digabung',
  'upload.errCeisaCombineMsg': 'File Excel CEISA harus diupload sendiri, tidak boleh digabung dengan dokumen lain.',
  'upload.errNoFile': 'Tidak ada file',
  'upload.errNoFileMsg': 'Silakan tambahkan file terlebih dahulu',
  'upload.errNoType': 'Jenis dokumen belum dipilih',
  'upload.errNoTypeMsg': '{n} file belum memiliki jenis dokumen',
  'upload.errEmptyFile': 'ukuran 0 byte (file kosong)',
  'upload.errInvalidPdf': 'bukan PDF valid (header "{magic}", size {size} byte)',
  'upload.errInvalidFile': 'File tidak valid',
  'upload.successUploaded': 'Upload Berhasil',
  'upload.successUploadedMsg': 'Semua dokumen berhasil diupload.',
  'upload.doneUploading': 'Upload Selesai',
  'upload.partialMsg': '{success} dari {total} dokumen berhasil diupload.',
  'upload.errCeisaProcess':
    'Gagal memproses Excel CEISA: {msg}. File telah tersimpan, silakan lanjutkan di halaman draft.',
  'upload.errUpload': 'Terjadi kesalahan saat mengupload dokumen: {msg}',
  'upload.errUploadFile': 'Gagal mengupload file.',
  'upload.errNoBatch': 'Batch UUID tidak ditemukan. Silakan upload dokumen terlebih dahulu.',
  'upload.uploadGagal': 'Upload gagal: Server tidak mengembalikan data yang valid',
  'upload.ceisaFileNotFound': 'File EXCEL CEISA tidak ditemukan',
  'upload.emptyHeader': 'File yang akan diupload ({n})',
  'upload.searchPlaceholder': 'Cari file...',
  'upload.selectDocType': 'Pilih jenis dokumen',
  'upload.alreadySelected': 'sudah dipilih',
  'upload.noMatch': 'Tidak ada file cocok dengan "{q}"',
  'upload.noFiles': 'Belum ada file yang diupload',
  'upload.dragDrop': 'Drag & drop atau',
  'upload.clickBrowse': 'klik untuk browse',
  'upload.dropPdf': 'Drop file PDF disini',
  'upload.dropPdfExcel': 'Drop file PDF/Excel disini',
  'upload.dropPdfExcelImg': 'Drop file PDF/Excel/foto (JPG/PNG) disini',
  'upload.maxFiles': 'Maks. {n} file',
  'upload.enlarge': 'Perbesar',
  'upload.shrink': 'Perkecil',
  'upload.fmtNotMatch': 'Format tidak sesuai',
  'upload.fmtPdfOnly': 'Hanya file PDF yang diperbolehkan',
  'upload.fmtPdfExcel': 'Hanya file PDF dan Excel yang diperbolehkan',
  'upload.fmtPdfExcelImg': 'Hanya file PDF, Excel, dan foto (JPG/PNG) yang diperbolehkan',
  'upload.tooMany': 'Terlalu banyak file',
  'upload.tooManyMsg': 'Maksimal {n} file dapat diupload',
  'upload.cantSelect': 'Tidak dapat memilih',
  'upload.masterOnlyOne': 'Hanya 1 {name} yang diperbolehkan',
  'upload.fileCount': '{n} file',
  'upload.groupedHeader': 'Dokumen telah dikelompokkan',
  'upload.dragReorder': 'Drag untuk ubah urutan',
  'upload.splitTitle': 'Pisah PDF menjadi beberapa dokumen',
  'upload.splitHint': 'Pilih file PDF untuk menandai segmen, atau klik "Pisah otomatis" agar dibaca otomatis.',
  'upload.notPdf': 'File ini bukan PDF',
  'upload.pages': '{n} hal',
  'upload.activeSeg': 'Aktif: Seg {n}',
  'upload.pageOf': 'Halaman {cur} / {total}',
  'pdf.zoomIn': 'Perbesar (Ctrl + scroll)',
  'pdf.zoomOut': 'Perkecil (Ctrl + scroll)',
  'pdf.zoomReset': 'Reset zoom',
  'pdf.documentOf': 'Dokumen {cur} / {total}',
  'pdf.pageOf': 'Hal. {cur} / {total}',
  'pdf.prevDocument': 'Dokumen sebelumnya',
  'pdf.nextDocument': 'Dokumen berikutnya',
  'pdf.download': 'Unduh',
  'pdf.close': 'Tutup PDF',
  'upload.smartSplit': 'Pisah otomatis',
  'upload.smartSplitHint': 'Pisah otomatis — baca isi PDF dan pisahkan per dokumen',
  'upload.smartSplitWorking': 'Membaca dokumen',
  'upload.smartSplitNeedsPages': 'Perlu minimal 2 halaman',
  'upload.smartSplitResult': '{n} dokumen ditemukan · {method}',
  'upload.smartSplitViaAi': 'dibaca AI',
  'upload.smartSplitViaText': 'dari teks PDF',
  'upload.smartSplitSingle': 'Hanya satu dokumen di file ini — tidak ada yang perlu dipisah.',
  'upload.smartSplitFailed': 'Deteksi gagal',
  'upload.smartSplitFailedMsg': 'Tidak dapat membaca dokumen. Tandai segmen secara manual.',
  'upload.smartSplitAll': 'Deteksi semua',
  'upload.smartSplitAllHint': 'Baca semua PDF sekaligus — jenis dokumen dan batas halaman',
  'upload.smartSplitAllProgress': 'Membaca {done}/{total}',
  'upload.aiDetectQueued': 'Menunggu',
  'upload.aiDetectFailed': 'Deteksi gagal — coba lagi',
  'upload.mismatchDetected': 'Isi file terbaca sebagai {type} ({pct}%), bukan {declared}',
  'upload.mismatchUse': 'Gunakan {type}',
  'upload.mismatchIgnore': 'Abaikan',
  'upload.junkSuggest': 'Sepertinya bukan dokumen pengiriman ({pct}%) — abaikan?',
  'upload.junkSkip': 'Abaikan dokumen',
  'upload.junkKeep': 'Tetap proses',
  'upload.junkSkipped': 'Diabaikan',
  'upload.errAllJunk': 'Tidak ada dokumen untuk diproses',
  'upload.errAllJunkMsg': 'Semua file ditandai Dokumen lain-lain (abaikan). Ganti jenisnya untuk memproses.',
  'upload.siblingHint': 'Terbaca {type} — mungkin lebih tepat',
  'upload.bundleDetected': 'Berisi {n} dokumen ({types}) — pisahkan dulu',
  'upload.bundleOpen': 'Buka pemisah',
  // ---- Upload per folder (upload_folder_ux) + Review check ----
  'upload.folders.todo.needsType': 'Belum ada jenis dokumen',
  'upload.folders.todo.junk': 'Bukan dokumen pengiriman?',
  'upload.folders.todo.bundle': 'Berisi {n} dokumen — pisahkan?',
  'upload.folders.todo.belongs': 'Sepertinya {type} — pindahkan?',
  'upload.folders.todo.mismatch': 'Isinya {type}, bukan {folder}',
  'upload.folders.todo.missingFolder': 'Belum ada file — wajib diisi',
  'upload.folders.todoLook': 'Lihat',
  'upload.folders.todoHint': 'Klik Lihat untuk menuju file-nya, lalu pilih jawaban di kotak kuning.',
  'upload.folders.todoNone': 'Semua file sudah beres',
  'upload.folders.todoTitle': 'Perlu dicek ({n})',
  'upload.folders.folderAttention': '{n} perlu dicek',
  'upload.folders.attention': 'Perlu dicek',
  'upload.folders.dropAllAnywhere': 'Bisa juga dijatuhkan di mana saja di halaman ini.',
  'upload.folders.emptyDrop': 'Seret PDF ke sini atau',
  'upload.folders.BL.title': 'BL / AWB',
  'upload.folders.BL.hint': 'Bill of Lading, Master B/L, Air Waybill, Master AWB',
  'upload.folders.I.title': 'Invoice',
  'upload.folders.I.hint': 'Commercial / proforma invoice — masukkan semua halaman',
  'upload.folders.PL.title': 'Packing List',
  'upload.folders.PL.hint': 'Berat & kemasan',
  'upload.folders.COO.title': 'COO / E-COO',
  'upload.folders.COO.hint': 'Certificate of Origin (fasilitas FTA)',
  'upload.folders.OTH.title': 'Lainnya',
  'upload.folders.OTH.hint': 'OF, SKI, LS, izin, Excel, dll. — JARVIS mendeteksi jenisnya',
  'upload.folders.typeAria': 'Jenis dokumen',
  'upload.folders.typeOther': 'Jenis lain… (pindah ke Lainnya)',
  'upload.folders.badgeSmart': 'Smart detect',
  'upload.folders.badgeDone': 'Lengkap',
  'upload.folders.badgeCount': '{n} file',
  'upload.folders.badgeRequired': 'Wajib',
  'upload.folders.badgeOptional': 'Opsional',
  'upload.folders.clickToPick': 'klik untuk pilih',
  'upload.folders.addMore': 'Tambah file {folder}',
  'upload.folders.dropHere': 'Lepaskan di sini → {folder}',
  'upload.folders.dropAllTitle': 'Seret semua sekaligus',
  'upload.folders.dropAllOr': 'atau',
  'upload.folders.dropAllAi': 'JARVIS memasukkan ke folder, Anda konfirmasi.',
  'upload.folders.dropAllName': 'file dimasukkan ke folder menurut namanya, Anda konfirmasi.',
  'upload.folders.dropAllLimits': 'PDF & Excel · maks. {n} file · {mb} MB per file · {count}/{n}',
  'upload.folders.dropOverlay': 'Lepaskan untuk diurutkan JARVIS — atau lepaskan tepat di sebuah folder',
  'upload.folders.sorting': 'JARVIS sedang mengurutkan {n} file{progress}…',
  'upload.folders.andMore': '+{n} file lagi',
  'upload.folders.reading': 'JARVIS membaca…',
  'upload.folders.detected': 'JARVIS · {pct}%',
  'upload.folders.dragHint': 'Seret ke folder lain',
  'upload.folders.remove': 'Hapus file',
  'upload.folders.openSplitter': 'Buka pemisah',
  'upload.folders.openSplitterHint': 'Buka pemisah halaman — pisahkan file ini jadi beberapa dokumen',
  'upload.folders.sortedAi': 'diurutkan JARVIS {pct}%',
  'upload.folders.sortedFilename': 'diurutkan dari nama file',
  'upload.folders.mismatch': 'Isi file terbaca sebagai {type} ({pct}%), bukan {folder}.',
  'upload.folders.belongs': 'Terbaca sebagai {type} — dokumen ini punya folder sendiri.',
  'upload.folders.moveTo': 'Pindahkan ke {folder}',
  'upload.folders.keepIn': 'Tetap di {folder}',
  'upload.folders.leaveHere': 'Biarkan',
  'upload.folders.bundle': 'File ini berisi {n} dokumen:',
  'upload.folders.bundlePart': '{type} hal {pages}',
  'upload.folders.unknownType': 'Jenis belum dikenali',
  'upload.folders.splitToFolders': 'Pisahkan ke folder masing-masing',
  'upload.folders.keepWhole': 'Semua tetap {folder}',
  'upload.folders.junk': 'Sepertinya bukan dokumen pengiriman (yakin {pct}%).',
  'upload.folders.skipFile': 'Abaikan file ini',
  'upload.folders.suggestion':
    'Hal {page} ada tulisan "{phrase}". Tetap dibaca sebagai {folder} karena ada di folder {folderName}.',
  'upload.folders.movePageOut': 'Hal {page} sebenarnya {type} → pindahkan ke Lainnya',
  'upload.folders.ok': 'Oke',
  'upload.folders.readFailed': 'JARVIS gagal membaca file ini. Jenisnya tetap {folder}.',
  'upload.folders.readFailedOther': 'JARVIS gagal membaca file ini. Pilih jenisnya sendiri.',
  'upload.folders.retry': 'Coba baca lagi',
  'upload.folders.tooBigTitle': 'File terlalu besar',
  'upload.folders.tooBigMsg': 'Ukuran file maksimal {mb} MB, dan file kosong tidak bisa diunggah.',
  'upload.folders.excelToOther': 'File Excel dimasukkan ke folder Lainnya — hanya folder itu yang menerima Excel.',
  'upload.folders.excelOnlyOther': 'File Excel hanya bisa di folder Lainnya.',
  'upload.folders.moved': '{name} dipindahkan ke {folder}.',
  'upload.folders.splitDone': '{name} dipisah jadi {n} dokumen, masing-masing masuk ke foldernya.',
  'upload.folders.pageMoved': 'Hal {page} dipindahkan ke Lainnya.',
  'upload.folders.splitterTitle': 'Pisahkan halaman',
  'upload.folders.checklistTitle': 'Kelengkapan',
  'upload.folders.optional': 'opsional',
  'upload.folders.excelExempt': 'tidak perlu untuk upload Excel',
  'upload.folders.continue': 'Lanjut ke Review ({n} dokumen)',
  'upload.folders.reviewNext': 'Review dokumen ({n} belum dicek)',
  'upload.folders.reviewNextHint': 'Buka dokumen berikutnya yang belum dicek',
  'upload.folders.readyHint': 'Berikutnya: Review (jenis & halaman bisa diubah).',
  'upload.folders.tip':
    'Salah folder? Seret file (pegang ⋮⋮ di kiri) ke folder lain — bisa berkali-kali, termasuk ke Lainnya — atau ganti Jenis dokumen-nya.',
  'upload.folders.otherTypesGroup': 'Jenis dokumen lain',
  'upload.folders.noTypeFound': 'Jenis tidak ditemukan',
  'upload.folders.dropToMove': 'Lepaskan untuk pindah ke {folder}',
  'upload.folders.startOver': 'Mulai ulang',
  'upload.folders.reason.empty': 'Lengkapi dokumen wajib dulu.',
  'upload.folders.reason.reading': 'JARVIS masih membaca {n} file…',
  'upload.folders.reason.allSkipped': 'Semua file diabaikan. Pilih jenis untuk setidaknya satu file.',
  'upload.folders.reason.needInvoice': 'Wajib ada dokumen Invoice',
  'upload.folders.reason.untyped': 'Pilih jenis untuk {n} file di folder Lainnya.',
  'upload.folders.reason.pending': 'Selesaikan daftar Perlu dicek di atas dulu.',
  'upload.folders.startHint':
    'Setelah file masuk, JARVIS mengelompokkannya per jenis dan menampilkan pratinjau untuk Anda cek satu per satu.',
  'upload.folders.otherFolders': 'Atau lepaskan langsung di folder',
  'upload.folders.chipAdd': 'Klik untuk menambah file {folder}',
  'upload.folders.chipShow': 'Klik untuk melihat file {folder}',
  'upload.folders.preview.empty': 'Pilih dokumen di daftar kiri untuk melihat isinya.',
  'upload.folders.preview.waiting': 'JARVIS sedang membaca {n} file. Pratinjau muncul begitu file masuk folder.',
  'upload.folders.preview.excel':
    'Pratinjau tidak tersedia untuk file Excel. Pastikan nama file dan jenisnya sudah benar.',
  'upload.folders.preview.failed': 'Pratinjau gagal dimuat. File tetap bisa diunggah.',
  'upload.folders.preview.page': 'Hal {n} / {total}',
  'upload.folders.preview.prevPage': 'Halaman sebelumnya',
  'upload.folders.preview.nextPage': 'Halaman berikutnya',
  'upload.folders.preview.prev': 'Dokumen sebelumnya',
  'upload.folders.preview.next': 'Dokumen berikutnya',
  'upload.folders.preview.split': 'Pisahkan halaman',
  'upload.folders.preview.close': 'Tutup pratinjau',
  'upload.folders.view': 'Lihat',
  'upload.folders.viewing': 'Sedang dilihat',
  'upload.folders.preview.reading': 'Tunggu JARVIS selesai membaca file ini.',
  'upload.folders.preview.needsType': 'Pilih jenis dokumennya dulu di daftar.',
  'upload.folders.preview.skipped': 'File ini diabaikan dan tidak ikut diunggah.',
  'upload.folders.preview.hasWarning': 'File ini punya peringatan di daftar — jawab juga sebelum lanjut.',
  'upload.folders.reason.unchecked': '{n} dokumen belum dicek.',
  'upload.folders.check.label': 'Sudah dicek',
  'upload.folders.check.tally': 'Dicek {done}/{total}',
  'upload.folders.check.bar': 'Dicek {done}/{total}',
  'upload.folders.check.scrollFirst': 'Klik Berikutnya sampai semua halaman dilihat dulu',
  'upload.folders.check.answerFirst': 'Jawab peringatan di baris ini dulu',
  'upload.folders.reason.unapplied': '{n} file punya halaman yang diubah jenisnya — klik “Terapkan pemisahan” dulu.',
  'upload.folders.panelWarn.bundleTitle': 'File ini berisi {n} dokumen',
  'upload.folders.final.countDocs': '{n} dokumen',
  'upload.folders.final.note.pagesIgnored': 'hal {pages} terbaca sebagai {type}, dibiarkan di file ini',
  'upload.folders.final.note.belongs': 'terbaca sebagai {type}, dibiarkan di Lainnya',
  'upload.folders.panelWarn.title': 'Bukan dokumen {folder}?',
  'upload.folders.panelWarn.mismatch':
    'File ini terbaca sebagai {type} ({pct}%), bukan {folder}. Cek isinya, lalu pindahkan kalau salah folder.',
  'upload.folders.panelWarn.belongs': 'File ini terbaca sebagai {type} ({pct}%) — dokumen ini punya folder sendiri.',
  'upload.folders.panelWarn.junkTitle': 'Bukan dokumen pengiriman?',
  'upload.folders.panelWarn.junk': 'File ini sepertinya bukan dokumen pengiriman ({pct}%).',
  'upload.folders.pager.prev': 'Sebelumnya',
  'upload.folders.pager.next': 'Berikutnya',
  'upload.folders.pager.seen': 'Dilihat {n}/{total} hal',
  'upload.folders.pageWarn.cut': 'Dokumen lain mulai di sini',
  'upload.folders.pageWarn.text': 'Hal {pages} terbaca sebagai {type}, tidak cocok dengan folder {folder}.',
  'upload.folders.pageWarn.split': 'Pisahkan hal {pages}',
  'upload.folders.pageWarn.ignore': 'Biarkan',
  'upload.folders.pageWarn.marked': 'Hal {pages} akan dipisah sebagai {type}. Klik “Terapkan pemisahan” di atas.',
  'upload.folders.pageWarn.undo': 'Batal',
  'upload.folders.pageWarn.dot': 'Hal {n}: terbaca sebagai {type}',
  'upload.folders.check.viewedWarning': 'Jawab dulu peringatan di baris file ini, lalu centang “Sudah dicek”.',
  'upload.folders.check.viewedReady': 'Kalau dokumen ini sudah benar, centang “Sudah dicek” di bawah pratinjau.',
  'upload.folders.check.viewedTitle': 'Sudah sampai halaman terakhir',
  'upload.folders.check.blockedTitle': 'Belum bisa dicentang',
  'upload.folders.check.cta': 'Centang kalau sudah benar',
  'upload.folders.banner.text': 'File ini berisi dokumen yang berbeda: {types}. Pisahkan?',
  'upload.folders.banner.split': 'Pisahkan sesuai saran',
  'upload.folders.banner.ignore': 'Biarkan',
  'upload.folders.pages.marked': 'Jenis halaman diubah — jadi {n} dokumen.',
  'upload.folders.pages.clear': 'Batal',
  'upload.folders.pages.apply': 'Terapkan pemisahan',
  'upload.folders.pages.tip': 'Jenis halaman ini menurut JARVIS. Klik untuk mengubah.',
  'upload.folders.pages.outTip': 'Halaman ini terbaca sebagai jenis lain dari foldernya. Klik untuk mengubah.',
  'upload.folders.pages.markedTip': 'Diubah oleh Anda (JARVIS: {type})',
  'upload.folders.final.title': 'Periksa sebelum diproses',
  'upload.folders.final.perFolder': 'Per folder',
  'upload.folders.final.count': '{n} dokumen · {pages} hal',
  'upload.folders.final.notesTitle': 'Catatan AI yang masih terbuka ({n})',
  'upload.folders.final.note.mismatch': 'terbaca sebagai {type}, tetap di {folder}',
  'upload.folders.final.note.bundle': 'mungkin berisi {types}, tidak dipisah',
  'upload.folders.final.note.suggestion': 'saran hal {page} ({type}) diabaikan',
  'upload.folders.final.note.splitIgnored': 'saran pemisahan ({types}) dibiarkan',
  'upload.folders.final.note.pagesLeftOut': 'hal {pages} tidak ikut diunggah',
  'upload.folders.final.aiCanErr':
    'AI bisa salah. Pastikan setiap dokumen ada di folder yang benar dan halamannya lengkap.',
  'upload.folders.final.ack': 'Saya sudah memeriksa semua dokumen',
  'upload.folders.final.back': 'Kembali',
  'upload.folders.final.go': 'Proses',
  'review.check.title': 'Periksa dokumen',
  'review.check.subtitle': 'Pastikan jenis dan halaman tiap dokumen sudah benar sebelum JARVIS membacanya.',
  'review.check.pagesHint': 'Klik nomor halaman untuk melewatinya. Arahkan kursor untuk melihat halamannya.',
  'review.check.minOnePage': 'Minimal satu halaman harus tetap dipilih.',
  'review.check.pagesCount': '{on} dari {total} halaman dibaca',
  'review.check.sorted': 'Diurutkan JARVIS — cek lagi',
  'review.check.warned': 'Tadi ada peringatan — cek lagi',
  'review.check.excel': 'File Excel — disertakan utuh',
  'review.check.summary': '{docs} dokumen · {pages} halaman akan dibaca',
  'review.check.changed': '{n} perubahan dari upload',
  'review.check.confirm': 'Konfirmasi & Proses',
  'review.check.processing': 'Memproses…',
  'review.check.back': 'Kembali ke folder',
  'review.check.pageLabel': 'Halaman {n}',
  // Jarvis 2.0 processing modal: reads waiting for room, and a failed run (next-jarvis#910).
  'processing.retry.waiting':
    'Server AI sedang padat. JARVIS terus mencoba membaca ulang dokumen ini — sudah {attempt} kali dicoba ({elapsed}). Dokumen Anda aman, mohon tunggu.',
  'processing.readFailed.highTraffic':
    '{file} belum berhasil dibaca setelah {attempt} kali dicoba ({elapsed}). Tidak ada draft yang dibuat — dokumen Anda tetap tersimpan, silakan proses ulang.',
  'processing.readFailed.generic':
    '{file} tidak dapat dibaca. Tidak ada draft yang dibuat — dokumen Anda tetap tersimpan. Periksa file lalu proses ulang.',
  'processing.failed.generic':
    'Pemrosesan gagal. Tidak ada draft yang dibuat — dokumen Anda tetap tersimpan, silakan proses ulang.',
  'processing.failed.retry': 'Proses ulang',
  'processing.failed.back': 'Kembali ke dokumen',
  'processing.elapsed.second.one': '{n} detik',
  'processing.elapsed.second.other': '{n} detik',
  'processing.elapsed.minute.one': '{n} menit',
  'processing.elapsed.minute.other': '{n} menit',
  'processing.elapsed.join': '{minutes} {seconds}',
  'upload.issuesTitle': 'Periksa jenis dokumen',
  'upload.issuesIntro': 'Isi {n} file tidak sesuai dengan jenis yang dipilih. Lanjutkan apa adanya?',
  'upload.issuesDeclared': 'dipilih',
  'upload.issuesDetected': 'terbaca',
  'upload.issuesBundle': 'berisi {types} — belum dipisah',
  'upload.issuesContinue': 'Lanjutkan',
  'upload.issuesReview': 'Periksa lagi',
  'upload.waitDetection': 'Membaca dokumen {done}/{total} — tunggu sampai selesai',
  'upload.waitDetectionHint': 'Tombol aktif setelah semua dokumen selesai dibaca',
  'upload.needsType': 'pilih jenis',
  'upload.lowConfidence': 'perlu dicek · {pct}%',
  'upload.confidence': 'yakin {pct}%',
  'upload.loadingPreview': 'Memuat pratinjau...',
  'upload.previewFailed': 'Pratinjau tidak dapat ditampilkan',
  'upload.previewFailedMsg': 'File tetap dapat dipisah otomatis dan diunggah.',
  'upload.addSegment': 'Tambah Segment',
  'upload.segmentHint': 'Klik tombol di atas, lalu pilih halaman pada thumbnail.',
  'upload.selectPages': 'Pilih halaman pada thumbnail...',
  'upload.noPages': 'Belum ada halaman',
  'upload.pagesLabel': 'Hal: {pages}',
  'upload.docTypePlaceholder': 'Jenis dokumen',
  'upload.removeOriginal': 'Hapus file asli',
  'upload.extractSegments': 'Ekstrak {n} Segment',
  'upload.activateSegmentFirst': 'Klik segment di bawah untuk mengaktifkannya terlebih dahulu',
  'upload.pageFreed': 'Halaman {page} dilepas dari Segmen {seg}',
  'upload.pageFreedClickAgain':
    'Halaman {page} dilepas dari Segmen {seg}. Klik lagi untuk memindahkannya ke segmen aktif.',
  'upload.fileLimitReached': 'Batas file tercapai',
  'upload.fileLimitReachedMsg': 'Tidak dapat menambah segment: akan melebihi batas {n} file',
  'upload.segMinPages': 'Setiap segmen harus memiliki minimal 1 halaman',
  'upload.segNeedType': 'Semua segmen harus memiliki jenis dokumen',
  'upload.segAllJunk': 'Semua segmen ditandai Dokumen lain-lain — tidak ada yang diekstrak',
  'upload.segJunkSuggest': 'Abaikan?',
  'upload.exceedLimit': 'Melebihi batas {n} file (saat ini {cur}, akan menambah {add})',
  'upload.validationFailed': 'Validasi gagal',
  'upload.extractSuccess': '{n} file dibuat dari "{name}"',
  'upload.extractFailed': 'Gagal memecah PDF',

  // Smart document detection
  'upload.detecting': 'Mendeteksi...',
  'upload.detected': 'Terdeteksi',
  'upload.detectedMulti': '{n} jenis dokumen terdeteksi',
  'upload.detectedSingle': 'Terdeteksi: {type}',
  'upload.detectFailed': 'Gagal mendeteksi',
  'upload.splitSuggestion': 'Pisahkan dokumen',
  'upload.unclassifiedPages': '{n} halaman tidak teridentifikasi',

  // Document type options (select/dropdown labels)
  'doctype.PL': '(PL) Packing List',
  'doctype.I': '(I) Invoice',
  'doctype.BL': '(BL) Bill of Lading',
  'doctype.MBL': '(MBL) Master Bill of Lading',
  'doctype.SI': '(SI) Shipping Instruction',
  'doctype.BR': '(BR) Booking Receipt',
  'doctype.COO': '(COO) Certificate of Origin',
  'doctype.ECOO': '(E-COO) Electronic Certificate of Origin',
  'doctype.AWB': '(AWB) Air Waybill',
  'doctype.MAWB': '(MAWB) Master Air Waybill',
  'doctype.LS': '(LS) Laporan Surveyor',
  'doctype.POSTEL': '(POSTEL) Postel',
  'doctype.PI': '(PI) Persetujuan Import',
  'doctype.AKL': '(AKL) Nomor Pendaftaran Alat Kesehatan/Depkes',
  'doctype.SKI': '(SKI) SURAT PERSETUJUAN MUAT BPOM',
  'doctype.SKB': '(SKBPPN) SKB PPN Impor',
  'doctype.SKBPPH': '(SKBPPH) SKB PPh Pasal 22 Impor',
  'doctype.SKBPP23': '(SKBPP23) SKB PPh Final PP 23',
  'doctype.SNI': '(SNI) SNI',
  'doctype.VLEGAL': '(VLEGAL) V-LEGAL',
  'doctype.CITES': '(CITES) CITES',
  'doctype.HC': '(HC) Health Certificate',
  'doctype.SKEPTPB': '(SKEPTPB) SKEP-TPB',
  'doctype.PE': '(PE) Persetujuan Ekspor',
  'doctype.SKEM': '(SKEM) SKEM',
  'doctype.SNISPBDEPDAG': '(SNISPBDEPDAG) SNISPBDEPDAG',
  'doctype.PP': '(PP) Pengecualian Perijinan RB3 / Registrasi B3 / KLH',
  'doctype.EXC-JRE': '(CIPL - JRE) CIPL - JRE',
  'doctype.EXC-ARJUNA': '(CIPL - ARJUNA) CIPL - ARJUNA',
  'doctype.EXC-OBOR': '(CIPL - OBOR) CIPL - OBOR',
  'doctype.EXC-BENING': '(CIPL - BENING) CIPL - BENING',
  'doctype.EXC-NADA': '(CIPL - NADA) CIPL - NADA',
  'doctype.EXC-MINEBEA': '(CIPL - MINEBEA) CIPL - MINEBEA',
  'doctype.EXC-WIDE-SUCCESS': '(CIPL - WIDE SUCCESS) CIPL - WIDE SUCCESS',
  'doctype.EXC-NICESO': '(CIPL - NICESO) CIPL - NICESO',
  'doctype.EXC-CEISA': '(EXCEL CEISA) Excel CEISA',
  'doctype.SKEP': '(SKEP) SKEP',
  'doctype.980': '(980) Deklarasi Impor',
  'doctype.530': '(530) Polis Asuransi',
  'doctype.OF': '(OF) Ocean Freight / Biaya Angkut',
  'doctype.JUNK': 'Dokumen lain-lain (abaikan)',

  // HeaderForm
  'headerform.labelPelabuhan': 'Pelabuhan',
  'headerform.labelKantorPabean': 'Kantor Pabean',
  'headerform.labelPIB': 'PIB',
  'headerform.labelJenisImpor': 'Jenis Impor',
  'headerform.labelCaraBayar': 'Cara Bayar',
  'headerform.placeholderPelabuhan': 'Pilih pelabuhan',
  'headerform.placeholderKantorPabean': 'Pilih kantor pabean',
  'headerform.placeholderPIB': 'Pilih jenis PIB',
  'headerform.placeholderJenisImpor': 'Pilih jenis impor',
  'headerform.placeholderCaraBayar': 'Pilih cara bayar',
  'headerform.pibOpt1': '1 - BIASA',
  'headerform.pibOpt2': '2 - BERKALA',
  'headerform.imporOpt1': '1 - UNTUK DIPAKAI',
  'headerform.imporOpt2': '2 - SEMENTARA',
  'headerform.imporOpt5': '5 - RUSH HANDLING',
  'headerform.imporOpt9': '9 - GABUNGAN 1 DAN 2',
  'headerform.bayarOpt1': '1 - BIASA/TUNAI',
  'headerform.bayarOpt2': '2 - BERKALA',
  'headerform.bayarOpt10': '10 - PEMBAYARAN KEMUDIAN (OPEN ACCOUNT) SECARA BERTAHAP',
  'headerform.bayarOpt11': '11 - PEMBAYARAN KEMUDIAN (OPEN ACCOUNT) SECARA TUNAI',
  'headerform.bayarOpt12': '12 - DILAKUKAN DI DN DENGAN PEMBAYARAN UANG TUNAI',
  'headerform.bayarOpt13': '13 - DILAKUKAN DI DN DENGAN PEMBAYARAN MELALUI TELEGRAPH TRANSFER (T/T)',
  'headerform.bayarOpt14': '14 - DILAKUKAN TANPA PEMBAYARAN',
  'headerform.bayarOpt15': '15 - PEMBAYARAN DIMUKA (ADVANCE PAYMENT)',
  'headerform.bayarOpt16': '16 - SIGHT LETTER OF CREDIT',
  'headerform.bayarOpt17': '17 - INKASO (COLLECTION DRAFT)',

  // DokumenForm
  'dokumenform.col.seri': 'Seri',
  'dokumenform.col.jenis': 'Jenis',
  'dokumenform.col.ecooStatus': 'eCOO Status',
  'dokumenform.col.nomor': 'Nomor',
  'dokumenform.col.tanggal': 'Tanggal',
  'dokumenform.col.fasilitas': 'Fasilitas',
  'dokumenform.col.kodeIjin': 'Kode Ijin',
  'dokumenform.col.attached': 'Terlampir',
  'dokumenform.col.state': 'Status',
  'dokumenform.col.aksi': 'Aksi',

  'dokumenform.action.attachToBarang': 'Lampirkan ke Barang',
  'dokumenform.action.edit': 'Edit',
  'dokumenform.action.copy': 'Salin',
  'dokumenform.action.uploadReplace': 'Unggah / Ganti File',
  'dokumenform.action.uploadReplaceAria': 'Unggah atau ganti file',
  'dokumenform.action.delete': 'Hapus',
  'dokumenform.action.deleteLastBlocked': 'Dokumen terakhir tidak dapat dihapus — CEISA memerlukan minimal 2 dokumen',
  'dokumenform.action.undo': 'Urungkan',
  'dokumenform.deleted.title': 'Dokumen yang dihapus',
  'dokumenform.deleted.hint':
    'Dokumen ini tidak akan muncul di tab Dokumen dan tidak dikirim ke CEISA. Pulihkan bila terhapus tidak sengaja.',
  'dokumenform.deleted.restore': 'Pulihkan',

  // Dokumen tab selection mode + bulk actions (PIB, BC 2.3, PEB).
  'dokumenform.bulk.total': 'Total: {count}',
  'dokumenform.bulk.selected': '{count} dipilih',
  'dokumenform.bulk.selectAll': 'Pilih semua dokumen',
  'dokumenform.bulk.selectRow': 'Pilih dokumen {serial}',
  'dokumenform.bulk.clear': 'Batal pilih',
  'dokumenform.bulk.edit': 'Edit',
  'dokumenform.bulk.editTooltip': 'Edit massal dokumen terpilih',
  'dokumenform.bulk.duplicate': 'Duplikat',
  'dokumenform.bulk.duplicateTooltip': 'Duplikat dokumen terpilih',
  'dokumenform.bulk.attach': 'Lampirkan',
  'dokumenform.bulk.attachTooltip': 'Lampirkan dokumen terpilih ke barang',
  'dokumenform.bulk.delete': 'Hapus',
  'dokumenform.bulk.deleteTooltip': 'Hapus dokumen terpilih',
  'dokumenform.bulk.cancel': 'Batal',
  'dokumenform.bulk.apply': 'Terapkan',
  'dokumenform.bulk.successTitle': 'Berhasil',
  'dokumenform.bulk.errorTitle': 'Gagal',
  'dokumenform.bulk.noNumber': '(tanpa nomor)',
  'dokumenform.bulk.editTitle': 'Edit Massal Dokumen',
  'dokumenform.bulk.editCount': 'Mengubah {count} dokumen',
  'dokumenform.bulk.editHint': 'Kosongkan kolom yang tidak ingin diubah. Kode dan nomor dokumen tidak ikut diubah.',
  'dokumenform.bulk.fieldDate': 'Tanggal Dokumen',
  'dokumenform.bulk.fieldDatePlaceholder': 'Pilih tanggal',
  'dokumenform.bulk.fieldFacility': 'Kode Fasilitas',
  'dokumenform.bulk.fieldFacilityPlaceholder': 'Pilih fasilitas',
  'dokumenform.bulk.fieldIjin': 'Kode Ijin',
  'dokumenform.bulk.fieldIjinPlaceholder': 'Masukkan kode ijin',
  'dokumenform.bulk.fieldStatus': 'Status',
  'dokumenform.bulk.statusUnchanged': 'Tidak diubah',
  'dokumenform.bulk.editSuccess': '{count} dokumen diperbarui',
  'dokumenform.bulk.duplicateTitle': 'Duplikat Dokumen',
  'dokumenform.bulk.duplicateConfirm': 'Duplikat {count} dokumen? Nomor dikosongkan dan harus diisi ulang.',
  'dokumenform.bulk.duplicateSuccess': '{count} dokumen diduplikat. Isi nomor dokumen yang baru.',
  'dokumenform.bulk.emptyNomorExists': 'Masih ada dokumen {kode} tanpa nomor, isi nomornya dulu sebelum duplikat lagi.',
  'dokumenform.bulk.nomorRequired': 'Nomor wajib diisi',
  'dokumenform.bulk.attachTitle': 'Lampirkan ke Barang',
  'dokumenform.bulk.attachCount': 'Melampirkan {count} dokumen ke barang yang dipilih',
  'dokumenform.bulk.modeAdd': 'Tambah ke lampiran yang ada',
  'dokumenform.bulk.modeReplace': 'Ganti lampiran',
  'dokumenform.bulk.replaceWarning': 'Lampiran lama pada {count} dokumen akan diganti.',
  'dokumenform.bulk.skippedList': 'Dilewati, tidak bisa dilampirkan ke barang: {list}',
  'dokumenform.bulk.allSkipped': 'Tidak ada dokumen terpilih yang bisa dilampirkan ke barang.',
  'dokumenform.bulk.selectAllBarang': 'Pilih semua barang',
  'dokumenform.bulk.barangPicked': '{count} barang dipilih',
  'dokumenform.bulk.noBarang': 'Belum ada barang di draft ini.',
  'dokumenform.bulk.attachSuccess': 'Barang dilampirkan ke {count} dokumen',
  'dokumenform.bulk.deleteTitle': 'Hapus {count} Dokumen',
  'dokumenform.bulk.deleteLinks': '{count} lampiran barang akan dilepas.',
  'dokumenform.bulk.deleteRestorable': 'Setelah dihapus, dokumen masih bisa dikembalikan dengan Batalkan.',
  'dokumenform.bulk.blockMinOne': 'Minimal 1 dokumen harus tersisa.',
  'dokumenform.bulk.blockRequiredCode': 'Dokumen {kode} terakhir tidak boleh dihapus.',
  'dokumenform.bulk.deleteSuccess': '{count} dokumen dihapus',
  'dokumenform.bulk.undo': 'Batalkan',
  'dokumenform.bulk.undoSuccess': 'Dokumen dikembalikan',
  'dokumenform.bulk.unknownSerial': 'Daftar dokumen berubah. Muat ulang halaman lalu coba lagi.',
  'dokumenform.bulk.flushFailed': 'Perubahan dokumen belum tersimpan, aksi massal dibatalkan. Coba lagi.',
  'dokumenform.bulk.genericError': 'Aksi massal gagal. Coba lagi.',

  'dokumenform.modal.attachTitle': 'Lampirkan Dokumen ke Barang',
  'dokumenform.modal.replaceTitle': 'Ganti pilihan saat ini?',
  'dokumenform.modal.uploadPdfTitle': 'Unggah PDF Dokumen',

  'dokumenform.label.quickSelect': 'Pilih Cepat (Input Rentang)',
  'dokumenform.label.filterHsCode': 'Filter berdasarkan Kode HS',
  'dokumenform.label.bulkSeriIjin': 'Bulk No. Urut di Izin',
  'dokumenform.label.filePdf': 'File PDF',
  'dokumenform.label.tipeDokumen': 'Tipe Dokumen',

  'dokumenform.placeholder.rangeExample': 'Contoh: 1-2,3,5-8,10 (gunakan nomor item, bukan indeks)',
  'dokumenform.placeholder.filterHsCode': 'Ketik kode HS untuk filter (mis. 9403)',
  'dokumenform.placeholder.value': 'Nilai',
  'dokumenform.placeholder.pilihFilePdf': 'Pilih file PDF',
  'dokumenform.placeholder.url': 'https://... (House-BL / AWB / dokumen pendukung)',

  'dokumenform.button.batal': 'Batal',
  'dokumenform.button.simpan': 'Simpan',
  'dokumenform.button.menyimpan': 'Menyimpan...',
  'dokumenform.button.unggahDokumen': 'Unggah PDF',
  'dokumenform.button.isiManual': 'Isi manual',
  'dokumenform.reread.upload.title': 'Unggah dokumen',
  'dokumenform.reread.match2.colSeriIjin': 'Seri izin',
  'dokumenform.reread.match2.izinHint':
    'Seri izin (No. Urut di Izin) terisi otomatis dari nomor baris (item no.) pada dokumen bila terbaca — periksa dan lengkapi yang kosong.',
  'dokumenform.reread.izinFilled': 'Seri izin terisi pada {n} barang yang sudah tertaut ke dokumen ini.',
  'dokumenform.reread.progress.waiting': 'Menunggu giliran dibaca…',
  'dokumenform.reread.error.runNotFinished': 'Draft ini masih diproses JARVIS. Coba lagi setelah selesai.',
  'dokumenform.reread.progress.starting': 'Memulai…',
  'dokumenform.reread.progress.reading': 'Membaca PDF ({pages} hal)…',
  'dokumenform.reread.progress.tabs': 'Menyusun tab ({done}/{total})…',
  'dokumenform.reread.progress.eta': '± {s} detik lagi',
  'dokumenform.reread.progress.queue': '{ready} dari {n} dokumen siap — dibaca bersamaan',
  'dokumenform.reread.multi.listTitle': 'Dokumen terdeteksi ({n})',
  'dokumenform.reread.match2.title': 'Tautkan barang ke {doc}',
  'dokumenform.reread.match2.body':
    'Auto-match JARVIS menyarankan {n} barang untuk dokumen ini ({existing} sudah tertaut). Barang yang dicentang akan ditautkan.',
  'dokumenform.reread.match2.save': 'Simpan tautan ({n})',
  'dokumenform.reread.match2.saved': '{n} barang ditautkan.',
  'dokumenform.reread.match2.by.both': 'HS + uraian',
  'dokumenform.reread.match2.by.hs_code': 'HS',
  'dokumenform.reread.match2.by.description': 'Uraian',
  'dokumenform.reread.match2.by.prebaked': 'Data JARVIS',
  'dokumenform.reread.match2.by.coverage': 'Satu-satunya barang',
  'dokumenform.reread.match2.by.count': 'Jumlah sama',
  'dokumenform.reread.fill.title': 'Lengkapi barang',
  'dokumenform.reread.fill.section': 'Lengkapi barang yang sudah ada ({n} seri)',
  'dokumenform.reread.fill.hint':
    'Data yang kosong di barang dan terbaca di dokumen sudah dicentang. Nilai yang berbeda dari isian sekarang tidak dicentang.',
  'dokumenform.reread.fill.seri': 'Seri {n} · {uraian}',
  'dokumenform.reread.fill.kosong': 'kosong',
  'dokumenform.reread.fill.newLines': 'Barang baru ({n})',
  'dokumenform.reread.fill.optionTitle': 'Lengkapi barang dari dokumen yang sudah ada',
  'dokumenform.reread.fill.optionBody':
    'JARVIS membaca ulang invoice dan packing list di draft ini, lalu mengisi data barang yang kosong (kemasan, berat, merk, …). Anda pilih yang diterapkan.',
  'dokumenform.reread.fill.optionButton': 'Lengkapi barang',
  'dokumenform.reread.field.jumlah_kemasan': 'Jumlah kemasan',
  'dokumenform.reread.field.kode_jenis_kemasan': 'Jenis kemasan',
  'dokumenform.reread.field.netto': 'Netto (kg)',
  'dokumenform.reread.field.bruto': 'Bruto (kg)',
  'dokumenform.reread.field.volume': 'Volume',
  'dokumenform.reread.field.kode_negara_asal': 'Negara asal',
  'dokumenform.reread.field.merk': 'Merk',
  'dokumenform.reread.field.tipe': 'Tipe',
  'dokumenform.reread.field.ukuran': 'Ukuran',
  'dokumenform.reread.field.spesifikasi_lain': 'Spesifikasi lain',
  'dokumenform.reread.field.kode_barang': 'Kode barang',
  'dokumenform.reread.multi.subtitleSorted':
    'Cek hasil pemisahan JARVIS: pindahkan dokumen yang salah folder, lihat isinya, lalu baca dengan JARVIS. Data barang yang kosong juga dilengkapi dari dokumen ini.',
  'dokumenform.reread.multi.subtitle':
    'Unggah PDF Anda — JARVIS memisahkan dokumen di dalamnya dan mengelompokkannya per jenis.',
  'dokumenform.reread.multi.dropTitle': 'Unggah PDF di sini',
  'dokumenform.reread.multi.dropBody':
    'Seret satu atau beberapa PDF — boleh gabungan BL, invoice, packing list dalam satu file — atau',
  'dokumenform.reread.multi.klikPilih': 'klik untuk pilih',
  'dokumenform.reread.multi.dropLimits': 'Hanya PDF · maks. {n} dokumen sekali unggah',
  'dokumenform.reread.multi.dropMore': 'Tambah PDF lagi',
  'dokumenform.reread.multi.splitting': 'JARVIS memisahkan dokumen… ({done}/{total} file)',
  'dokumenform.reread.multi.detected': 'Terbaca {jenis} · {pct}%',
  'dokumenform.reread.multi.notDetected': 'Jenis belum terbaca — pilih jenisnya',
  'dokumenform.reread.multi.preview': 'Lihat PDF',
  'dokumenform.reread.multi.previewTitle': 'Pratinjau — {file}',
  'dokumenform.reread.multi.splitFrom': 'Dipisah dari {file}, hal {pages}',
  'dokumenform.reread.multi.mulaiUlang': 'Mulai ulang',
  'dokumenform.reread.multi.jenis': 'Jenis',
  'dokumenform.reread.multi.untuk': 'Untuk',
  'dokumenform.reread.multi.baru': 'Dokumen baru',
  'dokumenform.reread.multi.tambahan': 'Halaman tambahan untuk {doc}',
  'dokumenform.reread.multi.semua': 'semua',
  'dokumenform.reread.multi.none': 'Belum ada file. Seret PDF ke folder jenisnya.',
  'dokumenform.reread.multi.needType': 'Pilih jenis untuk file di Lainnya.',
  'dokumenform.reread.multi.tooMany': 'Maksimal {n} dokumen sekali unggah.',
  'dokumenform.reread.multi.uploading': 'Mengunggah {i} dari {n}…',
  'dokumenform.reread.multi.ready': '{n} dokumen siap dibaca.',
  'dokumenform.reread.multi.baca': 'Baca dengan JARVIS ({n})',
  'dokumenform.reread.multi.queue': 'Dokumen {i} dari {n}',
  'dokumenform.reread.multi.lewati': 'Lewati',
  'dokumenform.reread.match.title': 'Dokumen ini sudah ada di draft',
  'dokumenform.reread.match.body': '{jenis} nomor {nomor} sama dengan baris ke-{n} di tab Dokumen.',
  'dokumenform.reread.match.merge': 'Gabungkan ke dokumen yang sudah ada (disarankan)',
  'dokumenform.reread.match.mergeHint':
    'Halaman file ini ditambahkan ke dokumen tersebut lalu dibaca ulang. Tidak ada baris dokumen baru, dan barang yang sama tidak dicentang.',
  'dokumenform.reread.match.new': 'Tambahkan sebagai dokumen baru',
  'dokumenform.reread.match.newHint': 'Membuat baris dokumen kedua dengan nomor yang sama.',
  'dokumenform.reread.match.go': 'Gabungkan & baca ulang',
  'dokumenform.reread.upload.pages': 'Halaman yang dibaca',
  'dokumenform.reread.upload.pagesAll': 'Pilih semua',
  'dokumenform.reread.upload.pagesNone': 'Kosongkan',
  'dokumenform.reread.upload.pagesMax': 'Maksimal {n} halaman sekali baca.',
  'dokumenform.reread.upload.pdfUnreadable': 'PDF tidak dapat dibuka.',
  'dokumenform.reread.reading': 'JARVIS sedang membaca…',
  'dokumenform.reread.failedTitle': 'Dokumen tidak dapat dibaca ulang',
  'dokumenform.reread.retry': 'Coba lagi',
  'dokumenform.reread.error.start': 'Baca ulang gagal dimulai.',
  'dokumenform.reread.error.apply': 'Perubahan gagal diterapkan.',
  'dokumenform.reread.ask.title': 'File diganti. Baca ulang dokumen ini dengan JARVIS?',
  'dokumenform.reread.ask.ya': 'Ya',
  'dokumenform.reread.ask.tidak': 'Tidak',
  'dokumenform.reread.preview.title': 'Pratinjau baca ulang — {jenis} {nomor}',
  'dokumenform.reread.preview.titleReading': 'Baca ulang dokumen',
  'dokumenform.reread.preview.nothing': 'Tidak ada perubahan yang terbaca dari dokumen ini.',
  'dokumenform.reread.tab.barang': 'Barang',
  'dokumenform.reread.tab.header': 'Header',
  'dokumenform.reread.tab.entitas': 'Entitas',
  'dokumenform.reread.tab.pengangkut': 'Pengangkut',
  'dokumenform.reread.tab.transaksi': 'Transaksi',
  'dokumenform.reread.tab.dokumen': 'Dokumen',
  'dokumenform.reread.tab.links': 'Tautan',
  'dokumenform.reread.col.seri': 'Seri',
  'dokumenform.reread.col.uraian': 'Uraian',
  'dokumenform.reread.col.qty': 'Jumlah',
  'dokumenform.reread.col.nilai': 'Nilai',
  'dokumenform.reread.col.field': 'Field',
  'dokumenform.reread.col.sekarang': 'Sekarang',
  'dokumenform.reread.col.terbaca': 'Terbaca',
  'dokumenform.reread.col.confidence': 'Keyakinan',
  'dokumenform.reread.col.seriBarang': 'Seri barang',
  'dokumenform.reread.col.dokumen': 'Dokumen',
  'dokumenform.reread.col.seriIjin': 'Seri izin',
  'dokumenform.reread.duplicate': 'Mirip barang seri {n}',
  'dokumenform.reread.total.hargaBarang': 'Nilai barang',
  'dokumenform.reread.total.beratBersih': 'Netto',
  'dokumenform.reread.total.beratKotor': 'Bruto',
  'dokumenform.reread.total.freight': 'Freight',
  'dokumenform.reread.freightAdjust': 'Freight disesuaikan: −{removed} / +{added}',
  'dokumenform.reread.applyTotals': 'Terapkan total',
  'dokumenform.reread.warning.KEMASAN_NOT_RECOMPUTED': 'Kemasan dan peti kemas tidak dihitung ulang.',
  'dokumenform.reread.warning.OLD_BARANG_KEPT': 'Barang dari file lama tidak dihapus otomatis.',
  'dokumenform.reread.warningTitle': 'Perhatian',
  'dokumenform.reread.apply': 'Terapkan ({n})',
  'dokumenform.reread.applied': '{lines} barang dan {links} tautan ditambahkan.',
  'dokumenform.reread.supporting.title': 'Halaman pendukung',
  'dokumenform.reread.supporting.note': '(tidak dikirim ke CEISA)',
  'dokumenform.reread.supporting.file': 'File',
  'dokumenform.reread.supporting.halaman': 'Halaman',
  'dokumenform.reread.supporting.jenis': 'Jenis',
  'dokumenform.reread.supporting.freight': 'Freight terbaca',
  'dokumenform.reread.supporting.semua': 'Semua',
  'dokumenform.reread.supporting.pilihJenis': 'Pilih jenis',
  'dokumenform.reread.supporting.retype': 'Ubah tipe & baca ulang',
  'dokumenform.reread.readingHint': 'Biasanya selesai dalam 1–2 menit. Belum ada yang diubah di draft.',
  'dokumenform.reread.fieldsHint':
    'Belum ada yang dicentang — pilih nilai terbaca yang ingin menggantikan isian sekarang.',
  'dokumenform.reread.tetap': 'tetap',
  'dokumenform.reread.upload.hal': 'Hal',
  'dokumenform.reread.upload.pdfOnly': 'Hanya file PDF yang bisa diunggah.',
  'dokumenform.reread.upload.hapusFile': 'Hapus file',
  'dokumenform.reread.upload.needBatch': 'Data draft belum siap. Muat ulang halaman.',
  'dokumenform.reread.field.port_code': 'Pelabuhan',
  'dokumenform.reread.field.pabean_office_code': 'Kantor pabean',
  'dokumenform.reread.field.pib_type': 'Jenis PIB',
  'dokumenform.reread.field.import_type': 'Jenis impor',
  'dokumenform.reread.field.payment_type': 'Cara bayar',
  'dokumenform.reread.field.importer_identity_no': 'Nomor identitas importir',
  'dokumenform.reread.field.importer_name': 'Nama importir',
  'dokumenform.reread.field.importer_address': 'Alamat importir',
  'dokumenform.reread.field.owner_identity_no': 'Nomor identitas pemilik barang',
  'dokumenform.reread.field.owner_name': 'Nama pemilik barang',
  'dokumenform.reread.field.owner_address': 'Alamat pemilik barang',
  'dokumenform.reread.field.sender_name': 'Nama pengirim',
  'dokumenform.reread.field.sender_address': 'Alamat pengirim',
  'dokumenform.reread.field.sender_country_code': 'Negara pengirim',
  'dokumenform.reread.field.seller_name': 'Nama penjual',
  'dokumenform.reread.field.seller_address': 'Alamat penjual',
  'dokumenform.reread.field.seller_country_code': 'Negara penjual',
  'dokumenform.reread.field.nomor_bc11': 'Nomor BC 1.1',
  'dokumenform.reread.field.tanggal_tutup_pu': 'Tanggal BC 1.1',
  'dokumenform.reread.field.nomor_pos': 'Nomor pos',
  'dokumenform.reread.field.nomor_subpos': 'Nomor subpos',
  'dokumenform.reread.field.cara_pengangkutan_code': 'Cara pengangkutan',
  'dokumenform.reread.field.nama_sarana_pengangkutan': 'Nama sarana angkut',
  'dokumenform.reread.field.nomor_voy': 'Nomor voyage / flight',
  'dokumenform.reread.field.bendera_code': 'Bendera',
  'dokumenform.reread.field.perkiraan_tanggal_tiba': 'Perkiraan tiba (ETA)',
  'dokumenform.reread.field.pelabuhan_muat_code': 'Pelabuhan muat',
  'dokumenform.reread.field.pelabuhan_transit_code': 'Pelabuhan transit',
  'dokumenform.reread.field.pelabuhan_tujuan_code': 'Pelabuhan tujuan',
  'dokumenform.reread.field.tempat_penimbunan_code': 'Tempat penimbunan',
  'dokumenform.reread.field.valuta_code': 'Valuta',
  'dokumenform.reread.field.jenis_transaksi_code': 'Jenis transaksi',
  'dokumenform.reread.field.incoterm_code': 'Incoterm',
  'dokumenform.reread.field.freight': 'Freight',
  'dokumenform.reread.field.kode_asuransi': 'Jenis asuransi',
  'dokumenform.reread.field.asuransi': 'Asuransi',
  'dokumenform.reread.field.nilai_asuransi': 'Nilai asuransi',
  'dokumenform.reread.field.document_no': 'Nomor dokumen',
  'dokumenform.reread.field.date': 'Tanggal dokumen',
  'dokumenform.reread.field.facility_code': 'Fasilitas',
  'dokumenform.button.upload': 'Unggah',
  'dokumenform.button.applyToSelected': 'Terapkan ke Terpilih ({n})',
  'dokumenform.button.clearSelection': 'Bersihkan pilihan',
  'dokumenform.button.replaceSelection': 'Ganti pilihan',
  'dokumenform.button.autoMatch': 'Auto-match',
  'dokumenform.button.autoMatchEcoo': 'Auto-match dari E-COO',
  'dokumenform.button.validateEcoo': 'Validasi eCOO',
  'dokumenform.button.autoSort': 'Urutkan Otomatis',
  'dokumenform.total': 'Total: {n}',

  'dokumenform.notify.success': 'Berhasil',
  'dokumenform.notify.successTitle': 'Sukses',
  'dokumenform.notify.errorTitle': 'Error',
  'dokumenform.notify.failed': 'Gagal',
  'dokumenform.notify.cannotUpload': 'Belum bisa upload',
  'dokumenform.notify.saveRowFirst': 'Simpan baris dokumen terlebih dahulu sebelum mengganti file.',
  'dokumenform.notify.formatNotSupported': 'Format tidak didukung',
  'dokumenform.notify.onlyPdfExcel': 'Hanya file PDF atau Excel (.xlsx/.xls/.csv) yang diperbolehkan.',
  'dokumenform.notify.uploaded': '{name} terupload',
  'dokumenform.notify.uploadFailed': 'Gagal mengupload file',
  'dokumenform.notify.urlSaveFailed': 'Gagal menyimpan URL Dokumen',
  'dokumenform.notify.documentAdded': 'Dokumen berhasil ditambahkan',
  'dokumenform.notify.documentUpdated': 'Dokumen berhasil diperbarui',
  'dokumenform.notify.documentAddFailed': 'Gagal menyimpan dokumen baru',
  'dokumenform.notify.documentEditFailed': 'Gagal menyimpan dokumen yang diedit',
  'dokumenform.notify.documentCopied': 'Dokumen berhasil disalin',
  'dokumenform.notify.documentCopyFailed': 'Gagal menyimpan dokumen yang disalin',
  'dokumenform.notify.documentDeleted': 'Dokumen berhasil dihapus',
  'dokumenform.notify.documentDeleteFailed': 'Gagal menyimpan perubahan setelah menghapus dokumen',
  'dokumenform.notify.cannotDeleteLastDocument':
    'Minimal satu dokumen harus tersisa. CEISA memerlukan minimal 2 dokumen untuk pengiriman.',
  'dokumenform.notify.documentRestored': 'Dokumen berhasil dipulihkan',
  'dokumenform.notify.documentRestoreFailed': 'Gagal memulihkan dokumen',
  'dokumenform.notify.stateChangedTo': 'Status dokumen diubah menjadi {state}',
  'dokumenform.notify.stateUpdateFailed': 'Gagal memperbarui status dokumen',
  'dokumenform.notify.autoMatch': 'Auto-match',
  'dokumenform.notify.noAutoMatch':
    'Tidak ditemukan kecocokan yang yakin untuk dokumen ini. Silakan pilih barang secara manual.',
  'dokumenform.notify.processIdNotFound': 'Process ID tidak ditemukan',
  'dokumenform.notify.serialNotFound': 'Nomor seri dokumen tidak ditemukan',
  'dokumenform.notify.attachedToBarang': 'Dokumen terlampir ke {count} barang',
  'dokumenform.notify.attachedPartial':
    'Dokumen terlampir ke {count} dari {requested} barang. {dropped} barang ditolak karena sudah terlampir di dokumen lain dengan kode yang sama.',
  'dokumenform.notify.attachFailed': 'Gagal menyimpan lampiran barang',
  'dokumenform.notify.pleaseSelectPdf': 'Silakan pilih file PDF terlebih dahulu',
  'dokumenform.notify.pdfExtracted': 'Dokumen berhasil diekstrak dari PDF',
  'dokumenform.notify.pdfExtractedWithEntitas': 'Dokumen berhasil diekstrak dari PDF, Tab Entitas ikut diperbarui',
  'dokumenform.notify.pdfUploadError': 'Terjadi kesalahan saat upload PDF',
  'dokumenform.notify.orderUpdated': 'Urutan dokumen berhasil diperbarui',
  'dokumenform.notify.orderSaveFailed': 'Gagal menyimpan urutan dokumen',
  'dokumenform.notify.orderAlreadySorted': 'Urutan dokumen sudah sesuai',
  'dokumenform.notify.validationFailed': 'Validasi Gagal',
  'dokumenform.notify.npwpRequired': 'NPWP Importir harus diisi untuk validasi eCOO',
  'dokumenform.notify.npwpInvalid': 'NPWP Importir tidak valid',
  'dokumenform.notify.noDocsToValidate': 'Tidak ada dokumen untuk divalidasi',
  'dokumenform.notify.ecooInvalid': 'Dokumen eCOO tidak valid',
  'dokumenform.notify.ajuRequired': 'Nomor AJU (BL Number) harus diisi untuk validasi eCOO',
  'dokumenform.notify.validationSuccess': 'Validasi Berhasil',
  'dokumenform.notify.ecooValidated': 'eCOO berhasil divalidasi',
  'dokumenform.notify.ecooValidationFailed': 'Validasi eCOO gagal',
  'dokumenform.notify.ecooError': 'Terjadi kesalahan saat validasi eCOO',

  'dokumenform.barang.selectPrompt': 'Pilih barang mana yang dokumen ini akan dilampirkan:',
  'dokumenform.barang.findingEcoo': 'Mencari barang yang disarankan dari item baris E-COO…',
  'dokumenform.barang.finding': 'Mencari barang yang disarankan untuk dokumen ini…',
  'dokumenform.barang.autoMatchShipment':
    'Kiriman ini hanya satu barang, jadi dokumen ini mencakupnya. Periksa sebelum menyimpan.',
  'dokumenform.barang.noAutoMatchEcoo':
    'Tidak ada kecocokan yang yakin dengan baris E-COO ini. Pilih barang secara manual.',
  'dokumenform.barang.noAutoMatch': 'Tidak ada kecocokan yang yakin untuk dokumen ini. Pilih barang secara manual.',
  'dokumenform.barang.colSeriBarang': 'Seri Barang',
  'dokumenform.barang.colHsCode': 'Kode HS',
  'dokumenform.barang.colNamaBarang': 'Nama Barang',
  'dokumenform.barang.colNoUrut': 'No. Urut di Izin',
  'dokumenform.barang.noItemsMatch': 'Tidak ada item yang cocok dengan kode HS "{hs}"',
  'dokumenform.barang.noBarang': 'Tidak ada barang yang tersedia. Silakan tambahkan barang terlebih dahulu.',
  'dokumenform.barang.loading': 'Memuat barang...',
  'dokumenform.barang.showingCount': 'Menampilkan {count} dari {total} item',
  'dokumenform.barang.filterDescription': 'Filter barang berdasarkan kode HS',
  'dokumenform.barang.replacePrompt':
    'Auto-match akan mengganti {count} barang yang dipilih saat ini dengan set yang disarankan untuk dokumen ini. Tidak ada yang disimpan sampai Anda mengklik Simpan.',
  'dokumenform.barang.rangeDescription':
    'Masukkan nomor item barang dipisahkan koma. Gunakan tanda hubung untuk rentang (mis. 1-5 berarti item 1,2,3,4,5)',
  'dokumenform.barang.unamed': 'TANPA NAMA',
  'dokumenform.barang.suggestedCoverage': 'Disarankan · {label}',
  'dokumenform.barang.suggestedConfidence': 'Disarankan · {confidence} · {percent}%',
  'dokumenform.barang.ecooItem': 'Item E-COO: {desc}',
  'dokumenform.popover.autoMatch': 'Auto-match',
  'dokumenform.popover.loading': 'Loading…',
  'dokumenform.popover.noAutoMatchData': 'No auto-match data — attached manually',
  'dokumenform.popover.seri': 'Seri {n}',
  'dokumenform.popover.wholeShipment': 'whole shipment',
  'dokumenform.popover.sameHsCode': 'kode HS sama ·',
  'dokumenform.popover.andMore': '…and {n} more',
  'dokumenform.popover.moreMatch': '{n} more barang match this document but are not attached',
  'dokumenform.file.downloadAria': 'Download {name}',
  'dokumenform.file.replaceTooltip': 'Ganti file',
  'dokumenform.file.uploadTooltip': 'Upload file',
  'dokumenform.file.replaceAria': 'Replace file',
  'dokumenform.file.uploadAria': 'Upload file',
  'dokumenform.file.uploading': 'Uploading…',
  'dokumenform.file.replaceUploading': 'Mengganti file…',
  'dokumenform.file.noUrlInResponse': 'Response tidak mengandung URL file yang baru',
  'dokumenform.barang.statusSuggested': '{count} dari {total} barang dicentang otomatis. Periksa sebelum menyimpan.',
  'dokumenform.barang.legend':
    'Badge hijau: cocok dengan baris sertifikat. Badge kuning: kecocokan lebih lemah. Tanpa badge: tidak dicocokkan, centang manual jika sertifikat mencakupnya.',
  'dokumenform.barang.legendWithCount':
    'Badge hijau: cocok dengan baris sertifikat. Badge kuning: jumlah baris sertifikat sama dengan jumlah barang, jadi sisanya kemungkinan tercakup. Periksa sebelum menyimpan.',
  'dokumenform.barang.claimedNote':
    '{count} barang sudah terlampir di sertifikat lain dan tidak bisa dicentang di sini. Lepaskan di sana dulu jika ingin memindahkannya.',
  'dokumenform.barang.showUnmatched': 'Lihat {count} barang yang tidak dicocokkan',
  'dokumenform.barang.hideUnmatched': 'Sembunyikan {count} barang yang tidak dicocokkan',
  'dokumenform.barang.suggestedHigh': 'Disarankan {percent}%',
  'dokumenform.barang.suggestedMedium': 'Mungkin cocok {percent}%',
  'dokumenform.barang.suggestedCount': 'Disarankan, jumlah sama',
  'dokumenform.barang.countTooltip':
    'Sertifikat ini punya {n} baris, sama dengan jumlah barang. Barang ini tidak cocok berdasarkan teks, tetapi kemungkinan tercakup.',
  'dokumenform.barang.suggestedHsCode': 'Disarankan, kode HS sama',
  'dokumenform.barang.hsCodeTooltip': 'Kode HS sama dengan yang tercantum di dokumen: {hs}',
  'dokumenform.barang.claimedBadge': 'Sudah di seri {seri}',
  'dokumenform.barang.claimedTooltip':
    'Barang ini sudah terlampir di dokumen seri {seri} dengan kode yang sama. Lepaskan di sana dulu untuk memindahkannya ke sini.',
  'dokumenform.button.selectAll': 'Pilih semua ({n})',
  'dokumenform.button.deselectAll': 'Kosongkan',
  'dokumenform.button.simpanCount': 'Simpan ({n} barang)',
  'dokumenform.barang.more': '+{n} more',
  'dokumenform.confidence.overall': 'Kepercayaan Keseluruhan',
  'dokumenform.confidence.documentNumber': 'Kepercayaan Nomor Dokumen',
  'dokumenform.confidence.documentDate': 'Kepercayaan Tanggal Dokumen',

  // <i18n-anchor-dokumenform>
  // <i18n-anchor-entitasform>
  'entitasform.entitas': 'Entitas',
  'entitasform.nibWajibDiisi': 'NIB wajib diisi',
  'entitasform.nibPerluDicek':
    'NIB diambil dari pengajuan sebelumnya dengan penulisan NPWP lain. Mohon periksa sebelum submit.',
  'entitasform.errNibImportirWajib': 'NIB Importir wajib diisi',
  'entitasform.errNibImportir13Digit': 'NIB Importir harus 13 digit',
  'entitasform.errNamaImportirWajib': 'Nama Importir wajib diisi',
  'entitasform.errJenisApiImportirWajib': 'Jenis API Importir wajib diisi',
  'entitasform.errJenisIdentitasWajib': 'Jenis Identitas wajib diisi',
  'entitasform.errNpwpImportirWajib': 'NPWP Importir wajib diisi',
  'entitasform.errAlamatImportirWajib': 'Alamat Importir wajib diisi',
  'entitasform.errStatusImportirWajib': 'Status Importir wajib diisi',
  'entitasform.errFieldWajibDiisi': 'Field ini wajib diisi',
  'entitasform.successTitle': 'Success',
  'entitasform.successMessage': 'Entity data loaded successfully!',
  'entitasform.titlePemilikBarang': 'Pemilik Barang',
  'entitasform.titlePemusatan': 'Pemusatan',
  'entitasform.titlePengirim': 'Pengirim',
  'entitasform.titlePenjual': 'Penjual',
  'entitasform.titlePpjk': 'PPJK',
  'entitasform.actionSalinImportir': 'Salin Importir',
  'entitasform.actionSalinDataPengirim': 'Salin Data Pengirim',
  'entitasform.importir': 'Importir',
  'entitasform.fieldJenis': 'Jenis',
  'entitasform.fieldNpwp': 'NPWP {title}',
  'entitasform.fieldNama': 'Nama {title}',
  'entitasform.fieldNegara': 'Negara {title}',
  'entitasform.fieldAlamat': 'Alamat {title}',
  'entitasform.fieldStatus': 'Status',
  'entitasform.fieldApiNib': 'API/NIB',
  'entitasform.fieldNib': 'NIB',
  'entitasform.fieldAfiliasi': 'Afiliasi',
  'entitasform.syncDariJarvis': 'Sync dari Jarvis',
  'entitasform.syncPerluDiperiksa': 'Berbeda dari dokumen terakhir — ambil data dari Jarvis',
  'entitasform.pilihDataDariJarvis': 'Pilih Data {title} dari Jarvis',
  'entitasform.syncGagal': 'Sync Gagal',
  'entitasform.tidakAdaDataJarvis': 'Tidak ada data untuk NPWP ini di Jarvis.',
  'entitasform.gagalSyncJarvis': 'Gagal sync data dari Jarvis.',
  'entitasform.npwpBelumLengkap': 'NPWP belum lengkap',
  'entitasform.npwpHarus16Digit': 'NPWP harus 16 digit untuk sync dari Jarvis.',
  'entitasform.diterapkan': 'Diterapkan',
  'entitasform.pilihDariRiwayat': 'Pilih dari riwayat dokumen',
  'entitasform.dataConsigneeSumber': 'Data Consignee',
  'entitasform.bukaDiConsignee': 'Buka di Data Consignee',
  'entitasform.bukaConsignee': 'Buka Data Consignee',
  'entitasform.riwayatDokumenCount': 'Riwayat dokumen ({count})',
  'entitasform.diperbaruiTanggal': 'Diperbarui {date}',
  'entitasform.belumAdaDiConsignee':
    'Importir ini belum ada di Master › Data Consignee. Setelah dokumen berhasil dikirim ke CEISA, data importir akan disimpan otomatis sebagai sumber utama.',
  'entitasform.belumAdaDiConsigneeSingkat':
    'Belum ada di Data Consignee. Tersimpan otomatis setelah dokumen berhasil dikirim ke CEISA.',
  'entitasform.dataMasterTidakBisaDitandai': 'Data Consignee dikelola di menu Master, bukan ditandai salah di sini.',
  'entitasform.riwayatTidakDapatDimuat': 'Riwayat dokumen tidak dapat dimuat',
  'entitasform.dibukaDiTabBaru': 'Dibuka di tab baru: Master › Data Consignee',
  'entitasform.dataConsigneeSeksi': 'DATA CONSIGNEE',
  'entitasform.consigneeTerpakai': 'Data consignee diterapkan ke Importir.',
  'entitasform.simpanKeConsignee': 'Simpan ke Data Consignee',
  'entitasform.simpanKeConsigneeHint': 'Simpan importir ini agar terisi otomatis di dokumen berikutnya.',
  'entitasform.tersimpanKeConsignee': 'Tersimpan ke Data Consignee',
  'entitasform.tersimpanKeConsigneeMsg': 'Importir ini akan terisi otomatis dari NPWP-nya mulai sekarang.',
  'entitasform.consigneeSudahAda': 'NPWP ini sudah ada di Data Consignee.',
  'entitasform.gagalSimpanConsignee': 'Gagal menyimpan ke Data Consignee.',
  'entitasform.dataDiterapkanSection': 'Data Jarvis diterapkan ke section.',
  'entitasform.dataDiterapkanImportir': 'Data Jarvis diterapkan ke Importir.',
  'entitasform.gagalMenyimpanEntitas': 'Gagal menyimpan Entitas',
  'entitasform.dataHistoricalBelumTersimpan': 'Data historical sudah diterapkan, tetapi belum tersimpan.',
  'entitasform.disinkronDariRiwayat': 'Disinkron dari riwayat dokumen',
  'entitasform.dataDariDokumenSebelumnya':
    'Data ini diambil dari dokumen sebelumnya. Periksa & sesuaikan sebelum dikirim.',
  'entitasform.optMita': 'MITA',
  'entitasform.optAeo': 'AEO',
  'entitasform.optLainnya': 'LAINNYA',
  'entitasform.optApiU': 'API U',
  'entitasform.optApiP': 'API P',
  'entitasform.optPaspor': '2 - PASPOR',
  'entitasform.optKtp': '3 - KTP',
  'entitasform.optLainnyaIdentitas': '4 - LAINNYA',
  'entitasform.optNpwp15': '5 - NPWP 15 DIGIT',
  'entitasform.optNpwp16': '6 - NPWP 16 DIGIT',
  'entitasform.optAfl': 'AFL - Affiliated Company',
  'entitasform.optCtr': 'CTR - Financial/legally controlled',
  'entitasform.optFam': 'FAM - Family member',
  'entitasform.optTah': 'TAH - Tidak berhubungan',
  // <i18n-anchor-kemasanform>
  'kemasanform.seri': 'Seri',
  'kemasanform.jumlah': 'Jumlah',
  'kemasanform.jenis': 'Jenis',
  'kemasanform.merek': 'Merek',
  'kemasanform.aksi': 'Aksi',
  'kemasanform.nomor': 'Nomor',
  'kemasanform.ukuran': 'Ukuran',
  'kemasanform.tipe': 'Tipe',
  'kemasanform.kemasan': 'Kemasan',
  'kemasanform.petiKemas': 'Peti Kemas',
  'kemasanform.tambahKemasan': 'Tambah Kemasan',
  'kemasanform.tambahPetiKemas': 'Tambah Peti Kemas',
  'kemasanform.totalPetiKemas': 'Total: {n}',
  'kemasanform.edit': 'Edit',
  'kemasanform.copy': 'Copy',
  'kemasanform.delete': 'Delete',
  'kemasanform.required': 'This field is required!',
  'kemasanform.jenisOptionEmpty': '4 - EMPTY',
  'kemasanform.jenisOptionLcl': '7 - LCL',
  'kemasanform.jenisOptionFcl': '8 - FCL',
  'kemasanform.tipeOptionGeneralDry': '1 - GENERAL / DRY CARGO',
  'kemasanform.tipeOptionTunnel': '2 - TUNNEL TYPE',
  'kemasanform.tipeOptionOpenTop': '3 - OPEN TOP STEEL',
  'kemasanform.tipeOptionFlatRack': '4 - FLAT RACK',
  'kemasanform.tipeOptionReefer': '5 - REEFER/REFRIGERATE',
  'kemasanform.tipeOptionBarge': '6 - BARGE CONTAINER',
  'kemasanform.tipeOptionBulk': '7 - BULK CONTAINER',
  'kemasanform.tipeOptionIsotank': '8 - ISOTANK',
  'kemasanform.tipeOptionLain': '99 - LAIN-LAIN',
  // PengangkutForm
  'pengangkutform.smartSync': 'Smart Sync dengan BC 1.1',
  'pengangkutform.syncing': 'Menyinkronkan...',
  'pengangkutform.kodeTutupPu': 'Kode Tutup PU',
  'pengangkutform.nomorBc11': 'Nomor BC 1.1',
  'pengangkutform.tanggalTutupPu': 'Tanggal Tutup PU',
  'pengangkutform.nomorPos': 'Nomor Pos',
  'pengangkutform.nomorSubpos': 'Nomor Subpos',
  'pengangkutform.nomorSubsubpos': 'Nomor Subsubpos',
  'pengangkutform.pengangkutan': 'Pengangkutan',
  'pengangkutform.caraPengangkutan': 'Cara Pengangkutan',
  'pengangkutform.namaSaranaPengangkut': 'Nama Sarana Pengangkut',
  'pengangkutform.nomorVoyFlightNoPol': 'Nomor Voy/Flight/No. Pol',
  'pengangkutform.bendera': 'Bendera',
  'pengangkutform.perkiraanTanggalTiba': 'Perkiraan Tanggal Tiba',
  'pengangkutform.cariBendera': 'Cari Bendera',
  'pengangkutform.pelabuhanTempatPenimbunan': 'Pelabuhan & Tempat Penimbunan',
  'pengangkutform.pelabuhanMuat': 'Pelabuhan Muat',
  'pengangkutform.pelabuhanTransit': 'Pelabuhan Transit',
  'pengangkutform.pelabuhanTujuan': 'Pelabuhan Tujuan',
  'pengangkutform.tempatPenimbunan': 'Tempat penimbunan',
  'pengangkutform.noticeOfArrival': 'Notice of Arrival',
  'pengangkutform.loadingData': 'Memuat data...',
  'pengangkutform.useThisValue': 'Gunakan nilai ini',
  'pengangkutform.uploading': 'Mengunggah...',
  'pengangkutform.maxFileSize': 'Ukuran file maksimum: 2MB',
  'pengangkutform.extractedInfo': '✓ Informasi yang Diekstrak',
  'pengangkutform.warehouse': 'Gudang:',
  'pengangkutform.invoiceNumber': 'Nomor Invoice:',
  'pengangkutform.shipper': 'Pengirim:',
  'pengangkutform.consignee': 'Penerima:',
  'pengangkutform.flagNameFromApi': 'Nama bendera dari API',
  'pengangkutform.portOfLoadingFromApi': 'Pelabuhan muat dari API',
  'pengangkutform.notifError': 'Error',
  'pengangkutform.notifSuccess': 'Sukses',
  'pengangkutform.notifWarning': 'Peringatan',
  'pengangkutform.notifFileTooLarge': 'File Terlalu Besar',
  'pengangkutform.notifUploadSuccessful': 'Upload Berhasil',
  'pengangkutform.notifPdfExtractionComplete': 'Ekstraksi PDF Selesai',
  'pengangkutform.notifUploadFailed': 'Upload Gagal',
  'pengangkutform.notifDocumentNotFound': 'Dokumen Tidak Ditemukan',
  'pengangkutform.notifIncompleteDocument': 'Dokumen Tidak Lengkap',
  'pengangkutform.notifNoData': 'Tidak Ada Data',
  'pengangkutform.notifDemoNoCeisa': 'Tidak tersedia di akun demo',
  'pengangkutform.msgDemoNoCeisa': 'Akun demo tidak terhubung ke CEISA, jadi data BC 1.1 tidak dapat diambil. Silakan isi Nomor BC 1.1, Tanggal Tutup PU, dan Nomor Pos secara manual. Fitur ini aktif setelah akun terhubung dengan CEISA.',
  'pengangkutform.notifApiError': 'API Error',
  'pengangkutform.msgEnterVesselNameFirst': 'Silakan masukkan nama kapal terlebih dahulu',
  'pengangkutform.msgFlagFound': 'Bendera ditemukan: {flag}',
  'pengangkutform.msgNoFlagInfo': 'Tidak ada informasi bendera untuk kapal ini',
  'pengangkutform.msgNoAirlineFlagInfo': 'Maskapai tidak dikenali, pilih bendera secara manual',
  'pengangkutform.msgEnterAirlineFirst': 'Silakan masukkan nama maskapai atau nomor penerbangan terlebih dahulu',
  'pengangkutform.msgFailedFetchFlag': 'Gagal mengambil informasi bendera kapal',
  'pengangkutform.msgFileTooLarge': 'Ukuran file harus kurang dari 2MB',
  'pengangkutform.msgBatchUuidNotFound': 'Batch UUID tidak ditemukan di URL',
  'pengangkutform.msgUploadSuccessful': 'File NOA "{name}" berhasil diunggah',
  'pengangkutform.msgPdfExtractionComplete': 'Data Notice of Arrival berhasil diekstrak',
  'pengangkutform.msgUploadFailed': 'Gagal mengunggah file NOA',
  'pengangkutform.msgNoBlDocument': 'Dokumen B/L (705) atau AWB (740) tidak ditemukan. Silakan tambahkan dokumen B/L atau AWB terlebih dahulu.',
  'pengangkutform.msgBlIncomplete': 'Dokumen B/L / AWB harus memiliki nomor dan tanggal.',
  'pengangkutform.msgPopulatedFields': '{n} field berhasil diisi dari Manifest BC 1.1',
  'pengangkutform.msgNoManifestData': 'Tidak ada data dalam respons Manifest BC 1.1',
  'pengangkutform.msgFailedRetrieveManifest': 'Gagal mengambil data manifest',
  'pengangkutform.msgFailedCallManifest': 'Gagal memanggil API Manifest BC 1.1. Silakan coba lagi.',
  'pengangkutform.caraOpt1': '1 - LAUT',
  'pengangkutform.caraOpt2': '2 - KERETA API',
  'pengangkutform.caraOpt3': '3 - DARAT',
  'pengangkutform.caraOpt4': '4 - UDARA',
  'pengangkutform.caraOpt5': '5 - POS',
  'pengangkutform.caraOpt6': '6 - MULTIMODA',
  'pengangkutform.caraOpt7': '7 - INSTALASI / PIPA',
  'pengangkutform.caraOpt8': '8 - PERAIRAN',
  'pengangkutform.caraOpt9': '9 - LAINNYA',
  // <i18n-anchor-pengangkutform>
  // <i18n-anchor-transaksiform>
  'transaksiform.titleHarga': 'Harga',
  'transaksiform.warningPastikanValuta': 'Harap pastikan valuta sudah benar',
  'transaksiform.labelValuta': 'Valuta',
  'transaksiform.placeholderPilihValuta': 'Pilih Valuta',
  'transaksiform.labelNdpbm': 'NDPBM',
  'transaksiform.placeholderNdpbm': 'NDPBM',
  'transaksiform.labelJenisTransaksi': 'Jenis Transaksi',
  'transaksiform.placeholderJenisTransaksi': 'Pilih Jenis Transaksi',
  'transaksiform.labelIncoterm': 'Incoterm',
  'transaksiform.placeholderIncoterm': 'Pilih Incoterm',
  'transaksiform.labelHargaBarang': 'Harga Barang',
  'transaksiform.placeholderHargaBarang': 'Harga Barang',
  'transaksiform.labelNilaiPabeanRupiah': 'Nilai Pabean dalam Rupiah',
  'transaksiform.placeholderNilaiPabeanRupiah': 'Nilai Pabean dalam Rupiah',
  'transaksiform.informasiKomponenBiaya': 'Informasi Komponen Biaya',
  'transaksiform.titleHargaLainnya': 'Harga Lainnya',
  'transaksiform.biayaPenambahan': 'Biaya penambahan',
  'transaksiform.biayaPengurang': 'Biaya pengurang',
  'transaksiform.freight': 'Freight',
  'transaksiform.labelAsuransi': 'Asuransi',
  'transaksiform.placeholderAsuransi': 'Asuransi',
  'transaksiform.nilaiAsuransi': 'Nilai Asuransi',
  'transaksiform.labelVoluntaryDeclaration': 'Voluntary declaration',
  'transaksiform.placeholderVoluntaryDeclaration': 'Voluntary declaration',
  'transaksiform.titleBerat': 'Berat',
  'transaksiform.labelBeratKotor': 'Berat Kotor (KGM)',
  'transaksiform.placeholderBeratKotor': 'Berat Kotor (KGM)',
  'transaksiform.labelBeratBersih': 'Berat Bersih (KGM)',
  'transaksiform.placeholderBeratBersih': 'Berat Bersih (KGM)',
  'transaksiform.helperNettoDihitung':
    'Dihitung dari total netto barang. Gunakan "Samakan ke berat kotor" untuk menyesuaikan, atau isi netto per barang di tab Barang. Tab Transaksi tetap kuning sampai nilai > 0.',
  'transaksiform.buttonSamakanKeBeratKotor': 'Samakan ke berat kotor',
  'transaksiform.tooltipSamakanKeBeratKotor':
    'Sesuaikan netto barang pertama agar total berat bersih sama dengan berat kotor',
  'transaksiform.disabledSamakanBrutoKosong': 'Isi berat kotor terlebih dahulu',
  'transaksiform.disabledSamakanTidakAdaBarang': 'Tidak ada barang untuk disamakan',
  'transaksiform.modalSamakanTitle': 'Samakan berat bersih ke berat kotor',
  'transaksiform.modalSamakanBeratKotor': 'Berat kotor',
  'transaksiform.modalSamakanTotalNetto': 'Total berat bersih saat ini',
  'transaksiform.modalSamakanItem': 'Barang yang diubah',
  'transaksiform.modalSamakanNettoLama': 'Netto lama',
  'transaksiform.modalSamakanNettoBaru': 'Netto baru',
  'transaksiform.modalSamakanConfirm': 'Samakan',
  'transaksiform.modalSamakanCancel': 'Batal',
  'transaksiform.hintNettoTidakSamaBruto':
    'Berat bersih berbeda dari berat kotor. Gunakan tombol di atas untuk menyamakan.',
  'transaksiform.errSamakanFirstNegatif':
    'Netto barang lain sudah melebihi berat kotor. Kurangi netto di tab Barang terlebih dahulu.',
  'transaksiform.errSamakanTidakAdaBarang': 'Tidak ada barang untuk disamakan',
  'transaksiform.errSamakanBrutoKosong': 'Berat kotor harus lebih dari 0',
  // Tab-bar ring tooltips.
  'docpabean.tabs.mandatoryFilled': '{filled} / {total} kolom wajib terisi.',
  // Tab-bar warning ring: Transaksi and Barang totals disagree.
  'docpabean.tabs.hargaMismatchTooltip':
    'Total harga tidak sama: tab Barang {barang} {valuta} ({seri} seri), tab Transaksi {harga} {valuta}. Selisih {selisih} {valuta}. Buka tab Transaksi untuk menyamakan.',
  // Harga Barang (Transaksi) vs Σ Total Nilai (Barang). Placeholders are filled
  // by utils/hargaBarangCheck.ts — keep {harga}/{barang}/{selisih}/{valuta}/{seri}.
  'transaksiform.hintHargaTidakSamaBarang':
    'Total nilai di tab Barang ({barang} {valuta} dari {seri} seri) tidak sama dengan Harga Barang di sini ({harga} {valuta}). Selisih {selisih} {valuta}.',
  'transaksiform.buttonSamakanHargaBarang': 'Samakan dengan total tab Barang',
  'transaksiform.modalSamakanHargaTitle': 'Samakan Harga Barang dengan total Barang',
  'transaksiform.modalSamakanHargaSekarang': 'Harga Barang sekarang',
  'transaksiform.modalSamakanHargaTotalBarang': 'Total nilai tab Barang ({seri} seri)',
  'transaksiform.modalSamakanHargaSelisih': 'Selisih',
  'transaksiform.modalSamakanHargaPenjelasan':
    'Harga Barang akan diisi dengan total nilai dari tab Barang. Harga per barang tidak diubah.',
  'transaksiform.modalSamakanHargaCatatanBiaya':
    'Catatan: Freight {freight} {valuta} dan Asuransi {asuransi} {valuta} diisi terpisah. Pastikan total di tab Barang belum termasuk keduanya, agar nilai pabean tidak dihitung dua kali.',
  'transaksiform.modalSamakanHargaHapusBiaya':
    'Biaya penambah akan dihapus karena dianggap sudah termasuk dalam total tab Barang: Freight {freight} {valuta}, Asuransi {asuransi} {valuta}, Biaya penambahan {biaya} {valuta}. Freight dan asuransi per barang juga dijadikan 0; harga per barang tidak berubah.',
  // Barang total = Harga Barang + freight + asuransi + biaya penambahan.
  'transaksiform.hintBiayaDalamBarang':
    'Total nilai di tab Barang ({barang} {valuta} dari {seri} seri) sama dengan Harga Barang ({harga} {valuta}) ditambah biaya penambah ({biaya} {valuta}: freight, asuransi, dll.). Jika biaya tersebut sudah termasuk dalam harga di invoice, samakan Harga Barang agar biaya tidak dihitung dua kali.',
  'transaksiform.hargaSamakanApplied': 'Harga Barang diisi {amount} {valuta} dari total tab Barang',
  'transaksiform.errHargaSamakanGagal': 'Gagal menyamakan Harga Barang. Coba lagi.',
  'transaksiform.errNettoHarusLebihDari0': 'Berat Bersih harus lebih dari 0 — isi netto per barang di tab Barang',
  'transaksiform.errNettoLebihDariBruto': 'Berat Bersih tidak boleh lebih besar dari Berat Kotor',
  'transaksiform.warningTitle': 'Warning',
  'transaksiform.errNdpbmRetrieve': 'Could not retrieve NDPBM value. Please enter manually.',
  'transaksiform.errorTitle': 'Error',
  'transaksiform.errNdpbmFetch': 'Error when fetching NDPBM',
  'transaksiform.confGrossWeight': 'Gross weight confidence',
  'transaksiform.confCurrency': 'Currency confidence',
  'transaksiform.confIncoterm': 'Incoterm confidence',
  'transaksiform.confHargaBarang': 'Harga barang confidence',
  'transaksiform.confFreight': 'Freight confidence',
  'transaksiform.confInsurance': 'Insurance value confidence',
  'transaksiform.confNdpbm': 'Exchange rate confidence',
  'transaksiform.confCif': 'CIF value confidence',
  'transaksiform.confNetto': 'Net weight confidence',
  // BarangForm — daftar barang (goods table)
  'barangform.notifError': 'Error',
  'barangform.notifSuccess': 'Berhasil',
  'barangform.notifInfo': 'Info',
  'barangform.minOneBarang': 'Minimal satu barang harus ditambahkan untuk melanjutkan',
  'barangform.seriUraianKosong': 'Seri barang [{seri}] ditemukan Uraian masih kosong',
  'barangform.seriSatuanKosong': 'Seri barang [{seri}] ditemukan Satuan masih kosong',
  'barangform.seriKodeSatuanKosong': 'Seri barang [{seri}] ditemukan Kode Satuan masih kosong',
  'barangform.seriNegaraKosong': 'Seri barang [{seri}] ditemukan Negara masih kosong',
  'barangform.seriHsKosong': 'Seri Barang [{seri}] ditemukan HS Code masih kosong',
  'barangform.seriHs8Digit': 'Seri Barang [{seri}] HS Code harus 8 digit',
  'barangform.gagalMenghapusDokumen': 'Gagal menghapus dokumen',
  'barangform.noItemsSelected': 'No items selected',
  'barangform.updatedCount': '{count} item berhasil diperbarui',
  'barangform.bulkEditFailed': 'Bulk edit failed',
  'barangform.seriBarangRequired': 'Seri Barang wajib diisi',
  'barangform.dataBerhasilDiperbarui': 'Data barang berhasil diperbarui',
  'barangform.gagalMemperbaruiData': 'Gagal memperbarui data barang',
  'barangform.fetchHsDetailsFailed': 'Failed to fetch HS code details',
  'barangform.fetchHsDetailsError': 'Error fetching HS code details',
  'barangform.itemBerhasilDihapus': 'Item berhasil dihapus',
  'barangform.gagalMenghapusItem': 'Gagal menghapus item',
  'barangform.tidakAdaItemDipilih': 'Tidak ada item yang dipilih',
  'barangform.itemBerhasilDihapusCount': '{count} item berhasil dihapus',
  'barangform.itemBerhasilDisalin': 'Item berhasil disalin',
  'barangform.gagalMenyalinItem': 'Gagal menyalin item',
  'barangform.loadItemEditFailed': 'Failed to load item for editing',
  'barangform.processIdNotFound': 'Process ID not found',
  'barangform.downloadSuccess': 'Download success!',
  'barangform.downloadFailed': 'Download failed!',
  'barangform.pilihFilePdf': 'Silakan pilih file PDF terlebih dahulu',
  'barangform.processIdTidakDitemukan': 'Process ID tidak ditemukan',
  'barangform.invoiceUploadSuccess': 'Invoice berhasil diupload dan sedang diproses',
  'barangform.uploadInvoiceError': 'Terjadi kesalahan saat upload invoice',
  'barangform.noItemsToCheck': 'No items to check',
  'barangform.noDuplicateDescriptions': 'No duplicate descriptions found',
  'barangform.foundDuplicates': 'Ditemukan {count} item dengan deskripsi duplikat',
  'barangform.tidakAdaBarangSync': 'Tidak ada barang untuk di-sync',
  'barangform.tidakAdaHsValid': 'Tidak ada HS Code yang valid untuk di-sync',
  'barangform.syncProsesDimulai': 'Proses sync {count} HS Code telah dimulai. Silakan tunggu hingga selesai.',
  'barangform.gagalMemulaiSync': 'Gagal memulai sync: {msg}',
  'barangform.tidakAdaHsCodeSync': 'Tidak ada HS Code untuk di-sync',
  'barangform.hsCodeSyncCount': '{count} HS Code berhasil di-sync',
  'barangform.hsCodeSyncErrorSuffix': ', {count} error',
  'barangform.gagalSyncTarifInsw': 'Gagal sync tarif dengan INSW',
  'barangform.processIdTidakTersedia': 'Process ID tidak tersedia. Silakan muat ulang halaman.',
  'barangform.processIdTidakTersediaSingkat': 'Process ID tidak tersedia',
  'barangform.noItemsToSync': 'Tidak ada barang untuk disinkronkan',
  'barangform.gagalSimpanSebelumSync': 'Gagal menyimpan data barang sebelum sinkronisasi',
  'barangform.smartSyncSukses': 'Smart Sync berhasil dijalankan',
  'barangform.smartSyncGagal': 'Smart Sync gagal',
  'barangform.noValidHsSync': 'Tidak ada kode HS valid untuk disinkronkan',
  'barangform.lartasStatusUpdated': 'Status LARTAS diperbarui untuk {count} item',
  'barangform.lartasAlreadyUpToDate': 'LARTAS status is already up to date',
  'barangform.gagalAmbilLartas': 'Failed to retrieve LARTAS data',
  'barangform.gagalSyncLartas': 'Failed to sync LARTAS data',
  'barangform.itemDariDatabaseSukses': 'Item berhasil ditambahkan dari database!',
  'barangform.gagalItemDatabase': 'Gagal menambahkan item dari database',
  'barangform.cifBerhasil': 'Biaya proporsional berhasil dihitung',
  'barangform.gagalHitungCif': 'Gagal menghitung biaya proporsional',
  'barangform.fobBerhasil': 'Harga FOB berhasil diterapkan',
  'barangform.gagalTerapkanFob': 'Gagal menerapkan harga FOB',
  'barangform.itemUpdatedApplied':
    'Item updated and changes applied to {count} items with same HS code or empty HS code',
  'barangform.itemUpdatedNoApply': 'Item updated. No other items had matching or empty HS codes to apply changes to.',
  'barangform.gagalSimpanServer': 'Failed to save changes to server. Please try again.',
  'barangform.itemAddedSukses': 'Item added successfully',
  'barangform.gagalSimpanItemBaru': 'Failed to save new item to server. Please try again.',
  'barangform.syncedTooltip': 'Data diambil dari dokumen sebelumnya',
  'barangform.syncedFromAjuLabel': 'Synced from Aju {aju}',
  'barangform.syncedFromDraftLabel': 'Synced from Draft {id}',
  'barangform.cekTarifInsw': 'Mengecek tarif dengan INSW...',
  'barangform.inswCocok': 'INSW tarif cocok ({kind}: {value}%)',
  'barangform.inswBerbeda': 'INSW tarif berbeda — INSW {kind}: {value}%',
  'barangform.inswCocokPreferensi': 'Sesuai INSW — tarif preferensi {pref} {value}% (MFN {mfn}%)',
  'barangform.inswPreferensiTidakDipakai': 'Preferensi {pref} {value}% tersedia dari SKA, tetapi BM memakai MFN {mfn}%',
  'barangform.inswGagal': 'Tarif INSW untuk HS ini tidak dapat diambil',
  'barangform.dataInswUmur': 'Data INSW: {age}',
  'barangform.preferentialMfnTooltip': '{preference}: "{raw}" untuk HS ini → tarif MFN dipakai.',
  'barangform.preferentialMfnFallbackPreference': 'Skema preferensi yang berlaku',
  'trq.status.trq':
    'Pos tarif ini kena kuota tarif (TRQ). Di luar kuota berlaku tarif MFN; centang "dalam kuota" dan isi nomor alokasi kuota untuk memakai tarif dalam kuota.',
  'trq.status.trq.badge': 'TRQ · MFN',
  'trq.status.trq_in_quota': 'Tarif TRQ dalam kuota diterapkan berdasarkan nomor alokasi kuota yang diisi.',
  'trq.status.trq_in_quota.badge': 'TRQ dalam kuota',
  'trq.status.trq_no_ref': 'Diklaim dalam kuota tanpa nomor alokasi kuota — BM tetap MFN.',
  'trq.status.trq_no_ref.badge': 'TRQ · lengkapi',
  'trq.status.trq_no_rate':
    'Diklaim dalam kuota, tetapi tarif TRQ untuk HS dan skema ini belum ada di master Tarif TRQ — BM tetap MFN.',
  'trq.status.trq_no_rate.badge': 'TRQ · tarif belum ada',
  'trq.status.trq_no_qty':
    'Diklaim dalam kuota, tetapi jumlah barang dalam satuan tarif TRQ tidak diketahui (isi netto atau satuan yang sama) — BM tetap MFN.',
  'trq.status.trq_no_qty.badge': 'TRQ · satuan',
  'trq.blocked.NO_QUOTA_REF': 'Barang seri {seri}: klaim TRQ dalam kuota belum ada nomor alokasi kuota, BM tetap MFN.',
  'trq.blocked.NO_RATE': 'Barang seri {seri}: tarif TRQ dalam kuota belum ada di master Tarif TRQ, BM tetap MFN.',
  'trq.blocked.NO_QUANTITY': 'Barang seri {seri}: jumlah dalam satuan tarif TRQ tidak diketahui, BM tetap MFN.',
  'pungutanform.readiness.trq':
    'Barang seri {seri}: pos tarif kuota (TRQ) — BM memakai MFN kecuali diklaim dalam kuota di tab Pungutan barang.',
  'pungutanform.readiness.trqInQuota': 'Barang seri {seri}: tarif TRQ dalam kuota diterapkan.',
  'trq.claim.title': 'Kuota tarif (TRQ)',
  'trq.claim.inQuota': 'Klaim tarif dalam kuota (TRQ)',
  'trq.claim.quotaRef': 'Nomor alokasi kuota',
  'trq.claim.quotaRefPlaceholder': 'Nomor surat alokasi kuota importir',
  'trq.claim.quotaRefRequired': 'Nomor alokasi kuota wajib diisi',
  'trq.claim.save': 'Simpan klaim',
  'trq.claim.saved': 'Klaim TRQ disimpan',
  'trq.claim.savedHint': 'Tarif BM barang ini sudah diperbarui.',
  'trq.claim.saveFailed': 'Gagal menyimpan klaim TRQ',
  'trq.tarif.specificLabel': 'Tarif (Rp/{unit})',
  'trq.tarif.jumlahSatuan': 'Jumlah Satuan',
  'trq.tarif.satuan': 'Satuan',
  'pungutanform.readiness.specificNoQty':
    'Barang seri {seri}: BM spesifik (Rp per satuan) tetapi jumlah satuannya 0 — isi netto atau jumlah satuan, BM masih Rp0.',
  'menu.tarifTrq': 'Tarif TRQ',
  'trqmaster.title': 'Tarif TRQ (dalam kuota)',
  'trqmaster.subtitle':
    'Tarif dalam kuota untuk pos tarif kuota (TRQ), yang tidak dipublikasikan INSW. Isi dari lampiran peraturan (mis. PMK 60 Tahun 2026); berlaku hanya untuk barang yang diklaim dalam kuota dengan nomor alokasi.',
  'trqmaster.add': 'Tambah tarif TRQ',
  'trqmaster.edit': 'Ubah',
  'trqmaster.delete': 'Hapus',
  'trqmaster.save': 'Simpan',
  'trqmaster.cancel': 'Batal',
  'trqmaster.searchHs': 'Cari HS…',
  'trqmaster.empty': 'Belum ada tarif TRQ',
  'trqmaster.saved': 'Tarif TRQ disimpan',
  'trqmaster.saveFailed': 'Gagal menyimpan tarif TRQ',
  'trqmaster.loadFailed': 'Gagal memuat tarif TRQ',
  'trqmaster.deleteFailed': 'Gagal menghapus tarif TRQ',
  'trqmaster.deleteConfirm': 'Hapus tarif TRQ untuk HS {hs}?',
  'trqmaster.col.hs': 'HS Code',
  'trqmaster.col.preference': 'Skema / perjanjian',
  'trqmaster.col.rate': 'Tarif dalam kuota',
  'trqmaster.col.validity': 'Berlaku',
  'trqmaster.col.regulation': 'Peraturan',
  'trqmaster.preferenceHint': 'Nama skema seperti di INSW, mis. IJEPA',
  'trqmaster.rateType': 'Jenis tarif',
  'trqmaster.rateType.specific': 'Spesifik (Rp per satuan)',
  'trqmaster.rateType.adValorem': 'Advalorum (%)',
  'trqmaster.rateRp': 'Tarif (Rp per satuan)',
  'trqmaster.ratePct': 'Tarif (%)',
  'trqmaster.unit': 'Satuan',
  'trqmaster.validFrom': 'Berlaku dari',
  'trqmaster.validTo': 'Berlaku sampai',
  'trqmaster.notes': 'Catatan',
  'trqmaster.err.hs': 'HS harus 8 digit',
  'trqmaster.err.required': 'Wajib diisi',
  'trqmaster.err.rate': 'Tarif tidak valid',
  'trqmaster.err.pct': 'Tarif advalorum maksimal 100%',
  'trqmaster.err.unit': 'Satuan wajib untuk tarif spesifik',
  'trqmaster.err.validTo': 'Tanggal akhir sebelum tanggal mulai',
  'barangform.memuatDetailHs': 'Memuat detail HS...',
  'barangform.lihatDetailHs': 'Lihat detail HS',
  'barangform.hsPick': 'Pilih HS code dari dokumen pengangkutan',
  'barangform.hsPickFailed': 'Gagal menyimpan HS code yang dipilih',
  'barangform.lartas': 'Lartas',
  'barangform.non': 'Non',
  'barangform.unnamedItem': 'Unnamed Item',
  'barangform.justNow': 'baru saja',
  'barangform.hoursAgo': '{count} jam yang lalu',
  'barangform.oneDayAgo': '1 hari yang lalu',
  'barangform.daysAgo': '{count} hari yang lalu',
  'barangform.hsCodeKosong': 'HS code kosong',
  'barangform.tidakAdaHsCodeDicari': 'Tidak ada HS code untuk dicari.',
  'barangform.prefTarif': '{pref} {year}: {nilai} vs BM {bm}%',
  'barangform.prefNoTarif': '{pref} — tidak ada tarif untuk {year}',
  'barangform.skbPphBadge': 'PPh BEBAS',
  'barangform.skbPphApplied': 'SKB PPh terhubung — PPh dibebaskan (fasilitas 5), tarif {tarif}% tetap tercatat.',
  'barangform.skbPphAppliedNoDoc':
    'PPh dibebaskan (fasilitas 5) tanpa dokumen SKB PPh terhubung — pastikan SKB ada di Tab Dokumen sebelum submit.',
  'barangform.skbPphPending':
    'SKB PPh terhubung, fasilitas bebas PPh belum diterapkan pada barang ini — buka tab Pungutan atau jalankan Sync Tarif HS.',
  'barangform.skbPpnBadge': 'PPN BEBAS',
  'barangform.skbPpnApplied':
    'SKB PPN terhubung — PPN dibebaskan (fasilitas 5), tarif {tarif}% tetap tercatat, PPN dibayar 0.',
  'barangform.skbPpnAppliedNoDoc':
    'PPN dibebaskan (fasilitas 5) tanpa dokumen SKB PPN terhubung — pastikan SKB ada di Tab Dokumen sebelum submit.',
  'barangform.skbPpnPending':
    'SKB PPN terhubung, fasilitas bebas PPN belum diterapkan pada barang ini — buka tab Pungutan atau jalankan Sync Tarif HS.',
  'barangform.editLabel': 'Edit',
  'barangform.copyLabel': 'Copy',
  'barangform.deleteLabel': 'Delete',
  'barangform.colSeri': 'Seri',
  'barangform.colGroup': 'Group',
  'barangform.colHs': 'HS',
  'barangform.colLartas': 'Lartas',
  'barangform.lartasUnverified': 'PERLU CEK',
  'barangform.colUraian': 'Uraian',
  'barangform.uraianFull': 'Tampilkan uraian lengkap',
  'barangform.uraianCompact': 'Ringkas uraian',
  'barangform.colTotalNilai': 'Total Nilai',
  'barangform.colNw': 'NW',
  'barangform.colSatuan': 'Satuan',
  'barangform.colKemasan': 'Kemasan',
  'barangform.kemasanMismatchDetail':
    '{count} baris Barang memakai kemasan {codes}, sedangkan tab Kemasan & Peti Kemas menyatakan {target}.',
  'barangform.kemasanMismatchApply': 'Samakan semua ke {target}',
  'barangform.kemasanMismatchApplying': 'Menyamakan...',
  'barangform.kemasanMismatchDismiss': 'Abaikan',
  'barangform.kemasanMismatchNoCode': 'tanpa kode',
  'barangform.kemasanMismatchDone': '{count} baris Barang diubah ke kemasan {target}.',
  'barangform.kemasanMismatchFailed': 'Gagal menyamakan kemasan Barang.',
  'barangform.kemasanTotalMismatchTitle': 'Jumlah kemasan tidak sama',
  'barangform.kemasanTotalMismatchDetail':
    'Total kemasan di tab Barang ({barang}) tidak sama dengan jumlah di tab Kemasan ({kemasan}). Selisih {selisih}. Peringatan saja — tidak memblokir submit.',
  'barangform.kemasanTotalMismatchOpen': 'Lihat tab Kemasan',

  // Kode HS pendek (6 digit) pada tab Barang — lihat utils/hsSuggestions.ts.
  'barangform.hsShortSummary':
    '{codes} kode HS masih kurang dari 8 digit pada {rows} baris. CEISA hanya menerima kode 8 digit.',
  'barangform.hsShortRows': '{count} baris (seri {seri})',
  'barangform.hsShortPick': 'Pilih kode 8 digit ({count} pilihan)',
  'barangform.hsShortModalTitle': 'Pilih kode HS 8 digit untuk {heading}',
  'barangform.hsShortModalIntro':
    'Buku tarif (BTKI) mencatat kode berikut di bawah {heading}. Kode yang Anda pilih akan dipakai untuk {count} baris sekaligus (seri {seri}).',
  'barangform.hsShortCatchAll': 'Lain-lain',
  'barangform.hsShortInactive': 'Tidak aktif',
  'barangform.hsShortInactiveSome':
    'Tidak aktif = tidak ada di sinkronisasi INSW terakhir, bukan berarti tidak bisa dipakai.',
  'barangform.hsShortInactiveAll':
    'Semua kode di bawah pos ini tidak aktif di sinkronisasi INSW terakhir — data BTKI kami (2022) mungkin tertinggal. Periksa dulu sebelum dipakai.',
  'barangform.hsShortUserEdited': '{count} baris pernah diubah manual (seri {seri}) dan akan ikut ditimpa.',
  'barangform.hsShortCancel': 'Batal',
  'barangform.hsShortConfirm': 'Terapkan ke {count} baris',
  'barangform.hsShortDone': '{count} baris diubah dari {heading} menjadi {code}.',
  'barangform.hsShortDoneSkipped':
    '{count} baris diubah menjadi {code}. {skipped} baris dilewati karena sudah berubah.',
  'barangform.hsShortFailed': 'Gagal menerapkan rekomendasi kode HS.',

  // Kode HS 8 digit yang tidak ada di daftar BTKI/INSW kami — panel yang sama.
  'barangform.hsUnknownSummary': '{codes} kode HS 8 digit tidak ditemukan di daftar BTKI/INSW kami pada {rows} baris.',
  'barangform.hsUnknownPick': 'Pilih kode di bawah {prefix} ({count} pilihan)',
  'barangform.hsUnknownModalTitle': 'Kode HS {heading} tidak ditemukan di BTKI',
  'barangform.hsUnknownModalIntro':
    'Kode {heading} tidak ada di daftar BTKI/INSW kami. Buku tarif mencatat kode berikut di bawah {prefix} — 6 digit pertama dipertahankan, 2 digit terakhir yang dipilih ulang. Kode yang Anda pilih akan dipakai untuk {count} baris sekaligus (seri {seri}).',

  // Satuan Barang yang tidak sesuai ketentuan kode HS — lihat utils/satuanSuggestions.ts.
  'barangform.satuanMismatchSummary':
    '{count} baris Barang memakai satuan yang tidak diizinkan untuk kode HS-nya. Satuan Barang mengikuti ketentuan pada Informasi Kode HS.',
  'barangform.satuanMismatchRows': '{count} baris (seri {seri}) memakai {used}, seharusnya {allowed}',
  'barangform.satuanMismatchApply': 'Ganti ke {target}',
  'barangform.satuanMismatchConverted': 'jumlah ikut dikonversi',
  'barangform.satuanMismatchKept': 'jumlah tetap, periksa kembali',
  'barangform.satuanMismatchApplyAll': 'Samakan semua ({count} baris)',
  'barangform.satuanMismatchApplying': 'Mengganti...',
  'barangform.satuanMismatchDismiss': 'Abaikan',
  'barangform.satuanMismatchDone': '{count} baris Barang diubah ke satuan {targets}.',
  'barangform.satuanMismatchDoneSkipped':
    '{count} baris Barang diubah ke satuan {targets}. {skipped} baris dilewati karena sudah berubah.',
  'barangform.satuanMismatchFailed': 'Gagal mengganti satuan Barang.',
  'barangform.colDok': 'Dok',
  'barangform.colPpn': 'PPN',
  'barangform.colPph': 'PPH',
  'barangform.colBm': 'BM',
  'barangform.colAction': 'Action',
  'barangform.colJenisDokumen': 'Jenis Dokumen',
  'barangform.colKode': 'Kode',
  'barangform.colNomorDokumen': 'Nomor Dokumen',
  'barangform.colTanggal': 'Tanggal',
  'barangform.colKodeFasilitas': 'Kode Fasilitas',
  'barangform.colNamaFasilitas': 'Nama Fasilitas',
  'barangform.colKodeIjin': 'Kode Ijin',
  'barangform.colSeriIzin': 'Seri Izin',
  'barangform.hapusBarangTitle': 'Hapus Barang',
  'barangform.tindakanTidakBisaDibatalkan': 'Tindakan ini tidak dapat dibatalkan',
  'barangform.konfirmasiHapusBarang': 'Anda yakin ingin menghapus barang berikut?',
  'barangform.konfirmasiHapusMany': 'Anda yakin ingin menghapus {count} barang yang dipilih?',
  'barangform.labelSeri': 'Seri:',
  'barangform.labelUraian': 'Uraian:',
  'barangform.labelHsCode': 'HS Code:',
  'barangform.cancel': 'Batal',
  'barangform.deleting': 'Menghapus...',
  'barangform.delete': 'Hapus',
  'barangform.hapusCountTitle': 'Hapus {count} Barang',
  'barangform.hapusCountItem': 'Hapus {count} Item',
  'barangform.labelJumlahItem': 'Jumlah Item:',
  'barangform.jumlahItemCount': '{count} item',
  'barangform.labelSeriBarang': 'Seri Barang:',
  'barangform.lagiSuffix': ', ... (+{count} lagi)',
  'barangform.hsCodeDetailsTitle': 'HS Code Details',
  'barangform.tabBasicInfo': 'Basic Info',
  'barangform.tabTariffRates': 'Tariff Rates',
  'barangform.tabPreferentialCount': 'Preferential Tariffs ({count})',
  'barangform.labelCode': 'Code:',
  'barangform.labelNormalizedCode': 'Normalized Code:',
  'barangform.labelIdDescription': 'ID Description:',
  'barangform.labelEnDescription': 'EN Description:',
  'barangform.labelInswYear': 'INSW Year:',
  'barangform.labelLartas': 'LARTAS:',
  'barangform.yes': 'YES',
  'barangform.no': 'NO',
  'barangform.labelPpnBm': 'PPN BM',
  'barangform.na': 'N/A',
  'barangform.placeholderSearchPrefTariffs': 'Search preferential tariffs...',
  'barangform.labelIssueDate': 'Issue Date:',
  'barangform.labelEffective': 'Effective:',
  'barangform.nowSuffix': ' (now)',
  'barangform.labelHistoricalRates': 'Historical Rates:',
  'barangform.loadingHsDetails': 'Loading HS code details...',
  'barangform.dokumenTerlampir': 'Dokumen Terlampir',
  'barangform.seriInfoLine': 'Seri {seri}: {uraian}',
  'barangform.dokumenFallback': 'Dokumen {kode}',
  'barangform.deleteAttachmentAria': 'Delete attachment',
  'barangform.tidakAdaDokumenTerlampir': 'Tidak ada dokumen yang terlampir pada barang ini',
  'barangform.memuatDataBarang': 'Memuat data barang...',
  'barangform.menyalinDataBarang': 'Menyalin data barang...',
  'barangform.tambahBarang': 'Tambah Barang',
  'barangform.editBarang': 'Edit Barang',
  'barangform.editMassalCount': 'Edit Massal {count} Item',
  'barangform.bulkEditHint':
    'Pilih field yang ingin diubah untuk semua item yang dipilih. Biarkan kosong untuk mempertahankan nilai yang ada.',
  'barangform.bulkUraianLabel': 'Uraian',
  'barangform.uraianMode.replace': 'Ganti',
  'barangform.uraianMode.prefix': 'Awalan',
  'barangform.uraianMode.suffix': 'Akhiran',
  'barangform.bulkUraianHint.replace': 'Uraian setiap barang terpilih diganti dengan teks ini.',
  'barangform.bulkUraianHint.prefix': 'Teks ditambahkan di depan uraian setiap barang, dipisah satu spasi.',
  'barangform.bulkUraianHint.suffix': 'Teks ditambahkan di belakang uraian setiap barang, dipisah satu spasi.',
  'barangform.bulkUraianPlaceholder': 'mis. SPARE PARTS',
  'barangform.bulkUraianPreview': 'Contoh hasil (Seri {seri})',
  'barangform.bulkUraianEmpty': '(kosong)',
  'barangform.hsCodeField': 'HS Code',
  'barangform.placeholderPilihHs': 'Pilih HS Code baru untuk item yang dipilih...',
  'barangform.nonLartasLabel': 'NON-LARTAS',
  'barangform.kodeSatuanField': 'Kode Satuan',
  'barangform.placeholderPilihSatuan': 'Pilih Kode Satuan baru untuk item yang dipilih...',
  'barangform.kodeKemasanField': 'Kode Kemasan',
  'barangform.placeholderPilihKemasan': 'Pilih Kode Kemasan baru untuk item yang dipilih...',
  'barangform.kodeNegaraField': 'Kode Negara',
  'barangform.placeholderPilihNegara': 'Pilih Kode Negara baru untuk item yang dipilih...',
  'barangform.tarifPungutan': 'Tarif (Pungutan)',
  'barangform.aturTarifHint': 'Atur tarif PPN, PPH, dan BM untuk item yang dipilih',
  'barangform.labelPpnPct': 'PPN (%)',
  'barangform.labelPphPct': 'PPH (%)',
  'barangform.labelBmPct': 'BM (%)',
  'barangform.fasilitasPpnField': 'Fasilitas PPN',
  'barangform.fasilitasPphField': 'Fasilitas PPH',
  'barangform.fasilitasBmField': 'Fasilitas BM',
  'barangform.placeholderPilihFasilitas': 'Pilih fasilitas...',
  'barangform.fasByr': '1 - BYR - DIBAYAR',
  'barangform.fasDtp': '2 - DITANGGUNG PEMERINTAH',
  'barangform.fasBbs': '5 - BBS - DIBEBASKAN',
  'barangform.fasTidakDipungut': '6 - TIDAK DIPUNGUT',
  'barangform.fasDilunasi': '7 - SUDAH DILUNASI',
  'barangform.fasDitunda': '9 - DITUNDA',
  'barangform.terapkanPerubahan': 'Terapkan Perubahan',
  'barangform.resyncTarifTitle': 'Re-Sync Tarif Database',
  'barangform.tersisa': 'tersisa',
  'barangform.syncingTarif': 'Sedang Mensinkronkan Tarif...',
  'barangform.resyncDescription':
    'Sistem sedang mengunduh dan memperbarui data tarif dari database INSW untuk HS Code yang ada di tabel barang Anda.',
  'barangform.harapTunggu': 'Harap tunggu hingga proses selesai. Jangan menutup halaman ini.',
  'barangform.syncSelesai': 'Sync Selesai!',
  'barangform.resyncSelesaiDesc':
    'Data tarif telah berhasil diperbarui. Silakan klik Smart Sync untuk menerapkan tarif terbaru ke tabel barang.',
  'barangform.selesai': 'Selesai',
  'barangform.loadingBarangData': 'Loading barang data...',
  'barangform.totalCount': 'Total: {count}',
  'barangform.labelHsCodes': 'HS Codes:',
  'barangform.filteredCount': 'Filtered: {count}',
  'barangform.duplicatesCount': 'Duplicates: {count}',
  'barangform.withDocumentsCount': 'With Documents: {count}',
  'barangform.lartasCount': 'Lartas: {count}',
  'barangform.nonLartasCount': 'Non-Lartas: {count}',
  'barangform.selectedCount': 'Dipilih: {count}',
  'barangform.editMassal': 'Edit Massal',
  'barangform.editBtn': 'Edit',
  'barangform.hapusMassal': 'Hapus Massal',
  'barangform.batalPilih': 'Batal Pilih',
  'barangform.duplikat': 'Duplikat',
  'barangform.duplikatMassal': 'Duplikat Massal',
  'barangform.duplikatTitle': 'Duplikat Barang',
  'barangform.duplikatSelected': '{count} baris dipilih',
  'barangform.duplikatCopiesLabel': 'Salinan per baris',
  'barangform.duplikatCopiesHint':
    'Setiap baris terpilih disalin sebanyak ini dan ditambahkan di akhir daftar (maks {max}).',
  'barangform.duplikatCopiesInvalid': 'Isi angka 1 – {max}',
  'barangform.duplikatAdded': '+{count} baris baru',
  'barangform.duplikatTotal': 'Total: {from} → {to} barang',
  'barangform.duplikatWillAdd': 'Akan menambah:',
  'barangform.duplikatTotalsNote':
    'Total di Header/Transaksi tidak diubah otomatis. Sesuaikan qty/nilai tiap baris setelahnya.',
  'barangform.duplikatConfirm': 'Duplikat {count}',
  'barangform.duplikatBerhasil': '{count} baris berhasil diduplikasi (seri {first}–{last})',
  'barangform.duplikatGagal': 'Gagal menduplikasi barang',
  'barangform.pilihHalamanIni': '{count} baris di halaman ini dipilih.',
  'barangform.pilihSemuaN': 'Pilih semua {count} barang',
  'barangform.pilihBarangDulu': 'Centang barang terlebih dahulu',
  'barangform.seriSelectPlaceholder': 'Pilih seri: 1-5, 8',
  'barangform.seriSelectHelp': 'Ketik nomor seri lalu Enter untuk memilih baris. Contoh: 1-5, 8, 10-12',
  'barangform.seriSelectApply': 'Pilih seri',
  'barangform.seriSelectInvalid': 'Format salah: {tokens}. Contoh: 1-5, 8, 10-12',
  'barangform.seriSelectMissing': '{count} barang dipilih. Seri tidak ditemukan: {seris}',
  'barangform.seriSelectNone': 'Seri tidak ditemukan: {seris}',
  'barangform.semuaDipilih': 'Semua {count} barang dipilih.',
  'barangform.placeholderCari': 'Cari berdasarkan uraian atau HS code...',
  'barangform.filterOptions': 'Filter Options',
  'barangform.filterHasDocument': 'Barang yang ada Dokumennya',
  'barangform.lartasStatus': 'Lartas Status',
  'barangform.filterLartas': 'Barang Lartas',
  'barangform.filterNonLartas': 'Barang Non-Lartas',
  'barangform.showingCount': 'Menampilkan {count} item',
  'barangform.sortBySeri': 'Urutkan Berdasarkan Seri Barang',
  'barangform.sortByHs': 'Urutkan Berdasarkan HS Code',
  'barangform.sortedBySeriMsg': 'Barang diurutkan berdasarkan Seri Barang',
  'barangform.sortedByHsMsg': 'Barang diurutkan berdasarkan HS Code',
  'barangform.legendBarang': 'Barang',
  'barangform.bulkUpdate': 'Bulk Update',
  'barangform.uploadInvoice': 'Upload Invoice',
  'barangform.legendTarif': 'Tarif',
  'barangform.smartSync': 'Smart Sync',
  'barangform.smartSyncStatusLain': 'Status Smart Sync: {status}',
  'barangform.smartSyncStatus.never': 'Smart Sync · Belum pernah dijalankan untuk draft ini',
  'barangform.smartSyncStatus.stale':
    'Smart Sync · Terakhir {relative} oleh {lastBy} · {count} perubahan barang setelahnya',
  'barangform.smartSyncStatus.fresh': 'Smart Sync · Terakhir {relative} oleh {lastBy}',
  'barangform.detailTarif': 'Detail Tarif',
  'barangform.hitungHargaProporsional': 'Hitung Harga Proporsional',
  'barangform.kembalikanHargaSemula': 'Kembalikan Ke Harga Semula',
  'barangform.labelFileInvoice': 'File Invoice (PDF)',
  'barangform.placeholderPilihFilePdf': 'Pilih file PDF',
  'barangform.uploadExtract': 'Upload & Extract',
  'barangform.goTo': 'Go to',
  'barangform.go': 'Go',
  // <i18n-anchor-barangform>
  // PungutanForm
  'pungutanform.title': 'Pungutan',
  'pungutanform.generate': 'Generate Pungutan',
  'pungutanform.total': 'Total Pungutan:',
  'pungutanform.colJenisPungutan': 'Jenis Pungutan',
  'pungutanform.colFasilitas': 'Fasilitas',
  'pungutanform.colNilaiPungutan': 'Nilai Pungutan (IDR)',
  'pungutanform.fasilitas.dibayar': 'Dibayar',
  'pungutanform.fasilitas.ditanggung': 'Ditanggung Pemerintah',
  'pungutanform.fasilitas.ditunda': 'Ditunda',
  'pungutanform.fasilitas.tidakDipungut': 'Tidak Dipungut',
  'pungutanform.fasilitas.dibebaskan': 'Dibebaskan',
  'pungutanform.notif.errorTitle': 'Error',
  'pungutanform.notif.noProcessId': 'Process ID tidak tersedia untuk hitung pungutan',
  'pungutanform.notif.successTitle': 'Success',
  'pungutanform.notif.generated': 'pungutan berhasil di-generate',
  'pungutanform.notif.calculated': 'pungutan dihitung dari barang & tarif',
  'pungutanform.notif.infoTitle': 'Info',
  'pungutanform.notif.noData': 'Tidak ada data pungutan',
  'pungutanform.notif.failTitle': 'Gagal',
  'pungutanform.notif.failGenerate': 'Gagal generate pungutan',
  // CEISA answered Generate with a message instead of pungutan (next-jarvis#779)
  'pungutanform.miss.ajuNotFound':
    'AJU ini tidak ditemukan di CEISA. Kemungkinan sudah dihapus di portal CEISA. Kirim ulang draft dari JARVIS bila perlu.',
  'pungutanform.miss.ceisaMessage': 'CEISA: {message}',
  'pungutanform.miss.lastCeisa': 'Hasil CEISA terakhir',
  'pungutanform.miss.lastCeisaAt': 'Hasil CEISA terakhir · {time} WIB',
  'pungutanform.estimate.button': 'Hitung estimasi JARVIS',
  'pungutanform.estimate.toggle': 'Estimasi JARVIS',
  'pungutanform.estimate.badge': 'Estimasi JARVIS, bukan dari CEISA',
  'pungutanform.estimate.failed': 'Gagal menghitung estimasi JARVIS',
  // Pre-AJU local calculation readiness (issue #237)
  'pungutanform.readiness.ready': 'Siap dihitung',
  'pungutanform.readiness.estimate': 'Perkiraan',
  'pungutanform.readiness.partial': 'Sebagian belum terhitung',
  'pungutanform.readiness.blocked': 'Belum bisa dihitung',
  'pungutanform.readiness.detail.ready':
    'Dihitung lokal dari tarif dan kurs pada draft. Nilai final mengikuti CEISA setelah AJU dikirim.',
  'pungutanform.readiness.detail.estimate':
    'Dihitung lokal dengan CIF perkiraan (freight & asuransi dibagi proporsional). Nilai final mengikuti CEISA setelah AJU dikirim.',
  'pungutanform.readiness.detail.blocked': 'Pungutan belum bisa dihitung untuk draft ini.',
  'pungutanform.readiness.detail.partialSuffix': '{count} barang belum ikut terhitung.',
  'pungutanform.readiness.reason.barangKosong': 'Draft belum memiliki data barang.',
  'pungutanform.readiness.reason.tarifBelumSinkron':
    'Tarif HS belum tersinkron, jadi tidak ada tarif BM/PPN/PPh yang bisa dipakai.',
  'pungutanform.readiness.reason.kursBelumAda':
    'Kurs (NDPBM) belum diisi di tab Transaksi, jadi nilai barang belum bisa dikonversi ke rupiah.',
  'pungutanform.readiness.reason.nilaiBarangKosong': 'Nilai barang masih 0, tidak ada dasar perhitungan.',
  'pungutanform.readiness.valuta': 'Valuta',
  'pungutanform.readiness.ndpbm': 'NDPBM',
  'pungutanform.readiness.ndpbmFromCeisa': 'kurs CEISA — belum tersimpan di tab Transaksi',
  'pungutanform.readiness.tarifSource': 'Sumber tarif',
  'pungutanform.readiness.source.saved': 'tarif tersimpan',
  'pungutanform.readiness.source.hsTariffs': 'tarif HS',
  'pungutanform.readiness.source.mixed': 'campuran',
  'pungutanform.readiness.source.none': '-',
  'pungutanform.readiness.missingCodes': 'Kode HS tanpa tarif',
  'pungutanform.readiness.andMore': '(+{count} lainnya)',
  'pungutanform.readiness.syncTarif': 'Sync Tarif HS',
  'pungutanform.readiness.syncDone': 'Sinkronisasi tarif HS selesai',
  'pungutanform.readiness.syncFailed': 'Gagal sinkronisasi tarif HS',
  'pungutanform.readiness.unsavedTarif':
    'Tarif {count} barang dihitung dari tarif HS & fasilitas dokumen, belum tersimpan di barang — disimpan otomatis saat sinkronisasi (perlu akses Master CEISA).',
  'pungutanform.readiness.ambiguousPreferential':
    'Tarif preferensi (BM fasilitas) barang seri {seri} tidak diterapkan otomatis karena data preferensi bertentangan — BM memakai tarif umum (MFN); cek fasilitas BM secara manual.',
  'pungutanform.readiness.preferentialMfn':
    'Barang seri {seri}: skema preferensi yang berlaku tidak memberi tarif khusus untuk HS barang tersebut (MFN), BM memakai tarif umum.',
  'pungutanform.readiness.pphExempt':
    'PPh {count} barang (seri {seri}) dibebaskan karena SKB PPh / SKB PP 23 terhubung — tercantum sebagai baris PPH fasilitas 5 (Dibebaskan).',
  'pungutanform.readiness.ppnExempt':
    'PPN {count} barang (seri {seri}) dibebaskan karena SKB PPN terhubung — tercantum sebagai baris PPN fasilitas 5 (Dibebaskan).',

  // PernyataanForm
  'pernyataanform.title': 'Pernyataan',
  'pernyataanform.titleSync': 'Sync Pernyataan',
  'pernyataanform.syncing': 'Syncing...',
  'pernyataanform.declarationHeader': 'Dengan ini saya menyatakan:',
  'pernyataanform.statement1':
    'bertanggung jawab atas kebenaran hal-hal yang diberitahukan dalam dokumen ini dan keabsahan dokumen pelengkap pabean yang menjadi dasar pembuatan dokumen ini; dan',
  'pernyataanform.statement2':
    'apabila dalam jangka waktu paling lambat 1 (satu) hari setelah tanggal pemberitahuan kesiapan barang, saya tidak hadir untuk menyaksikan pemeriksaan fisik, maka saya menuasakan penyaksian kepada pengusaha TPS dengan resiko dan biaya menjadi tanggung jawab saya.',
  'pernyataanform.signerInfo': 'Informasi Penandatangan',
  'pernyataanform.nama': 'Nama',
  'pernyataanform.tanggal': 'Tanggal',
  'pernyataanform.placeholderTanggal': 'tanggal',
  'pernyataanform.tempat': 'Tempat',
  'pernyataanform.jabatan': 'Jabatan',
  'pernyataanform.errorNamaTtd': 'Nama TTD wajib diisi',
  'pernyataanform.errorTanggalTtd': 'Tanggal TTD wajib diisi',
  'pernyataanform.errorKotaTtd': 'Kota TTD wajib diisi',
  'pernyataanform.errorJabatanTtd': 'Jabatan TTD wajib diisi',
  'pernyataanform.notifySuccessTitle': 'Success',
  'pernyataanform.notifySuccessMessage': 'Pernyataan data synced successfully',
  'pernyataanform.notifyErrorTitle': 'Error',
  'pernyataanform.notifyErrorSyncMessage': 'Failed to sync pernyataan data',
  'pernyataanform.notifyErrorGeneralMessage': 'Error syncing pernyataan data',
  'pernyataanform.notifyNoStatementTitle': 'Pernyataan belum diatur',
  'pernyataanform.notifyNoStatementMessage':
    'Belum ada Pernyataan untuk PPJK Anda. Isi di Master → Pernyataan, lalu sinkronkan lagi.',

  // Subscription: free trial
  'subscription.trial.badge.active': 'Uji Coba Gratis',
  'subscription.trial.badge.ended': 'Uji Coba Berakhir',
  'subscription.trial.free': 'Gratis',
  'subscription.trial.endsOn': 'Uji Coba Berakhir',
  'subscription.trial.cost': 'Biaya',
  'subscription.trial.running.title': 'Uji coba gratis sedang berjalan',
  'subscription.trial.running.daysLeft': 'Sisa {n} hari.',
  'subscription.trial.running.endsToday': 'Uji coba berakhir hari ini.',
  'subscription.trial.running.body': 'Setelah berakhir, pengajuan baru akan terblokir sampai Anda berlangganan.',
  'subscription.trial.running.cta': 'Lihat paket berlangganan',
  'subscription.trial.header.daysLeft': 'Uji coba: {n} hari lagi',
  'subscription.trial.header.endsToday': 'Uji coba: hari terakhir',
  'subscription.trial.header.ended': 'Uji coba berakhir',
  'subscription.trial.strip.soon': 'Uji coba gratis berakhir dalam {n} hari.',
  'subscription.trial.strip.today': 'Uji coba gratis berakhir hari ini.',
  'subscription.trial.strip.ended': 'Uji coba gratis telah berakhir.',
  'subscription.trial.strip.soonDetail': 'Setelah itu pengajuan baru terblokir sampai Anda berlangganan.',
  'subscription.trial.strip.endedDetail': 'Pengajuan baru terblokir sampai Anda berlangganan.',
  'subscription.trial.contactSales': 'Hubungi Sales',
  'subscription.trial.contactSales.message':
    'Halo Sales JARVIS, masa uji coba gratis perusahaan kami akan segera berakhir. Saya ingin berlangganan paket JARVIS.',
  'subscription.trial.ended.title': 'Masa uji coba gratis telah berakhir',
  'subscription.trial.ended.body':
    'Akun Anda diblokir untuk pengajuan baru{since}. Tidak ada tagihan yang harus dibayar. Pilih paket berlangganan untuk melanjutkan layanan. Sisa kredit uji coba tidak dibawa ke paket berbayar.',
  'subscription.trial.ended.since': ' sejak {date}',
  'subscription.trial.ended.cta': 'Pilih paket berlangganan',
  'subscription.trial.picker.title': 'Lanjutkan dengan paket berbayar',
  'subscription.trial.picker.subtitleRunning':
    'Uji coba Anda masih berjalan. Berlangganan sekarang agar layanan tidak terputus saat masa uji coba berakhir. Sisa kredit uji coba tidak dibawa ke paket berbayar.',
  'subscription.trial.picker.subtitleEnded':
    'Masa uji coba telah berakhir dan akun Anda terblokir. Pilih paket di bawah untuk mengaktifkan kembali layanan.',
  'subscription.invoice.trialBadge': 'Uji Coba Gratis',
  'subscription.invoice.free': 'Gratis',
  // Subscription page + billing components
  'subscription.page.title': 'Langganan',
  'subscription.page.subtitle': 'Kelola paket langganan dan tagihan bulanan Anda',
  'subscription.page.loadingSubscription': 'Memuat data langganan...',
  'subscription.page.loadingPlans': 'Memuat paket langganan...',
  'subscription.common.error': 'Terjadi kesalahan',
  'subscription.card.title': 'Langganan',
  'subscription.card.currentPeriod': 'Periode Berjalan',
  'subscription.card.nextBilling': 'Tagihan Berikutnya',
  'subscription.card.pricePerMonth': 'Harga per Bulan',
  'subscription.card.quotaTitle': 'Kuota Kredit Bulanan',
  'subscription.card.col.product': 'Produk',
  'subscription.card.col.quotaPerPeriod': 'Kuota per Periode',
  'subscription.card.col.used': 'Terpakai',
  'subscription.card.col.balance': 'Saldo Saat Ini',
  'subscription.card.credits': 'kredit',
  'subscription.card.usedOf': '{used}/{quota} terpakai',
  'subscription.card.balanceError': 'Gagal memuat saldo kredit',
  'subscription.card.override': 'Khusus',
  'subscription.card.noQuota': 'Tidak ada kuota kredit pada paket ini',
  'subscription.status.active': 'Aktif',
  'subscription.status.pending': 'Menunggu Pembayaran',
  'subscription.status.unpaid': 'Belum Dibayar',
  'subscription.status.cancelled': 'Dibatalkan',
  'subscription.cancel.button': 'Batalkan Langganan',
  'subscription.cancel.confirm.title': 'Batalkan langganan?',
  'subscription.cancel.confirm.body':
    'Anda tetap dapat menggunakan kredit hingga {date}. Kartu Anda tidak akan ditagih lagi setelah langganan berakhir.',
  'subscription.cancel.confirm.titleImmediate': 'Batalkan langganan sekarang?',
  'subscription.cancel.confirm.bodyImmediate':
    'Langganan ini belum aktif karena tagihan pertama belum dibayar, jadi akan langsung dibatalkan. Tagihan yang menunggu pembayaran ikut dibatalkan, tidak ada penagihan, dan tidak ada kredit yang diberikan. Anda dapat berlangganan lagi kapan saja.',
  'subscription.cancel.toast.periodEnd.title': 'Berhasil',
  'subscription.cancel.toast.periodEnd.body':
    'Langganan tidak akan diperpanjang. Kredit tetap dapat digunakan hingga akhir periode.',
  'subscription.cancel.toast.immediate.title': 'Langganan dibatalkan',
  'subscription.cancel.toast.immediate.body': 'Tagihan yang menunggu pembayaran dibatalkan. Anda tidak ditagih.',
  'subscription.cancel.toast.error.title': 'Error',
  'subscription.cancel.toast.error.body': 'Gagal membatalkan langganan. Silakan coba lagi.',
  'subscription.cancel.confirm.back': 'Kembali',
  'subscription.cancel.confirm.confirm': 'Ya, batalkan',
  'subscription.cancel.endsOn': 'Berakhir {date}',
  'subscription.cancel.cancelling.title': 'Berhenti diperpanjang otomatis',
  'subscription.cancel.cancelling.body':
    'Langganan tetap aktif hingga {date}. Kartu tidak akan ditagih lagi. Berlangganan kembali kapan saja.',
  'subscription.cancel.cancelling.cta': 'Lihat paket',
  'subscription.cancel.picker.title': 'Berlangganan kembali',
  'subscription.cancel.picker.subtitle': 'Pilih paket untuk melanjutkan layanan.',
  'subscription.alert.unpaid.title': 'Akun diblokir - segera lakukan pembayaran',
  'subscription.alert.unpaid.body':
    'Langganan Anda belum dibayar{since}. Akun Anda diblokir sampai tagihan dilunasi. Silakan bayar tagihan tertunda di bagian Tagihan di bawah.',
  'subscription.alert.unpaid.since': ' sejak {date}',
  'subscription.alert.pending.title': 'Menunggu pembayaran',
  'subscription.alert.pending.body':
    'Langganan Anda akan aktif setelah tagihan pertama dibayar. Silakan selesaikan pembayaran di bagian Tagihan di bawah.',
  'subscription.picker.title': 'Pilih Paket Langganan',
  'subscription.picker.subtitle': 'Anda belum memiliki langganan. Pilih paket di bawah untuk mulai berlangganan.',
  'subscription.picker.empty': 'Tidak ada paket langganan tersedia saat ini.',
  'subscription.picker.perMonth': '/ bulan',
  'subscription.picker.periodDays': 'Periode {n} hari',
  'subscription.picker.accountPrice': 'Harga khusus akun Anda',
  'subscription.picker.includedCredits': 'Kredit Termasuk:',
  'subscription.picker.creditLine': '{n} kredit {product}',
  'subscription.picker.product': 'Produk #{id}',
  'subscription.picker.subscribe': 'Berlangganan',
  'subscription.invoices.title': 'Tagihan',
  'subscription.invoices.col.type': 'Tipe',
  'subscription.invoices.col.period': 'Periode',
  'subscription.invoices.col.amount': 'Jumlah',
  'subscription.invoices.col.status': 'Status',
  'subscription.invoices.col.action': 'Aksi',
  'subscription.invoices.type.initial': 'Tagihan Awal',
  'subscription.invoices.type.renewal': 'Perpanjangan',
  'subscription.invoices.status.pending': 'Menunggu Pembayaran',
  'subscription.invoices.status.paid': 'Lunas',
  'subscription.invoices.status.cancelled': 'Dibatalkan',
  'subscription.invoices.paidOn': 'Dibayar {date}',
  'subscription.invoices.priorAttempt': 'Terdapat instruksi pembayaran sebelumnya',
  'subscription.invoices.continuePayment': 'Lanjutkan Pembayaran',
  'subscription.invoices.pay': 'Bayar',
  'subscription.invoices.download': 'Unduh',
  'subscription.invoices.downloadError': 'Gagal mengunduh invoice. Silakan coba lagi.',
  'subscription.invoices.empty': 'Belum ada tagihan.',
  'subscription.banner.unpaid.title': 'Langganan Belum Dibayar',
  'subscription.banner.unpaid.body': 'Langganan Anda belum dibayar, akun diblokir untuk pengajuan baru.',
  'subscription.banner.unpaid.cta': 'Bayar Sekarang',
  'subscription.banner.trial.title': 'Masa Uji Coba Berakhir',
  'subscription.banner.trial.body': 'Masa uji coba gratis Anda telah berakhir, akun diblokir untuk pengajuan baru.',
  'subscription.banner.trial.cta': 'Pilih Paket',
  'subscription.banner.pending.title': 'Tagihan Menunggu Pembayaran',
  'subscription.banner.pending.body': 'Tagihan perpanjangan langganan menunggu pembayaran.',
  'subscription.banner.pending.cta': 'Bayar Perpanjangan',
  // Subscription payment modal
  'subscription.pay.title': 'Pembayaran Tagihan #{id}',
  'subscription.pay.subtotal': 'Subtotal',
  'subscription.pay.fee': 'Biaya layanan pembayaran',
  'subscription.pay.feeNotice': 'Biaya layanan pembayaran ditambahkan di atas subtotal dan dapat berbeda tiap metode.',
  'subscription.pay.total': 'Total Pembayaran:',
  'subscription.pay.method': 'Metode Pembayaran',
  'subscription.pay.method.va': 'Virtual Account',
  'subscription.pay.method.qris': 'QRIS',
  'subscription.pay.method.card': 'Kartu Kredit',
  'subscription.pay.method.unknown': 'Tidak diketahui',
  'subscription.pay.prior.title': 'Instruksi pembayaran sebelumnya tersedia',
  'subscription.pay.prior.body':
    'Anda sudah memulai pembayaran dengan metode {method}{bank}. Anda dapat menampilkan kembali instruksi tersebut atau membuat pembayaran baru dengan metode lain.',
  'subscription.pay.prior.cta': 'Tampilkan Instruksi Sebelumnya',
  'subscription.pay.selectBank': 'Pilih Bank',
  'subscription.pay.continue': 'Lanjut ke Pembayaran',
  'subscription.pay.va.transferTo': 'Transfer ke nomor Virtual Account di bawah ini:',
  'subscription.pay.va.note': 'Setelah transfer, pembayaran akan diproses secara otomatis dalam 1-5 menit.',
  'subscription.pay.copy': 'Salin',
  'subscription.pay.copied.title': 'Berhasil',
  'subscription.pay.copied.body': 'Disalin ke clipboard',
  'subscription.pay.qris.title': 'Scan QRIS',
  'subscription.pay.qris.body': 'Scan kode QR di bawah ini dengan aplikasi e-wallet Anda:',
  'subscription.pay.qris.unavailable': 'Gambar QR tidak tersedia',
  'subscription.pay.card.title': 'Pembayaran Kartu Kredit',
  'subscription.pay.card.open': 'Buka Halaman Pembayaran',
  'subscription.pay.card.unavailable': 'Link pembayaran tidak tersedia',
  'subscription.pay.waiting': 'Menunggu Pembayaran',
  'subscription.pay.polling': 'Status diperiksa otomatis setiap 5 detik',
  'subscription.pay.changeMethod': 'Ganti Metode Pembayaran',
  'subscription.pay.checkStatus': 'Periksa Status',
  'subscription.pay.success.title': 'Pembayaran Berhasil',
  'subscription.pay.success.body': 'Tagihan langganan Anda telah dibayar. Terima kasih!',
  'subscription.pay.success.notification': 'Tagihan langganan Anda telah dibayar.',
  'subscription.pay.close': 'Tutup',

  // Dashboard header notification bell (incoming CEISA email responses)
  'notifications.bell.title': 'Notifikasi',
  'notifications.bell.aria': 'Notifikasi respon email',
  'notifications.bell.markAllRead': 'Tandai semua terbaca',
  'notifications.bell.empty': 'Belum ada respon email masuk',
  'notifications.bell.emptyHint': 'Respon CEISA yang masuk akan muncul di sini',
  'notifications.bell.loading': 'Memuat notifikasi...',
  'notifications.bell.error': 'Gagal memuat notifikasi',
  'notifications.bell.retry': 'Coba lagi',
  'notifications.bell.unreadCount': 'belum dibaca',
  'notifications.bell.new': 'Baru',
  'notifications.bell.ajuNumber': 'Nomor AJU',
  'notifications.bell.filterAll': 'Semua',
  'notifications.bell.filterUnread': 'Belum dibaca',
  'notifications.bell.emptyUnread': 'Semua sudah terbaca',
  'notifications.bell.emptyUnreadHint': 'Tidak ada respon yang menunggu dibuka',
  'notifications.bell.urgent': 'Urgent',
  'notifications.bell.download': 'Unduh',
  'notifications.bell.downloading': 'Mengunduh',
  'notifications.bell.downloaded': 'berhasil diunduh',
  'notifications.bell.downloadFailed': 'Gagal mengunduh',
  'notifications.bell.sinceLastResponse': 'sejak respon terakhir',
  'notifications.bell.lastResponseAt': 'Respon terakhir',
  // Entity history check — the badge on each Entitas card and the suggestions
  // it offers. Plain words on purpose: never "AI" or "ekstraksi", always the
  // document and its date.
  'entitycheck.cocok': 'Cocok',
  'entitycheck.perluDiperiksa': 'Perlu diperiksa',
  'entitycheck.tidakDicek': 'Tidak dicek',
  'entitycheck.dariAkun': 'Dari akun Anda',
  'entitycheck.samaDenganDokumen': 'Sama dengan dokumen',
  'entitycheck.bedaDariDokumen': 'Berbeda dari dokumen',
  'entitycheck.cocokDariNama': 'cocok dari nama',
  'entitycheck.dokumen': 'Dokumen',
  'entitycheck.dokumenSebelumnya': 'Dokumen sebelumnya',
  'entitycheck.pakaiIni': 'Pakai ini',
  'entitycheck.biarkanSaja': 'Biarkan saja',
  'entitycheck.belumAda': 'Belum ada di sini',
  'entitycheck.tambahkan': 'Tambahkan',

  // ---- Info Kode HS (detail komoditas INSW) ----
  // Judul dan label memakai istilah yang sama dengan portal INSW supaya orang
  // yang terbiasa dengan portal itu mengenali panelnya tanpa menerjemahkan.
  'hsCodeInfo.title': 'Informasi Kode HS',
  'hsCodeInfo.kodeHs': 'Kode HS',
  'hsCodeInfo.tabTarif': 'Informasi Tarif',
  'hsCodeInfo.tabPreferensi': 'Tarif Preferensi',
  'hsCodeInfo.tabRegulasiImpor': 'Regulasi Impor',
  'hsCodeInfo.tabRegulasiEkspor': 'Regulasi Ekspor',
  'hsCodeInfo.lartasBorder': 'Regulasi Impor (Lartas Border)',
  'hsCodeInfo.tataNiagaPostBorder': 'Regulasi Impor (Tata Niaga Post Border)',
  'hsCodeInfo.regulasiImporUmum': 'Regulasi Impor (Umum)',
  'hsCodeInfo.lartasEkspor': 'Regulasi Ekspor (Lartas Ekspor)',
  'hsCodeInfo.kolNamaIzin': 'Nama Izin',
  'hsCodeInfo.kolKodeIzin': 'Kode Izin',
  'hsCodeInfo.kolDeskripsi': 'Deskripsi',
  'hsCodeInfo.kolDasarHukum': 'Dasar Hukum',
  'hsCodeInfo.kolMasaBerlaku': 'Masa Berlaku',
  'hsCodeInfo.kolKeterangan': 'Keterangan',
  'hsCodeInfo.kolDokumenPabean': 'Dokumen Pabean',
  'hsCodeInfo.kolUraianBarang': 'Uraian Barang',
  'hsCodeInfo.instansi': 'Instansi',
  'hsCodeInfo.sekarang': 'Sekarang',
  'hsCodeInfo.berlaku': 'Berlaku',
  'hsCodeInfo.terbaru': 'Terbaru',
  'hsCodeInfo.legacy': 'Lama',
  'hsCodeInfo.mfnTerbaru': 'Most Favored Nation (Terbaru)',
  'hsCodeInfo.mfn': 'Most Favored Nation',
  'hsCodeInfo.preferensiTerbaru': 'Tarif Preferensi (Terbaru)',
  'hsCodeInfo.preferensi': 'Tarif Preferensi',
  'hsCodeInfo.tarifPerTahun': 'Tarif per Tahun',
  'hsCodeInfo.lanjutan': 'Tarif berlanjut untuk tahun berikutnya',
  'hsCodeInfo.sda': 'SDA (Sumber Daya Alam)',
  'hsCodeInfo.tidakDiaturLartasBorder': 'Atas HS dimaksud tidak diatur dalam Lartas Border',
  'hsCodeInfo.tidakDiaturPostBorder': 'Atas HS dimaksud tidak diatur dalam Tata Niaga Post Border',
  'hsCodeInfo.tidakDiaturImporUmum': 'Atas HS dimaksud tidak diatur dalam Regulasi Impor Umum',
  'hsCodeInfo.tidakDiaturLartasEkspor': 'Atas HS dimaksud tidak diatur dalam Lartas Ekspor',
  // Dipakai saat INSW belum pernah menjawab untuk kode ini: kosong berarti "belum tahu",
  // bukan "tidak diatur".
  'hsCodeInfo.regulasiBelumTersedia': 'Data regulasi belum tersedia untuk kode ini',
  'hsCodeInfo.tidakAdaTarif': 'Data tarif MFN tidak tersedia',
  'hsCodeInfo.tidakAdaPreferensi': 'Tidak ada skema tarif preferensi untuk kode ini',
  'hsCodeInfo.tidakAdaData': 'Tidak ada data untuk kode HS ini',
  'hsCodeInfo.tidakDitemukan': 'Data untuk kode HS ini tidak ditemukan',
  'hsCodeInfo.kolNamaTarif': 'Nama Tarif',
  'hsCodeInfo.kolTarif': 'Tarif',
  'hsCodeInfo.kolRegulasi': 'Regulasi',
  'hsCodeInfo.tabUmum': 'Uraian Barang',
  'hsCodeInfo.tabLainnya': 'Informasi Lainnya',
  'hsCodeInfo.lartasYa': 'Lartas',
  'hsCodeInfo.lartasTidak': 'Non-Lartas',
  'hsCodeInfo.kodeNormal': 'Kode Ternormalisasi',
  'hsCodeInfo.uraianId': 'Uraian (ID)',
  'hsCodeInfo.uraianEn': 'Uraian (EN)',
  'hsCodeInfo.tahunInsw': 'Tahun INSW',
  'hsCodeInfo.kodeSatuan': 'Kode Satuan',
  'hsCodeInfo.spesifikasi': 'Spesifikasi Barang',
  'hsCodeInfo.cariPreferensi': 'Cari skema atau nomor PMK',
  'hsCodeInfo.dibandingMfn': 'Dibandingkan BM MFN {rate}',
  'hsCodeInfo.hematBm': 'Hemat {n}% BM',
  'hsCodeInfo.tidakLebihMurah': 'Tidak lebih murah dari MFN',
  'hsCodeInfo.preferensiTidakCocok': 'Tidak ada skema preferensi yang cocok dengan "{query}"',
  'hsCodeInfo.berlakuSeterusnya': 'Berlaku seterusnya',
  'hsCodeInfo.kedaluwarsa': 'Kedaluwarsa',
  'hsCodeInfo.belumBerlaku': 'Belum berlaku',
  'hsCodeInfo.bahasa': 'Bahasa',
  'hsCodeInfo.english': 'English',
  'hsCodeInfo.satuanBarang': 'Satuan Barang',
  'hsCodeInfo.kolKodeSatuan': 'Kode Satuan',
  'hsCodeInfo.kolUraianSatuan': 'Uraian Satuan',
  'hsCodeInfo.kolJenis': 'Jenis',
  'hsCodeInfo.gagalMuat': 'Gagal memuat detail kode HS',

  // ---- Master: Data Consignee ----
  'menu.dataConsignee': 'Data Consignee',
  'consignee.title': 'Data Consignee',
  'consignee.subtitle': 'Daftar importir yang Anda urus. Isi sekali, dipakai berulang di dokumen Anda.',
  'consignee.privacyTitle': 'Hanya untuk PPJK Anda',
  'consignee.tabOwn': 'PPJK Saya',
  'consignee.tabGlobal': 'Semua PPJK',
  'consignee.colPpjk': 'PPJK',
  'consignee.globalNoticeTitle': 'Tampilan internal, hanya baca',
  'consignee.globalNotice':
    'Daftar consignee dari semua PPJK, hanya terlihat oleh super admin. Untuk menambah atau mengubah consignee, masuk sebagai PPJK pemiliknya.',
  'consignee.globalSearchPlaceholder': 'Cari consignee, NPWP, atau PPJK',
  'consignee.privacyBody':
    'Daftar ini tersimpan khusus untuk {company} (NPWP {npwp}). Tidak dibagikan ke PPJK lain, tidak dipakai untuk melatih apa pun, dan hanya dipakai untuk mengisi dokumen Anda.',
  'consignee.yourPpjk': 'PPJK Anda',
  'consignee.noPpjkTitle': 'NPWP PPJK belum ada',
  'consignee.noPpjkMsg': 'Akun Anda belum terhubung ke PPJK. Hubungi administrator Anda.',
  'consignee.loadFailedTitle': 'Gagal memuat',
  'consignee.loadFailedMsg': 'Daftar consignee belum bisa dimuat. Coba lagi beberapa saat.',
  'consignee.searchPlaceholder': 'Cari nama atau NPWP',
  'consignee.total': '{n} consignee',
  'consignee.template': 'Template',
  'consignee.exportCurrent': 'Unduh data saat ini',
  'consignee.uploadExcel': 'Unggah Excel',
  'consignee.uploadIntro':
    'Unduh template, isi di Excel, lalu unggah kembali. Anda akan melihat apa yang akan berubah sebelum data disimpan.',
  'consignee.add': 'Tambah',
  'consignee.addTitle': 'Tambah Consignee',
  'consignee.editTitle': 'Ubah Consignee',
  'consignee.emptyTitle': 'Belum ada consignee',
  'consignee.emptyHint': 'Tambah satu per satu, atau unggah sekaligus dari Excel.',
  'consignee.colNama': 'Nama Consignee',
  'consignee.colNpwp': 'NPWP',
  'consignee.colAlamat': 'Alamat',
  'consignee.colNib': 'NIB',
  'consignee.colJenisApi': 'Jenis API',
  'consignee.colStatus': 'Status',
  'consignee.colSumber': 'Sumber',
  'consignee.colDiperbarui': 'Diperbarui',
  'consignee.colAksi': 'Aksi',
  'consignee.sourceExcel': 'Excel',
  'consignee.sourceManual': 'Manual',
  'consignee.sourceCeisa': 'CEISA',
  'consignee.edit': 'Ubah',
  'consignee.delete': 'Hapus',
  'consignee.cancel': 'Batal',
  'consignee.save': 'Simpan',
  'consignee.create': 'Tambah',
  'consignee.unknown': 'Tidak diketahui',
  'consignee.npwpHint': '15 atau 16 digit. Titik dan strip boleh diketik, akan dirapikan otomatis.',
  'consignee.npwpStoredAs': 'Akan disimpan sebagai {npwp}',
  'consignee.npwpInvalid': 'NPWP harus 15 atau 16 digit',
  'consignee.nibInvalid': 'NIB harus 13 digit angka',
  'consignee.formInvalidTitle': 'Periksa isian',
  'consignee.formInvalidMsg': 'Nama dan NPWP wajib diisi dengan benar.',
  'consignee.savedTitle': 'Tersimpan',
  'consignee.createdMsg': 'Consignee ditambahkan.',
  'consignee.updatedMsg': 'Consignee diperbarui.',
  'consignee.existsMsg': 'NPWP ini sudah ada di daftar Anda. Ubah data yang ada, bukan menambah baru.',
  'consignee.saveFailedTitle': 'Gagal menyimpan',
  'consignee.saveFailedMsg': 'Consignee belum tersimpan. Coba lagi.',
  'consignee.deleteTitle': 'Hapus Consignee',
  'consignee.deleteConfirm': 'Hapus {nama} dari daftar Anda? Data ini tidak akan muncul lagi di dokumen baru.',
  'consignee.deletedTitle': 'Dihapus',
  'consignee.deletedMsg': 'Consignee dihapus dari daftar.',
  'consignee.deleteFailedMsg': 'Consignee belum terhapus. Coba lagi.',
  'consignee.downloadFailedTitle': 'Gagal mengunduh',
  'consignee.downloadFailedMsg': 'File belum bisa diunduh. Coba lagi beberapa saat.',
  'consigneeImport.dropTitle': 'Tarik file Excel ke sini',
  'consigneeImport.dropHint': 'Satu file .xlsx, maksimal 5.000 baris',
  'consigneeImport.chooseFile': 'Pilih file',
  'consigneeImport.onlyXlsx': 'Gunakan satu file Excel (.xlsx) dari template.',
  'consigneeImport.reading': 'Membaca {file}',
  'consigneeImport.previewFailed': 'File belum bisa dibaca',
  'consigneeImport.previewStale': 'Data Consignee berubah, pratinjau mungkin tidak sesuai',
  'consigneeImport.reloadPreview': 'Muat ulang pratinjau',
  'consigneeImport.chooseOther': 'Pilih file lain',
  'consigneeImport.rowsSeen': '{n} baris',
  'consigneeImport.rowLabel': 'Baris {n}',
  'consigneeImport.actionNew': 'baru',
  'consigneeImport.actionUpdated': 'diperbarui',
  'consigneeImport.actionUnchanged': 'tidak berubah',
  'consigneeImport.actionRejected': 'dilewati',
  'consigneeImport.neverDeletes':
    'Unggahan tidak pernah menghapus data. Baris yang tidak ada di file dibiarkan apa adanya; sel kosong tidak menimpa nilai yang sudah ada.',
  'consigneeImport.importN': 'Impor {n} baris',
  'consigneeImport.importedTitle': 'Impor selesai',
  'consigneeImport.importedMsg': '{new} baru, {updated} diperbarui.',
  'consigneeImport.resultLine': '{new} baru, {updated} diperbarui, {unchanged} tidak berubah.',
  'consigneeImport.rejectedTitle': 'Baris yang dilewati',
  'consigneeImport.failedTitle': 'Impor gagal',
  'consigneeImport.failedMsg': 'Data belum tersimpan. Coba lagi.',
  'consigneeImport.uploadAnother': 'Unggah file lain',
  'menu.dataEksportir': 'Data Eksportir',
  'menu.masterBarang': 'Barang',
  'masterBarang.title': 'Master Barang',
  'masterBarang.subtitle':
    'Daftar barang per importir: uraian → Spesifikasi Lain → HS. Dipakai hanya saat Anda menekan "Sinkron Master Barang" di draft PIB.',
  'masterBarang.importerLabel': 'Importir',
  'masterBarang.importerPlaceholder': 'Cari nama atau NPWP importir',
  'masterBarang.importerRows': '{n} baris',
  'masterBarang.importersLoading': 'Memuat importir…',
  'masterBarang.importersNone': 'Belum ada importir — tambah lewat Tambah Consignee',
  'masterBarang.importersNoMatch': 'Importir tidak ditemukan',
  'masterBarang.importerMissingTitle': 'Importir {npwp} belum ada di daftar',
  'masterBarang.importerMissingMsg':
    'Tambahkan dulu sebagai consignee lewat Tambah Consignee (NPWP sudah terisi), lalu import atau tambah barangnya.',
  'masterBarang.importerMissingNoAdd':
    'Importir ini belum menjadi consignee PPJK ini. Tambahkan dulu di Data Consignee PPJK tersebut.',
  'masterBarang.addConsignee': 'Tambah Consignee',
  'masterBarang.ppjkLabel': 'PPJK',
  'masterBarang.ppjkPlaceholder': 'Pilih PPJK',
  'masterBarang.ppjkEmpty': 'PPJK tidak ditemukan',
  'masterBarang.pickPpjk': 'Pilih PPJK terlebih dahulu',
  'masterBarang.pickPpjkHint': 'Master Barang disimpan per PPJK. Pilih PPJK yang akan dikelola.',
  'masterBarang.backfill': 'Backfill riwayat AJU',
  'masterBarang.backfillHint': 'Khusus staf: pelajari barang dari PIB importir ini 365 hari terakhir',
  'masterBarang.backfillDoneTitle': 'Backfill selesai',
  'masterBarang.backfillDoneMsg': '{processes} PIB dibaca: {rowsInserted} baris baru, {rowsSeen} sudah ada',
  'masterBarang.backfillFailedTitle': 'Backfill gagal',
  'masterBarang.backfillFailedMsg': 'Backfill riwayat AJU gagal. Coba lagi.',
  'masterBarang.addConsigneeTitle': 'Tambah Consignee',
  'masterBarang.addConsigneeIntro':
    'Consignee baru disimpan di Data Consignee dan langsung dipilih sebagai importir di sini.',
  'masterBarang.addConsigneeCreated': 'Consignee {npwp} ditambahkan dan dipilih.',
  'masterBarang.addConsigneeExists': 'NPWP {npwp} sudah ada di Data Consignee — langsung dipilih.',
  'masterBarang.pickImporter': 'Pilih importir untuk melihat Master Barang',
  'masterBarang.pickImporterHint':
    'Setiap importir punya daftar barang sendiri. Belum ada di daftar? Tambahkan lewat tombol Tambah Consignee.',
  'masterBarang.total': '{n} barang',
  'masterBarang.template': 'Template',
  'masterBarang.export': 'Export',
  'masterBarang.uploadExcel': 'Import Excel',
  'masterBarang.add': 'Tambah Barang',
  'masterBarang.searchPlaceholder': 'Cari uraian, Spesifikasi Lain, atau HS',
  'masterBarang.sourceAll': 'Semua sumber',
  'masterBarang.sourceManual': 'Manual',
  'masterBarang.sourceImport': 'Import Excel',
  'masterBarang.sourceSubmission': 'Riwayat AJU',
  'masterBarang.conflictOnly': 'Konflik saja',
  'masterBarang.help.button': 'Cara pakai',
  'masterBarang.help.title': 'Cara pakai Master Barang',
  'masterBarang.help.intro':
    'Master Barang menyimpan daftar barang per importir. Upload dokumen tidak mengisi apa pun dari daftar ini: Anda sendiri yang menekan "Sinkron Master Barang" di draft PIB, lalu barang dicocokkan lewat Uraian (bukan HS) dan kode Master mengisi Spesifikasi Lain serta HS-nya.',
  'masterBarang.help.gifAlt':
    'Contoh: Sinkron Master Barang di draft PIB — barang dicocokkan lewat Uraian; HS yang sama dengan Uraian lain tetap "Tidak ada di Master"',
  'masterBarang.help.step1': 'Tambah Consignee (importir) bila belum ada di daftar, lalu pilih importirnya.',
  'masterBarang.help.step2':
    'Download Template atau Import Excel berkolom Uraian Barang | Spesifikasi Lain | HS Code, cek pratinjau, lalu klik Import.',
  'masterBarang.help.step3': 'Nyalakan "Konflik saja" untuk melihat kode yang punya lebih dari satu HS.',
  'masterBarang.help.step4':
    'Di draft PIB, buka tab Barang → tombol "Sinkron Master Barang" → pilih importir → Sinkronkan. Barang dicocokkan lewat Uraian, bukan HS: kode mengisi Spesifikasi Lain dan HS. Yang cocok persis langsung diisi dan Uraian-nya tetap; yang memuat semua kata Uraian Master ditinjau dulu (Ubah = pakai Uraian Master, kata lain dihapus / Tetap).',
  'masterBarang.help.step5':
    'Titik hijau = cocok; kuning = cek lalu Konfirmasi; "Pilih kode" = pilih dari kandidat; merah = Uraian cocok tapi HS beda — pilih "Uraian benar" atau "Tetap" (pakai HS dokumen); abu-abu = "Tidak ada di Master" (HS sama saja tidak cukup).',
  'masterBarang.help.close': 'Mengerti',
  'masterBarang.conflictNameMultiCode': 'Nama ini punya >1 kode',
  'masterBarang.conflictCodeMultiHs': 'Kode ini punya >1 HS',
  'masterBarang.colUraian': 'Uraian Barang',
  'masterBarang.colSpesifikasiLain': 'Spesifikasi Lain',
  'masterBarang.colHs': 'HS Code',
  'masterBarang.colSumber': 'Sumber',
  'masterBarang.colDipakai': 'Dipakai',
  'masterBarang.colAksi': 'Aksi',
  'masterBarang.seenCount': '{n}×',
  'masterBarang.relative.justNow': 'baru saja',
  'masterBarang.relative.minutes': '{n} menit lalu',
  'masterBarang.relative.hours': '{n} jam lalu',
  'masterBarang.relative.days': '{n} hari lalu',
  'masterBarang.relative.months': '{n} bulan lalu',
  'masterBarang.relative.years': '{n} tahun lalu',
  'masterBarang.emptyTitle': 'Belum ada barang untuk importir ini',
  'masterBarang.emptyHint': 'Tambah satu per satu atau import dari Excel.',
  'masterBarang.emptyFiltered': 'Tidak ada barang yang cocok dengan filter',
  'masterBarang.loadFailedTitle': 'Gagal memuat Master Barang',
  'masterBarang.loadFailedMsg': 'Coba muat ulang halaman.',
  'masterBarang.noPpjkTitle': 'NPWP PPJK tidak ditemukan',
  'masterBarang.noPpjkMsg': 'Master Barang disimpan per PPJK. Masuk dengan akun PPJK untuk mengelolanya.',
  'masterBarang.addTitle': 'Tambah Barang',
  'masterBarang.editTitle': 'Ubah Barang',
  'masterBarang.forImporter': 'Importir: {npwp}',
  'masterBarang.editHint': 'Perubahan menjadikan baris ini Manual — tidak tertimpa Import',
  'masterBarang.hsHint': 'HS 8 digit, boleh pakai titik (3903.30.90)',
  'masterBarang.hsInvalid': 'HS harus 8 digit',
  'masterBarang.required': 'Wajib diisi',
  'masterBarang.cancel': 'Batal',
  'masterBarang.save': 'Simpan',
  'masterBarang.create': 'Tambah',
  'masterBarang.formInvalidTitle': 'Data belum lengkap',
  'masterBarang.formInvalidMsg': 'Isi Uraian Barang, Spesifikasi Lain, dan HS 8 digit.',
  'masterBarang.savedTitle': 'Tersimpan',
  'masterBarang.createdMsg': 'Barang ditambahkan ke Master Barang.',
  'masterBarang.updatedMsg': 'Barang diperbarui dan sekarang bersumber Manual.',
  'masterBarang.existsMsg': 'Barang dengan uraian, kode, dan HS yang sama sudah ada.',
  'masterBarang.saveFailedTitle': 'Gagal menyimpan',
  'masterBarang.saveFailedMsg': 'Barang tidak tersimpan. Coba lagi.',
  'masterBarang.deleteTitle': 'Hapus barang',
  'masterBarang.deleteConfirm': 'Hapus "{uraian}" ({kode}) dari Master Barang? Jarvis tidak akan memakainya lagi. Anda bisa memulihkannya dari Riwayat dihapus.',
  'masterBarang.delete': 'Hapus',
  'masterBarang.edit': 'Ubah',
  'masterBarang.deletedTitle': 'Dihapus',
  'masterBarang.deletedMsg': 'Barang dihapus dari Master Barang.',
  'masterBarang.deleteFailedMsg': 'Barang tidak terhapus. Coba lagi.',
  'masterBarang.viewActive': 'Aktif',
  'masterBarang.viewDeleted': 'Riwayat dihapus',
  'masterBarang.selectedCount': '{n} dipilih',
  'masterBarang.selectAllMatching': 'Pilih semua {n} barang',
  'masterBarang.allMatchingSelected': 'Semua {n} barang yang cocok dipilih',
  'masterBarang.clearSelection': 'Batalkan pilihan',
  'masterBarang.deleteSelected': 'Hapus terpilih',
  'masterBarang.bulkDeleteTitle': 'Hapus {n} barang',
  'masterBarang.bulkDeleteConfirm': '{n} barang akan dihapus dari Master Barang dan tidak dipakai Sinkron lagi. Anda bisa memulihkannya dari Riwayat dihapus.',
  'masterBarang.bulkDeleteAllNote': 'Ini semua barang yang cocok dengan pencarian dan filter saat ini, bukan hanya halaman ini.',
  'masterBarang.bulkDeletedMsg': '{n} barang dihapus. Lihat di Riwayat dihapus.',
  'masterBarang.selectionChangedTitle': 'Jumlah barang berubah',
  'masterBarang.selectionChangedMsg': 'Sekarang ada {n} barang yang cocok. Belum ada yang diubah; periksa lagi lalu ulangi.',
  'masterBarang.history.intro': 'Barang yang dihapus tidak dipakai Sinkron. Pulihkan untuk memakainya lagi. Setiap hapus dan pulihkan tercatat di Log aktivitas.',
  'masterBarang.history.tabDeleted': 'Barang dihapus',
  'masterBarang.history.tabLog': 'Log aktivitas',
  'masterBarang.history.colDeleted': 'Dihapus',
  'masterBarang.history.beforeLog': 'Sebelum log dicatat',
  'masterBarang.history.restore': 'Pulihkan',
  'masterBarang.history.restoreSelected': 'Pulihkan terpilih',
  'masterBarang.history.restoreTitle': 'Pulihkan {n} barang',
  'masterBarang.history.restoreConfirm': '{n} barang kembali ke Master Barang dan dipakai Sinkron lagi. Barang yang Uraian, Spesifikasi Lain dan HS-nya sudah ada di Master tidak dipulihkan, supaya tidak dobel.',
  'masterBarang.history.restoredMsg': '{n} barang dipulihkan.',
  'masterBarang.history.skippedTitle': '{n} barang tidak dipulihkan',
  'masterBarang.history.skippedDuplicate': 'Sudah ada di Master Barang: {list}',
  'masterBarang.history.restoreFailedMsg': 'Barang tidak dipulihkan. Coba lagi.',
  'masterBarang.history.empty': 'Belum ada barang yang dihapus',
  'masterBarang.history.emptyFiltered': 'Tidak ada barang dihapus yang cocok',
  'masterBarang.history.logEmpty': 'Belum ada aktivitas hapus atau pulihkan',
  'masterBarang.history.searchPlaceholder': 'Cari uraian, Spesifikasi Lain, atau HS',
  'masterBarang.history.colTime': 'Waktu',
  'masterBarang.history.colAction': 'Aksi',
  'masterBarang.history.colVia': 'Cara',
  'masterBarang.history.colBy': 'Oleh',
  'masterBarang.history.actionAll': 'Semua aksi',
  'masterBarang.history.actionDelete': 'Dihapus',
  'masterBarang.history.actionRestore': 'Dipulihkan',
  'masterBarang.history.via.single': 'Satu baris',
  'masterBarang.history.via.bulk': 'Massal',
  'masterBarang.history.via.import': 'Import Excel',
  'masterBarang.history.via.edit': 'Edit barang',
  'masterBarang.history.via.create': 'Tambah barang',
  'masterBarang.history.batchOf': '{n} barang sekaligus',
  'masterBarang.history.unknownUser': 'Tidak diketahui',
  'masterBarang.downloadFailedTitle': 'Gagal mengunduh',
  'masterBarang.downloadFailedMsg': 'File tidak terunduh. Coba lagi.',
  'masterBarang.uploadIntro':
    'Semua baris di file masuk ke Master Barang importir {npwp}. Kolom: Uraian Barang, Spesifikasi Lain, HS Code.',
  'masterBarangImport.dropTitle': 'Tarik file Excel ke sini',
  'masterBarangImport.dropHint': 'Format .xlsx dengan kolom Uraian Barang, Spesifikasi Lain, HS Code',
  'masterBarangImport.chooseFile': 'Pilih file',
  'masterBarangImport.onlyXlsx': 'Hanya file .xlsx yang bisa diimport.',
  'masterBarangImport.reading': 'Membaca {file}…',
  'masterBarangImport.previewFailed': 'File tidak bisa dibaca',
  'masterBarangImport.failedTitle': 'Import gagal',
  'masterBarangImport.failedMsg': 'Coba lagi atau periksa format file.',
  'masterBarangImport.chooseOther': 'Pilih file lain',
  'masterBarangImport.previewStale': 'Master Barang importir ini berubah sejak pratinjau dibuat.',
  'masterBarangImport.reloadPreview': 'Muat ulang pratinjau',
  'masterBarangImport.rowsSeen': '{n} baris dibaca',
  'masterBarangImport.summary.new': '{n} baru',
  'masterBarangImport.summary.unchanged': '{n} tidak berubah',
  'masterBarangImport.summary.reactivated': '{n} diaktifkan lagi',
  'masterBarangImport.summary.skipped': '{n} dilewati',
  'masterBarangImport.summary.duplicatesCollapsed': '{n} duplikat digabung',
  'masterBarangImport.noIssues': 'Tidak ada peringatan.',
  'masterBarangImport.examplesNote': 'Paling banyak 50 contoh.',
  'masterBarangImport.issue.HS_TRUNCATED': 'HS 10 digit dipotong jadi 8 digit',
  'masterBarangImport.issue.HS_NOT_IN_BTKI': 'HS tidak ada di BTKI (tetap diimport)',
  'masterBarangImport.issue.HS_INVALID': 'HS tidak valid (dilewati)',
  'masterBarangImport.issue.ROW_INCOMPLETE': 'Uraian atau Spesifikasi Lain kosong (dilewati)',
  'masterBarangImport.issue.NAME_MULTI_CODE': 'Nama ini punya >1 kode',
  'masterBarangImport.issue.CODE_MULTI_HS': 'Kode ini punya >1 HS',
  'masterBarangImport.colRow': 'Baris',
  'masterBarangImport.colRaw': 'Nilai asli',
  'masterBarangImport.colHsCodes': 'HS',
  'masterBarangImport.neverDeletes':
    'Import tidak menghapus baris yang tidak ada di file, dan tidak menimpa baris Manual.',
  'masterBarangImport.importN': 'Import {n} baris',
  'masterBarangImport.importedTitle': 'Import selesai',
  'masterBarangImport.importedMsg': '{inserted} baris baru, {reactivated} diaktifkan lagi.',
  'masterBarangImport.resultLine':
    '{inserted} baris baru, {reactivated} diaktifkan lagi, {promoted} dari Riwayat AJU menjadi Import Excel.',
  'masterBarangImport.uploadAnother': 'Import file lain',
  'masterMatch.chipExact': 'Master',
  'masterMatch.chipFuzzy': 'Semua kata Master ada · cek',
  'masterMatch.chipAmbiguous': 'Pilih kode',
  'masterMatch.chipNone': 'Tidak ada di Master',
  'masterMatch.chipPicked': 'Dipilih dari Master',
  'masterMatch.chipHs': 'Cocok HS · cek',
  'masterMatch.chipConflict': 'Uraian & HS beda — pilih',
  'masterMatch.chipTooltip': 'Sumber Spesifikasi Lain: Master Barang',
  'masterMatch.popoverExact': 'Diisi dari Master Barang',
  'masterMatch.beforeTitle': 'Sebelum diisi dari Master',
  'masterMatch.popoverPicked': 'Dipilih dari Master Barang',
  'masterMatch.popoverFuzzy': 'Diisi dari Master Barang yang semua katanya ada di Uraian — cek dulu',
  'masterMatch.popoverAmbiguous': 'Pilih kode dari Master Barang',
  'masterMatch.popoverNone': 'Tidak ada di Master Barang',
  'masterMatch.popoverHs': 'Diisi dari kode Master Barang dengan HS yang sama — cek dulu',
  'masterMatch.popoverConflict':
    'Uraian cocok dengan Master Barang, tetapi HS-nya beda dengan dokumen — pilih yang benar',
  'masterMatch.conflictDocumentHs': 'Dokumen: HS {hs}',
  'masterMatch.conflictUraianRight': 'Uraian benar',
  'masterMatch.conflictKeep': 'Tetap — pakai HS dokumen',
  'masterMatch.conflictHint':
    'Uraian benar: Spesifikasi Lain diisi kode Master, HS Master dipakai dan tarif disinkronkan. Tetap: HS dan Uraian dokumen dipakai, barang tidak diubah.',
  'masterMatch.noneBody': 'Uraian ini belum ada di Master Barang importir.',
  'masterMatch.addToMaster': 'Tambah ke Master Barang',
  'masterMatch.noRows': 'Baris Master Barang tidak ditemukan.',
  'masterMatch.ambiguousHint': 'Nama ini punya lebih dari satu kode di Master Barang. Pilih yang benar.',
  'masterMatch.ambiguousHsHint': 'Uraian tidak cocok; HS ini punya beberapa kode di Master Barang. Pilih yang benar.',
  'masterMatch.hsHint': 'Uraian tidak cocok dengan Master Barang, jadi kode dipilih lewat HS.',
  'masterMatch.viaHs': 'via HS',
  'masterMatch.applied': 'Dipakai',
  'masterMatch.pick': 'Pilih',
  'masterMatch.confirm': 'Konfirmasi',
  'masterMatch.confirmHint': 'Konfirmasi menandai baris ini sudah dicek — chip jadi hijau',
  'masterMatch.candidatesCount': '{n} kandidat',
  'masterMatch.pickedTitle': 'Dipilih dari Master',
  'masterMatch.pickedMsg': 'Spesifikasi Lain diisi dari Master Barang.',
  'masterMatch.pickedHsMsg':
    'Spesifikasi Lain dan HS diisi dari Master Barang. Tarif HS baru disinkronkan — simpan untuk menyimpannya.',
  'masterMatch.keptTitle': 'Tetap pakai data dokumen',
  'masterMatch.keptMsg':
    'Barang ini tidak diubah: HS dan Uraian dokumen dipakai. Sinkron berikutnya tidak menyentuhnya lagi.',
  'masterMatch.pickFailedTitle': 'Gagal memilih',
  'masterMatch.pickFailed': 'Baris Master Barang tidak bisa dipakai. Coba lagi.',
  'masterMatch.pickNoLine': 'Simpan barang ini dulu, lalu pilih dari Master Barang.',
  'masterMatch.hsMasterApplied': 'HS dari Master Barang (dokumen: {hs})',
  'masterMatch.hsKeptMultiHs': 'Kode ini punya >1 HS di Master Barang — HS dokumen dipakai',
  'masterMatch.hsKeptNotBtki': 'HS di Master Barang tidak ada di BTKI — HS dokumen dipakai',
  'masterMatch.hsMasterAppliedNoDocument': 'HS dari Master Barang (dokumen tidak mencantumkan HS)',
  'masterMatch.hsKeptMultiHsPick': 'Kode ini punya >1 HS di Master Barang — pilih HS:',
  'masterMatch.hsKeptMultiHsNoDocument': 'Kode ini punya >1 HS di Master Barang — isi HS manual',
  'masterMatch.hsKeptNotBtkiNoDocument': 'HS di Master Barang tidak ada di BTKI — isi HS manual',
  'masterMatch.hsConflict': 'HS dokumen berbeda dengan Master Barang — pilih di chip Spesifikasi Lain',
  'masterMatch.hsConflictManual': 'HS dokumen berbeda dengan HS Master Barang untuk kode ini',
  'masterMatch.useMasterHs': 'Pakai HS Master {hs}',
  'masterMatch.hsChoiceTitle': 'HS dari Master Barang dipakai',
  'masterMatch.useDocumentHs': 'Pakai HS dokumen',
  'masterMatch.documentHsTitle': 'HS dokumen dipakai',
  'masterMatch.documentHsMsg': 'HS {hs} dipasang dan tarifnya disinkronkan. Simpan untuk menerapkan.',
  'masterMatch.openInDrawer': 'Buka di Edit Barang',
  'masterMatch.pickedHsTableMsg': 'Spesifikasi Lain dan HS diisi dari Master Barang, tarifnya disinkronkan.',
  'masterMatch.filterActive': 'Master Barang: menampilkan {n} barang yang perlu dicek',
  'masterMatch.filterLoading': 'Memuat barang yang perlu dicek…',
  'masterMatch.filterFailed': 'Barang yang perlu dicek tidak bisa dimuat.',
  'masterMatch.filterClear': 'Tampilkan semua barang',
  'masterMatch.syncButton': 'Sinkron Master Barang',
  'masterMatch.syncTitle': 'Sinkron Master Barang',
  'masterMatch.syncIntro':
    'Cocokkan setiap barang dengan Master Barang importir lewat Uraian (atau kode di Uraian), tidak lewat HS: kode Master masuk ke Spesifikasi Lain dan HS diisi. Cocok persis: Uraian tetap. Semua kata Master ada di Uraian (urutan bebas, kata tambahan boleh): ditinjau dulu — Ubah memakai Uraian Master dan menghapus kata tambahan, Tetap tidak mengubah barang. Merk dan Tipe tidak diubah. Barang yang Uraian-nya tidak cocok tidak diisi, dan barang yang Spesifikasi Lain-nya sudah terisi tidak ditimpa.',
  'masterMatch.syncImporterLabel': 'Importir / consignee',
  'masterMatch.syncImporterPlaceholder': 'Pilih importir',
  'masterMatch.syncNoImporters': 'Belum ada importir di Master Barang.',
  'masterMatch.syncNoImportersLink': 'Tambah consignee & import barang di Master Barang →',
  'masterMatch.syncImporterMissing': 'Importir draft ini belum ada di Master Barang — tambah lewat Tambah Consignee',
  'masterMatch.syncNoRows': 'Importir ini belum punya baris Master Barang.',
  'masterMatch.syncOpenMaster': 'Buka Master Barang',
  'masterMatch.syncSubmit': 'Sinkronkan',
  'masterMatch.syncErrorTitle': 'Sinkron gagal',
  'masterMatch.syncErrorEmpty':
    'Importir ini belum punya baris Master Barang. Tambahkan atau import dulu di Master Barang.',
  'masterMatch.syncErrorUnavailable': 'Jarvis tidak dapat dihubungi, coba lagi',
  'masterMatch.syncErrorDbBusy': 'Database staging sedang penuh, coba lagi sebentar.',
  'masterMatch.syncErrorServer': 'Server sedang bermasalah (502), coba lagi sebentar.',
  'masterMatch.syncErrorTooLarge': 'Master Barang importir ini terlalu besar (>50.000 baris) untuk disinkronkan',
  'masterMatch.syncErrorPibOnly': 'Sinkron Master Barang hanya untuk PIB',
  'masterMatch.syncFailed': 'Sinkron Master Barang gagal. Coba lagi.',
  'masterMatch.syncHeadline': '{filled} dari {total} barang diisi dari Master Barang',
  'masterMatch.syncMasterRows': 'Master Barang {npwp}: {n} baris',
  'masterMatch.syncSectionLines': 'Spesifikasi Lain',
  'masterMatch.syncSectionHs': 'HS',
  'masterMatch.syncFilledExact': 'Diisi — cocok persis',
  'masterMatch.syncFilledFuzzy': 'Diisi — semua kata Master ada, perlu dicek',
  'masterMatch.syncAmbiguous': 'Perlu pilih kode',
  'masterMatch.syncConflict': 'Uraian & HS beda — perlu dipilih',
  'masterMatch.syncNone': 'Tidak ada di Master Barang',
  'masterMatch.syncSkippedFilled': 'Sudah terisi, tidak ditimpa',
  'masterMatch.syncHsAgree': 'HS sama dengan dokumen',
  'masterMatch.syncHsMasterApplied': 'HS dari Master Barang (berbeda dengan dokumen)',
  'masterMatch.syncHsKeptMultiHs': 'HS dokumen dipakai — kode punya >1 HS',
  'masterMatch.syncHsKeptNotBtki': 'HS dokumen dipakai — HS Master tidak ada di BTKI',
  'masterMatch.syncReview': 'Lihat barang yang perlu dicek',
  'masterMatch.syncClose': 'Tutup',
  'masterMatch.syncKept': 'Tetap — tidak diubah',
  'masterMatch.syncPending': 'Belum dipilih — tidak diubah',
  'masterMatch.syncReviewTitle': 'Tinjau perubahan sebelum disimpan',
  'masterMatch.syncReviewCount':
    '{n} barang tidak cocok persis — cek dulu. Belum ada yang disimpan — pilih Ubah atau Tetap per barang.',
  'masterMatch.syncAutoApplyCount': '{n} barang cocok persis akan langsung diubah',
  'masterMatch.syncAutoApplyShow': 'Lihat',
  'masterMatch.syncAutoApplyHide': 'Sembunyikan',
  'masterMatch.syncFuzzyWarning':
    'Semua kata Master ada di Uraian, tapi tidak persis — kata lain akan dihapus, cek dulu',
  'masterMatch.syncHsMoveWarning': 'HS akan diganti dari Master Barang (tarif ikut diperbarui)',
  'masterMatch.syncKindExact': 'Cocok persis',
  'masterMatch.syncKindFuzzy': 'Semua kata Master ada di Uraian',
  'masterMatch.syncRemovedWords': 'Dihapus:',
  'masterMatch.syncKindHsMove': 'HS dari Master',
  'masterMatch.syncKindOther': 'Dari Master Barang',
  'masterMatch.syncSeri': 'Seri {n}',
  'masterMatch.syncFieldUraian': 'Uraian',
  'masterMatch.syncFieldSpesifikasiLain': 'Spesifikasi Lain',
  'masterMatch.syncFieldHs': 'HS',
  'masterMatch.syncFieldKodeBarang': 'Kode Barang',
  'masterMatch.syncFieldUkuran': 'Ukuran',
  'masterMatch.syncFieldMerk': 'Merk',
  'masterMatch.syncFieldTipe': 'Tipe',
  'masterMatch.syncEmptyValue': '(kosong)',
  'masterMatch.syncCleared': '(dikosongkan)',
  'masterMatch.syncRetariff': 'tarif ikut diperbarui',
  'masterMatch.syncChoiceAccept': 'Ubah',
  'masterMatch.syncChoiceKeep': 'Tetap',
  'masterMatch.syncAcceptAll': 'Ubah semua',
  'masterMatch.syncKeepAll': 'Tetap semua',
  'masterMatch.syncChoiceLabel': 'Pilihan untuk seri {n}',
  'masterMatch.syncApply': 'Terapkan ({n} diubah)',
  'submitsummary.masterBarang.title': 'Master Barang: {n} barang perlu dicek',
  'submitsummary.masterBarang.body':
    'Kode atau HS dari Master Barang perlu dicek: kode belum dipilih, tidak ada di Master, cocok lewat kata (belum persis), atau HS Master berbeda dengan dokumen. Tidak menghalangi submit.',
  'submitsummary.masterBarang.open': 'Lihat barang',
  'eksportir.title': 'Data Eksportir',
  'eksportir.subtitle': 'Daftar eksportir yang Anda urus. Isi sekali, dipakai berulang di dokumen PEB Anda.',
  'eksportir.privacyTitle': 'Hanya untuk PPJK Anda',
  'eksportir.tabOwn': 'PPJK Saya',
  'eksportir.tabGlobal': 'Semua PPJK',
  'eksportir.colPpjk': 'PPJK',
  'eksportir.globalNoticeTitle': 'Tampilan internal, hanya baca',
  'eksportir.globalNotice':
    'Daftar eksportir dari semua PPJK, hanya terlihat oleh super admin. Untuk menambah atau mengubah eksportir, masuk sebagai PPJK pemiliknya.',
  'eksportir.globalSearchPlaceholder': 'Cari eksportir, nomor identitas, atau PPJK',
  'eksportir.privacyBody':
    'Daftar ini tersimpan khusus untuk {company} (NPWP {npwp}). Tidak dibagikan ke PPJK lain, tidak dipakai untuk melatih apa pun, dan hanya dipakai untuk mengisi dokumen Anda.',
  'eksportir.yourPpjk': 'PPJK Anda',
  'eksportir.noPpjkTitle': 'NPWP PPJK belum ada',
  'eksportir.noPpjkMsg': 'Akun Anda belum terhubung ke PPJK. Hubungi administrator Anda.',
  'eksportir.loadFailedTitle': 'Gagal memuat',
  'eksportir.loadFailedMsg': 'Daftar eksportir belum bisa dimuat. Coba lagi beberapa saat.',
  'eksportir.searchPlaceholder': 'Cari nama atau nomor identitas',
  'eksportir.total': '{n} eksportir',
  'eksportir.template': 'Template',
  'eksportir.exportCurrent': 'Unduh data saat ini',
  'eksportir.uploadExcel': 'Unggah Excel',
  'eksportir.uploadIntro':
    'Unduh template, isi di Excel, lalu unggah kembali. Anda akan melihat apa yang akan berubah sebelum data disimpan.',
  'eksportir.add': 'Tambah',
  'eksportir.addTitle': 'Tambah Eksportir',
  'eksportir.editTitle': 'Ubah Eksportir',
  'eksportir.emptyTitle': 'Belum ada eksportir',
  'eksportir.emptyHint': 'Tambah satu per satu, atau unggah sekaligus dari Excel.',
  'eksportir.colNama': 'Nama Eksportir',
  'eksportir.colIdentitas': 'Identitas',
  'eksportir.colJenisIdentitas': 'Jenis Identitas',
  'eksportir.colNomorIdentitas': 'Nomor Identitas',
  'eksportir.colAlamat': 'Alamat',
  'eksportir.colStatus': 'Status',
  'eksportir.colSumber': 'Sumber',
  'eksportir.colDiperbarui': 'Diperbarui',
  'eksportir.colAksi': 'Aksi',
  'eksportir.sourceExcel': 'Excel',
  'eksportir.sourceManual': 'Manual',
  'eksportir.sourceCeisa': 'CEISA',
  'eksportir.edit': 'Ubah',
  'eksportir.delete': 'Hapus',
  'eksportir.cancel': 'Batal',
  'eksportir.save': 'Simpan',
  'eksportir.create': 'Tambah',
  'eksportir.unknown': 'Tidak diketahui',
  'eksportir.namaPlaceholder': 'PT. CONTOH',
  'eksportir.npwpHint': '15 atau 16 digit. Titik dan strip boleh diketik, akan dirapikan otomatis.',
  'eksportir.identitasHint': 'Hanya angka. Karakter lain dibuang otomatis.',
  'eksportir.identitasStoredAs': 'Akan disimpan sebagai {nomor}',
  'eksportir.npwpInvalid': 'NPWP harus 15 atau 16 digit',
  'eksportir.ktpInvalid': 'KTP harus 16 digit angka',
  'eksportir.identitasEmpty': 'Nomor identitas harus berisi angka',
  'eksportir.identitasTooLong': 'Nomor identitas maksimal 50 digit',
  'eksportir.formInvalidTitle': 'Periksa isian',
  'eksportir.formInvalidMsg': 'Nama dan nomor identitas wajib diisi dengan benar.',
  'eksportir.savedTitle': 'Tersimpan',
  'eksportir.createdMsg': 'Eksportir ditambahkan.',
  'eksportir.updatedMsg': 'Eksportir diperbarui.',
  'eksportir.existsMsg': 'Identitas ini sudah ada di daftar Anda. Ubah data yang ada, bukan menambah baru.',
  'eksportir.saveFailedTitle': 'Gagal menyimpan',
  'eksportir.saveFailedMsg': 'Eksportir belum tersimpan. Coba lagi.',
  'eksportir.deleteTitle': 'Hapus Eksportir',
  'eksportir.deleteConfirm': 'Hapus {nama} dari daftar Anda? Data ini tidak akan muncul lagi di dokumen baru.',
  'eksportir.deletedTitle': 'Dihapus',
  'eksportir.deletedMsg': 'Eksportir dihapus dari daftar.',
  'eksportir.deleteFailedMsg': 'Eksportir belum terhapus. Coba lagi.',
  'eksportir.downloadFailedTitle': 'Gagal mengunduh',
  'eksportir.downloadFailedMsg': 'File belum bisa diunduh. Coba lagi beberapa saat.',
  'eksportir.jenis.2': 'PASPOR',
  'eksportir.jenis.3': 'KTP',
  'eksportir.jenis.4': 'LAINNYA',
  'eksportir.jenis.5': 'NPWP 15 DIGIT',
  'eksportir.jenis.6': 'NPWP 16 DIGIT',
  'eksportir.jenis.npwp': 'NPWP',
  'eksportir.status.1': 'KOPERASI',
  'eksportir.status.2': 'PMDN (MIGAS)',
  'eksportir.status.3': 'PMDN (NON MIGAS)',
  'eksportir.status.4': 'PMA (MIGAS)',
  'eksportir.status.5': 'PMA (NON MIGAS)',
  'eksportir.status.6': 'BUMN',
  'eksportir.status.7': 'BUMD',
  'eksportir.status.8': 'SWASTA',
  'eksportir.status.9': 'JOINT VENTURE',
  'eksportir.status.10': 'LAINNYA',
  'eksportirImport.dropTitle': 'Tarik file Excel ke sini',
  'eksportirImport.dropHint': 'Satu file .xlsx, maksimal 5.000 baris',
  'eksportirImport.chooseFile': 'Pilih file',
  'eksportirImport.onlyXlsx': 'Gunakan satu file Excel (.xlsx) dari template.',
  'eksportirImport.reading': 'Membaca {file}',
  'eksportirImport.previewFailed': 'File belum bisa dibaca',
  'eksportirImport.previewStale': 'Data Eksportir berubah, pratinjau mungkin tidak sesuai',
  'eksportirImport.reloadPreview': 'Muat ulang pratinjau',
  'eksportirImport.chooseOther': 'Pilih file lain',
  'eksportirImport.rowsSeen': '{n} baris',
  'eksportirImport.rowLabel': 'Baris {n}',
  'eksportirImport.actionNew': 'baru',
  'eksportirImport.actionUpdated': 'diperbarui',
  'eksportirImport.actionUnchanged': 'tidak berubah',
  'eksportirImport.actionRejected': 'dilewati',
  'eksportirImport.neverDeletes':
    'Unggahan tidak pernah menghapus data. Baris yang tidak ada di file dibiarkan apa adanya; sel kosong tidak menimpa nilai yang sudah ada.',
  'eksportirImport.importN': 'Impor {n} baris',
  'eksportirImport.importedTitle': 'Impor selesai',
  'eksportirImport.importedMsg': '{new} baru, {updated} diperbarui.',
  'eksportirImport.resultLine': '{new} baru, {updated} diperbarui, {unchanged} tidak berubah.',
  'eksportirImport.rejectedTitle': 'Baris yang dilewati',
  'eksportirImport.failedTitle': 'Impor gagal',
  'eksportirImport.failedMsg': 'Data belum tersimpan. Coba lagi.',
  'eksportirImport.uploadAnother': 'Unggah file lain',
  'eksportirCard.dataEksportir': 'Data Eksportir',
  'eksportirCard.dibukaDiTabBaru': 'Dibuka di tab baru: Master › Data Eksportir',
  'eksportirCard.belumAda':
    'Belum ada di Data Eksportir. Tersimpan otomatis setelah dokumen berhasil dikirim ke CEISA.',
  'eksportirCard.buka': 'Buka Data Eksportir',
  'eksportirCard.simpan': 'Simpan ke Data Eksportir',
  'eksportirCard.simpanHint': 'Simpan eksportir ini agar terisi otomatis di dokumen berikutnya.',
  'eksportirCard.tersimpan': 'Tersimpan ke Data Eksportir',
  'eksportirCard.tersimpanMsg': 'Eksportir ini akan terisi otomatis dari nomor identitasnya mulai sekarang.',
  'eksportirCard.sudahAda': 'Identitas ini sudah ada di Data Eksportir.',
  'eksportirCard.gagalSimpan': 'Gagal menyimpan ke Data Eksportir.',
  'eksportirCard.diterapkanTitle': 'Diterapkan',
  'eksportirCard.diterapkanMsg': 'Data Eksportir diterapkan ke Eksportir.',
  'statement.updatedBy': 'Diperbarui oleh {email} pada {date}',
  'statement.utama': 'Utama',
  'statement.tabOwn': 'PPJK Saya',
  'statement.tabGlobal': 'Semua PPJK',
  'statement.staleSessionTitle': 'PPJK akun Anda sudah berubah',
  'statement.staleSessionMsg':
    'Browser ini masih menyimpan PPJK lama ({stored}). Akun Anda sekarang terhubung ke {current}, dan itulah yang ditampilkan di sini dan dipakai draft Anda. Keluar lalu masuk lagi agar bagian lain aplikasi ikut menyesuaikan.',
  'statement.jadikanUtama': 'Jadikan utama',
  'statement.jadikanUtamaBerhasil': '{name} sekarang menjadi Pernyataan utama untuk draft baru.',
  'statement.jadikanUtamaGagal': 'Gagal menjadikan utama',
  'statement.nonaktifkanUtamaJudul': 'Nonaktifkan Pernyataan utama?',
  'statement.nonaktifkanUtamaPesan':
    'Pernyataan aktif lain yang paling awal dibuat akan otomatis menjadi utama untuk draft baru.',
  'statement.nonaktifkanUtamaTanpaPengganti':
    'Tidak ada Pernyataan aktif lain. Draft baru tidak akan terisi Pernyataan secara otomatis.',
  'statement.nonaktifkan': 'Nonaktifkan',
  'statement.batal': 'Batal',
  'statement.konflikJudul': 'Pernyataan baru saja diperbarui oleh rekan Anda',
  'statement.konflikDiperbaruiOleh': 'Diperbarui oleh {email} pada {date}',
  'statement.konflikDiperbaruiPada': 'Diperbarui pada {date}',
  'statement.kolomTempat': 'Tempat',
  'statement.kolomNama': 'Nama',
  'statement.kolomJabatan': 'Jabatan',
  'statement.konflikMuatUlang': 'Muat ulang',
  'statement.konflikTimpa': 'Timpa',
  'statement.konflikGagalMemuat': 'Data terbaru belum bisa dimuat.',
  'statement.konflikMuatUlangDaftar': 'Muat ulang daftar',
  'pernyataanform.pilihPernyataan': 'Pilih Pernyataan',
  'pernyataanform.pilihPernyataanPlaceholder': 'Pilih dari Master › Pernyataan',
  'pernyataanform.diubahManual': 'Nilai saat ini diubah manual',
  'settings.sectionTampilan': 'Tampilan',
  'settings.theme': 'Tema',
  'settings.themeDesc': 'Warna tampilan aplikasi. Berlaku untuk akun Anda saja.',
  'settings.language': 'Bahasa',
  'settings.languageDesc': 'Bahasa menu dan teks aplikasi.',
  'settings.textSize': 'Ukuran teks',
  'settings.textSizeDesc': 'Perbesar teks dan tombol di seluruh aplikasi.',
  'settings.textSizeNormal': 'Normal',
  'settings.textSizeLarge': 'Besar',
  'settings.textSizeLarger': 'Lebih besar',
  'settings.textSizePreview': 'Contoh: Nomor Aju 000020-001234-20260915-000041, Importir PT. CEMANI TOKA, Status SPPB.',
  'settings.textSizeNote':
    'Perubahan langsung terlihat. Beberapa tabel yang padat akan terasa lebih rapat pada ukuran terbesar.',

  // ---- Riwayat perubahan draf (drawer "Audit Logs" di halaman edit) ----
  'docpabean.audit.title': 'Riwayat Perubahan',
  'docpabean.audit.refresh': 'Muat ulang',
  'docpabean.audit.count': '{n} perubahan',
  'docpabean.audit.loadMore': 'Muat lebih banyak ({n} lagi)',
  'docpabean.audit.unavailable': 'Riwayat belum tersedia untuk draf ini.',
  'docpabean.audit.subtitle.batch': 'Batch {uuid}',
  'docpabean.audit.subtitle.none': 'Draf belum tersimpan',
  'docpabean.audit.systemActor': 'Sistem',
  'docpabean.audit.rowCount': '{n} baris',
  'docpabean.audit.empty': '(kosong)',
  'docpabean.audit.yes': 'Ya',
  'docpabean.audit.no': 'Tidak',
  'docpabean.audit.addedEntity': 'Ditambahkan: {entity}',
  'docpabean.audit.removedEntity': 'Dihapus: {entity}',
  'docpabean.audit.showMoreFields': 'Lihat {n} lainnya',
  'docpabean.audit.hideMoreFields': 'Sembunyikan',
  'docpabean.audit.showMoreValue': 'selengkapnya',
  'docpabean.audit.showLessValue': 'lebih sedikit',
  'docpabean.audit.filter.tab.all': 'Semua',
  'docpabean.audit.filteredEmpty': 'Tidak ada perubahan pada tab ini.',
  'docpabean.audit.empty.title': 'Belum ada riwayat',
  'docpabean.audit.empty.body': 'Perubahan pada draf ini akan tampil di sini.',
  'docpabean.audit.error.title': 'Gagal memuat riwayat',
  'docpabean.audit.error.body': 'Riwayat tidak dapat dimuat. Coba lagi sebentar lagi.',
  'docpabean.audit.error.retry': 'Coba lagi',
  'docpabean.audit.notFound.title': 'Riwayat tidak ditemukan',
  'docpabean.audit.notFound.body': 'Draf ini tidak tersedia untuk akun Anda.',
  'docpabean.audit.forbidden.title': 'Akun belum terhubung PPJK',
  'docpabean.audit.forbidden.body': 'Akun Anda belum terhubung ke PPJK, sehingga riwayat draf tidak dapat ditampilkan.',
  'docpabean.audit.day.today': 'Hari ini',
  'docpabean.audit.day.yesterday': 'Kemarin',
  'docpabean.audit.day.unknown': 'Tanggal tidak diketahui',
  'docpabean.audit.time.justNow': 'Baru saja',
  'docpabean.audit.time.minutesAgo': '{n} menit lalu',
  'docpabean.audit.time.hoursAgo': '{n} jam lalu',
  'docpabean.audit.time.daysAgo': '{n} hari lalu',
  'docpabean.audit.time.monthsAgo': '{n} bulan lalu',
  'docpabean.audit.time.yearsAgo': '{n} tahun lalu',
  'docpabean.audit.time.unknown': 'Waktu tidak diketahui',
  // Ekstraksi AI tampil sebagai tiga tonggak saja: tanpa jumlah, tanpa nama
  // field, tanpa nilai.
  'docpabean.audit.milestone.extractionStarted': 'Ekstraksi AI dimulai oleh {name}',
  'docpabean.audit.milestone.extractionStartedAnon': 'Ekstraksi AI dimulai',
  'docpabean.audit.milestone.extractionCompleted': 'Ekstraksi AI selesai',
  'docpabean.audit.milestone.extractionFailed': 'Ekstraksi AI gagal',
  'docpabean.audit.milestone.submitDraft': '{name} mengirim draf',
  'docpabean.audit.milestone.submitFinal': '{name} mengirim dokumen final',
  'docpabean.audit.milestone.draftDeleted': '{name} menghapus draf',
  'docpabean.audit.milestone.documentFileUploaded': '{name} mengunggah berkas {file}',
  'docpabean.audit.milestone.documentFileUploadedAnon': 'Berkas {file} diunggah',
  'docpabean.audit.milestone.smartSync': '{name} menjalankan Smart Sync',
  'docpabean.audit.import.full': 'Excel · Full',
  'docpabean.audit.import.barangOnly': 'Excel · Barang Only',
  'docpabean.audit.import.allTabs': 'Semua tab',
  'docpabean.audit.import.otherTab': 'Tanpa tab',
  'docpabean.audit.import.added': '{n} ditambah',
  'docpabean.audit.import.changed': '{n} diubah',
  'docpabean.audit.import.removed': '{n} dihapus',
  'docpabean.audit.import.fields': '{n} field',
  'docpabean.audit.import.noChanges': 'Tidak ada perubahan',
  'docpabean.audit.import.goodsReplaced': 'Daftar barang diganti sesuai isi file',
  'docpabean.audit.import.showPerTab': 'Lihat perubahan per tab',
  'docpabean.audit.import.hidePerTab': 'Sembunyikan perubahan per tab',
  'docpabean.audit.import.truncated': 'Menampilkan 300 baris pertama',
  'docpabean.audit.action.UPDATE': 'Diubah',
  'docpabean.audit.action.CREATE': 'Ditambahkan',
  'docpabean.audit.action.DELETE': 'Dihapus',
  'docpabean.audit.action.HISTORICAL_SYNC': 'Disalin dari riwayat',
  'docpabean.audit.action.AI_APPLIED': 'Diisi AI',
  'docpabean.audit.action.EXTRACTION_REQUESTED': 'Ekstraksi AI dimulai',
  'docpabean.audit.action.EXTRACTION_COMPLETED': 'Ekstraksi AI selesai',
  'docpabean.audit.action.EXTRACTION_FAILED': 'Ekstraksi AI gagal',
  'docpabean.audit.action.SUBMIT_DRAFT': 'Draf dikirim',
  'docpabean.audit.action.SUBMIT_FINAL': 'Dokumen final dikirim',
  'docpabean.audit.action.DRAFT_DELETED': 'Draf dihapus',
  'docpabean.audit.action.BULK_SUMMARY': 'Perubahan massal',
  'docpabean.audit.action.EXCEL_IMPORT': 'Unggah Excel',
  'docpabean.audit.action.SMART_SYNC': 'Smart Sync',
  'docpabean.audit.entity.header': 'Header',
  'docpabean.audit.entity.entity': 'Entitas',
  'docpabean.audit.entity.document': 'Dokumen',
  'docpabean.audit.entity.carrier': 'Pengangkut',
  'docpabean.audit.entity.peti_kemas': 'Peti kemas',
  'docpabean.audit.entity.kemasan': 'Kemasan',
  'docpabean.audit.entity.transaksi': 'Transaksi',
  'docpabean.audit.entity.barang': 'Barang',
  'docpabean.audit.entity.statement': 'Pernyataan',
  'docpabean.audit.entity.process': 'Proses',
  'docpabean.audit.entity.barang_vd': 'Jenis transaksi',
  'docpabean.audit.field.barang_vd.kodeJenisVd': 'Jenis transaksi',
  'docpabean.audit.field.barang_vd.nilaiBarangVd': 'Nilai VD',
  // A customs term, not UI copy: the CEISA form prints these words, so they are
  // the same in every language block rather than translated out of the document.
  'docpabean.audit.value.kondisiBarang1': 'Barang Baru',
  'docpabean.audit.value.kondisiBarang2': 'Bukan Barang Baru',
  'docpabean.audit.value.jenisApi01': 'API U',
  'docpabean.audit.value.jenisApi02': 'API P',
  'docpabean.audit.tab.header': 'Header',
  'docpabean.audit.tab.entitas': 'Entitas',
  'docpabean.audit.tab.dokumen': 'Dokumen',
  'docpabean.audit.tab.pengangkut': 'Pengangkut',
  'docpabean.audit.tab.kemasan': 'Kemasan & Peti Kemas',
  'docpabean.audit.tab.transaksi': 'Transaksi',
  'docpabean.audit.tab.barang': 'Barang',
  'docpabean.audit.tab.pungutan': 'Pungutan',
  'docpabean.audit.tab.pernyataan': 'Pernyataan',

  // "Hasil Ekstraksi" drawer on the PIB draft editor (src/features/draft-extraction)
  'docpabean.extraction.button': 'Hasil Ekstraksi',
  'docpabean.extraction.title': 'Hasil Ekstraksi',
  'docpabean.extraction.extractedAt': 'Diekstraksi {date}',
  'docpabean.extraction.download': 'Unduh Excel',
  'docpabean.extraction.downloading': 'Menyiapkan Excel…',
  'docpabean.extraction.note.snapshot':
    'Nilai AI adalah nilai saat diekstraksi. Nilai saat ini mengikuti form, termasuk perubahan yang belum disimpan.',
  'docpabean.extraction.note.source':
    'Sumber menunjukkan dokumen yang dipetakan ke field ini dan dikirim ke AI, bukan kutipan pasti dari dokumen.',
  'docpabean.extraction.filter.changedOnly': 'Hanya yang diubah',
  'docpabean.extraction.filter.status.placeholder': 'Semua status',
  'docpabean.extraction.column.seri': 'Seri',
  'docpabean.extraction.column.field': 'Field',
  'docpabean.extraction.column.ai': 'Nilai AI',
  'docpabean.extraction.column.current': 'Nilai saat ini',
  'docpabean.extraction.column.status': 'Status',
  'docpabean.extraction.column.source': 'Sumber (dipetakan)',
  'docpabean.extraction.column.changed': 'Diubah',
  'docpabean.extraction.changed': 'Diubah',
  'docpabean.extraction.status.ok': 'Dari dokumen',
  'docpabean.extraction.status.master-ok': 'Dari master data',
  'docpabean.extraction.status.default': 'Nilai bawaan',
  'docpabean.extraction.status.calc': 'Dihitung CEISA',
  'docpabean.extraction.status.user': 'Diisi pengguna',
  'docpabean.extraction.status.master': 'Perlu master data',
  'docpabean.extraction.status.shape': 'Di luar pilihan',
  'docpabean.extraction.source.open': 'Buka di penampil PDF',
  'docpabean.extraction.source.unavailable': 'Dokumen tidak tersedia',
  'docpabean.extraction.source.notUploadedTypes': 'Dokumen yang dipetakan tidak diunggah: {types}',
  'docpabean.extraction.source.notUploadedHint':
    'Field ini dipetakan ke bagian dokumen yang tidak ada di unggahan proses ini. Nilainya datang dari sumber lain (master data, nilai bawaan, atau isian pengguna).',
  'docpabean.extraction.source.emptySection': 'Bagian yang dipetakan kosong di {files}',
  'docpabean.extraction.source.emptySectionHint':
    'Dokumennya diunggah, tetapi bagian yang dipetakan untuk field ini tidak terbaca di dalamnya. Nilainya datang dari sumber lain.',
  'docpabean.extraction.source.unmapped': 'Tanpa pemetaan bagian dokumen',
  'docpabean.extraction.source.unmappedHint':
    'Peta semantik tidak menunjuk bagian dokumen tertentu untuk field ini, jadi tidak ada file yang bisa dibuka. Statusnya tetap menunjukkan dari mana nilainya berasal.',
  'docpabean.extraction.search.placeholder': 'Cari field, nilai, dokumen… (mis. npwp, invoice, diubah)',
  'docpabean.extraction.search.clear': 'Hapus pencarian',
  'docpabean.extraction.search.results': '{n} hasil di semua tab',
  'docpabean.extraction.search.empty': 'Tidak ada yang cocok dengan "{q}". Coba kata lain, nama field, atau nilainya.',
  'docpabean.extraction.goTo': 'Buka field ini di form',
  'docpabean.extraction.goToTab': 'Buka tab ini di form',
  'docpabean.extraction.page.range': '{from}–{to} dari {total}',
  'docpabean.extraction.row.seri': 'Seri {n}',
  'docpabean.extraction.attach.title': 'Lampiran barang',
  'docpabean.extraction.attach.count': '{n} dokumen',
  'docpabean.extraction.attach.callout':
    '{n} dokumen di draft ini bisa dilampirkan ke barang. Lihat barang apa saja yang sudah terlampir di tiap dokumen.',
  'docpabean.extraction.attach.open': 'Lihat lampiran',
  'docpabean.extraction.attach.hide': 'Sembunyikan',
  'docpabean.extraction.attach.description':
    'Dokumen seperti e-COO, SNI, laporan surveyor, dan izin bisa dilampirkan ke barang. Di sini Anda bisa melihat, untuk setiap barang yang tercantum di dokumen, barang mana di draft yang dilampirkan dan kenapa keduanya dianggap cocok. Invoice, packing list, B/L, dan DO tidak dilampirkan ke barang, jadi tidak muncul di sini.',
  'docpabean.extraction.attach.empty': 'Draft ini tidak punya dokumen yang bisa dilampirkan ke barang.',
  'docpabean.extraction.attach.filter': 'Cari nomor seri, kode, atau nama barang',
  'docpabean.extraction.attach.unmatchedOnly': 'Belum terlampir saja',
  'docpabean.extraction.attach.missedOnly': 'Perlu dicek saja',
  'docpabean.extraction.attach.notExact':
    'Catatan: hasil pencocokan di bawah mungkin sedikit berbeda dari yang tersimpan saat AI memproses draft ini.',
  'docpabean.extraction.attach.noMatch': 'Tidak ada dokumen atau barang yang cocok dengan pencarian ini.',
  'docpabean.extraction.attach.noRecord': 'Belum ada data lampiran dari AI untuk dokumen ini.',
  'docpabean.extraction.attach.noLines': 'Dokumen ini tidak memuat daftar barang.',
  'docpabean.extraction.attach.noLineMatch': 'Tidak ada barang yang cocok dengan pencarian ini.',
  'docpabean.extraction.attach.notInForm': 'Dokumen ini sudah tidak ada di tab Dokumen.',
  'docpabean.extraction.attach.dokumenNo': 'Dokumen #{n}',
  'docpabean.extraction.attach.terlampir': 'Terlampir',
  'docpabean.extraction.attach.summary': '{rows} barang terlampir dari {lines} baris',
  'docpabean.extraction.attach.unmatchedCount': '{n} baris belum terlampir',
  'docpabean.extraction.attach.missedCount': '{n} perlu dicek',
  'docpabean.extraction.attach.pending': 'Belum terlampir',
  'docpabean.extraction.attach.col.line': 'No.',
  'docpabean.extraction.attach.col.code': 'Kode di dokumen',
  'docpabean.extraction.attach.col.naming': 'Nama barang di dokumen',
  'docpabean.extraction.attach.col.qty': 'Jumlah',
  'docpabean.extraction.attach.col.seri': 'Seri barang',
  'docpabean.extraction.attach.col.barang': 'Barang di draft',
  'docpabean.extraction.attach.col.settledBy': 'Dicocokkan lewat',
  'docpabean.extraction.attach.col.evidence': 'Yang sama',
  'docpabean.extraction.attach.decision.code': 'kode barang sama',
  'docpabean.extraction.attach.decision.ocr_misread': 'kode hampir sama',
  'docpabean.extraction.attach.decision.amount': 'jumlahnya sama',
  'docpabean.extraction.attach.decision.naming': 'namanya mirip',
  'docpabean.extraction.attach.decision.line_number': 'nomor barisnya sama',
  'docpabean.extraction.attach.decision.sum': 'total jumlahnya sesuai',
  'docpabean.extraction.attach.decision.article': 'semua barang dengan kode ini',
  'docpabean.extraction.attach.decision.kind': 'jenis barangnya sesuai',
  'docpabean.extraction.attach.decision.shipment': 'berlaku untuk seluruh kiriman',
  'docpabean.extraction.attach.decision.unknown': 'tidak diketahui',
  'docpabean.extraction.attach.evidence.code': 'kode sama',
  'docpabean.extraction.attach.evidence.ocrMisread': 'kode hampir sama',
  'docpabean.extraction.attach.evidence.contradicts': 'kode berbeda',
  'docpabean.extraction.attach.evidence.amounts': '{fields} sama',
  'docpabean.extraction.attach.evidence.naming': 'nama mirip {n}%',
  'docpabean.extraction.attach.evidence.lineNumber': 'nomor baris sama',
  'docpabean.extraction.attach.field.jumlahSatuan': 'jumlah satuan',
  'docpabean.extraction.attach.field.jumlahKemasan': 'jumlah kemasan',
  'docpabean.extraction.attach.field.netto': 'berat bersih',
  'docpabean.extraction.attach.field.bruto': 'berat kotor',
  'docpabean.extraction.attach.field.nilaiBarang': 'nilai barang',
  'docpabean.extraction.attach.verdict.notShipped': 'Tidak ada di kiriman',
  'docpabean.extraction.attach.verdict.lookalikesTaken': 'Barang serupa sudah terlampir',
  'docpabean.extraction.attach.verdict.likelyMissed': 'Perlu dicek',
  'docpabean.extraction.attach.verdict.noCode': 'Tanpa kode barang',
  'docpabean.extraction.attach.verdict.notShippedDetail':
    'Tidak ada barang di draft dengan kode yang mirip, jadi wajar belum terlampir.',
  'docpabean.extraction.attach.verdict.noCodeDetail':
    'Baris ini tidak mencantumkan kode barang, jadi tidak bisa dicocokkan otomatis.',
  'docpabean.extraction.attach.verdict.candidate': 'Seri {n} ({code}) mungkin cocok: {reason}',
  'docpabean.extraction.attach.verdict.taken': 'Seri {n} ({code}) sudah terlampir lewat baris {line}',
  'docpabean.extraction.attach.reason.sameCode': 'kodenya sama',
  'docpabean.extraction.attach.reason.leadingZero': 'hanya beda angka 0 di depan',
  'docpabean.extraction.attach.reason.ocrMisread': 'beda satu huruf karena salah baca',
  'docpabean.extraction.attach.reason.insideLonger': 'kodenya bagian dari kode yang lebih panjang',
  'docpabean.extraction.attach.reason.cutOff': 'kodenya terpotong di dokumen',
  'docpabean.extraction.file.open': 'Lihat {name}',
  'docpabean.extraction.panel.fullScreen': 'Layar penuh',
  'docpabean.extraction.panel.dock': 'Tampilkan berdampingan dengan form',
  'docpabean.extraction.panel.resize': 'Geser untuk mengubah lebar panel (klik dua kali: layar penuh)',
  'docpabean.extraction.panel.releaseFull': 'Lepas untuk layar penuh',
  'docpabean.extraction.role.primary': 'utama',
  'docpabean.extraction.role.fallback': 'cadangan',
  'docpabean.extraction.current.seeTable': 'Lihat tabel',
  'docpabean.extraction.current.ceisa': 'Dihitung CEISA',
  'docpabean.extraction.current.notInForm': 'Tidak ada di form ini',
  'docpabean.extraction.rows': '{n} baris',
  'docpabean.extraction.row.status': 'Status baris',
  'docpabean.extraction.row.changed': 'Diubah',
  'docpabean.extraction.row.added': 'Ditambahkan pengguna',
  'docpabean.extraction.row.removed': 'Dihapus',
  'docpabean.extraction.table.aiOnly': 'Nilai AI saja — pungutan dihitung oleh CEISA',
  'docpabean.extraction.empty.tab': 'Tab ini tidak punya field dari AI.',
  'docpabean.extraction.empty.filtered': 'Tidak ada yang cocok dengan filter di tab ini.',
  'docpabean.extraction.notAvailable': 'Rincian ekstraksi tidak tersedia untuk draft ini.',
  'docpabean.extraction.error.title': 'Hasil ekstraksi gagal dimuat',
  'docpabean.extraction.error.retry': 'Coba lagi',
  'docpabean.extraction.excel.error': 'File Excel gagal dibuat. Coba lagi.',
  'docpabean.extraction.excel.summary': 'Ringkasan',
  'docpabean.extraction.excel.ajuNo': 'No. Aju',
  'docpabean.extraction.excel.processId': 'Process ID',
  'docpabean.extraction.excel.extractedAt': 'Diekstraksi pada',
  'docpabean.extraction.excel.downloadedAt': 'Diunduh pada',
  'docpabean.extraction.excel.downloadedBy': 'Diunduh oleh',
  'docpabean.extraction.excel.tab': 'Tab',
  'docpabean.extraction.excel.changedFields': 'Field diubah',
  'docpabean.extraction.excel.changedRows': 'Baris diubah',
  'docpabean.extraction.excel.notes': 'Catatan',
  'docpabean.extraction.excel.ai': 'AI',
  'docpabean.extraction.excel.current': 'saat ini',
  'docpabean.extraction.excel.yes': 'Ya',
  'docpabean.extraction.excel.no': 'Tidak',
  'docpabean.extraction.excel.col.section': 'Bagian',
  'docpabean.extraction.excel.col.field': 'Field',
  'docpabean.extraction.excel.col.required': 'Wajib',
  'docpabean.extraction.excel.col.ai': 'Nilai AI',
  'docpabean.extraction.excel.col.current': 'Nilai saat ini',
  'docpabean.extraction.excel.col.changed': 'Diubah (Ya/Tidak)',
  'docpabean.extraction.excel.col.status': 'Status',
  'docpabean.extraction.excel.col.sourceFile': 'Sumber dokumen (file)',
  'docpabean.extraction.excel.col.documentType': 'Jenis dokumen',
  'docpabean.extraction.excel.col.sectionId': 'Bagian dokumen (sectionId)',
  'docpabean.extraction.excel.col.role': 'Peran (utama/cadangan)',

  // Konsistensi Dokumen — Document Consistency Matrix (src/features/draft-consistency)
  'docpabean.consistency.button': 'Konsistensi Dokumen',
  'docpabean.consistency.title': 'Konsistensi Dokumen',
  'docpabean.consistency.badge': 'Temuan antar dokumen: {critical} critical, {high} high, {medium} medium',
  'docpabean.consistency.builtAt': 'Dibuat {date}',
  'docpabean.consistency.download': 'Unduh Excel',
  'docpabean.consistency.downloading': 'Menyiapkan Excel…',
  'docpabean.consistency.excel.error': 'Excel gagal dibuat. Coba lagi.',
  'docpabean.consistency.notAvailable': 'Matriks konsistensi tidak tersedia untuk draft ini.',
  'docpabean.consistency.error.title': 'Matriks konsistensi tidak dapat dimuat.',
  'docpabean.consistency.error.retry': 'Coba lagi',
  'docpabean.consistency.footnote':
    '`-` berarti nilai tidak terbaca dari dokumen tersebut atau dokumen tidak mencantumkannya. Hasil ini hanya informasi dan tidak menghalangi pengiriman.',
  'docpabean.consistency.document': 'Dokumen',
  'docpabean.consistency.openDocument': 'lihat PDF di samping tabel',
  'docpabean.consistency.goToField': 'Cek di form',
  'docpabean.consistency.columns.move': 'Seret untuk memindahkan kolom ke kiri atau kanan',
  'docpabean.consistency.columns.moveLeft': 'Pindah ke kiri',
  'docpabean.consistency.columns.moveRight': 'Pindah ke kanan',
  'docpabean.consistency.columns.resetOrder': 'Urutan awal',
  'docpabean.consistency.columns.orderNote': 'Seret ikon ⋮⋮ di judul kolom, atau pakai panah, untuk mengubah urutan.',
  'docpabean.consistency.columns.resetSizes': 'Atur ulang ukuran',
  'docpabean.consistency.columns.sizesNote': 'Seret tepi kolom atau baris untuk mengubah ukurannya.',
  'docpabean.consistency.resize.column':
    'Ubah lebar kolom: seret, atau panah kiri/kanan. Klik dua kali untuk ukuran awal.',
  'docpabean.consistency.resize.row':
    'Ubah tinggi baris: seret, atau panah atas/bawah. Klik dua kali untuk ukuran awal.',
  'docpabean.consistency.sheet.toFill': '🔴 Perlu diisi',
  'docpabean.consistency.sheet.toFillShort': 'Perlu diisi',
  'docpabean.consistency.sheet.toggle': 'Klik untuk membuka atau menutup bagian ini',
  'docpabean.consistency.sheet.expandAll': 'Buka semua',
  'docpabean.consistency.sheet.collapseAll': 'Tutup semua',
  'docpabean.consistency.sheet.count.fields': '{n} field',
  'docpabean.consistency.sheet.count.ok': '{n} sesuai',
  'docpabean.consistency.sheet.count.problem': '{n} bermasalah',
  'docpabean.consistency.sheet.count.review': '{n} perlu dicek',
  'docpabean.consistency.status.ok': 'Sesuai',
  'docpabean.consistency.status.review': 'Perlu dicek',
  'docpabean.consistency.status.mismatch': 'Tidak sesuai',
  'docpabean.consistency.status.required': 'Wajib diisi',
  'docpabean.consistency.status.empty': 'Kosong',
  'docpabean.consistency.status.notCompared': 'Tidak dibandingkan',
  'docpabean.consistency.status.detail.oneDocument': 'Sesuai dengan satu-satunya dokumen',
  'docpabean.consistency.sheet.sameAsAi': 'Sama dengan hasil AI',
  'docpabean.consistency.sheet.differsFromAi': 'Berbeda dengan hasil AI',
  'docpabean.consistency.sheet.filledManually': 'Diisi manual, AI tidak mengambil nilai',
  'docpabean.consistency.sheet.empty': 'Cek manual apakah perlu diisi',
  'docpabean.consistency.sheet.requiredEmpty': 'Masih kosong, perlu diisi',
  'docpabean.consistency.sheet.ceisa': 'Dihitung oleh CEISA',
  'docpabean.consistency.sheet.notInForm': 'Tidak ada di form',
  'docpabean.consistency.sheet.lineAdded': 'Ada di PIB, tidak ada di hasil AI',
  'docpabean.consistency.sheet.lineRemoved': 'Ada di hasil AI, tidak ada di PIB',
  'docpabean.consistency.sheet.barangLine': 'Barang',
  'docpabean.consistency.sheet.sourceCell': 'Sumber AI',
  'docpabean.consistency.sheet.sourceHint':
    'Hasil AI untuk field ini diambil dari dokumen ini. Klik untuk melihat PDF.',
  'docpabean.consistency.sheet.partial':
    'Daftar lengkap field PIB memerlukan Hasil Ekstraksi, yang belum aktif untuk draft ini. Yang tampil hanya field yang dibandingkan antar dokumen.',
  'docpabean.consistency.excel.chooseTitle': 'Dokumen yang disertakan di Excel',
  'docpabean.consistency.excel.chooseNote': 'Field, PIB saat ini, Diambil AI dan Hasil selalu disertakan.',
  'docpabean.consistency.excel.selectAll': 'Pilih semua',
  'docpabean.consistency.excel.selectNone': 'Kosongkan',
  'docpabean.consistency.excel.confirm': 'Unduh',
  'docpabean.consistency.excel.documents': 'Dokumen di file ini',
  'docpabean.consistency.excel.col.status': 'Status',
  'docpabean.consistency.excel.col.reason': 'Keterangan',
  'docpabean.consistency.excel.perTab': 'Hasil per tab',
  'docpabean.consistency.excel.statusCounts': 'Jumlah per status',
  'docpabean.consistency.excel.howTo': 'Cara membaca',
  'docpabean.consistency.excel.sheets': 'Lembar di file ini',
  'docpabean.consistency.excel.nothingToCheck': 'Tidak ada field yang perlu dicek.',
  'docpabean.consistency.excel.legend.ok': 'Nilai PIB sesuai dengan dokumen atau dengan hasil AI.',
  'docpabean.consistency.excel.legend.review':
    'Nilai PIB berbeda dengan hasil AI, atau ada perbedaan kecil antar dokumen. Periksa kembali.',
  'docpabean.consistency.excel.legend.mismatch':
    'Dokumen tidak cocok satu sama lain atau dengan PIB. Merah = Critical, oranye = High.',
  'docpabean.consistency.excel.legend.required': 'Field wajib di PIB masih kosong dan perlu diisi.',
  'docpabean.consistency.excel.legend.empty': 'Field tidak wajib dan masih kosong. Cek apakah perlu diisi.',
  'docpabean.consistency.excel.legend.notCompared':
    'Tidak ada pembanding: diisi manual, dihitung CEISA, tidak ada di form, atau hanya satu dokumen.',
  'docpabean.consistency.excel.legend.source': 'Dokumen tempat AI mengambil nilai field tersebut.',
  'docpabean.consistency.excel.legend.sheets':
    'Perlu Dicek: hanya field yang perlu ditindaklanjuti. Matriks: semua field PIB. Temuan: satu baris per temuan.',
  'docpabean.consistency.excel.col.tab': 'Tab',
  'docpabean.consistency.excel.col.section': 'Bagian',
  'docpabean.consistency.split.width': 'Seret untuk membagi lebar tabel dan PDF. Klik dua kali untuk ukuran awal.',
  'docpabean.consistency.split.height': 'Seret untuk mengubah tinggi daftar temuan. Klik dua kali untuk ukuran awal.',
  'docpabean.consistency.pdf.show': 'Tampilkan PDF',
  'docpabean.consistency.pdf.shown': 'Sedang ditampilkan di samping',
  'docpabean.consistency.pdf.previous': 'Dokumen sebelumnya',
  'docpabean.consistency.pdf.next': 'Dokumen berikutnya',
  'docpabean.consistency.pdf.newTab': 'Buka di tab baru',
  'docpabean.consistency.pdf.close': 'Tutup PDF',
  'docpabean.consistency.pdf.notPdf': 'Pratinjau hanya untuk PDF. Buka file ini di tab baru.',
  'docpabean.consistency.columns.button': 'Kolom ({shown}/{total})',
  'docpabean.consistency.columns.title': 'Tampilkan kolom',
  'docpabean.consistency.columns.showAll': 'Tampilkan semua',
  'docpabean.consistency.columns.note': 'Field dan Hasil selalu tampil. Unduh Excel tetap berisi semua kolom.',
  'docpabean.consistency.legend.derived': 'Dijumlah dari baris barang',
  'docpabean.consistency.legend.reference': 'Abu-abu: hanya referensi, tidak dibandingkan',
  'docpabean.consistency.fullScreen': 'Layar penuh',
  'docpabean.consistency.exitFullScreen': 'Keluar dari layar penuh',
  'docpabean.consistency.goToFieldHint': 'Tutup matriks dan tunjukkan field ini di form PIB',
  'docpabean.consistency.openCellDocument': 'Lihat PDF dokumen ini di samping tabel',
  'docpabean.consistency.unreadableBadge': 'Tidak terbaca',
  'docpabean.consistency.column.field': 'Field',
  'docpabean.consistency.column.ai': 'Diambil AI',
  'docpabean.consistency.column.pib': 'PIB saat ini',
  'docpabean.consistency.column.result': 'Hasil',
  'docpabean.consistency.column.severity': 'Severity',
  'docpabean.consistency.result.match': 'Cocok dengan dokumen',
  'docpabean.consistency.result.single_source': 'Hanya satu dokumen mencantumkan',
  'docpabean.consistency.result.no_data': 'Tidak ada data dari dokumen',
  'docpabean.consistency.severity.critical': '🔴 Critical — perlu dicek',
  'docpabean.consistency.severity.high': '🟠 High — review',
  'docpabean.consistency.severity.medium': '🟡 Medium — review',
  'docpabean.consistency.severity.short.critical': 'Critical',
  'docpabean.consistency.severity.short.high': 'High',
  'docpabean.consistency.severity.short.medium': 'Medium',
  'docpabean.consistency.aiDiffers': '≠ dokumen',
  'docpabean.consistency.cell.derived': 'Dijumlah dari baris barang',
  'docpabean.consistency.cell.reference': 'Hanya sebagai referensi, tidak dibandingkan',
  'docpabean.consistency.cell.supporting': 'Pendukung: dapat menguatkan, tidak dianggap berbeda',
  'docpabean.consistency.note.inside_total_offset':
    'Harga barang = total invoice dikurangi freight, asuransi, dan biaya di dalam invoice',
  'docpabean.consistency.note.offset_unknown': 'Total invoice tidak terbaca; tidak dibandingkan',
  'docpabean.consistency.note.lcl': 'LCL: tidak ada peti kemas yang diberitahukan',
  'docpabean.consistency.finding.none': 'Tidak ada temuan — nilai pada semua dokumen konsisten.',
  'docpabean.consistency.finding.requiredEmpty': 'tidak dicantumkan di dokumen mana pun',
  'docpabean.consistency.finding.stale': 'sebagian hasil baca berasal dari proses lain dan diabaikan',
  'docpabean.consistency.finding.pib': 'PIB',
  'docpabean.consistency.finding.documents': 'dokumen',
  'docpabean.consistency.finding.live': 'dari nilai PIB saat ini',
  'docpabean.consistency.unreadable.not_read': 'dokumen tidak terbaca',
  'docpabean.consistency.unreadable.unsupported_format': 'format file tidak didukung',
  'docpabean.consistency.unreadable.not_extracted': 'isi dokumen tidak dapat diekstrak',
  'docpabean.consistency.unreadable.no_sections': 'tidak ada bagian dokumen yang ditemukan',
  'docpabean.consistency.excel.col.code': 'Kode',
  'docpabean.consistency.excel.col.document': 'Dokumen',
  'docpabean.consistency.excel.col.detail': 'Keterangan',
  'docpabean.consistency.excel.summary.item': 'Keterangan',
  'docpabean.consistency.excel.summary.value': 'Nilai',
  'docpabean.consistency.excel.ajuNo': 'No. Aju',
  'docpabean.consistency.excel.processId': 'Process ID',
  'docpabean.consistency.excel.builtAt': 'Dibuat pada',
  'docpabean.consistency.excel.downloadedAt': 'Diunduh pada',
  'docpabean.consistency.excel.downloadedBy': 'Diunduh oleh',
  'docpabean.consistency.excel.note': 'Catatan',
  'docpabean.consistency.row.quantity': 'Quantity',
  'docpabean.consistency.row.packages': 'Package',
  'docpabean.consistency.row.gross_weight': 'Gross Weight',
  'docpabean.consistency.row.net_weight': 'Net Weight',
  'docpabean.consistency.row.seller': 'Seller / Exporter',
  'docpabean.consistency.row.importer': 'Importer / Consignee',
  'docpabean.consistency.row.transport_doc_no': 'B/L / AWB Number',
  'docpabean.consistency.row.currency': 'Currency',
  'docpabean.consistency.row.total_value': 'Total Value',
  'docpabean.consistency.row.incoterm': 'Incoterm',
  'docpabean.consistency.row.containers': 'Container',
  'docpabean.consistency.row.description': 'Description',
  'docpabean.consistency.code.QUANTITY_MISMATCH': 'QUANTITY MISMATCH',
  'docpabean.consistency.code.PACKAGE_MISMATCH': 'PACKAGE MISMATCH',
  'docpabean.consistency.code.WEIGHT_MISMATCH': 'WEIGHT MISMATCH',
  'docpabean.consistency.code.SELLER_MISMATCH': 'SELLER MISMATCH',
  'docpabean.consistency.code.IMPORTER_MISMATCH': 'IMPORTER MISMATCH',
  'docpabean.consistency.code.BL_NUMBER_MISMATCH': 'B/L NUMBER MISMATCH',
  'docpabean.consistency.code.CURRENCY_MISMATCH': 'CURRENCY MISMATCH',
  'docpabean.consistency.code.TOTAL_VALUE_MISMATCH': 'TOTAL VALUE MISMATCH',
  'docpabean.consistency.code.INCOTERM_MISMATCH': 'INCOTERM MISMATCH',
  'docpabean.consistency.code.CONTAINER_MISMATCH': 'CONTAINER MISMATCH',
  'docpabean.consistency.code.DESCRIPTION_MISMATCH': 'DESCRIPTION MISMATCH',
  'docpabean.consistency.code.UNREADABLE_DOCUMENT': 'Dokumen tidak terbaca',
  'docpabean.consistency.code.GROSS_LT_NET': 'Gross weight < net weight',
  'docpabean.consistency.code.REQUIRED_EMPTY': 'Data wajib kosong',
  'docpabean.consistency.code.STALE_READING': 'Hasil baca diabaikan',
  'docpabean.consistency.code.PIB_DIFFERS': 'PIB berbeda dengan dokumen',
  'docpabean.consistency.code.DUPLICATE_DOCUMENT': 'Dokumen ganda',
  'docpabean.consistency.code.DESCRIPTION_SLIGHTLY_DIFFERENT': 'Deskripsi sedikit berbeda',
  'docpabean.consistency.code.FORMAT_DIFFERS': 'Format berbeda',
  'docpabean.consistency.code.DATE_UNUSUAL': 'Tanggal tidak wajar',
  'docpabean.consistency.code.HISTORICAL_VALUE_UNUSUAL': 'Nilai historis tidak wajar',

  // CCN (CUBEforall) workspace — /ccn/*
  'ccn.product': 'Inward Manifest (AWB)',
  'ccn.logout': 'Keluar',
  'ccn.language': 'Bahasa',
  'ccn.inbox.title': 'Inward Manifest dari CUBEforall',
  'ccn.inbox.subtitle':
    'AWB yang dikirim ke JARVIS dari CUBEforall. Buka untuk menyusun draft, lalu kirim kembali ke CCN.',
  'ccn.inbox.subtitleCompany':
    'AWB yang dikirim untuk {company}. Buka untuk menyusun draft, lalu kirim kembali ke CCN.',
  'ccn.inbox.search': 'Cari AWB / HAWB / email',
  'ccn.inbox.refresh': 'Muat ulang daftar',
  'ccn.inbox.loadError': 'Gagal memuat daftar dokumen CCN.',
  'ccn.inbox.retry': 'Coba lagi',
  'ccn.inbox.emptyTitle': 'Belum ada AWB yang dikirim ke JARVIS.',
  'ccn.inbox.emptyBody':
    'Pilih satu AWB di CUBEforall lalu klik Send to JARVIS. Dokumen akan muncul di sini dalam beberapa detik.',
  'ccn.inbox.col.awb': 'AWB',
  'ccn.inbox.col.hawb': 'HAWB',
  'ccn.inbox.col.route': 'Rute',
  'ccn.inbox.col.sentBy': 'Dikirim oleh',
  'ccn.inbox.col.received': 'Diterima',
  'ccn.inbox.col.status': 'Status',
  'ccn.inbox.staleBadge': 'Versi baru',
  'ccn.inbox.staleHint': 'CCN mengirim versi baru setelah draft dibuat',
  'ccn.inbox.resync': 'Muat ulang dari CCN',
  'ccn.inbox.resyncOk': 'AWB {awb} dimuat ulang dari CCN.',
  'ccn.inbox.resyncFail': 'Gagal memuat ulang dari CCN',
  'ccn.inbox.open': 'Buka',
  'ccn.inbox.view': 'Lihat',
  'ccn.status.RECEIVED': 'Diterima',
  'ccn.status.FETCHING': 'Mengambil data',
  'ccn.status.DRAFTED': 'Draft siap',
  'ccn.status.FETCH_FAILED': 'Gagal mengambil',
  'ccn.status.MAP_FAILED': 'Gagal memetakan',
  'ccn.status.SUBMITTING': 'Mengirim ke CCN',
  'ccn.status.SUBMITTED': 'Terkirim ke CCN',
  'ccn.status.SUBMIT_FAILED': 'Gagal kirim',
  'ccn.open.preparing': 'Mengambil AWB dari CUBEforall dan menyiapkan draft…',
  'ccn.open.failed': 'Dokumen CCN tidak dapat dibuka',
  'ccn.open.toInbox': 'Ke daftar AWB',
  'ccn.callback.checking': 'Memeriksa sesi CUBEforall…',
  'ccn.callback.redirecting': 'Mengalihkan ke login CUBEforall…',
  'ccn.callback.exchanging': 'Menyiapkan sesi JARVIS…',
  'ccn.callback.prompt': 'Masuk dengan akun CUBEforall Anda untuk membuka Inward Manifest di JARVIS.',
  'ccn.callback.exchangeFailed': 'Pertukaran sesi CUBEforall gagal',
  'ccn.sso.inactive':
    'Akses ditolak: langganan CUBEforall Anda belum aktif untuk JARVIS. Hubungi CCN untuk mengaktifkannya.',
  'ccn.sso.inactiveRedirect':
    'Perusahaan Anda belum berlangganan JARVIS di CUBEforall. Anda akan diarahkan ke halaman JARVIS di CUBEforall untuk berlangganan.',
  'ccn.sso.openProductPage': 'Buka halaman JARVIS di CUBEforall',
  'ccn.submit.title': 'Kirim manifest ke CUBEforall',
  'ccn.submit.body':
    'Manifest inward ini (sesuai yang tersimpan di setiap tab) dibuat sebagai dokumen di CUBEforall. Tidak ada yang dikirim ke CEISA.',
  'ccn.submit.staleTitle': 'CCN mengirim versi baru',
  'ccn.submit.staleBody': 'Versi terbaru dari CCN belum dimuat ke draft ini. Kirim dengan data yang ada?',
  'ccn.submit.staleAck': 'Ya, kirim draft ini apa adanya',
  'ccn.submit.cancel': 'Batal',
  'ccn.submit.send': 'Kirim ke CUBEforall',
  'ccn.submit.sending': 'Membuat dokumen di CUBEforall…',
  'ccn.incomplete.body': 'Deklarasi belum bisa dikirim ke CCN. Lengkapi {count} kolom wajib berikut terlebih dahulu.',
  // ---- Editor manifest: kelengkapan data ----
  'manifestEditor.completeness.title': 'Data Belum Lengkap ({count})',
  'manifestEditor.completeness.body':
    'Manifest belum bisa didorong ke CEISA. Lengkapi {count} kolom wajib berikut terlebih dahulu.',
  'manifestEditor.completeness.goToTab': 'Ke tab →',
  'manifestEditor.completeness.close': 'Tutup',
  'manifestEditor.noAccess': 'Manifest ini tidak dapat dibuka dengan akun ini.',
  'manifestEditor.completeness.rowBadge': 'Belum lengkap ({count})',
  'manifestEditor.completeness.tabTooltip': '{count} data belum lengkap',
  'manifestEditor.completeness.tabComplete': 'Data lengkap',
  'manifestEditor.completeness.panelTitle': '{count} data belum lengkap di tab ini',
  'manifestEditor.completeness.panelHint': 'Lengkapi sebelum Submit Draft. Klik salah satu untuk langsung ke kolomnya.',
  'manifestEditor.completeness.panelJump': 'Lihat →',
  'manifestEditor.completeness.itemJump': 'Lihat',
  'manifestEditor.completeness.startFixing': 'Mulai perbaiki',
  'manifestEditor.completeness.panelShowAll': 'Tampilkan semua ({count})',
  'manifestEditor.completeness.panelShowLess': 'Tampilkan lebih sedikit',
  'manifestEditor.completeness.panelHide': 'Sembunyikan',
  'manifestEditor.completeness.panelShow': 'Tampilkan',
  'manifestEditor.completeness.statusColumn': 'Status',

  // ---- PIB draft editor: "Data Belum Lengkap" submit gate ----
  'pibEditor.completeness.title': 'Data Belum Lengkap ({count})',
  'pibEditor.completeness.body':
    'PIB belum bisa didorong ke CEISA. Lengkapi {count} kolom wajib berikut terlebih dahulu.',
  'pibEditor.completeness.goToTab': 'Ke tab →',
  'pibEditor.completeness.itemJump': 'Lihat',
  'pibEditor.completeness.close': 'Tutup',
  'pibEditor.completeness.startFixing': 'Mulai perbaiki',

  // ---- PEB draft editor: "Data Belum Lengkap" submit gate ----
  'pebEditor.completeness.title': 'Data Belum Lengkap ({count})',
  'pebEditor.completeness.body':
    'PEB belum bisa didorong ke CEISA. Lengkapi {count} kolom wajib berikut terlebih dahulu.',
  'pebEditor.completeness.goToTab': 'Ke tab →',
  'pebEditor.completeness.itemJump': 'Lihat',
  'pebEditor.completeness.close': 'Tutup',
  'pebEditor.completeness.startFixing': 'Mulai perbaiki',
  'pebEditor.ownerDiffers.inlineWarning':
    'Data Pemilik Barang berbeda dengan data Eksportir. Hal ini diperbolehkan, namun mohon pastikan data tersebut telah sesuai.',
  'pebEditor.ownerDiffers.viewOwners': 'Lihat Pemilik Barang',
  'pebEditor.ownerDiffers.rowChip': 'Berbeda dari Eksportir',
  'pebEditor.ownerDiffers.modalTitle': 'Eksportir dan Pemilik Barang Berbeda',
  'pebEditor.ownerDiffers.modalBody':
    'Data Pemilik Barang pada PEB ini berbeda dengan data Eksportir. Hal ini diperbolehkan, namun mohon pastikan data tersebut telah sesuai sebelum dikirim ke CEISA.',
  'pebEditor.ownerDiffers.eksportirLabel': 'Eksportir',
  'pebEditor.ownerDiffers.ownerLabel': 'Pemilik Barang {seri}',
  'pebEditor.ownerDiffers.name': 'Nama',
  'pebEditor.ownerDiffers.npwp': 'NPWP',
  'pebEditor.ownerDiffers.confirm': 'Ya, Data Sudah Sesuai',
  'pebEditor.ownerDiffers.review': 'Periksa Kembali',
  'pebEditor.owners.saved': 'Data Pemilik Barang telah disimpan.',
  'pebEditor.barangPemilik.auto': 'Otomatis',
  'pebEditor.barangPemilik.autoHint':
    'Belum ada pemilik yang dipilih untuk barang ini, jadi barang ini milik semua Pemilik Barang di tab Entitas.',
  'pebEditor.barangPemilik.resetToAuto': 'Kembalikan ke otomatis',
  'pebEditor.barangPemilik.ownerNotFound': 'Pemilik tidak ditemukan',
  'pebEditor.barangPemilik.jenisPemilik': 'PEMILIK',
  'pebEditor.barangPemilik.danglingLabel': 'Pemilik Barang',
  'pebEditor.barangPemilik.danglingIssue':
    'Pemilik barang (entitas seri {seri}) tidak ada di tab Entitas. Pilih ulang pemilik barang ini.',
  'pebEditor.barangPemilik.emptyIssue':
    'Barang ini belum memiliki pemilik. Tambah pemilik atau kembalikan ke otomatis.',
  'pebEditor.barangPemilik.noOwner':
    'Barang ini belum memiliki pemilik. Tambah pemilik dari daftar di atas, atau kembalikan ke otomatis.',
  'pebEditor.barangPemilik.addNewHint': 'Belum ada Pemilik Barang di tab Entitas. Isi pemilik baru di sini.',
  'pebEditor.barangPemilik.editOwner': 'Ubah data pemilik (berlaku di tab Entitas dan semua barang)',
  'pebEditor.barangPemilik.title': 'Pemilik Barang',
  'pebEditor.barangPemilik.singleOwnerHint': 'Satu PEB hanya boleh memiliki 1 Pemilik Barang.',
  'pebEditor.barangPemilik.copyEksportirHint': 'Data Pemilik Barang akan ditimpa dengan data Eksportir.',
  'pebEditor.barangPemilik.tooManyOwnersIssue': 'Hanya boleh ada 1 Pemilik Barang. Hapus pemilik lainnya.',
  'pebEditor.barangPemilik.tooManyBarangIssue': 'Barang hanya boleh memiliki 1 pemilik. Hapus pemilik lainnya.',
  'ccn.submit.doneTitle': 'Terkirim ke CUBEforall',
  'ccn.submit.doneBody': 'Manifest tersimpan sebagai dokumen di kotak CUBEforall perusahaan Anda.',
  'ccn.submit.doneId': 'ID dokumen: {id}',
  'ccn.submit.failedTitle': 'Belum terkirim',
  'ccn.submit.rejected': 'CCN menolak dokumen',
  'ccn.submit.timeout': 'CCN belum menjawab. Status akan diperbarui di daftar AWB.',
  'ccn.submit.failed': 'Gagal mengirim ke CCN',
  'ccn.submit.close': 'Tutup',
  'ccn.submit.retry': 'Coba lagi',
  'ccn.submit.subtitle': 'Manifest inward udara (BC 1.1)',
  'ccn.submit.awb': 'AWB',
  'ccn.submit.hawb': 'Host AWB',
  'ccn.submit.route': 'Rute',
  'ccn.submit.sender': 'Dikirim oleh',
  'ccn.submit.destination': 'Disimpan ke',
  'ccn.submit.destinationValue': '{company} di CUBEforall',
  'ccn.submit.destinationFallback': 'Kotak CUBEforall perusahaan Anda',
  'ccn.submit.whatHappens': 'Yang terjadi',
  'ccn.submit.step1': 'JARVIS membuat manifest ini sebagai dokumen di kotak CUBEforall perusahaan Anda.',
  'ccn.submit.step2': 'Mengirim ulang nanti memperbarui dokumen yang sama, bukan membuat dokumen baru.',
  'ccn.submit.step3': 'Tidak dilaporkan ke Bea Cukai (CEISA). Pelaporan BC 1.1 tetap langkah terpisah.',
  'ccn.submit.sendingHint': 'Biasanya hanya beberapa detik.',
  'ccn.submit.backToList': 'Kembali ke daftar AWB',
  'ccn.submit.copy': 'Salin',
  'ccn.submit.copied': 'Tersalin',
  'ccn.submit.details': 'Detail teknis',
  'ccn.editor.staleBadge': 'Versi baru dari CCN',
  'ccn.merge.conflictTitle': '{n} kolom perlu Anda putuskan',
  'ccn.merge.conflictBody': 'CCN mengirim versi baru dengan nilai berbeda dari yang sudah Anda ubah. Draft tetap memakai nilai Anda sampai Anda memilih.',
  'ccn.merge.yours': 'Milik Anda',
  'ccn.merge.keepMine': 'Tetap pakai milik saya',
  'ccn.merge.useCcn': 'Pakai nilai CCN',
  'ccn.merge.resolveFailed': 'Pilihan belum tersimpan, coba lagi',
  'ccn.merge.updatedTitle': '{n} kolom diperbarui dari versi baru CCN',
  'ccn.merge.updatedBody': 'CCN mengirim versi baru pada {date}. Kolom yang belum Anda ubah sudah mengikuti versi tersebut.',
  'ccn.merge.showChanges': 'Lihat perubahan',
  'ccn.merge.hideChanges': 'Sembunyikan perubahan',
  'ccn.merge.dismiss': 'Tutup',
  'ccn.merge.header': 'Header',
  'ccn.merge.wholeHouse': 'Baris HAWB',
  'ccn.merge.housePresent': 'Ada di draft',
  'ccn.merge.houseAbsent': 'Dihapus',
  'ccn.inbox.conflictBadge': '{n} perlu dicek',
  'ccn.inbox.conflictHint': 'CCN mengirim versi baru yang berbeda dari perubahan Anda',
  'ccn.submit.conflictTitle': '{n} kolom belum diputuskan',
  'ccn.submit.conflictBody': 'Versi baru dari CCN berbeda dengan perubahan Anda di beberapa kolom. Draft akan dikirim dengan nilai Anda.',
  'ccn.merge.field.namaSaranaPengangkut': 'Nama sarana pengangkut',
  'ccn.merge.field.nomorVoyage': 'Nomor penerbangan',
  'ccn.merge.field.tanggalTiba': 'Tanggal tiba',
  'ccn.merge.field.imoNumber': 'Kode maskapai',
  'ccn.merge.field.kodeNegara': 'Negara asal',
  'ccn.merge.field.tanggalBl': 'Tanggal MAWB',
  'ccn.merge.field.tanggalHostBl': 'Tanggal HAWB',
  'ccn.merge.field.namaPengirim': 'Nama pengirim',
  'ccn.merge.field.alamatPengirim': 'Alamat pengirim',
  'ccn.merge.field.namaPenerima': 'Nama penerima',
  'ccn.merge.field.alamatPenerima': 'Alamat penerima',
  'ccn.merge.field.npwpPenerima': 'NPWP penerima',
  'ccn.merge.field.namaNotify': 'Nama notify',
  'ccn.merge.field.alamatNotify': 'Alamat notify',
  'ccn.merge.field.berat': 'Berat (kg)',
  'ccn.merge.field.dimensi': 'Volume (m³)',
  'ccn.merge.field.jumlahKemasan': 'Jumlah kemasan',
  'ccn.merge.field.jenisKemasan': 'Jenis kemasan',
  'ccn.merge.field.kodePelabuhanAsal': 'Pelabuhan asal',
  'ccn.merge.field.kodePelabuhanBongkar': 'Pelabuhan bongkar',
  'ccn.merge.field.kodePelabuhanAkhir': 'Pelabuhan akhir',
  'ccn.merge.field.goods': 'Barang',

  // ---- Shipping Instruction (export upload + PEB Document tab) ----
  'upload.siGuide.link': 'Apa itu Shipping Instruction?',
  'upload.siGuide.heading': 'Baru di upload ekspor',
  'upload.siGuide.what.title': 'Shipping Instruction punya jenisnya sendiri',
  'upload.siGuide.what.body':
    'Instruksi pengiriman dari forwarder — biasanya e-mail berisi DEST, ETD, MAWB/HAWB, QTY, INV dan FLIGHT — kini bisa diunggah sebagai Shipping Instruction. Tidak perlu lagi mengunggahnya sebagai AWB.',
  'upload.siGuide.pick.title': 'Pilih "000 - Shipping Instruction"',
  'upload.siGuide.pick.body':
    'Di kolom jenis dokumen, ketik "si" atau "000" lalu pilih 000 - Shipping Instruction. "Deteksi semua" juga mengenalinya sendiri dari isi berkasnya, walaupun berkas itu tidak punya judul.',
  'upload.siGuide.fills.title': 'Dibaca untuk mengisi draft PEB',
  'upload.siGuide.fills.body':
    'Jarvis membaca sarana pengangkut (flight atau kapal), pelabuhan, tanggal perkiraan ekspor, serta jumlah dan jenis kemasan, lalu mengisikannya ke tab Header, Pengangkut dan Kemasan.',
  'upload.siGuide.notSent.title': 'Tidak dikirim ke CEISA',
  'upload.siGuide.notSent.body':
    'Shipping Instruction bukan dokumen pabean, jadi tidak masuk ke tabel dokumen dan tidak dikirim ke CEISA — tidak ada lagi baris yang harus dihapus. Berkasnya tetap bisa dilihat di bagian bawah tab Document, beserta kolom yang dibaca darinya.',
  'upload.siGuide.back': 'Kembali',
  'upload.siGuide.next': 'Lanjut',
  'upload.siGuide.done': 'Mengerti',
  'export.si.title': 'Dokumen referensi',
  'export.si.notSent': 'Tidak dikirim ke CEISA',
  'export.si.hint':
    'Shipping Instruction dibaca untuk membantu mengisi draft, tetapi bukan dokumen pabean: tidak masuk ke tabel dokumen di atas dan tidak dikirim ke CEISA.',
  'export.si.view': 'Lihat',
  'export.si.hide': 'Tutup PDF',
  'export.si.loading': 'Memuat rincian…',
  'export.si.sourceFor': 'Dibaca sebagai sumber untuk kolom berikut:',
  'export.si.sourceForNote':
    'Kolom yang juga tercetak di dokumen lain (mis. packing list) bisa saja terisi dari dokumen tersebut.',
  'export.si.sourceForNone': 'Tidak ada kolom yang terisi dari dokumen ini pada ekstraksi ini.',
  'export.si.sourceForGeneral':
    'Isinya dipakai untuk membantu mengisi tab Header, Entitas, Pengangkut, serta Kemasan & Peti Kemas.',
  'export.si.field.exportLoadPort': 'Pelabuhan Muat Ekspor',
  'export.si.field.exportirName': 'Nama Eksportir',
  'export.si.field.exportirAddress': 'Alamat Eksportir',
  'export.si.field.exportirIdentity': 'Nomor Identitas Eksportir',
  'export.si.field.exportirIdentityType': 'Jenis Identitas Eksportir',
  'export.si.field.recipientName': 'Nama Penerima',
  'export.si.field.recipientAddress': 'Alamat Penerima',
  'export.si.field.recipientCountry': 'Negara Penerima',
  'export.si.field.meansTransportName': 'Nama Sarana Pengangkut',
  'export.si.field.voyNumber': 'Nomor Voy/Flight',
  'export.si.field.modeOfTransportation': 'Cara Pengangkutan',
  'export.si.field.estimatedExportDate': 'Tanggal Perkiraan Ekspor',
  'export.si.field.originLoadingPort': 'Pelabuhan Muat Asal',
  'export.si.field.exportLoadingPort': 'Pelabuhan Muat Ekspor',
  'export.si.field.unloadingPort': 'Pelabuhan Bongkar',
  'export.si.field.destinationPort': 'Pelabuhan Tujuan',
  'export.si.field.destinationCountry': 'Negara Tujuan',
  'export.si.field.containerNumber': 'Nomor Peti Kemas',
  'export.si.field.containerSize': 'Ukuran Peti Kemas',
  'export.si.field.containerType': 'Jenis Peti Kemas',
  'export.si.field.packageCount': 'Jumlah Kemasan',
  'export.si.field.packageType': 'Jenis Kemasan',
  // Manifest "Dari PEB (NPE)" — outward draft from NPE PEBs (next-jarvis#583)
  'manifest.fromPabean.card.title': 'Dari PEB (NPE)',
  'manifest.fromPabean.card.subtitle': 'Pilih PEB yang sudah NPE, tanpa upload & ekstraksi AI.',
  'manifest.fromPabean.preview.heading': 'Buat manifest dari PEB yang sudah NPE',
  'manifest.fromPabean.preview.pick.title': 'Pilih PEB',
  'manifest.fromPabean.preview.pick.body':
    'Centang PEB yang sudah NPE dan dimuat bersama. Urutan centang menjadi urutan pos di manifest.',
  'manifest.fromPabean.preview.create.title': 'Buat Manifest',
  'manifest.fromPabean.preview.create.body':
    'Header, house BL/AWB, kontainer, HS, dan dokumen PEB terisi otomatis dari data PEB. Tanpa upload, tanpa ekstraksi AI.',
  'manifest.fromPabean.preview.masterBl.title': 'Upload Master BL (opsional)',
  'manifest.fromPabean.preview.masterBl.body':
    'Master BL bisa diupload atau diisi manual di draft kapan saja. Draft tetap tersimpan tanpa Master BL.',
  'manifest.fromPabean.preview.dontShow': 'Jangan tampilkan lagi',
  'manifest.fromPabean.preview.back': 'Kembali',
  'manifest.fromPabean.preview.next': 'Lanjut',
  'manifest.fromPabean.preview.start': 'Mulai',
  'manifest.fromPabean.page.title': 'Buat Manifest dari PEB (NPE)',
  'manifest.fromPabean.page.subtitle': 'Pilih PEB yang dimuat bersama; satu PEB menjadi satu house BL/AWB.',
  'manifest.fromPabean.page.outward': 'Outward',
  'manifest.fromPabean.page.sea': 'Laut',
  'manifest.fromPabean.page.air': 'Udara',
  'manifest.fromPabean.page.changeProduct': 'Ganti produk',
  'manifest.fromPabean.page.guide': 'Panduan',
  'manifest.fromPabean.note.always': 'Hanya PEB yang dibuat lewat JARVIS dan sudah berstatus NPE yang tampil di sini.',
  'manifest.fromPabean.note.excluded':
    '{n} PEB NPE lain tidak tampil karena tidak dibuat lewat JARVIS — PEB tersebut bisa ditambahkan dari dalam draft lewat',
  'manifest.fromPabean.note.susulan': 'Upload PEB Susulan',
  'manifest.fromPabean.note.susulanTip':
    'Tombol "Upload PEB / BL Susulan" ada di tab BL pada draft manifest. Unggah PDF PEB di sana untuk menambah house BL.',
  'manifest.fromPabean.filter.dateFrom': 'Tgl daftar dari',
  'manifest.fromPabean.filter.dateTo': 'Sampai',
  'manifest.fromPabean.filter.search': 'Cari No. Aju, No. Daftar, atau Eksportir',
  'manifest.fromPabean.col.aju': 'No. Aju',
  'manifest.fromPabean.col.daftar': 'No. & Tgl Daftar',
  'manifest.fromPabean.col.npe': 'Tgl NPE',
  'manifest.fromPabean.col.exporter': 'Eksportir',
  'manifest.fromPabean.col.buyer': 'Buyer',
  'manifest.fromPabean.col.ports': 'Pelabuhan Muat → Bongkar',
  'manifest.fromPabean.col.carrier': 'Sarana / Voyage',
  'manifest.fromPabean.col.bl': 'No. BL',
  'manifest.fromPabean.col.awb': 'No. AWB',
  'manifest.fromPabean.col.containers': 'Kontainer',
  'manifest.fromPabean.col.hs': 'HS',
  'manifest.fromPabean.col.status': 'Status',
  'manifest.fromPabean.status.inDraft': 'Sudah di draft',
  'manifest.fromPabean.status.inDraftTip': 'Buka draft yang sudah memakai PEB ini. PEB tetap bisa dipilih.',
  'manifest.fromPabean.status.ready': 'Siap',
  'manifest.fromPabean.noBlTip': 'PEB ini tidak punya dokumen B/L/AWB; isi nanti di draft',
  'manifest.fromPabean.empty.title': 'Tidak ada PEB NPE yang bisa dipakai',
  'manifest.fromPabean.empty.body': 'Ubah rentang tanggal atau kata kunci pencarian.',
  'manifest.fromPabean.bar.selected': '{n} PEB dipilih',
  'manifest.fromPabean.bar.reset': 'Reset pilihan',
  'manifest.fromPabean.bar.create': 'Buat Manifest',
  'manifest.fromPabean.bar.max': 'Maksimal {max} PEB per manifest',
  'manifest.fromPabean.confirm.title': 'Buat manifest dari PEB',
  'manifest.fromPabean.confirm.mode': 'Moda',
  'manifest.fromPabean.confirm.kantor': 'Kantor pemuatan',
  'manifest.fromPabean.confirm.carrier': 'Sarana / Voyage',
  'manifest.fromPabean.confirm.houses': 'House BL/AWB',
  'manifest.fromPabean.confirm.housesValue': '{n} (satu per PEB)',
  'manifest.fromPabean.confirm.masterBl': 'Master BL',
  'manifest.fromPabean.confirm.masterBlValue': 'Belum ada — bisa diupload di draft',
  'manifest.fromPabean.confirm.firstPebNote': 'Header manifest mengikuti PEB pertama yang dipilih.',
  'manifest.fromPabean.confirm.prewarnTitle': 'Perlu diperhatikan',
  'manifest.fromPabean.confirm.cancel': 'Batal',
  'manifest.fromPabean.confirm.submit': 'Buat Manifest',
  'manifest.fromPabean.confirm.createdTitle': 'Draft dibuat dengan catatan',
  'manifest.fromPabean.confirm.createdBody': 'Draft sudah tersimpan. Periksa catatan berikut di editor:',
  'manifest.fromPabean.confirm.continue': 'Lanjut ke draft',
  'manifest.fromPabean.prewarn.vessel': 'Sarana/voyage berbeda dari PEB pertama',
  'manifest.fromPabean.prewarn.port': 'Pelabuhan muat berbeda dari PEB pertama',
  'manifest.fromPabean.prewarn.kantor': 'Kantor pemuatan berbeda dari PEB pertama',
  'manifest.fromPabean.prewarn.used': 'Sudah dipakai di draft lain',
  'manifest.fromPabean.reason.NOT_FOUND': 'PEB tidak ditemukan',
  'manifest.fromPabean.reason.NOT_PEB': 'Bukan PEB (BC 3.0)',
  'manifest.fromPabean.reason.NOT_NPE': 'Belum NPE',
  'manifest.fromPabean.reason.NO_STRUCTURED_DATA': 'Tidak dibuat lewat JARVIS',
  'manifest.fromPabean.reason.MODE_MISMATCH': 'Moda tidak sesuai',
  'manifest.fromPabean.reason.KANTOR_MISMATCH': 'Kantor pemuatan berbeda',
  'manifest.fromPabean.reason.DUPLICATE_AJU': 'Dipilih dua kali',
  'manifest.fromPabean.reason.UNKNOWN': 'Tidak bisa dipakai',
  'manifest.fromPabean.warning.VESSEL_MISMATCH': 'Sarana/voyage berbeda dari PEB pertama; header memakai PEB pertama.',
  'manifest.fromPabean.warning.LOADING_PORT_MISMATCH': 'Pelabuhan muat berbeda dari PEB pertama.',
  'manifest.fromPabean.warning.NO_BL_ON_PEB': 'PEB tidak punya dokumen B/L/AWB; nomor house BL/AWB dikosongkan.',
  'manifest.fromPabean.warning.GROSS_WEIGHT_MISSING':
    'PEB tidak punya berat kotor (KGM); Bruto Total dikosongkan, isi di editor.',
  'manifest.fromPabean.rejected.toast': 'Beberapa PEB tidak bisa dipakai. Periksa baris yang ditandai merah.',
  'manifest.fromPabean.error.create': 'Gagal membuat manifest',
  'manifest.manualDraft.error.create': 'Gagal membuat draft manifest',
  'manifest.fromPabean.error.load': 'Gagal memuat daftar PEB',
  'manifest.fromPabean.masterBl.emptyTitle': 'Belum ada Master BL',
  'manifest.fromPabean.masterBlStep.title': 'Upload {doc} (opsional)',
  'manifest.fromPabean.masterBlStep.body':
    'Kalau dokumen {doc} sudah ada, upload sekarang agar langsung diekstrak ke draft setelah dibuat. Kalau belum, lewati saja — {doc} bisa diupload atau diisi manual di draft kapan saja.',
  'manifest.fromPabean.masterBlStep.drop': 'Tarik PDF {doc} ke sini atau klik untuk memilih',
  'manifest.fromPabean.masterBlStep.hint': 'Satu file PDF, maksimal 20 MB',
  'manifest.fromPabean.masterBlStep.rejected': 'Hanya satu file PDF maksimal 20 MB.',
  'manifest.fromPabean.masterBlStep.remove': 'Hapus file',
  'manifest.fromPabean.masterBlStep.skip': 'Lewati',
  'manifest.fromPabean.masterBlStep.next': 'Lanjut',
  'manifest.fromPabean.confirm.masterBlFile': '{name} — diekstrak setelah draft dibuat',
  'manifest.fromPabean.confirm.creating': 'Membuat draft…',
  'manifest.fromPabean.confirm.extracting': 'Draft dibuat. Mengekstrak Master BL…',
  'manifest.fromPabean.confirm.masterBlFailed':
    'Draft dibuat, tetapi Master BL gagal diekstrak: {reason}. Upload ulang dari tab Master BL di draft.',
  'manifest.fromPabean.masterBl.emptyBody':
    'Master BL bisa diisi nanti. Draft tetap tersimpan. Upload dokumen Master BL atau klik Tambah Master BL.',
  // Manifest "Dari PIB (SPPB)" — inward draft from SPPB PIBs (next-jarvis#591).
  // Shared keys above serve both flows; manifest.fromPabean.inward.* holds
  // the inward wording where it differs (see copyFor in from-pabean utils).
  'manifest.fromPabean.page.inward': 'Inward',
  'manifest.fromPabean.col.sppb': 'Tgl SPPB',
  'manifest.fromPabean.col.importer': 'Importir',
  'manifest.fromPabean.col.sender': 'Pengirim (negara)',
  'manifest.fromPabean.col.bc11': 'BC 1.1 (nomor/pos)',
  'manifest.fromPabean.reason.NOT_PIB': 'Bukan PIB (BC 2.0)',
  'manifest.fromPabean.reason.NOT_SPPB': 'Belum SPPB',
  'manifest.fromPabean.warning.DISCHARGE_PORT_MISMATCH': 'Pelabuhan bongkar berbeda dari PIB pertama.',
  'manifest.fromPabean.warning.NO_BL_ON_PIB': 'PIB tidak punya dokumen B/L/AWB; nomor house BL/AWB dikosongkan.',
  'manifest.fromPabean.warning.BC11_REF_DROPPED': 'Referensi BC 1.1 asal tidak tersimpan di draft —',
  'manifest.fromPabean.warning.NO_PIB_DOC_CODE': 'Dokumen asal PIB belum terisi otomatis —',
  'manifest.fromPabean.inward.card.title': 'Dari PIB (SPPB)',
  'manifest.fromPabean.inward.card.subtitle': 'Pilih PIB yang sudah SPPB, tanpa upload & ekstraksi AI.',
  'manifest.fromPabean.inward.preview.heading': 'Buat manifest dari PIB yang sudah SPPB',
  'manifest.fromPabean.inward.preview.pick.title': 'Pilih PIB',
  'manifest.fromPabean.inward.preview.pick.body':
    'Centang PIB yang sudah SPPB dan dikonsolidasikan bersama. Urutan centang menjadi urutan pos di manifest.',
  'manifest.fromPabean.inward.preview.create.body':
    'Header, house BL/AWB, kontainer, dan HS terisi otomatis dari data PIB. Tanpa upload, tanpa ekstraksi AI.',
  'manifest.fromPabean.inward.page.title': 'Buat Manifest dari PIB (SPPB)',
  'manifest.fromPabean.inward.page.subtitle':
    'Pilih PIB yang dikonsolidasikan bersama; satu PIB menjadi satu house BL/AWB.',
  'manifest.fromPabean.inward.note.always':
    'Hanya PIB yang dibuat lewat JARVIS dan sudah berstatus SPPB yang tampil di sini.',
  'manifest.fromPabean.inward.note.excluded':
    '{n} PIB SPPB lain tidak tampil karena tidak dibuat lewat JARVIS — house BL/AWB-nya bisa ditambahkan dari dalam draft lewat',
  'manifest.fromPabean.inward.note.susulan': 'Upload BL/AWB Susulan',
  'manifest.fromPabean.inward.note.susulanTip':
    'Tombol "Upload BL/AWB Susulan" ada di tab BL pada draft manifest. Unggah PDF BL/AWB di sana untuk menambah house BL.',
  'manifest.fromPabean.inward.filter.search': 'Cari No. Aju, No. Daftar, atau Importir',
  'manifest.fromPabean.inward.status.inDraftTip': 'Buka draft yang sudah memakai PIB ini. PIB tetap bisa dipilih.',
  'manifest.fromPabean.inward.noBlTip': 'PIB ini tidak punya dokumen B/L/AWB; isi nanti di draft',
  'manifest.fromPabean.inward.empty.title': 'Tidak ada PIB SPPB yang bisa dipakai',
  'manifest.fromPabean.inward.bar.selected': '{n} PIB dipilih',
  'manifest.fromPabean.inward.bar.max': 'Maksimal {max} PIB per manifest',
  'manifest.fromPabean.inward.confirm.title': 'Buat manifest dari PIB',
  'manifest.fromPabean.inward.confirm.kantor': 'Kantor pabean',
  'manifest.fromPabean.inward.confirm.housesValue': '{n} (satu per PIB)',
  'manifest.fromPabean.inward.confirm.firstPebNote': 'Header manifest mengikuti PIB pertama yang dipilih.',
  'manifest.fromPabean.inward.prewarn.vessel': 'Sarana/voyage berbeda dari PIB pertama',
  'manifest.fromPabean.inward.prewarn.dischargePort': 'Pelabuhan bongkar berbeda dari PIB pertama',
  'manifest.fromPabean.inward.prewarn.kantor': 'Kantor pabean berbeda dari PIB pertama',
  'manifest.fromPabean.inward.reason.NOT_FOUND': 'PIB tidak ditemukan',
  'manifest.fromPabean.inward.reason.KANTOR_MISMATCH': 'Kantor pabean berbeda',
  'manifest.fromPabean.inward.warning.VESSEL_MISMATCH':
    'Sarana/voyage berbeda dari PIB pertama; header memakai PIB pertama.',
  'manifest.fromPabean.inward.warning.GROSS_WEIGHT_MISSING':
    'PIB tidak punya berat kotor (KGM); Bruto Total dikosongkan, isi di editor.',
  'manifest.fromPabean.inward.rejected.toast': 'Beberapa PIB tidak bisa dipakai. Periksa baris yang ditandai merah.',
  'manifest.fromPabean.inward.error.load': 'Gagal memuat daftar PIB',

  // ---- Penolakan /document/check CEISA (utils/ceisa-check-issues.ts) ----
  'ceisaCheck.rejected': 'Dokumen ditolak CEISA: {issues}',
  'ceisaSubmit.upstreamPpjkMismatch':
    'CEISA sedang bermasalah dan menolak pengiriman ini. Data Anda sudah benar dan tidak perlu diubah. Coba kirim lagi dalam beberapa menit.',
  'ceisaSubmit.accountPpjkMismatch':
    'Akun CEISA yang dipakai (NPWP {accountNpwp}) berbeda dengan PPJK di dokumen (NPWP {ppjkNpwp}). Periksa PPJK di tab Entitas atau hubungi admin untuk akun CEISA yang benar.',
  'ceisaCheck.sentence': '{subject} {problem}.',
  'ceisaCheck.sentenceOther': '{subject}: {text}.',
  'ceisaCheck.textOnly': '{text}.',
  'ceisaCheck.item': 'Data',
  'ceisaCheck.subjectGoods': '{field} barang seri {seris}',
  'ceisaCheck.subjectGoodsNested': '{field} {array} barang seri {seris}',
  'ceisaCheck.subjectArray': '{field} ({array} ke-{n})',
  'ceisaCheck.problem.decimals': 'maksimal {n} angka di belakang koma',
  'ceisaCheck.problem.integer': 'harus bilangan bulat',
  'ceisaCheck.problem.multiple': 'harus kelipatan {n}',
  'ceisaCheck.problem.required': 'wajib diisi',
  'ceisaCheck.problem.maxLength': 'maksimal {n} karakter',
  'ceisaCheck.problem.minLength': 'minimal {n} karakter',
  'ceisaCheck.problem.max': 'tidak boleh lebih dari {n}',
  'ceisaCheck.problem.min': 'tidak boleh kurang dari {n}',
  'ceisaCheck.problem.lessThan': 'harus kurang dari {n}',
  'ceisaCheck.problem.greaterThan': 'harus lebih dari {n}',
  'ceisaCheck.problem.date': 'format tanggalnya tidak valid',
  'ceisaCheck.problem.format': 'formatnya tidak valid',
  'ceisaCheck.problem.enum': 'nilainya tidak dikenal CEISA',
  'ceisaCheck.problem.type': 'jenis isiannya tidak sesuai',
  'ceisaCheck.field.alamatEntitas': 'Alamat entitas',
  'ceisaCheck.field.asuransi': 'Asuransi',
  'ceisaCheck.field.bruto': 'Bruto',
  'ceisaCheck.field.cif': 'CIF',
  'ceisaCheck.field.cifRupiah': 'CIF rupiah',
  'ceisaCheck.field.fob': 'FOB',
  'ceisaCheck.field.freight': 'Freight',
  'ceisaCheck.field.hargaSatuan': 'Harga satuan',
  'ceisaCheck.field.hs': 'HS',
  'ceisaCheck.field.jumlahKemasan': 'Jumlah kemasan',
  'ceisaCheck.field.jumlahSatuan': 'Jumlah satuan',
  'ceisaCheck.field.kodeDokumen': 'Kode dokumen',
  'ceisaCheck.field.kodeFasilitas': 'Kode fasilitas',
  'ceisaCheck.field.kodeJenisKemasan': 'Jenis kemasan',
  'ceisaCheck.field.kodeNegaraAsal': 'Negara asal',
  'ceisaCheck.field.kodeSatuanBarang': 'Satuan barang',
  'ceisaCheck.field.merk': 'Merek',
  'ceisaCheck.field.namaEntitas': 'Nama entitas',
  'ceisaCheck.field.ndpbm': 'NDPBM',
  'ceisaCheck.field.netto': 'Netto',
  'ceisaCheck.field.nilaiBarang': 'Nilai barang',
  'ceisaCheck.field.nomorAju': 'Nomor aju',
  'ceisaCheck.field.nomorBc11': 'Nomor BC 1.1',
  'ceisaCheck.field.nomorDokumen': 'Nomor dokumen',
  'ceisaCheck.field.nomorIdentitas': 'Nomor identitas',
  'ceisaCheck.field.nomorKontainer': 'Nomor kontainer',
  'ceisaCheck.field.posBc11': 'Pos BC 1.1',
  'ceisaCheck.field.posTarif': 'HS',
  'ceisaCheck.field.spesifikasiLain': 'Spesifikasi lain',
  'ceisaCheck.field.subposBc11': 'Subpos BC 1.1',
  'ceisaCheck.field.tanggalBc11': 'Tanggal BC 1.1',
  'ceisaCheck.field.tanggalDokumen': 'Tanggal dokumen',
  'ceisaCheck.field.tarif': 'Tarif',
  'ceisaCheck.field.tipe': 'Tipe',
  'ceisaCheck.field.ukuran': 'Ukuran',
  'ceisaCheck.field.uraian': 'Uraian',
  'ceisaCheck.field.volume': 'Volume',
  'ceisaCheck.array.barangDokumen': 'dokumen',
  'ceisaCheck.array.barangTarif': 'tarif',
  'ceisaCheck.array.dokumen': 'dokumen',
  'ceisaCheck.array.entitas': 'entitas',
  'ceisaCheck.array.kemasan': 'kemasan',
  'ceisaCheck.array.kontainer': 'kontainer',
  'ceisaCheck.array.pengangkut': 'pengangkut',
  // ---- Spesifikasi Khusus (next-jarvis#778) ----
  'editbarang.spekKhusus.required':
    'HS ini wajib Spesifikasi Khusus di CEISA (mis. Nomor CAS). Tanpa ini, barang tidak bisa disimpan di portal CEISA.',
  'editbarang.spekKhusus.navMissing': 'Spesifikasi Khusus belum diisi',
  'editbarang.spekKhusus.switchTitle': 'Ganti kategori?',
  'editbarang.spekKhusus.switchMessage': 'Data {category} akan dihapus. Lanjutkan?',
  'editbarang.spekKhusus.switchCancel': 'Batal',
  'editbarang.spekKhusus.switchConfirm': 'Lanjutkan',
  'editbarang.spekKhusus.untickTitle': 'Hapus Spesifikasi Khusus?',
  'editbarang.spekKhusus.untickMessage': 'Data Spesifikasi Khusus barang ini akan dihapus saat disimpan. Lanjutkan?',
  'editbarang.spekKhusus.flagStaffOnly': 'Hanya staf JARVIS yang dapat menandai HS sebagai Spek Khusus.',
  'submitsummary.spekKhusus.title': 'Spesifikasi Khusus belum diisi',
  'submitsummary.spekKhusus.body':
    'HS barang di bawah ini wajib Spesifikasi Khusus di CEISA (mis. Nomor CAS). Buka barangnya, lalu isi bagian Spesifikasi Khusus.',
  'submitsummary.spekKhusus.line': 'Seri {seri} · {hs} · {uraian}',
  'submitsummary.spekKhusus.open': 'Isi Spesifikasi Khusus',
  'submitsummary.spekKhusus.ack':
    'Saya mengerti barang ini bisa ditolak / tidak bisa disimpan di CEISA tanpa Spesifikasi Khusus',
  'submitsummary.spekKhusus.blocked': 'Centang dulu konfirmasi Spesifikasi Khusus di atas',
  'submitsummary.kemasanTotal.title': 'Jumlah kemasan tidak sama',
  'submitsummary.kemasanTotal.barang': 'Tab Barang ({seri} seri)',
  'submitsummary.kemasanTotal.kemasan': 'Tab Kemasan',
  'submitsummary.kemasanTotal.selisih': 'Selisih',
  'submitsummary.kemasanTotal.body':
    'Periksa dulu jumlah kemasan per barang di tab Barang dan jumlah di tab Kemasan & Peti Kemas.',
  'submitsummary.kemasanTotal.ack': 'Saya sudah cek jumlah kemasan dan tetap ingin submit',
  'submitsummary.kemasanTotal.blocked': 'Centang dulu konfirmasi jumlah kemasan di atas',
  'submitsummary.smartSync.neverTitle': 'Smart Sync belum dijalankan',
  'submitsummary.smartSync.neverBody':
    'Tarif, lartas, satuan & kemasan barang belum dicek ulang ke INSW. Opsional — Anda tetap bisa submit.',
  'submitsummary.smartSync.staleTitle': 'Ada perubahan barang setelah Smart Sync',
  'submitsummary.smartSync.staleBody':
    'Smart Sync terakhir {relative} oleh {lastBy}; {count} perubahan barang setelahnya. Opsional — Anda tetap bisa submit.',
  'submitsummary.smartSync.open': 'Buka Smart Sync →',

  // ---- Stempel perusahaan (Layanan Lainnya → Stamp) ----
  'stamp.upload.title': 'Upload stempel perusahaan',
  'stamp.upload.subtitle': 'Semua pengguna di perusahaan Anda memakai stempel ini saat memberi stempel pada dokumen.',
  'stamp.upload.drop': 'Tarik gambar stempel ke sini atau klik untuk memilih',
  'stamp.upload.formats': 'PNG atau JPG, maksimal 2 MB',
  'stamp.upload.tip': 'Gunakan PNG berlatar transparan agar dokumen di bawahnya tetap terlihat',
  'stamp.upload.preview': 'Pratinjau stempel',
  'stamp.upload.save': 'Simpan',
  'stamp.upload.cancel': 'Batal',
  'stamp.upload.saved': 'Stempel perusahaan disimpan',
  'stamp.active.label': 'Stempel perusahaan',
  'stamp.active.uploadedBy': 'Diunggah oleh {email} · {date}',
  'stamp.replace.button': 'Ganti stempel',
  'stamp.replace.title': 'Ganti stempel perusahaan',
  'stamp.replace.note': 'Stempel baru langsung dipakai oleh semua pengguna di perusahaan Anda.',
  'stamp.disabled.title': 'Stempel perusahaan Anda dinonaktifkan oleh tim JARVIS',
  'stamp.disabled.reason': 'Alasan: {reason}',
  'stamp.disabled.body':
    'Anda tidak dapat memberi stempel atau mengunggah stempel baru sampai tim JARVIS mengaktifkannya kembali.',
  'stamp.disabled.contact': 'Hubungi support',
  'stamp.noPpjk.title': 'Akun Anda belum terhubung ke PPJK',
  'stamp.noPpjk.body':
    'Stempel perusahaan tersedia setelah akun Anda terhubung ke PPJK. Hubungi admin perusahaan Anda.',
  'stamp.error.tooLarge': 'Maksimal 2 MB',
  'stamp.error.type': 'Hanya PNG atau JPG',
  'stamp.error.invalidImage': 'Gambar stempel tidak dapat dipakai',
  'stamp.error.impersonated': 'Stempel tidak dapat diganti selama impersonasi; ganti melalui CMS',
  'stamp.error.busy': 'Server sedang sibuk, coba lagi sebentar lagi',
  'stamp.error.generic': 'Terjadi kesalahan, coba lagi',
  'stamp.error.load': 'Stempel perusahaan tidak dapat dimuat',
  'stamp.error.retry': 'Coba lagi',
  'stamp.viewer.hint': 'Klik pada dokumen untuk menempatkan stempel, lalu seret untuk menggesernya.',
  'stamp.viewer.item': 'Stempel {n}',
  'stamp.viewer.remove': 'Hapus',
  'stamp.viewer.x': 'Posisi X',
  'stamp.viewer.y': 'Posisi Y',
  'stamp.viewer.page': 'Halaman',
  'stamp.viewer.add': 'Tambah stempel',
  'stamp.viewer.reset': 'Reset posisi',
  'stamp.viewer.download': 'Unduh PDF berstempel',
  'stamp.viewer.downloadError': 'Gagal membuat PDF berstempel.',
  'stamp.viewer.newFile': 'Unggah file lain',

  // Bulk Update modal, "Nilai & Transaksi" section (next-jarvis#926).
  'bulkNilai.sectionTitle': 'Nilai & Transaksi',
  'bulkNilai.sectionSubtitle': 'Centang "ubah" pada field yang ingin diganti; yang tidak dicentang tidak diubah',
  'bulkNilai.ubah': 'UBAH',
  'bulkNilai.spesifikasiLain': 'Spesifikasi Lain',
  'bulkNilai.spesifikasiLainPlaceholder': 'mis. WARNA HITAM, 220V',
  'bulkNilai.spesifikasiLainHint': 'Maks. {count} karakter. Dicentang tapi kosong = spesifikasi lain dihapus.',
  'bulkNilai.freeGoods': 'Barang gratis / contoh (Metode 2 + CMA + Jenis Transaksi CMA)',
  'bulkNilai.freeGoodsHint':
    'Sama dengan centang "Free of Charge Item" di detail barang, ditambah jenis transaksi CMA.',
  'bulkNilai.metode': 'Metode Penentuan Nilai Pabean',
  'bulkNilai.metodePlaceholder': 'Pilih Metode',
  'bulkNilai.alasan': 'Alasan',
  'bulkNilai.alasanPlaceholder': 'Pilih Alasan',
  'bulkNilai.alasanHint': 'Dicentang tapi kosong = alasan dihapus.',
  'bulkNilai.alasanLocked': 'Metode 1 tidak memakai alasan, jadi alasan dikosongkan.',
  'bulkNilai.jenisTransaksi': 'Jenis Transaksi',
  'bulkNilai.jenisTransaksiHelp': 'Mengganti jenis transaksi di barang terpilih',
  'bulkNilai.jenisTransaksiEmpty':
    'Belum ada baris. Bila diterapkan begini, jenis transaksi di barang terpilih dihapus.',
  'bulkNilai.kodeJenisVd': 'Jenis Nilai',
  'bulkNilai.kodePlaceholder': 'Pilih jenis transaksi',
  'bulkNilai.nilaiBarangVd': 'Nilai VD',
  'bulkNilai.addRow': 'Tambah Jenis Transaksi',
  'bulkNilai.removeRow': 'Hapus baris',
  'bulkNilai.maxRows': 'Maksimal {count} jenis transaksi per barang.',
  'bulkNilai.previewTitle': 'Pratinjau Perubahan',
  'bulkNilai.previewNone': 'Belum ada field yang dicentang.',
  'bulkNilai.previewCount': '{count} barang',
  'bulkNilai.cleared': '(dikosongkan)',
  'bulkNilai.summaryNone': 'Tidak diubah.',
  'bulkNilai.err.noSeri': 'Isi Seri Barang di bagian 1; field ini hanya diterapkan ke seri barang tersebut.',
  'bulkNilai.err.spesifikasiTooLong': 'Spesifikasi Lain maksimal {count} karakter.',
  'bulkNilai.err.metodeRequired': 'Pilih metode penentuan nilai.',
  'bulkNilai.err.metodeInvalid': 'Metode penentuan nilai tidak dikenal.',
  'bulkNilai.err.alasanInvalid': 'Alasan tidak dikenal.',
  'bulkNilai.err.tooManyRows': 'Maksimal {count} jenis transaksi per barang.',
  'bulkNilai.err.kodeRequired': 'Pilih jenis transaksi.',
  'bulkNilai.err.kodeInvalid': 'Kode jenis transaksi tidak dikenal.',
  'bulkNilai.err.kodeDuplicate': 'Jenis transaksi ini sudah ada di daftar.',
  'bulkNilai.err.nilaiInvalid': 'Nilai VD harus angka 0 atau lebih.',
  'bulkNilai.err.server': 'Nilai ini ditolak server.',
  'bulkNilai.err.checkTitle': 'Perubahan belum diterapkan',
  'bulkNilai.err.checkBody': 'Periksa field yang ditandai merah di bagian Nilai & Transaksi.',
  'bulkNilai.err.rejectedBody':
    'Server menolak sebagian isian, tidak ada data yang diubah. Periksa field yang ditandai merah.',
};

const zh: TranslationDict = {
  // ---- 应用更新 ----
  'appUpdate.title': '有新版本可用',
  'appUpdate.message': '此更新是 Jarvis 正常运行所必需的。请重新加载页面以继续。',
  'appUpdate.reload': '立即重新加载',
  'appUpdate.banner.lead': 'Jarvis 有新版本可用。',
  'appUpdate.banner.detail': '请先保存您的工作，准备好后再重新加载。',
  'appUpdate.banner.reload': '重新加载',
  'appUpdate.banner.dismiss': '关闭',
  'appUpdate.header.tooltip': '有新版本可用 · 点击重新加载',

  // ---- 设置（个人 + 公司）----
  'settings.title': '设置',
  'settings.subtitle': '按您的工作习惯调整 Jarvis。',
  'settings.sectionPersonal': '我的偏好',
  'settings.sectionCompany': '公司设置',
  'settings.docDetection': '自动识别单证类型',
  'settings.docDetectionDesc': '系统会读取每份上传的单证并自动填写其类型。若您更愿意自行选择，请关闭此项。',
  'settings.docDetectionNote': '适用于 PIB 上传步骤。即使关闭，仍会根据文件名进行推测。',
  'settings.docDetectionLockedNote': '此设置已由贵公司管理员锁定。如需更改请联系管理员。',
  'settings.lockedByCompany': '已被公司锁定',
  'settings.professionalMode': '专业模式',
  'settings.professionalModeDesc': '开启后将在处理流程中隐藏印花税、小游戏和知识问答。',
  'settings.professionalModeNote': '切换模式会重新加载页面，以便界面采用最新的偏好设置。',
  'settings.companyDocDetection': '全公司默认识别设置',
  'settings.companyDocDetectionDesc': '尚未自行设置的成员所采用的初始状态。',
  'settings.companyLock': '锁定此选项',
  'settings.companyLockDesc': '锁定期间成员无法更改自动识别。他们的选择会被保留，解锁后重新生效。',
  'settings.companyNote': '仅公司管理员可见此部分。',
  'settings.saveFailed': '保存失败',
  'settings.saveFailedMsg': '公司设置尚未保存，请重试。',
  // Language switcher
  'language.switcher': '语言',
  'language.indonesia': 'Bahasa Indonesia',
  'language.english': 'English',
  'language.chinese': '中文',

  // Sidebar menus
  'menu.mgmtDashboard': '管理仪表盘',
  'menu.manifest': '舱单',
  'menu.dashboard': '仪表盘',
  'menu.buatAju': '创建申报',
  'menu.draft': '草稿',
  'menu.docManifes': '舱单文件',
  'menu.theGuardian': '守卫',
  'menu.radar': '雷达',
  'menu.kepabeanan': '海关',
  'menu.docPabean': '报关文件',
  'menu.monitoringBlokir': '封锁监控',
  'menu.respon': '响应',
  'menu.databaseBarang': '商品数据库',
  'menu.ppftz': 'PPFTZ',
  'menu.kuotaImporEkspor': '进出口配额',
  'menu.shipmentQuota': '货运配额',
  'menu.hargaReferensi': '参考价格',
  'menu.cukai': '消费税',
  'menu.tutorial': '教程',
  'menu.suratJalan': '发货单',
  'menu.dokumenCk': 'CK文件',
  'menu.billOfMaterial': '物料清单',
  'menu.inventori': '库存',
  'menu.riskSelfCheck': '风险自查',
  'menu.customerApproval': '客户审批',
  'menu.approvalRequests': '审批请求',
  'menu.emailGroups': '电子邮件组',
  'menu.reviewers': '审阅者',
  'menu.rolesPermissions': '角色与权限',
  'menu.creditTopup': '信用充值',
  'menu.langganan': '订阅',
  'menu.berita': '新闻',
  'menu.antaraNews': '安塔拉新闻',
  'menu.cnnIndonesia': 'CNN 印尼',
  'menu.cnbcIndonesia': 'CNBC 印尼',
  'menu.republikaNews': '共和报新闻',
  'menu.kumparanNews': 'Kumparan 新闻',
  'menu.voaNews': '美国之音新闻',
  'menu.layananLainnya': '其他服务',
  'menu.stampDuty': '印花税',
  'menu.miniGames': '小游戏',
  'menu.fileCompress': '文件压缩',
  'menu.splitPdf': '拆分PDF',
  'menu.pengaturan': '设置',
  'menu.master': '主数据',
  'menu.ceisaUser': 'Ceisa用户',
  'menu.user': '用户',
  'menu.seaCarriers': '海运承运人',
  'menu.email': '电子邮件',
  'menu.customerEmailForwarding': '客户邮件转发',
  'menu.statement': '声明',
  'menu.manifestReminder': '舱单提醒',
  'menu.revokeAccess': '撤销访问',
  'menu.exportBank': '出口银行',
  'menu.riwayatPembaruan': '更新历史',

  // Sidebar badges
  'badge.new': '新',
  'badge.bod': 'BOD',
  'badge.mulai': '开始',
  'badge.aiReady': 'AI就绪',

  // Sidebar footer / search
  'sidebar.manageAccount': '管理账户',
  'sidebar.impersonate': '模拟用户',
  'sidebar.impersonating': '正在模拟',
  'sidebar.changeTheme': '切换主题',
  'sidebar.theme': '主题',
  'theme.jarvis': 'JARVIS',
  'theme.jarvisNight': 'JARVIS 黑夜',
  'theme.horizon': 'Horizon',
  'theme.horizonNight': 'Horizon 黑夜',
  'theme.horizonDawn': 'Horizon 黎明',
  'theme.horizonDusk': 'Horizon 黄昏',
  'theme.horizonMist': 'Horizon 薄雾',
  'sidebar.logout': '退出登录',
  'sidebar.loggingOut': '正在退出...',
  'sidebar.collapse': '收起侧边栏',
  'sidebar.expand': '展开侧边栏',
  'sidebar.quickSearch': '快速搜索...',
  'sidebar.noMatches': '无匹配结果',

  // Login
  'auth.welcome': '欢迎回来！登录以访问您的账户',
  'auth.email': '电子邮件地址',
  'auth.emailPlaceholder': 'example@mail.com',
  'auth.password': '密码',
  'auth.passwordPlaceholder': '您的密码',
  'auth.signIn': '登录',
  'auth.or': '或',
  'auth.cubeLogin': '使用 CUBEforall 账户登录',
  'auth.reviewerLogin': '以审阅者身份登录',
  'auth.cubeErrorTitle': 'CUBEforall 登录失败',
  'auth.demoEndedTitle': '演示账户已到期',
  'auth.sessionInconsistent': '会话不同步，请重新登录。',
  'auth.switchUserEnded': '您的切换用户会话已结束。',
  'docpabean.draft.noAccess': '当前账户无法打开此草稿。',
  'demo.badge': '演示账户',
  'demo.endsIn': '剩余时间',
  'demo.quotaHint': '演示账户已处理（提取）的文件配额',
  'demo.contactSales': '联系销售',
  'demo.salesMessage': '您好，我正在试用 Jarvis 演示账户，想了解更多。',
  'auth.demoEndedMessage': '感谢您试用 Jarvis。如需延长演示或开始订阅，请联系 Jarvis 团队。',

  // Login showcase (right panel of the login page)
  'auth.showcase.headline': '报关文件几分钟完成，而不是几个小时。',
  'auth.showcase.ariaLabel': 'JARVIS 功能',
  'auth.showcase.play': '播放',
  'auth.showcase.pause': '暂停',
  'auth.showcase.segBrand': 'JARVIS',
  'auth.showcase.segExtract': 'AI 提取',
  'auth.showcase.segHs': 'HS 与 Lartas',
  'auth.showcase.segCeisa': 'CEISA',
  'auth.showcase.segRadar': '雷达',
  'auth.showcase.segUpload': '上传',
  'auth.showcase.extractTitle': 'AI 提取',
  'auth.showcase.extractDesc': '自动读取发票和装箱单，每个数值都附带置信度评分。',
  'auth.showcase.tabBarang': '货物',
  'auth.showcase.itemsDetected': '检测到 {n} 个条目',
  'auth.showcase.reading': '正在读取文件',
  'auth.showcase.draftReady': 'PIB 草稿可供复核',
  'auth.showcase.verified': 'Verified',
  'auth.showcase.sampleData': '示例数据',
  'auth.showcase.tipVerified': 'Verified',
  'auth.showcase.tipCheck': 'Check',
  'auth.showcase.tipAutoVerified': '已根据来源自动校验',
  'auth.showcase.tipClickReview': '点击对照来源复核',
  'auth.showcase.tipHsConfidence': 'HS 编码提取置信度',
  'auth.showcase.hsTitle': 'HS 编码与 Lartas 校验',
  'auth.showcase.hsDesc': 'HS 编码对接 INSW 核对，自动判定 Lartas 状态并计算税率。',
  'auth.showcase.hsCode': '编码',
  'auth.showcase.hsNormalized': '标准化编码',
  'auth.showcase.hsUraian': '描述（印尼语）',
  'auth.showcase.hsInswYear': 'INSW 年份',
  'auth.showcase.no': '否',
  'auth.showcase.tipNoLartas': '无需 Lartas 许可',
  'auth.showcase.tipBm': '进口关税，MFN 税率',
  'auth.showcase.tipPpn': '增值税',
  'auth.showcase.tipPph': '进口所得税第 22 条，持 API',
  'auth.showcase.tipPostel': '需要 Postel 证书',
  'auth.showcase.ceisaTitle': '提交至 CEISA 4.0',
  'auth.showcase.ceisaDesc': '一键提交，状态记录回流到 JARVIS。',
  'auth.showcase.sent': '已提交',
  'auth.showcase.tipDraft': '草稿已保存在 JARVIS',
  'auth.showcase.tipSubmitted': '已提交至 CEISA 4.0',
  'auth.showcase.tipUmum': '已受理，通道分配中',
  'auth.showcase.tipSppb': '货物放行批准函',
  'auth.showcase.radarTitle': '舱单雷达',
  'auth.showcase.radarDesc': '船舶抵达前即监控进出舱单。',
  'auth.showcase.vessel': '船名',
  'auth.showcase.remaining': '剩余',
  'auth.showcase.uploadTitle': '一次上传最多 50 份文件',
  'auth.showcase.uploadDesc': '自动识别文件类型并分组。',
  'auth.showcase.dropHint': '拖放文件',
  'auth.showcase.typesDetected': '检测到 {n} 种文件类型',

  // ---- Sinkron data historis ----
  'syncHistorical.npwpMissingTitleImport': '尚未填写进口商 NPWP',
  'syncHistorical.npwpMissingTitleExport': '尚未填写出口商 NPWP',
  'syncHistorical.npwpMissingBodyImport':
    '历史数据按进口商 NPWP 匹配。请在 Entitas 标签页填写进口商 NPWP 并保存，然后重新打开此功能。',
  'syncHistorical.npwpMissingBodyExport':
    '历史数据按出口商 NPWP 匹配。请在 Entitas 标签页填写出口商 NPWP 并保存，然后重新打开此功能。',

  // Doc Pabean page
  'docpabean.errorLoad': '加载报关文件数据失败。',
  'docpabean.retry': '重试',
  'docpabean.allStatus': '全部状态',
  'docpabean.sortPlaceholder': '排序',
  'docpabean.filterStatus': '筛选状态',
  'docpabean.filterBranch': '筛选分公司',
  'docpabean.branchMine': '我的分公司',
  'docpabean.branchAll': '所有分公司',
  'docpabean.sortNewest': '排序：最新',
  'docpabean.sortAjuAsc': '申报号（A-Z）',
  'docpabean.sortAjuDesc': '申报号（Z-A）',
  'docpabean.sortShipperAsc': '货主名称（A-Z）',
  'docpabean.sortShipperDesc': '货主名称（Z-A）',
  'docpabean.sortDateOldest': 'AJU 提交日期（最早）',
  'docpabean.sortDateNewest': 'AJU 提交日期（最新）',
  'docpabean.sortItemLeast': '条目总数（最少）',
  'docpabean.sortItemMost': '条目总数（最多）',
  'docpabean.downloadUsage': '下载使用报告',
  'docpabean.downloadReport': '下载报告',
  'docpabean.startDate': '开始日期',
  'docpabean.endDate': '结束日期',
  'docpabean.selectStartDate': '选择开始日期',
  'docpabean.selectEndDate': '选择结束日期',
  'docpabean.docType': '文件类型',
  'docpabean.all': '全部',
  'docpabean.cancel': '取消',
  'docpabean.download': '下载',
  'docpabean.errSelectDates': '请选择开始日期和结束日期',
  'docpabean.successDownloaded': '使用报告下载成功',
  'docpabean.errDownload': '下载使用报告失败',
  'docpabean.errorTitle': '错误',

  // Doc Pabean credits banner
  'docpabean.remainingCredits': '剩余积分',
  'docpabean.errLoadBalance': '加载余额失败',
  'docpabean.viewSubscription': '查看订阅',
  'docpabean.usageThisMonth': '本月用量',

  // Doc Pabean download modal
  'docpabean.downloadModalTitle': '下载报告',
  'docpabean.loadingOptions': '加载选项...',
  'docpabean.filterHint': '按公司名称和/或日期范围筛选导出历史记录。草稿员名称可选。',
  'docpabean.drafterName': '草稿员名称（可选）',
  'docpabean.drafterPlaceholder': '搜索并选择草稿员...',
  'docpabean.noDrafters': '未找到草稿员',
  'docpabean.companyName': '公司名称',
  'docpabean.companyPlaceholder': '搜索并选择公司...',
  'docpabean.noCompanies': '未找到公司',
  'docpabean.errSelectCompanyDates': '请选择公司和/或日期范围（草稿员名称可选）',
  'docpabean.errDateRequiredCompany': '导出 {company} 必须填写开始日期和结束日期（DD-MM-YYYY）',
  'docpabean.errEndBeforeStart': '结束日期必须不早于开始日期',
  'docpabean.successReportDownloaded': '报告下载成功',
  'docpabean.errReportDownload': '下载报告失败',

  // Doc Pabean table
  'docpabean.colNomorAju': '申报号',
  'docpabean.colShipper': '货主名称',
  'docpabean.colBuyer': '买方名称',
  'docpabean.colDate': 'AJU 提交日期',
  'docpabean.colRespon': '响应',
  'docpabean.colStatus': '状态',
  'docpabean.colType': '类型',
  'docpabean.colJenisKategori': '类型 | 出口类别',
  'docpabean.colDrafter': '草稿员',
  'docpabean.colTotalItem': '条目总数',
  'docpabean.colApproval': '审批',
  'docpabean.colActions': '操作',
  'docpabean.colVesselVoy': '船名 & 航次',
  'docpabean.colTglTibaEkspor': 'ETA / ETD 日期',
  'docpabean.incompleteTitle': '部分数据未能加载',
  'docpabean.incompleteBody': '{list} 列暂时无法加载。您的文件数据未受影响。',
  'docpabean.incompleteReload': '重新加载',
  'docpabean.incompleteCell': '加载失败',
  'docpabean.incompleteCellTooltip': '此数据无法加载。请点击上方的“重新加载”。',
  'docpabean.incompleteFiles': '文件',
  'docpabean.tooltipTglTiba': '预计到港日期',
  'docpabean.tooltipTglEkspor': '出口日期',
  'docpabean.sortTglTibaEksporNearest': 'ETA/ETD 日期（最近）',
  'docpabean.sortTglTibaEksporFarthest': 'ETA/ETD 日期（最远）',
  'docpabean.cardVessel': '船名',
  'docpabean.cardTibaEkspor': 'ETA/ETD',
  'docpabean.kolom.button': '列',
  'docpabean.kolom.title': '显示列',
  'docpabean.kolom.alwaysShown': 'Nomor Aju 和操作列始终显示。',
  'docpabean.kolom.display': '显示',
  'docpabean.kolom.showLogos': '显示公司标志 / 缩写',
  'docpabean.kolom.showFlags': '显示国旗',
  'docpabean.kolom.reset': '恢复默认',
  'docpabean.filterShipmentType': '运输类型',
  'docpabean.filterNamaPerusahaan': '公司名称',
  'docpabean.filterDrafter': '草稿员名称',
  'docpabean.filterMotType': '运输方式类型',
  'docpabean.motSea': '海运',
  'docpabean.motAir': '空运',
  'docpabean.filterCountry': '发货人/收货人国家',
  'docpabean.statusHistory': '状态历史',
  'docpabean.latest': '最新',
  'docpabean.respon': '响应',
  'docpabean.tooltipVerified': '完整：发票 + 提单/空运单',
  'docpabean.tooltipView': '查看',
  'docpabean.tooltipViewEdit': '查看 / 编辑',
  'docpabean.tooltipEdit': '编辑',
  'docpabean.tooltipCopy': '复制',
  'docpabean.tooltipUpload': '上传文件',
  'docpabean.tooltipSyncRespon': '同步响应',
  'docpabean.tooltipDelete': '删除',
  'docpabean.tooltipPreviewPdf': '预览 PDF',
  'docpabean.tooltipPreviewPdfNoAju': '尚无 AJU 编号',
  'docpabean.pdfPreview.title': '预览 {doc}',
  'docpabean.pdfPreview.kindFinal': '正式 (NOPEN)',
  'docpabean.pdfPreview.kindDraft': 'CEISA 草稿',
  'docpabean.pdfPreview.fallbackTitle': '暂时无法获取正式文件',
  'docpabean.pdfPreview.fallbackBody': '该文件已获得 NPE/SPPB，但无法从 CEISA 获取正式表格。当前显示的是 CEISA 草稿。',
  'docpabean.pdfPreview.loading': '正在从 CEISA 获取文件…',
  'docpabean.pdfPreview.loadingHint': '如果文件尚未生成，CEISA 需要一些时间来准备 — CEISA 较慢时可能需要约一分钟。',
  'docpabean.pdfPreview.docGeneric': '文件',
  'docpabean.pdfPreview.refreshDraft': '刷新草稿',
  'docpabean.pdfPreview.download': '下载',
  'docpabean.pdfPreview.openNewTab': '在新标签页打开',
  'docpabean.pdfPreview.errorTitle': '无法显示文件',
  'docpabean.pdfPreview.errorGeneric': '获取文件失败，请重试。',
  'docpabean.pdfPreview.errorBilling': '订阅未付款 / 额度不足 — 无法打开预览。',
  'docpabean.pdfPreview.retry': '重试',
  'docpabean.deleteConfirm': '从列表中删除文件 {nomor}？已发送到 CEISA 的文件不受影响。',
  'docpabean.deleteCancel': '取消',
  'docpabean.deleteFiledWarning': '该文件已在 CEISA 登记。删除仅将其从 Jarvis 隐藏 — 文件仍保留在 CEISA。',
  'docpabean.showDeleted': '显示已删除',
  'docpabean.deletedBadge': '已删除',
  'docpabean.tooltipRestore': '恢复',
  'docpabean.restoreConfirm': '将文件 {nomor} 恢复到列表？',
  'docpabean.restore': '恢复',
  'docpabean.delete': '删除',
  'docpabean.loadingData': '加载数据...',
  'docpabean.emptyFilter': '当前筛选条件下没有文件。',
  'docpabean.page': '页',
  'docpabean.company': '公司',
  'docpabean.proses': '流程',
  'docpabean.totalItemLabel': '条目总数',
  'docpabean.country': '国家',
  'docpabean.export': '出口',
  'docpabean.import': '进口',
  'docpabean.justNow': '刚刚',
  'docpabean.ago': '前',
  'docpabean.approved': '已批准',
  'docpabean.waiting': '等待中',
  'docpabean.needRevision': '需要修订',
  'docpabean.rejected': '已拒绝',
  'docpabean.cancelled': '已取消',
  'docpabean.scheduled': '已安排',
  // 提交拦截：贸易术语为 FOB/FCA 但运费为 0（issue #234）
  'docpabean.freightZero.title': '运费为 0 — 请检查费用组成信息',
  'docpabean.freightZero.body':
    '{incoterm} 贸易术语要求将运费作为独立的费用组成项填写，因为运费不包含在发票价格中。当前运费仍为 0，申报的完税价格可能有误。',
  'docpabean.freightZero.hint':
    '请在“费用组成信息”中填写运输费用（Freight）并保存。运费大于 0 后，即可将文件提交至 CEISA。',
  'docpabean.freightZero.cta': '打开费用组成信息',
  'docpabean.freightZero.cancel': '取消',
  // 上传运费截图 → 识别金额与币种（issue #235）
  'docpabean.freightUpload.dropTitle': '上传运费截图或 PDF',
  'docpabean.freightUpload.dropHint': '将邮件或 WhatsApp 的截图或 PDF 拖放到此处，点击选择文件，或按 {paste} 粘贴',
  'docpabean.freightUpload.ofUploaded': '已上传海运费（OF）文件',
  'docpabean.freightUpload.ofUploadedFiles': '创建报关单时已从 {files} 读取运费金额。',
  'docpabean.freightUpload.ofUploadedHint': '创建报关单时已从该文件读取运费金额。',
  'docpabean.freightUpload.ofUploadedOverride': '仅在需要替换运费金额时，才在下方上传截图或 PDF。',
  'docpabean.freightUpload.ofReading.converted':
    '读取到 {from} {amount}，因交易币种为 {to}，已按 NDPBM 汇率（{kurs}）换算为 {to} {converted}。',
  'docpabean.freightUpload.ofReading.sameCurrency': '读取到 {from} {amount}，与交易币种相同。',
  'docpabean.freightUpload.ofReading.kursUnavailable':
    '读取到 {from} {amount}，因创建报关单时无法获取 NDPBM 汇率，尚未换算为 {to}——请检查运费金额。',
  'docpabean.freightUpload.ofReading.checkCurrency': '读取到 {amount}；请检查其币种。',
  'docpabean.freightUpload.ofReading.read': '读取到 {amount}。',
  'docpabean.freightUpload.ofReading.kurs': '1 {code} = Rp {rate}',
  'docpabean.freightUpload.reading': '正在识别文件...',
  'docpabean.freightUpload.readingHint': '通常只需几秒钟',
  'docpabean.freightUpload.detected': '识别到运费：{currency} {amount}',
  'docpabean.freightUpload.detectedSub': '已从文件自动读取（置信度 {pct}%，{method}）',
  'docpabean.freightUpload.detectedSubNoPct': '已从文件自动读取（{method}）',
  'docpabean.freightUpload.mismatchInline': '识别到运费：{currency} {amount}，与交易币种（{txn}）不一致',
  'docpabean.freightUpload.use': '使用此数值',
  'docpabean.freightUpload.useAs': '按 {currency} 使用',
  'docpabean.freightUpload.review': '查看换算',
  'docpabean.freightUpload.retry': '重试',
  'docpabean.freightUpload.dismiss': '关闭',
  'docpabean.freightUpload.lowConfidence': '置信度较低（{pct}%），使用前请核对数值。',
  'docpabean.freightUpload.notFound': '未能从该文件中识别到运费',
  'docpabean.freightUpload.notFoundHint': '请换一个包含运费金额的截图或 PDF，或在“费用组成信息”中手动填写。',
  'docpabean.freightUpload.currencyUnknown': '识别到金额 {amount}，但无法从文件确定币种。',
  'docpabean.freightUpload.invalidType': '文件必须是图片（JPEG/PNG/WebP）或 PDF。',
  'docpabean.freightUpload.tooLarge': '文件大小不能超过 10 MB。',
  'docpabean.freightUpload.failed': '文件识别失败：{message}',
  'docpabean.freightUpload.applyFailed': '运费保存失败：{message}',
  'docpabean.freightUpload.applied': '运费 {currency} {amount} 已保存至费用组成信息',
  'docpabean.freightUpload.appliedInline': '已使用运费 {value}',
  'docpabean.freightUpload.appliedHintField': '已保存至费用组成信息',
  'docpabean.freightUpload.appliedFrom.converted': '由 {currency} {amount} 按 NDPBM 汇率换算为 {txn}',
  'docpabean.freightUpload.appliedFrom.original': '数值 {amount} 已按原样作为 {txn} 填入（文件识别为 {currency}）',
  'docpabean.freightUpload.appliedFrom.assumed': '数值 {amount} 已视为 {txn}；未能从文件识别币种',
  'docpabean.freightUpload.appliedHintRow': '已填入此行，请点击“保存”以保存。',
  'docpabean.freightUpload.method.ocr': 'OCR',
  'docpabean.freightUpload.method.gemini': 'AI',
  'docpabean.freightUpload.method.pdf-text': 'PDF 文本层',
  'docpabean.freightUpload.method.pdf-ocr': 'PDF 页面 OCR',
  'docpabean.freightUpload.mismatch.title': '运费币种不一致',
  'docpabean.freightUpload.mismatch.body':
    '识别到的运费币种为 {detected}（{detected} {detectedAmount}），而本笔交易以 {txn} 计价。系统将按 NDPBM 汇率把 {detected} 换算为 {txn}，约为 {converted} {txn}。是否使用换算结果？',
  'docpabean.freightUpload.mismatch.bodyNoRate':
    '识别到的运费币种为 {detected}（{detected} {detectedAmount}），而本笔交易以 {txn} 计价。',
  'docpabean.freightUpload.mismatch.rate':
    '{detected} 的 NDPBM 汇率：1 {detected} = Rp {ndpbmSrc}\n{txn} 的 NDPBM 汇率：1 {txn} = Rp {ndpbmTxn}\n结果：1 {detected} ≈ {rate} {txn}',
  'docpabean.freightUpload.mismatch.noRate':
    '当前无法获取用于换算的 NDPBM 汇率，因此无法计算换算结果。您可以使用原始数值或手动填写。',
  'docpabean.freightUpload.mismatch.valutaHint':
    '如果发票本身就是 {detected} 计价，请先在“价格”卡片中更改币种，然后重新上传文件。',
  'docpabean.freightUpload.mismatch.useConverted': '使用换算结果',
  'docpabean.freightUpload.mismatch.useOriginal': '将 {amount} 作为 {txn} 填入',
  'docpabean.freightUpload.mismatch.cancel': '取消',

  // Status / Respon history modal
  'statushistory.title': '状态历史',
  'statushistory.loading': '加载中...',
  'statushistory.document': '文件',
  'statushistory.by': '由',
  'statushistory.totalItems': '条目总数',
  'statushistory.item': '项',
  'statushistory.items': '项',
  'statushistory.country': '国家',
  'statushistory.file': '文件',
  'statushistory.totalTime': '总耗时',
  'statushistory.noData': '没有可用数据',
  'statushistory.viewResponHistory': '查看响应历史',
  'statushistory.errFetch': '加载状态历史失败',
  'statushistory.errGeneric': '加载状态历史出错',

  // Buat Aju page
  'buataju.import': '进口',
  'buataju.importDesc': '创建进口到印尼的货物的报关文件。',
  'buataju.export': '出口',
  'buataju.exportDesc': '创建从印尼出口的货物的报关文件。',
  'buataju.bc33Desc': '经由或从保税物流中心（PLB）出口货物的申报单 — 用于通过/从保税物流中心出口。',
  'buataju.ppftzDesc': '使用 AI 从发票、装箱单和提单创建 FTZ (511) 文件，或手动填写。',
  'buataju.bc16Desc': '将进口货物运入保税物流中心（PLB）。',
  'buataju.bc23Desc': '将进口货物从海关区域或 TPS 运入 TPB。',
  'buataju.bc25Desc': '将进口货物从 TPB 运出到 TLDDP 供本地使用。',
  'buataju.bc261Desc': '凭担保将货物从 TPB 临时运出到 TLDDP。',
  'buataju.bc262Desc': '将临时运出的货物重新运入 TPB。',
  'buataju.bc27Desc': '在 TPB、KEK 或自由区之间转移货物。',
  'buataju.bc28Desc': '将货物从 PLB 运出供本地使用或临时使用。',
  'buataju.bc40Desc': '将来自 TLDDP 的货物运入保税仓库。',
  'buataju.bc41Desc': '将来自 TLDDP 的货物从 TPB 运回 TLDDP。',
  'buataju.bcp3betDesc': '用于保税展会活动（P3BET）的申报单。',
  'buataju.popular': '热门',
  'buataju.limitedAccess': '受限访问',
  'buataju.comingSoon': '即将推出',
  'buataju.new': '新',
  'buataju.locked': '已锁定',
  'buataju.start': '开始',
  'buataju.badge': '轻松处理报关文件',
  'buataju.title': '选择文件类型',
  'buataju.subtitle': '选择符合您业务需求的报关文件类型，开始您的旅程。',
  'buataju.typesAvailable': '种类型可用',
  'buataju.tpb': 'TPB',
  'buataju.tpbDesc': '保税仓库',
  'buataju.codeImport': '进口',
  'buataju.codeExport': '出口',
  'buataju.codeEkspor': '出口',
  'buataju.codePpftz': 'PPFTZ',
  'buataju.codeTpb': 'TPB',

  // Doc Pabean Upload page
  'upload.back': '返回',
  'upload.title': '上传文件',
  'upload.subtitle': '上传并分组您的报关文件。',
  'upload.backToWizard': '返回 3 步向导流程',
  'upload.useWizard': '使用向导',
  'upload.documents': '文件',
  'upload.processing': '处理中...',
  'upload.grouped': '已分组',
  'upload.readyToProcess': '准备处理',
  'upload.successCount': '{n} 成功',
  'upload.failedCount': '{n} 失败',
  'upload.reset': '重置',
  'upload.continueReview': '继续到审阅',
  'upload.uploadDocs': '上传 {n} 个文件',
  'upload.processDocs': '处理文件',
  'upload.uploading': '上传中... {p}%',
  'upload.groupingDocs': '按类型分组文件...',
  'upload.resultsTitle': '文件上传结果',
  'upload.total': '总计',
  'upload.success': '成功',
  'upload.failed': '失败',
  'upload.caution': '注意',
  'upload.cautionMsg': '部分文件上传失败。您可以重试或继续使用已成功上传的文件。',
  'upload.successDocs': '成功文件（{n}）',
  'upload.failedDocs': '失败文件（{n}）',
  'upload.docType': '类型：{type}',
  'upload.noDocType': '无文件类型',
  'upload.errorLabel': '错误：{msg}',
  'upload.reUpload': '重新上传',
  'upload.continue': '继续',
  'upload.errRequiredTransport': '必须包含 BL、AWB、MBL 或 MAWB 文件',
  'upload.errCeisaCombine': 'Excel CEISA 不能合并',
  'upload.errCeisaCombineMsg': 'Excel CEISA 文件必须单独上传，不能与其他文件合并。',
  'upload.errNoFile': '没有文件',
  'upload.errNoFileMsg': '请先添加文件',
  'upload.errNoType': '尚未选择文件类型',
  'upload.errNoTypeMsg': '{n} 个文件没有文件类型',
  'upload.errEmptyFile': '0 字节（空文件）',
  'upload.errInvalidPdf': '不是有效的 PDF（标题 "{magic}"，大小 {size} 字节）',
  'upload.errInvalidFile': '文件无效',
  'upload.successUploaded': '上传成功',
  'upload.successUploadedMsg': '所有文件均上传成功。',
  'upload.doneUploading': '上传完成',
  'upload.partialMsg': '{total} 个文件中有 {success} 个上传成功。',
  'upload.errCeisaProcess': '处理 Excel CEISA 失败：{msg}。文件已保存，请继续到草稿页面。',
  'upload.errUpload': '上传文件时出错：{msg}',
  'upload.errUploadFile': '上传文件失败。',
  'upload.errNoBatch': '未找到 Batch UUID。请先上传文件。',
  'upload.uploadGagal': '上传失败：服务器未返回有效数据',
  'upload.ceisaFileNotFound': '未找到 EXCEL CEISA 文件',
  'upload.emptyHeader': '待上传文件（{n}）',
  'upload.searchPlaceholder': '搜索文件...',
  'upload.selectDocType': '选择文件类型',
  'upload.alreadySelected': '已选择',
  'upload.noMatch': '没有与 "{q}" 匹配的文件',
  'upload.noFiles': '尚未上传文件',
  'upload.dragDrop': '拖放或',
  'upload.clickBrowse': '点击浏览',
  'upload.dropPdf': '将 PDF 文件拖放到此处',
  'upload.dropPdfExcel': '将 PDF/Excel 文件拖放到此处',
  'upload.dropPdfExcelImg': '将 PDF/Excel/照片 (JPG/PNG) 文件拖放到此处',
  'upload.maxFiles': '最多 {n} 个文件',
  'upload.enlarge': '放大',
  'upload.shrink': '缩小',
  'upload.fmtNotMatch': '格式不符合',
  'upload.fmtPdfOnly': '仅允许 PDF 文件',
  'upload.fmtPdfExcel': '仅允许 PDF 和 Excel 文件',
  'upload.fmtPdfExcelImg': '仅允许 PDF、Excel 和照片 (JPG/PNG) 文件',
  'upload.tooMany': '文件太多',
  'upload.tooManyMsg': '最多可上传 {n} 个文件',
  'upload.cantSelect': '无法选择',
  'upload.masterOnlyOne': '仅允许 1 个 {name}',
  'upload.fileCount': '{n} 个文件',
  'upload.groupedHeader': '文件已分组',
  'upload.dragReorder': '拖拽调整顺序',
  'upload.splitTitle': '将 PDF 拆分为多个文件',
  'upload.splitHint': '选择 PDF 文件手动标记分段，或点击"智能拆分"自动识别。',
  'upload.notPdf': '此文件不是 PDF',
  'upload.pages': '{n} 页',
  'upload.activeSeg': '活动：段 {n}',
  'upload.pageOf': '第 {cur} 页 / 共 {total} 页',
  'pdf.zoomIn': '放大（Ctrl + 滚轮）',
  'pdf.zoomOut': '缩小（Ctrl + 滚轮）',
  'pdf.zoomReset': '重置缩放',
  'pdf.documentOf': '文件 {cur} / {total}',
  'pdf.pageOf': '第 {cur} / {total} 页',
  'pdf.prevDocument': '上一个文件',
  'pdf.nextDocument': '下一个文件',
  'pdf.download': '下载',
  'pdf.close': '关闭 PDF',
  'upload.smartSplit': '智能拆分',
  'upload.smartSplitHint': '智能拆分 — 读取 PDF 内容并按文件拆分',
  'upload.smartSplitWorking': '正在读取文件',
  'upload.smartSplitNeedsPages': '至少需要 2 页',
  'upload.smartSplitResult': '找到 {n} 份文件 · {method}',
  'upload.smartSplitViaAi': 'AI 识别',
  'upload.smartSplitViaText': '来自 PDF 文本',
  'upload.smartSplitSingle': '此文件只有一份文件，无需拆分。',
  'upload.smartSplitFailed': '识别失败',
  'upload.smartSplitFailedMsg': '无法读取文件，请手动标记分段。',
  'upload.smartSplitAll': '全部识别',
  'upload.smartSplitAllHint': '一次读取所有 PDF — 识别文件类型与分页',
  'upload.smartSplitAllProgress': '正在读取 {done}/{total}',
  'upload.aiDetectQueued': '等待中',
  'upload.aiDetectFailed': '识别失败 — 重试',
  'upload.mismatchDetected': '文件内容识别为 {type}（{pct}%），而非 {declared}',
  'upload.mismatchUse': '改为 {type}',
  'upload.mismatchIgnore': '忽略',
  'upload.junkSuggest': '似乎不是货运单证（{pct}%）— 忽略？',
  'upload.junkSkip': '忽略此文件',
  'upload.junkKeep': '仍然处理',
  'upload.junkSkipped': '已忽略',
  'upload.errAllJunk': '没有可处理的文件',
  'upload.errAllJunkMsg': '所有文件都被标记为其他文件（忽略）。请更改类型后再处理。',
  'upload.siblingHint': '识别为 {type} — 可能更准确',
  'upload.bundleDetected': '包含 {n} 份文件（{types}）— 请先拆分',
  'upload.bundleOpen': '打开拆分',
  // ---- Upload per folder (upload_folder_ux) + Review check ----
  'upload.folders.todo.needsType': '尚未选择文件类型',
  'upload.folders.todo.junk': '不是货运文件？',
  'upload.folders.todo.bundle': '包含 {n} 份文件 — 要拆分吗？',
  'upload.folders.todo.belongs': '看起来是 {type} — 要移动吗？',
  'upload.folders.todo.mismatch': '内容是 {type}，不是{folder}',
  'upload.folders.todo.missingFolder': '尚无文件 — 必填',
  'upload.folders.todoLook': '查看',
  'upload.folders.todoHint': '点击“查看”定位到文件，然后在黄色框中选择处理方式。',
  'upload.folders.todoNone': '所有文件都没问题',
  'upload.folders.todoTitle': '待检查（{n}）',
  'upload.folders.folderAttention': '{n} 个待检查',
  'upload.folders.attention': '待检查',
  'upload.folders.dropAllAnywhere': '也可拖放到本页任意位置。',
  'upload.folders.emptyDrop': '将 PDF 拖到此处，或',
  'upload.folders.BL.title': 'BL / AWB',
  'upload.folders.BL.hint': '提单、主提单、空运单、主空运单',
  'upload.folders.I.title': '发票',
  'upload.folders.I.hint': '商业 / 形式发票 — 请放入所有页面',
  'upload.folders.PL.title': '装箱单',
  'upload.folders.PL.hint': '重量与包装',
  'upload.folders.COO.title': 'COO / E-COO',
  'upload.folders.COO.hint': '原产地证书（FTA 优惠）',
  'upload.folders.OTH.title': '其他',
  'upload.folders.OTH.hint': 'OF、SKI、LS、许可证、Excel 等 — JARVIS 自动识别类型',
  'upload.folders.typeAria': '文件类型',
  'upload.folders.typeOther': '其他类型…（移至“其他”）',
  'upload.folders.badgeSmart': '智能识别',
  'upload.folders.badgeDone': '已完成',
  'upload.folders.badgeCount': '{n} 个文件',
  'upload.folders.badgeRequired': '必填',
  'upload.folders.badgeOptional': '可选',
  'upload.folders.clickToPick': '点击选择',
  'upload.folders.addMore': '添加{folder}文件',
  'upload.folders.dropHere': '松开放入 → {folder}',
  'upload.folders.dropAllTitle': '一次拖入全部文件',
  'upload.folders.dropAllOr': '或',
  'upload.folders.dropAllAi': 'JARVIS 放入文件夹，由您确认。',
  'upload.folders.dropAllName': '按文件名放入文件夹，由您确认。',
  'upload.folders.dropAllLimits': 'PDF 和 Excel · 最多 {n} 个文件 · 每个 {mb} MB · {count}/{n}',
  'upload.folders.dropOverlay': '松开即由 JARVIS 分类 — 或直接拖到某个文件夹',
  'upload.folders.sorting': 'JARVIS 正在分类 {n} 个文件{progress}…',
  'upload.folders.andMore': '还有 {n} 个',
  'upload.folders.reading': 'JARVIS 读取中…',
  'upload.folders.detected': 'JARVIS · {pct}%',
  'upload.folders.dragHint': '拖到其他文件夹',
  'upload.folders.remove': '删除文件',
  'upload.folders.openSplitter': '打开拆分',
  'upload.folders.openSplitterHint': '打开页面拆分 — 将此文件拆成多份文件',
  'upload.folders.sortedAi': 'JARVIS 已分类 {pct}%',
  'upload.folders.sortedFilename': '按文件名分类',
  'upload.folders.mismatch': '文件内容识别为 {type}（{pct}%），而非{folder}。',
  'upload.folders.belongs': '识别为 {type} — 此文件有专属文件夹。',
  'upload.folders.moveTo': '移至{folder}',
  'upload.folders.keepIn': '保留在{folder}',
  'upload.folders.leaveHere': '保留',
  'upload.folders.bundle': '此文件包含 {n} 份文件：',
  'upload.folders.bundlePart': '{type} 第 {pages} 页',
  'upload.folders.unknownType': '类型未识别',
  'upload.folders.splitToFolders': '拆分到各自文件夹',
  'upload.folders.keepWhole': '全部保留为{folder}',
  'upload.folders.junk': '这看起来不是货运文件（把握 {pct}%）。',
  'upload.folders.skipFile': '忽略此文件',
  'upload.folders.suggestion': '第 {page} 页含有“{phrase}”。因位于{folderName}文件夹，仍按{folder}读取。',
  'upload.folders.movePageOut': '第 {page} 页其实是 {type} → 移至“其他”',
  'upload.folders.ok': '好的',
  'upload.folders.readFailed': 'JARVIS 无法读取此文件。类型保持为{folder}。',
  'upload.folders.readFailedOther': 'JARVIS 无法读取此文件。请自行选择类型。',
  'upload.folders.retry': '重新读取',
  'upload.folders.tooBigTitle': '文件过大',
  'upload.folders.tooBigMsg': '文件最大 {mb} MB，且不能上传空文件。',
  'upload.folders.excelToOther': 'Excel 文件已放入“其他” — 只有该文件夹接受 Excel。',
  'upload.folders.excelOnlyOther': 'Excel 文件只能放在“其他”文件夹。',
  'upload.folders.moved': '{name} 已移至{folder}。',
  'upload.folders.splitDone': '{name} 已拆分为 {n} 份文件，并放入各自文件夹。',
  'upload.folders.pageMoved': '第 {page} 页已移至“其他”。',
  'upload.folders.splitterTitle': '拆分页面',
  'upload.folders.checklistTitle': '完整性',
  'upload.folders.optional': '可选',
  'upload.folders.excelExempt': 'Excel 上传无需此项',
  'upload.folders.continue': '继续审核（{n} 份文件）',
  'upload.folders.reviewNext': '检查文件（{n} 份未检查）',
  'upload.folders.reviewNextHint': '打开下一份未检查的文件',
  'upload.folders.readyHint': '下一步：审核（类型和页面仍可修改）。',
  'upload.folders.tip': '放错文件夹？按住左侧 ⋮⋮ 把文件拖到其他文件夹（可反复拖，包括“其他”），或更改文件类型。',
  'upload.folders.otherTypesGroup': '其他文件类型',
  'upload.folders.noTypeFound': '未找到该类型',
  'upload.folders.dropToMove': '松开即移至{folder}',
  'upload.folders.startOver': '重新开始',
  'upload.folders.reason.empty': '请先添加必需的文件。',
  'upload.folders.reason.reading': 'JARVIS 仍在读取 {n} 个文件…',
  'upload.folders.reason.allSkipped': '所有文件都已忽略。请至少为一个文件选择类型。',
  'upload.folders.reason.needInvoice': '必须包含发票文件',
  'upload.folders.reason.untyped': '请为“其他”中的 {n} 个文件选择类型。',
  'upload.folders.reason.pending': '请先处理上方的待检查清单。',
  'upload.folders.startHint': '文件放入后，JARVIS 会按类型分组并显示预览，供您逐一检查。',
  'upload.folders.otherFolders': '或直接放入文件夹',
  'upload.folders.chipAdd': '点击添加{folder}文件',
  'upload.folders.chipShow': '点击查看{folder}文件',
  'upload.folders.preview.empty': '在左侧列表中选择文件以查看内容。',
  'upload.folders.preview.waiting': 'JARVIS 正在读取 {n} 个文件，文件进入文件夹后即可预览。',
  'upload.folders.preview.excel': 'Excel 文件无法预览，请确认文件名和类型正确。',
  'upload.folders.preview.failed': '预览加载失败，文件仍可上传。',
  'upload.folders.preview.page': '第 {n} / {total} 页',
  'upload.folders.preview.prevPage': '上一页',
  'upload.folders.preview.nextPage': '下一页',
  'upload.folders.preview.prev': '上一个文件',
  'upload.folders.preview.next': '下一个文件',
  'upload.folders.preview.split': '拆分页面',
  'upload.folders.preview.close': '关闭预览',
  'upload.folders.view': '查看',
  'upload.folders.viewing': '查看中',
  'upload.folders.preview.reading': '请等待 JARVIS 读完此文件。',
  'upload.folders.preview.needsType': '请先在列表中选择文件类型。',
  'upload.folders.preview.skipped': '此文件已忽略，不会上传。',
  'upload.folders.preview.hasWarning': '此文件在列表中有提醒，继续前也请处理。',
  'upload.folders.reason.unchecked': '还有 {n} 份文件未检查。',
  'upload.folders.check.label': '已检查',
  'upload.folders.check.tally': '已检查 {done}/{total}',
  'upload.folders.check.bar': '已检查 {done}/{total}',
  'upload.folders.check.scrollFirst': '请先点击“下一页”看完所有页面',
  'upload.folders.check.answerFirst': '请先处理此行的提醒',
  'upload.folders.reason.unapplied': '{n} 个文件已更改页面类型——请先点击“应用拆分”。',
  'upload.folders.panelWarn.bundleTitle': '此文件包含 {n} 份文件',
  'upload.folders.final.countDocs': '{n} 份文件',
  'upload.folders.final.note.pagesIgnored': '第 {pages} 页识别为{type}，保留在此文件中',
  'upload.folders.final.note.belongs': '识别为{type}，保留在其他',
  'upload.folders.panelWarn.title': '不是{folder}文件？',
  'upload.folders.panelWarn.mismatch': '此文件识别为{type}（{pct}%），而不是{folder}。请检查内容，放错了就移动。',
  'upload.folders.panelWarn.belongs': '此文件识别为{type}（{pct}%）——它有自己的文件夹。',
  'upload.folders.panelWarn.junkTitle': '不是货运单据？',
  'upload.folders.panelWarn.junk': '此文件似乎不是货运单据（{pct}%）。',
  'upload.folders.pager.prev': '上一页',
  'upload.folders.pager.next': '下一页',
  'upload.folders.pager.seen': '已看 {n}/{total} 页',
  'upload.folders.pageWarn.cut': '另一份文件从这里开始',
  'upload.folders.pageWarn.text': '第 {pages} 页识别为{type}，与文件夹{folder}不符。',
  'upload.folders.pageWarn.split': '拆分第 {pages} 页',
  'upload.folders.pageWarn.ignore': '保持不变',
  'upload.folders.pageWarn.marked': '第 {pages} 页将拆分为{type}。请点击上方的“应用拆分”。',
  'upload.folders.pageWarn.undo': '取消',
  'upload.folders.pageWarn.dot': '第 {n} 页：识别为{type}',
  'upload.folders.check.viewedWarning': '请先处理此文件行上的提醒，再勾选“已检查”。',
  'upload.folders.check.viewedReady': '如果此文件无误，请勾选预览下方的“已检查”。',
  'upload.folders.check.viewedTitle': '已到最后一页',
  'upload.folders.check.blockedTitle': '暂时无法勾选',
  'upload.folders.check.cta': '确认无误请勾选',
  'upload.folders.banner.text': '此文件包含不同的文件：{types}。要拆分吗？',
  'upload.folders.banner.split': '按建议拆分',
  'upload.folders.banner.ignore': '保持不变',
  'upload.folders.pages.marked': '已更改页面类型——将拆分为 {n} 份文件。',
  'upload.folders.pages.clear': '取消',
  'upload.folders.pages.apply': '应用拆分',
  'upload.folders.pages.tip': 'JARVIS 识别的页面类型，点击可更改。',
  'upload.folders.pages.outTip': '此页的类型与所在文件夹不同，点击可更改。',
  'upload.folders.pages.markedTip': '已由您更改（JARVIS：{type}）',
  'upload.folders.final.title': '处理前检查',
  'upload.folders.final.perFolder': '按文件夹',
  'upload.folders.final.count': '{n} 份文件 · {pages} 页',
  'upload.folders.final.notesTitle': '仍未处理的 AI 提示（{n}）',
  'upload.folders.final.note.mismatch': '识别为{type}，保留在{folder}',
  'upload.folders.final.note.bundle': '可能包含 {types}，未拆分',
  'upload.folders.final.note.suggestion': '第 {page} 页的建议（{type}）已忽略',
  'upload.folders.final.note.splitIgnored': '拆分建议（{types}）未采纳',
  'upload.folders.final.note.pagesLeftOut': '第 {pages} 页未上传',
  'upload.folders.final.aiCanErr': 'AI 可能出错。请确认每份文件都在正确的文件夹中且页面完整。',
  'upload.folders.final.ack': '我已检查所有文件',
  'upload.folders.final.back': '返回',
  'upload.folders.final.go': '处理',
  'review.check.title': '检查文件',
  'review.check.subtitle': '在 JARVIS 读取之前，请确认每份文件的类型和页面正确。',
  'review.check.pagesHint': '点击页码可跳过该页。悬停可预览页面。',
  'review.check.minOnePage': '至少需保留一页。',
  'review.check.pagesCount': '读取 {on}/{total} 页',
  'review.check.sorted': '由 JARVIS 分类 — 请再次确认',
  'review.check.warned': '曾有提示 — 请再次确认',
  'review.check.excel': 'Excel 文件 — 整份提交',
  'review.check.summary': '{docs} 份文件 · 将读取 {pages} 页',
  'review.check.changed': '相比上传有 {n} 处更改',
  'review.check.confirm': '确认并处理',
  'review.check.processing': '处理中…',
  'review.check.back': '返回文件夹',
  'review.check.pageLabel': '第 {n} 页',
  // Jarvis 2.0 processing modal: reads waiting for room, and a failed run (next-jarvis#910).
  'processing.retry.waiting':
    'AI 服务当前繁忙。JARVIS 正在持续重新读取此文件 — 已尝试 {attempt} 次（{elapsed}）。您的文件是安全的，请稍候。',
  'processing.readFailed.highTraffic':
    '{file} 在尝试 {attempt} 次后（{elapsed}）仍未能读取。未创建任何草稿 — 您的文件已保留，请重新处理。',
  'processing.readFailed.generic': '{file} 无法读取。未创建任何草稿 — 您的文件已保留。请检查文件后重新处理。',
  'processing.failed.generic': '处理失败。未创建任何草稿 — 您的文件已保留，请重新处理。',
  'processing.failed.retry': '重新处理',
  'processing.failed.back': '返回文件',
  'processing.elapsed.second.one': '{n}秒',
  'processing.elapsed.second.other': '{n}秒',
  'processing.elapsed.minute.one': '{n}分',
  'processing.elapsed.minute.other': '{n}分',
  'processing.elapsed.join': '{minutes}{seconds}',
  'upload.issuesTitle': '请检查文件类型',
  'upload.issuesIntro': '{n} 个文件的内容与所选类型不符。是否照原样继续？',
  'upload.issuesDeclared': '所选',
  'upload.issuesDetected': '识别',
  'upload.issuesBundle': '包含 {types} — 尚未拆分',
  'upload.issuesContinue': '继续',
  'upload.issuesReview': '再检查',
  'upload.waitDetection': '正在读取文件 {done}/{total} — 请等待完成',
  'upload.waitDetectionHint': '所有文件读取完成后按钮才可用',
  'upload.needsType': '选择类型',
  'upload.lowConfidence': '需复核 · {pct}%',
  'upload.confidence': '置信度 {pct}%',
  'upload.loadingPreview': '正在加载预览...',
  'upload.previewFailed': '无法显示预览',
  'upload.previewFailedMsg': '该文件仍可智能拆分并上传。',
  'upload.addSegment': '添加分段',
  'upload.segmentHint': '点击上方按钮，然后在缩略图上选择页面。',
  'upload.selectPages': '在缩略图上选择页面...',
  'upload.noPages': '还没有页面',
  'upload.pagesLabel': '页：{pages}',
  'upload.docTypePlaceholder': '文件类型',
  'upload.removeOriginal': '删除原始文件',
  'upload.extractSegments': '提取 {n} 个分段',
  'upload.activateSegmentFirst': '点击下方分段以先激活它',
  'upload.pageFreed': '第 {page} 页已从第 {seg} 段移出',
  'upload.pageFreedClickAgain': '第 {page} 页已从第 {seg} 段移出，再次点击可将其移入当前分段。',
  'upload.fileLimitReached': '达到文件上限',
  'upload.fileLimitReachedMsg': '无法添加分段：将超过 {n} 个文件的上限',
  'upload.segMinPages': '每个分段必须至少包含 1 页',
  'upload.segNeedType': '所有分段都必须有文件类型',
  'upload.segAllJunk': '所有分段都被标记为其他文件 — 没有可提取的内容',
  'upload.segJunkSuggest': '忽略？',
  'upload.exceedLimit': '超过 {n} 个文件的上限（当前 {cur}，将添加 {add}）',
  'upload.validationFailed': '验证失败',
  'upload.extractSuccess': '从 "{name}" 创建了 {n} 个文件',
  'upload.extractFailed': '拆分 PDF 失败',

  // Document type options (select/dropdown labels)
  'doctype.PL': '(PL) 装箱单',
  'doctype.I': '(I) 发票',
  'doctype.BL': '(BL) 提单',
  'doctype.MBL': '(MBL) 主提单',
  'doctype.SI': '(SI) 装运指示',
  'doctype.BR': '(BR) 订舱收据',
  'doctype.COO': '(COO) 原产地证书',
  'doctype.ECOO': '(E-COO) 电子原产地证书',
  'doctype.AWB': '(AWB) 空运单',
  'doctype.MAWB': '(MAWB) 主空运单',
  'doctype.LS': '(LS) 检验报告',
  'doctype.POSTEL': '(POSTEL) 邮政',
  'doctype.PI': '(PI) 进口许可',
  'doctype.AKL': '(AKL) 医疗器械注册号/卫生部',
  'doctype.SKI': '(SKI) BPOM 装运批准函',
  'doctype.SKB': '(SKBPPN) 进口增值税免税函',
  'doctype.SKBPPH': '(SKBPPH) 进口所得税第 22 条免税函',
  'doctype.SKBPP23': '(SKBPP23) PP 23 最终所得税免税函',
  'doctype.SNI': '(SNI) SNI',
  'doctype.VLEGAL': '(VLEGAL) V-LEGAL',
  'doctype.CITES': '(CITES) CITES',
  'doctype.HC': '(HC) 健康证书',
  'doctype.SKEPTPB': '(SKEPTPB) SKEP-TPB',
  'doctype.PE': '(PE) 出口许可',
  'doctype.SKEM': '(SKEM) SKEM',
  'doctype.SNISPBDEPDAG': '(SNISPBDEPDAG) SNISPBDEPDAG',
  'doctype.PP': '(PP) RB3 许可豁免 / B3 注册 / KLH',
  'doctype.EXC-JRE': '(CIPL - JRE) CIPL - JRE',
  'doctype.EXC-ARJUNA': '(CIPL - ARJUNA) CIPL - ARJUNA',
  'doctype.EXC-OBOR': '(CIPL - OBOR) CIPL - OBOR',
  'doctype.EXC-BENING': '(CIPL - BENING) CIPL - BENING',
  'doctype.EXC-NADA': '(CIPL - NADA) CIPL - NADA',
  'doctype.EXC-MINEBEA': '(CIPL - MINEBEA) CIPL - MINEBEA',
  'doctype.EXC-WIDE-SUCCESS': '(CIPL - WIDE SUCCESS) CIPL - WIDE SUCCESS',
  'doctype.EXC-NICESO': '(CIPL - NICESO) CIPL - NICESO',
  'doctype.EXC-CEISA': '(EXCEL CEISA) Excel CEISA',
  'doctype.SKEP': '(SKEP) SKEP',
  'doctype.980': '(980) Deklarasi Impor',
  'doctype.530': '(530) Polis Asuransi',
  'doctype.OF': '(OF) 海运费',
  'doctype.JUNK': '其他文件（忽略）',

  // HeaderForm
  'headerform.labelPelabuhan': '港口',
  'headerform.labelKantorPabean': '海关办公室',
  'headerform.labelPIB': 'PIB',
  'headerform.labelJenisImpor': '进口类型',
  'headerform.labelCaraBayar': '付款方式',
  'headerform.placeholderPelabuhan': '选择港口',
  'headerform.placeholderKantorPabean': '选择海关办公室',
  'headerform.placeholderPIB': '选择 PIB 类型',
  'headerform.placeholderJenisImpor': '选择进口类型',
  'headerform.placeholderCaraBayar': '选择付款方式',
  'headerform.pibOpt1': '1 - 普通 (BIASA)',
  'headerform.pibOpt2': '2 - 定期 (BERKALA)',
  'headerform.imporOpt1': '1 - 供自用 (UNTUK DIPAKAI)',
  'headerform.imporOpt2': '2 - 临时 (SEMENTARA)',
  'headerform.imporOpt5': '5 - 加急处理 (RUSH HANDLING)',
  'headerform.imporOpt9': '9 - 第 1 和第 2 类组合 (GABUNGAN 1 DAN 2)',
  'headerform.bayarOpt1': '1 - 普通/现金 (BIASA/TUNAI)',
  'headerform.bayarOpt2': '2 - 定期 (BERKALA)',
  'headerform.bayarOpt10': '10 - 分期延期付款（赊账）(OPEN ACCOUNT)',
  'headerform.bayarOpt11': '11 - 延期付款（赊账）现金结算 (OPEN ACCOUNT)',
  'headerform.bayarOpt12': '12 - 在国内以现金付款完成',
  'headerform.bayarOpt13': '13 - 在国内以电汇 (T/T) 付款完成',
  'headerform.bayarOpt14': '14 - 无付款完成',
  'headerform.bayarOpt15': '15 - 预付款 (ADVANCE PAYMENT)',
  'headerform.bayarOpt16': '16 - 即期信用证 (SIGHT LETTER OF CREDIT)',
  'headerform.bayarOpt17': '17 - 托收 (COLLECTION DRAFT)',

  // DokumenForm
  'dokumenform.col.seri': '序号',
  'dokumenform.col.jenis': '类型',
  'dokumenform.col.ecooStatus': 'eCOO 状态',
  'dokumenform.col.nomor': '号码',
  'dokumenform.col.tanggal': '日期',
  'dokumenform.col.fasilitas': '设施',
  'dokumenform.col.kodeIjin': '许可代码',
  'dokumenform.col.attached': '已附',
  'dokumenform.col.state': '状态',
  'dokumenform.col.aksi': '操作',

  'dokumenform.action.attachToBarang': '附加到货物',
  'dokumenform.action.edit': '编辑',
  'dokumenform.action.copy': '复制',
  'dokumenform.action.uploadReplace': '上传 / 替换文件',
  'dokumenform.action.uploadReplaceAria': '上传或替换文件',
  'dokumenform.action.delete': '删除',
  'dokumenform.action.deleteLastBlocked': '无法删除最后一份文件 — CEISA 至少需要 2 份文件',
  'dokumenform.action.undo': '撤销',
  'dokumenform.deleted.title': '已删除的文件',
  'dokumenform.deleted.hint': '这些文件不会显示在文件标签页中，也不会提交给 CEISA。如果误删，可以恢复。',
  'dokumenform.deleted.restore': '恢复',

  'dokumenform.bulk.total': '总计：{count}',
  'dokumenform.bulk.selected': '已选 {count}',
  'dokumenform.bulk.selectAll': '选择所有文件',
  'dokumenform.bulk.selectRow': '选择文件 {serial}',
  'dokumenform.bulk.clear': '取消选择',
  'dokumenform.bulk.edit': '编辑',
  'dokumenform.bulk.editTooltip': '批量编辑所选文件',
  'dokumenform.bulk.duplicate': '复制',
  'dokumenform.bulk.duplicateTooltip': '复制所选文件',
  'dokumenform.bulk.attach': '附加',
  'dokumenform.bulk.attachTooltip': '将所选文件附加到货物',
  'dokumenform.bulk.delete': '删除',
  'dokumenform.bulk.deleteTooltip': '删除所选文件',
  'dokumenform.bulk.cancel': '取消',
  'dokumenform.bulk.apply': '应用',
  'dokumenform.bulk.successTitle': '成功',
  'dokumenform.bulk.errorTitle': '失败',
  'dokumenform.bulk.noNumber': '（无编号）',
  'dokumenform.bulk.editTitle': '批量编辑文件',
  'dokumenform.bulk.editCount': '正在修改 {count} 份文件',
  'dokumenform.bulk.editHint': '留空的字段保持不变。此处不会修改文件代码和编号。',
  'dokumenform.bulk.fieldDate': '文件日期',
  'dokumenform.bulk.fieldDatePlaceholder': '选择日期',
  'dokumenform.bulk.fieldFacility': '便利代码',
  'dokumenform.bulk.fieldFacilityPlaceholder': '选择便利',
  'dokumenform.bulk.fieldIjin': '许可代码',
  'dokumenform.bulk.fieldIjinPlaceholder': '输入许可代码',
  'dokumenform.bulk.fieldStatus': '状态',
  'dokumenform.bulk.statusUnchanged': '不变',
  'dokumenform.bulk.editSuccess': '已更新 {count} 份文件',
  'dokumenform.bulk.duplicateTitle': '复制文件',
  'dokumenform.bulk.duplicateConfirm': '复制 {count} 份文件？副本的编号为空，需要重新填写。',
  'dokumenform.bulk.duplicateSuccess': '已复制 {count} 份文件。请填写新文件的编号。',
  'dokumenform.bulk.emptyNomorExists': '仍有 {kode} 文件没有编号，请先填写编号再复制。',
  'dokumenform.bulk.nomorRequired': '必须填写编号',
  'dokumenform.bulk.attachTitle': '附加到货物',
  'dokumenform.bulk.attachCount': '将 {count} 份文件附加到下方所选货物',
  'dokumenform.bulk.modeAdd': '添加到现有附件',
  'dokumenform.bulk.modeReplace': '替换附件',
  'dokumenform.bulk.replaceWarning': '{count} 份文件的现有附件将被替换。',
  'dokumenform.bulk.skippedList': '已跳过，无法附加到货物：{list}',
  'dokumenform.bulk.allSkipped': '所选文件均无法附加到货物。',
  'dokumenform.bulk.selectAllBarang': '选择所有货物',
  'dokumenform.bulk.barangPicked': '已选 {count} 项货物',
  'dokumenform.bulk.noBarang': '此草稿尚无货物。',
  'dokumenform.bulk.attachSuccess': '已将货物附加到 {count} 份文件',
  'dokumenform.bulk.deleteTitle': '删除 {count} 份文件',
  'dokumenform.bulk.deleteLinks': '将移除 {count} 个货物附件。',
  'dokumenform.bulk.deleteRestorable': '删除后仍可通过“撤销”恢复这些文件。',
  'dokumenform.bulk.blockMinOne': '至少需要保留 1 份文件。',
  'dokumenform.bulk.blockRequiredCode': '不能删除最后一份 {kode} 文件。',
  'dokumenform.bulk.deleteSuccess': '已删除 {count} 份文件',
  'dokumenform.bulk.undo': '撤销',
  'dokumenform.bulk.undoSuccess': '文件已恢复',
  'dokumenform.bulk.unknownSerial': '文件列表已更改。请重新加载页面后重试。',
  'dokumenform.bulk.flushFailed': '待保存的文件更改未能保存，因此未执行批量操作。请重试。',
  'dokumenform.bulk.genericError': '批量操作失败。请重试。',

  'dokumenform.modal.attachTitle': '将文档附加到货物',
  'dokumenform.modal.replaceTitle': '替换当前选择？',
  'dokumenform.modal.uploadPdfTitle': '上传 PDF 文档',

  'dokumenform.label.quickSelect': '快速选择（范围输入）',
  'dokumenform.label.filterHsCode': '按 HS 编码筛选',
  'dokumenform.label.bulkSeriIjin': '批量许可序号',
  'dokumenform.label.filePdf': 'PDF 文件',
  'dokumenform.label.tipeDokumen': '文档类型',

  'dokumenform.placeholder.rangeExample': '示例：1-2,3,5-8,10（使用项目编号，而非索引）',
  'dokumenform.placeholder.filterHsCode': '输入 HS 编码筛选（例如 9403）',
  'dokumenform.placeholder.value': '值',
  'dokumenform.placeholder.pilihFilePdf': '选择 PDF 文件',
  'dokumenform.placeholder.url': 'https://... (House-BL / AWB / 支持文档)',

  'dokumenform.button.batal': '取消',
  'dokumenform.button.simpan': '保存',
  'dokumenform.button.menyimpan': '保存中...',
  'dokumenform.button.unggahDokumen': '上传 PDF',
  'dokumenform.button.isiManual': '手动填写',
  'dokumenform.reread.upload.title': '上传文档',
  'dokumenform.reread.match2.colSeriIjin': '许可序号',
  'dokumenform.reread.match2.izinHint': '许可序号（文件上的行号）读取到时会自动填写——请核对并补全空白项。',
  'dokumenform.reread.izinFilled': '已为此文档已关联的 {n} 项货物填写许可序号。',
  'dokumenform.reread.progress.waiting': '等待读取…',
  'dokumenform.reread.error.runNotFinished': 'JARVIS 仍在处理此草稿，请在完成后重试。',
  'dokumenform.reread.progress.starting': '开始中…',
  'dokumenform.reread.progress.reading': '正在读取 PDF（{pages} 页）…',
  'dokumenform.reread.progress.tabs': '正在填写标签（{done}/{total}）…',
  'dokumenform.reread.progress.eta': '约剩 {s} 秒',
  'dokumenform.reread.progress.queue': '{n} 个文档中 {ready} 个已就绪（同时读取）',
  'dokumenform.reread.multi.listTitle': '识别到的文档（{n}）',
  'dokumenform.reread.match2.title': '将货物关联到 {doc}',
  'dokumenform.reread.match2.body':
    'JARVIS 自动匹配为此文档建议了 {n} 项货物（已关联 {existing} 项）。勾选的将被关联。',
  'dokumenform.reread.match2.save': '保存关联（{n}）',
  'dokumenform.reread.match2.saved': '已关联 {n} 项货物。',
  'dokumenform.reread.match2.by.both': 'HS + 描述',
  'dokumenform.reread.match2.by.hs_code': 'HS',
  'dokumenform.reread.match2.by.description': '描述',
  'dokumenform.reread.match2.by.prebaked': 'JARVIS 数据',
  'dokumenform.reread.match2.by.coverage': '唯一货物',
  'dokumenform.reread.match2.by.count': '数量相同',
  'dokumenform.reread.fill.title': '补全货物',
  'dokumenform.reread.fill.section': '补全已有货物（{n} 项）',
  'dokumenform.reread.fill.hint': '文档可补全的空白货物字段已勾选；与当前值不同的不勾选。',
  'dokumenform.reread.fill.seri': '第 {n} 项 · {uraian}',
  'dokumenform.reread.fill.kosong': '空白',
  'dokumenform.reread.fill.newLines': '新货物（{n}）',
  'dokumenform.reread.fill.optionTitle': '用已有文档补全货物',
  'dokumenform.reread.fill.optionBody':
    'JARVIS 重新读取本草稿的发票和装箱单，补全空白的货物字段（包装、重量、品牌等）。由您选择应用哪些。',
  'dokumenform.reread.fill.optionButton': '补全货物',
  'dokumenform.reread.field.jumlah_kemasan': '包装数量',
  'dokumenform.reread.field.kode_jenis_kemasan': '包装类型',
  'dokumenform.reread.field.netto': '净重 (kg)',
  'dokumenform.reread.field.bruto': '毛重 (kg)',
  'dokumenform.reread.field.volume': '体积',
  'dokumenform.reread.field.kode_negara_asal': '原产国',
  'dokumenform.reread.field.merk': '品牌',
  'dokumenform.reread.field.tipe': '型号',
  'dokumenform.reread.field.ukuran': '尺寸',
  'dokumenform.reread.field.spesifikasi_lain': '其他规格',
  'dokumenform.reread.field.kode_barang': '商品编码',
  'dokumenform.reread.multi.subtitleSorted':
    '检查 JARVIS 的拆分结果：移动放错文件夹的文档，预览后用 JARVIS 读取。空白的货物字段也会由这些文档补全。',
  'dokumenform.reread.multi.subtitle': '上传 PDF——JARVIS 会拆分其中的文档并按类型分组。',
  'dokumenform.reread.multi.dropTitle': '在此上传 PDF',
  'dokumenform.reread.multi.dropBody': '拖入一个或多个 PDF（提单、发票、装箱单合并在一个文件中也可以），或',
  'dokumenform.reread.multi.klikPilih': '点击选择',
  'dokumenform.reread.multi.dropLimits': '仅限 PDF · 每次最多 {n} 个文档',
  'dokumenform.reread.multi.dropMore': '继续添加 PDF',
  'dokumenform.reread.multi.splitting': 'JARVIS 正在拆分文档…（{done}/{total} 个文件）',
  'dokumenform.reread.multi.detected': '识别为 {jenis} · {pct}%',
  'dokumenform.reread.multi.notDetected': '未识别类型——请选择',
  'dokumenform.reread.multi.preview': '预览 PDF',
  'dokumenform.reread.multi.previewTitle': '预览 — {file}',
  'dokumenform.reread.multi.splitFrom': '拆分自 {file}，第 {pages} 页',
  'dokumenform.reread.multi.mulaiUlang': '重新开始',
  'dokumenform.reread.multi.jenis': '类型',
  'dokumenform.reread.multi.untuk': '用途',
  'dokumenform.reread.multi.baru': '新文档',
  'dokumenform.reread.multi.tambahan': '{doc} 的附加页',
  'dokumenform.reread.multi.semua': '全部',
  'dokumenform.reread.multi.none': '尚无文件。请将 PDF 拖入对应文件夹。',
  'dokumenform.reread.multi.needType': '请为“其他”中的文件选择类型。',
  'dokumenform.reread.multi.tooMany': '每次最多上传 {n} 个文档。',
  'dokumenform.reread.multi.uploading': '正在上传第 {i}/{n} 个…',
  'dokumenform.reread.multi.ready': '{n} 个文档可读取。',
  'dokumenform.reread.multi.baca': '用 JARVIS 读取 ({n})',
  'dokumenform.reread.multi.queue': '第 {i}/{n} 个文档',
  'dokumenform.reread.multi.lewati': '跳过',
  'dokumenform.reread.match.title': '该文档已在草稿中',
  'dokumenform.reread.match.body': '{jenis} 编号 {nomor} 与文档标签第 {n} 行相同。',
  'dokumenform.reread.match.merge': '合并到现有文档（推荐）',
  'dokumenform.reread.match.mergeHint': '此文件的页面将添加到该文档并重新读取。不会新增文档行，相同货物不勾选。',
  'dokumenform.reread.match.new': '作为新文档添加',
  'dokumenform.reread.match.newHint': '将创建编号相同的第二个文档行。',
  'dokumenform.reread.match.go': '合并并重新读取',
  'dokumenform.reread.upload.pages': '要读取的页面',
  'dokumenform.reread.upload.pagesAll': '全选',
  'dokumenform.reread.upload.pagesNone': '清空',
  'dokumenform.reread.upload.pagesMax': '每次最多读取 {n} 页。',
  'dokumenform.reread.upload.pdfUnreadable': '无法打开该 PDF。',
  'dokumenform.reread.reading': 'JARVIS 正在读取…',
  'dokumenform.reread.failedTitle': '无法重新读取该文档',
  'dokumenform.reread.retry': '重试',
  'dokumenform.reread.error.start': '无法开始重新读取。',
  'dokumenform.reread.error.apply': '无法应用更改。',
  'dokumenform.reread.ask.title': '文件已替换。用 JARVIS 重新读取此文档？',
  'dokumenform.reread.ask.ya': '是',
  'dokumenform.reread.ask.tidak': '否',
  'dokumenform.reread.preview.title': '重新读取预览 — {jenis} {nomor}',
  'dokumenform.reread.preview.titleReading': '重新读取文档',
  'dokumenform.reread.preview.nothing': '此文档没有读取到任何更改。',
  'dokumenform.reread.tab.barang': '货物',
  'dokumenform.reread.tab.header': '表头',
  'dokumenform.reread.tab.entitas': '实体',
  'dokumenform.reread.tab.pengangkut': '运输',
  'dokumenform.reread.tab.transaksi': '交易',
  'dokumenform.reread.tab.dokumen': '文档',
  'dokumenform.reread.tab.links': '关联',
  'dokumenform.reread.col.seri': 'Seri',
  'dokumenform.reread.col.uraian': '描述',
  'dokumenform.reread.col.qty': '数量',
  'dokumenform.reread.col.nilai': '金额',
  'dokumenform.reread.col.field': '字段',
  'dokumenform.reread.col.sekarang': '当前',
  'dokumenform.reread.col.terbaca': '读取值',
  'dokumenform.reread.col.confidence': '置信度',
  'dokumenform.reread.col.seriBarang': '货物序号',
  'dokumenform.reread.col.dokumen': '文档',
  'dokumenform.reread.col.seriIjin': '许可序号',
  'dokumenform.reread.duplicate': '与货物序号 {n} 相似',
  'dokumenform.reread.total.hargaBarang': '货物价值',
  'dokumenform.reread.total.beratBersih': '净重',
  'dokumenform.reread.total.beratKotor': '毛重',
  'dokumenform.reread.total.freight': '运费',
  'dokumenform.reread.freightAdjust': '运费已调整：−{removed} / +{added}',
  'dokumenform.reread.applyTotals': '应用合计',
  'dokumenform.reread.warning.KEMASAN_NOT_RECOMPUTED': '包装和集装箱不会重新计算。',
  'dokumenform.reread.warning.OLD_BARANG_KEPT': '旧文件中的货物不会自动删除。',
  'dokumenform.reread.warningTitle': '注意',
  'dokumenform.reread.apply': '应用 ({n})',
  'dokumenform.reread.applied': '已添加 {lines} 条货物和 {links} 条关联。',
  'dokumenform.reread.supporting.title': '辅助页面',
  'dokumenform.reread.supporting.note': '（不发送至 CEISA）',
  'dokumenform.reread.supporting.file': '文件',
  'dokumenform.reread.supporting.halaman': '页面',
  'dokumenform.reread.supporting.jenis': '类型',
  'dokumenform.reread.supporting.freight': '读取的运费',
  'dokumenform.reread.supporting.semua': '全部',
  'dokumenform.reread.supporting.pilihJenis': '选择类型',
  'dokumenform.reread.supporting.retype': '更改类型并重新读取',
  'dokumenform.reread.readingHint': '通常需要 1–2 分钟。草稿尚未更改。',
  'dokumenform.reread.fieldsHint': '默认未勾选——请选择要替换当前内容的读取值。',
  'dokumenform.reread.tetap': '不变',
  'dokumenform.reread.upload.hal': '页',
  'dokumenform.reread.upload.pdfOnly': '只能上传 PDF 文件。',
  'dokumenform.reread.upload.hapusFile': '移除文件',
  'dokumenform.reread.upload.needBatch': '草稿数据未就绪，请刷新页面。',
  'dokumenform.reread.field.port_code': '港口',
  'dokumenform.reread.field.pabean_office_code': '海关办公室',
  'dokumenform.reread.field.pib_type': 'PIB 类型',
  'dokumenform.reread.field.import_type': '进口类型',
  'dokumenform.reread.field.payment_type': '付款方式',
  'dokumenform.reread.field.importer_identity_no': '进口商证件号',
  'dokumenform.reread.field.importer_name': '进口商名称',
  'dokumenform.reread.field.importer_address': '进口商地址',
  'dokumenform.reread.field.owner_identity_no': '货主证件号',
  'dokumenform.reread.field.owner_name': '货主名称',
  'dokumenform.reread.field.owner_address': '货主地址',
  'dokumenform.reread.field.sender_name': '发货人名称',
  'dokumenform.reread.field.sender_address': '发货人地址',
  'dokumenform.reread.field.sender_country_code': '发货人国家',
  'dokumenform.reread.field.seller_name': '卖方名称',
  'dokumenform.reread.field.seller_address': '卖方地址',
  'dokumenform.reread.field.seller_country_code': '卖方国家',
  'dokumenform.reread.field.nomor_bc11': 'BC 1.1 编号',
  'dokumenform.reread.field.tanggal_tutup_pu': 'BC 1.1 日期',
  'dokumenform.reread.field.nomor_pos': 'Pos 编号',
  'dokumenform.reread.field.nomor_subpos': '子 Pos 编号',
  'dokumenform.reread.field.cara_pengangkutan_code': '运输方式',
  'dokumenform.reread.field.nama_sarana_pengangkutan': '运输工具名称',
  'dokumenform.reread.field.nomor_voy': '航次/航班号',
  'dokumenform.reread.field.bendera_code': '船旗',
  'dokumenform.reread.field.perkiraan_tanggal_tiba': '预计到达 (ETA)',
  'dokumenform.reread.field.pelabuhan_muat_code': '装货港',
  'dokumenform.reread.field.pelabuhan_transit_code': '中转港',
  'dokumenform.reread.field.pelabuhan_tujuan_code': '目的港',
  'dokumenform.reread.field.tempat_penimbunan_code': '堆存地点',
  'dokumenform.reread.field.valuta_code': '币种',
  'dokumenform.reread.field.jenis_transaksi_code': '交易类型',
  'dokumenform.reread.field.incoterm_code': '贸易术语',
  'dokumenform.reread.field.freight': '运费',
  'dokumenform.reread.field.kode_asuransi': '保险类型',
  'dokumenform.reread.field.asuransi': '保险',
  'dokumenform.reread.field.nilai_asuransi': '保险金额',
  'dokumenform.reread.field.document_no': '文档编号',
  'dokumenform.reread.field.date': '文档日期',
  'dokumenform.reread.field.facility_code': '便利',
  'dokumenform.button.upload': '上传',
  'dokumenform.button.applyToSelected': '应用到已选 ({n})',
  'dokumenform.button.clearSelection': '清除选择',
  'dokumenform.button.replaceSelection': '替换选择',
  'dokumenform.button.autoMatch': '自动匹配',
  'dokumenform.button.autoMatchEcoo': '从 E-COO 自动匹配',
  'dokumenform.button.validateEcoo': '验证 eCOO',
  'dokumenform.button.autoSort': '自动排序',
  'dokumenform.total': '总计: {n}',

  'dokumenform.notify.success': '成功',
  'dokumenform.notify.successTitle': '成功',
  'dokumenform.notify.errorTitle': '错误',
  'dokumenform.notify.failed': '失败',
  'dokumenform.notify.cannotUpload': '暂不能上传',
  'dokumenform.notify.saveRowFirst': '请先保存文档行，再替换文件。',
  'dokumenform.notify.formatNotSupported': '不支持的格式',
  'dokumenform.notify.onlyPdfExcel': '仅允许 PDF 或 Excel（.xlsx/.xls/.csv）文件。',
  'dokumenform.notify.uploaded': '{name} 已上传',
  'dokumenform.notify.uploadFailed': '文件上传失败',
  'dokumenform.notify.urlSaveFailed': '文档 URL 保存失败',
  'dokumenform.notify.documentAdded': '文档添加成功',
  'dokumenform.notify.documentUpdated': '文档更新成功',
  'dokumenform.notify.documentAddFailed': '保存新文档失败',
  'dokumenform.notify.documentEditFailed': '保存编辑后的文档失败',
  'dokumenform.notify.documentCopied': '文档复制成功',
  'dokumenform.notify.documentCopyFailed': '保存复制的文档失败',
  'dokumenform.notify.documentDeleted': '文档删除成功',
  'dokumenform.notify.documentDeleteFailed': '删除文档后保存更改失败',
  'dokumenform.notify.cannotDeleteLastDocument': '至少需要保留一份文件。CEISA 提交至少需要 2 份文件。',
  'dokumenform.notify.documentRestored': '文件恢复成功',
  'dokumenform.notify.documentRestoreFailed': '恢复文件失败',
  'dokumenform.notify.stateChangedTo': '文档状态已更改为 {state}',
  'dokumenform.notify.stateUpdateFailed': '更新文档状态失败',
  'dokumenform.notify.autoMatch': '自动匹配',
  'dokumenform.notify.noAutoMatch': '未找到此文档的确定匹配。请手动选择货物。',
  'dokumenform.notify.processIdNotFound': '未找到流程 ID',
  'dokumenform.notify.serialNotFound': '未找到文档序列号',
  'dokumenform.notify.attachedToBarang': '文档已附加到 {count} 个货物',
  'dokumenform.notify.attachedPartial':
    '文档已附加到 {requested} 个货物中的 {count} 个。{dropped} 个货物被拒绝，因为它们已附加到相同代码的其他文档。',
  'dokumenform.notify.attachFailed': '保存货物附件失败',
  'dokumenform.notify.pleaseSelectPdf': '请先选择 PDF 文件',
  'dokumenform.notify.pdfExtracted': '文档已从 PDF 成功提取',
  'dokumenform.notify.pdfExtractedWithEntitas': '文档已从 PDF 成功提取，实体标签页已同步更新',
  'dokumenform.notify.pdfUploadError': '上传 PDF 时发生错误',
  'dokumenform.notify.orderUpdated': '文档顺序更新成功',
  'dokumenform.notify.orderSaveFailed': '保存文档顺序失败',
  'dokumenform.notify.orderAlreadySorted': '文档顺序已正确',
  'dokumenform.notify.validationFailed': '验证失败',
  'dokumenform.notify.npwpRequired': 'eCOO 验证需要填写进口商 NPWP',
  'dokumenform.notify.npwpInvalid': '进口商 NPWP 无效',
  'dokumenform.notify.noDocsToValidate': '没有可验证的文档',
  'dokumenform.notify.ecooInvalid': 'eCOO 文档无效',
  'dokumenform.notify.ajuRequired': 'eCOO 验证需要填写 AJU 号码（提单号）',
  'dokumenform.notify.validationSuccess': '验证成功',
  'dokumenform.notify.ecooValidated': 'eCOO 验证成功',
  'dokumenform.notify.ecooValidationFailed': 'eCOO 验证失败',
  'dokumenform.notify.ecooError': '验证 eCOO 时发生错误',

  'dokumenform.barang.selectPrompt': '选择此文档应附加到的货物：',
  'dokumenform.barang.findingEcoo': '正在从 E-COO 行项目查找建议的货物…',
  'dokumenform.barang.finding': '正在为此文档查找建议的货物…',
  'dokumenform.barang.autoMatchShipment': '自动匹配：此托运为单一货物，因此此文档涵盖它（见下方徽章）——保存前请复查。',
  'dokumenform.barang.noAutoMatchEcoo': '未为此 E-COO 找到确定的自动匹配——请手动选择货物。',
  'dokumenform.barang.noAutoMatch': '未为此文档找到确定的自动匹配（配对不明确）——请手动选择货物。',
  'dokumenform.barang.colSeriBarang': '货物序号',
  'dokumenform.barang.colHsCode': 'HS 编码',
  'dokumenform.barang.colNamaBarang': '货物名称',
  'dokumenform.barang.colNoUrut': '许可序号',
  'dokumenform.barang.noItemsMatch': '没有与 HS 编码 "{hs}" 匹配的项目',
  'dokumenform.barang.noBarang': '没有可用货物。请先添加货物。',
  'dokumenform.barang.loading': '正在加载货物...',
  'dokumenform.barang.showingCount': '显示 {count} / {total} 个项目',
  'dokumenform.barang.filterDescription': '按 HS 编码筛选货物',
  'dokumenform.barang.replacePrompt':
    '自动匹配将用为此文档建议的集合替换当前选中的 {count} 个货物。在您点击保存前不会保存任何内容。',
  'dokumenform.barang.rangeDescription':
    '输入货物项目编号，用逗号分隔。使用短横线表示范围（例如 1-5 表示项目 1,2,3,4,5）',
  'dokumenform.barang.unamed': '未命名',
  'dokumenform.barang.suggestedCoverage': '建议 · {label}',
  'dokumenform.barang.suggestedConfidence': '建议 · {confidence} · {percent}%',
  'dokumenform.barang.ecooItem': 'E-COO 项目: {desc}',
  'dokumenform.popover.autoMatch': '自动匹配',
  'dokumenform.popover.loading': '加载中…',
  'dokumenform.popover.noAutoMatchData': '无自动匹配数据——已手动附加',
  'dokumenform.popover.seri': '序号 {n}',
  'dokumenform.popover.wholeShipment': '整个托运',
  'dokumenform.popover.sameHsCode': 'HS 编码相同 ·',
  'dokumenform.popover.andMore': '…还有 {n} 个',
  'dokumenform.popover.moreMatch': '{n} 个货物匹配此文档但未附加',
  'dokumenform.file.downloadAria': '下载 {name}',
  'dokumenform.file.replaceTooltip': '替换文件',
  'dokumenform.file.uploadTooltip': '上传文件',
  'dokumenform.file.replaceAria': '替换文件',
  'dokumenform.file.uploadAria': '上传文件',
  'dokumenform.file.uploading': '上传中…',
  'dokumenform.file.replaceUploading': '正在替换文件…',
  'dokumenform.file.noUrlInResponse': '响应中不包含新的文件 URL',
  'dokumenform.barang.statusSuggested': '已自动勾选 {count} / {total} 个货物。保存前请复查。',
  'dokumenform.barang.legend':
    '绿色徽章：与证书行项目匹配。黄色徽章：匹配度较弱。无徽章：未匹配，仅当证书涵盖时手动勾选。',
  'dokumenform.barang.legendWithCount':
    '绿色徽章：与证书行项目匹配。黄色徽章：证书行数与货物数相同，其余货物很可能也被涵盖。保存前请复查。',
  'dokumenform.barang.claimedNote': '{count} 个货物已附加到其他证书，无法在此勾选。如需移动，请先在那里解除。',
  'dokumenform.barang.showUnmatched': '查看 {count} 个未匹配的货物',
  'dokumenform.barang.hideUnmatched': '隐藏 {count} 个未匹配的货物',
  'dokumenform.barang.suggestedHigh': '建议 {percent}%',
  'dokumenform.barang.suggestedMedium': '可能匹配 {percent}%',
  'dokumenform.barang.suggestedCount': '建议，数量相同',
  'dokumenform.barang.countTooltip': '此证书有 {n} 行，与货物数量相同。该货物未按文本匹配，但很可能被涵盖。',
  'dokumenform.barang.suggestedHsCode': '建议，HS 编码相同',
  'dokumenform.barang.hsCodeTooltip': 'HS 编码与文件中列出的相同：{hs}',
  'dokumenform.barang.claimedBadge': '已在序号 {seri}',
  'dokumenform.barang.claimedTooltip': '该货物已附加到相同代码的序号 {seri} 文档。请先在那里解除，再移到此处。',
  'dokumenform.button.selectAll': '全选 ({n})',
  'dokumenform.button.deselectAll': '清空',
  'dokumenform.button.simpanCount': '保存（{n} 个货物）',
  'dokumenform.barang.more': '+{n} 更多',
  'dokumenform.confidence.overall': '总体置信度',
  'dokumenform.confidence.documentNumber': '文档编号置信度',
  'dokumenform.confidence.documentDate': '文档日期置信度',

  // <i18n-anchor-dokumenform>
  // <i18n-anchor-entitasform>
  'entitasform.entitas': '实体',
  'entitasform.nibWajibDiisi': 'NIB 必填',
  'entitasform.nibPerluDicek': '此 NIB 取自该 NPWP 另一种写法的既往申报，提交前请核对。',
  'entitasform.errNibImportirWajib': '进口商 NIB 必填',
  'entitasform.errNibImportir13Digit': '进口商 NIB 必须为 13 位数字',
  'entitasform.errNamaImportirWajib': '进口商名称必填',
  'entitasform.errJenisApiImportirWajib': '进口商 API 类型必填',
  'entitasform.errJenisIdentitasWajib': '证件类型必填',
  'entitasform.errNpwpImportirWajib': '进口商 NPWP 必填',
  'entitasform.errAlamatImportirWajib': '进口商地址必填',
  'entitasform.errStatusImportirWajib': '进口商状态必填',
  'entitasform.errFieldWajibDiisi': '此字段必填',
  'entitasform.successTitle': '成功',
  'entitasform.successMessage': '实体数据加载成功！',
  'entitasform.titlePemilikBarang': '货主',
  'entitasform.titlePemusatan': '集中地',
  'entitasform.titlePengirim': '发货人',
  'entitasform.titlePenjual': '卖方',
  'entitasform.titlePpjk': 'PPJK',
  'entitasform.actionSalinImportir': '复制进口商',
  'entitasform.actionSalinDataPengirim': '复制发货人数据',
  'entitasform.importir': '进口商',
  'entitasform.fieldJenis': '类型',
  'entitasform.fieldNpwp': 'NPWP {title}',
  'entitasform.fieldNama': '名称 {title}',
  'entitasform.fieldNegara': '国家 {title}',
  'entitasform.fieldAlamat': '地址 {title}',
  'entitasform.fieldStatus': '状态',
  'entitasform.fieldApiNib': 'API/NIB',
  'entitasform.fieldNib': 'NIB',
  'entitasform.fieldAfiliasi': '关联',
  'entitasform.syncDariJarvis': '从 Jarvis 同步',
  'entitasform.syncPerluDiperiksa': '与最近一次申报不同 — 从 Jarvis 获取数据',
  'entitasform.pilihDataDariJarvis': '从 Jarvis 选择 {title} 数据',
  'entitasform.syncGagal': '同步失败',
  'entitasform.tidakAdaDataJarvis': 'Jarvis 中此 NPWP 没有数据。',
  'entitasform.gagalSyncJarvis': '从 Jarvis 同步数据失败。',
  'entitasform.npwpBelumLengkap': 'NPWP 不完整',
  'entitasform.npwpHarus16Digit': 'NPWP 必须为 16 位才能从 Jarvis 同步。',
  'entitasform.diterapkan': '已应用',
  'entitasform.pilihDariRiwayat': '从文档历史中选择',
  'entitasform.dataConsigneeSumber': '收货人数据',
  'entitasform.bukaDiConsignee': '在收货人数据中打开',
  'entitasform.bukaConsignee': '打开收货人数据',
  'entitasform.riwayatDokumenCount': '文档历史（{count}）',
  'entitasform.diperbaruiTanggal': '更新于 {date}',
  'entitasform.belumAdaDiConsignee':
    '此进口商尚未在 主数据 › 收货人数据 中。文档成功提交到 CEISA 后，进口商数据将自动保存为主要来源。',
  'entitasform.belumAdaDiConsigneeSingkat': '尚未在收货人数据中。文档成功提交到 CEISA 后将自动保存。',
  'entitasform.dataMasterTidakBisaDitandai': '收货人数据在主数据菜单中管理，不能在此标记为错误。',
  'entitasform.riwayatTidakDapatDimuat': '无法加载文档历史',
  'entitasform.dibukaDiTabBaru': '在新标签页中打开：主数据 › 收货人数据',
  'entitasform.dataConsigneeSeksi': '收货人数据',
  'entitasform.consigneeTerpakai': '收货人数据已应用到进口商。',
  'entitasform.simpanKeConsignee': '保存到收货人数据',
  'entitasform.simpanKeConsigneeHint': '保存此进口商，下次文档将自动填写。',
  'entitasform.tersimpanKeConsignee': '已保存到收货人数据',
  'entitasform.tersimpanKeConsigneeMsg': '从现在起，此进口商将根据其 NPWP 自动填写。',
  'entitasform.consigneeSudahAda': '此 NPWP 已在收货人数据中。',
  'entitasform.gagalSimpanConsignee': '保存到收货人数据失败。',
  'entitasform.dataDiterapkanSection': 'Jarvis 数据已应用到分区。',
  'entitasform.dataDiterapkanImportir': 'Jarvis 数据已应用到进口商。',
  'entitasform.gagalMenyimpanEntitas': '保存实体失败',
  'entitasform.dataHistoricalBelumTersimpan': '历史数据已应用，但尚未保存。',
  'entitasform.disinkronDariRiwayat': '已从历史文档同步',
  'entitasform.dataDariDokumenSebelumnya': '此数据取自以前的文档。提交前请检查并调整。',
  'entitasform.optMita': 'MITA',
  'entitasform.optAeo': 'AEO',
  'entitasform.optLainnya': '其他',
  'entitasform.optApiU': 'API U',
  'entitasform.optApiP': 'API P',
  'entitasform.optPaspor': '2 - 护照',
  'entitasform.optKtp': '3 - 身份证',
  'entitasform.optLainnyaIdentitas': '4 - 其他',
  'entitasform.optNpwp15': '5 - NPWP 15 位',
  'entitasform.optNpwp16': '6 - NPWP 16 位',
  'entitasform.optAfl': 'AFL - 关联公司',
  'entitasform.optCtr': 'CTR - 财务/法律控制',
  'entitasform.optFam': 'FAM - 家庭成员',
  'entitasform.optTah': 'TAH - 无关联',
  // <i18n-anchor-kemasanform>
  'kemasanform.seri': '序号',
  'kemasanform.jumlah': '数量',
  'kemasanform.jenis': '类型',
  'kemasanform.merek': '品牌',
  'kemasanform.aksi': '操作',
  'kemasanform.nomor': '编号',
  'kemasanform.ukuran': '尺寸',
  'kemasanform.tipe': '型号',
  'kemasanform.kemasan': '包装',
  'kemasanform.petiKemas': '集装箱',
  'kemasanform.tambahKemasan': '添加包装',
  'kemasanform.tambahPetiKemas': '添加集装箱',
  'kemasanform.totalPetiKemas': '总计: {n}',
  'kemasanform.edit': '编辑',
  'kemasanform.copy': '复制',
  'kemasanform.delete': '删除',
  'kemasanform.required': '此字段为必填项！',
  'kemasanform.jenisOptionEmpty': '4 - 空箱',
  'kemasanform.jenisOptionLcl': '7 - 拼箱货',
  'kemasanform.jenisOptionFcl': '8 - 整箱货',
  'kemasanform.tipeOptionGeneralDry': '1 - 普通/干货',
  'kemasanform.tipeOptionTunnel': '2 - 隧道式',
  'kemasanform.tipeOptionOpenTop': '3 - 开顶钢制',
  'kemasanform.tipeOptionFlatRack': '4 - 平板架',
  'kemasanform.tipeOptionReefer': '5 - 冷藏/制冷',
  'kemasanform.tipeOptionBarge': '6 - 驳船集装箱',
  'kemasanform.tipeOptionBulk': '7 - 散装集装箱',
  'kemasanform.tipeOptionIsotank': '8 - 罐式集装箱',
  'kemasanform.tipeOptionLain': '99 - 其他',
  // PengangkutForm
  'pengangkutform.smartSync': '与 BC 1.1 智能同步',
  'pengangkutform.syncing': '同步中...',
  'pengangkutform.kodeTutupPu': '结关码',
  'pengangkutform.nomorBc11': 'BC 1.1 号码',
  'pengangkutform.tanggalTutupPu': '结关日期',
  'pengangkutform.nomorPos': '序号',
  'pengangkutform.nomorSubpos': '子序号',
  'pengangkutform.nomorSubsubpos': '子子序号',
  'pengangkutform.pengangkutan': '运输',
  'pengangkutform.caraPengangkutan': '运输方式',
  'pengangkutform.namaSaranaPengangkut': '运输工具名称',
  'pengangkutform.nomorVoyFlightNoPol': '航次/航班/车牌号',
  'pengangkutform.bendera': '船旗',
  'pengangkutform.perkiraanTanggalTiba': '预计抵达日期',
  'pengangkutform.cariBendera': '查找船旗',
  'pengangkutform.pelabuhanTempatPenimbunan': '港口与临时存放地',
  'pengangkutform.pelabuhanMuat': '装货港',
  'pengangkutform.pelabuhanTransit': '转运港',
  'pengangkutform.pelabuhanTujuan': '目的港',
  'pengangkutform.tempatPenimbunan': '临时存放地',
  'pengangkutform.noticeOfArrival': '到货通知',
  'pengangkutform.loadingData': '加载数据中...',
  'pengangkutform.useThisValue': '使用此值',
  'pengangkutform.uploading': '上传中...',
  'pengangkutform.maxFileSize': '最大文件大小：2MB',
  'pengangkutform.extractedInfo': '✓ 已提取信息',
  'pengangkutform.warehouse': '仓库:',
  'pengangkutform.invoiceNumber': '发票号码:',
  'pengangkutform.shipper': '发货人:',
  'pengangkutform.consignee': '收货人:',
  'pengangkutform.flagNameFromApi': '来自 API 的船旗名称',
  'pengangkutform.portOfLoadingFromApi': '来自 API 的装货港',
  'pengangkutform.notifError': '错误',
  'pengangkutform.notifSuccess': '成功',
  'pengangkutform.notifWarning': '警告',
  'pengangkutform.notifFileTooLarge': '文件过大',
  'pengangkutform.notifUploadSuccessful': '上传成功',
  'pengangkutform.notifPdfExtractionComplete': 'PDF 提取完成',
  'pengangkutform.notifUploadFailed': '上传失败',
  'pengangkutform.notifDocumentNotFound': '未找到文件',
  'pengangkutform.notifIncompleteDocument': '文件不完整',
  'pengangkutform.notifNoData': '无数据',
  'pengangkutform.notifDemoNoCeisa': '演示账户不可用',
  'pengangkutform.msgDemoNoCeisa': '演示账户未连接 CEISA，因此无法获取 BC 1.1 数据。请手动填写 BC 1.1 号码、PU 关闭日期和 Pos 号码。账户连接 CEISA 后即可使用此功能。',
  'pengangkutform.notifApiError': 'API 错误',
  'pengangkutform.msgEnterVesselNameFirst': '请先输入船名',
  'pengangkutform.msgFlagFound': '找到船旗：{flag}',
  'pengangkutform.msgNoFlagInfo': '未找到此船舶的船旗信息',
  'pengangkutform.msgNoAirlineFlagInfo': '未识别该航空公司，请手动选择国籍',
  'pengangkutform.msgEnterAirlineFirst': '请先输入航空公司名称或航班号',
  'pengangkutform.msgFailedFetchFlag': '获取船舶船旗信息失败',
  'pengangkutform.msgFileTooLarge': '文件大小必须小于 2MB',
  'pengangkutform.msgBatchUuidNotFound': 'URL 中未找到 Batch UUID',
  'pengangkutform.msgUploadSuccessful': 'NOA 文件“{name}”上传成功',
  'pengangkutform.msgPdfExtractionComplete': '到货通知数据提取成功',
  'pengangkutform.msgUploadFailed': '上传 NOA 文件失败',
  'pengangkutform.msgNoBlDocument': '未找到 B/L (705) 或 AWB (740) 文件。请先添加 B/L 或 AWB 文件。',
  'pengangkutform.msgBlIncomplete': 'B/L / AWB 文件必须包含号码和日期。',
  'pengangkutform.msgPopulatedFields': '已从 BC 1.1 舱单填充 {n} 个字段',
  'pengangkutform.msgNoManifestData': 'BC 1.1 舱单响应中未找到数据',
  'pengangkutform.msgFailedRetrieveManifest': '获取舱单数据失败',
  'pengangkutform.msgFailedCallManifest': '调用 BC 1.1 舱单 API 失败。请重试。',
  'pengangkutform.caraOpt1': '1 - 海运',
  'pengangkutform.caraOpt2': '2 - 铁路',
  'pengangkutform.caraOpt3': '3 - 公路',
  'pengangkutform.caraOpt4': '4 - 空运',
  'pengangkutform.caraOpt5': '5 - 邮政',
  'pengangkutform.caraOpt6': '6 - 多式联运',
  'pengangkutform.caraOpt7': '7 - 装置/管道',
  'pengangkutform.caraOpt8': '8 - 水路',
  'pengangkutform.caraOpt9': '9 - 其他',
  // <i18n-anchor-pengangkutform>
  // <i18n-anchor-transaksiform>
  'transaksiform.titleHarga': '价格',
  'transaksiform.warningPastikanValuta': '请确保币种正确',
  'transaksiform.labelValuta': '币种',
  'transaksiform.placeholderPilihValuta': '选择币种',
  'transaksiform.labelNdpbm': 'NDPBM',
  'transaksiform.placeholderNdpbm': 'NDPBM',
  'transaksiform.labelJenisTransaksi': '交易类型',
  'transaksiform.placeholderJenisTransaksi': '选择交易类型',
  'transaksiform.labelIncoterm': 'Incoterm',
  'transaksiform.placeholderIncoterm': '选择 Incoterm',
  'transaksiform.labelHargaBarang': '货物价值',
  'transaksiform.placeholderHargaBarang': '货物价值',
  'transaksiform.labelNilaiPabeanRupiah': '海关价值（卢比）',
  'transaksiform.placeholderNilaiPabeanRupiah': '海关价值（卢比）',
  'transaksiform.informasiKomponenBiaya': '费用构成信息',
  'transaksiform.titleHargaLainnya': '其他费用',
  'transaksiform.biayaPenambahan': '增加费用',
  'transaksiform.biayaPengurang': '减少费用',
  'transaksiform.freight': '运费',
  'transaksiform.labelAsuransi': '保险',
  'transaksiform.placeholderAsuransi': '保险',
  'transaksiform.nilaiAsuransi': '保险价值',
  'transaksiform.labelVoluntaryDeclaration': '自愿申报',
  'transaksiform.placeholderVoluntaryDeclaration': '自愿申报',
  'transaksiform.titleBerat': '重量',
  'transaksiform.labelBeratKotor': '毛重 (KGM)',
  'transaksiform.placeholderBeratKotor': '毛重 (KGM)',
  'transaksiform.labelBeratBersih': '净重 (KGM)',
  'transaksiform.placeholderBeratBersih': '净重 (KGM)',
  'transaksiform.helperNettoDihitung':
    '由商品总净重计算。可使用“对齐到毛重”进行调整，或在商品标签页填写每项净重。在净重 > 0 之前，交易标签保持黄色。',
  'transaksiform.buttonSamakanKeBeratKotor': '对齐到毛重',
  'transaksiform.tooltipSamakanKeBeratKotor': '调整第一项商品净重，使总净重等于毛重',
  'transaksiform.disabledSamakanBrutoKosong': '请先填写毛重',
  'transaksiform.disabledSamakanTidakAdaBarang': '没有可对齐的商品',
  'transaksiform.modalSamakanTitle': '将净重对齐到毛重',
  'transaksiform.modalSamakanBeratKotor': '毛重',
  'transaksiform.modalSamakanTotalNetto': '当前总净重',
  'transaksiform.modalSamakanItem': '将更改的商品',
  'transaksiform.modalSamakanNettoLama': '原净重',
  'transaksiform.modalSamakanNettoBaru': '新净重',
  'transaksiform.modalSamakanConfirm': '对齐',
  'transaksiform.modalSamakanCancel': '取消',
  'transaksiform.hintNettoTidakSamaBruto': '净重与毛重不一致。请使用上方按钮对齐。',
  'transaksiform.errSamakanFirstNegatif': '其他商品的净重已超过毛重。请先在商品标签页减少净重。',
  'transaksiform.errSamakanTidakAdaBarang': '没有可对齐的商品',
  'transaksiform.errSamakanBrutoKosong': '毛重必须大于 0',
  'docpabean.tabs.mandatoryFilled': '已填写 {filled} / {total} 个必填栏位。',
  'docpabean.tabs.hargaMismatchTooltip':
    '总价不一致：商品标签页 {barang} {valuta}（{seri} 项），交易标签页 {harga} {valuta}，相差 {selisih} {valuta}。请打开交易标签页对齐。',
  'transaksiform.hintHargaTidakSamaBarang':
    '商品标签页的总价值（{seri} 项，{barang} {valuta}）与此处的货物价格（{harga} {valuta}）不一致，相差 {selisih} {valuta}。',
  'transaksiform.buttonSamakanHargaBarang': '与商品标签页总额对齐',
  'transaksiform.modalSamakanHargaTitle': '将货物价格对齐到商品总额',
  'transaksiform.modalSamakanHargaSekarang': '当前货物价格',
  'transaksiform.modalSamakanHargaTotalBarang': '商品标签页总价值（{seri} 项）',
  'transaksiform.modalSamakanHargaSelisih': '差额',
  'transaksiform.modalSamakanHargaPenjelasan': '货物价格将填入商品标签页的总价值，各项商品价格不会更改。',
  'transaksiform.modalSamakanHargaCatatanBiaya':
    '注意：运费 {freight} {valuta} 与保险费 {asuransi} {valuta} 单独填写。请确认商品标签页的总额尚未包含这两项，以免完税价格重复计算。',
  'transaksiform.modalSamakanHargaHapusBiaya':
    '附加费用将被清除，视为已包含在商品标签页总额中：运费 {freight} {valuta}、保险费 {asuransi} {valuta}、其他附加费用 {biaya} {valuta}。各项商品的运费和保险费也将设为 0，商品价格不变。',
  'transaksiform.hintBiayaDalamBarang':
    '商品标签页总额（{barang} {valuta}，共 {seri} 项）等于货物价格（{harga} {valuta}）加上附加费用（{biaya} {valuta}：运费、保险费等）。如果这些费用已包含在发票价格中，请对齐货物价格，以免重复计算。',
  'transaksiform.hargaSamakanApplied': '货物价格已按商品标签页总额填入 {amount} {valuta}',
  'transaksiform.errHargaSamakanGagal': '对齐货物价格失败，请重试。',
  'transaksiform.errNettoHarusLebihDari0': '净重必须大于 0 — 请在商品标签页填写每项净重',
  'transaksiform.errNettoLebihDariBruto': '净重不能大于毛重',
  'transaksiform.warningTitle': '警告',
  'transaksiform.errNdpbmRetrieve': '无法获取 NDPBM 值。请手动输入。',
  'transaksiform.errorTitle': '错误',
  'transaksiform.errNdpbmFetch': '获取 NDPBM 时出错',
  'transaksiform.confGrossWeight': '毛重置信度',
  'transaksiform.confCurrency': '币种置信度',
  'transaksiform.confIncoterm': 'Incoterm 置信度',
  'transaksiform.confHargaBarang': '货物价值置信度',
  'transaksiform.confFreight': '运费置信度',
  'transaksiform.confInsurance': '保险价值置信度',
  'transaksiform.confNdpbm': '汇率置信度',
  'transaksiform.confCif': 'CIF价值置信度',
  'transaksiform.confNetto': '净重置信度',
  // BarangForm — 货物清单（货物表格）
  'barangform.notifError': '错误',
  'barangform.notifSuccess': '成功',
  'barangform.notifInfo': '提示',
  'barangform.minOneBarang': '至少必须添加一件货物才能继续',
  'barangform.seriUraianKosong': '货号 [{seri}] 的描述为空',
  'barangform.seriSatuanKosong': '货号 [{seri}] 的计量单位为空',
  'barangform.seriKodeSatuanKosong': '货号 [{seri}] 的计量单位代码为空',
  'barangform.seriNegaraKosong': '货号 [{seri}] 的原产国为空',
  'barangform.seriHsKosong': '货号 [{seri}] 的 HS 编码为空',
  'barangform.seriHs8Digit': '货号 [{seri}] 的 HS 编码必须为 8 位',
  'barangform.gagalMenghapusDokumen': '删除文件失败',
  'barangform.noItemsSelected': '未选择任何项目',
  'barangform.updatedCount': '{count} 个项目已更新',
  'barangform.bulkEditFailed': '批量编辑失败',
  'barangform.seriBarangRequired': '必须填写货号',
  'barangform.dataBerhasilDiperbarui': '货物数据已成功更新',
  'barangform.gagalMemperbaruiData': '更新货物数据失败',
  'barangform.fetchHsDetailsFailed': '获取 HS 编码详情失败',
  'barangform.fetchHsDetailsError': '获取 HS 编码详情时出错',
  'barangform.itemBerhasilDihapus': '项目已成功删除',
  'barangform.gagalMenghapusItem': '删除项目失败',
  'barangform.tidakAdaItemDipilih': '未选择任何项目',
  'barangform.itemBerhasilDihapusCount': '{count} 个项目已成功删除',
  'barangform.itemBerhasilDisalin': '项目已成功复制',
  'barangform.gagalMenyalinItem': '复制项目失败',
  'barangform.loadItemEditFailed': '加载待编辑项目失败',
  'barangform.processIdNotFound': '未找到流程 ID',
  'barangform.downloadSuccess': '下载成功！',
  'barangform.downloadFailed': '下载失败！',
  'barangform.pilihFilePdf': '请先选择 PDF 文件',
  'barangform.processIdTidakDitemukan': '未找到流程 ID',
  'barangform.invoiceUploadSuccess': '发票已上传并正在处理中',
  'barangform.uploadInvoiceError': '上传发票时出错',
  'barangform.noItemsToCheck': '没有可检查的项目',
  'barangform.noDuplicateDescriptions': '未发现重复的描述',
  'barangform.foundDuplicates': '发现 {count} 个项目存在重复描述',
  'barangform.tidakAdaBarangSync': '没有可同步的货物',
  'barangform.tidakAdaHsValid': '没有有效的 HS 编码可同步',
  'barangform.syncProsesDimulai': '已开始同步 {count} 个 HS 编码。请等待完成。',
  'barangform.gagalMemulaiSync': '开始同步失败：{msg}',
  'barangform.tidakAdaHsCodeSync': '没有可同步的 HS 编码',
  'barangform.hsCodeSyncCount': '{count} 个 HS 编码已成功同步',
  'barangform.hsCodeSyncErrorSuffix': '，{count} 个错误',
  'barangform.gagalSyncTarifInsw': '与 INSW 同步税费失败',
  'barangform.processIdTidakTersedia': '流程 ID 不可用。请刷新页面。',
  'barangform.processIdTidakTersediaSingkat': '流程 ID 不可用',
  'barangform.noItemsToSync': '没有可同步的项目',
  'barangform.gagalSimpanSebelumSync': '同步前保存货物数据失败',
  'barangform.smartSyncSukses': '智能同步已成功完成',
  'barangform.smartSyncGagal': '智能同步失败',
  'barangform.noValidHsSync': '未找到可同步的有效 HS 编码',
  'barangform.lartasStatusUpdated': '已为 {count} 个项目更新 LARTAS 状态',
  'barangform.lartasAlreadyUpToDate': 'LARTAS 状态已是最新',
  'barangform.gagalAmbilLartas': '获取 LARTAS 数据失败',
  'barangform.gagalSyncLartas': '同步 LARTAS 数据失败',
  'barangform.itemDariDatabaseSukses': '已成功从数据库添加项目！',
  'barangform.gagalItemDatabase': '从数据库添加项目失败',
  'barangform.cifBerhasil': '已成功计算按比例分摊的费用',
  'barangform.gagalHitungCif': '计算按比例分摊的费用失败',
  'barangform.fobBerhasil': '已成功应用 FOB 价格',
  'barangform.gagalTerapkanFob': '应用 FOB 价格失败',
  'barangform.itemUpdatedApplied': '项目已更新，更改已应用于 {count} 个具有相同或空 HS 编码的项目',
  'barangform.itemUpdatedNoApply': '项目已更新。没有其他项目具有匹配或空的 HS 编码可应用更改。',
  'barangform.gagalSimpanServer': '保存更改到服务器失败。请重试。',
  'barangform.itemAddedSukses': '项目已成功添加',
  'barangform.gagalSimpanItemBaru': '保存新项目到服务器失败。请重试。',
  'barangform.syncedTooltip': '数据取自先前文档',
  'barangform.syncedFromAjuLabel': '从 Aju {aju} 同步',
  'barangform.syncedFromDraftLabel': '从草稿 {id} 同步',
  'barangform.cekTarifInsw': '正在检查 INSW 税费...',
  'barangform.inswCocok': 'INSW 税费匹配（{kind}：{value}%）',
  'barangform.inswBerbeda': 'INSW 税费不同 — INSW {kind}：{value}%',
  'barangform.inswCocokPreferensi': '与 INSW 一致 — {pref} 优惠税率 {value}%（MFN {mfn}%）',
  'barangform.inswPreferensiTidakDipakai': '原产地证书可享 {pref} 优惠税率 {value}%，但 BM 使用了 MFN {mfn}%',
  'barangform.inswGagal': '无法获取该 HS 的 INSW 税率',
  'barangform.dataInswUmur': 'INSW 数据：{age}',
  'barangform.preferentialMfnTooltip': '{preference}：该 HS 为 "{raw}" → 采用 MFN 税率。',
  'barangform.preferentialMfnFallbackPreference': '现行优惠方案',
  'trq.status.trq':
    '该 HS 为关税配额 (TRQ) 税目。配额外适用 MFN 税率；勾选"配额内"并填写配额分配编号即可使用配额内税率。',
  'trq.status.trq.badge': 'TRQ · MFN',
  'trq.status.trq_in_quota': '已根据填写的配额分配编号适用 TRQ 配额内税率。',
  'trq.status.trq_in_quota.badge': 'TRQ 配额内',
  'trq.status.trq_no_ref': '已申报配额内但未填写配额分配编号 — BM 仍为 MFN。',
  'trq.status.trq_no_ref.badge': 'TRQ · 待补全',
  'trq.status.trq_no_rate': '已申报配额内，但 TRQ 税率主数据中没有该 HS 和协定的税率 — BM 仍为 MFN。',
  'trq.status.trq_no_rate.badge': 'TRQ · 无税率',
  'trq.status.trq_no_qty': '已申报配额内，但未知以 TRQ 税率单位计的数量（请填写净重或使用相同单位）— BM 仍为 MFN。',
  'trq.status.trq_no_qty.badge': 'TRQ · 单位',
  'trq.blocked.NO_QUOTA_REF': '第 {seri} 项货物：TRQ 配额内申报缺少配额分配编号，BM 仍为 MFN。',
  'trq.blocked.NO_RATE': '第 {seri} 项货物：TRQ 税率主数据中没有配额内税率，BM 仍为 MFN。',
  'trq.blocked.NO_QUANTITY': '第 {seri} 项货物：未知以 TRQ 税率单位计的数量，BM 仍为 MFN。',
  'pungutanform.readiness.trq':
    '第 {seri} 项货物：关税配额 (TRQ) 税目 — 除非在货物的 Pungutan 标签中申报配额内，否则 BM 采用 MFN。',
  'pungutanform.readiness.trqInQuota': '第 {seri} 项货物：已适用 TRQ 配额内税率。',
  'trq.claim.title': '关税配额 (TRQ)',
  'trq.claim.inQuota': '申报配额内税率 (TRQ)',
  'trq.claim.quotaRef': '配额分配编号',
  'trq.claim.quotaRefPlaceholder': '进口商配额分配函编号',
  'trq.claim.quotaRefRequired': '必须填写配额分配编号',
  'trq.claim.save': '保存申报',
  'trq.claim.saved': 'TRQ 申报已保存',
  'trq.claim.savedHint': '该货物的 BM 已更新。',
  'trq.claim.saveFailed': '保存 TRQ 申报失败',
  'trq.tarif.specificLabel': '税率 (Rp/{unit})',
  'trq.tarif.jumlahSatuan': '数量',
  'trq.tarif.satuan': '单位',
  'pungutanform.readiness.specificNoQty':
    '第 {seri} 项货物：BM 为从量税率（每单位 Rp），但数量为 0 — 请填写净重或数量，目前 BM 为 Rp0。',
  'menu.tarifTrq': 'TRQ 税率',
  'trqmaster.title': 'TRQ 配额内税率',
  'trqmaster.subtitle':
    '关税配额 (TRQ) 税目的配额内税率，INSW 不公布。请依据法规附件（如 PMK 60 Tahun 2026）填写；仅适用于以配额分配编号申报配额内的货物。',
  'trqmaster.add': '新增 TRQ 税率',
  'trqmaster.edit': '编辑',
  'trqmaster.delete': '删除',
  'trqmaster.save': '保存',
  'trqmaster.cancel': '取消',
  'trqmaster.searchHs': '搜索 HS…',
  'trqmaster.empty': '暂无 TRQ 税率',
  'trqmaster.saved': 'TRQ 税率已保存',
  'trqmaster.saveFailed': '保存 TRQ 税率失败',
  'trqmaster.loadFailed': '加载 TRQ 税率失败',
  'trqmaster.deleteFailed': '删除 TRQ 税率失败',
  'trqmaster.deleteConfirm': '删除 HS {hs} 的 TRQ 税率？',
  'trqmaster.col.hs': 'HS 编码',
  'trqmaster.col.preference': '协定',
  'trqmaster.col.rate': '配额内税率',
  'trqmaster.col.validity': '有效期',
  'trqmaster.col.regulation': '法规',
  'trqmaster.preferenceHint': '与 INSW 一致的协定名称，如 IJEPA',
  'trqmaster.rateType': '税率类型',
  'trqmaster.rateType.specific': '从量 (每单位 Rp)',
  'trqmaster.rateType.adValorem': '从价 (%)',
  'trqmaster.rateRp': '税率 (每单位 Rp)',
  'trqmaster.ratePct': '税率 (%)',
  'trqmaster.unit': '单位',
  'trqmaster.validFrom': '生效日期',
  'trqmaster.validTo': '截止日期',
  'trqmaster.notes': '备注',
  'trqmaster.err.hs': 'HS 必须为 8 位',
  'trqmaster.err.required': '必填',
  'trqmaster.err.rate': '税率无效',
  'trqmaster.err.pct': '从价税率最高 100%',
  'trqmaster.err.unit': '从量税率必须填写单位',
  'trqmaster.err.validTo': '截止日期早于生效日期',
  'barangform.memuatDetailHs': '正在加载 HS 详情...',
  'barangform.lihatDetailHs': '查看 HS 详情',
  'barangform.hsPick': '从运输单据选择 HS 编码',
  'barangform.hsPickFailed': '无法保存所选的 HS 编码',
  'barangform.lartas': 'Lartas',
  'barangform.non': '非',
  'barangform.unnamedItem': '未命名项目',
  'barangform.justNow': '刚刚',
  'barangform.hoursAgo': '{count} 小时前',
  'barangform.oneDayAgo': '1 天前',
  'barangform.daysAgo': '{count} 天前',
  'barangform.hsCodeKosong': 'HS 编码为空',
  'barangform.tidakAdaHsCodeDicari': '没有可搜索的 HS 编码。',
  'barangform.prefTarif': '{pref} {year}：{nilai} 对比 BM {bm}%',
  'barangform.prefNoTarif': '{pref} — {year} 年没有税率',
  'barangform.skbPphBadge': 'PPh 免征',
  'barangform.skbPphApplied': '已关联 SKB PPh — PPh 免征（优惠代码 5），税率 {tarif}% 保留记录。',
  'barangform.skbPphAppliedNoDoc': 'PPh 免征（优惠代码 5）但未关联 SKB PPh 单证 — 提交前请确认单证页签中有 SKB。',
  'barangform.skbPphPending': '已关联 SKB PPh，但免征优惠尚未应用到此货物 — 请打开税费页签或运行同步 HS 税率。',
  'barangform.skbPpnBadge': 'PPN 免征',
  'barangform.skbPpnApplied': '已关联 SKB PPN — PPN 免征（优惠代码 5），税率 {tarif}% 保留记录，应缴 PPN 为 0。',
  'barangform.skbPpnAppliedNoDoc': 'PPN 免征（优惠代码 5）但未关联 SKB PPN 单证 — 提交前请确认单证页签中有 SKB。',
  'barangform.skbPpnPending': '已关联 SKB PPN，但免征优惠尚未应用到此货物 — 请打开税费页签或运行同步 HS 税率。',
  'barangform.editLabel': '编辑',
  'barangform.copyLabel': '复制',
  'barangform.deleteLabel': '删除',
  'barangform.colSeri': '序号',
  'barangform.colGroup': '组',
  'barangform.colHs': 'HS',
  'barangform.colLartas': 'Lartas',
  'barangform.lartasUnverified': '需核查',
  'barangform.colUraian': '描述',
  'barangform.uraianFull': '显示完整描述',
  'barangform.uraianCompact': '精简描述',
  'barangform.colTotalNilai': '总价值',
  'barangform.colNw': '净重',
  'barangform.colSatuan': '单位',
  'barangform.colKemasan': '包装',
  'barangform.kemasanMismatchDetail': '{count} 行商品使用包装 {codes}，而“包装与集装箱”标签页申报的是 {target}。',
  'barangform.kemasanMismatchApply': '全部改为 {target}',
  'barangform.kemasanMismatchApplying': '正在统一...',
  'barangform.kemasanMismatchDismiss': '忽略',
  'barangform.kemasanMismatchNoCode': '无代码',
  'barangform.kemasanMismatchDone': '{count} 行商品的包装已改为 {target}。',
  'barangform.kemasanMismatchFailed': '统一商品包装失败。',
  'barangform.kemasanTotalMismatchTitle': '包装数量不一致',
  'barangform.kemasanTotalMismatchDetail':
    '商品标签页的包装总数（{barang}）与包装标签页的数量（{kemasan}）不一致，相差 {selisih}。仅为提醒，不会阻止提交。',
  'barangform.kemasanTotalMismatchOpen': '查看包装标签页',

  // 商品标签页的 6 位 HS 编码建议
  'barangform.hsShortSummary': '{codes} 个 HS 编码不足 8 位，涉及 {rows} 行。CEISA 只接受 8 位编码。',
  'barangform.hsShortRows': '{count} 行（序号 {seri}）',
  'barangform.hsShortPick': '选择 8 位编码（{count} 个选项）',
  'barangform.hsShortModalTitle': '为 {heading} 选择 8 位 HS 编码',
  'barangform.hsShortModalIntro':
    '印尼税则（BTKI）在 {heading} 下收录了以下编码。所选编码将一次性应用于 {count} 行（序号 {seri}）。',
  'barangform.hsShortCatchAll': '其他',
  'barangform.hsShortInactive': '未启用',
  'barangform.hsShortInactiveSome': '未启用 = 最近一次 INSW 同步中没有该编码，并不表示不能申报。',
  'barangform.hsShortInactiveAll':
    '该品目下所有编码在最近一次 INSW 同步中均未启用 —— 我们的 BTKI 数据（2022）可能已过时，使用前请先核对。',
  'barangform.hsShortUserEdited': '其中 {count} 行曾手动修改（序号 {seri}），也会被覆盖。',
  'barangform.hsShortCancel': '取消',
  'barangform.hsShortConfirm': '应用于 {count} 行',
  'barangform.hsShortDone': '{count} 行已从 {heading} 改为 {code}。',
  'barangform.hsShortDoneSkipped': '{count} 行已改为 {code}。{skipped} 行因已变更而跳过。',
  'barangform.hsShortFailed': '应用 HS 编码建议失败。',

  // 不在我们 BTKI/INSW 清单中的 8 位 HS 编码 —— 同一面板
  'barangform.hsUnknownSummary': '{codes} 个 8 位 HS 编码未在我们的 BTKI/INSW 清单中找到，涉及 {rows} 行。',
  'barangform.hsUnknownPick': '选择 {prefix} 下的编码（{count} 个选项）',
  'barangform.hsUnknownModalTitle': 'HS 编码 {heading} 未在 BTKI 中找到',
  'barangform.hsUnknownModalIntro':
    '编码 {heading} 不在我们的 BTKI/INSW 清单中。税则在 {prefix} 下收录了以下编码 —— 保留前 6 位，只重新选择后 2 位。所选编码将一次性应用于 {count} 行（序号 {seri}）。',

  // 商品计量单位与 HS 编码规定不符
  'barangform.satuanMismatchSummary':
    '{count} 行商品使用的计量单位不符合其 HS 编码的规定。计量单位以 HS 编码信息中的规定为准。',
  'barangform.satuanMismatchRows': '{count} 行（序号 {seri}）使用 {used}，应为 {allowed}',
  'barangform.satuanMismatchApply': '改为 {target}',
  'barangform.satuanMismatchConverted': '数量随之换算',
  'barangform.satuanMismatchKept': '数量不变，请核对',
  'barangform.satuanMismatchApplyAll': '全部统一（{count} 行）',
  'barangform.satuanMismatchApplying': '正在修改...',
  'barangform.satuanMismatchDismiss': '忽略',
  'barangform.satuanMismatchDone': '{count} 行商品的计量单位已改为 {targets}。',
  'barangform.satuanMismatchDoneSkipped': '{count} 行商品的计量单位已改为 {targets}。{skipped} 行因已变更而跳过。',
  'barangform.satuanMismatchFailed': '修改商品计量单位失败。',
  'barangform.colDok': '文件',
  'barangform.colPpn': 'PPN',
  'barangform.colPph': 'PPH',
  'barangform.colBm': 'BM',
  'barangform.colAction': '操作',
  'barangform.colJenisDokumen': '文件类型',
  'barangform.colKode': '代码',
  'barangform.colNomorDokumen': '文件编号',
  'barangform.colTanggal': '日期',
  'barangform.colKodeFasilitas': '设施代码',
  'barangform.colNamaFasilitas': '设施名称',
  'barangform.colKodeIjin': '许可代码',
  'barangform.colSeriIzin': '许可序号',
  'barangform.hapusBarangTitle': '删除货物',
  'barangform.tindakanTidakBisaDibatalkan': '此操作无法撤销',
  'barangform.konfirmasiHapusBarang': '您确定要删除以下货物吗？',
  'barangform.konfirmasiHapusMany': '您确定要删除选中的 {count} 件货物吗？',
  'barangform.labelSeri': '序号：',
  'barangform.labelUraian': '描述：',
  'barangform.labelHsCode': 'HS 编码：',
  'barangform.cancel': '取消',
  'barangform.deleting': '删除中...',
  'barangform.delete': '删除',
  'barangform.hapusCountTitle': '删除 {count} 件货物',
  'barangform.hapusCountItem': '删除 {count} 个项目',
  'barangform.labelJumlahItem': '项目数量：',
  'barangform.jumlahItemCount': '{count} 个项目',
  'barangform.labelSeriBarang': '货号：',
  'barangform.lagiSuffix': '，...（+{count} 更多）',
  'barangform.hsCodeDetailsTitle': 'HS 编码详情',
  'barangform.tabBasicInfo': '基本信息',
  'barangform.tabTariffRates': '税率',
  'barangform.tabPreferentialCount': '优惠税率（{count}）',
  'barangform.labelCode': '代码：',
  'barangform.labelNormalizedCode': '标准化代码：',
  'barangform.labelIdDescription': '印尼语描述：',
  'barangform.labelEnDescription': '英文描述：',
  'barangform.labelInswYear': 'INSW 年份：',
  'barangform.labelLartas': 'LARTAS：',
  'barangform.yes': '是',
  'barangform.no': '否',
  'barangform.labelPpnBm': 'PPN BM',
  'barangform.na': '无',
  'barangform.placeholderSearchPrefTariffs': '搜索优惠税率...',
  'barangform.labelIssueDate': '发布日期：',
  'barangform.labelEffective': '生效日期：',
  'barangform.nowSuffix': '（当前）',
  'barangform.labelHistoricalRates': '历史税率：',
  'barangform.loadingHsDetails': '正在加载 HS 编码详情...',
  'barangform.dokumenTerlampir': '附带文件',
  'barangform.seriInfoLine': '序号 {seri}：{uraian}',
  'barangform.dokumenFallback': '文件 {kode}',
  'barangform.deleteAttachmentAria': '删除附件',
  'barangform.tidakAdaDokumenTerlampir': '此货物没有附带的文件',
  'barangform.memuatDataBarang': '正在加载货物数据...',
  'barangform.menyalinDataBarang': '正在复制货物数据...',
  'barangform.tambahBarang': '添加货物',
  'barangform.editBarang': '编辑货物',
  'barangform.editMassalCount': '批量编辑 {count} 个项目',
  'barangform.bulkEditHint': '选择要为所有选中项目更改的字段。留空以保留现有值。',
  'barangform.bulkUraianLabel': '货物描述',
  'barangform.uraianMode.replace': '替换',
  'barangform.uraianMode.prefix': '前缀',
  'barangform.uraianMode.suffix': '后缀',
  'barangform.bulkUraianHint.replace': '所有选中项目的描述将替换为此文本。',
  'barangform.bulkUraianHint.prefix': '文本将添加到每个项目描述的前面，以一个空格分隔。',
  'barangform.bulkUraianHint.suffix': '文本将添加到每个项目描述的后面，以一个空格分隔。',
  'barangform.bulkUraianPlaceholder': '例如 SPARE PARTS',
  'barangform.bulkUraianPreview': '结果预览（序号 {seri}）',
  'barangform.bulkUraianEmpty': '（空）',
  'barangform.hsCodeField': 'HS 编码',
  'barangform.placeholderPilihHs': '为选中的项目选择新的 HS 编码...',
  'barangform.nonLartasLabel': '非 LARTAS',
  'barangform.kodeSatuanField': '计量单位代码',
  'barangform.placeholderPilihSatuan': '为选中的项目选择新的计量单位代码...',
  'barangform.kodeKemasanField': '包装代码',
  'barangform.placeholderPilihKemasan': '为选中的项目选择新的包装代码...',
  'barangform.kodeNegaraField': '国家代码',
  'barangform.placeholderPilihNegara': '为选中的项目选择新的国家代码...',
  'barangform.tarifPungutan': '税费（征费）',
  'barangform.aturTarifHint': '为选中的项目设置 PPN、PPH 和 BM 税率',
  'barangform.labelPpnPct': 'PPN (%)',
  'barangform.labelPphPct': 'PPH (%)',
  'barangform.labelBmPct': 'BM (%)',
  'barangform.fasilitasPpnField': 'PPN 设施',
  'barangform.fasilitasPphField': 'PPH 设施',
  'barangform.fasilitasBmField': 'BM 设施',
  'barangform.placeholderPilihFasilitas': '选择设施...',
  'barangform.fasByr': '1 - BYR - 已支付',
  'barangform.fasDtp': '2 - 由政府承担',
  'barangform.fasBbs': '5 - BBS - 已豁免',
  'barangform.fasTidakDipungut': '6 - 不征收',
  'barangform.fasDilunasi': '7 - 已结清',
  'barangform.fasDitunda': '9 - 延后',
  'barangform.terapkanPerubahan': '应用更改',
  'barangform.resyncTarifTitle': '重新同步税率数据库',
  'barangform.tersisa': '剩余',
  'barangform.syncingTarif': '正在同步税率...',
  'barangform.resyncDescription': '系统正在从 INSW 数据库下载并更新您货物表格中 HS 编码的税率数据。',
  'barangform.harapTunggu': '请等待流程完成。请勿关闭此页面。',
  'barangform.syncSelesai': '同步完成！',
  'barangform.resyncSelesaiDesc': '税率数据已成功更新。请点击智能同步以将最新税率应用到货物表格。',
  'barangform.selesai': '完成',
  'barangform.loadingBarangData': '正在加载货物数据...',
  'barangform.totalCount': '总计：{count}',
  'barangform.labelHsCodes': 'HS 编码：',
  'barangform.filteredCount': '已筛选：{count}',
  'barangform.duplicatesCount': '重复：{count}',
  'barangform.withDocumentsCount': '有文件：{count}',
  'barangform.lartasCount': 'Lartas：{count}',
  'barangform.nonLartasCount': '非 Lartas：{count}',
  'barangform.selectedCount': '已选：{count}',
  'barangform.editMassal': '批量编辑',
  'barangform.editBtn': '编辑',
  'barangform.hapusMassal': '批量删除',
  'barangform.batalPilih': '取消选择',
  'barangform.duplikat': '复制',
  'barangform.duplikatMassal': '批量复制',
  'barangform.duplikatTitle': '复制商品',
  'barangform.duplikatSelected': '已选择 {count} 行',
  'barangform.duplikatCopiesLabel': '每行副本数',
  'barangform.duplikatCopiesHint': '每个选中的行将被复制此数量，并添加到列表末尾（最多 {max}）。',
  'barangform.duplikatCopiesInvalid': '请输入 1 – {max}',
  'barangform.duplikatAdded': '+{count} 新行',
  'barangform.duplikatTotal': '总计：{from} → {to} 项商品',
  'barangform.duplikatWillAdd': '将增加：',
  'barangform.duplikatTotalsNote': '表头/交易中的总计不会自动更改。请之后调整每行的数量/金额。',
  'barangform.duplikatConfirm': '复制 {count}',
  'barangform.duplikatBerhasil': '已成功复制 {count} 行（序号 {first}–{last}）',
  'barangform.duplikatGagal': '复制商品失败',
  'barangform.pilihHalamanIni': '已选择本页 {count} 行。',
  'barangform.pilihSemuaN': '选择全部 {count} 项商品',
  'barangform.pilihBarangDulu': '请先勾选商品',
  'barangform.seriSelectPlaceholder': '选择序号：1-5, 8',
  'barangform.seriSelectHelp': '输入序号后按回车选择行。例如：1-5, 8, 10-12',
  'barangform.seriSelectApply': '选择序号',
  'barangform.seriSelectInvalid': '格式错误：{tokens}。例如：1-5, 8, 10-12',
  'barangform.seriSelectMissing': '已选择 {count} 个商品。未找到序号：{seris}',
  'barangform.seriSelectNone': '未找到序号：{seris}',
  'barangform.semuaDipilih': '已选择全部 {count} 项商品。',
  'barangform.placeholderCari': '按描述或 HS 编码搜索...',
  'barangform.filterOptions': '筛选选项',
  'barangform.filterHasDocument': '有文件的货物',
  'barangform.lartasStatus': 'Lartas 状态',
  'barangform.filterLartas': 'Lartas 货物',
  'barangform.filterNonLartas': '非 Lartas 货物',
  'barangform.showingCount': '显示 {count} 个项目',
  'barangform.sortBySeri': '按货号排序',
  'barangform.sortByHs': '按 HS 编码排序',
  'barangform.sortedBySeriMsg': '货物已按货号排序',
  'barangform.sortedByHsMsg': '货物已按 HS 编码排序',
  'barangform.legendBarang': '货物',
  'barangform.bulkUpdate': '批量更新',
  'barangform.uploadInvoice': '上传发票',
  'barangform.legendTarif': '税费',
  'barangform.smartSync': '智能同步',
  'barangform.smartSyncStatusLain': '智能同步状态：{status}',
  'barangform.smartSyncStatus.never': '智能同步 · 此草稿尚未运行过',
  'barangform.smartSyncStatus.stale': '智能同步 · 上次由 {lastBy} 于{relative}运行 · 之后有 {count} 处货物变更',
  'barangform.smartSyncStatus.fresh': '智能同步 · 上次由 {lastBy} 于{relative}运行',
  'barangform.detailTarif': '税费详情',
  'barangform.hitungHargaProporsional': '计算按比例价格',
  'barangform.kembalikanHargaSemula': '恢复原始价格',
  'barangform.labelFileInvoice': '发票文件（PDF）',
  'barangform.placeholderPilihFilePdf': '选择 PDF 文件',
  'barangform.uploadExtract': '上传并提取',
  'barangform.goTo': '转到',
  'barangform.go': '跳转',
  // <i18n-anchor-barangform>
  // PungutanForm
  'pungutanform.title': '税费',
  'pungutanform.generate': '生成税费',
  'pungutanform.total': '税费合计：',
  'pungutanform.colJenisPungutan': '税费类型',
  'pungutanform.colFasilitas': '设施',
  'pungutanform.colNilaiPungutan': '税费金额（IDR）',
  'pungutanform.fasilitas.dibayar': '已支付',
  'pungutanform.fasilitas.ditanggung': '由政府承担',
  'pungutanform.fasilitas.ditunda': '已延期',
  'pungutanform.fasilitas.tidakDipungut': '不予征收',
  'pungutanform.fasilitas.dibebaskan': '已免除',
  'pungutanform.notif.errorTitle': '错误',
  'pungutanform.notif.noProcessId': '流程 ID 不可用，无法计算税费',
  'pungutanform.notif.successTitle': '成功',
  'pungutanform.notif.generated': '项税费已成功生成',
  'pungutanform.notif.calculated': '项税费已根据货物与税率计算',
  'pungutanform.notif.infoTitle': '提示',
  'pungutanform.notif.noData': '没有税费数据',
  'pungutanform.notif.failTitle': '失败',
  'pungutanform.notif.failGenerate': '生成税费失败',
  // CEISA answered Generate with a message instead of pungutan (next-jarvis#779)
  'pungutanform.miss.ajuNotFound':
    'CEISA 中找不到此 AJU，可能已在 CEISA 门户中删除。如有需要，请从 JARVIS 重新发送草稿。',
  'pungutanform.miss.ceisaMessage': 'CEISA：{message}',
  'pungutanform.miss.lastCeisa': '最近一次 CEISA 结果',
  'pungutanform.miss.lastCeisaAt': '最近一次 CEISA 结果 · {time} WIB',
  'pungutanform.estimate.button': '计算 JARVIS 估算',
  'pungutanform.estimate.toggle': 'JARVIS 估算',
  'pungutanform.estimate.badge': 'JARVIS 估算，非 CEISA 结果',
  'pungutanform.estimate.failed': '计算 JARVIS 估算失败',
  // Pre-AJU local calculation readiness (issue #237)
  'pungutanform.readiness.ready': '可计算',
  'pungutanform.readiness.estimate': '预估值',
  'pungutanform.readiness.partial': '部分未计算',
  'pungutanform.readiness.blocked': '暂无法计算',
  'pungutanform.readiness.detail.ready': '根据草稿的税率与汇率在本地计算。提交 AJU 后以 CEISA 的数值为准。',
  'pungutanform.readiness.detail.estimate':
    '按预估 CIF 在本地计算（运费与保险费按比例分摊）。提交 AJU 后以 CEISA 的数值为准。',
  'pungutanform.readiness.detail.blocked': '该草稿暂时无法计算税费。',
  'pungutanform.readiness.detail.partialSuffix': '仍有 {count} 项货物未纳入计算。',
  'pungutanform.readiness.reason.barangKosong': '草稿尚无货物数据。',
  'pungutanform.readiness.reason.tarifBelumSinkron': 'HS 税率尚未同步，没有可用的进口税/增值税/所得税税率。',
  'pungutanform.readiness.reason.kursBelumAda': '交易页尚未填写汇率（NDPBM），货值无法折算为印尼盾。',
  'pungutanform.readiness.reason.nilaiBarangKosong': '货值仍为 0，缺少计算依据。',
  'pungutanform.readiness.valuta': '币种',
  'pungutanform.readiness.ndpbm': '汇率',
  'pungutanform.readiness.ndpbmFromCeisa': 'CEISA 汇率 — 尚未保存到交易页',
  'pungutanform.readiness.tarifSource': '税率来源',
  'pungutanform.readiness.source.saved': '已保存税率',
  'pungutanform.readiness.source.hsTariffs': 'HS 税率表',
  'pungutanform.readiness.source.mixed': '混合来源',
  'pungutanform.readiness.source.none': '-',
  'pungutanform.readiness.missingCodes': '缺少税率的 HS 编码',
  'pungutanform.readiness.andMore': '(另有 {count} 个)',
  'pungutanform.readiness.syncTarif': '同步 HS 税率',
  'pungutanform.readiness.syncDone': 'HS 税率同步完成',
  'pungutanform.readiness.syncFailed': 'HS 税率同步失败',
  'pungutanform.readiness.unsavedTarif':
    '{count} 项货物的税率来自 HS 税率表和单证优惠，尚未保存到货物 — 同步时自动保存（需要 Master CEISA 权限）。',
  'pungutanform.readiness.ambiguousPreferential':
    '第 {seri} 项货物的优惠税率（BM 优惠）未自动应用，因为优惠数据相互矛盾 — BM 采用普通税率 (MFN)；请手动核对 BM 优惠。',
  'pungutanform.readiness.preferentialMfn':
    '第 {seri} 项货物：现行优惠方案对这些货物的 HS 未给予特别税率 (MFN)，BM 采用普通税率。',
  'pungutanform.readiness.pphExempt':
    '{count} 项货物（第 {seri} 项）因已关联 SKB PPh / SKB PP 23 而免征 PPh — 列为 PPH 优惠代码 5（已免除）行。',
  'pungutanform.readiness.ppnExempt':
    '{count} 项货物（第 {seri} 项）因已关联 SKB PPN 而免征 PPN — 列为 PPN 优惠代码 5（已免除）行。',
  // PernyataanForm
  'pernyataanform.title': '声明',
  'pernyataanform.titleSync': '同步声明',
  'pernyataanform.syncing': '同步中...',
  'pernyataanform.declarationHeader': '兹声明如下：',
  'pernyataanform.statement1': '本人对本文件中所申报内容的真实性及作为本文件编制依据的报关补充文件的有效性负责；并且',
  'pernyataanform.statement2':
    '若在货物准备就绪通知日期后最迟 1（一）日内，本人未出席见证现场查验，则本人授权 TPS 经营者代为见证，由此产生的风险和费用由本人承担。',
  'pernyataanform.signerInfo': '签署人信息',
  'pernyataanform.nama': '姓名',
  'pernyataanform.tanggal': '日期',
  'pernyataanform.placeholderTanggal': '日期',
  'pernyataanform.tempat': '地点',
  'pernyataanform.jabatan': '职务',
  'pernyataanform.errorNamaTtd': '必须填写签署人姓名',
  'pernyataanform.errorTanggalTtd': '必须填写签署日期',
  'pernyataanform.errorKotaTtd': '必须填写签署地点',
  'pernyataanform.errorJabatanTtd': '必须填写签署人职务',
  'pernyataanform.notifySuccessTitle': '成功',
  'pernyataanform.notifySuccessMessage': '声明数据已成功同步',
  'pernyataanform.notifyErrorTitle': '错误',
  'pernyataanform.notifyErrorSyncMessage': '声明数据同步失败',
  'pernyataanform.notifyErrorGeneralMessage': '同步声明数据时出错',
  'pernyataanform.notifyNoStatementTitle': '尚未设置声明',
  'pernyataanform.notifyNoStatementMessage': '贵 PPJK 尚未设置声明。请在 Master → Pernyataan 中填写后再同步。',

  // Subscription: free trial
  'subscription.trial.badge.active': '免费试用',
  'subscription.trial.badge.ended': '试用已结束',
  'subscription.trial.free': '免费',
  'subscription.trial.endsOn': '试用结束日期',
  'subscription.trial.cost': '费用',
  'subscription.trial.running.title': '免费试用进行中',
  'subscription.trial.running.daysLeft': '还剩 {n} 天。',
  'subscription.trial.running.endsToday': '试用今天结束。',
  'subscription.trial.running.body': '试用结束后，新的申报将被停用，直到您订阅套餐。',
  'subscription.trial.running.cta': '查看订阅套餐',
  'subscription.trial.header.daysLeft': '免费试用：还剩 {n} 天',
  'subscription.trial.header.endsToday': '免费试用：最后一天',
  'subscription.trial.header.ended': '免费试用已结束',
  'subscription.trial.strip.soon': '免费试用将在 {n} 天后结束。',
  'subscription.trial.strip.today': '免费试用今天结束。',
  'subscription.trial.strip.ended': '免费试用已结束。',
  'subscription.trial.strip.soonDetail': '之后新的申报将被停用，直到您订阅套餐。',
  'subscription.trial.strip.endedDetail': '新的申报已停用，直到您订阅套餐。',
  'subscription.trial.contactSales': '联系销售',
  'subscription.trial.contactSales.message':
    'Halo Sales JARVIS, masa uji coba gratis perusahaan kami akan segera berakhir. Saya ingin berlangganan paket JARVIS.',
  'subscription.trial.ended.title': '免费试用已结束',
  'subscription.trial.ended.body':
    '您的账户已停止新的申报{since}。无需支付任何账单，请选择订阅套餐以继续使用服务。试用期剩余额度不会转入付费套餐。',
  'subscription.trial.ended.since': '（自 {date} 起）',
  'subscription.trial.ended.cta': '选择订阅套餐',
  'subscription.trial.picker.title': '继续使用付费套餐',
  'subscription.trial.picker.subtitleRunning':
    '您的试用仍在进行中。现在订阅可确保试用结束后服务不中断。试用期剩余额度不会转入付费套餐。',
  'subscription.trial.picker.subtitleEnded': '试用已结束，您的账户已被停用。请选择下方套餐以恢复服务。',
  'subscription.invoice.trialBadge': '免费试用',
  'subscription.invoice.free': '免费',
  // Subscription page + billing components
  'subscription.page.title': '订阅',
  'subscription.page.subtitle': '管理您的订阅套餐和月度账单',
  'subscription.page.loadingSubscription': '正在加载订阅数据...',
  'subscription.page.loadingPlans': '正在加载订阅套餐...',
  'subscription.common.error': '发生错误',
  'subscription.card.title': '订阅',
  'subscription.card.currentPeriod': '当前周期',
  'subscription.card.nextBilling': '下次账单',
  'subscription.card.pricePerMonth': '每月价格',
  'subscription.card.quotaTitle': '每月额度',
  'subscription.card.col.product': '产品',
  'subscription.card.col.quotaPerPeriod': '每周期额度',
  'subscription.card.col.used': '已使用',
  'subscription.card.col.balance': '当前余额',
  'subscription.card.credits': '额度',
  'subscription.card.usedOf': '已使用 {used}/{quota}',
  'subscription.card.balanceError': '无法加载额度余额',
  'subscription.card.override': '专属',
  'subscription.card.noQuota': '此套餐不含额度',
  'subscription.status.active': '生效中',
  'subscription.status.pending': '等待付款',
  'subscription.status.unpaid': '未付款',
  'subscription.status.cancelled': '已取消',
  'subscription.cancel.button': '取消订阅',
  'subscription.cancel.confirm.title': '取消订阅？',
  'subscription.cancel.confirm.body': '您可以继续使用积分直到 {date}。订阅结束后将不再从您的银行卡扣款。',
  'subscription.cancel.confirm.titleImmediate': '立即取消订阅？',
  'subscription.cancel.confirm.bodyImmediate':
    '首期账单尚未支付，订阅还未生效，因此将立即取消。待付账单会一并作废，不会产生任何扣款，也不会发放积分。您可以随时重新订阅。',
  'subscription.cancel.toast.periodEnd.title': '操作成功',
  'subscription.cancel.toast.periodEnd.body': '订阅将不再续费。积分在本周期结束前仍可使用。',
  'subscription.cancel.toast.immediate.title': '订阅已取消',
  'subscription.cancel.toast.immediate.body': '待付账单已作废，未产生任何扣款。',
  'subscription.cancel.toast.error.title': '错误',
  'subscription.cancel.toast.error.body': '取消订阅失败，请重试。',
  'subscription.cancel.confirm.back': '返回',
  'subscription.cancel.confirm.confirm': '是的，取消',
  'subscription.cancel.endsOn': '{date} 结束',
  'subscription.cancel.cancelling.title': '已停止自动续费',
  'subscription.cancel.cancelling.body': '订阅将持续有效至 {date}。不再自动扣款，可随时重新订阅。',
  'subscription.cancel.cancelling.cta': '查看套餐',
  'subscription.cancel.picker.title': '重新订阅',
  'subscription.cancel.picker.subtitle': '选择套餐以继续服务。',
  'subscription.alert.unpaid.title': '账户已停用，请尽快付款',
  'subscription.alert.unpaid.body': '您的订阅尚未付款{since}。账户将被停用直到账单结清。请在下方账单区完成付款。',
  'subscription.alert.unpaid.since': '（自 {date} 起）',
  'subscription.alert.pending.title': '等待付款',
  'subscription.alert.pending.body': '首期账单付款后订阅即生效。请在下方账单区完成付款。',
  'subscription.picker.title': '选择订阅套餐',
  'subscription.picker.subtitle': '您还没有订阅。请选择下方套餐开始订阅。',
  'subscription.picker.empty': '目前没有可用的订阅套餐。',
  'subscription.picker.perMonth': '/ 月',
  'subscription.picker.periodDays': '周期 {n} 天',
  'subscription.picker.accountPrice': '您账户的专属价格',
  'subscription.picker.includedCredits': '包含额度：',
  'subscription.picker.creditLine': '{n} 额度 {product}',
  'subscription.picker.product': '产品 #{id}',
  'subscription.picker.subscribe': '订阅',
  'subscription.invoices.title': '账单',
  'subscription.invoices.col.type': '类型',
  'subscription.invoices.col.period': '周期',
  'subscription.invoices.col.amount': '金额',
  'subscription.invoices.col.status': '状态',
  'subscription.invoices.col.action': '操作',
  'subscription.invoices.type.initial': '首期账单',
  'subscription.invoices.type.renewal': '续期账单',
  'subscription.invoices.status.pending': '等待付款',
  'subscription.invoices.status.paid': '已付款',
  'subscription.invoices.status.cancelled': '已取消',
  'subscription.invoices.paidOn': '付款于 {date}',
  'subscription.invoices.priorAttempt': '存在此前的付款指引',
  'subscription.invoices.continuePayment': '继续付款',
  'subscription.invoices.pay': '付款',
  'subscription.invoices.download': '下载',
  'subscription.invoices.downloadError': '下载发票失败，请重试。',
  'subscription.invoices.empty': '暂无账单。',
  'subscription.banner.unpaid.title': '订阅未付款',
  'subscription.banner.unpaid.body': '您的订阅尚未付款，账户已停止新的申报。',
  'subscription.banner.unpaid.cta': '立即付款',
  'subscription.banner.trial.title': '试用已结束',
  'subscription.banner.trial.body': '您的免费试用已结束，账户已停止新的申报。',
  'subscription.banner.trial.cta': '选择套餐',
  'subscription.banner.pending.title': '账单等待付款',
  'subscription.banner.pending.body': '续期账单正在等待付款。',
  'subscription.banner.pending.cta': '支付续期账单',
  // Subscription payment modal
  'subscription.pay.title': '支付账单 #{id}',
  'subscription.pay.subtotal': '小计',
  'subscription.pay.fee': '支付服务费',
  'subscription.pay.feeNotice': '支付服务费在小计之外另行收取，不同支付方式的费率可能不同。',
  'subscription.pay.total': '应付总额：',
  'subscription.pay.method': '支付方式',
  'subscription.pay.method.va': '虚拟账户',
  'subscription.pay.method.qris': 'QRIS',
  'subscription.pay.method.card': '信用卡',
  'subscription.pay.method.unknown': '未知',
  'subscription.pay.prior.title': '存在此前的付款指引',
  'subscription.pay.prior.body': '您已通过 {method}{bank} 发起付款。可以重新查看该指引，或使用其他方式重新付款。',
  'subscription.pay.prior.cta': '查看此前的付款指引',
  'subscription.pay.selectBank': '选择银行',
  'subscription.pay.continue': '继续付款',
  'subscription.pay.va.transferTo': '请转账至以下虚拟账户号码：',
  'subscription.pay.va.note': '转账后，付款将在 1-5 分钟内自动处理。',
  'subscription.pay.copy': '复制',
  'subscription.pay.copied.title': '成功',
  'subscription.pay.copied.body': '已复制到剪贴板',
  'subscription.pay.qris.title': '扫描 QRIS',
  'subscription.pay.qris.body': '请使用电子钱包应用扫描下方二维码：',
  'subscription.pay.qris.unavailable': '二维码图片不可用',
  'subscription.pay.card.title': '信用卡支付',
  'subscription.pay.card.open': '打开支付页面',
  'subscription.pay.card.unavailable': '支付链接不可用',
  'subscription.pay.waiting': '等待付款',
  'subscription.pay.polling': '每 5 秒自动检查状态',
  'subscription.pay.changeMethod': '更换支付方式',
  'subscription.pay.checkStatus': '检查状态',
  'subscription.pay.success.title': '支付成功',
  'subscription.pay.success.body': '您的订阅账单已支付，谢谢！',
  'subscription.pay.success.notification': '您的订阅账单已支付。',
  'subscription.pay.close': '关闭',

  // Dashboard header notification bell (incoming CEISA email responses)
  'notifications.bell.title': '通知',
  'notifications.bell.aria': '邮件响应通知',
  'notifications.bell.markAllRead': '全部标为已读',
  'notifications.bell.empty': '暂无邮件响应',
  'notifications.bell.emptyHint': '收到的 CEISA 响应将显示在这里',
  'notifications.bell.loading': '正在加载通知...',
  'notifications.bell.error': '加载通知失败',
  'notifications.bell.retry': '重试',
  'notifications.bell.unreadCount': '条未读',
  'notifications.bell.new': '新',
  'notifications.bell.ajuNumber': '申报编号',
  'notifications.bell.filterAll': '全部',
  'notifications.bell.filterUnread': '未读',
  'notifications.bell.emptyUnread': '全部已读',
  'notifications.bell.emptyUnreadHint': '没有待查看的响应',
  'notifications.bell.urgent': '紧急',
  'notifications.bell.download': '下载',
  'notifications.bell.downloading': '正在下载',
  'notifications.bell.downloaded': '下载完成',
  'notifications.bell.downloadFailed': '下载失败',
  'notifications.bell.sinceLastResponse': '自上次响应',
  'notifications.bell.lastResponseAt': '上次响应',
  // Entity history check — see the Indonesian block for the wording rules.
  'entitycheck.cocok': '一致',
  'entitycheck.perluDiperiksa': '请核对',
  'entitycheck.tidakDicek': '未核对',
  'entitycheck.dariAkun': '来自您的账户',
  'entitycheck.samaDenganDokumen': '与文档一致',
  'entitycheck.bedaDariDokumen': '与文档不同',
  'entitycheck.cocokDariNama': '按名称匹配',
  'entitycheck.dokumen': '文档',
  'entitycheck.dokumenSebelumnya': '以前的文档',
  'entitycheck.pakaiIni': '使用这个',
  'entitycheck.biarkanSaja': '保留当前',
  'entitycheck.belumAda': '此处尚无',
  'entitycheck.tambahkan': '添加',

  // ---- HS 编码信息（INSW 商品详情）----
  // 标题与字段沿用 INSW 门户的用词，熟悉该门户的用户无需转换术语。
  'hsCodeInfo.title': 'HS 编码信息',
  'hsCodeInfo.kodeHs': 'HS 编码',
  'hsCodeInfo.tabTarif': '关税信息',
  'hsCodeInfo.tabPreferensi': '优惠关税',
  'hsCodeInfo.tabRegulasiImpor': '进口法规',
  'hsCodeInfo.tabRegulasiEkspor': '出口法规',
  'hsCodeInfo.kolNamaTarif': '税种名称',
  'hsCodeInfo.berlakuSeterusnya': '持续有效',
  'hsCodeInfo.kedaluwarsa': '已失效',
  'hsCodeInfo.belumBerlaku': '尚未生效',
  'hsCodeInfo.bahasa': '印尼文',
  'hsCodeInfo.english': '英文',
  'hsCodeInfo.satuanBarang': '商品计量单位',
  'hsCodeInfo.kolKodeSatuan': '单位代码',
  'hsCodeInfo.kolUraianSatuan': '单位说明',
  'hsCodeInfo.kolJenis': '类别',
  'hsCodeInfo.kolTarif': '税率',
  'hsCodeInfo.kolRegulasi': '法规',
  'hsCodeInfo.tabUmum': '商品描述',
  'hsCodeInfo.tabLainnya': '其他信息',
  'hsCodeInfo.lartasYa': '受管制',
  'hsCodeInfo.lartasTidak': '非管制',
  'hsCodeInfo.kodeNormal': '标准化编码',
  'hsCodeInfo.uraianId': '描述（印尼文）',
  'hsCodeInfo.uraianEn': '描述（英文）',
  'hsCodeInfo.tahunInsw': 'INSW 年份',
  'hsCodeInfo.kodeSatuan': '单位代码',
  'hsCodeInfo.spesifikasi': '商品规格',
  'hsCodeInfo.cariPreferensi': '搜索协定或 PMK 编号',
  'hsCodeInfo.dibandingMfn': '对比 MFN 关税 {rate}',
  'hsCodeInfo.hematBm': '节省 {n}% 关税',
  'hsCodeInfo.tidakLebihMurah': '不低于 MFN 税率',
  'hsCodeInfo.preferensiTidakCocok': '没有符合「{query}」的优惠协定',
  'hsCodeInfo.lartasBorder': '进口法规（Lartas Border）',
  'hsCodeInfo.tataNiagaPostBorder': '进口法规（Tata Niaga Post Border）',
  'hsCodeInfo.regulasiImporUmum': '进口法规（一般）',
  'hsCodeInfo.lartasEkspor': '出口法规（Lartas Ekspor）',
  'hsCodeInfo.kolNamaIzin': '许可证名称',
  'hsCodeInfo.kolKodeIzin': '许可证代码',
  'hsCodeInfo.kolDeskripsi': '描述',
  'hsCodeInfo.kolDasarHukum': '法律依据',
  'hsCodeInfo.kolMasaBerlaku': '有效期',
  'hsCodeInfo.kolKeterangan': '备注',
  'hsCodeInfo.kolDokumenPabean': '海关单证',
  'hsCodeInfo.kolUraianBarang': '货物描述',
  'hsCodeInfo.instansi': '机构',
  'hsCodeInfo.sekarang': '至今',
  'hsCodeInfo.berlaku': '生效',
  'hsCodeInfo.terbaru': '最新',
  'hsCodeInfo.legacy': '旧版',
  'hsCodeInfo.mfnTerbaru': '最惠国税率（最新）',
  'hsCodeInfo.mfn': '最惠国税率',
  'hsCodeInfo.preferensiTerbaru': '优惠税率（最新）',
  'hsCodeInfo.preferensi': '优惠税率',
  'hsCodeInfo.tarifPerTahun': '各年度税率',
  'hsCodeInfo.lanjutan': '后续年度沿用此税率',
  'hsCodeInfo.sda': 'SDA（自然资源）',
  'hsCodeInfo.tidakDiaturLartasBorder': '该 HS 编码未列入 Lartas Border 管制',
  'hsCodeInfo.tidakDiaturPostBorder': '该 HS 编码未列入 Tata Niaga Post Border 管制',
  'hsCodeInfo.tidakDiaturImporUmum': '该 HS 编码未列入一般进口法规',
  'hsCodeInfo.tidakDiaturLartasEkspor': '该 HS 编码未列入 Lartas Ekspor 管制',
  // 用于 INSW 尚未对该编码作答时：空并不意味着“未受管制”。
  'hsCodeInfo.regulasiBelumTersedia': '该编码的法规数据尚未获取',
  'hsCodeInfo.tidakAdaTarif': '暂无最惠国税率数据',
  'hsCodeInfo.tidakAdaPreferensi': '该编码暂无优惠税率方案',
  'hsCodeInfo.tidakAdaData': '该 HS 编码暂无数据',
  'hsCodeInfo.tidakDitemukan': '未找到该 HS 编码的数据',
  'hsCodeInfo.gagalMuat': '加载 HS 编码详情失败',

  // ---- Master: Data Consignee ----
  'menu.dataConsignee': '收货人数据',
  'consignee.title': '收货人数据',
  'consignee.subtitle': '您经办的进口商名单。填写一次，在您的单证中反复使用。',
  'consignee.privacyTitle': '仅供贵报关行使用',
  'consignee.tabOwn': '我的 PPJK',
  'consignee.tabGlobal': '全部 PPJK',
  'consignee.colPpjk': 'PPJK',
  'consignee.globalNoticeTitle': '内部视图，仅供查看',
  'consignee.globalNotice':
    '所有 PPJK 的收货人列表，仅超级管理员可见。如需新增或修改收货人，请以其所属 PPJK 的身份操作。',
  'consignee.globalSearchPlaceholder': '搜索收货人、NPWP 或 PPJK',
  'consignee.privacyBody':
    '此名单仅为 {company}（NPWP {npwp}）保存。不会共享给其他报关行，不用于任何训练，只用于填写您的单证。',
  'consignee.yourPpjk': '贵报关行',
  'consignee.noPpjkTitle': '尚无报关行 NPWP',
  'consignee.noPpjkMsg': '您的账号尚未关联报关行，请联系管理员。',
  'consignee.loadFailedTitle': '加载失败',
  'consignee.loadFailedMsg': '收货人名单暂时无法加载，请稍后再试。',
  'consignee.searchPlaceholder': '搜索名称或 NPWP',
  'consignee.total': '{n} 个收货人',
  'consignee.template': '模板',
  'consignee.exportCurrent': '下载当前数据',
  'consignee.uploadExcel': '上传 Excel',
  'consignee.uploadIntro': '下载模板，在 Excel 中填写后重新上传。保存前您会看到将要发生的变更。',
  'consignee.add': '新增',
  'consignee.addTitle': '新增收货人',
  'consignee.editTitle': '编辑收货人',
  'consignee.emptyTitle': '暂无收货人',
  'consignee.emptyHint': '逐个添加，或通过 Excel 一次导入。',
  'consignee.colNama': '收货人名称',
  'consignee.colNpwp': 'NPWP',
  'consignee.colAlamat': '地址',
  'consignee.colNib': 'NIB',
  'consignee.colJenisApi': 'API 类型',
  'consignee.colStatus': '状态',
  'consignee.colSumber': '来源',
  'consignee.colDiperbarui': '更新时间',
  'consignee.colAksi': '操作',
  'consignee.sourceExcel': 'Excel',
  'consignee.sourceManual': '手动',
  'consignee.sourceCeisa': 'CEISA',
  'consignee.edit': '编辑',
  'consignee.delete': '删除',
  'consignee.cancel': '取消',
  'consignee.save': '保存',
  'consignee.create': '新增',
  'consignee.unknown': '未知',
  'consignee.npwpHint': '15 或 16 位数字。可带点和横线，会自动整理。',
  'consignee.npwpStoredAs': '将保存为 {npwp}',
  'consignee.npwpInvalid': 'NPWP 必须为 15 或 16 位数字',
  'consignee.nibInvalid': 'NIB 必须为 13 位数字',
  'consignee.formInvalidTitle': '请检查输入',
  'consignee.formInvalidMsg': '名称和 NPWP 为必填且须正确。',
  'consignee.savedTitle': '已保存',
  'consignee.createdMsg': '收货人已添加。',
  'consignee.updatedMsg': '收货人已更新。',
  'consignee.existsMsg': '该 NPWP 已在您的名单中。请编辑现有记录，而不是新增。',
  'consignee.saveFailedTitle': '保存失败',
  'consignee.saveFailedMsg': '收货人尚未保存，请重试。',
  'consignee.deleteTitle': '删除收货人',
  'consignee.deleteConfirm': '从名单中删除 {nama}？此后新单证中不再出现。',
  'consignee.deletedTitle': '已删除',
  'consignee.deletedMsg': '收货人已从名单中删除。',
  'consignee.deleteFailedMsg': '收货人尚未删除，请重试。',
  'consignee.downloadFailedTitle': '下载失败',
  'consignee.downloadFailedMsg': '文件暂时无法下载，请稍后再试。',
  'consigneeImport.dropTitle': '将 Excel 文件拖到此处',
  'consigneeImport.dropHint': '一个 .xlsx 文件，最多 5,000 行',
  'consigneeImport.chooseFile': '选择文件',
  'consigneeImport.onlyXlsx': '请使用模板生成的单个 Excel（.xlsx）文件。',
  'consigneeImport.reading': '正在读取 {file}',
  'consigneeImport.previewFailed': '文件无法读取',
  'consigneeImport.previewStale': '收货人数据已变更，预览可能已不准确',
  'consigneeImport.reloadPreview': '重新加载预览',
  'consigneeImport.chooseOther': '选择其他文件',
  'consigneeImport.rowsSeen': '{n} 行',
  'consigneeImport.rowLabel': '第 {n} 行',
  'consigneeImport.actionNew': '新增',
  'consigneeImport.actionUpdated': '更新',
  'consigneeImport.actionUnchanged': '未变更',
  'consigneeImport.actionRejected': '跳过',
  'consigneeImport.neverDeletes': '上传不会删除数据。文件中没有的行保持不变；空单元格不会覆盖已有的值。',
  'consigneeImport.importN': '导入 {n} 行',
  'consigneeImport.importedTitle': '导入完成',
  'consigneeImport.importedMsg': '新增 {new}，更新 {updated}。',
  'consigneeImport.resultLine': '新增 {new}，更新 {updated}，未变更 {unchanged}。',
  'consigneeImport.rejectedTitle': '被跳过的行',
  'consigneeImport.failedTitle': '导入失败',
  'consigneeImport.failedMsg': '数据尚未保存，请重试。',
  'consigneeImport.uploadAnother': '上传其他文件',
  'menu.dataEksportir': '出口商数据',
  'menu.masterBarang': '货物',
  'masterBarang.title': '货物主数据',
  'masterBarang.subtitle':
    '按进口商维护的货物清单：品名 → 其他规格 → HS。仅在您于 PIB 草稿中点击“同步货物主数据”时使用。',
  'masterBarang.importerLabel': '进口商',
  'masterBarang.importerPlaceholder': '搜索进口商名称或 NPWP',
  'masterBarang.importerRows': '{n} 行',
  'masterBarang.importersLoading': '正在加载进口商…',
  'masterBarang.importersNone': '还没有进口商——请通过“新增收货人”添加',
  'masterBarang.importersNoMatch': '未找到进口商',
  'masterBarang.importerMissingTitle': '进口商 {npwp} 不在列表中',
  'masterBarang.importerMissingMsg': '请先通过“新增收货人”将其添加为收货人（NPWP 已填好），再导入或添加货物。',
  'masterBarang.importerMissingNoAdd': '该进口商还不是此 PPJK 的收货人。请先在该 PPJK 的收货人数据中添加。',
  'masterBarang.addConsignee': '新增收货人',
  'masterBarang.ppjkLabel': 'PPJK',
  'masterBarang.ppjkPlaceholder': '选择 PPJK',
  'masterBarang.ppjkEmpty': '未找到 PPJK',
  'masterBarang.pickPpjk': '请先选择 PPJK',
  'masterBarang.pickPpjkHint': '货物主数据按 PPJK 保存。请选择要管理的 PPJK。',
  'masterBarang.backfill': '回填 AJU 历史',
  'masterBarang.backfillHint': '仅限员工：从该进口商最近 365 天的 PIB 中学习货物',
  'masterBarang.backfillDoneTitle': '回填完成',
  'masterBarang.backfillDoneMsg': '已读取 {processes} 份 PIB：新增 {rowsInserted} 行，{rowsSeen} 行已存在',
  'masterBarang.backfillFailedTitle': '回填失败',
  'masterBarang.backfillFailedMsg': 'AJU 历史回填失败，请重试。',
  'masterBarang.addConsigneeTitle': '新增收货人',
  'masterBarang.addConsigneeIntro': '新收货人将保存到收货人数据，并在此处被选为进口商。',
  'masterBarang.addConsigneeCreated': '收货人 {npwp} 已添加并选中。',
  'masterBarang.addConsigneeExists': 'NPWP {npwp} 已在收货人数据中 — 已直接选中。',
  'masterBarang.pickImporter': '选择进口商以查看货物主数据',
  'masterBarang.pickImporterHint': '每个进口商都有自己的货物清单。列表中没有？请通过“新增收货人”按钮添加。',
  'masterBarang.total': '{n} 项货物',
  'masterBarang.template': '模板',
  'masterBarang.export': '导出',
  'masterBarang.uploadExcel': '导入 Excel',
  'masterBarang.add': '添加货物',
  'masterBarang.searchPlaceholder': '搜索品名、其他规格或 HS',
  'masterBarang.sourceAll': '全部来源',
  'masterBarang.sourceManual': '手动',
  'masterBarang.sourceImport': 'Excel 导入',
  'masterBarang.sourceSubmission': 'AJU 历史',
  'masterBarang.conflictOnly': '仅显示冲突',
  'masterBarang.help.button': '使用说明',
  'masterBarang.help.title': '货物主数据使用说明',
  'masterBarang.help.intro':
    '货物主数据按进口商保存货物清单。上传单据不会从中填写任何内容：由您在 PIB 草稿中点击“同步货物主数据”，系统按货物描述（不按 HS）匹配，主数据代码填入其他规格并填写 HS。',
  'masterBarang.help.gifAlt':
    '示例：在 PIB 草稿中同步货物主数据——按描述匹配；HS 相同但描述不同的货物仍为“不在主数据中”',
  'masterBarang.help.step1': '进口商不在列表中时，先“新增收货人”，然后选择该进口商。',
  'masterBarang.help.step2': '下载模板或导入 Excel（品名 | 其他规格 | HS 编码），检查预览，然后点击导入。',
  'masterBarang.help.step3': '打开“仅显示冲突”，查看有多个 HS 的代码。',
  'masterBarang.help.step4':
    '在 PIB 草稿中打开“货物”标签 → “同步货物主数据”按钮 → 选择进口商 → 同步。按货物描述匹配，不按 HS：代码填入其他规格并填写 HS。完全匹配直接填写，货物描述不变；包含主数据描述全部词的先审核（修改 = 使用主数据描述并删除多余的词 / 保留）。',
  'masterBarang.help.step5':
    '绿点 = 匹配；黄色 = 请核对并确认；“选择代码” = 从候选中选择；红色 = 描述匹配但 HS 不同 — 选择“货物描述正确”或“保留”（使用单据 HS）；灰色 = “不在主数据中”（仅 HS 相同不算匹配）。',
  'masterBarang.help.close': '知道了',
  'masterBarang.conflictNameMultiCode': '此名称有多个代码',
  'masterBarang.conflictCodeMultiHs': '此代码有多个 HS',
  'masterBarang.colUraian': '品名',
  'masterBarang.colSpesifikasiLain': '其他规格',
  'masterBarang.colHs': 'HS 编码',
  'masterBarang.colSumber': '来源',
  'masterBarang.colDipakai': '使用',
  'masterBarang.colAksi': '操作',
  'masterBarang.seenCount': '{n} 次',
  'masterBarang.relative.justNow': '刚刚',
  'masterBarang.relative.minutes': '{n} 分钟前',
  'masterBarang.relative.hours': '{n} 小时前',
  'masterBarang.relative.days': '{n} 天前',
  'masterBarang.relative.months': '{n} 个月前',
  'masterBarang.relative.years': '{n} 年前',
  'masterBarang.emptyTitle': '该进口商还没有货物',
  'masterBarang.emptyHint': '逐个添加或从 Excel 导入。',
  'masterBarang.emptyFiltered': '没有符合筛选条件的货物',
  'masterBarang.loadFailedTitle': '无法加载货物主数据',
  'masterBarang.loadFailedMsg': '请尝试刷新页面。',
  'masterBarang.noPpjkTitle': '未找到 PPJK NPWP',
  'masterBarang.noPpjkMsg': '货物主数据按 PPJK 保存。请使用 PPJK 账户登录以进行管理。',
  'masterBarang.addTitle': '添加货物',
  'masterBarang.editTitle': '编辑货物',
  'masterBarang.forImporter': '进口商：{npwp}',
  'masterBarang.editHint': '修改后此行变为手动 — 导入不会覆盖',
  'masterBarang.hsHint': '8 位 HS，可带点（3903.30.90）',
  'masterBarang.hsInvalid': 'HS 必须为 8 位',
  'masterBarang.required': '必填',
  'masterBarang.cancel': '取消',
  'masterBarang.save': '保存',
  'masterBarang.create': '添加',
  'masterBarang.formInvalidTitle': '信息不完整',
  'masterBarang.formInvalidMsg': '请填写品名、其他规格和 8 位 HS。',
  'masterBarang.savedTitle': '已保存',
  'masterBarang.createdMsg': '货物已添加到货物主数据。',
  'masterBarang.updatedMsg': '货物已更新，来源现为手动。',
  'masterBarang.existsMsg': '已存在品名、代码和 HS 相同的货物。',
  'masterBarang.saveFailedTitle': '保存失败',
  'masterBarang.saveFailedMsg': '货物未保存，请重试。',
  'masterBarang.deleteTitle': '删除货物',
  'masterBarang.deleteConfirm': '从货物主数据中删除“{uraian}”（{kode}）？Jarvis 将不再使用它。可在删除记录中恢复。',
  'masterBarang.delete': '删除',
  'masterBarang.edit': '编辑',
  'masterBarang.deletedTitle': '已删除',
  'masterBarang.deletedMsg': '货物已从货物主数据中删除。',
  'masterBarang.deleteFailedMsg': '货物未删除，请重试。',
  'masterBarang.viewActive': '有效',
  'masterBarang.viewDeleted': '删除记录',
  'masterBarang.selectedCount': '已选 {n} 项',
  'masterBarang.selectAllMatching': '选择全部 {n} 项货物',
  'masterBarang.allMatchingSelected': '已选择全部 {n} 项匹配货物',
  'masterBarang.clearSelection': '取消选择',
  'masterBarang.deleteSelected': '删除所选',
  'masterBarang.bulkDeleteTitle': '删除 {n} 项货物',
  'masterBarang.bulkDeleteConfirm': '将从货物主数据中删除 {n} 项货物，同步将不再使用它们。可在删除记录中恢复。',
  'masterBarang.bulkDeleteAllNote': '这是与当前搜索和筛选匹配的全部货物，不仅是本页。',
  'masterBarang.bulkDeletedMsg': '已删除 {n} 项货物。可在删除记录中查看。',
  'masterBarang.selectionChangedTitle': '货物数量已变化',
  'masterBarang.selectionChangedMsg': '现在有 {n} 项匹配货物。尚未做任何更改，请检查后重试。',
  'masterBarang.history.intro': '已删除的货物不会被同步使用。恢复后可再次使用。每次删除和恢复都记录在活动日志中。',
  'masterBarang.history.tabDeleted': '已删除货物',
  'masterBarang.history.tabLog': '活动日志',
  'masterBarang.history.colDeleted': '删除时间',
  'masterBarang.history.beforeLog': '日志启用之前',
  'masterBarang.history.restore': '恢复',
  'masterBarang.history.restoreSelected': '恢复所选',
  'masterBarang.history.restoreTitle': '恢复 {n} 项货物',
  'masterBarang.history.restoreConfirm': '{n} 项货物将回到货物主数据并再次被同步使用。描述、其他规格和 HS 已存在于主数据中的货物不会恢复，以免重复。',
  'masterBarang.history.restoredMsg': '已恢复 {n} 项货物。',
  'masterBarang.history.skippedTitle': '{n} 项货物未恢复',
  'masterBarang.history.skippedDuplicate': '已存在于货物主数据：{list}',
  'masterBarang.history.restoreFailedMsg': '货物未恢复，请重试。',
  'masterBarang.history.empty': '尚无已删除的货物',
  'masterBarang.history.emptyFiltered': '没有匹配的已删除货物',
  'masterBarang.history.logEmpty': '尚无删除或恢复记录',
  'masterBarang.history.searchPlaceholder': '搜索描述、其他规格或 HS',
  'masterBarang.history.colTime': '时间',
  'masterBarang.history.colAction': '操作',
  'masterBarang.history.colVia': '方式',
  'masterBarang.history.colBy': '操作人',
  'masterBarang.history.actionAll': '全部操作',
  'masterBarang.history.actionDelete': '已删除',
  'masterBarang.history.actionRestore': '已恢复',
  'masterBarang.history.via.single': '单行',
  'masterBarang.history.via.bulk': '批量',
  'masterBarang.history.via.import': 'Excel 导入',
  'masterBarang.history.via.edit': '编辑货物',
  'masterBarang.history.via.create': '新增货物',
  'masterBarang.history.batchOf': '一次 {n} 项',
  'masterBarang.history.unknownUser': '未知',
  'masterBarang.downloadFailedTitle': '下载失败',
  'masterBarang.downloadFailedMsg': '文件未下载，请重试。',
  'masterBarang.uploadIntro':
    '文件中的所有行都将导入进口商 {npwp} 的货物主数据。列：Uraian Barang、Spesifikasi Lain、HS Code。',
  'masterBarangImport.dropTitle': '将 Excel 文件拖到此处',
  'masterBarangImport.dropHint': '.xlsx 格式，列为 Uraian Barang、Spesifikasi Lain、HS Code',
  'masterBarangImport.chooseFile': '选择文件',
  'masterBarangImport.onlyXlsx': '只能导入 .xlsx 文件。',
  'masterBarangImport.reading': '正在读取 {file}…',
  'masterBarangImport.previewFailed': '无法读取文件',
  'masterBarangImport.failedTitle': '导入失败',
  'masterBarangImport.failedMsg': '请重试或检查文件格式。',
  'masterBarangImport.chooseOther': '选择其他文件',
  'masterBarangImport.previewStale': '预览生成后，该进口商的货物主数据已更改。',
  'masterBarangImport.reloadPreview': '重新加载预览',
  'masterBarangImport.rowsSeen': '已读取 {n} 行',
  'masterBarangImport.summary.new': '{n} 新增',
  'masterBarangImport.summary.unchanged': '{n} 未变',
  'masterBarangImport.summary.reactivated': '{n} 重新启用',
  'masterBarangImport.summary.skipped': '{n} 跳过',
  'masterBarangImport.summary.duplicatesCollapsed': '{n} 重复已合并',
  'masterBarangImport.noIssues': '没有警告。',
  'masterBarangImport.examplesNote': '最多 50 个示例。',
  'masterBarangImport.issue.HS_TRUNCATED': '10 位 HS 已截为 8 位',
  'masterBarangImport.issue.HS_NOT_IN_BTKI': 'HS 不在 BTKI 中（仍会导入）',
  'masterBarangImport.issue.HS_INVALID': 'HS 无效（已跳过）',
  'masterBarangImport.issue.ROW_INCOMPLETE': '品名或其他规格为空（已跳过）',
  'masterBarangImport.issue.NAME_MULTI_CODE': '此名称有多个代码',
  'masterBarangImport.issue.CODE_MULTI_HS': '此代码有多个 HS',
  'masterBarangImport.colRow': '行',
  'masterBarangImport.colRaw': '原始值',
  'masterBarangImport.colHsCodes': 'HS',
  'masterBarangImport.neverDeletes': '导入不会删除文件中没有的行，也不会覆盖手动行。',
  'masterBarangImport.importN': '导入 {n} 行',
  'masterBarangImport.importedTitle': '导入完成',
  'masterBarangImport.importedMsg': '新增 {inserted} 行，重新启用 {reactivated} 行。',
  'masterBarangImport.resultLine':
    '新增 {inserted} 行，重新启用 {reactivated} 行，{promoted} 行 AJU 历史升级为 Excel 导入。',
  'masterBarangImport.uploadAnother': '导入其他文件',
  'masterMatch.chipExact': '主数据',
  'masterMatch.chipFuzzy': '包含主数据全部词 · 请核对',
  'masterMatch.chipAmbiguous': '选择代码',
  'masterMatch.chipNone': '不在主数据中',
  'masterMatch.chipPicked': '已从主数据选择',
  'masterMatch.chipHs': 'HS 匹配 · 请核对',
  'masterMatch.chipConflict': '货物描述与 HS 不一致 — 请选择',
  'masterMatch.chipTooltip': '其他规格来源：货物主数据',
  'masterMatch.popoverExact': '由货物主数据填写',
  'masterMatch.beforeTitle': '主数据填写前',
  'masterMatch.popoverPicked': '已从货物主数据选择',
  'masterMatch.popoverFuzzy': '由品名包含其全部词的货物主数据行填写 — 请核对',
  'masterMatch.popoverAmbiguous': '从货物主数据中选择代码',
  'masterMatch.popoverNone': '不在货物主数据中',
  'masterMatch.popoverHs': '由相同 HS 的货物主数据代码填写 — 请核对',
  'masterMatch.popoverConflict': '货物描述与货物主数据匹配，但其 HS 与单据不同 — 请选择正确的一方',
  'masterMatch.conflictDocumentHs': '单据：HS {hs}',
  'masterMatch.conflictUraianRight': '货物描述正确',
  'masterMatch.conflictKeep': '保留 — 使用单据 HS',
  'masterMatch.conflictHint':
    '货物描述正确：其他规格填入主数据代码，使用主数据 HS，并重新同步税率。保留：保留单据的 HS 和货物描述，货物不作更改。',
  'masterMatch.noneBody': '该品名尚未在进口商的货物主数据中。',
  'masterMatch.addToMaster': '添加到货物主数据',
  'masterMatch.noRows': '未找到货物主数据行。',
  'masterMatch.ambiguousHint': '此名称在货物主数据中有多个代码，请选择正确的一个。',
  'masterMatch.ambiguousHsHint': '货物描述不匹配；此 HS 在货物主数据中有多个代码。请选择正确的一个。',
  'masterMatch.hsHint': '货物描述与货物主数据不匹配，因此按 HS 选择了代码。',
  'masterMatch.viaHs': '经 HS',
  'masterMatch.applied': '使用中',
  'masterMatch.pick': '选择',
  'masterMatch.confirm': '确认',
  'masterMatch.confirmHint': '确认表示此行已检查 — 标签变为绿色',
  'masterMatch.candidatesCount': '{n} 个候选',
  'masterMatch.pickedTitle': '已从主数据选择',
  'masterMatch.pickedMsg': '其他规格已由货物主数据填写。',
  'masterMatch.pickedHsMsg': '其他规格和 HS 已由货物主数据填写。新 HS 的税率已同步 — 请保存。',
  'masterMatch.keptTitle': '已保留单据数据',
  'masterMatch.keptMsg': '此货物未更改：保留单据的 HS 和货物描述。之后的同步不会再处理它。',
  'masterMatch.pickFailedTitle': '选择失败',
  'masterMatch.pickFailed': '无法使用该货物主数据行，请重试。',
  'masterMatch.pickNoLine': '请先保存此货物，再从货物主数据中选择。',
  'masterMatch.hsMasterApplied': 'HS 来自货物主数据（单据：{hs}）',
  'masterMatch.hsKeptMultiHs': '此代码在货物主数据中有多个 HS — 使用单据 HS',
  'masterMatch.hsKeptNotBtki': '货物主数据中的 HS 不在 BTKI 中 — 使用单据 HS',
  'masterMatch.hsMasterAppliedNoDocument': 'HS 来自货物主数据（单据未列明 HS）',
  'masterMatch.hsKeptMultiHsPick': '此代码在货物主数据中有多个 HS — 请选择 HS：',
  'masterMatch.hsKeptMultiHsNoDocument': '此代码在货物主数据中有多个 HS — 请手动填写 HS',
  'masterMatch.hsKeptNotBtkiNoDocument': '货物主数据中的 HS 不在 BTKI 中 — 请手动填写 HS',
  'masterMatch.hsConflict': '单据 HS 与货物主数据不同 — 请在其他规格标签中选择',
  'masterMatch.hsConflictManual': '单据 HS 与该代码在货物主数据中的 HS 不同',
  'masterMatch.useMasterHs': '使用主数据 HS {hs}',
  'masterMatch.hsChoiceTitle': '已使用货物主数据 HS',
  'masterMatch.useDocumentHs': '使用单据 HS',
  'masterMatch.documentHsTitle': '已使用单据 HS',
  'masterMatch.documentHsMsg': '已设置 HS {hs} 并同步税率。请保存以生效。',
  'masterMatch.openInDrawer': '在编辑货物中打开',
  'masterMatch.pickedHsTableMsg': '其他规格和 HS 已由货物主数据填写，税率已同步。',
  'masterMatch.filterActive': '货物主数据：显示 {n} 项需核对的货物',
  'masterMatch.filterLoading': '正在加载需核对的货物…',
  'masterMatch.filterFailed': '无法加载需核对的货物。',
  'masterMatch.filterClear': '显示全部货物',
  'masterMatch.syncButton': '同步货物主数据',
  'masterMatch.syncTitle': '同步货物主数据',
  'masterMatch.syncIntro':
    '按货物描述（Uraian，或其中的代码）匹配进口商的货物主数据，不按 HS 匹配：主数据代码写入其他规格，并填写 HS。完全匹配：货物描述不变。品名包含主数据全部词（顺序不限，可有多余的词）：先审核 — 修改则使用主数据描述并删除多余的词，保留则不更改货物。品牌和型号不会更改。货物描述不匹配的货物不会被填写，已填写其他规格的货物不会被覆盖。',
  'masterMatch.syncImporterLabel': '进口商 / 收货人',
  'masterMatch.syncImporterPlaceholder': '选择进口商',
  'masterMatch.syncNoImporters': '货物主数据中还没有进口商。',
  'masterMatch.syncNoImportersLink': '在货物主数据中新增收货人并导入货物 →',
  'masterMatch.syncImporterMissing': '此草稿的进口商不在货物主数据中——请通过“新增收货人”添加',
  'masterMatch.syncNoRows': '该进口商还没有货物主数据。',
  'masterMatch.syncOpenMaster': '打开货物主数据',
  'masterMatch.syncSubmit': '同步',
  'masterMatch.syncErrorTitle': '同步失败',
  'masterMatch.syncErrorEmpty': '该进口商没有货物主数据。请先在货物主数据中添加或导入。',
  'masterMatch.syncErrorUnavailable': '无法连接 Jarvis，请重试',
  'masterMatch.syncErrorDbBusy': 'Staging 数据库连接已满，请稍后再试。',
  'masterMatch.syncErrorServer': '服务器出现问题（502），请稍后再试。',
  'masterMatch.syncErrorTooLarge': '该进口商的货物主数据过大（超过 50,000 行），无法同步',
  'masterMatch.syncErrorPibOnly': '货物主数据同步仅适用于 PIB',
  'masterMatch.syncFailed': '货物主数据同步失败。请重试。',
  'masterMatch.syncHeadline': '{total} 项货物中有 {filled} 项已从货物主数据填写',
  'masterMatch.syncMasterRows': '货物主数据 {npwp}：{n} 行',
  'masterMatch.syncSectionLines': '其他规格',
  'masterMatch.syncSectionHs': 'HS',
  'masterMatch.syncFilledExact': '已填写 — 完全匹配',
  'masterMatch.syncFilledFuzzy': '已填写 — 包含主数据全部词，请核对',
  'masterMatch.syncAmbiguous': '需选择编码',
  'masterMatch.syncConflict': '货物描述与 HS 不一致 — 需选择',
  'masterMatch.syncNone': '不在货物主数据中',
  'masterMatch.syncSkippedFilled': '已填写，未覆盖',
  'masterMatch.syncHsAgree': 'HS 与单据一致',
  'masterMatch.syncHsMasterApplied': '使用主数据 HS（与单据不同）',
  'masterMatch.syncHsKeptMultiHs': '保留单据 HS — 该编码有多个 HS',
  'masterMatch.syncHsKeptNotBtki': '保留单据 HS — 主数据 HS 不在 BTKI 中',
  'masterMatch.syncReview': '查看需核对的货物',
  'masterMatch.syncClose': '关闭',
  'masterMatch.syncKept': '保留 — 未修改',
  'masterMatch.syncPending': '未选择 — 未修改',
  'masterMatch.syncReviewTitle': '保存前核对更改',
  'masterMatch.syncReviewCount': '{n} 项货物并非完全匹配 — 请先核对。尚未保存 — 请逐项选择修改或保留。',
  'masterMatch.syncAutoApplyCount': '{n} 项完全匹配的货物将直接修改',
  'masterMatch.syncAutoApplyShow': '查看',
  'masterMatch.syncAutoApplyHide': '收起',
  'masterMatch.syncFuzzyWarning': '品名包含主数据全部词，但并非完全一致 — 多余的词将被删除，请先核对',
  'masterMatch.syncHsMoveWarning': 'HS 将按货物主数据替换（税率随之更新）',
  'masterMatch.syncKindExact': '完全匹配',
  'masterMatch.syncKindFuzzy': '品名包含主数据全部词',
  'masterMatch.syncRemovedWords': '将删除：',
  'masterMatch.syncKindHsMove': '使用主数据 HS',
  'masterMatch.syncKindOther': '来自货物主数据',
  'masterMatch.syncSeri': '序号 {n}',
  'masterMatch.syncFieldUraian': '货物描述',
  'masterMatch.syncFieldSpesifikasiLain': '其他规格',
  'masterMatch.syncFieldHs': 'HS',
  'masterMatch.syncFieldKodeBarang': '货物代码',
  'masterMatch.syncFieldUkuran': '尺寸',
  'masterMatch.syncFieldMerk': '品牌',
  'masterMatch.syncFieldTipe': '型号',
  'masterMatch.syncEmptyValue': '（空）',
  'masterMatch.syncCleared': '（清空）',
  'masterMatch.syncRetariff': '税率随之更新',
  'masterMatch.syncChoiceAccept': '修改',
  'masterMatch.syncChoiceKeep': '保留',
  'masterMatch.syncAcceptAll': '全部修改',
  'masterMatch.syncKeepAll': '全部保留',
  'masterMatch.syncChoiceLabel': '序号 {n} 的选择',
  'masterMatch.syncApply': '应用（修改 {n} 项）',
  'submitsummary.masterBarang.title': '货物主数据：{n} 项货物需核对',
  'submitsummary.masterBarang.body':
    '来自货物主数据的代码或 HS 需要核对：尚未选择代码、不在主数据中、按词匹配（并非完全一致），或主数据 HS 与单据不同。不会阻止提交。',
  'submitsummary.masterBarang.open': '查看货物',
  'eksportir.title': '出口商数据',
  'eksportir.subtitle': '您经办的出口商名单。填写一次，在您的 PEB 单证中反复使用。',
  'eksportir.privacyTitle': '仅供贵报关行使用',
  'eksportir.tabOwn': '我的 PPJK',
  'eksportir.tabGlobal': '全部 PPJK',
  'eksportir.colPpjk': 'PPJK',
  'eksportir.globalNoticeTitle': '内部视图，仅供查看',
  'eksportir.globalNotice':
    '所有 PPJK 的出口商列表，仅超级管理员可见。如需新增或修改出口商，请以其所属 PPJK 的身份操作。',
  'eksportir.globalSearchPlaceholder': '搜索出口商、证件号码或 PPJK',
  'eksportir.privacyBody':
    '此名单仅为 {company}（NPWP {npwp}）保存。不会共享给其他报关行，不用于任何训练，只用于填写您的单证。',
  'eksportir.yourPpjk': '贵报关行',
  'eksportir.noPpjkTitle': '尚无报关行 NPWP',
  'eksportir.noPpjkMsg': '您的账号尚未关联报关行，请联系管理员。',
  'eksportir.loadFailedTitle': '加载失败',
  'eksportir.loadFailedMsg': '出口商名单暂时无法加载，请稍后再试。',
  'eksportir.searchPlaceholder': '搜索名称或证件号码',
  'eksportir.total': '{n} 个出口商',
  'eksportir.template': '模板',
  'eksportir.exportCurrent': '下载当前数据',
  'eksportir.uploadExcel': '上传 Excel',
  'eksportir.uploadIntro': '下载模板，在 Excel 中填写后重新上传。保存前您会看到将要发生的变更。',
  'eksportir.add': '新增',
  'eksportir.addTitle': '新增出口商',
  'eksportir.editTitle': '编辑出口商',
  'eksportir.emptyTitle': '暂无出口商',
  'eksportir.emptyHint': '逐个添加，或通过 Excel 一次导入。',
  'eksportir.colNama': '出口商名称',
  'eksportir.colIdentitas': '证件',
  'eksportir.colJenisIdentitas': '证件类型',
  'eksportir.colNomorIdentitas': '证件号码',
  'eksportir.colAlamat': '地址',
  'eksportir.colStatus': '状态',
  'eksportir.colSumber': '来源',
  'eksportir.colDiperbarui': '更新时间',
  'eksportir.colAksi': '操作',
  'eksportir.sourceExcel': 'Excel',
  'eksportir.sourceManual': '手动',
  'eksportir.sourceCeisa': 'CEISA',
  'eksportir.edit': '编辑',
  'eksportir.delete': '删除',
  'eksportir.cancel': '取消',
  'eksportir.save': '保存',
  'eksportir.create': '新增',
  'eksportir.unknown': '未知',
  'eksportir.namaPlaceholder': 'PT. 示例',
  'eksportir.npwpHint': '15 或 16 位数字。可带点和横线，会自动整理。',
  'eksportir.identitasHint': '仅限数字，其他字符会被自动去除。',
  'eksportir.identitasStoredAs': '将保存为 {nomor}',
  'eksportir.npwpInvalid': 'NPWP 必须为 15 或 16 位数字',
  'eksportir.ktpInvalid': 'KTP 必须为 16 位数字',
  'eksportir.identitasEmpty': '证件号码必须包含数字',
  'eksportir.identitasTooLong': '证件号码最多 50 位数字',
  'eksportir.formInvalidTitle': '请检查输入',
  'eksportir.formInvalidMsg': '名称和证件号码为必填且须正确。',
  'eksportir.savedTitle': '已保存',
  'eksportir.createdMsg': '出口商已添加。',
  'eksportir.updatedMsg': '出口商已更新。',
  'eksportir.existsMsg': '该证件已在您的名单中。请编辑现有记录，而不是新增。',
  'eksportir.saveFailedTitle': '保存失败',
  'eksportir.saveFailedMsg': '出口商尚未保存，请重试。',
  'eksportir.deleteTitle': '删除出口商',
  'eksportir.deleteConfirm': '从名单中删除 {nama}？此后新单证中不再出现。',
  'eksportir.deletedTitle': '已删除',
  'eksportir.deletedMsg': '出口商已从名单中删除。',
  'eksportir.deleteFailedMsg': '出口商尚未删除，请重试。',
  'eksportir.downloadFailedTitle': '下载失败',
  'eksportir.downloadFailedMsg': '文件暂时无法下载，请稍后再试。',
  'eksportir.jenis.2': '护照',
  'eksportir.jenis.3': '身份证 (KTP)',
  'eksportir.jenis.4': '其他',
  'eksportir.jenis.5': 'NPWP 15 位',
  'eksportir.jenis.6': 'NPWP 16 位',
  'eksportir.jenis.npwp': 'NPWP',
  'eksportir.status.1': '合作社',
  'eksportir.status.2': 'PMDN（油气）',
  'eksportir.status.3': 'PMDN（非油气）',
  'eksportir.status.4': 'PMA（油气）',
  'eksportir.status.5': 'PMA（非油气）',
  'eksportir.status.6': '国有企业 (BUMN)',
  'eksportir.status.7': '地方国企 (BUMD)',
  'eksportir.status.8': '私营企业',
  'eksportir.status.9': '合资企业',
  'eksportir.status.10': '其他',
  'eksportirImport.dropTitle': '将 Excel 文件拖到此处',
  'eksportirImport.dropHint': '一个 .xlsx 文件，最多 5,000 行',
  'eksportirImport.chooseFile': '选择文件',
  'eksportirImport.onlyXlsx': '请使用模板生成的单个 Excel（.xlsx）文件。',
  'eksportirImport.reading': '正在读取 {file}',
  'eksportirImport.previewFailed': '文件无法读取',
  'eksportirImport.previewStale': '出口商数据已变更，预览可能已不准确',
  'eksportirImport.reloadPreview': '重新加载预览',
  'eksportirImport.chooseOther': '选择其他文件',
  'eksportirImport.rowsSeen': '{n} 行',
  'eksportirImport.rowLabel': '第 {n} 行',
  'eksportirImport.actionNew': '新增',
  'eksportirImport.actionUpdated': '更新',
  'eksportirImport.actionUnchanged': '未变更',
  'eksportirImport.actionRejected': '跳过',
  'eksportirImport.neverDeletes': '上传不会删除数据。文件中没有的行保持不变；空单元格不会覆盖已有的值。',
  'eksportirImport.importN': '导入 {n} 行',
  'eksportirImport.importedTitle': '导入完成',
  'eksportirImport.importedMsg': '新增 {new}，更新 {updated}。',
  'eksportirImport.resultLine': '新增 {new}，更新 {updated}，未变更 {unchanged}。',
  'eksportirImport.rejectedTitle': '被跳过的行',
  'eksportirImport.failedTitle': '导入失败',
  'eksportirImport.failedMsg': '数据尚未保存，请重试。',
  'eksportirImport.uploadAnother': '上传其他文件',
  'eksportirCard.dataEksportir': '出口商数据',
  'eksportirCard.dibukaDiTabBaru': '在新标签页打开：Master › 出口商数据',
  'eksportirCard.belumAda': '尚未在出口商数据中。单证成功提交至 CEISA 后将自动保存。',
  'eksportirCard.buka': '打开出口商数据',
  'eksportirCard.simpan': '保存到出口商数据',
  'eksportirCard.simpanHint': '保存此出口商，以便在后续单证中自动填写。',
  'eksportirCard.tersimpan': '已保存到出口商数据',
  'eksportirCard.tersimpanMsg': '从现在起，此出口商将根据其证件号码自动填写。',
  'eksportirCard.sudahAda': '该证件已在出口商数据中。',
  'eksportirCard.gagalSimpan': '保存到出口商数据失败。',
  'eksportirCard.diterapkanTitle': '已应用',
  'eksportirCard.diterapkanMsg': '已将出口商数据应用到出口商。',
  'statement.updatedBy': '由 {email} 于 {date} 更新',
  'statement.utama': '默认',
  'statement.tabOwn': '我的 PPJK',
  'statement.tabGlobal': '全部 PPJK',
  'statement.staleSessionTitle': '您账户的 PPJK 已变更',
  'statement.staleSessionMsg':
    '此浏览器仍保存着旧的 PPJK（{stored}）。您的账户现已关联到 {current}，此处显示的和草稿使用的都是它。请退出并重新登录，以便应用的其他部分同步更新。',
  'statement.jadikanUtama': '设为默认',
  'statement.jadikanUtamaBerhasil': '{name} 现为新草稿的默认声明。',
  'statement.jadikanUtamaGagal': '设为默认失败',
  'statement.nonaktifkanUtamaJudul': '停用默认声明？',
  'statement.nonaktifkanUtamaPesan': '最早创建的其他有效声明将自动成为新草稿的默认声明。',
  'statement.nonaktifkanUtamaTanpaPengganti': '没有其他有效声明。新草稿将不会自动填写声明。',
  'statement.nonaktifkan': '停用',
  'statement.batal': '取消',
  'statement.konflikJudul': '声明刚被您的同事更新',
  'statement.konflikDiperbaruiOleh': '由 {email} 于 {date} 更新',
  'statement.konflikDiperbaruiPada': '更新于 {date}',
  'statement.kolomTempat': '地点',
  'statement.kolomNama': '姓名',
  'statement.kolomJabatan': '职务',
  'statement.konflikMuatUlang': '重新加载',
  'statement.konflikTimpa': '覆盖',
  'statement.konflikGagalMemuat': '暂时无法加载最新数据。',
  'statement.konflikMuatUlangDaftar': '重新加载列表',
  'pernyataanform.pilihPernyataan': '选择声明',
  'pernyataanform.pilihPernyataanPlaceholder': '从 主数据 › 声明 中选择',
  'pernyataanform.diubahManual': '当前值已手动修改',
  'settings.sectionTampilan': '外观',
  'settings.theme': '主题',
  'settings.themeDesc': '应用的配色，仅对您的账号生效。',
  'settings.language': '语言',
  'settings.languageDesc': '菜单和界面文字的语言。',
  'settings.textSize': '文字大小',
  'settings.textSizeDesc': '放大整个应用的文字和按钮。',
  'settings.textSizeNormal': '标准',
  'settings.textSizeLarge': '大',
  'settings.textSizeLarger': '更大',
  'settings.textSizePreview': '示例：Nomor Aju 000020-001234-20260915-000041，进口商 PT. CEMANI TOKA，状态 SPPB。',
  'settings.textSizeNote': '更改立即生效。在最大尺寸下，部分紧凑的表格会显得更密。',

  // ---- 草稿变更历史（编辑页的 “Audit Logs” 抽屉）----
  'docpabean.audit.title': '变更历史',
  'docpabean.audit.refresh': '重新加载',
  'docpabean.audit.count': '{n} 项变更',
  'docpabean.audit.loadMore': '加载更多（剩余 {n}）',
  'docpabean.audit.unavailable': '此草稿暂无可用历史。',
  'docpabean.audit.subtitle.batch': '批次 {uuid}',
  'docpabean.audit.subtitle.none': '草稿尚未保存',
  'docpabean.audit.systemActor': '系统',
  'docpabean.audit.rowCount': '{n} 行',
  'docpabean.audit.empty': '（空）',
  'docpabean.audit.yes': '是',
  'docpabean.audit.no': '否',
  'docpabean.audit.addedEntity': '新增：{entity}',
  'docpabean.audit.removedEntity': '删除：{entity}',
  'docpabean.audit.showMoreFields': '再显示 {n} 项',
  'docpabean.audit.hideMoreFields': '收起',
  'docpabean.audit.showMoreValue': '更多',
  'docpabean.audit.showLessValue': '收起',
  'docpabean.audit.filter.tab.all': '全部',
  'docpabean.audit.filteredEmpty': '此标签页没有变更。',
  'docpabean.audit.empty.title': '暂无历史',
  'docpabean.audit.empty.body': '此草稿的变更将显示在这里。',
  'docpabean.audit.error.title': '无法加载历史',
  'docpabean.audit.error.body': '无法加载历史，请稍后再试。',
  'docpabean.audit.error.retry': '重试',
  'docpabean.audit.notFound.title': '未找到历史',
  'docpabean.audit.notFound.body': '此草稿不适用于您的账户。',
  'docpabean.audit.forbidden.title': '账户未关联 PPJK',
  'docpabean.audit.forbidden.body': '您的账户未关联 PPJK，因此无法显示草稿历史。',
  'docpabean.audit.day.today': '今天',
  'docpabean.audit.day.yesterday': '昨天',
  'docpabean.audit.day.unknown': '日期未知',
  'docpabean.audit.time.justNow': '刚刚',
  'docpabean.audit.time.minutesAgo': '{n} 分钟前',
  'docpabean.audit.time.hoursAgo': '{n} 小时前',
  'docpabean.audit.time.daysAgo': '{n} 天前',
  'docpabean.audit.time.monthsAgo': '{n} 个月前',
  'docpabean.audit.time.yearsAgo': '{n} 年前',
  'docpabean.audit.time.unknown': '时间未知',
  // AI 提取仅显示三个里程碑：不含数量、字段名和值。
  'docpabean.audit.milestone.extractionStarted': '{name} 启动了 AI 提取',
  'docpabean.audit.milestone.extractionStartedAnon': 'AI 提取已启动',
  'docpabean.audit.milestone.extractionCompleted': 'AI 提取完成',
  'docpabean.audit.milestone.extractionFailed': 'AI 提取失败',
  'docpabean.audit.milestone.submitDraft': '{name} 提交了草稿',
  'docpabean.audit.milestone.submitFinal': '{name} 提交了最终文件',
  'docpabean.audit.milestone.draftDeleted': '{name} 删除了草稿',
  'docpabean.audit.milestone.documentFileUploaded': '{name} 上传了文件 {file}',
  'docpabean.audit.milestone.documentFileUploadedAnon': '已上传文件 {file}',
  'docpabean.audit.milestone.smartSync': '{name} 运行了智能同步',
  'docpabean.audit.import.full': 'Excel · 全部',
  'docpabean.audit.import.barangOnly': 'Excel · 仅货物',
  'docpabean.audit.import.allTabs': '全部标签页',
  'docpabean.audit.import.otherTab': '无标签页',
  'docpabean.audit.import.added': '新增 {n}',
  'docpabean.audit.import.changed': '修改 {n}',
  'docpabean.audit.import.removed': '删除 {n}',
  'docpabean.audit.import.fields': '{n} 个字段',
  'docpabean.audit.import.noChanges': '没有变更',
  'docpabean.audit.import.goodsReplaced': '货物清单已按文件内容替换',
  'docpabean.audit.import.showPerTab': '查看各标签页的变更',
  'docpabean.audit.import.hidePerTab': '收起各标签页的变更',
  'docpabean.audit.import.truncated': '仅显示前 300 行',
  'docpabean.audit.action.UPDATE': '已修改',
  'docpabean.audit.action.CREATE': '已新增',
  'docpabean.audit.action.DELETE': '已删除',
  'docpabean.audit.action.HISTORICAL_SYNC': '从历史复制',
  'docpabean.audit.action.AI_APPLIED': '由 AI 填写',
  'docpabean.audit.action.EXTRACTION_REQUESTED': 'AI 提取已启动',
  'docpabean.audit.action.EXTRACTION_COMPLETED': 'AI 提取完成',
  'docpabean.audit.action.EXTRACTION_FAILED': 'AI 提取失败',
  'docpabean.audit.action.SUBMIT_DRAFT': '已提交草稿',
  'docpabean.audit.action.SUBMIT_FINAL': '已提交最终文件',
  'docpabean.audit.action.DRAFT_DELETED': '草稿已删除',
  'docpabean.audit.action.BULK_SUMMARY': '批量变更',
  'docpabean.audit.action.EXCEL_IMPORT': '上传 Excel',
  'docpabean.audit.action.SMART_SYNC': '智能同步',
  'docpabean.audit.entity.header': '表头',
  'docpabean.audit.entity.entity': '主体',
  'docpabean.audit.entity.document': '单证',
  'docpabean.audit.entity.carrier': '承运人',
  'docpabean.audit.entity.peti_kemas': '集装箱',
  'docpabean.audit.entity.kemasan': '包装',
  'docpabean.audit.entity.transaksi': '交易',
  'docpabean.audit.entity.barang': '货物',
  'docpabean.audit.entity.statement': '声明',
  'docpabean.audit.entity.process': '流程',
  'docpabean.audit.entity.barang_vd': '交易类型',
  'docpabean.audit.field.barang_vd.kodeJenisVd': '交易类型',
  'docpabean.audit.field.barang_vd.nilaiBarangVd': '自愿申报金额',
  // 海关术语，非界面文案：CEISA 表单印的就是这几个词，故各语言保持一致。
  'docpabean.audit.value.kondisiBarang1': 'Barang Baru',
  'docpabean.audit.value.kondisiBarang2': 'Bukan Barang Baru',
  'docpabean.audit.value.jenisApi01': 'API U',
  'docpabean.audit.value.jenisApi02': 'API P',
  'docpabean.audit.tab.header': '表头',
  'docpabean.audit.tab.entitas': '主体',
  'docpabean.audit.tab.dokumen': '单证',
  'docpabean.audit.tab.pengangkut': '承运人',
  'docpabean.audit.tab.kemasan': '包装与集装箱',
  'docpabean.audit.tab.transaksi': '交易',
  'docpabean.audit.tab.barang': '货物',
  'docpabean.audit.tab.pungutan': '税费',
  'docpabean.audit.tab.pernyataan': '声明',

  // "Hasil Ekstraksi" drawer on the PIB draft editor (src/features/draft-extraction)
  'docpabean.extraction.button': '提取结果',
  'docpabean.extraction.title': '提取结果',
  'docpabean.extraction.extractedAt': '提取于 {date}',
  'docpabean.extraction.download': '下载 Excel',
  'docpabean.extraction.downloading': '正在准备 Excel…',
  'docpabean.extraction.note.snapshot': 'AI 值是提取时的值。当前值跟随表单，包括尚未保存的更改。',
  'docpabean.extraction.note.source': '来源是映射到此字段并发送给 AI 的文档，而不是文档中的确切引文。',
  'docpabean.extraction.filter.changedOnly': '仅显示已更改',
  'docpabean.extraction.filter.status.placeholder': '所有状态',
  'docpabean.extraction.column.seri': '序号',
  'docpabean.extraction.column.field': '字段',
  'docpabean.extraction.column.ai': 'AI 值',
  'docpabean.extraction.column.current': '当前值',
  'docpabean.extraction.column.status': '状态',
  'docpabean.extraction.column.source': '来源（映射）',
  'docpabean.extraction.column.changed': '已更改',
  'docpabean.extraction.changed': '已更改',
  'docpabean.extraction.status.ok': '来自文档',
  'docpabean.extraction.status.master-ok': '来自主数据',
  'docpabean.extraction.status.default': '默认值',
  'docpabean.extraction.status.calc': '由 CEISA 计算',
  'docpabean.extraction.status.user': '由用户填写',
  'docpabean.extraction.status.master': '需要主数据',
  'docpabean.extraction.status.shape': '不在选项内',
  'docpabean.extraction.source.open': '在 PDF 查看器中打开',
  'docpabean.extraction.source.unavailable': '文档不可用',
  'docpabean.extraction.source.notUploadedTypes': '映射的文档未上传：{types}',
  'docpabean.extraction.source.notUploadedHint':
    '此字段映射到本流程未上传的文档部分。其值来自其他来源（主数据、默认值或用户填写）。',
  'docpabean.extraction.source.emptySection': '映射的部分在 {files} 中为空',
  'docpabean.extraction.source.emptySectionHint': '文档已上传，但未在其中读取到此字段映射的部分。其值来自其他来源。',
  'docpabean.extraction.source.unmapped': '未映射到文档部分',
  'docpabean.extraction.source.unmappedHint':
    '语义映射未将此字段指向任何文档部分，因此没有可打开的文件。状态仍显示其值的来源。',
  'docpabean.extraction.search.placeholder': '搜索字段、值、文档…（如 npwp、invoice、已修改）',
  'docpabean.extraction.search.clear': '清除搜索',
  'docpabean.extraction.search.results': '所有标签中共 {n} 个结果',
  'docpabean.extraction.search.empty': '没有与“{q}”匹配的内容。请尝试其他词、字段名或值。',
  'docpabean.extraction.goTo': '在表单中打开此字段',
  'docpabean.extraction.goToTab': '在表单中打开此标签',
  'docpabean.extraction.page.range': '{from}–{to}，共 {total}',
  'docpabean.extraction.row.seri': '序号 {n}',
  'docpabean.extraction.attach.title': '货物附件',
  'docpabean.extraction.attach.count': '{n} 份文档',
  'docpabean.extraction.attach.callout': '此草稿中有 {n} 份文档可附加到货物。查看每份文档附加了哪些货物。',
  'docpabean.extraction.attach.open': '查看附件',
  'docpabean.extraction.attach.hide': '收起',
  'docpabean.extraction.attach.description':
    'e-COO、SNI、检验报告和许可证等文档可以附加到货物。这里列出文档中的每项货物，以及它附加到草稿中的哪项货物、为何判定匹配。发票、装箱单、提单和提货单不会附加到货物，因此不在此列出。',
  'docpabean.extraction.attach.empty': '此草稿没有可附加到货物的文档。',
  'docpabean.extraction.attach.filter': '按序号、代码或货物名称搜索',
  'docpabean.extraction.attach.unmatchedOnly': '仅显示未附加',
  'docpabean.extraction.attach.missedOnly': '仅显示需核对',
  'docpabean.extraction.attach.notExact': '注意：以下匹配结果可能与 AI 处理此草稿时保存的结果略有不同。',
  'docpabean.extraction.attach.noMatch': '没有文档或货物符合此搜索。',
  'docpabean.extraction.attach.noRecord': 'AI 尚未提供此文档的附件数据。',
  'docpabean.extraction.attach.noLines': '此文档未列出货物。',
  'docpabean.extraction.attach.noLineMatch': '没有货物符合此搜索。',
  'docpabean.extraction.attach.notInForm': '此文档已不在“文档”标签中。',
  'docpabean.extraction.attach.dokumenNo': '文档 #{n}',
  'docpabean.extraction.attach.terlampir': '已附加',
  'docpabean.extraction.attach.summary': '{lines} 行中已附加 {rows} 项货物',
  'docpabean.extraction.attach.unmatchedCount': '{n} 行未附加',
  'docpabean.extraction.attach.missedCount': '{n} 项需核对',
  'docpabean.extraction.attach.pending': '未附加',
  'docpabean.extraction.attach.col.line': '序',
  'docpabean.extraction.attach.col.code': '文档中的代码',
  'docpabean.extraction.attach.col.naming': '文档中的货物名称',
  'docpabean.extraction.attach.col.qty': '数量',
  'docpabean.extraction.attach.col.seri': '序号',
  'docpabean.extraction.attach.col.barang': '草稿中的货物',
  'docpabean.extraction.attach.col.settledBy': '匹配依据',
  'docpabean.extraction.attach.col.evidence': '相同之处',
  'docpabean.extraction.attach.decision.code': '货物代码相同',
  'docpabean.extraction.attach.decision.ocr_misread': '代码几乎相同',
  'docpabean.extraction.attach.decision.amount': '数量相同',
  'docpabean.extraction.attach.decision.naming': '名称相似',
  'docpabean.extraction.attach.decision.line_number': '行号相同',
  'docpabean.extraction.attach.decision.sum': '数量合计相符',
  'docpabean.extraction.attach.decision.article': '所有带此代码的货物',
  'docpabean.extraction.attach.decision.kind': '货物种类相符',
  'docpabean.extraction.attach.decision.shipment': '适用于整批货物',
  'docpabean.extraction.attach.decision.unknown': '未知',
  'docpabean.extraction.attach.evidence.code': '代码相同',
  'docpabean.extraction.attach.evidence.ocrMisread': '代码几乎相同',
  'docpabean.extraction.attach.evidence.contradicts': '代码不同',
  'docpabean.extraction.attach.evidence.amounts': '{fields}相同',
  'docpabean.extraction.attach.evidence.naming': '名称相似 {n}%',
  'docpabean.extraction.attach.evidence.lineNumber': '行号相同',
  'docpabean.extraction.attach.field.jumlahSatuan': '单位数量',
  'docpabean.extraction.attach.field.jumlahKemasan': '包装数量',
  'docpabean.extraction.attach.field.netto': '净重',
  'docpabean.extraction.attach.field.bruto': '毛重',
  'docpabean.extraction.attach.field.nilaiBarang': '货物价值',
  'docpabean.extraction.attach.verdict.notShipped': '不在本批货物中',
  'docpabean.extraction.attach.verdict.lookalikesTaken': '相似货物已附加',
  'docpabean.extraction.attach.verdict.likelyMissed': '需核对',
  'docpabean.extraction.attach.verdict.noCode': '无货物代码',
  'docpabean.extraction.attach.verdict.notShippedDetail': '草稿中没有代码相近的货物，因此未附加是正常的。',
  'docpabean.extraction.attach.verdict.noCodeDetail': '此行没有货物代码，无法自动匹配。',
  'docpabean.extraction.attach.verdict.candidate': '序号 {n}（{code}）可能匹配：{reason}',
  'docpabean.extraction.attach.verdict.taken': '序号 {n}（{code}）已通过第 {line} 行附加',
  'docpabean.extraction.attach.reason.sameCode': '代码相同',
  'docpabean.extraction.attach.reason.leadingZero': '仅前面的 0 不同',
  'docpabean.extraction.attach.reason.ocrMisread': '一个字符误读',
  'docpabean.extraction.attach.reason.insideLonger': '代码是更长代码的一部分',
  'docpabean.extraction.attach.reason.cutOff': '代码在文档中被截断',
  'docpabean.extraction.file.open': '查看 {name}',
  'docpabean.extraction.panel.fullScreen': '全屏',
  'docpabean.extraction.panel.dock': '与表单并排显示',
  'docpabean.extraction.panel.resize': '拖动以调整面板宽度（双击：全屏）',
  'docpabean.extraction.panel.releaseFull': '松开以全屏显示',
  'docpabean.extraction.role.primary': '主要',
  'docpabean.extraction.role.fallback': '备用',
  'docpabean.extraction.current.seeTable': '查看表格',
  'docpabean.extraction.current.ceisa': '由 CEISA 计算',
  'docpabean.extraction.current.notInForm': '不在此表单中',
  'docpabean.extraction.rows': '{n} 行',
  'docpabean.extraction.row.status': '行状态',
  'docpabean.extraction.row.changed': '已更改',
  'docpabean.extraction.row.added': '用户添加',
  'docpabean.extraction.row.removed': '已删除',
  'docpabean.extraction.table.aiOnly': '仅 AI 值——税费由 CEISA 计算',
  'docpabean.extraction.empty.tab': '此标签页没有来自 AI 的字段。',
  'docpabean.extraction.empty.filtered': '此标签页没有符合筛选条件的内容。',
  'docpabean.extraction.notAvailable': '此草稿没有可用的提取详情。',
  'docpabean.extraction.error.title': '无法加载提取结果',
  'docpabean.extraction.error.retry': '重试',
  'docpabean.extraction.excel.error': '无法创建 Excel 文件，请重试。',
  'docpabean.extraction.excel.summary': '摘要',
  'docpabean.extraction.excel.ajuNo': '申报号 (AJU)',
  'docpabean.extraction.excel.processId': '流程 ID',
  'docpabean.extraction.excel.extractedAt': '提取时间',
  'docpabean.extraction.excel.downloadedAt': '下载时间',
  'docpabean.extraction.excel.downloadedBy': '下载者',
  'docpabean.extraction.excel.tab': '标签页',
  'docpabean.extraction.excel.changedFields': '已更改字段',
  'docpabean.extraction.excel.changedRows': '已更改行',
  'docpabean.extraction.excel.notes': '说明',
  'docpabean.extraction.excel.ai': 'AI',
  'docpabean.extraction.excel.current': '当前',
  'docpabean.extraction.excel.yes': '是',
  'docpabean.extraction.excel.no': '否',
  'docpabean.extraction.excel.col.section': '部分',
  'docpabean.extraction.excel.col.field': '字段',
  'docpabean.extraction.excel.col.required': '必填',
  'docpabean.extraction.excel.col.ai': 'AI 值',
  'docpabean.extraction.excel.col.current': '当前值',
  'docpabean.extraction.excel.col.changed': '已更改（是/否）',
  'docpabean.extraction.excel.col.status': '状态',
  'docpabean.extraction.excel.col.sourceFile': '来源文档（文件）',
  'docpabean.extraction.excel.col.documentType': '文档类型',
  'docpabean.extraction.excel.col.sectionId': '文档部分（sectionId）',
  'docpabean.extraction.excel.col.role': '角色（主要/备用）',

  // Konsistensi Dokumen — Document Consistency Matrix (src/features/draft-consistency)
  'docpabean.consistency.button': '单据一致性',
  'docpabean.consistency.title': '单据一致性',
  'docpabean.consistency.badge': '单据间问题：{critical} 个严重，{high} 个高，{medium} 个中',
  'docpabean.consistency.builtAt': '生成于 {date}',
  'docpabean.consistency.download': '下载 Excel',
  'docpabean.consistency.downloading': '正在准备 Excel…',
  'docpabean.consistency.excel.error': 'Excel 生成失败，请重试。',
  'docpabean.consistency.notAvailable': '此草稿没有一致性矩阵。',
  'docpabean.consistency.error.title': '无法加载一致性矩阵。',
  'docpabean.consistency.error.retry': '重试',
  'docpabean.consistency.footnote': '`-` 表示无法从该单据读取该值，或单据未列出该值。此结果仅供参考，不会阻止提交。',
  'docpabean.consistency.document': '单据',
  'docpabean.consistency.openDocument': '在表格旁查看 PDF',
  'docpabean.consistency.goToField': '在表单中查看',
  'docpabean.consistency.columns.move': '拖动可左右移动此列',
  'docpabean.consistency.columns.moveLeft': '左移',
  'docpabean.consistency.columns.moveRight': '右移',
  'docpabean.consistency.columns.resetOrder': '恢复原顺序',
  'docpabean.consistency.columns.orderNote': '拖动列标题上的 ⋮⋮ 图标或使用箭头可调整顺序。',
  'docpabean.consistency.columns.resetSizes': '重置尺寸',
  'docpabean.consistency.columns.sizesNote': '拖动列或行的边缘可调整大小。',
  'docpabean.consistency.resize.column': '调整列宽：拖动，或使用左右方向键。双击恢复默认大小。',
  'docpabean.consistency.resize.row': '调整行高：拖动，或使用上下方向键。双击恢复默认大小。',
  'docpabean.consistency.sheet.toFill': '🔴 需要填写',
  'docpabean.consistency.sheet.toFillShort': '需要填写',
  'docpabean.consistency.sheet.toggle': '点击展开或收起此部分',
  'docpabean.consistency.sheet.expandAll': '全部展开',
  'docpabean.consistency.sheet.collapseAll': '全部收起',
  'docpabean.consistency.sheet.count.fields': '{n} 个字段',
  'docpabean.consistency.sheet.count.ok': '{n} 个一致',
  'docpabean.consistency.sheet.count.problem': '{n} 个有问题',
  'docpabean.consistency.sheet.count.review': '{n} 个需核对',
  'docpabean.consistency.status.ok': '一致',
  'docpabean.consistency.status.review': '需核对',
  'docpabean.consistency.status.mismatch': '不一致',
  'docpabean.consistency.status.required': '必填',
  'docpabean.consistency.status.empty': '为空',
  'docpabean.consistency.status.notCompared': '未比对',
  'docpabean.consistency.status.detail.oneDocument': '与唯一的单据一致',
  'docpabean.consistency.sheet.sameAsAi': '与 AI 结果一致',
  'docpabean.consistency.sheet.differsFromAi': '与 AI 结果不同',
  'docpabean.consistency.sheet.filledManually': '手动填写，AI 未提取该值',
  'docpabean.consistency.sheet.empty': '请人工核对是否需要填写',
  'docpabean.consistency.sheet.requiredEmpty': '仍为空，需要填写',
  'docpabean.consistency.sheet.ceisa': '由 CEISA 计算',
  'docpabean.consistency.sheet.notInForm': '不在表单中',
  'docpabean.consistency.sheet.lineAdded': 'PIB 中有，AI 结果中没有',
  'docpabean.consistency.sheet.lineRemoved': 'AI 结果中有，PIB 中没有',
  'docpabean.consistency.sheet.barangLine': '货物',
  'docpabean.consistency.sheet.sourceCell': 'AI 来源',
  'docpabean.consistency.sheet.sourceHint': '此字段的 AI 结果取自该单据。点击查看 PDF。',
  'docpabean.consistency.sheet.partial':
    '完整的 PIB 字段列表需要“提取结果”功能，此草稿尚未开启。当前仅显示单据之间比对的字段。',
  'docpabean.consistency.excel.chooseTitle': 'Excel 中包含的单据',
  'docpabean.consistency.excel.chooseNote': '字段、当前 PIB、AI 提取值和结果始终包含在内。',
  'docpabean.consistency.excel.selectAll': '全选',
  'docpabean.consistency.excel.selectNone': '清空',
  'docpabean.consistency.excel.confirm': '下载',
  'docpabean.consistency.excel.documents': '本文件包含的单据',
  'docpabean.consistency.excel.col.status': '状态',
  'docpabean.consistency.excel.col.reason': '说明',
  'docpabean.consistency.excel.perTab': '各标签页结果',
  'docpabean.consistency.excel.statusCounts': '各状态数量',
  'docpabean.consistency.excel.howTo': '阅读说明',
  'docpabean.consistency.excel.sheets': '本文件的工作表',
  'docpabean.consistency.excel.nothingToCheck': '没有需要核对的字段。',
  'docpabean.consistency.excel.legend.ok': 'PIB 值与单据或 AI 结果一致。',
  'docpabean.consistency.excel.legend.review': 'PIB 值与 AI 结果不同，或单据之间存在细微差异。请再次核对。',
  'docpabean.consistency.excel.legend.mismatch': '单据之间或与 PIB 不一致。红色 = 严重，橙色 = 高。',
  'docpabean.consistency.excel.legend.required': 'PIB 必填字段仍为空，需要填写。',
  'docpabean.consistency.excel.legend.empty': '非必填字段仍为空。请核对是否需要填写。',
  'docpabean.consistency.excel.legend.notCompared': '无可比对内容：手动填写、由 CEISA 计算、不在表单中，或仅一份单据。',
  'docpabean.consistency.excel.legend.source': 'AI 提取该字段值所依据的单据。',
  'docpabean.consistency.excel.legend.sheets':
    '需核对：仅列出需要处理的字段。矩阵：所有 PIB 字段。问题：每个问题一行。',
  'docpabean.consistency.excel.col.tab': '标签页',
  'docpabean.consistency.excel.col.section': '分组',
  'docpabean.consistency.split.width': '拖动以调整表格与 PDF 的宽度。双击恢复默认大小。',
  'docpabean.consistency.split.height': '拖动以调整问题列表的高度。双击恢复默认大小。',
  'docpabean.consistency.pdf.show': '显示 PDF',
  'docpabean.consistency.pdf.shown': '正在旁边显示',
  'docpabean.consistency.pdf.previous': '上一个单据',
  'docpabean.consistency.pdf.next': '下一个单据',
  'docpabean.consistency.pdf.newTab': '在新标签页中打开',
  'docpabean.consistency.pdf.close': '关闭 PDF',
  'docpabean.consistency.pdf.notPdf': '此处仅可预览 PDF。请在新标签页中打开此文件。',
  'docpabean.consistency.columns.button': '列 ({shown}/{total})',
  'docpabean.consistency.columns.title': '显示列',
  'docpabean.consistency.columns.showAll': '全部显示',
  'docpabean.consistency.columns.note': '字段和结果始终显示。下载的 Excel 始终包含所有列。',
  'docpabean.consistency.legend.derived': '由货物行汇总',
  'docpabean.consistency.legend.reference': '灰色：仅供参考，不参与比较',
  'docpabean.consistency.fullScreen': '全屏',
  'docpabean.consistency.exitFullScreen': '退出全屏',
  'docpabean.consistency.goToFieldHint': '关闭矩阵并在 PIB 表单中显示此字段',
  'docpabean.consistency.openCellDocument': '在表格旁查看此单据的 PDF',
  'docpabean.consistency.unreadableBadge': '无法读取',
  'docpabean.consistency.column.field': '字段',
  'docpabean.consistency.column.ai': 'AI 取值',
  'docpabean.consistency.column.pib': '当前 PIB',
  'docpabean.consistency.column.result': '结果',
  'docpabean.consistency.column.severity': '严重程度',
  'docpabean.consistency.result.match': '与单据一致',
  'docpabean.consistency.result.single_source': '仅一份单据载明',
  'docpabean.consistency.result.no_data': '单据中无数据',
  'docpabean.consistency.severity.critical': '🔴 严重 — 请检查',
  'docpabean.consistency.severity.high': '🟠 高 — 复核',
  'docpabean.consistency.severity.medium': '🟡 中 — 复核',
  'docpabean.consistency.severity.short.critical': '严重',
  'docpabean.consistency.severity.short.high': '高',
  'docpabean.consistency.severity.short.medium': '中',
  'docpabean.consistency.aiDiffers': '≠ 单据',
  'docpabean.consistency.cell.derived': '由货物行汇总',
  'docpabean.consistency.cell.reference': '仅供参考，不参与比较',
  'docpabean.consistency.cell.supporting': '辅助：可佐证，不计为差异',
  'docpabean.consistency.note.inside_total_offset': '货物价格 = 发票总额减去发票内的运费、保险费和费用',
  'docpabean.consistency.note.offset_unknown': '未读取到发票总额；不比较',
  'docpabean.consistency.note.lcl': '拼箱 (LCL)：不申报集装箱',
  'docpabean.consistency.finding.none': '没有问题 — 所有单据的数值一致。',
  'docpabean.consistency.finding.requiredEmpty': '任何单据均未列出',
  'docpabean.consistency.finding.stale': '部分读取结果来自其他处理，已忽略',
  'docpabean.consistency.finding.pib': 'PIB',
  'docpabean.consistency.finding.documents': '单据',
  'docpabean.consistency.finding.live': '根据当前 PIB 值',
  'docpabean.consistency.unreadable.not_read': '单据无法读取',
  'docpabean.consistency.unreadable.unsupported_format': '不支持的文件格式',
  'docpabean.consistency.unreadable.not_extracted': '无法提取单据内容',
  'docpabean.consistency.unreadable.no_sections': '未找到单据部分',
  'docpabean.consistency.excel.col.code': '代码',
  'docpabean.consistency.excel.col.document': '单据',
  'docpabean.consistency.excel.col.detail': '说明',
  'docpabean.consistency.excel.summary.item': '项目',
  'docpabean.consistency.excel.summary.value': '值',
  'docpabean.consistency.excel.ajuNo': 'AJU 编号',
  'docpabean.consistency.excel.processId': 'Process ID',
  'docpabean.consistency.excel.builtAt': '生成时间',
  'docpabean.consistency.excel.downloadedAt': '下载时间',
  'docpabean.consistency.excel.downloadedBy': '下载人',
  'docpabean.consistency.excel.note': '备注',
  'docpabean.consistency.row.quantity': '数量',
  'docpabean.consistency.row.packages': '包装',
  'docpabean.consistency.row.gross_weight': '毛重',
  'docpabean.consistency.row.net_weight': '净重',
  'docpabean.consistency.row.seller': '卖方 / 出口商',
  'docpabean.consistency.row.importer': '进口商 / 收货人',
  'docpabean.consistency.row.transport_doc_no': '提单 / 空运单号',
  'docpabean.consistency.row.currency': '币种',
  'docpabean.consistency.row.total_value': '总价值',
  'docpabean.consistency.row.incoterm': '贸易术语',
  'docpabean.consistency.row.containers': '集装箱',
  'docpabean.consistency.row.description': '货物描述',
  'docpabean.consistency.code.QUANTITY_MISMATCH': '数量不一致',
  'docpabean.consistency.code.PACKAGE_MISMATCH': '包装不一致',
  'docpabean.consistency.code.WEIGHT_MISMATCH': '重量不一致',
  'docpabean.consistency.code.SELLER_MISMATCH': '卖方不一致',
  'docpabean.consistency.code.IMPORTER_MISMATCH': '进口商不一致',
  'docpabean.consistency.code.BL_NUMBER_MISMATCH': '提单号不一致',
  'docpabean.consistency.code.CURRENCY_MISMATCH': '币种不一致',
  'docpabean.consistency.code.TOTAL_VALUE_MISMATCH': '总价值不一致',
  'docpabean.consistency.code.INCOTERM_MISMATCH': '贸易术语不一致',
  'docpabean.consistency.code.CONTAINER_MISMATCH': '集装箱不一致',
  'docpabean.consistency.code.DESCRIPTION_MISMATCH': '货物描述不一致',
  'docpabean.consistency.code.UNREADABLE_DOCUMENT': '单据无法读取',
  'docpabean.consistency.code.GROSS_LT_NET': '毛重 < 净重',
  'docpabean.consistency.code.REQUIRED_EMPTY': '必填数据为空',
  'docpabean.consistency.code.STALE_READING': '读取结果已忽略',
  'docpabean.consistency.code.PIB_DIFFERS': 'PIB 与单据不一致',
  'docpabean.consistency.code.DUPLICATE_DOCUMENT': '重复单据',
  'docpabean.consistency.code.DESCRIPTION_SLIGHTLY_DIFFERENT': '货物描述略有不同',
  'docpabean.consistency.code.FORMAT_DIFFERS': '格式不同',
  'docpabean.consistency.code.DATE_UNUSUAL': '日期异常',
  'docpabean.consistency.code.HISTORICAL_VALUE_UNUSUAL': '历史价值异常',

  // CCN (CUBEforall) workspace — /ccn/*
  'ccn.product': '进口舱单 (AWB)',
  'ccn.logout': '退出',
  'ccn.language': '语言',
  'ccn.inbox.title': '来自 CUBEforall 的进口舱单',
  'ccn.inbox.subtitle': '从 CUBEforall 发送到 JARVIS 的 AWB。打开以准备草稿,然后发回 CCN。',
  'ccn.inbox.subtitleCompany': '为 {company} 发送的 AWB。打开以准备草稿,然后发回 CCN。',
  'ccn.inbox.search': '搜索 AWB / HAWB / 邮箱',
  'ccn.inbox.refresh': '刷新列表',
  'ccn.inbox.loadError': '无法加载 CCN 文件列表。',
  'ccn.inbox.retry': '重试',
  'ccn.inbox.emptyTitle': '尚未有 AWB 发送到 JARVIS。',
  'ccn.inbox.emptyBody': '在 CUBEforall 中选择一个 AWB 并点击 Send to JARVIS。几秒钟后它会显示在这里。',
  'ccn.inbox.col.awb': 'AWB',
  'ccn.inbox.col.hawb': 'HAWB',
  'ccn.inbox.col.route': '航线',
  'ccn.inbox.col.sentBy': '发送人',
  'ccn.inbox.col.received': '接收时间',
  'ccn.inbox.col.status': '状态',
  'ccn.inbox.staleBadge': '新版本',
  'ccn.inbox.staleHint': '草稿创建后 CCN 发送了新版本',
  'ccn.inbox.resync': '从 CCN 重新加载',
  'ccn.inbox.resyncOk': 'AWB {awb} 已从 CCN 重新加载。',
  'ccn.inbox.resyncFail': '无法从 CCN 重新加载',
  'ccn.inbox.open': '打开',
  'ccn.inbox.view': '查看',
  'ccn.status.RECEIVED': '已接收',
  'ccn.status.FETCHING': '正在获取数据',
  'ccn.status.DRAFTED': '草稿就绪',
  'ccn.status.FETCH_FAILED': '获取失败',
  'ccn.status.MAP_FAILED': '映射失败',
  'ccn.status.SUBMITTING': '正在发送到 CCN',
  'ccn.status.SUBMITTED': '已发送到 CCN',
  'ccn.status.SUBMIT_FAILED': '发送失败',
  'ccn.open.preparing': '正在从 CUBEforall 获取 AWB 并准备草稿…',
  'ccn.open.failed': '无法打开 CCN 文件',
  'ccn.open.toInbox': '返回 AWB 列表',
  'ccn.callback.checking': '正在检查 CUBEforall 会话…',
  'ccn.callback.redirecting': '正在跳转到 CUBEforall 登录…',
  'ccn.callback.exchanging': '正在准备 JARVIS 会话…',
  'ccn.callback.prompt': '使用您的 CUBEforall 账户登录,以在 JARVIS 中打开进口舱单。',
  'ccn.callback.exchangeFailed': 'CUBEforall 会话交换失败',
  'ccn.sso.inactive': '访问被拒绝:您的 CUBEforall 订阅尚未对 JARVIS 生效。请联系 CCN 激活。',
  'ccn.sso.inactiveRedirect': '贵公司尚未在 CUBEforall 上订阅 JARVIS。即将跳转到 CUBEforall 上的 JARVIS 页面进行订阅。',
  'ccn.sso.openProductPage': '打开 CUBEforall 上的 JARVIS 页面',
  'ccn.submit.title': '将舱单发送到 CUBEforall',
  'ccn.submit.body': '此进口舱单(按各选项卡中保存的内容)将在 CUBEforall 中创建为文件。不会发送到 CEISA。',
  'ccn.submit.staleTitle': 'CCN 发送了新版本',
  'ccn.submit.staleBody': 'CCN 的最新版本尚未加载到此草稿。按当前数据发送吗?',
  'ccn.submit.staleAck': '是,按原样发送此草稿',
  'ccn.submit.cancel': '取消',
  'ccn.submit.send': '发送到 CUBEforall',
  'ccn.submit.sending': '正在 CUBEforall 中创建文件…',
  'ccn.incomplete.body': '申报暂时无法发送到 CCN。请先填写以下 {count} 个必填项。',
  // ---- 舱单编辑器：数据完整性 ----
  'manifestEditor.completeness.title': '数据不完整（{count}）',
  'manifestEditor.completeness.body': '舱单暂时无法推送到 CEISA。请先填写以下 {count} 个必填项。',
  'manifestEditor.completeness.goToTab': '前往标签 →',
  'manifestEditor.completeness.close': '关闭',
  'manifestEditor.noAccess': '当前账户无法打开此舱单。',
  'manifestEditor.completeness.rowBadge': '未完成（{count}）',
  'manifestEditor.completeness.tabTooltip': '{count} 项数据不完整',
  'manifestEditor.completeness.tabComplete': '数据完整',
  'manifestEditor.completeness.panelTitle': '此标签有 {count} 项数据不完整',
  'manifestEditor.completeness.panelHint': '提交草稿前请先完成。点击任一条目可直接跳转到对应字段。',
  'manifestEditor.completeness.panelJump': '查看 →',
  'manifestEditor.completeness.itemJump': '查看',
  'manifestEditor.completeness.startFixing': '开始修复',
  'manifestEditor.completeness.panelShowAll': '显示全部（{count}）',
  'manifestEditor.completeness.panelShowLess': '收起',
  'manifestEditor.completeness.panelHide': '隐藏',
  'manifestEditor.completeness.panelShow': '显示',
  'manifestEditor.completeness.statusColumn': '状态',

  // ---- PIB draft editor: "Data Belum Lengkap" submit gate ----
  'pibEditor.completeness.title': '数据不完整（{count}）',
  'pibEditor.completeness.body': 'PIB 暂时无法推送到 CEISA。请先填写以下 {count} 个必填项。',
  'pibEditor.completeness.goToTab': '前往标签 →',
  'pibEditor.completeness.itemJump': '查看',
  'pibEditor.completeness.close': '关闭',
  'pibEditor.completeness.startFixing': '开始修复',

  // ---- PEB draft editor: "Data Belum Lengkap" submit gate ----
  'pebEditor.completeness.title': '数据不完整（{count}）',
  'pebEditor.completeness.body': 'PEB 暂时无法推送到 CEISA。请先填写以下 {count} 个必填项。',
  'pebEditor.completeness.goToTab': '前往标签 →',
  'pebEditor.completeness.itemJump': '查看',
  'pebEditor.completeness.close': '关闭',
  'pebEditor.completeness.startFixing': '开始修复',
  'pebEditor.ownerDiffers.inlineWarning': '货物所有人数据与出口商数据不一致。此情况是允许的，但请确认数据无误。',
  'pebEditor.ownerDiffers.viewOwners': '查看货物所有人',
  'pebEditor.ownerDiffers.rowChip': '与出口商不同',
  'pebEditor.ownerDiffers.modalTitle': '出口商与货物所有人不一致',
  'pebEditor.ownerDiffers.modalBody':
    '此 PEB 的货物所有人数据与出口商数据不一致。此情况是允许的，但在发送至 CEISA 之前，请确认数据无误。',
  'pebEditor.ownerDiffers.eksportirLabel': '出口商',
  'pebEditor.ownerDiffers.ownerLabel': '货物所有人 {seri}',
  'pebEditor.ownerDiffers.name': '名称',
  'pebEditor.ownerDiffers.npwp': 'NPWP',
  'pebEditor.ownerDiffers.confirm': '是，数据无误',
  'pebEditor.ownerDiffers.review': '重新检查',
  'pebEditor.owners.saved': '货物所有人数据已保存。',
  'pebEditor.barangPemilik.auto': '自动',
  'pebEditor.barangPemilik.autoHint': '此货物尚未选择所有人，因此属于实体标签页中的所有货物所有人。',
  'pebEditor.barangPemilik.resetToAuto': '恢复为自动',
  'pebEditor.barangPemilik.ownerNotFound': '未找到所有人',
  'pebEditor.barangPemilik.jenisPemilik': '所有人',
  'pebEditor.barangPemilik.danglingLabel': '货物所有人',
  'pebEditor.barangPemilik.danglingIssue': '货物所有人（实体序号 {seri}）不在实体标签页中。请重新选择此货物的所有人。',
  'pebEditor.barangPemilik.emptyIssue': '此货物尚无所有人。请添加所有人或恢复为自动。',
  'pebEditor.barangPemilik.noOwner': '此货物尚无所有人。请从上方列表添加，或恢复为自动。',
  'pebEditor.barangPemilik.addNewHint': '实体标签页中尚无货物所有人。请在此填写新的所有人。',
  'pebEditor.barangPemilik.editOwner': '编辑所有人（适用于实体标签页及所有货物）',
  'pebEditor.barangPemilik.title': '货物所有人',
  'pebEditor.barangPemilik.singleOwnerHint': '一份 PEB 只能有 1 个货物所有人。',
  'pebEditor.barangPemilik.copyEksportirHint': '货物所有人数据将被出口商数据覆盖。',
  'pebEditor.barangPemilik.tooManyOwnersIssue': '只能有 1 个货物所有人。请删除其他所有人。',
  'pebEditor.barangPemilik.tooManyBarangIssue': '每项货物只能有 1 个所有人。请删除其他所有人。',
  'ccn.submit.doneTitle': '已发送到 CUBEforall',
  'ccn.submit.doneBody': '舱单已作为文件保存在贵公司的 CUBEforall 文件箱中。',
  'ccn.submit.doneId': '文件 ID:{id}',
  'ccn.submit.failedTitle': '尚未发送',
  'ccn.submit.rejected': 'CCN 拒绝了该文件',
  'ccn.submit.timeout': 'CCN 尚未回复。状态将在 AWB 列表中更新。',
  'ccn.submit.failed': '无法发送到 CCN',
  'ccn.submit.close': '关闭',
  'ccn.submit.retry': '重试',
  'ccn.submit.subtitle': '空运进口舱单(BC 1.1)',
  'ccn.submit.awb': 'AWB',
  'ccn.submit.hawb': '分运单',
  'ccn.submit.route': '航线',
  'ccn.submit.sender': '发送方',
  'ccn.submit.destination': '保存到',
  'ccn.submit.destinationValue': 'CUBEforall 上的 {company}',
  'ccn.submit.destinationFallback': '贵公司的 CUBEforall 文件箱',
  'ccn.submit.whatHappens': '将会发生',
  'ccn.submit.step1': 'JARVIS 将此舱单作为文件创建在贵公司的 CUBEforall 文件箱中。',
  'ccn.submit.step2': '之后再次发送会更新同一文件,而不是新建文件。',
  'ccn.submit.step3': '不会申报给海关(CEISA)。BC 1.1 申报仍是单独的步骤。',
  'ccn.submit.sendingHint': '通常只需几秒钟。',
  'ccn.submit.backToList': '返回 AWB 列表',
  'ccn.submit.copy': '复制',
  'ccn.submit.copied': '已复制',
  'ccn.submit.details': '技术详情',
  'ccn.editor.staleBadge': 'CCN 的新版本',
  'ccn.merge.conflictTitle': '{n} 个字段需要您决定',
  'ccn.merge.conflictBody': 'CCN 发送了新版本,其中的值与您的修改不同。在您选择之前,草稿保留您的值。',
  'ccn.merge.yours': '您的',
  'ccn.merge.keepMine': '保留我的',
  'ccn.merge.useCcn': '使用 CCN 的值',
  'ccn.merge.resolveFailed': '您的选择未保存,请重试',
  'ccn.merge.updatedTitle': '已根据 CCN 新版本更新 {n} 个字段',
  'ccn.merge.updatedBody': 'CCN 于 {date} 发送了新版本。您未修改的字段已随之更新。',
  'ccn.merge.showChanges': '查看更改',
  'ccn.merge.hideChanges': '隐藏更改',
  'ccn.merge.dismiss': '关闭',
  'ccn.merge.header': '表头',
  'ccn.merge.wholeHouse': '分运单行',
  'ccn.merge.housePresent': '包含在草稿中',
  'ccn.merge.houseAbsent': '已移除',
  'ccn.inbox.conflictBadge': '{n} 项待检查',
  'ccn.inbox.conflictHint': 'CCN 发送的新版本与您的修改不同',
  'ccn.submit.conflictTitle': '{n} 个字段尚未决定',
  'ccn.submit.conflictBody': 'CCN 的新版本在部分字段上与您的修改不同。草稿将按您的值发送。',
  'ccn.merge.field.namaSaranaPengangkut': '承运人名称',
  'ccn.merge.field.nomorVoyage': '航班号',
  'ccn.merge.field.tanggalTiba': '到达日期',
  'ccn.merge.field.imoNumber': '航空公司代码',
  'ccn.merge.field.kodeNegara': '出发国家',
  'ccn.merge.field.tanggalBl': '主运单日期',
  'ccn.merge.field.tanggalHostBl': '分运单日期',
  'ccn.merge.field.namaPengirim': '发货人名称',
  'ccn.merge.field.alamatPengirim': '发货人地址',
  'ccn.merge.field.namaPenerima': '收货人名称',
  'ccn.merge.field.alamatPenerima': '收货人地址',
  'ccn.merge.field.npwpPenerima': '收货人税号',
  'ccn.merge.field.namaNotify': '通知方名称',
  'ccn.merge.field.alamatNotify': '通知方地址',
  'ccn.merge.field.berat': '毛重(公斤)',
  'ccn.merge.field.dimensi': '体积(立方米)',
  'ccn.merge.field.jumlahKemasan': '件数',
  'ccn.merge.field.jenisKemasan': '包装类型',
  'ccn.merge.field.kodePelabuhanAsal': '装货港',
  'ccn.merge.field.kodePelabuhanBongkar': '卸货港',
  'ccn.merge.field.kodePelabuhanAkhir': '最终目的地',
  'ccn.merge.field.goods': '货物',

  // ---- Shipping Instruction (export upload + PEB Document tab) ----
  'upload.siGuide.link': '什么是 Shipping Instruction？',
  'upload.siGuide.heading': '出口上传的新功能',
  'upload.siGuide.what.title': 'Shipping Instruction 有了自己的类型',
  'upload.siGuide.what.body':
    '货代发来的装运指示 — 通常是一封列有 DEST、ETD、MAWB/HAWB、QTY、INV 和 FLIGHT 的邮件 — 现在可以作为 Shipping Instruction 上传，不必再当作 AWB 上传。',
  'upload.siGuide.pick.title': '选择“000 - Shipping Instruction”',
  'upload.siGuide.pick.body':
    '在文件类型栏输入“si”或“000”，然后选择 000 - Shipping Instruction。即使文件没有标题，“全部识别”也能根据内容自动认出它。',
  'upload.siGuide.fills.title': '用于填写 PEB 草稿',
  'upload.siGuide.fills.body':
    'Jarvis 读取运输工具（航班或船舶）、港口、预计出口日期以及包装的数量和种类，并填入 Header、Pengangkut 和 Kemasan 标签页。',
  'upload.siGuide.notSent.title': '不会提交给 CEISA',
  'upload.siGuide.notSent.body':
    'Shipping Instruction 不是报关单证，因此不会进入单证表，也不会提交给 CEISA — 不再有需要删除的行。文件仍可在 Document 标签页底部查看，并列出从中读取的栏位。',
  'upload.siGuide.back': '上一步',
  'upload.siGuide.next': '下一步',
  'upload.siGuide.done': '知道了',
  'export.si.title': '参考文件',
  'export.si.notSent': '不提交给 CEISA',
  'export.si.hint': 'Shipping Instruction 用于帮助填写草稿，但不是报关单证：不会进入上方的单证表，也不会提交给 CEISA。',
  'export.si.view': '查看',
  'export.si.hide': '关闭 PDF',
  'export.si.loading': '正在加载详情…',
  'export.si.sourceFor': '作为以下栏位的来源被读取：',
  'export.si.sourceForNote': '其他单证（如装箱单）上也印有的栏位，可能取自那份单证。',
  'export.si.sourceForNone': '本次提取中没有栏位取自此文件。',
  'export.si.sourceForGeneral': '其内容用于帮助填写 Header、Entitas、Pengangkut 以及 Kemasan & Peti Kemas 标签页。',
  'export.si.field.exportLoadPort': '出口装货港',
  'export.si.field.exportirName': '出口商名称',
  'export.si.field.exportirAddress': '出口商地址',
  'export.si.field.exportirIdentity': '出口商证件号码',
  'export.si.field.exportirIdentityType': '出口商证件类型',
  'export.si.field.recipientName': '收货人名称',
  'export.si.field.recipientAddress': '收货人地址',
  'export.si.field.recipientCountry': '收货人国家',
  'export.si.field.meansTransportName': '运输工具名称',
  'export.si.field.voyNumber': '航次/航班号',
  'export.si.field.modeOfTransportation': '运输方式',
  'export.si.field.estimatedExportDate': '预计出口日期',
  'export.si.field.originLoadingPort': '起运装货港',
  'export.si.field.exportLoadingPort': '出口装货港',
  'export.si.field.unloadingPort': '卸货港',
  'export.si.field.destinationPort': '目的港',
  'export.si.field.destinationCountry': '目的国',
  'export.si.field.containerNumber': '集装箱号',
  'export.si.field.containerSize': '集装箱尺寸',
  'export.si.field.containerType': '集装箱类型',
  'export.si.field.packageCount': '包装数量',
  'export.si.field.packageType': '包装种类',
  // Manifest "Dari PEB (NPE)" — outward draft from NPE PEBs (next-jarvis#583)
  'manifest.fromPabean.card.title': '来自 PEB（NPE）',
  'manifest.fromPabean.card.subtitle': '选择已获 NPE 的 PEB，无需上传和 AI 提取。',
  'manifest.fromPabean.preview.heading': '用已获 NPE 的 PEB 创建舱单',
  'manifest.fromPabean.preview.pick.title': '选择 PEB',
  'manifest.fromPabean.preview.pick.body': '勾选一起装运且已获 NPE 的 PEB。勾选顺序即舱单上的 pos 顺序。',
  'manifest.fromPabean.preview.create.title': '创建舱单',
  'manifest.fromPabean.preview.create.body':
    '表头、分提单/分运单、集装箱、HS 和 PEB 单证会根据 PEB 数据自动填写。无需上传，无需 AI 提取。',
  'manifest.fromPabean.preview.masterBl.title': '上传主提单（可选）',
  'manifest.fromPabean.preview.masterBl.body': '主提单可随时在草稿中上传或手动填写。没有主提单草稿也会保存。',
  'manifest.fromPabean.preview.dontShow': '不再显示',
  'manifest.fromPabean.preview.back': '上一步',
  'manifest.fromPabean.preview.next': '下一步',
  'manifest.fromPabean.preview.start': '开始',
  'manifest.fromPabean.page.title': '用 NPE PEB 创建舱单',
  'manifest.fromPabean.page.subtitle': '选择一起装运的 PEB；每个 PEB 生成一个分提单/分运单。',
  'manifest.fromPabean.page.outward': '出境',
  'manifest.fromPabean.page.sea': '海运',
  'manifest.fromPabean.page.air': '空运',
  'manifest.fromPabean.page.changeProduct': '更换产品',
  'manifest.fromPabean.page.guide': '指南',
  'manifest.fromPabean.note.always': '这里只列出通过 JARVIS 创建且已获 NPE 的 PEB。',
  'manifest.fromPabean.note.excluded':
    '另有 {n} 个已获 NPE 的 PEB 未列出，因为它们不是通过 JARVIS 创建的——可以在草稿中通过以下功能添加：',
  'manifest.fromPabean.note.susulan': 'Upload PEB Susulan',
  'manifest.fromPabean.note.susulanTip':
    '“Upload PEB / BL Susulan”按钮位于舱单草稿的 BL 标签页。在那里上传 PEB PDF 即可添加分提单。',
  'manifest.fromPabean.filter.dateFrom': '登记日期自',
  'manifest.fromPabean.filter.dateTo': '至',
  'manifest.fromPabean.filter.search': '搜索申报号、登记号或出口商',
  'manifest.fromPabean.col.aju': '申报号',
  'manifest.fromPabean.col.daftar': '登记号和日期',
  'manifest.fromPabean.col.npe': 'NPE 日期',
  'manifest.fromPabean.col.exporter': '出口商',
  'manifest.fromPabean.col.buyer': '买方',
  'manifest.fromPabean.col.ports': '装货港 → 卸货港',
  'manifest.fromPabean.col.carrier': '运输工具 / 航次',
  'manifest.fromPabean.col.bl': '提单号',
  'manifest.fromPabean.col.awb': '运单号',
  'manifest.fromPabean.col.containers': '集装箱',
  'manifest.fromPabean.col.hs': 'HS',
  'manifest.fromPabean.col.status': '状态',
  'manifest.fromPabean.status.inDraft': '已在草稿中',
  'manifest.fromPabean.status.inDraftTip': '打开已使用此 PEB 的草稿。仍可选择此 PEB。',
  'manifest.fromPabean.status.ready': '可用',
  'manifest.fromPabean.noBlTip': '此 PEB 没有提单/运单单证；请稍后在草稿中填写',
  'manifest.fromPabean.empty.title': '没有可用的 NPE PEB',
  'manifest.fromPabean.empty.body': '请更改日期范围或搜索关键词。',
  'manifest.fromPabean.bar.selected': '已选择 {n} 个 PEB',
  'manifest.fromPabean.bar.reset': '清除选择',
  'manifest.fromPabean.bar.create': '创建舱单',
  'manifest.fromPabean.bar.max': '每个舱单最多 {max} 个 PEB',
  'manifest.fromPabean.confirm.title': '用 PEB 创建舱单',
  'manifest.fromPabean.confirm.mode': '运输方式',
  'manifest.fromPabean.confirm.kantor': '装货海关',
  'manifest.fromPabean.confirm.carrier': '运输工具 / 航次',
  'manifest.fromPabean.confirm.houses': '分提单/分运单',
  'manifest.fromPabean.confirm.housesValue': '{n} 个（每个 PEB 一个）',
  'manifest.fromPabean.confirm.masterBl': '主提单',
  'manifest.fromPabean.confirm.masterBlValue': '暂无——可在草稿中上传',
  'manifest.fromPabean.confirm.firstPebNote': '舱单表头以第一个选择的 PEB 为准。',
  'manifest.fromPabean.confirm.prewarnTitle': '请注意',
  'manifest.fromPabean.confirm.cancel': '取消',
  'manifest.fromPabean.confirm.submit': '创建舱单',
  'manifest.fromPabean.confirm.createdTitle': '草稿已创建，附有提示',
  'manifest.fromPabean.confirm.createdBody': '草稿已保存。请在编辑器中检查以下提示：',
  'manifest.fromPabean.confirm.continue': '前往草稿',
  'manifest.fromPabean.prewarn.vessel': '运输工具/航次与第一个 PEB 不同',
  'manifest.fromPabean.prewarn.port': '装货港与第一个 PEB 不同',
  'manifest.fromPabean.prewarn.kantor': '装货海关与第一个 PEB 不同',
  'manifest.fromPabean.prewarn.used': '已在其他草稿中使用',
  'manifest.fromPabean.reason.NOT_FOUND': '未找到 PEB',
  'manifest.fromPabean.reason.NOT_PEB': '不是 PEB（BC 3.0）',
  'manifest.fromPabean.reason.NOT_NPE': '尚未获得 NPE',
  'manifest.fromPabean.reason.NO_STRUCTURED_DATA': '不是通过 JARVIS 创建',
  'manifest.fromPabean.reason.MODE_MISMATCH': '运输方式不符',
  'manifest.fromPabean.reason.KANTOR_MISMATCH': '装货海关不同',
  'manifest.fromPabean.reason.DUPLICATE_AJU': '重复选择',
  'manifest.fromPabean.reason.UNKNOWN': '无法使用',
  'manifest.fromPabean.warning.VESSEL_MISMATCH': '运输工具/航次与第一个 PEB 不同；表头使用第一个 PEB。',
  'manifest.fromPabean.warning.LOADING_PORT_MISMATCH': '装货港与第一个 PEB 不同。',
  'manifest.fromPabean.warning.NO_BL_ON_PEB': 'PEB 没有提单/运单单证；分提单/分运单号留空。',
  'manifest.fromPabean.warning.GROSS_WEIGHT_MISSING': 'PEB 没有毛重（KGM）；Bruto Total 留空，请在编辑器中填写。',
  'manifest.fromPabean.rejected.toast': '部分 PEB 无法使用。请检查标红的行。',
  'manifest.fromPabean.error.create': '创建舱单失败',
  'manifest.manualDraft.error.create': '创建舱单草稿失败',
  'manifest.fromPabean.error.load': '加载 PEB 列表失败',
  'manifest.fromPabean.masterBl.emptyTitle': '暂无主提单',
  'manifest.fromPabean.masterBlStep.title': '上传 {doc}（可选）',
  'manifest.fromPabean.masterBlStep.body':
    '如果已有 {doc}，现在上传，草稿创建后会立即提取到草稿中。如果还没有，可以跳过——{doc} 可随时在草稿中上传或手动填写。',
  'manifest.fromPabean.masterBlStep.drop': '将 {doc} PDF 拖到这里或点击选择',
  'manifest.fromPabean.masterBlStep.hint': '一个 PDF 文件，最大 20 MB',
  'manifest.fromPabean.masterBlStep.rejected': '只能上传一个不超过 20 MB 的 PDF 文件。',
  'manifest.fromPabean.masterBlStep.remove': '移除文件',
  'manifest.fromPabean.masterBlStep.skip': '跳过',
  'manifest.fromPabean.masterBlStep.next': '下一步',
  'manifest.fromPabean.confirm.masterBlFile': '{name}——草稿创建后提取',
  'manifest.fromPabean.confirm.creating': '正在创建草稿…',
  'manifest.fromPabean.confirm.extracting': '草稿已创建，正在提取主提单…',
  'manifest.fromPabean.confirm.masterBlFailed':
    '草稿已创建，但主提单提取失败：{reason}。请在草稿的 Master BL 标签页重新上传。',
  'manifest.fromPabean.masterBl.emptyBody': '主提单可以稍后填写，草稿已保存。请上传主提单文件或点击 Tambah Master BL。',
  // Manifest "Dari PIB (SPPB)" — inward draft from SPPB PIBs (next-jarvis#591)
  'manifest.fromPabean.page.inward': '入境',
  'manifest.fromPabean.col.sppb': 'SPPB 日期',
  'manifest.fromPabean.col.importer': '进口商',
  'manifest.fromPabean.col.sender': '发货人（国家）',
  'manifest.fromPabean.col.bc11': 'BC 1.1（编号/pos）',
  'manifest.fromPabean.reason.NOT_PIB': '不是 PIB（BC 2.0）',
  'manifest.fromPabean.reason.NOT_SPPB': '尚未获得 SPPB',
  'manifest.fromPabean.warning.DISCHARGE_PORT_MISMATCH': '卸货港与第一个 PIB 不同。',
  'manifest.fromPabean.warning.NO_BL_ON_PIB': 'PIB 没有提单/运单单证；分提单/分运单号留空。',
  'manifest.fromPabean.warning.BC11_REF_DROPPED': '原 BC 1.1 参考未保存在草稿中 —',
  'manifest.fromPabean.warning.NO_PIB_DOC_CODE': 'PIB 原始单证未自动填写 —',
  'manifest.fromPabean.inward.card.title': '来自 PIB（SPPB）',
  'manifest.fromPabean.inward.card.subtitle': '选择已获 SPPB 的 PIB，无需上传和 AI 提取。',
  'manifest.fromPabean.inward.preview.heading': '用已获 SPPB 的 PIB 创建舱单',
  'manifest.fromPabean.inward.preview.pick.title': '选择 PIB',
  'manifest.fromPabean.inward.preview.pick.body': '勾选一起拼箱且已获 SPPB 的 PIB。勾选顺序即舱单上的 pos 顺序。',
  'manifest.fromPabean.inward.preview.create.body':
    '表头、分提单/分运单、集装箱和 HS 根据 PIB 数据自动填写。无需上传，无需 AI 提取。',
  'manifest.fromPabean.inward.page.title': '用 SPPB PIB 创建舱单',
  'manifest.fromPabean.inward.page.subtitle': '选择一起拼箱的 PIB；每个 PIB 生成一个分提单/分运单。',
  'manifest.fromPabean.inward.note.always': '这里只列出通过 JARVIS 创建且已获 SPPB 的 PIB。',
  'manifest.fromPabean.inward.note.excluded':
    '另有 {n} 个 SPPB PIB 因不是通过 JARVIS 创建而未列出 — 可在草稿中通过以下按钮添加其分提单/分运单：',
  'manifest.fromPabean.inward.note.susulan': 'Upload BL/AWB Susulan',
  'manifest.fromPabean.inward.note.susulanTip':
    '"Upload BL/AWB Susulan" 按钮位于舱单草稿的 BL 标签页。在那里上传提单/运单 PDF 即可添加分提单。',
  'manifest.fromPabean.inward.filter.search': '搜索申报号、登记号或进口商',
  'manifest.fromPabean.inward.status.inDraftTip': '打开已使用此 PIB 的草稿。此 PIB 仍可选择。',
  'manifest.fromPabean.inward.noBlTip': '此 PIB 没有提单/运单单证；请稍后在草稿中填写',
  'manifest.fromPabean.inward.empty.title': '没有可用的 SPPB PIB',
  'manifest.fromPabean.inward.bar.selected': '已选择 {n} 个 PIB',
  'manifest.fromPabean.inward.bar.max': '每个舱单最多 {max} 个 PIB',
  'manifest.fromPabean.inward.confirm.title': '用 PIB 创建舱单',
  'manifest.fromPabean.inward.confirm.kantor': '海关',
  'manifest.fromPabean.inward.confirm.housesValue': '{n} 个（每个 PIB 一个）',
  'manifest.fromPabean.inward.confirm.firstPebNote': '舱单表头以第一个选择的 PIB 为准。',
  'manifest.fromPabean.inward.prewarn.vessel': '运输工具/航次与第一个 PIB 不同',
  'manifest.fromPabean.inward.prewarn.dischargePort': '卸货港与第一个 PIB 不同',
  'manifest.fromPabean.inward.prewarn.kantor': '海关与第一个 PIB 不同',
  'manifest.fromPabean.inward.reason.NOT_FOUND': '未找到 PIB',
  'manifest.fromPabean.inward.reason.KANTOR_MISMATCH': '海关不同',
  'manifest.fromPabean.inward.warning.VESSEL_MISMATCH': '运输工具/航次与第一个 PIB 不同；表头使用第一个 PIB。',
  'manifest.fromPabean.inward.warning.GROSS_WEIGHT_MISSING':
    'PIB 没有毛重（KGM）；Bruto Total 留空，请在编辑器中填写。',
  'manifest.fromPabean.inward.rejected.toast': '部分 PIB 无法使用。请检查标红的行。',
  'manifest.fromPabean.inward.error.load': '加载 PIB 列表失败',

  // ---- CEISA /document/check 拒绝（utils/ceisa-check-issues.ts）----
  'ceisaCheck.rejected': 'CEISA 拒绝了该文件：{issues}',
  'ceisaSubmit.upstreamPpjkMismatch': 'CEISA 出现故障，拒绝了本次提交。您的数据是正确的，无需修改。请几分钟后再试。',
  'ceisaSubmit.accountPpjkMismatch':
    '所使用的 CEISA 账户（NPWP {accountNpwp}）与文件中的 PPJK（NPWP {ppjkNpwp}）不一致。请检查 Entitas 标签中的 PPJK，或联系管理员获取正确的 CEISA 账户。',
  'ceisaCheck.sentence': '{subject}{problem}。',
  'ceisaCheck.sentenceOther': '{subject}：{text}。',
  'ceisaCheck.textOnly': '{text}。',
  'ceisaCheck.item': '数据',
  'ceisaCheck.subjectGoods': '第 {seris} 项商品的{field}',
  'ceisaCheck.subjectGoodsNested': '第 {seris} 项商品{array}的{field}',
  'ceisaCheck.subjectArray': '第 {n} 个{array}的{field}',
  'ceisaCheck.problem.decimals': '最多保留 {n} 位小数',
  'ceisaCheck.problem.integer': '必须为整数',
  'ceisaCheck.problem.multiple': '必须是 {n} 的倍数',
  'ceisaCheck.problem.required': '为必填项',
  'ceisaCheck.problem.maxLength': '最多 {n} 个字符',
  'ceisaCheck.problem.minLength': '至少需要 {n} 个字符',
  'ceisaCheck.problem.max': '不能大于 {n}',
  'ceisaCheck.problem.min': '不能小于 {n}',
  'ceisaCheck.problem.lessThan': '必须小于 {n}',
  'ceisaCheck.problem.greaterThan': '必须大于 {n}',
  'ceisaCheck.problem.date': '不是有效的日期格式',
  'ceisaCheck.problem.format': '格式无效',
  'ceisaCheck.problem.enum': '的取值不被 CEISA 认可',
  'ceisaCheck.problem.type': '填写类型不正确',
  'ceisaCheck.field.alamatEntitas': '实体地址',
  'ceisaCheck.field.asuransi': '保险费',
  'ceisaCheck.field.bruto': '毛重',
  'ceisaCheck.field.cif': 'CIF',
  'ceisaCheck.field.cifRupiah': 'CIF（印尼盾）',
  'ceisaCheck.field.fob': 'FOB',
  'ceisaCheck.field.freight': '运费',
  'ceisaCheck.field.hargaSatuan': '单价',
  'ceisaCheck.field.hs': 'HS 编码',
  'ceisaCheck.field.jumlahKemasan': '包装数量',
  'ceisaCheck.field.jumlahSatuan': '数量',
  'ceisaCheck.field.kodeDokumen': '单证代码',
  'ceisaCheck.field.kodeFasilitas': '优惠代码',
  'ceisaCheck.field.kodeJenisKemasan': '包装类型',
  'ceisaCheck.field.kodeNegaraAsal': '原产国',
  'ceisaCheck.field.kodeSatuanBarang': '计量单位',
  'ceisaCheck.field.merk': '品牌',
  'ceisaCheck.field.namaEntitas': '实体名称',
  'ceisaCheck.field.ndpbm': '汇率（NDPBM）',
  'ceisaCheck.field.netto': '净重',
  'ceisaCheck.field.nilaiBarang': '货值',
  'ceisaCheck.field.nomorAju': 'Aju 编号',
  'ceisaCheck.field.nomorBc11': 'BC 1.1 编号',
  'ceisaCheck.field.nomorDokumen': '单证编号',
  'ceisaCheck.field.nomorIdentitas': '识别号',
  'ceisaCheck.field.nomorKontainer': '集装箱号',
  'ceisaCheck.field.posBc11': 'BC 1.1 项',
  'ceisaCheck.field.posTarif': 'HS 编码',
  'ceisaCheck.field.spesifikasiLain': '其他规格',
  'ceisaCheck.field.subposBc11': 'BC 1.1 子项',
  'ceisaCheck.field.tanggalBc11': 'BC 1.1 日期',
  'ceisaCheck.field.tanggalDokumen': '单证日期',
  'ceisaCheck.field.tarif': '税率',
  'ceisaCheck.field.tipe': '型号',
  'ceisaCheck.field.ukuran': '尺寸',
  'ceisaCheck.field.uraian': '货物描述',
  'ceisaCheck.field.volume': '体积',
  'ceisaCheck.array.barangDokumen': '单证',
  'ceisaCheck.array.barangTarif': '税率',
  'ceisaCheck.array.dokumen': '单证',
  'ceisaCheck.array.entitas': '实体',
  'ceisaCheck.array.kemasan': '包装',
  'ceisaCheck.array.kontainer': '集装箱',
  'ceisaCheck.array.pengangkut': '运输工具',
  // ---- Spesifikasi Khusus (next-jarvis#778) ----
  'editbarang.spekKhusus.required':
    '此 HS 在 CEISA 中必须填写特殊规格（例如 CAS 编号）。缺少此项，货物无法在 CEISA 门户中保存。',
  'editbarang.spekKhusus.navMissing': '尚未填写特殊规格',
  'editbarang.spekKhusus.switchTitle': '更换类别？',
  'editbarang.spekKhusus.switchMessage': '{category} 数据将被删除。是否继续？',
  'editbarang.spekKhusus.switchCancel': '取消',
  'editbarang.spekKhusus.switchConfirm': '继续',
  'editbarang.spekKhusus.untickTitle': '删除特殊规格？',
  'editbarang.spekKhusus.untickMessage': '保存时将删除此货物的特殊规格数据。是否继续？',
  'editbarang.spekKhusus.flagStaffOnly': '只有 JARVIS 员工可以将 HS 标记为特殊规格。',
  'submitsummary.spekKhusus.title': '尚未填写特殊规格',
  'submitsummary.spekKhusus.body':
    '以下货物的 HS 在 CEISA 中必须填写特殊规格（例如 CAS 编号）。请打开该货物并填写特殊规格部分。',
  'submitsummary.spekKhusus.line': '序号 {seri} · {hs} · {uraian}',
  'submitsummary.spekKhusus.open': '填写特殊规格',
  'submitsummary.spekKhusus.ack': '我了解没有特殊规格，此货物可能会被 CEISA 拒绝或无法保存',
  'submitsummary.spekKhusus.blocked': '请先勾选上方的特殊规格确认',
  'submitsummary.kemasanTotal.title': '包装数量不一致',
  'submitsummary.kemasanTotal.barang': '商品标签页（{seri} 项）',
  'submitsummary.kemasanTotal.kemasan': '包装标签页',
  'submitsummary.kemasanTotal.selisih': '差额',
  'submitsummary.kemasanTotal.body': '请先核对商品标签页中每项商品的包装数量，以及“包装与集装箱”标签页中的数量。',
  'submitsummary.kemasanTotal.ack': '我已核对包装数量，仍要提交',
  'submitsummary.kemasanTotal.blocked': '请先勾选上方的包装数量确认',
  'submitsummary.smartSync.neverTitle': '尚未运行智能同步',
  'submitsummary.smartSync.neverBody':
    '货物的税率、限制（lartas）、单位和包装尚未与 INSW 重新核对。此项可选——您仍可提交。',
  'submitsummary.smartSync.staleTitle': '智能同步后货物有变更',
  'submitsummary.smartSync.staleBody':
    '智能同步上次由 {lastBy} 于{relative}运行；之后有 {count} 处货物变更。此项可选——您仍可提交。',
  'submitsummary.smartSync.open': '打开智能同步 →',

  // next-jarvis#854: keys that had no Chinese yet.
  'upload.detecting': '正在识别...',
  'upload.detected': '已识别',
  'upload.detectedMulti': '识别出 {n} 种文件类型',
  'upload.detectedSingle': '已识别：{type}',
  'upload.detectFailed': '识别失败',
  'upload.splitSuggestion': '拆分文件',
  'upload.unclassifiedPages': '{n} 页无法识别',

  // ---- 公司印章（其他服务 → 盖章） ----
  'stamp.upload.title': '上传公司印章',
  'stamp.upload.subtitle': '贵公司的所有用户在给文件盖章时都会使用此印章。',
  'stamp.upload.drop': '将印章图片拖到此处，或点击选择',
  'stamp.upload.formats': 'PNG 或 JPG，最大 2 MB',
  'stamp.upload.tip': '请使用透明背景的 PNG，以免遮挡下方的文件内容',
  'stamp.upload.preview': '印章预览',
  'stamp.upload.save': '保存',
  'stamp.upload.cancel': '取消',
  'stamp.upload.saved': '公司印章已保存',
  'stamp.active.label': '公司印章',
  'stamp.active.uploadedBy': '由 {email} 上传 · {date}',
  'stamp.replace.button': '更换印章',
  'stamp.replace.title': '更换公司印章',
  'stamp.replace.note': '新印章将立即对贵公司的所有用户生效。',
  'stamp.disabled.title': '贵公司的印章已被 JARVIS 团队停用',
  'stamp.disabled.reason': '原因：{reason}',
  'stamp.disabled.body': '在 JARVIS 团队重新启用之前，您无法盖章或上传新印章。',
  'stamp.disabled.contact': '联系客服',
  'stamp.noPpjk.title': '您的账户尚未关联 PPJK',
  'stamp.noPpjk.body': '账户关联 PPJK 后即可使用公司印章。请联系贵公司管理员。',
  'stamp.error.tooLarge': '最大 2 MB',
  'stamp.error.type': '仅支持 PNG 或 JPG',
  'stamp.error.invalidImage': '此印章图片无法使用',
  'stamp.error.impersonated': '模拟登录期间无法更换印章，请通过 CMS 更换',
  'stamp.error.busy': '服务器繁忙，请稍后再试',
  'stamp.error.generic': '出现错误，请重试',
  'stamp.error.load': '无法加载公司印章',
  'stamp.error.retry': '重试',
  'stamp.viewer.hint': '点击文档放置印章，然后拖动印章调整位置。',
  'stamp.viewer.item': '印章 {n}',
  'stamp.viewer.remove': '删除',
  'stamp.viewer.x': 'X 坐标',
  'stamp.viewer.y': 'Y 坐标',
  'stamp.viewer.page': '页码',
  'stamp.viewer.add': '添加印章',
  'stamp.viewer.reset': '重置位置',
  'stamp.viewer.download': '下载已盖章的 PDF',
  'stamp.viewer.downloadError': '无法生成已盖章的 PDF。',
  'stamp.viewer.newFile': '上传其他文件',

  // Bulk Update modal, "Nilai & Transaksi" section (next-jarvis#926).
  'bulkNilai.sectionTitle': '价值与交易',
  'bulkNilai.sectionSubtitle': '勾选要替换字段的“修改”；未勾选的字段保持不变',
  'bulkNilai.ubah': '修改',
  'bulkNilai.spesifikasiLain': '其他规格',
  'bulkNilai.spesifikasiLainPlaceholder': '例如 黑色, 220V',
  'bulkNilai.spesifikasiLainHint': '最多 {count} 个字符。勾选但留空 = 清除其他规格。',
  'bulkNilai.freeGoods': '免费货物 / 样品（Metode 2 + CMA + 交易类型 CMA）',
  'bulkNilai.freeGoodsHint': '与货物详情中勾选“Free of Charge Item”相同，并加上交易类型 CMA。',
  'bulkNilai.metode': '海关估价方法',
  'bulkNilai.metodePlaceholder': '选择方法',
  'bulkNilai.alasan': '理由',
  'bulkNilai.alasanPlaceholder': '选择理由',
  'bulkNilai.alasanHint': '勾选但留空 = 清除理由。',
  'bulkNilai.alasanLocked': 'Metode 1 不使用理由，因此理由已清空。',
  'bulkNilai.jenisTransaksi': '交易类型',
  'bulkNilai.jenisTransaksiHelp': '替换所选货物的交易类型',
  'bulkNilai.jenisTransaksiEmpty': '尚无行。若按此应用，所选货物的交易类型将被删除。',
  'bulkNilai.kodeJenisVd': '价值类型',
  'bulkNilai.kodePlaceholder': '选择交易类型',
  'bulkNilai.nilaiBarangVd': 'VD 金额',
  'bulkNilai.addRow': '添加交易类型',
  'bulkNilai.removeRow': '删除行',
  'bulkNilai.maxRows': '每项货物最多 {count} 个交易类型。',
  'bulkNilai.previewTitle': '变更预览',
  'bulkNilai.previewNone': '尚未勾选任何字段。',
  'bulkNilai.previewCount': '{count} 项货物',
  'bulkNilai.cleared': '（清空）',
  'bulkNilai.summaryNone': '不修改。',
  'bulkNilai.err.noSeri': '请在第 1 部分填写货物序号；这些字段只应用于这些序号。',
  'bulkNilai.err.spesifikasiTooLong': '其他规格最多 {count} 个字符。',
  'bulkNilai.err.metodeRequired': '请选择估价方法。',
  'bulkNilai.err.metodeInvalid': '未知的估价方法。',
  'bulkNilai.err.alasanInvalid': '未知的理由。',
  'bulkNilai.err.tooManyRows': '每项货物最多 {count} 个交易类型。',
  'bulkNilai.err.kodeRequired': '请选择交易类型。',
  'bulkNilai.err.kodeInvalid': '未知的交易类型代码。',
  'bulkNilai.err.kodeDuplicate': '该交易类型已在列表中。',
  'bulkNilai.err.nilaiInvalid': 'VD 金额必须是 0 或以上的数字。',
  'bulkNilai.err.server': '服务器拒绝了此值。',
  'bulkNilai.err.checkTitle': '更改未应用',
  'bulkNilai.err.checkBody': '请检查“价值与交易”部分中标红的字段。',
  'bulkNilai.err.rejectedBody': '服务器拒绝了部分输入，未做任何更改。请检查标红的字段。',
};

// English has every key `id` has (next-jarvis#854). `t()` still falls back to
// Indonesian for a missing key, so a key added to `id` alone would quietly
// render in Indonesian here; translations.parity.test.ts fails instead. Add
// `id`, `en` and `zh` together. Customs terms the officers use (PIB, PEB, AJU,
// NOPEN, HS, BM, PPN, PPh, SPPB, Lartas, Pungutan) stay as they are.
const en: TranslationDict = {
  'pdf.documentOf': 'Document {cur} / {total}',
  'pdf.pageOf': 'Page {cur} / {total}',
  'pdf.prevDocument': 'Previous document',
  'pdf.nextDocument': 'Next document',
  'pdf.download': 'Download',
  'pdf.close': 'Close PDF',
  'entitasform.nibPerluDicek':
    'NIB taken from an earlier filing under another spelling of this NPWP. Please check it before submitting.',
  'entitasform.errNibImportir13Digit': 'Importer NIB must be 13 digits',
  // ---- Dokumen tab: Jarvis 2.0 document re-read (next-jarvis#630) ----
  'dokumenform.button.unggahDokumen': 'Upload PDF',
  'dokumenform.button.isiManual': 'Enter manually',
  'dokumenform.reread.upload.title': 'Upload document',
  'dokumenform.reread.match2.colSeriIjin': 'Permit no.',
  'dokumenform.reread.match2.izinHint':
    'Seri izin (the item number of the line on the document) is filled automatically where it was read — check it and fill any blanks.',
  'dokumenform.reread.izinFilled': 'Seri izin filled on {n} barang already linked to this document.',
  'dokumenform.reread.progress.waiting': 'Waiting for its turn…',
  'dokumenform.reread.error.runNotFinished': 'JARVIS is still processing this draft. Try again once it has finished.',
  'dokumenform.reread.progress.starting': 'Starting…',
  'dokumenform.reread.progress.reading': 'Reading the PDF ({pages} pages)…',
  'dokumenform.reread.progress.tabs': 'Filling the tabs ({done}/{total})…',
  'dokumenform.reread.progress.eta': 'about {s}s left',
  'dokumenform.reread.progress.queue': '{ready} of {n} documents ready — read side by side',
  'dokumenform.reread.multi.listTitle': 'Documents found ({n})',
  'dokumenform.reread.match2.title': 'Link goods to {doc}',
  'dokumenform.reread.match2.body':
    "JARVIS's auto-match suggests {n} goods for this document ({existing} already linked). Ticked goods will be linked.",
  'dokumenform.reread.match2.save': 'Save links ({n})',
  'dokumenform.reread.match2.saved': '{n} goods linked.',
  'dokumenform.reread.match2.by.both': 'HS + description',
  'dokumenform.reread.match2.by.hs_code': 'HS',
  'dokumenform.reread.match2.by.description': 'Description',
  'dokumenform.reread.match2.by.prebaked': 'JARVIS data',
  'dokumenform.reread.match2.by.coverage': 'Only goods line',
  'dokumenform.reread.match2.by.count': 'Same count',
  'dokumenform.reread.fill.title': 'Complete goods',
  'dokumenform.reread.fill.section': 'Complete existing goods ({n} lines)',
  'dokumenform.reread.fill.hint':
    'Blank goods fields the documents fill are ticked. Values that differ from what is there now stay unticked.',
  'dokumenform.reread.fill.seri': 'Line {n} · {uraian}',
  'dokumenform.reread.fill.kosong': 'blank',
  'dokumenform.reread.fill.newLines': 'New goods ({n})',
  'dokumenform.reread.fill.optionTitle': 'Complete goods from the documents already here',
  'dokumenform.reread.fill.optionBody':
    "JARVIS reads this draft's invoices and packing lists again and fills blank goods fields (packages, weights, brand, …). You choose what to apply.",
  'dokumenform.reread.fill.optionButton': 'Complete goods',
  'dokumenform.reread.field.jumlah_kemasan': 'Package count',
  'dokumenform.reread.field.kode_jenis_kemasan': 'Package type',
  'dokumenform.reread.field.netto': 'Net weight (kg)',
  'dokumenform.reread.field.bruto': 'Gross weight (kg)',
  'dokumenform.reread.field.volume': 'Volume',
  'dokumenform.reread.field.kode_negara_asal': 'Country of origin',
  'dokumenform.reread.field.merk': 'Brand',
  'dokumenform.reread.field.tipe': 'Type',
  'dokumenform.reread.field.ukuran': 'Size',
  'dokumenform.reread.field.spesifikasi_lain': 'Other specification',
  'dokumenform.reread.field.kode_barang': 'Item code',
  'dokumenform.reread.multi.subtitleSorted':
    "Check JARVIS's split: move any document in the wrong folder, preview it, then read with JARVIS. Blank goods fields are completed from these documents too.",
  'dokumenform.reread.multi.subtitle':
    'Upload your PDFs — JARVIS splits out the documents inside and sorts them by type.',
  'dokumenform.reread.multi.dropTitle': 'Upload PDFs here',
  'dokumenform.reread.multi.dropBody':
    'Drag one or more PDFs — a BL, invoice and packing list combined in one file is fine — or',
  'dokumenform.reread.multi.klikPilih': 'click to choose',
  'dokumenform.reread.multi.dropLimits': 'PDF only · up to {n} documents per upload',
  'dokumenform.reread.multi.dropMore': 'Add more PDFs',
  'dokumenform.reread.multi.splitting': 'JARVIS is splitting the documents… ({done}/{total} files)',
  'dokumenform.reread.multi.detected': 'Read as {jenis} · {pct}%',
  'dokumenform.reread.multi.notDetected': 'Type not recognised — choose one',
  'dokumenform.reread.multi.preview': 'Preview PDF',
  'dokumenform.reread.multi.previewTitle': 'Preview — {file}',
  'dokumenform.reread.multi.splitFrom': 'Split from {file}, pages {pages}',
  'dokumenform.reread.multi.mulaiUlang': 'Start over',
  'dokumenform.reread.multi.jenis': 'Type',
  'dokumenform.reread.multi.untuk': 'For',
  'dokumenform.reread.multi.baru': 'New document',
  'dokumenform.reread.multi.tambahan': 'Extra pages for {doc}',
  'dokumenform.reread.multi.semua': 'all',
  'dokumenform.reread.multi.none': 'No files yet. Drag PDFs into their folders.',
  'dokumenform.reread.multi.needType': 'Choose a type for each file in Lainnya.',
  'dokumenform.reread.multi.tooMany': 'At most {n} documents per upload.',
  'dokumenform.reread.multi.uploading': 'Uploading {i} of {n}…',
  'dokumenform.reread.multi.ready': '{n} documents ready to read.',
  'dokumenform.reread.multi.baca': 'Read with JARVIS ({n})',
  'dokumenform.reread.multi.queue': 'Document {i} of {n}',
  'dokumenform.reread.multi.lewati': 'Skip',
  'dokumenform.reread.match.title': 'This document is already on the draft',
  'dokumenform.reread.match.body': '{jenis} number {nomor} matches row {n} on the Dokumen tab.',
  'dokumenform.reread.match.merge': 'Merge into the existing document (recommended)',
  'dokumenform.reread.match.mergeHint':
    "This file's pages are added to that document and read again. No new document row, and matching goods stay unticked.",
  'dokumenform.reread.match.new': 'Add as a new document',
  'dokumenform.reread.match.newHint': 'Creates a second document row with the same number.',
  'dokumenform.reread.match.go': 'Merge & read again',
  'dokumenform.reread.upload.pages': 'Pages to read',
  'dokumenform.reread.upload.pagesAll': 'Select all',
  'dokumenform.reread.upload.pagesNone': 'Clear',
  'dokumenform.reread.upload.pagesMax': 'At most {n} pages per read.',
  'dokumenform.reread.upload.pdfUnreadable': 'The PDF cannot be opened.',
  'dokumenform.reread.reading': 'JARVIS is reading…',
  'dokumenform.reread.failedTitle': 'The document could not be re-read',
  'dokumenform.reread.retry': 'Try again',
  'dokumenform.reread.error.start': 'The re-read could not start.',
  'dokumenform.reread.error.apply': 'The changes could not be applied.',
  'dokumenform.reread.ask.title': 'File replaced. Re-read this document with JARVIS?',
  'dokumenform.reread.ask.ya': 'Yes',
  'dokumenform.reread.ask.tidak': 'No',
  'dokumenform.reread.preview.title': 'Re-read preview — {jenis} {nomor}',
  'dokumenform.reread.preview.titleReading': 'Re-read document',
  'dokumenform.reread.preview.nothing': 'Nothing on this document changes the draft.',
  'dokumenform.reread.tab.barang': 'Goods',
  'dokumenform.reread.tab.header': 'Header',
  'dokumenform.reread.tab.entitas': 'Entities',
  'dokumenform.reread.tab.pengangkut': 'Transport',
  'dokumenform.reread.tab.transaksi': 'Transaction',
  'dokumenform.reread.tab.dokumen': 'Document',
  'dokumenform.reread.tab.links': 'Links',
  'dokumenform.reread.col.seri': 'Item no.',
  'dokumenform.reread.col.uraian': 'Description',
  'dokumenform.reread.col.qty': 'Quantity',
  'dokumenform.reread.col.nilai': 'Value',
  'dokumenform.reread.col.field': 'Field',
  'dokumenform.reread.col.sekarang': 'Now',
  'dokumenform.reread.col.terbaca': 'Read',
  'dokumenform.reread.col.confidence': 'Confidence',
  'dokumenform.reread.col.seriBarang': 'Goods line',
  'dokumenform.reread.col.dokumen': 'Document',
  'dokumenform.reread.col.seriIjin': 'Permit line',
  'dokumenform.reread.duplicate': 'Like goods line {n}',
  'dokumenform.reread.total.hargaBarang': 'Goods value',
  'dokumenform.reread.total.beratBersih': 'Net weight',
  'dokumenform.reread.total.beratKotor': 'Gross weight',
  'dokumenform.reread.total.freight': 'Freight',
  'dokumenform.reread.freightAdjust': 'Freight adjusted: −{removed} / +{added}',
  'dokumenform.reread.applyTotals': 'Apply totals',
  'dokumenform.reread.warning.KEMASAN_NOT_RECOMPUTED': 'Packages and containers are not recomputed.',
  'dokumenform.reread.warning.OLD_BARANG_KEPT': 'Goods from the old file are not removed automatically.',
  'dokumenform.reread.warningTitle': 'Note',
  'dokumenform.reread.apply': 'Apply ({n})',
  'dokumenform.reread.applied': '{lines} goods lines and {links} links added.',
  'dokumenform.reread.supporting.title': 'Supporting pages',
  'dokumenform.reread.supporting.note': '(not sent to CEISA)',
  'dokumenform.reread.supporting.file': 'File',
  'dokumenform.reread.supporting.halaman': 'Pages',
  'dokumenform.reread.supporting.jenis': 'Type',
  'dokumenform.reread.supporting.freight': 'Freight read',
  'dokumenform.reread.supporting.semua': 'All',
  'dokumenform.reread.supporting.pilihJenis': 'Pick a type',
  'dokumenform.reread.supporting.retype': 'Change type & re-read',
  'dokumenform.reread.readingHint': 'This usually takes 1–2 minutes. Nothing in the draft has changed yet.',
  'dokumenform.reread.fieldsHint':
    'Nothing is ticked yet — pick the read values that should replace what is there now.',
  'dokumenform.reread.tetap': 'unchanged',
  'dokumenform.reread.upload.hal': 'Pages',
  'dokumenform.reread.upload.pdfOnly': 'Only PDF files can be uploaded.',
  'dokumenform.reread.upload.hapusFile': 'Remove file',
  'dokumenform.reread.upload.needBatch': 'Draft data is not ready. Reload the page.',
  'dokumenform.reread.field.port_code': 'Port',
  'dokumenform.reread.field.pabean_office_code': 'Customs office',
  'dokumenform.reread.field.pib_type': 'PIB type',
  'dokumenform.reread.field.import_type': 'Import type',
  'dokumenform.reread.field.payment_type': 'Payment method',
  'dokumenform.reread.field.importer_identity_no': 'Importer ID number',
  'dokumenform.reread.field.importer_name': 'Importer name',
  'dokumenform.reread.field.importer_address': 'Importer address',
  'dokumenform.reread.field.owner_identity_no': 'Owner ID number',
  'dokumenform.reread.field.owner_name': 'Owner name',
  'dokumenform.reread.field.owner_address': 'Owner address',
  'dokumenform.reread.field.sender_name': 'Shipper name',
  'dokumenform.reread.field.sender_address': 'Shipper address',
  'dokumenform.reread.field.sender_country_code': 'Shipper country',
  'dokumenform.reread.field.seller_name': 'Seller name',
  'dokumenform.reread.field.seller_address': 'Seller address',
  'dokumenform.reread.field.seller_country_code': 'Seller country',
  'dokumenform.reread.field.nomor_bc11': 'BC 1.1 number',
  'dokumenform.reread.field.tanggal_tutup_pu': 'BC 1.1 date',
  'dokumenform.reread.field.nomor_pos': 'Pos number',
  'dokumenform.reread.field.nomor_subpos': 'Sub-pos number',
  'dokumenform.reread.field.cara_pengangkutan_code': 'Mode of transport',
  'dokumenform.reread.field.nama_sarana_pengangkutan': 'Vessel / carrier name',
  'dokumenform.reread.field.nomor_voy': 'Voyage / flight number',
  'dokumenform.reread.field.bendera_code': 'Flag',
  'dokumenform.reread.field.perkiraan_tanggal_tiba': 'Estimated arrival (ETA)',
  'dokumenform.reread.field.pelabuhan_muat_code': 'Port of loading',
  'dokumenform.reread.field.pelabuhan_transit_code': 'Transit port',
  'dokumenform.reread.field.pelabuhan_tujuan_code': 'Port of destination',
  'dokumenform.reread.field.tempat_penimbunan_code': 'Storage place',
  'dokumenform.reread.field.valuta_code': 'Currency',
  'dokumenform.reread.field.jenis_transaksi_code': 'Transaction type',
  'dokumenform.reread.field.incoterm_code': 'Incoterm',
  'dokumenform.reread.field.freight': 'Freight',
  'dokumenform.reread.field.kode_asuransi': 'Insurance type',
  'dokumenform.reread.field.asuransi': 'Insurance',
  'dokumenform.reread.field.nilai_asuransi': 'Insurance value',
  'dokumenform.reread.field.document_no': 'Document number',
  'dokumenform.reread.field.date': 'Document date',
  'dokumenform.reread.field.facility_code': 'Facility',
  // ---- Upload per folder (upload_folder_ux) + Review check ----
  'upload.folders.todo.needsType': 'No document type yet',
  'upload.folders.todo.junk': 'Not a shipping document?',
  'upload.folders.todo.bundle': 'Holds {n} documents — split?',
  'upload.folders.todo.belongs': 'Looks like {type} — move it?',
  'upload.folders.todo.mismatch': 'Reads as {type}, not {folder}',
  'upload.folders.todo.missingFolder': 'No file yet — required',
  'upload.folders.todoLook': 'View',
  'upload.folders.todoHint': 'Click View to go to the file, then pick an answer in its yellow box.',
  'upload.folders.todoNone': 'All files are fine',
  'upload.folders.todoTitle': 'To check ({n})',
  'upload.folders.folderAttention': '{n} to check',
  'upload.folders.attention': 'Check',
  'upload.folders.dropAllAnywhere': 'You can also drop anywhere on this page.',
  'upload.folders.emptyDrop': 'Drag PDFs here or',
  'upload.folders.BL.title': 'BL / AWB',
  'upload.folders.BL.hint': 'Bill of Lading, Master B/L, Air Waybill, Master AWB',
  'upload.folders.I.title': 'Invoice',
  'upload.folders.I.hint': 'Commercial / proforma invoice — include every page',
  'upload.folders.PL.title': 'Packing List',
  'upload.folders.PL.hint': 'Weights & packages',
  'upload.folders.COO.title': 'COO / E-COO',
  'upload.folders.COO.hint': 'Certificate of Origin (FTA facility)',
  'upload.folders.OTH.title': 'Other',
  'upload.folders.OTH.hint': 'OF, SKI, LS, permits, Excel, etc. — JARVIS detects the type',
  'upload.folders.typeAria': 'Document type',
  'upload.folders.typeOther': 'Another type… (move to Other)',
  'upload.folders.badgeSmart': 'Smart detect',
  'upload.folders.badgeDone': 'Complete',
  'upload.folders.badgeCount': '{n} file(s)',
  'upload.folders.badgeRequired': 'Required',
  'upload.folders.badgeOptional': 'Optional',
  'upload.folders.clickToPick': 'click to choose',
  'upload.folders.addMore': 'Add {folder} file',
  'upload.folders.dropHere': 'Drop here → {folder}',
  'upload.folders.dropAllTitle': 'Drop everything at once',
  'upload.folders.dropAllOr': 'or',
  'upload.folders.dropAllAi': 'JARVIS puts them in folders, you confirm.',
  'upload.folders.dropAllName': 'files go to a folder by their name, you confirm.',
  'upload.folders.dropAllLimits': 'PDF & Excel · max {n} files · {mb} MB per file · {count}/{n}',
  'upload.folders.dropOverlay': 'Drop to let JARVIS sort them — or drop right on a folder',
  'upload.folders.sorting': 'JARVIS is sorting {n} file(s){progress}…',
  'upload.folders.andMore': '+{n} more',
  'upload.folders.reading': 'JARVIS is reading…',
  'upload.folders.detected': 'JARVIS · {pct}%',
  'upload.folders.dragHint': 'Drag to another folder',
  'upload.folders.remove': 'Remove file',
  'upload.folders.openSplitter': 'Open splitter',
  'upload.folders.openSplitterHint': 'Open the page splitter — cut this file into several documents',
  'upload.folders.sortedAi': 'sorted by JARVIS {pct}%',
  'upload.folders.sortedFilename': 'sorted by file name',
  'upload.folders.mismatch': 'The content reads as {type} ({pct}%), not {folder}.',
  'upload.folders.belongs': 'Reads as {type} — this document has its own folder.',
  'upload.folders.moveTo': 'Move to {folder}',
  'upload.folders.keepIn': 'Keep in {folder}',
  'upload.folders.leaveHere': 'Leave it',
  'upload.folders.bundle': 'This file holds {n} documents:',
  'upload.folders.bundlePart': '{type} page {pages}',
  'upload.folders.unknownType': 'Type not recognised',
  'upload.folders.splitToFolders': 'Split into their folders',
  'upload.folders.keepWhole': 'Keep all as {folder}',
  'upload.folders.junk': 'This does not look like a shipping document ({pct}% sure).',
  'upload.folders.skipFile': 'Skip this file',
  'upload.folders.suggestion':
    'Page {page} mentions "{phrase}". It is still read as {folder} because it is in the {folderName} folder.',
  'upload.folders.movePageOut': 'Page {page} really is {type} → move to Other',
  'upload.folders.ok': 'OK',
  'upload.folders.readFailed': 'JARVIS could not read this file. Its type stays {folder}.',
  'upload.folders.readFailedOther': 'JARVIS could not read this file. Please pick its type.',
  'upload.folders.retry': 'Read again',
  'upload.folders.tooBigTitle': 'File too large',
  'upload.folders.tooBigMsg': 'Files can be at most {mb} MB, and empty files cannot be uploaded.',
  'upload.folders.excelToOther': 'Excel files go to the Other folder — it is the only folder that takes Excel.',
  'upload.folders.excelOnlyOther': 'Excel files can only be in the Other folder.',
  'upload.folders.moved': '{name} moved to {folder}.',
  'upload.folders.splitDone': '{name} was split into {n} documents, each in its own folder.',
  'upload.folders.pageMoved': 'Page {page} moved to Other.',
  'upload.folders.splitterTitle': 'Split pages',
  'upload.folders.checklistTitle': 'Checklist',
  'upload.folders.optional': 'optional',
  'upload.folders.excelExempt': 'not needed for an Excel upload',
  'upload.folders.continue': 'Continue to Review ({n} documents)',
  'upload.folders.reviewNext': 'Review documents ({n} not checked)',
  'upload.folders.reviewNextHint': 'Open the next document not checked yet',
  'upload.folders.readyHint': 'Next: Review (type & pages can still be changed).',
  'upload.folders.tip':
    'Wrong folder? Drag the file (grab ⋮⋮ on the left) to another folder — as often as you like, Other included — or change its Document type.',
  'upload.folders.otherTypesGroup': 'Other document types',
  'upload.folders.noTypeFound': 'No such type',
  'upload.folders.dropToMove': 'Drop to move to {folder}',
  'upload.folders.startOver': 'Start over',
  'upload.folders.reason.empty': 'Add the required documents first.',
  'upload.folders.reason.reading': 'JARVIS is still reading {n} file(s)…',
  'upload.folders.reason.allSkipped': 'Every file is skipped. Pick a type for at least one file.',
  'upload.folders.reason.needInvoice': 'An Invoice document is required',
  'upload.folders.reason.untyped': 'Pick a type for {n} file(s) in the Other folder.',
  'upload.folders.reason.pending': 'Clear the To check list above first.',
  'upload.folders.startHint':
    'Once files are in, JARVIS groups them by type and shows a preview so you can check them one by one.',
  'upload.folders.otherFolders': 'Or drop straight into a folder',
  'upload.folders.chipAdd': 'Click to add a {folder} file',
  'upload.folders.chipShow': 'Click to see the {folder} file',
  'upload.folders.preview.empty': 'Pick a document in the list on the left to see it.',
  'upload.folders.preview.waiting': 'JARVIS is reading {n} file(s). The preview appears once a file is in its folder.',
  'upload.folders.preview.excel': 'Excel files have no preview. Make sure the file name and type are right.',
  'upload.folders.preview.failed': 'The preview could not load. The file can still be uploaded.',
  'upload.folders.preview.page': 'Page {n} / {total}',
  'upload.folders.preview.prevPage': 'Previous page',
  'upload.folders.preview.nextPage': 'Next page',
  'upload.folders.preview.prev': 'Previous document',
  'upload.folders.preview.next': 'Next document',
  'upload.folders.preview.split': 'Split pages',
  'upload.folders.preview.close': 'Close preview',
  'upload.folders.view': 'View',
  'upload.folders.viewing': 'Viewing',
  'upload.folders.preview.reading': 'Wait until JARVIS has read this file.',
  'upload.folders.preview.needsType': 'Pick its document type in the list first.',
  'upload.folders.preview.skipped': 'This file is skipped and will not be uploaded.',
  'upload.folders.preview.hasWarning': 'This file has a warning in the list — answer it too before you continue.',
  'upload.folders.reason.unchecked': '{n} document(s) not checked yet.',
  'upload.folders.check.label': 'Checked',
  'upload.folders.check.tally': 'Checked {done}/{total}',
  'upload.folders.check.bar': 'Checked {done}/{total}',
  'upload.folders.check.scrollFirst': 'Click Next until every page has been seen first',
  'upload.folders.check.answerFirst': "Answer this row's warning first",
  'upload.folders.reason.unapplied': '{n} file(s) have retyped pages — click “Apply split” first.',
  'upload.folders.panelWarn.bundleTitle': 'This file holds {n} documents',
  'upload.folders.final.countDocs': '{n} document(s)',
  'upload.folders.final.note.pagesIgnored': 'pages {pages} read as {type}, left in this file',
  'upload.folders.final.note.belongs': 'reads as {type}, left in Lainnya',
  'upload.folders.panelWarn.title': 'Not a {folder} document?',
  'upload.folders.panelWarn.mismatch':
    'This file reads as {type} ({pct}%), not {folder}. Check it, and move it if it is in the wrong folder.',
  'upload.folders.panelWarn.belongs': 'This file reads as {type} ({pct}%) — that document has its own folder.',
  'upload.folders.panelWarn.junkTitle': 'Not a shipping document?',
  'upload.folders.panelWarn.junk': 'This file does not look like a shipping document ({pct}%).',
  'upload.folders.pager.prev': 'Previous',
  'upload.folders.pager.next': 'Next',
  'upload.folders.pager.seen': 'Seen {n}/{total} pages',
  'upload.folders.pageWarn.cut': 'Another document starts here',
  'upload.folders.pageWarn.text': 'Page(s) {pages} read as {type}, not a match for the {folder} folder.',
  'upload.folders.pageWarn.split': 'Split page(s) {pages}',
  'upload.folders.pageWarn.ignore': 'Leave it',
  'upload.folders.pageWarn.marked': 'Page(s) {pages} will be split off as {type}. Click “Apply split” above.',
  'upload.folders.pageWarn.undo': 'Undo',
  'upload.folders.pageWarn.dot': 'Page {n}: reads as {type}',
  'upload.folders.check.viewedWarning': "Answer the warning on this file's row first, then tick “Checked”.",
  'upload.folders.check.viewedReady': 'If this document is right, tick “Checked” under the preview.',
  'upload.folders.check.viewedTitle': "You've reached the last page",
  'upload.folders.check.blockedTitle': "Can't tick this yet",
  'upload.folders.check.cta': 'Tick if it is right',
  'upload.folders.banner.text': 'This file holds different documents: {types}. Split it?',
  'upload.folders.banner.split': 'Split as suggested',
  'upload.folders.banner.ignore': 'Leave it',
  'upload.folders.pages.marked': 'Pages retyped — this makes {n} documents.',
  'upload.folders.pages.clear': 'Cancel',
  'upload.folders.pages.apply': 'Apply split',
  'upload.folders.pages.tip': 'The type JARVIS reads for this page. Click to change it.',
  'upload.folders.pages.outTip': 'This page reads as a different type than its folder. Click to change it.',
  'upload.folders.pages.markedTip': 'Changed by you (JARVIS: {type})',
  'upload.folders.final.title': 'Check before processing',
  'upload.folders.final.perFolder': 'Per folder',
  'upload.folders.final.count': '{n} document(s) · {pages} page(s)',
  'upload.folders.final.notesTitle': 'AI notes still open ({n})',
  'upload.folders.final.note.mismatch': 'reads as {type}, kept in {folder}',
  'upload.folders.final.note.bundle': 'may hold {types}, not split',
  'upload.folders.final.note.suggestion': 'suggestion for page {page} ({type}) ignored',
  'upload.folders.final.note.splitIgnored': 'split suggestion ({types}) left as is',
  'upload.folders.final.note.pagesLeftOut': 'pages {pages} are left out',
  'upload.folders.final.aiCanErr':
    'AI can be wrong. Make sure every document is in the right folder and has all its pages.',
  'upload.folders.final.ack': 'I have checked every document',
  'upload.folders.final.back': 'Back',
  'upload.folders.final.go': 'Process',
  'review.check.title': 'Check documents',
  'review.check.subtitle': "Make sure each document's type and pages are right before JARVIS reads them.",
  'review.check.pagesHint': 'Click a page number to skip it. Hover to see the page.',
  'review.check.minOnePage': 'At least one page must stay selected.',
  'review.check.pagesCount': '{on} of {total} pages read',
  'review.check.sorted': 'Sorted by JARVIS — check again',
  'review.check.warned': 'Had a warning — check again',
  'review.check.excel': 'Excel file — included as a whole',
  'review.check.summary': '{docs} documents · {pages} pages will be read',
  'review.check.changed': '{n} change(s) since upload',
  'review.check.confirm': 'Confirm & Process',
  'review.check.processing': 'Processing…',
  'review.check.back': 'Back to folders',
  'review.check.pageLabel': 'Page {n}',
  // Jarvis 2.0 processing modal: reads waiting for room, and a failed run (next-jarvis#910).
  'processing.retry.waiting':
    'The AI service is busy right now. JARVIS keeps trying to read this document again — tried {attempt}× so far ({elapsed}). Your document is safe, please wait.',
  'processing.readFailed.highTraffic':
    '{file} could not be read after trying {attempt}× ({elapsed}). No draft was created — your documents are still saved, please process again.',
  'processing.readFailed.generic':
    '{file} could not be read. No draft was created — your documents are still saved. Check the file, then process again.',
  'processing.failed.generic':
    'Processing failed. No draft was created — your documents are still saved, please process again.',
  'processing.failed.retry': 'Process again',
  'processing.failed.back': 'Back to documents',
  'processing.elapsed.second.one': '{n} second',
  'processing.elapsed.second.other': '{n} seconds',
  'processing.elapsed.minute.one': '{n} minute',
  'processing.elapsed.minute.other': '{n} minutes',
  'processing.elapsed.join': '{minutes} {seconds}',
  'upload.errRequiredTransport': 'A BL, AWB, MBL or MAWB document is required',
  // ---- Sinkron data historis ----
  'syncHistorical.npwpMissingTitleImport': 'Importer NPWP is missing',
  'syncHistorical.npwpMissingTitleExport': 'Exporter NPWP is missing',
  'syncHistorical.npwpMissingBodyImport':
    'Historical data is matched by importer NPWP. Fill in the importer NPWP on the Entitas tab, save, then open this feature again.',
  'syncHistorical.npwpMissingBodyExport':
    'Historical data is matched by exporter NPWP. Fill in the exporter NPWP on the Entitas tab, save, then open this feature again.',

  // ---- Demo account ----
  'auth.demoEndedTitle': 'Your demo has ended',
  'auth.sessionInconsistent': 'Your session was out of sync. Please sign in again.',
  'auth.switchUserEnded': 'Your switch-user session ended.',
  'docpabean.draft.noAccess': 'This draft cannot be opened with this account.',
  'docpabean.freightUpload.ofReading.converted':
    'Read {from} {amount}, converted to {to} {converted} at the NDPBM rate ({kurs}) because the transaction currency is {to}.',
  'docpabean.freightUpload.ofReading.sameCurrency': 'Read {from} {amount}, the same as the transaction currency.',
  'docpabean.freightUpload.ofReading.kursUnavailable':
    'Read {from} {amount}, not converted to {to} because no NDPBM rate was available when the PIB was created — check the freight value.',
  'docpabean.freightUpload.ofReading.checkCurrency': 'Read {amount}; its currency needs checking.',
  'docpabean.freightUpload.ofReading.read': 'Read {amount}.',
  'docpabean.freightUpload.ofReading.kurs': '1 {code} = Rp {rate}',
  'demo.badge': 'Demo account',
  'demo.endsIn': 'ends in',
  'demo.quotaHint': 'Documents processed (extracted) out of the demo quota',
  'demo.contactSales': 'Contact sales',
  'demo.salesMessage': 'Hi, I am trying the Jarvis demo account and would like to know more.',
  'auth.demoEndedMessage': 'Thanks for trying Jarvis. Contact the Jarvis team to extend the demo or to subscribe.',

  // ---- App update ----
  'appUpdate.title': 'A new version is available',
  'appUpdate.message': 'This update is required for Jarvis to keep working correctly. Reload the page to continue.',
  'appUpdate.reload': 'Reload Now',
  'appUpdate.banner.lead': 'A new version of Jarvis is available.',
  'appUpdate.banner.detail': 'Save your work, then reload when you are ready.',
  'appUpdate.banner.reload': 'Reload',
  'appUpdate.banner.dismiss': 'Dismiss',
  'appUpdate.header.tooltip': 'New version available · click to reload',

  // ---- Settings (personal + company) ----
  'settings.title': 'Settings',
  'settings.subtitle': 'Tailor Jarvis to the way you work.',
  'settings.sectionPersonal': 'My Preferences',
  'settings.sectionCompany': 'Company Settings',
  'settings.docDetection': 'Automatic Document Type Detection',
  'settings.docDetectionDesc':
    'The system reads every uploaded document and fills in its type for you. Turn this off if you would rather pick the document type yourself.',
  'settings.docDetectionNote':
    'Applies to the PIB upload step. Guessing from the filename keeps working even with detection off.',
  'settings.docDetectionLockedNote':
    'This setting is locked by your company administrator. Contact them if you need it changed.',
  'settings.lockedByCompany': 'Locked by company',
  'settings.professionalMode': 'Professional Mode',
  'settings.professionalModeDesc': 'Hides Stamp Duty, Mini Games, and Trivia Game from the processing flow.',
  'settings.professionalModeNote': 'Switching reloads the page so the interface picks up your latest preference.',
  'settings.companyDocDetection': 'Company-wide detection default',
  'settings.companyDocDetectionDesc': 'Where detection starts for members who have never set it themselves.',
  'settings.companyLock': 'Lock this choice',
  'settings.companyLockDesc':
    'Members cannot change detection while it is locked. Their own choice is kept and takes effect again once you unlock it.',
  'settings.companyNote': 'Only company administrators see this section.',
  'settings.saveFailed': 'Could not save',
  'settings.saveFailedMsg': 'The company setting was not saved. Please try again.',
  // Language switcher
  'language.switcher': 'Language',
  'language.indonesia': 'Bahasa Indonesia',
  'language.english': 'English',
  'language.chinese': '中文',

  // Sidebar menus
  'menu.mgmtDashboard': 'Management Dashboard',
  'menu.manifest': 'Manifest',
  'menu.dashboard': 'Dashboard',
  'menu.buatAju': 'Create Declaration',
  'menu.draft': 'Draft',
  'menu.docManifes': 'Manifest Documents',
  'menu.theGuardian': 'The Guardian',
  'menu.radar': 'Radar',
  'menu.kepabeanan': 'Customs',
  'menu.docPabean': 'Customs Documents',
  'menu.monitoringBlokir': 'Block Monitoring',
  'menu.respon': 'Responses',
  'menu.databaseBarang': 'Goods Database',
  'menu.ppftz': 'PPFTZ',
  'menu.kuotaImporEkspor': 'Import / Export Quota',
  'menu.shipmentQuota': 'Shipment Quota',
  'menu.hargaReferensi': 'Reference Prices',
  'menu.cukai': 'Excise',
  'menu.tutorial': 'Tutorial',
  'menu.suratJalan': 'Delivery Note',
  'menu.dokumenCk': 'CK Documents',
  'menu.billOfMaterial': 'Bill of Material',
  'menu.inventori': 'Inventory',
  'menu.riskSelfCheck': 'Risk Self-Check',
  'menu.customerApproval': 'Customer Approval',
  'menu.approvalRequests': 'Approval Requests',
  'menu.emailGroups': 'Email Groups',
  'menu.reviewers': 'Reviewers',
  'menu.rolesPermissions': 'Roles & Permissions',
  'menu.creditTopup': 'Credit Top-up',
  'menu.langganan': 'Subscription',
  'menu.berita': 'News',
  'menu.antaraNews': 'Antara News',
  'menu.cnnIndonesia': 'CNN Indonesia',
  'menu.cnbcIndonesia': 'CNBC Indonesia',
  'menu.republikaNews': 'Republika News',
  'menu.kumparanNews': 'Kumparan News',
  'menu.voaNews': 'VOA News',
  'menu.layananLainnya': 'Other Services',
  'menu.stampDuty': 'Stamp Duty',
  'menu.miniGames': 'Mini Games',
  'menu.fileCompress': 'Compress Files',
  'menu.splitPdf': 'Split PDF',
  'menu.pengaturan': 'Settings',
  'menu.master': 'Master Data',
  'menu.ceisaUser': 'CEISA Users',
  'menu.user': 'Users',
  'menu.seaCarriers': 'Sea Carriers',
  'menu.email': 'Email',
  'menu.customerEmailForwarding': 'Customer Email Forwarding',
  'menu.statement': 'Statement',
  'menu.manifestReminder': 'Manifest Reminder',
  'menu.revokeAccess': 'Revoke Access',
  'menu.exportBank': 'Export Bank',
  'menu.riwayatPembaruan': 'Update History',

  // Sidebar badges
  'badge.new': 'New',
  'badge.bod': 'BOD',
  'badge.mulai': 'Start',
  'badge.aiReady': 'AI Ready',

  // Sidebar footer / controls
  'sidebar.manageAccount': 'Manage account',
  'sidebar.impersonate': 'Impersonate User',
  'sidebar.impersonating': 'Impersonating',
  'sidebar.changeTheme': 'Change Theme',
  'sidebar.theme': 'Theme',
  'theme.jarvis': 'JARVIS',
  'theme.jarvisNight': 'JARVIS Night',
  'theme.horizon': 'Horizon',
  'theme.horizonNight': 'Horizon Night',
  'theme.horizonDawn': 'Horizon Dawn',
  'theme.horizonDusk': 'Horizon Dusk',
  'theme.horizonMist': 'Horizon Mist',
  'sidebar.logout': 'Log out',
  'sidebar.loggingOut': 'Logging out...',
  'sidebar.collapse': 'Collapse sidebar',
  'sidebar.expand': 'Expand sidebar',
  'sidebar.quickSearch': 'Quick search...',
  'sidebar.noMatches': 'No matches',

  // Notification bell
  'notifications.bell.title': 'Notifications',
  'notifications.bell.aria': 'Email response notifications',
  'notifications.bell.markAllRead': 'Mark all as read',
  'notifications.bell.empty': 'No email responses yet',
  'notifications.bell.emptyHint': 'Incoming CEISA responses will appear here',
  'notifications.bell.loading': 'Loading notifications...',
  'notifications.bell.error': 'Failed to load notifications',
  'notifications.bell.retry': 'Try again',
  'notifications.bell.unreadCount': 'unread',
  'notifications.bell.new': 'New',
  'notifications.bell.ajuNumber': 'AJU Number',
  'notifications.bell.filterAll': 'All',
  'notifications.bell.filterUnread': 'Unread',
  'notifications.bell.emptyUnread': 'All caught up',
  'notifications.bell.emptyUnreadHint': 'No responses waiting to be opened',
  'notifications.bell.urgent': 'Urgent',
  'notifications.bell.download': 'Download',
  'notifications.bell.downloading': 'Downloading',
  'notifications.bell.downloaded': 'downloaded successfully',
  'notifications.bell.downloadFailed': 'Download failed',
  'notifications.bell.sinceLastResponse': 'since last response',
  'notifications.bell.lastResponseAt': 'Last response',
  // Entity history check — see the Indonesian block for the wording rules.
  'entitycheck.cocok': 'Matches',
  'entitycheck.perluDiperiksa': 'Please check',
  'entitycheck.tidakDicek': 'Not checked',
  'entitycheck.dariAkun': 'From your account',
  'entitycheck.samaDenganDokumen': 'Same as document',
  'entitycheck.bedaDariDokumen': 'Differs from document',
  'entitycheck.cocokDariNama': 'matched by name',
  'entitycheck.dokumen': 'Document',
  'entitycheck.dokumenSebelumnya': 'Previous document',
  'entitycheck.pakaiIni': 'Use this',
  'entitycheck.biarkanSaja': 'Keep mine',
  'entitycheck.belumAda': 'Not here yet',
  'entitycheck.tambahkan': 'Add',
  'entitasform.pilihDariRiwayat': 'Pick from document history',
  'entitasform.syncPerluDiperiksa': 'Differs from the last filing — pull the data from Jarvis',
  'entitasform.dataConsigneeSumber': 'Consignee Data',
  'entitasform.bukaDiConsignee': 'Open in Consignee Data',
  'entitasform.bukaConsignee': 'Open Consignee Data',
  'entitasform.riwayatDokumenCount': 'Document history ({count})',
  'entitasform.diperbaruiTanggal': 'Updated {date}',
  'entitasform.belumAdaDiConsignee':
    'This importer is not in Master › Consignee Data yet. Once the document is accepted by CEISA, the importer is saved there automatically as the primary source.',
  'entitasform.belumAdaDiConsigneeSingkat':
    'Not in Consignee Data yet. Saved automatically once the document is accepted by CEISA.',
  'entitasform.dataMasterTidakBisaDitandai': 'Consignee Data is managed from the Master menu, not marked wrong here.',
  'entitasform.riwayatTidakDapatDimuat': 'Document history could not be loaded',
  'entitasform.dibukaDiTabBaru': 'Opens in a new tab: Master › Consignee Data',
  'entitasform.dataConsigneeSeksi': 'CONSIGNEE DATA',
  'entitasform.consigneeTerpakai': 'Consignee data applied to Importir.',
  'entitasform.simpanKeConsignee': 'Save to Consignee Data',
  'entitasform.simpanKeConsigneeHint': 'Save this importer so it fills in automatically on the next document.',
  'entitasform.tersimpanKeConsignee': 'Saved to Consignee Data',
  'entitasform.tersimpanKeConsigneeMsg': 'This importer will now fill in from its NPWP.',
  'entitasform.consigneeSudahAda': 'This NPWP is already in Consignee Data.',
  'entitasform.gagalSimpanConsignee': 'Could not save to Consignee Data.',

  // ---- Master: Data Consignee ----
  'menu.dataConsignee': 'Consignee Data',
  'consignee.title': 'Consignee Data',
  'consignee.subtitle': 'The importers you file for. Enter once, reuse across your documents.',
  'consignee.privacyTitle': 'Only for your PPJK',
  'consignee.tabOwn': 'My PPJK',
  'consignee.tabGlobal': 'All PPJKs',
  'consignee.colPpjk': 'PPJK',
  'consignee.globalNoticeTitle': 'Internal view, read-only',
  'consignee.globalNotice':
    'Consignees of every PPJK, visible to super admins only. To add or change a consignee, work as the PPJK that owns it.',
  'consignee.globalSearchPlaceholder': 'Search consignee, NPWP or PPJK',
  'consignee.privacyBody':
    'This list is stored for {company} (NPWP {npwp}) only. It is not shared with other PPJKs, not used to train anything, and only used to fill your documents.',
  'consignee.yourPpjk': 'your PPJK',
  'consignee.noPpjkTitle': 'No PPJK NPWP yet',
  'consignee.noPpjkMsg': 'Your account is not linked to a PPJK. Contact your administrator.',
  'consignee.loadFailedTitle': 'Could not load',
  'consignee.loadFailedMsg': 'The consignee list could not be loaded. Try again shortly.',
  'consignee.searchPlaceholder': 'Search name or NPWP',
  'consignee.total': '{n} consignees',
  'consignee.template': 'Template',
  'consignee.exportCurrent': 'Download current data',
  'consignee.uploadExcel': 'Upload Excel',
  'consignee.uploadIntro':
    'Download the template, fill it in Excel, then upload it. You will see what changes before anything is saved.',
  'consignee.add': 'Add',
  'consignee.addTitle': 'Add Consignee',
  'consignee.editTitle': 'Edit Consignee',
  'consignee.emptyTitle': 'No consignees yet',
  'consignee.emptyHint': 'Add them one by one, or upload all at once from Excel.',
  'consignee.colNama': 'Consignee Name',
  'consignee.colNpwp': 'NPWP',
  'consignee.colAlamat': 'Address',
  'consignee.colNib': 'NIB',
  'consignee.colJenisApi': 'API Type',
  'consignee.colStatus': 'Status',
  'consignee.colSumber': 'Source',
  'consignee.colDiperbarui': 'Updated',
  'consignee.colAksi': 'Actions',
  'consignee.sourceExcel': 'Excel',
  'consignee.sourceManual': 'Manual',
  'consignee.sourceCeisa': 'CEISA',
  'consignee.edit': 'Edit',
  'consignee.delete': 'Delete',
  'consignee.cancel': 'Cancel',
  'consignee.save': 'Save',
  'consignee.create': 'Add',
  'consignee.unknown': 'Unknown',
  'consignee.npwpHint': '15 or 16 digits. Dots and dashes are fine, they are cleaned up automatically.',
  'consignee.npwpStoredAs': 'Will be stored as {npwp}',
  'consignee.npwpInvalid': 'NPWP must be 15 or 16 digits',
  'consignee.nibInvalid': 'NIB must be 13 digits',
  'consignee.formInvalidTitle': 'Check the form',
  'consignee.formInvalidMsg': 'Name and NPWP are required and must be valid.',
  'consignee.savedTitle': 'Saved',
  'consignee.createdMsg': 'Consignee added.',
  'consignee.updatedMsg': 'Consignee updated.',
  'consignee.existsMsg': 'This NPWP is already in your list. Edit the existing row instead of adding a new one.',
  'consignee.saveFailedTitle': 'Could not save',
  'consignee.saveFailedMsg': 'The consignee was not saved. Try again.',
  'consignee.deleteTitle': 'Delete Consignee',
  'consignee.deleteConfirm': 'Remove {nama} from your list? It will no longer appear on new documents.',
  'consignee.deletedTitle': 'Deleted',
  'consignee.deletedMsg': 'Consignee removed from the list.',
  'consignee.deleteFailedMsg': 'The consignee was not deleted. Try again.',
  'consignee.downloadFailedTitle': 'Could not download',
  'consignee.downloadFailedMsg': 'The file could not be downloaded. Try again shortly.',
  'consigneeImport.dropTitle': 'Drop the Excel file here',
  'consigneeImport.dropHint': 'One .xlsx file, up to 5,000 rows',
  'consigneeImport.chooseFile': 'Choose file',
  'consigneeImport.onlyXlsx': 'Use a single Excel (.xlsx) file made from the template.',
  'consigneeImport.reading': 'Reading {file}',
  'consigneeImport.previewFailed': 'The file could not be read',
  'consigneeImport.previewStale': 'Consignee data changed, the preview may be out of date',
  'consigneeImport.reloadPreview': 'Reload preview',
  'consigneeImport.chooseOther': 'Choose another file',
  'consigneeImport.rowsSeen': '{n} rows',
  'consigneeImport.rowLabel': 'Row {n}',
  'consigneeImport.actionNew': 'new',
  'consigneeImport.actionUpdated': 'updated',
  'consigneeImport.actionUnchanged': 'unchanged',
  'consigneeImport.actionRejected': 'skipped',
  'consigneeImport.neverDeletes':
    'An upload never deletes. Rows missing from the file are left alone; blank cells never overwrite an existing value.',
  'consigneeImport.importN': 'Import {n} rows',
  'consigneeImport.importedTitle': 'Import finished',
  'consigneeImport.importedMsg': '{new} new, {updated} updated.',
  'consigneeImport.resultLine': '{new} new, {updated} updated, {unchanged} unchanged.',
  'consigneeImport.rejectedTitle': 'Skipped rows',
  'consigneeImport.failedTitle': 'Import failed',
  'consigneeImport.failedMsg': 'Nothing was saved. Try again.',
  'consigneeImport.uploadAnother': 'Upload another file',
  'menu.dataEksportir': 'Exporter Data',
  'menu.masterBarang': 'Goods',
  'masterBarang.title': 'Goods Master',
  'masterBarang.subtitle':
    'Per-importer goods list: description → Other Specification → HS. Used only when you press "Sync Goods Master" on a draft PIB.',
  'masterBarang.importerLabel': 'Importer',
  'masterBarang.importerPlaceholder': 'Search importer name or NPWP',
  'masterBarang.importerRows': '{n} rows',
  'masterBarang.importersLoading': 'Loading importers…',
  'masterBarang.importersNone': 'No importers yet — add one with Add Consignee',
  'masterBarang.importersNoMatch': 'No matching importer',
  'masterBarang.importerMissingTitle': 'Importer {npwp} is not in the list yet',
  'masterBarang.importerMissingMsg':
    'Add it as a consignee first with Add Consignee (the NPWP is filled in), then import or add its goods.',
  'masterBarang.importerMissingNoAdd':
    'This importer is not a consignee of this PPJK yet. Add it in that PPJK’s Data Consignee first.',
  'masterBarang.addConsignee': 'Add Consignee',
  'masterBarang.ppjkLabel': 'PPJK',
  'masterBarang.ppjkPlaceholder': 'Select a PPJK',
  'masterBarang.ppjkEmpty': 'No PPJK found',
  'masterBarang.pickPpjk': 'Pick a PPJK first',
  'masterBarang.pickPpjkHint': 'The Goods Master is kept per PPJK. Pick the PPJK to manage.',
  'masterBarang.backfill': 'Backfill AJU history',
  'masterBarang.backfillHint': "Staff only: learn items from this importer's PIBs of the last 365 days",
  'masterBarang.backfillDoneTitle': 'Backfill done',
  'masterBarang.backfillDoneMsg': '{processes} PIBs read: {rowsInserted} new rows, {rowsSeen} already there',
  'masterBarang.backfillFailedTitle': 'Backfill failed',
  'masterBarang.backfillFailedMsg': 'Backfilling the AJU history failed. Try again.',
  'masterBarang.addConsigneeTitle': 'Add Consignee',
  'masterBarang.addConsigneeIntro': 'The new consignee is saved to Data Consignee and picked as the importer here.',
  'masterBarang.addConsigneeCreated': 'Consignee {npwp} added and picked.',
  'masterBarang.addConsigneeExists': 'NPWP {npwp} is already in Data Consignee — picked it.',
  'masterBarang.pickImporter': 'Pick an importer to see its Goods Master',
  'masterBarang.pickImporterHint':
    'Each importer has its own goods list. Not in the list? Add it with the Add Consignee button.',
  'masterBarang.total': '{n} items',
  'masterBarang.template': 'Template',
  'masterBarang.export': 'Export',
  'masterBarang.uploadExcel': 'Import Excel',
  'masterBarang.add': 'Add Item',
  'masterBarang.searchPlaceholder': 'Search description, Other Specification or HS',
  'masterBarang.sourceAll': 'All sources',
  'masterBarang.sourceManual': 'Manual',
  'masterBarang.sourceImport': 'Excel Import',
  'masterBarang.sourceSubmission': 'AJU History',
  'masterBarang.conflictOnly': 'Conflicts only',
  'masterBarang.help.button': 'How to use',
  'masterBarang.help.title': 'How to use the Goods Master',
  'masterBarang.help.intro':
    'The Goods Master keeps a goods list per importer. Uploading documents fills nothing from it: you press "Sync Goods Master" on a draft PIB, then goods are matched by Uraian (not by HS) and the Master code fills their Other Specification and HS.',
  'masterBarang.help.gifAlt':
    'Example: Sync Goods Master on a draft PIB — goods are matched by Uraian; the same HS with another Uraian stays "Not in Master"',
  'masterBarang.help.step1': 'Add Consignee (the importer) if it is not in the list yet, then pick the importer.',
  'masterBarang.help.step2':
    'Download the Template or Import Excel with columns Description | Other Specification | HS Code, check the preview, then click Import.',
  'masterBarang.help.step3': 'Turn on "Conflicts only" to see codes that have more than one HS.',
  'masterBarang.help.step4':
    'On a draft PIB, open the Goods tab → "Sync Goods Master" → pick the importer → Sync. Goods are matched by Uraian, not by HS: the code fills Other Specification and the HS. Exact matches are filled at once and keep their Uraian; items holding every word of the Master Uraian are reviewed first (Change = Master Uraian, extra words removed / Keep).',
  'masterBarang.help.step5':
    'Green dot = matched; yellow = check, then Confirm; "Pick a code" = choose from the candidates; red = the Uraian matches but the HS differs — choose "Uraian is right" or "Keep" (document HS); grey = "Not in Master" (the same HS alone is not a match).',
  'masterBarang.help.close': 'Got it',
  'masterBarang.conflictNameMultiCode': 'This name has >1 code',
  'masterBarang.conflictCodeMultiHs': 'This code has >1 HS',
  'masterBarang.colUraian': 'Description',
  'masterBarang.colSpesifikasiLain': 'Other Specification',
  'masterBarang.colHs': 'HS Code',
  'masterBarang.colSumber': 'Source',
  'masterBarang.colDipakai': 'Used',
  'masterBarang.colAksi': 'Actions',
  'masterBarang.seenCount': '{n}×',
  'masterBarang.relative.justNow': 'just now',
  'masterBarang.relative.minutes': '{n} min ago',
  'masterBarang.relative.hours': '{n} h ago',
  'masterBarang.relative.days': '{n} days ago',
  'masterBarang.relative.months': '{n} months ago',
  'masterBarang.relative.years': '{n} years ago',
  'masterBarang.emptyTitle': 'No items for this importer yet',
  'masterBarang.emptyHint': 'Add them one by one or import from Excel.',
  'masterBarang.emptyFiltered': 'No items match the filter',
  'masterBarang.loadFailedTitle': 'Could not load the Goods Master',
  'masterBarang.loadFailedMsg': 'Try reloading the page.',
  'masterBarang.noPpjkTitle': 'PPJK NPWP not found',
  'masterBarang.noPpjkMsg': 'The Goods Master is kept per PPJK. Sign in with a PPJK account to manage it.',
  'masterBarang.addTitle': 'Add Item',
  'masterBarang.editTitle': 'Edit Item',
  'masterBarang.forImporter': 'Importer: {npwp}',
  'masterBarang.editHint': 'Editing makes this row Manual — an import will not overwrite it',
  'masterBarang.hsHint': '8-digit HS, dots allowed (3903.30.90)',
  'masterBarang.hsInvalid': 'HS must be 8 digits',
  'masterBarang.required': 'Required',
  'masterBarang.cancel': 'Cancel',
  'masterBarang.save': 'Save',
  'masterBarang.create': 'Add',
  'masterBarang.formInvalidTitle': 'Incomplete',
  'masterBarang.formInvalidMsg': 'Fill in Description, Other Specification and an 8-digit HS.',
  'masterBarang.savedTitle': 'Saved',
  'masterBarang.createdMsg': 'Item added to the Goods Master.',
  'masterBarang.updatedMsg': 'Item updated; its source is now Manual.',
  'masterBarang.existsMsg': 'An item with the same description, code and HS already exists.',
  'masterBarang.saveFailedTitle': 'Could not save',
  'masterBarang.saveFailedMsg': 'The item was not saved. Try again.',
  'masterBarang.deleteTitle': 'Delete item',
  'masterBarang.deleteConfirm': 'Delete "{uraian}" ({kode}) from the Goods Master? Jarvis will no longer use it. You can restore it from Deleted history.',
  'masterBarang.delete': 'Delete',
  'masterBarang.edit': 'Edit',
  'masterBarang.deletedTitle': 'Deleted',
  'masterBarang.deletedMsg': 'Item removed from the Goods Master.',
  'masterBarang.deleteFailedMsg': 'The item was not deleted. Try again.',
  'masterBarang.viewActive': 'Active',
  'masterBarang.viewDeleted': 'Deleted history',
  'masterBarang.selectedCount': '{n} selected',
  'masterBarang.selectAllMatching': 'Select all {n} items',
  'masterBarang.allMatchingSelected': 'All {n} matching items selected',
  'masterBarang.clearSelection': 'Clear selection',
  'masterBarang.deleteSelected': 'Delete selected',
  'masterBarang.bulkDeleteTitle': 'Delete {n} items',
  'masterBarang.bulkDeleteConfirm': '{n} items will be removed from the Goods Master and no longer used by Sync. You can restore them from Deleted history.',
  'masterBarang.bulkDeleteAllNote': 'These are all items matching the current search and filters, not only this page.',
  'masterBarang.bulkDeletedMsg': '{n} items deleted. See them in Deleted history.',
  'masterBarang.selectionChangedTitle': 'The number of items changed',
  'masterBarang.selectionChangedMsg': '{n} items match now. Nothing was changed; check again and retry.',
  'masterBarang.history.intro': 'Deleted items are not used by Sync. Restore them to use them again. Every delete and restore is recorded in the Activity log.',
  'masterBarang.history.tabDeleted': 'Deleted items',
  'masterBarang.history.tabLog': 'Activity log',
  'masterBarang.history.colDeleted': 'Deleted',
  'masterBarang.history.beforeLog': 'Before the log started',
  'masterBarang.history.restore': 'Restore',
  'masterBarang.history.restoreSelected': 'Restore selected',
  'masterBarang.history.restoreTitle': 'Restore {n} items',
  'masterBarang.history.restoreConfirm': '{n} items go back to the Goods Master and are used by Sync again. An item whose Description, Other Specification and HS already exist in the Master is not restored, so nothing is duplicated.',
  'masterBarang.history.restoredMsg': '{n} items restored.',
  'masterBarang.history.skippedTitle': '{n} items not restored',
  'masterBarang.history.skippedDuplicate': 'Already in the Goods Master: {list}',
  'masterBarang.history.restoreFailedMsg': 'The items were not restored. Try again.',
  'masterBarang.history.empty': 'No items have been deleted',
  'masterBarang.history.emptyFiltered': 'No deleted items match',
  'masterBarang.history.logEmpty': 'No delete or restore activity yet',
  'masterBarang.history.searchPlaceholder': 'Search description, Other Specification or HS',
  'masterBarang.history.colTime': 'Time',
  'masterBarang.history.colAction': 'Action',
  'masterBarang.history.colVia': 'How',
  'masterBarang.history.colBy': 'By',
  'masterBarang.history.actionAll': 'All actions',
  'masterBarang.history.actionDelete': 'Deleted',
  'masterBarang.history.actionRestore': 'Restored',
  'masterBarang.history.via.single': 'One row',
  'masterBarang.history.via.bulk': 'Bulk',
  'masterBarang.history.via.import': 'Excel import',
  'masterBarang.history.via.edit': 'Item edit',
  'masterBarang.history.via.create': 'Item added',
  'masterBarang.history.batchOf': '{n} items at once',
  'masterBarang.history.unknownUser': 'Unknown',
  'masterBarang.downloadFailedTitle': 'Download failed',
  'masterBarang.downloadFailedMsg': 'The file was not downloaded. Try again.',
  'masterBarang.uploadIntro':
    'Every row in the file goes into the Goods Master of importer {npwp}. Columns: Uraian Barang, Spesifikasi Lain, HS Code.',
  'masterBarangImport.dropTitle': 'Drop the Excel file here',
  'masterBarangImport.dropHint': '.xlsx with columns Uraian Barang, Spesifikasi Lain, HS Code',
  'masterBarangImport.chooseFile': 'Choose file',
  'masterBarangImport.onlyXlsx': 'Only .xlsx files can be imported.',
  'masterBarangImport.reading': 'Reading {file}…',
  'masterBarangImport.previewFailed': 'The file could not be read',
  'masterBarangImport.failedTitle': 'Import failed',
  'masterBarangImport.failedMsg': 'Try again or check the file format.',
  'masterBarangImport.chooseOther': 'Choose another file',
  'masterBarangImport.previewStale': 'This importer’s Goods Master changed after the preview was made.',
  'masterBarangImport.reloadPreview': 'Reload preview',
  'masterBarangImport.rowsSeen': '{n} rows read',
  'masterBarangImport.summary.new': '{n} new',
  'masterBarangImport.summary.unchanged': '{n} unchanged',
  'masterBarangImport.summary.reactivated': '{n} reactivated',
  'masterBarangImport.summary.skipped': '{n} skipped',
  'masterBarangImport.summary.duplicatesCollapsed': '{n} duplicates merged',
  'masterBarangImport.noIssues': 'No warnings.',
  'masterBarangImport.examplesNote': 'Up to 50 examples.',
  'masterBarangImport.issue.HS_TRUNCATED': '10-digit HS cut to 8 digits',
  'masterBarangImport.issue.HS_NOT_IN_BTKI': 'HS not in BTKI (still imported)',
  'masterBarangImport.issue.HS_INVALID': 'Invalid HS (skipped)',
  'masterBarangImport.issue.ROW_INCOMPLETE': 'Description or Other Specification empty (skipped)',
  'masterBarangImport.issue.NAME_MULTI_CODE': 'This name has >1 code',
  'masterBarangImport.issue.CODE_MULTI_HS': 'This code has >1 HS',
  'masterBarangImport.colRow': 'Row',
  'masterBarangImport.colRaw': 'Original value',
  'masterBarangImport.colHsCodes': 'HS',
  'masterBarangImport.neverDeletes':
    'An import never deletes rows missing from the file and never overwrites Manual rows.',
  'masterBarangImport.importN': 'Import {n} rows',
  'masterBarangImport.importedTitle': 'Import done',
  'masterBarangImport.importedMsg': '{inserted} new rows, {reactivated} reactivated.',
  'masterBarangImport.resultLine':
    '{inserted} new rows, {reactivated} reactivated, {promoted} AJU History rows promoted to Excel Import.',
  'masterBarangImport.uploadAnother': 'Import another file',
  'masterMatch.chipExact': 'Master',
  'masterMatch.chipFuzzy': 'All Master words found · check',
  'masterMatch.chipAmbiguous': 'Pick a code',
  'masterMatch.chipNone': 'Not in Master',
  'masterMatch.chipPicked': 'Picked from Master',
  'masterMatch.chipHs': 'HS match · check',
  'masterMatch.chipConflict': 'Uraian & HS differ — choose',
  'masterMatch.chipTooltip': 'Other Specification source: Goods Master',
  'masterMatch.popoverExact': 'Filled from the Goods Master',
  'masterMatch.beforeTitle': 'Before the master filled it',
  'masterMatch.popoverPicked': 'Picked from the Goods Master',
  'masterMatch.popoverFuzzy': 'Filled from a Goods Master row whose words are all in the Uraian — check it',
  'masterMatch.popoverAmbiguous': 'Pick a code from the Goods Master',
  'masterMatch.popoverNone': 'Not in the Goods Master',
  'masterMatch.popoverHs': 'Filled from a Goods Master code with the same HS — check it',
  'masterMatch.popoverConflict':
    'The Uraian matches the Goods Master, but its HS differs from the document — choose which is right',
  'masterMatch.conflictDocumentHs': 'Document: HS {hs}',
  'masterMatch.conflictUraianRight': 'Uraian is right',
  'masterMatch.conflictKeep': 'Keep — use the document HS',
  'masterMatch.conflictHint':
    'Uraian is right: Other Specification gets the Master code, the Master HS is used and the tariffs re-synced. Keep: the document HS and Uraian stay; the item is not changed.',
  'masterMatch.noneBody': 'This description is not in the importer’s Goods Master yet.',
  'masterMatch.addToMaster': 'Add to Goods Master',
  'masterMatch.noRows': 'The Goods Master row was not found.',
  'masterMatch.ambiguousHint': 'This name has more than one code in the Goods Master. Pick the right one.',
  'masterMatch.ambiguousHsHint':
    'The Uraian did not match; this HS has several codes in the Goods Master. Pick the right one.',
  'masterMatch.hsHint': 'The Uraian did not match the Goods Master, so the code was chosen by HS.',
  'masterMatch.viaHs': 'via HS',
  'masterMatch.applied': 'In use',
  'masterMatch.pick': 'Pick',
  'masterMatch.confirm': 'Confirm',
  'masterMatch.confirmHint': 'Confirm marks this row as checked — the chip turns green',
  'masterMatch.candidatesCount': '{n} candidates',
  'masterMatch.pickedTitle': 'Picked from Master',
  'masterMatch.pickedMsg': 'Other Specification filled from the Goods Master.',
  'masterMatch.pickedHsMsg':
    'Other Specification and HS filled from the Goods Master. The new HS tariffs were synced — save to keep them.',
  'masterMatch.keptTitle': 'Document data kept',
  'masterMatch.keptMsg': 'This item was not changed: the document HS and Uraian stay. Later syncs leave it alone.',
  'masterMatch.pickFailedTitle': 'Could not pick',
  'masterMatch.pickFailed': 'The Goods Master row could not be used. Try again.',
  'masterMatch.pickNoLine': 'Save this item first, then pick from the Goods Master.',
  'masterMatch.hsMasterApplied': 'HS from the Goods Master (document: {hs})',
  'masterMatch.hsKeptMultiHs': 'This code has >1 HS in the Goods Master — the document HS is used',
  'masterMatch.hsKeptNotBtki': 'The Goods Master HS is not in BTKI — the document HS is used',
  'masterMatch.hsMasterAppliedNoDocument': 'HS from the Goods Master (the documents give no HS)',
  'masterMatch.hsKeptMultiHsPick': 'This code has >1 HS in the Goods Master — pick the HS:',
  'masterMatch.hsKeptMultiHsNoDocument': 'This code has >1 HS in the Goods Master — enter the HS manually',
  'masterMatch.hsKeptNotBtkiNoDocument': 'The Goods Master HS is not in BTKI — enter the HS manually',
  'masterMatch.hsConflict': 'The document HS differs from the Goods Master — choose in the Other Specification chip',
  'masterMatch.hsConflictManual': 'The document HS differs from the Goods Master HS for this code',
  'masterMatch.useMasterHs': 'Use Master HS {hs}',
  'masterMatch.hsChoiceTitle': 'Goods Master HS used',
  'masterMatch.useDocumentHs': 'Use document HS',
  'masterMatch.documentHsTitle': 'Document HS used',
  'masterMatch.documentHsMsg': 'HS {hs} set and its tariffs synced. Save to apply.',
  'masterMatch.openInDrawer': 'Open in Edit Goods',
  'masterMatch.pickedHsTableMsg': 'Other Specification and HS filled from the Goods Master, with the tariffs synced.',
  'masterMatch.filterActive': 'Goods Master: showing {n} items to check',
  'masterMatch.filterLoading': 'Loading the items to check…',
  'masterMatch.filterFailed': 'The items to check could not be loaded.',
  'masterMatch.filterClear': 'Show all items',
  'masterMatch.syncButton': 'Sync Goods Master',
  'masterMatch.syncTitle': 'Sync Goods Master',
  'masterMatch.syncIntro':
    "Match each item against the importer's Goods Master by Uraian (or the code in it), never by HS: the Master code goes into Other Specification and the HS is filled. Exact match: the Uraian stays. All Master words in the Uraian (any order, extra words allowed): reviewed first — Change takes the Master Uraian and removes the extra words, Keep leaves the item. Brand and Type are not changed. Items whose Uraian matches nothing are not filled, and items whose Other Specification is already filled are never overwritten.",
  'masterMatch.syncImporterLabel': 'Importer / consignee',
  'masterMatch.syncImporterPlaceholder': 'Pick an importer',
  'masterMatch.syncNoImporters': 'No importers in the Goods Master yet.',
  'masterMatch.syncNoImportersLink': 'Add a consignee & import goods in the Goods Master →',
  'masterMatch.syncImporterMissing': 'This draft’s importer is not in the Goods Master yet — add it with Add Consignee',
  'masterMatch.syncNoRows': 'This importer has no Goods Master rows yet.',
  'masterMatch.syncOpenMaster': 'Open Goods Master',
  'masterMatch.syncSubmit': 'Sync',
  'masterMatch.syncErrorTitle': 'Sync failed',
  'masterMatch.syncErrorEmpty': 'This importer has no Goods Master rows. Add or import them in the Goods Master first.',
  'masterMatch.syncErrorUnavailable': 'Jarvis could not be reached, try again',
  'masterMatch.syncErrorDbBusy': 'The staging database is full right now, try again in a moment.',
  'masterMatch.syncErrorServer': 'The server is having problems (502), try again in a moment.',
  'masterMatch.syncErrorTooLarge': "This importer's Goods Master is too large (>50,000 rows) to sync",
  'masterMatch.syncErrorPibOnly': 'Goods Master sync is for PIB only',
  'masterMatch.syncFailed': 'Goods Master sync failed. Try again.',
  'masterMatch.syncHeadline': '{filled} of {total} items filled from the Goods Master',
  'masterMatch.syncMasterRows': 'Goods Master {npwp}: {n} rows',
  'masterMatch.syncSectionLines': 'Other Specification',
  'masterMatch.syncSectionHs': 'HS',
  'masterMatch.syncFilledExact': 'Filled — exact match',
  'masterMatch.syncFilledFuzzy': 'Filled — all Master words found, check it',
  'masterMatch.syncAmbiguous': 'Needs a code picked',
  'masterMatch.syncConflict': 'Uraian & HS differ — needs a choice',
  'masterMatch.syncNone': 'Not in the Goods Master',
  'masterMatch.syncSkippedFilled': 'Already filled, kept',
  'masterMatch.syncHsAgree': 'HS matches the document',
  'masterMatch.syncHsMasterApplied': 'HS from the Goods Master (differs from the document)',
  'masterMatch.syncHsKeptMultiHs': 'Document HS kept — code has >1 HS',
  'masterMatch.syncHsKeptNotBtki': 'Document HS kept — master HS not in BTKI',
  'masterMatch.syncReview': 'Show items to check',
  'masterMatch.syncClose': 'Close',
  'masterMatch.syncKept': 'Kept — not changed',
  'masterMatch.syncPending': 'Not chosen — not changed',
  'masterMatch.syncReviewTitle': 'Review the changes before saving',
  'masterMatch.syncReviewCount':
    '{n} items are not an exact match — check them first. Nothing is saved yet — pick Change or Keep per item.',
  'masterMatch.syncAutoApplyCount': '{n} exact matches will be changed right away',
  'masterMatch.syncAutoApplyShow': 'Show',
  'masterMatch.syncAutoApplyHide': 'Hide',
  'masterMatch.syncFuzzyWarning':
    'All Master words are in the Uraian, but it is not exact — the other words will be removed, check it first',
  'masterMatch.syncHsMoveWarning': 'The HS will be replaced from the Goods Master (tariff is updated too)',
  'masterMatch.syncKindExact': 'Exact match',
  'masterMatch.syncKindFuzzy': 'All Master words are in the Uraian',
  'masterMatch.syncRemovedWords': 'Removed:',
  'masterMatch.syncKindHsMove': 'HS from the Master',
  'masterMatch.syncKindOther': 'From the Goods Master',
  'masterMatch.syncSeri': 'Item {n}',
  'masterMatch.syncFieldUraian': 'Uraian',
  'masterMatch.syncFieldSpesifikasiLain': 'Spesifikasi Lain',
  'masterMatch.syncFieldHs': 'HS',
  'masterMatch.syncFieldKodeBarang': 'Item code',
  'masterMatch.syncFieldUkuran': 'Size',
  'masterMatch.syncFieldMerk': 'Brand',
  'masterMatch.syncFieldTipe': 'Type',
  'masterMatch.syncEmptyValue': '(empty)',
  'masterMatch.syncCleared': '(cleared)',
  'masterMatch.syncRetariff': 'tariff is updated too',
  'masterMatch.syncChoiceAccept': 'Change',
  'masterMatch.syncChoiceKeep': 'Keep',
  'masterMatch.syncAcceptAll': 'Change all',
  'masterMatch.syncKeepAll': 'Keep all',
  'masterMatch.syncChoiceLabel': 'Choice for item {n}',
  'masterMatch.syncApply': 'Apply ({n} changed)',
  'submitsummary.masterBarang.title': 'Goods Master: {n} items to check',
  'submitsummary.masterBarang.body':
    'A code or HS from the Goods Master needs a look: no code picked, not in the Master, a word match (not exact), or the Master HS differs from the document. This does not block the submit.',
  'submitsummary.masterBarang.open': 'Show items',
  'eksportir.title': 'Exporter Data',
  'eksportir.subtitle': 'The exporters you file for. Enter once, reuse across your PEB documents.',
  'eksportir.privacyTitle': 'Only for your PPJK',
  'eksportir.tabOwn': 'My PPJK',
  'eksportir.tabGlobal': 'All PPJKs',
  'eksportir.colPpjk': 'PPJK',
  'eksportir.globalNoticeTitle': 'Internal view, read-only',
  'eksportir.globalNotice':
    'Exporters of every PPJK, visible to super admins only. To add or change an exporter, work as the PPJK that owns it.',
  'eksportir.globalSearchPlaceholder': 'Search exporter, identity number or PPJK',
  'eksportir.privacyBody':
    'This list is stored for {company} (NPWP {npwp}) only. It is not shared with other PPJKs, not used to train anything, and only used to fill your documents.',
  'eksportir.yourPpjk': 'your PPJK',
  'eksportir.noPpjkTitle': 'No PPJK NPWP yet',
  'eksportir.noPpjkMsg': 'Your account is not linked to a PPJK. Contact your administrator.',
  'eksportir.loadFailedTitle': 'Could not load',
  'eksportir.loadFailedMsg': 'The exporter list could not be loaded. Try again shortly.',
  'eksportir.searchPlaceholder': 'Search name or identity number',
  'eksportir.total': '{n} exporters',
  'eksportir.template': 'Template',
  'eksportir.exportCurrent': 'Download current data',
  'eksportir.uploadExcel': 'Upload Excel',
  'eksportir.uploadIntro':
    'Download the template, fill it in Excel, then upload it. You will see what changes before anything is saved.',
  'eksportir.add': 'Add',
  'eksportir.addTitle': 'Add Exporter',
  'eksportir.editTitle': 'Edit Exporter',
  'eksportir.emptyTitle': 'No exporters yet',
  'eksportir.emptyHint': 'Add them one by one, or upload all at once from Excel.',
  'eksportir.colNama': 'Exporter Name',
  'eksportir.colIdentitas': 'Identity',
  'eksportir.colJenisIdentitas': 'Identity Type',
  'eksportir.colNomorIdentitas': 'Identity Number',
  'eksportir.colAlamat': 'Address',
  'eksportir.colStatus': 'Status',
  'eksportir.colSumber': 'Source',
  'eksportir.colDiperbarui': 'Updated',
  'eksportir.colAksi': 'Actions',
  'eksportir.sourceExcel': 'Excel',
  'eksportir.sourceManual': 'Manual',
  'eksportir.sourceCeisa': 'CEISA',
  'eksportir.edit': 'Edit',
  'eksportir.delete': 'Delete',
  'eksportir.cancel': 'Cancel',
  'eksportir.save': 'Save',
  'eksportir.create': 'Add',
  'eksportir.unknown': 'Unknown',
  'eksportir.namaPlaceholder': 'PT. EXAMPLE',
  'eksportir.npwpHint': '15 or 16 digits. Dots and dashes are fine, they are cleaned up automatically.',
  'eksportir.identitasHint': 'Digits only. Anything else is removed automatically.',
  'eksportir.identitasStoredAs': 'Will be stored as {nomor}',
  'eksportir.npwpInvalid': 'NPWP must be 15 or 16 digits',
  'eksportir.ktpInvalid': 'KTP must be 16 digits',
  'eksportir.identitasEmpty': 'The identity number must contain digits',
  'eksportir.identitasTooLong': 'The identity number can have at most 50 digits',
  'eksportir.formInvalidTitle': 'Check the form',
  'eksportir.formInvalidMsg': 'Name and identity number are required and must be valid.',
  'eksportir.savedTitle': 'Saved',
  'eksportir.createdMsg': 'Exporter added.',
  'eksportir.updatedMsg': 'Exporter updated.',
  'eksportir.existsMsg': 'This identity is already in your list. Edit the existing row instead of adding a new one.',
  'eksportir.saveFailedTitle': 'Could not save',
  'eksportir.saveFailedMsg': 'The exporter was not saved. Try again.',
  'eksportir.deleteTitle': 'Delete Exporter',
  'eksportir.deleteConfirm': 'Remove {nama} from your list? It will no longer appear on new documents.',
  'eksportir.deletedTitle': 'Deleted',
  'eksportir.deletedMsg': 'Exporter removed from the list.',
  'eksportir.deleteFailedMsg': 'The exporter was not deleted. Try again.',
  'eksportir.downloadFailedTitle': 'Could not download',
  'eksportir.downloadFailedMsg': 'The file could not be downloaded. Try again shortly.',
  'eksportir.jenis.2': 'PASSPORT',
  'eksportir.jenis.3': 'KTP',
  'eksportir.jenis.4': 'OTHER',
  'eksportir.jenis.5': 'NPWP 15 DIGITS',
  'eksportir.jenis.6': 'NPWP 16 DIGITS',
  'eksportir.jenis.npwp': 'NPWP',
  'eksportir.status.1': 'COOPERATIVE',
  'eksportir.status.2': 'PMDN (OIL & GAS)',
  'eksportir.status.3': 'PMDN (NON OIL & GAS)',
  'eksportir.status.4': 'PMA (OIL & GAS)',
  'eksportir.status.5': 'PMA (NON OIL & GAS)',
  'eksportir.status.6': 'BUMN',
  'eksportir.status.7': 'BUMD',
  'eksportir.status.8': 'PRIVATE',
  'eksportir.status.9': 'JOINT VENTURE',
  'eksportir.status.10': 'OTHER',
  'eksportirImport.dropTitle': 'Drop the Excel file here',
  'eksportirImport.dropHint': 'One .xlsx file, up to 5,000 rows',
  'eksportirImport.chooseFile': 'Choose file',
  'eksportirImport.onlyXlsx': 'Use a single Excel (.xlsx) file made from the template.',
  'eksportirImport.reading': 'Reading {file}',
  'eksportirImport.previewFailed': 'The file could not be read',
  'eksportirImport.previewStale': 'Exporter data changed, the preview may be out of date',
  'eksportirImport.reloadPreview': 'Reload preview',
  'eksportirImport.chooseOther': 'Choose another file',
  'eksportirImport.rowsSeen': '{n} rows',
  'eksportirImport.rowLabel': 'Row {n}',
  'eksportirImport.actionNew': 'new',
  'eksportirImport.actionUpdated': 'updated',
  'eksportirImport.actionUnchanged': 'unchanged',
  'eksportirImport.actionRejected': 'skipped',
  'eksportirImport.neverDeletes':
    'An upload never deletes. Rows missing from the file are left alone; blank cells never overwrite an existing value.',
  'eksportirImport.importN': 'Import {n} rows',
  'eksportirImport.importedTitle': 'Import finished',
  'eksportirImport.importedMsg': '{new} new, {updated} updated.',
  'eksportirImport.resultLine': '{new} new, {updated} updated, {unchanged} unchanged.',
  'eksportirImport.rejectedTitle': 'Skipped rows',
  'eksportirImport.failedTitle': 'Import failed',
  'eksportirImport.failedMsg': 'Nothing was saved. Try again.',
  'eksportirImport.uploadAnother': 'Upload another file',
  'eksportirCard.dataEksportir': 'Exporter Data',
  'eksportirCard.dibukaDiTabBaru': 'Opens in a new tab: Master › Exporter Data',
  'eksportirCard.belumAda':
    'Not in Exporter Data yet. Saved automatically once the document is sent to CEISA successfully.',
  'eksportirCard.buka': 'Open Exporter Data',
  'eksportirCard.simpan': 'Save to Exporter Data',
  'eksportirCard.simpanHint': 'Save this exporter so it fills in automatically on the next documents.',
  'eksportirCard.tersimpan': 'Saved to Exporter Data',
  'eksportirCard.tersimpanMsg': 'This exporter will now fill in automatically from its identity number.',
  'eksportirCard.sudahAda': 'This identity is already in Exporter Data.',
  'eksportirCard.gagalSimpan': 'Could not save to Exporter Data.',
  'eksportirCard.diterapkanTitle': 'Applied',
  'eksportirCard.diterapkanMsg': 'Exporter Data applied to the Exporter card.',
  'statement.updatedBy': 'Updated by {email} on {date}',
  'statement.utama': 'Primary',
  'pernyataanform.notifyNoStatementTitle': 'No Pernyataan set up',
  'pernyataanform.notifyNoStatementMessage':
    'Your PPJK has no Pernyataan yet. Fill it in under Master → Pernyataan, then sync again.',
  'statement.tabOwn': 'My PPJK',
  'statement.tabGlobal': 'All PPJKs',
  'statement.staleSessionTitle': "Your account's PPJK has changed",
  'statement.staleSessionMsg':
    'This browser still holds your old PPJK ({stored}). Your account is now linked to {current}, which is what this tab shows and what your drafts use. Log out and back in so the rest of the app follows.',
  'statement.jadikanUtama': 'Make primary',
  'statement.jadikanUtamaBerhasil': '{name} is now the primary statement for new drafts.',
  'statement.jadikanUtamaGagal': 'Could not make it primary',
  'statement.nonaktifkanUtamaJudul': 'Deactivate the primary statement?',
  'statement.nonaktifkanUtamaPesan':
    'The earliest other active statement becomes primary for new drafts automatically.',
  'statement.nonaktifkanUtamaTanpaPengganti':
    'There is no other active statement. New drafts will not get a statement filled in automatically.',
  'statement.nonaktifkan': 'Deactivate',
  'statement.batal': 'Cancel',
  'statement.konflikJudul': 'A colleague just updated this statement',
  'statement.konflikDiperbaruiOleh': 'Updated by {email} on {date}',
  'statement.konflikDiperbaruiPada': 'Updated on {date}',
  'statement.kolomTempat': 'Place',
  'statement.kolomNama': 'Name',
  'statement.kolomJabatan': 'Position',
  'statement.konflikMuatUlang': 'Reload',
  'statement.konflikTimpa': 'Overwrite',
  'statement.konflikGagalMemuat': 'The latest values could not be loaded.',
  'statement.konflikMuatUlangDaftar': 'Reload list',
  'pernyataanform.pilihPernyataan': 'Choose statement',
  'pernyataanform.pilihPernyataanPlaceholder': 'Choose from Master › Statement',
  'pernyataanform.diubahManual': 'Current values were edited manually',
  'settings.sectionTampilan': 'Appearance',
  'settings.theme': 'Theme',
  'settings.themeDesc': 'App colours. Applies to your account only.',
  'settings.language': 'Language',
  'settings.languageDesc': 'Language of menus and app text.',
  'settings.textSize': 'Text size',
  'settings.textSizeDesc': 'Enlarge text and buttons across the app.',
  'settings.textSizeNormal': 'Normal',
  'settings.textSizeLarge': 'Large',
  'settings.textSizeLarger': 'Larger',
  'settings.textSizePreview':
    'Example: Nomor Aju 000020-001234-20260915-000041, Importer PT. CEMANI TOKA, Status SPPB.',
  'settings.textSizeNote': 'Changes apply immediately. Some dense tables feel tighter at the largest size.',

  // ---- Dok Pabean declaration PDF preview (table action) ----
  // New user-facing surface, so it is filled in here rather than falling back.
  'docpabean.tooltipPreviewPdf': 'Preview PDF',
  'docpabean.tooltipPreviewPdfNoAju': 'No AJU number yet',
  'docpabean.pdfPreview.title': '{doc} Preview',
  'docpabean.pdfPreview.kindFinal': 'Final (NOPEN)',
  'docpabean.pdfPreview.kindDraft': 'CEISA Draft',
  'docpabean.pdfPreview.fallbackTitle': 'Final document not available yet',
  'docpabean.pdfPreview.fallbackBody':
    'This document already has an NPE/SPPB, but the final form could not be fetched from CEISA. Showing the CEISA draft instead.',
  'docpabean.pdfPreview.loading': 'Fetching the document from CEISA…',
  'docpabean.pdfPreview.loadingHint':
    'If the document has not been generated before, CEISA needs time to prepare it — up to about a minute when CEISA is slow.',
  'docpabean.pdfPreview.docGeneric': 'Document',
  'docpabean.pdfPreview.refreshDraft': 'Refresh Draft',
  'docpabean.pdfPreview.download': 'Download',
  'docpabean.pdfPreview.openNewTab': 'Open in New Tab',
  'docpabean.pdfPreview.errorTitle': 'The document cannot be shown',
  'docpabean.pdfPreview.errorGeneric': 'Failed to fetch the document. Please try again.',
  'docpabean.pdfPreview.errorBilling': 'Subscription unpaid / insufficient credit — the preview cannot be opened.',
  'docpabean.pdfPreview.retry': 'Try Again',

  // ---- Draft change history (the "Audit Logs" drawer on the edit page) ----
  'docpabean.audit.title': 'Change History',
  'docpabean.audit.refresh': 'Reload',
  'docpabean.audit.count': '{n} changes',
  'docpabean.audit.loadMore': 'Load more ({n} left)',
  'docpabean.audit.unavailable': 'History is not available for this draft yet.',
  'docpabean.audit.subtitle.batch': 'Batch {uuid}',
  'docpabean.audit.subtitle.none': 'Draft not saved yet',
  'docpabean.audit.systemActor': 'System',
  'docpabean.audit.rowCount': '{n} rows',
  'docpabean.audit.empty': '(empty)',
  'docpabean.audit.yes': 'Yes',
  'docpabean.audit.no': 'No',
  'docpabean.audit.addedEntity': 'Added: {entity}',
  'docpabean.audit.removedEntity': 'Removed: {entity}',
  'docpabean.audit.showMoreFields': 'Show {n} more',
  'docpabean.audit.hideMoreFields': 'Hide',
  'docpabean.audit.showMoreValue': 'more',
  'docpabean.audit.showLessValue': 'less',
  'docpabean.audit.filter.tab.all': 'All',
  'docpabean.audit.filteredEmpty': 'No changes on this tab.',
  'docpabean.audit.empty.title': 'No history yet',
  'docpabean.audit.empty.body': 'Changes to this draft will appear here.',
  'docpabean.audit.error.title': 'Could not load the history',
  'docpabean.audit.error.body': 'The history could not be loaded. Please try again shortly.',
  'docpabean.audit.error.retry': 'Try again',
  'docpabean.audit.notFound.title': 'History not found',
  'docpabean.audit.notFound.body': 'This draft is not available for your account.',
  'docpabean.audit.forbidden.title': 'Account is not linked to a PPJK',
  'docpabean.audit.forbidden.body': 'Your account is not linked to a PPJK, so draft history cannot be shown.',
  'docpabean.audit.day.today': 'Today',
  'docpabean.audit.day.yesterday': 'Yesterday',
  'docpabean.audit.day.unknown': 'Unknown date',
  'docpabean.audit.time.justNow': 'Just now',
  'docpabean.audit.time.minutesAgo': '{n} minutes ago',
  'docpabean.audit.time.hoursAgo': '{n} hours ago',
  'docpabean.audit.time.daysAgo': '{n} days ago',
  'docpabean.audit.time.monthsAgo': '{n} months ago',
  'docpabean.audit.time.yearsAgo': '{n} years ago',
  'docpabean.audit.time.unknown': 'Unknown time',
  // AI extraction shows as three milestones only: no counts, no field names, no
  // values.
  'docpabean.audit.milestone.extractionStarted': 'AI extraction started by {name}',
  'docpabean.audit.milestone.extractionStartedAnon': 'AI extraction started',
  'docpabean.audit.milestone.extractionCompleted': 'AI extraction finished',
  'docpabean.audit.milestone.extractionFailed': 'AI extraction failed',
  'docpabean.audit.milestone.submitDraft': '{name} submitted the draft',
  'docpabean.audit.milestone.submitFinal': '{name} submitted the final document',
  'docpabean.audit.milestone.draftDeleted': '{name} deleted the draft',
  'docpabean.audit.milestone.documentFileUploaded': '{name} uploaded the file {file}',
  'docpabean.audit.milestone.documentFileUploadedAnon': 'File {file} was uploaded',
  'docpabean.audit.milestone.smartSync': '{name} ran Smart Sync',
  'docpabean.audit.import.full': 'Excel · Full',
  'docpabean.audit.import.barangOnly': 'Excel · Barang Only',
  'docpabean.audit.import.allTabs': 'All tabs',
  'docpabean.audit.import.otherTab': 'No tab',
  'docpabean.audit.import.added': '{n} added',
  'docpabean.audit.import.changed': '{n} changed',
  'docpabean.audit.import.removed': '{n} removed',
  'docpabean.audit.import.fields': '{n} fields',
  'docpabean.audit.import.noChanges': 'No changes',
  'docpabean.audit.import.goodsReplaced': 'Goods list replaced with the sheet contents',
  'docpabean.audit.import.showPerTab': 'Show changes by tab',
  'docpabean.audit.import.hidePerTab': 'Hide changes by tab',
  'docpabean.audit.import.truncated': 'Showing the first 300 rows',
  'docpabean.audit.action.UPDATE': 'Changed',
  'docpabean.audit.action.CREATE': 'Added',
  'docpabean.audit.action.DELETE': 'Removed',
  'docpabean.audit.action.HISTORICAL_SYNC': 'Copied from history',
  'docpabean.audit.action.AI_APPLIED': 'AI filled in',
  'docpabean.audit.action.EXTRACTION_REQUESTED': 'Extraction started',
  'docpabean.audit.action.EXTRACTION_COMPLETED': 'Extraction finished',
  'docpabean.audit.action.EXTRACTION_FAILED': 'Extraction failed',
  'docpabean.audit.action.SUBMIT_DRAFT': 'Draft submitted',
  'docpabean.audit.action.SUBMIT_FINAL': 'Final document submitted',
  'docpabean.audit.action.DRAFT_DELETED': 'Draft deleted',
  'docpabean.audit.action.BULK_SUMMARY': 'Bulk change',
  'docpabean.audit.action.EXCEL_IMPORT': 'Excel upload',
  'docpabean.audit.action.SMART_SYNC': 'Smart Sync',
  'docpabean.audit.entity.header': 'Header',
  'docpabean.audit.entity.entity': 'Entity',
  'docpabean.audit.entity.document': 'Document',
  'docpabean.audit.entity.carrier': 'Carrier',
  'docpabean.audit.entity.peti_kemas': 'Container',
  'docpabean.audit.entity.kemasan': 'Packaging',
  'docpabean.audit.entity.transaksi': 'Transaction',
  'docpabean.audit.entity.barang': 'Goods',
  'docpabean.audit.entity.statement': 'Statement',
  'docpabean.audit.entity.process': 'Process',
  'docpabean.audit.entity.barang_vd': 'Transaction type',
  'docpabean.audit.field.barang_vd.kodeJenisVd': 'Transaction type',
  'docpabean.audit.field.barang_vd.nilaiBarangVd': 'VD value',
  // A customs term, not UI copy: the CEISA form prints these words, so they are
  // the same in every language block rather than translated out of the document.
  'docpabean.audit.value.kondisiBarang1': 'Barang Baru',
  'docpabean.audit.value.kondisiBarang2': 'Bukan Barang Baru',
  'docpabean.audit.value.jenisApi01': 'API U',
  'docpabean.audit.value.jenisApi02': 'API P',
  'docpabean.audit.tab.header': 'Header',
  'docpabean.audit.tab.entitas': 'Entity',
  'docpabean.audit.tab.dokumen': 'Document',
  'docpabean.audit.tab.pengangkut': 'Carrier',
  'docpabean.audit.tab.kemasan': 'Packaging & Containers',
  'docpabean.audit.tab.transaksi': 'Transaction',
  'docpabean.audit.tab.barang': 'Goods',
  'docpabean.audit.tab.pungutan': 'Levies',
  'docpabean.audit.tab.pernyataan': 'Statement',

  // "Hasil Ekstraksi" drawer on the PIB draft editor (src/features/draft-extraction)
  'docpabean.extraction.button': 'Extraction Result',
  'docpabean.extraction.title': 'Extraction Result',
  'docpabean.extraction.extractedAt': 'Extracted {date}',
  'docpabean.extraction.download': 'Download Excel',
  'docpabean.extraction.downloading': 'Preparing Excel…',
  'docpabean.extraction.note.snapshot':
    'The AI value is the value at extraction time. The current value follows the form, including unsaved changes.',
  'docpabean.extraction.note.source':
    'The source is the document mapped to this field and sent to the AI, not an exact quote from the document.',
  'docpabean.extraction.filter.changedOnly': 'Changed only',
  'docpabean.extraction.filter.status.placeholder': 'All statuses',
  'docpabean.extraction.column.seri': 'Item no.',
  'docpabean.extraction.column.field': 'Field',
  'docpabean.extraction.column.ai': 'AI value',
  'docpabean.extraction.column.current': 'Current value',
  'docpabean.extraction.column.status': 'Status',
  'docpabean.extraction.column.source': 'Source (mapped)',
  'docpabean.extraction.column.changed': 'Changed',
  'docpabean.extraction.changed': 'Changed',
  'docpabean.extraction.status.ok': 'From documents',
  'docpabean.extraction.status.master-ok': 'From master data',
  'docpabean.extraction.status.default': 'Default value',
  'docpabean.extraction.status.calc': 'Calculated by CEISA',
  'docpabean.extraction.status.user': 'Filled by user',
  'docpabean.extraction.status.master': 'Needs master data',
  'docpabean.extraction.status.shape': 'Outside the options',
  'docpabean.extraction.source.open': 'Open in the PDF viewer',
  'docpabean.extraction.source.unavailable': 'Document not available',
  'docpabean.extraction.source.notUploadedTypes': 'Mapped document not uploaded: {types}',
  'docpabean.extraction.source.notUploadedHint':
    "This field is mapped to a document section that is not among this process's uploads. Its value came from elsewhere (master data, a default, or the user).",
  'docpabean.extraction.source.emptySection': 'Mapped section empty in {files}',
  'docpabean.extraction.source.emptySectionHint':
    'The document was uploaded, but the section mapped to this field was not read from it. Its value came from elsewhere.',
  'docpabean.extraction.source.unmapped': 'No document section mapped',
  'docpabean.extraction.source.unmappedHint':
    'The semantics map points this field at no document section, so there is no file to open. The status still says where its value came from.',
  'docpabean.extraction.search.placeholder': 'Search fields, values, documents… (e.g. npwp, invoice, changed)',
  'docpabean.extraction.search.clear': 'Clear search',
  'docpabean.extraction.search.results': '{n} results across all tabs',
  'docpabean.extraction.search.empty': 'Nothing matches "{q}". Try another word, a field name or its value.',
  'docpabean.extraction.goTo': 'Open this field in the form',
  'docpabean.extraction.goToTab': 'Open this tab in the form',
  'docpabean.extraction.page.range': '{from}–{to} of {total}',
  'docpabean.extraction.row.seri': 'Line {n}',
  'docpabean.extraction.attach.title': 'Goods attachments',
  'docpabean.extraction.attach.count': '{n} documents',
  'docpabean.extraction.attach.callout':
    '{n} documents in this draft can be attached to goods. See which goods each one is attached to.',
  'docpabean.extraction.attach.open': 'View attachments',
  'docpabean.extraction.attach.hide': 'Hide',
  'docpabean.extraction.attach.description':
    'Documents such as the e-COO, SNI, surveyor reports and permits can be attached to goods. Here you can see, for each item a document lists, which goods in the draft it is attached to and why they were matched. Invoices, packing lists, B/Ls and DOs are never attached to goods, so they are not listed.',
  'docpabean.extraction.attach.empty': 'This draft has no document that can be attached to goods.',
  'docpabean.extraction.attach.filter': 'Search by seri, code or goods name',
  'docpabean.extraction.attach.unmatchedOnly': 'Not attached only',
  'docpabean.extraction.attach.missedOnly': 'Needs a check only',
  'docpabean.extraction.attach.notExact':
    'Note: the matches below may differ slightly from what was saved when the AI processed this draft.',
  'docpabean.extraction.attach.noMatch': 'No document or item matches this search.',
  'docpabean.extraction.attach.noRecord': 'No attachment data from the AI for this document yet.',
  'docpabean.extraction.attach.noLines': 'This document lists no goods.',
  'docpabean.extraction.attach.noLineMatch': 'No item matches this search.',
  'docpabean.extraction.attach.notInForm': 'This document is no longer on the Dokumen tab.',
  'docpabean.extraction.attach.dokumenNo': 'Document #{n}',
  'docpabean.extraction.attach.terlampir': 'Attached',
  'docpabean.extraction.attach.summary': '{rows} goods attached from {lines} lines',
  'docpabean.extraction.attach.unmatchedCount': '{n} lines not attached',
  'docpabean.extraction.attach.missedCount': '{n} need a check',
  'docpabean.extraction.attach.pending': 'Not attached',
  'docpabean.extraction.attach.col.line': 'No.',
  'docpabean.extraction.attach.col.code': 'Code on document',
  'docpabean.extraction.attach.col.naming': 'Goods name on document',
  'docpabean.extraction.attach.col.qty': 'Quantity',
  'docpabean.extraction.attach.col.seri': 'Seri',
  'docpabean.extraction.attach.col.barang': 'Goods in the draft',
  'docpabean.extraction.attach.col.settledBy': 'Matched by',
  'docpabean.extraction.attach.col.evidence': 'What matches',
  'docpabean.extraction.attach.decision.code': 'same goods code',
  'docpabean.extraction.attach.decision.ocr_misread': 'nearly the same code',
  'docpabean.extraction.attach.decision.amount': 'same quantity',
  'docpabean.extraction.attach.decision.naming': 'similar name',
  'docpabean.extraction.attach.decision.line_number': 'same line number',
  'docpabean.extraction.attach.decision.sum': 'quantities add up',
  'docpabean.extraction.attach.decision.article': 'every item with this code',
  'docpabean.extraction.attach.decision.kind': 'matching kind of goods',
  'docpabean.extraction.attach.decision.shipment': 'covers the whole shipment',
  'docpabean.extraction.attach.decision.unknown': 'unknown',
  'docpabean.extraction.attach.evidence.code': 'same code',
  'docpabean.extraction.attach.evidence.ocrMisread': 'nearly the same code',
  'docpabean.extraction.attach.evidence.contradicts': 'different code',
  'docpabean.extraction.attach.evidence.amounts': 'same {fields}',
  'docpabean.extraction.attach.evidence.naming': 'name {n}% similar',
  'docpabean.extraction.attach.evidence.lineNumber': 'same line number',
  'docpabean.extraction.attach.field.jumlahSatuan': 'unit quantity',
  'docpabean.extraction.attach.field.jumlahKemasan': 'package count',
  'docpabean.extraction.attach.field.netto': 'net weight',
  'docpabean.extraction.attach.field.bruto': 'gross weight',
  'docpabean.extraction.attach.field.nilaiBarang': 'goods value',
  'docpabean.extraction.attach.verdict.notShipped': 'Not in this shipment',
  'docpabean.extraction.attach.verdict.lookalikesTaken': 'Similar goods already attached',
  'docpabean.extraction.attach.verdict.likelyMissed': 'Needs a check',
  'docpabean.extraction.attach.verdict.noCode': 'No goods code',
  'docpabean.extraction.attach.verdict.notShippedDetail':
    'No goods in the draft have a similar code, so it is fine that this is not attached.',
  'docpabean.extraction.attach.verdict.noCodeDetail':
    'This line has no goods code, so it cannot be matched automatically.',
  'docpabean.extraction.attach.verdict.candidate': 'Seri {n} ({code}) may match: {reason}',
  'docpabean.extraction.attach.verdict.taken': 'Seri {n} ({code}) is already attached through line {line}',
  'docpabean.extraction.attach.reason.sameCode': 'same code',
  'docpabean.extraction.attach.reason.leadingZero': 'only a leading 0 differs',
  'docpabean.extraction.attach.reason.ocrMisread': 'one character misread',
  'docpabean.extraction.attach.reason.insideLonger': 'the code is part of a longer code',
  'docpabean.extraction.attach.reason.cutOff': 'the code is cut off on the document',
  'docpabean.extraction.file.open': 'View {name}',
  'docpabean.extraction.panel.fullScreen': 'Full screen',
  'docpabean.extraction.panel.dock': 'Show beside the form',
  'docpabean.extraction.panel.resize': 'Drag to resize the panel (double-click: full screen)',
  'docpabean.extraction.panel.releaseFull': 'Release for full screen',
  'docpabean.extraction.role.primary': 'primary',
  'docpabean.extraction.role.fallback': 'fallback',
  'docpabean.extraction.current.seeTable': 'See table',
  'docpabean.extraction.current.ceisa': 'Calculated by CEISA',
  'docpabean.extraction.current.notInForm': 'Not on this form',
  'docpabean.extraction.rows': '{n} rows',
  'docpabean.extraction.row.status': 'Row status',
  'docpabean.extraction.row.changed': 'Changed',
  'docpabean.extraction.row.added': 'Added by user',
  'docpabean.extraction.row.removed': 'Removed',
  'docpabean.extraction.table.aiOnly': 'AI values only — levies are calculated by CEISA',
  'docpabean.extraction.empty.tab': 'This tab has no fields from the AI.',
  'docpabean.extraction.empty.filtered': 'Nothing on this tab matches the filters.',
  'docpabean.extraction.notAvailable': 'Extraction details are not available for this draft.',
  'docpabean.extraction.error.title': 'Could not load the extraction result',
  'docpabean.extraction.error.retry': 'Retry',
  'docpabean.extraction.excel.error': 'Could not create the Excel file. Please try again.',
  'docpabean.extraction.excel.summary': 'Summary',
  'docpabean.extraction.excel.ajuNo': 'AJU No.',
  'docpabean.extraction.excel.processId': 'Process ID',
  'docpabean.extraction.excel.extractedAt': 'Extracted at',
  'docpabean.extraction.excel.downloadedAt': 'Downloaded at',
  'docpabean.extraction.excel.downloadedBy': 'Downloaded by',
  'docpabean.extraction.excel.tab': 'Tab',
  'docpabean.extraction.excel.changedFields': 'Changed fields',
  'docpabean.extraction.excel.changedRows': 'Changed rows',
  'docpabean.extraction.excel.notes': 'Notes',
  'docpabean.extraction.excel.ai': 'AI',
  'docpabean.extraction.excel.current': 'current',
  'docpabean.extraction.excel.yes': 'Yes',
  'docpabean.extraction.excel.no': 'No',
  'docpabean.extraction.excel.col.section': 'Section',
  'docpabean.extraction.excel.col.field': 'Field',
  'docpabean.extraction.excel.col.required': 'Required',
  'docpabean.extraction.excel.col.ai': 'AI value',
  'docpabean.extraction.excel.col.current': 'Current value',
  'docpabean.extraction.excel.col.changed': 'Changed (Yes/No)',
  'docpabean.extraction.excel.col.status': 'Status',
  'docpabean.extraction.excel.col.sourceFile': 'Source document (file)',
  'docpabean.extraction.excel.col.documentType': 'Document type',
  'docpabean.extraction.excel.col.sectionId': 'Document section (sectionId)',
  'docpabean.extraction.excel.col.role': 'Role (primary/fallback)',

  // Konsistensi Dokumen — Document Consistency Matrix (src/features/draft-consistency)
  'docpabean.consistency.button': 'Document Consistency',
  'docpabean.consistency.title': 'Document Consistency',
  'docpabean.consistency.badge': 'Document findings: {critical} critical, {high} high, {medium} medium',
  'docpabean.consistency.builtAt': 'Built {date}',
  'docpabean.consistency.download': 'Download Excel',
  'docpabean.consistency.downloading': 'Preparing Excel…',
  'docpabean.consistency.excel.error': 'The Excel file could not be created. Please try again.',
  'docpabean.consistency.notAvailable': 'The consistency matrix is not available for this draft.',
  'docpabean.consistency.error.title': 'The consistency matrix could not be loaded.',
  'docpabean.consistency.error.retry': 'Try again',
  'docpabean.consistency.footnote':
    '`-` means the value could not be read from that document or the document does not state it. This result is for information only and does not block submission.',
  'docpabean.consistency.document': 'Document',
  'docpabean.consistency.openDocument': 'view the PDF beside the table',
  'docpabean.consistency.goToField': 'Check in form',
  'docpabean.consistency.columns.move': 'Drag to move this column left or right',
  'docpabean.consistency.columns.moveLeft': 'Move left',
  'docpabean.consistency.columns.moveRight': 'Move right',
  'docpabean.consistency.columns.resetOrder': 'Original order',
  'docpabean.consistency.columns.orderNote':
    'Drag the ⋮⋮ icon on a column header, or use the arrows, to change the order.',
  'docpabean.consistency.columns.resetSizes': 'Reset sizes',
  'docpabean.consistency.columns.sizesNote': 'Drag a column or row edge to resize it.',
  'docpabean.consistency.resize.column':
    'Resize column: drag, or left/right arrows. Double-click for the default size.',
  'docpabean.consistency.resize.row': 'Resize row: drag, or up/down arrows. Double-click for the default size.',
  'docpabean.consistency.sheet.toFill': '🔴 Needs filling',
  'docpabean.consistency.sheet.toFillShort': 'Needs filling',
  'docpabean.consistency.sheet.toggle': 'Click to open or close this section',
  'docpabean.consistency.sheet.expandAll': 'Open all',
  'docpabean.consistency.sheet.collapseAll': 'Close all',
  'docpabean.consistency.sheet.count.fields': '{n} fields',
  'docpabean.consistency.sheet.count.ok': '{n} OK',
  'docpabean.consistency.sheet.count.problem': '{n} with problems',
  'docpabean.consistency.sheet.count.review': '{n} to check',
  'docpabean.consistency.status.ok': 'Matches',
  'docpabean.consistency.status.review': 'To check',
  'docpabean.consistency.status.mismatch': 'Mismatch',
  'docpabean.consistency.status.required': 'Required',
  'docpabean.consistency.status.empty': 'Empty',
  'docpabean.consistency.status.notCompared': 'Not compared',
  'docpabean.consistency.status.detail.oneDocument': 'Matches the only document',
  'docpabean.consistency.sheet.sameAsAi': 'Same as the AI result',
  'docpabean.consistency.sheet.differsFromAi': 'Differs from the AI result',
  'docpabean.consistency.sheet.filledManually': 'Filled in manually; the AI took no value',
  'docpabean.consistency.sheet.empty': 'Check manually whether it should be filled',
  'docpabean.consistency.sheet.requiredEmpty': 'Still empty, needs filling',
  'docpabean.consistency.sheet.ceisa': 'Computed by CEISA',
  'docpabean.consistency.sheet.notInForm': 'Not on the form',
  'docpabean.consistency.sheet.lineAdded': 'In the PIB, not in the AI result',
  'docpabean.consistency.sheet.lineRemoved': 'In the AI result, not in the PIB',
  'docpabean.consistency.sheet.barangLine': 'Goods line',
  'docpabean.consistency.sheet.sourceCell': 'AI source',
  'docpabean.consistency.sheet.sourceHint':
    "The AI's value for this field was taken from this document. Click to see the PDF.",
  'docpabean.consistency.sheet.partial':
    'The full list of PIB fields needs Hasil Ekstraksi, which is not on for this draft yet. Only the fields compared across documents are shown.',
  'docpabean.consistency.excel.chooseTitle': 'Documents to include in the Excel file',
  'docpabean.consistency.excel.chooseNote': 'Field, PIB saat ini, Diambil AI and Hasil are always included.',
  'docpabean.consistency.excel.selectAll': 'Select all',
  'docpabean.consistency.excel.selectNone': 'Clear',
  'docpabean.consistency.excel.confirm': 'Download',
  'docpabean.consistency.excel.documents': 'Documents in this file',
  'docpabean.consistency.excel.col.status': 'Status',
  'docpabean.consistency.excel.col.reason': 'Reason',
  'docpabean.consistency.excel.perTab': 'Result per tab',
  'docpabean.consistency.excel.statusCounts': 'Count per status',
  'docpabean.consistency.excel.howTo': 'How to read this file',
  'docpabean.consistency.excel.sheets': 'Sheets in this file',
  'docpabean.consistency.excel.nothingToCheck': 'No field needs checking.',
  'docpabean.consistency.excel.legend.ok': 'The PIB value matches the documents or the AI result.',
  'docpabean.consistency.excel.legend.review':
    'The PIB value differs from the AI result, or the documents differ slightly. Check it again.',
  'docpabean.consistency.excel.legend.mismatch':
    'The documents disagree with each other or with the PIB. Red = Critical, orange = High.',
  'docpabean.consistency.excel.legend.required': 'A required PIB field is still empty and needs filling.',
  'docpabean.consistency.excel.legend.empty': 'An optional field is still empty. Check whether it should be filled.',
  'docpabean.consistency.excel.legend.notCompared':
    'Nothing to compare with: filled in manually, computed by CEISA, not on the form, or only one document.',
  'docpabean.consistency.excel.legend.source': 'The document the AI took the value of that field from.',
  'docpabean.consistency.excel.legend.sheets':
    'Perlu Dicek: only the fields to act on. Matriks: every PIB field. Temuan: one line per finding.',
  'docpabean.consistency.excel.col.tab': 'Tab',
  'docpabean.consistency.excel.col.section': 'Section',
  'docpabean.consistency.split.width':
    'Drag to split the width between the table and the PDF. Double-click for the default size.',
  'docpabean.consistency.split.height':
    'Drag to change the height of the findings list. Double-click for the default size.',
  'docpabean.consistency.pdf.show': 'Show PDF',
  'docpabean.consistency.pdf.shown': 'Shown beside the table',
  'docpabean.consistency.pdf.previous': 'Previous document',
  'docpabean.consistency.pdf.next': 'Next document',
  'docpabean.consistency.pdf.newTab': 'Open in a new tab',
  'docpabean.consistency.pdf.close': 'Close PDF',
  'docpabean.consistency.pdf.notPdf': 'Only PDFs can be previewed here. Open this file in a new tab.',
  'docpabean.consistency.columns.button': 'Columns ({shown}/{total})',
  'docpabean.consistency.columns.title': 'Show columns',
  'docpabean.consistency.columns.showAll': 'Show all',
  'docpabean.consistency.columns.note': 'Field and Result are always shown. Download Excel always has every column.',
  'docpabean.consistency.legend.derived': 'Summed from the goods lines',
  'docpabean.consistency.legend.reference': 'Grey: reference only, not compared',
  'docpabean.consistency.fullScreen': 'Full screen',
  'docpabean.consistency.exitFullScreen': 'Exit full screen',
  'docpabean.consistency.goToFieldHint': 'Close the matrix and show this field on the PIB form',
  'docpabean.consistency.openCellDocument': "View this document's PDF beside the table",
  'docpabean.consistency.unreadableBadge': 'Unreadable',
  'docpabean.consistency.column.field': 'Field',
  'docpabean.consistency.column.ai': 'Taken by AI',
  'docpabean.consistency.column.pib': 'Current PIB',
  'docpabean.consistency.column.result': 'Result',
  'docpabean.consistency.column.severity': 'Severity',
  'docpabean.consistency.result.match': 'Matches the documents',
  'docpabean.consistency.result.single_source': 'Only one document states it',
  'docpabean.consistency.result.no_data': 'No data from the documents',
  'docpabean.consistency.severity.critical': '🔴 Critical — please check',
  'docpabean.consistency.severity.high': '🟠 High — review',
  'docpabean.consistency.severity.medium': '🟡 Medium — review',
  'docpabean.consistency.severity.short.critical': 'Critical',
  'docpabean.consistency.severity.short.high': 'High',
  'docpabean.consistency.severity.short.medium': 'Medium',
  'docpabean.consistency.aiDiffers': '≠ documents',
  'docpabean.consistency.cell.derived': 'Summed from the goods lines',
  'docpabean.consistency.cell.reference': 'Reference only, not compared',
  'docpabean.consistency.cell.supporting': 'Supporting: may confirm, never counted as a difference',
  'docpabean.consistency.note.inside_total_offset':
    'Goods price = invoice total minus the freight, insurance and charges inside the invoice',
  'docpabean.consistency.note.offset_unknown': 'The invoice total was not read; not compared',
  'docpabean.consistency.note.lcl': 'LCL: no containers are declared',
  'docpabean.consistency.finding.none': 'No findings — the values agree across all documents.',
  'docpabean.consistency.finding.requiredEmpty': 'not stated on any document',
  'docpabean.consistency.finding.stale': 'part of the reading came from another run and was ignored',
  'docpabean.consistency.finding.pib': 'PIB',
  'docpabean.consistency.finding.documents': 'documents',
  'docpabean.consistency.finding.live': 'from the current PIB value',
  'docpabean.consistency.unreadable.not_read': 'the document could not be read',
  'docpabean.consistency.unreadable.unsupported_format': 'unsupported file format',
  'docpabean.consistency.unreadable.not_extracted': "the document's content could not be extracted",
  'docpabean.consistency.unreadable.no_sections': 'no document sections were found',
  'docpabean.consistency.excel.col.code': 'Code',
  'docpabean.consistency.excel.col.document': 'Document',
  'docpabean.consistency.excel.col.detail': 'Detail',
  'docpabean.consistency.excel.summary.item': 'Item',
  'docpabean.consistency.excel.summary.value': 'Value',
  'docpabean.consistency.excel.ajuNo': 'AJU No.',
  'docpabean.consistency.excel.processId': 'Process ID',
  'docpabean.consistency.excel.builtAt': 'Built at',
  'docpabean.consistency.excel.downloadedAt': 'Downloaded at',
  'docpabean.consistency.excel.downloadedBy': 'Downloaded by',
  'docpabean.consistency.excel.note': 'Note',
  'docpabean.consistency.row.quantity': 'Quantity',
  'docpabean.consistency.row.packages': 'Package',
  'docpabean.consistency.row.gross_weight': 'Gross Weight',
  'docpabean.consistency.row.net_weight': 'Net Weight',
  'docpabean.consistency.row.seller': 'Seller / Exporter',
  'docpabean.consistency.row.importer': 'Importer / Consignee',
  'docpabean.consistency.row.transport_doc_no': 'B/L / AWB Number',
  'docpabean.consistency.row.currency': 'Currency',
  'docpabean.consistency.row.total_value': 'Total Value',
  'docpabean.consistency.row.incoterm': 'Incoterm',
  'docpabean.consistency.row.containers': 'Container',
  'docpabean.consistency.row.description': 'Description',
  'docpabean.consistency.code.QUANTITY_MISMATCH': 'QUANTITY MISMATCH',
  'docpabean.consistency.code.PACKAGE_MISMATCH': 'PACKAGE MISMATCH',
  'docpabean.consistency.code.WEIGHT_MISMATCH': 'WEIGHT MISMATCH',
  'docpabean.consistency.code.SELLER_MISMATCH': 'SELLER MISMATCH',
  'docpabean.consistency.code.IMPORTER_MISMATCH': 'IMPORTER MISMATCH',
  'docpabean.consistency.code.BL_NUMBER_MISMATCH': 'B/L NUMBER MISMATCH',
  'docpabean.consistency.code.CURRENCY_MISMATCH': 'CURRENCY MISMATCH',
  'docpabean.consistency.code.TOTAL_VALUE_MISMATCH': 'TOTAL VALUE MISMATCH',
  'docpabean.consistency.code.INCOTERM_MISMATCH': 'INCOTERM MISMATCH',
  'docpabean.consistency.code.CONTAINER_MISMATCH': 'CONTAINER MISMATCH',
  'docpabean.consistency.code.DESCRIPTION_MISMATCH': 'DESCRIPTION MISMATCH',
  'docpabean.consistency.code.UNREADABLE_DOCUMENT': 'Unreadable document',
  'docpabean.consistency.code.GROSS_LT_NET': 'Gross weight < net weight',
  'docpabean.consistency.code.REQUIRED_EMPTY': 'Required data empty',
  'docpabean.consistency.code.STALE_READING': 'Reading ignored',
  'docpabean.consistency.code.PIB_DIFFERS': 'PIB differs from the documents',
  'docpabean.consistency.code.DUPLICATE_DOCUMENT': 'Duplicate document',
  'docpabean.consistency.code.DESCRIPTION_SLIGHTLY_DIFFERENT': 'Description slightly different',
  'docpabean.consistency.code.FORMAT_DIFFERS': 'Format differs',
  'docpabean.consistency.code.DATE_UNUSUAL': 'Unusual date',
  'docpabean.consistency.code.HISTORICAL_VALUE_UNUSUAL': 'Unusual historical value',

  // CCN (CUBEforall) workspace — /ccn/*
  'ccn.product': 'Inward Manifest (AWB)',
  'ccn.logout': 'Sign out',
  'ccn.language': 'Language',
  'ccn.inbox.title': 'Inward Manifests from CUBEforall',
  'ccn.inbox.subtitle': 'AWBs sent to JARVIS from CUBEforall. Open one to prepare the draft, then send it back to CCN.',
  'ccn.inbox.subtitleCompany': 'AWBs sent for {company}. Open one to prepare the draft, then send it back to CCN.',
  'ccn.inbox.search': 'Search AWB / HAWB / email',
  'ccn.inbox.refresh': 'Refresh list',
  'ccn.inbox.loadError': 'Could not load the CCN documents.',
  'ccn.inbox.retry': 'Try again',
  'ccn.inbox.emptyTitle': 'No AWB has been sent to JARVIS yet.',
  'ccn.inbox.emptyBody':
    'Pick an AWB in CUBEforall and click Send to JARVIS. It will appear here within a few seconds.',
  'ccn.inbox.col.awb': 'AWB',
  'ccn.inbox.col.hawb': 'HAWB',
  'ccn.inbox.col.route': 'Route',
  'ccn.inbox.col.sentBy': 'Sent by',
  'ccn.inbox.col.received': 'Received',
  'ccn.inbox.col.status': 'Status',
  'ccn.inbox.staleBadge': 'New version',
  'ccn.inbox.staleHint': 'CCN sent a newer version after the draft was created',
  'ccn.inbox.resync': 'Reload from CCN',
  'ccn.inbox.resyncOk': 'AWB {awb} reloaded from CCN.',
  'ccn.inbox.resyncFail': 'Could not reload from CCN',
  'ccn.inbox.open': 'Open',
  'ccn.inbox.view': 'View',
  'ccn.status.RECEIVED': 'Received',
  'ccn.status.FETCHING': 'Fetching data',
  'ccn.status.DRAFTED': 'Draft ready',
  'ccn.status.FETCH_FAILED': 'Fetch failed',
  'ccn.status.MAP_FAILED': 'Mapping failed',
  'ccn.status.SUBMITTING': 'Sending to CCN',
  'ccn.status.SUBMITTED': 'Sent to CCN',
  'ccn.status.SUBMIT_FAILED': 'Send failed',
  'ccn.open.preparing': 'Fetching the AWB from CUBEforall and preparing the draft…',
  'ccn.open.failed': 'The CCN document could not be opened',
  'ccn.open.toInbox': 'Back to AWB list',
  'ccn.callback.checking': 'Checking your CUBEforall session…',
  'ccn.callback.redirecting': 'Redirecting to CUBEforall sign-in…',
  'ccn.callback.exchanging': 'Preparing your JARVIS session…',
  'ccn.callback.prompt': 'Sign in with your CUBEforall account to open Inward Manifest in JARVIS.',
  'ccn.callback.exchangeFailed': 'CUBEforall session exchange failed',
  'ccn.sso.inactive':
    'Access denied: your CUBEforall subscription is not active for JARVIS. Please contact CCN to activate it.',
  'ccn.sso.inactiveRedirect':
    'Your company has not subscribed to JARVIS on CUBEforall yet. Taking you to the JARVIS page on CUBEforall to subscribe.',
  'ccn.sso.openProductPage': 'Open the JARVIS page on CUBEforall',
  'ccn.submit.title': 'Send manifest to CUBEforall',
  'ccn.submit.body':
    'This inward manifest (as saved in each tab) is created as a document in CUBEforall. Nothing is sent to CEISA.',
  'ccn.submit.staleTitle': 'CCN sent a newer version',
  'ccn.submit.staleBody':
    'The latest version from CCN has not been loaded into this draft. Send it with the current data?',
  'ccn.submit.staleAck': 'Yes, send this draft as it is',
  'ccn.submit.cancel': 'Cancel',
  'ccn.submit.send': 'Send to CUBEforall',
  'ccn.submit.sending': 'Creating the document in CUBEforall…',
  'ccn.incomplete.body': 'The declaration cannot be sent to CCN yet. Fill in the {count} required fields below first.',
  // ---- Manifest editor: data completeness ----
  'manifestEditor.completeness.title': 'Incomplete Data ({count})',
  'manifestEditor.completeness.body':
    'The manifest cannot be pushed to CEISA yet. Fill in the {count} required fields below first.',
  'manifestEditor.completeness.goToTab': 'Go to tab →',
  'manifestEditor.completeness.close': 'Close',
  'manifestEditor.noAccess': 'This manifest cannot be opened with this account.',
  'manifestEditor.completeness.rowBadge': 'Incomplete ({count})',
  'manifestEditor.completeness.tabTooltip': '{count} items incomplete',
  'manifestEditor.completeness.tabComplete': 'Data complete',
  'manifestEditor.completeness.panelTitle': '{count} items incomplete on this tab',
  'manifestEditor.completeness.panelHint': 'Complete these before Submit Draft. Click one to jump straight to it.',
  'manifestEditor.completeness.panelJump': 'Show →',
  'manifestEditor.completeness.itemJump': 'Show',
  'manifestEditor.completeness.startFixing': 'Start fixing',
  'manifestEditor.completeness.panelShowAll': 'Show all ({count})',
  'manifestEditor.completeness.panelShowLess': 'Show less',
  'manifestEditor.completeness.panelHide': 'Hide',
  'manifestEditor.completeness.panelShow': 'Show',
  'manifestEditor.completeness.statusColumn': 'Status',

  // ---- PIB draft editor: "Data Belum Lengkap" submit gate ----
  'pibEditor.completeness.title': 'Incomplete Data ({count})',
  'pibEditor.completeness.body':
    'The PIB cannot be pushed to CEISA yet. Fill in the {count} required fields below first.',
  'pibEditor.completeness.goToTab': 'Go to tab →',
  'pibEditor.completeness.itemJump': 'Show',
  'pibEditor.completeness.close': 'Close',
  'pibEditor.completeness.startFixing': 'Start fixing',

  // ---- PEB draft editor: "Data Belum Lengkap" submit gate ----
  'pebEditor.completeness.title': 'Incomplete Data ({count})',
  'pebEditor.completeness.body':
    'The PEB cannot be pushed to CEISA yet. Fill in the {count} required fields below first.',
  'pebEditor.completeness.goToTab': 'Go to tab →',
  'pebEditor.completeness.itemJump': 'Show',
  'pebEditor.completeness.close': 'Close',
  'pebEditor.completeness.startFixing': 'Start fixing',
  'pebEditor.ownerDiffers.inlineWarning':
    'The Goods Owner data differs from the Exporter data. This is permitted; however, please ensure that the data is correct.',
  'pebEditor.ownerDiffers.viewOwners': 'View Goods Owner',
  'pebEditor.ownerDiffers.rowChip': 'Differs from Exporter',
  'pebEditor.ownerDiffers.modalTitle': 'Exporter and Goods Owner Differ',
  'pebEditor.ownerDiffers.modalBody':
    'The Goods Owner data on this PEB differs from the Exporter data. This is permitted; however, please ensure that the data is correct before it is sent to CEISA.',
  'pebEditor.ownerDiffers.eksportirLabel': 'Exporter',
  'pebEditor.ownerDiffers.ownerLabel': 'Goods Owner {seri}',
  'pebEditor.ownerDiffers.name': 'Name',
  'pebEditor.ownerDiffers.npwp': 'NPWP',
  'pebEditor.ownerDiffers.confirm': 'Yes, the Data Is Correct',
  'pebEditor.ownerDiffers.review': 'Review Again',
  'pebEditor.owners.saved': 'Goods Owner data has been saved.',
  'pebEditor.barangPemilik.auto': 'Automatic',
  'pebEditor.barangPemilik.autoHint':
    'No owner has been picked for this item, so it belongs to every Goods Owner on the Entitas tab.',
  'pebEditor.barangPemilik.resetToAuto': 'Reset to automatic',
  'pebEditor.barangPemilik.ownerNotFound': 'Owner not found',
  'pebEditor.barangPemilik.jenisPemilik': 'OWNER',
  'pebEditor.barangPemilik.danglingLabel': 'Goods Owner',
  'pebEditor.barangPemilik.danglingIssue':
    "The goods owner (entitas seri {seri}) is not on the Entitas tab. Pick this item's owner again.",
  'pebEditor.barangPemilik.emptyIssue': 'This item has no goods owner. Add an owner or reset to automatic.',
  'pebEditor.barangPemilik.noOwner':
    'This item has no goods owner. Add one from the list above, or reset to automatic.',
  'pebEditor.barangPemilik.addNewHint': 'There is no Goods Owner on the Entitas tab yet. Enter a new owner here.',
  'pebEditor.barangPemilik.editOwner': 'Edit the owner (applies on the Entitas tab and to every item)',
  'pebEditor.barangPemilik.title': 'Goods Owner',
  'pebEditor.barangPemilik.singleOwnerHint': 'A PEB can only have 1 Goods Owner.',
  'pebEditor.barangPemilik.copyEksportirHint': "The Goods Owner will be overwritten with the Exporter's data.",
  'pebEditor.barangPemilik.tooManyOwnersIssue': 'Only 1 Goods Owner is allowed. Remove the others.',
  'pebEditor.barangPemilik.tooManyBarangIssue': 'An item can only have 1 owner. Remove the others.',
  'ccn.submit.doneTitle': 'Sent to CUBEforall',
  'ccn.submit.doneBody': "The manifest is saved as a document in your company's CUBEforall box.",
  'ccn.submit.doneId': 'Document ID: {id}',
  'ccn.submit.failedTitle': 'Not sent yet',
  'ccn.submit.rejected': 'CCN rejected the document',
  'ccn.submit.timeout': 'CCN has not answered yet. The status will update in the AWB list.',
  'ccn.submit.failed': 'Could not send to CCN',
  'ccn.submit.close': 'Close',
  'ccn.submit.retry': 'Try again',
  'ccn.submit.subtitle': 'Inward air manifest (BC 1.1)',
  'ccn.submit.awb': 'AWB',
  'ccn.submit.hawb': 'Host AWB',
  'ccn.submit.route': 'Route',
  'ccn.submit.sender': 'Sent by',
  'ccn.submit.destination': 'Saved to',
  'ccn.submit.destinationValue': '{company} on CUBEforall',
  'ccn.submit.destinationFallback': "Your company's CUBEforall box",
  'ccn.submit.whatHappens': 'What happens',
  'ccn.submit.step1': "JARVIS creates this manifest as a document in your company's CUBEforall box.",
  'ccn.submit.step2': 'Sending again later updates the same document instead of creating a new one.',
  'ccn.submit.step3': 'It is not filed with Customs (CEISA). Filing the BC 1.1 stays a separate step.',
  'ccn.submit.sendingHint': 'This usually takes a few seconds.',
  'ccn.submit.backToList': 'Back to the AWB list',
  'ccn.submit.copy': 'Copy',
  'ccn.submit.copied': 'Copied',
  'ccn.submit.details': 'Technical details',
  'ccn.editor.staleBadge': 'New version from CCN',
  'ccn.merge.conflictTitle': '{n} fields need your decision',
  'ccn.merge.conflictBody': 'CCN sent a newer version with values that differ from your edits. The draft keeps your value until you choose.',
  'ccn.merge.yours': 'Yours',
  'ccn.merge.keepMine': 'Keep mine',
  'ccn.merge.useCcn': "Use CCN's value",
  'ccn.merge.resolveFailed': 'Your choice was not saved, please try again',
  'ccn.merge.updatedTitle': "{n} fields updated from CCN's newer version",
  'ccn.merge.updatedBody': 'CCN sent a newer version on {date}. Fields you had not changed now follow it.',
  'ccn.merge.showChanges': 'Show changes',
  'ccn.merge.hideChanges': 'Hide changes',
  'ccn.merge.dismiss': 'Dismiss',
  'ccn.merge.header': 'Header',
  'ccn.merge.wholeHouse': 'HAWB row',
  'ccn.merge.housePresent': 'Included',
  'ccn.merge.houseAbsent': 'Removed',
  'ccn.inbox.conflictBadge': '{n} to review',
  'ccn.inbox.conflictHint': 'CCN sent a newer version that differs from your edits',
  'ccn.submit.conflictTitle': '{n} fields not decided yet',
  'ccn.submit.conflictBody': "CCN's newer version differs from your edits in some fields. The draft will be sent with your values.",
  'ccn.merge.field.namaSaranaPengangkut': 'Carrier name',
  'ccn.merge.field.nomorVoyage': 'Flight number',
  'ccn.merge.field.tanggalTiba': 'Arrival date',
  'ccn.merge.field.imoNumber': 'Airline code',
  'ccn.merge.field.kodeNegara': 'Departure country',
  'ccn.merge.field.tanggalBl': 'MAWB date',
  'ccn.merge.field.tanggalHostBl': 'HAWB date',
  'ccn.merge.field.namaPengirim': 'Shipper name',
  'ccn.merge.field.alamatPengirim': 'Shipper address',
  'ccn.merge.field.namaPenerima': 'Consignee name',
  'ccn.merge.field.alamatPenerima': 'Consignee address',
  'ccn.merge.field.npwpPenerima': 'Consignee tax ID',
  'ccn.merge.field.namaNotify': 'Notify party name',
  'ccn.merge.field.alamatNotify': 'Notify party address',
  'ccn.merge.field.berat': 'Gross weight (kg)',
  'ccn.merge.field.dimensi': 'Volume (m³)',
  'ccn.merge.field.jumlahKemasan': 'Package count',
  'ccn.merge.field.jenisKemasan': 'Package type',
  'ccn.merge.field.kodePelabuhanAsal': 'Port of loading',
  'ccn.merge.field.kodePelabuhanBongkar': 'Port of discharge',
  'ccn.merge.field.kodePelabuhanAkhir': 'Final destination',
  'ccn.merge.field.goods': 'Goods',

  // ---- Shipping Instruction (export upload + PEB Document tab) ----
  'upload.siGuide.link': 'What is a Shipping Instruction?',
  'upload.siGuide.heading': 'New on export upload',
  'upload.siGuide.what.title': 'Shipping Instruction has its own type',
  'upload.siGuide.what.body':
    "The forwarder's shipping instruction — usually an e-mail listing DEST, ETD, MAWB/HAWB, QTY, INV and FLIGHT — can now be uploaded as a Shipping Instruction. There is no need to upload it as an AWB any more.",
  'upload.siGuide.pick.title': 'Pick "000 - Shipping Instruction"',
  'upload.siGuide.pick.body':
    'In the document type field, type "si" or "000" and pick 000 - Shipping Instruction. "Detect all" also recognises it from its contents, even when the file has no title.',
  'upload.siGuide.fills.title': 'Read to fill the PEB draft',
  'upload.siGuide.fills.body':
    'Jarvis reads the means of transport (flight or vessel), the ports, the estimated export date, and the package count and type, and fills them into the Header, Pengangkut and Kemasan tabs.',
  'upload.siGuide.notSent.title': 'Not sent to CEISA',
  'upload.siGuide.notSent.body':
    'A Shipping Instruction is not a customs document, so it is not added to the document table and is not sent to CEISA — there is no row to delete any more. The file stays viewable at the bottom of the Document tab, with the fields that were read from it.',
  'upload.siGuide.back': 'Back',
  'upload.siGuide.next': 'Next',
  'upload.siGuide.done': 'Got it',
  'export.si.title': 'Reference documents',
  'export.si.notSent': 'Not sent to CEISA',
  'export.si.hint':
    'A Shipping Instruction is read to help fill the draft, but it is not a customs document: it is not in the document table above and is not sent to CEISA.',
  'export.si.view': 'View',
  'export.si.hide': 'Close PDF',
  'export.si.loading': 'Loading details…',
  'export.si.sourceFor': 'Read as a source for these fields:',
  'export.si.sourceForNote':
    'A field that is also printed on another document (a packing list, for example) may have been filled from that document.',
  'export.si.sourceForNone': 'No field was filled from this document in this extraction.',
  'export.si.sourceForGeneral':
    'Its contents are used to help fill the Header, Entitas, Pengangkut and Kemasan & Peti Kemas tabs.',
  'export.si.field.exportLoadPort': 'Export loading port',
  'export.si.field.exportirName': 'Exporter name',
  'export.si.field.exportirAddress': 'Exporter address',
  'export.si.field.exportirIdentity': 'Exporter identity number',
  'export.si.field.exportirIdentityType': 'Exporter identity type',
  'export.si.field.recipientName': 'Recipient name',
  'export.si.field.recipientAddress': 'Recipient address',
  'export.si.field.recipientCountry': 'Recipient country',
  'export.si.field.meansTransportName': 'Means of transport',
  'export.si.field.voyNumber': 'Voyage/flight number',
  'export.si.field.modeOfTransportation': 'Mode of transport',
  'export.si.field.estimatedExportDate': 'Estimated export date',
  'export.si.field.originLoadingPort': 'Origin loading port',
  'export.si.field.exportLoadingPort': 'Export loading port',
  'export.si.field.unloadingPort': 'Unloading port',
  'export.si.field.destinationPort': 'Destination port',
  'export.si.field.destinationCountry': 'Destination country',
  'export.si.field.containerNumber': 'Container number',
  'export.si.field.containerSize': 'Container size',
  'export.si.field.containerType': 'Container type',
  'export.si.field.packageCount': 'Package count',
  'export.si.field.packageType': 'Package type',
  // Manifest "Dari PEB (NPE)" — outward draft from NPE PEBs (next-jarvis#583)
  'manifest.fromPabean.card.title': 'From PEB (NPE)',
  'manifest.fromPabean.card.subtitle': 'Pick PEBs that reached NPE, with no upload or AI extraction.',
  'manifest.fromPabean.preview.heading': 'Build a manifest from NPE PEBs',
  'manifest.fromPabean.preview.pick.title': 'Pick PEBs',
  'manifest.fromPabean.preview.pick.body':
    'Tick the NPE PEBs that ship together. The order you tick them is the pos order on the manifest.',
  'manifest.fromPabean.preview.create.title': 'Create the manifest',
  'manifest.fromPabean.preview.create.body':
    'The header, house BL/AWB, containers, HS lines and the PEB document are filled from the PEB data. No upload, no AI extraction.',
  'manifest.fromPabean.preview.masterBl.title': 'Upload the master BL (optional)',
  'manifest.fromPabean.preview.masterBl.body':
    'Upload or type the master BL in the draft whenever it is ready. The draft is saved without it.',
  'manifest.fromPabean.preview.dontShow': "Don't show this again",
  'manifest.fromPabean.preview.back': 'Back',
  'manifest.fromPabean.preview.next': 'Next',
  'manifest.fromPabean.preview.start': 'Start',
  'manifest.fromPabean.page.title': 'Create a manifest from NPE PEBs',
  'manifest.fromPabean.page.subtitle': 'Pick the PEBs that ship together; each PEB becomes one house BL/AWB.',
  'manifest.fromPabean.page.outward': 'Outward',
  'manifest.fromPabean.page.sea': 'Sea',
  'manifest.fromPabean.page.air': 'Air',
  'manifest.fromPabean.page.changeProduct': 'Change product',
  'manifest.fromPabean.page.guide': 'Guide',
  'manifest.fromPabean.note.always': 'Only PEBs created through JARVIS that have reached NPE are listed here.',
  'manifest.fromPabean.note.excluded':
    '{n} other NPE PEBs are not listed because they were not created through JARVIS — you can add them from inside the draft with',
  'manifest.fromPabean.note.susulan': 'Upload PEB Susulan',
  'manifest.fromPabean.note.susulanTip':
    'The "Upload PEB / BL Susulan" button is on the BL tab of the manifest draft. Upload the PEB PDF there to add a house BL.',
  'manifest.fromPabean.filter.dateFrom': 'Registered from',
  'manifest.fromPabean.filter.dateTo': 'To',
  'manifest.fromPabean.filter.search': 'Search aju no., registration no. or exporter',
  'manifest.fromPabean.col.aju': 'Aju No.',
  'manifest.fromPabean.col.daftar': 'Registration No. & Date',
  'manifest.fromPabean.col.npe': 'NPE Date',
  'manifest.fromPabean.col.exporter': 'Exporter',
  'manifest.fromPabean.col.buyer': 'Buyer',
  'manifest.fromPabean.col.ports': 'Loading → Unloading Port',
  'manifest.fromPabean.col.carrier': 'Vessel / Voyage',
  'manifest.fromPabean.col.bl': 'BL No.',
  'manifest.fromPabean.col.awb': 'AWB No.',
  'manifest.fromPabean.col.containers': 'Containers',
  'manifest.fromPabean.col.hs': 'HS',
  'manifest.fromPabean.col.status': 'Status',
  'manifest.fromPabean.status.inDraft': 'Already in a draft',
  'manifest.fromPabean.status.inDraftTip': 'Open the draft that already uses this PEB. It can still be selected.',
  'manifest.fromPabean.status.ready': 'Ready',
  'manifest.fromPabean.noBlTip': 'This PEB has no B/L or AWB document; fill it in on the draft',
  'manifest.fromPabean.empty.title': 'No usable NPE PEBs',
  'manifest.fromPabean.empty.body': 'Change the date range or the search terms.',
  'manifest.fromPabean.bar.selected': '{n} PEBs selected',
  'manifest.fromPabean.bar.reset': 'Clear selection',
  'manifest.fromPabean.bar.create': 'Create Manifest',
  'manifest.fromPabean.bar.max': 'At most {max} PEBs per manifest',
  'manifest.fromPabean.confirm.title': 'Create a manifest from PEBs',
  'manifest.fromPabean.confirm.mode': 'Mode',
  'manifest.fromPabean.confirm.kantor': 'Loading customs office',
  'manifest.fromPabean.confirm.carrier': 'Vessel / Voyage',
  'manifest.fromPabean.confirm.houses': 'House BL/AWB',
  'manifest.fromPabean.confirm.housesValue': '{n} (one per PEB)',
  'manifest.fromPabean.confirm.masterBl': 'Master BL',
  'manifest.fromPabean.confirm.masterBlValue': 'None yet — upload it on the draft',
  'manifest.fromPabean.confirm.firstPebNote': 'The manifest header follows the first selected PEB.',
  'manifest.fromPabean.confirm.prewarnTitle': 'Please note',
  'manifest.fromPabean.confirm.cancel': 'Cancel',
  'manifest.fromPabean.confirm.submit': 'Create Manifest',
  'manifest.fromPabean.confirm.createdTitle': 'Draft created with notes',
  'manifest.fromPabean.confirm.createdBody': 'The draft is saved. Check these notes in the editor:',
  'manifest.fromPabean.confirm.continue': 'Go to draft',
  'manifest.fromPabean.prewarn.vessel': 'Different vessel/voyage from the first PEB',
  'manifest.fromPabean.prewarn.port': 'Different loading port from the first PEB',
  'manifest.fromPabean.prewarn.kantor': 'Different loading customs office from the first PEB',
  'manifest.fromPabean.prewarn.used': 'Already used in another draft',
  'manifest.fromPabean.reason.NOT_FOUND': 'PEB not found',
  'manifest.fromPabean.reason.NOT_PEB': 'Not a PEB (BC 3.0)',
  'manifest.fromPabean.reason.NOT_NPE': 'No NPE yet',
  'manifest.fromPabean.reason.NO_STRUCTURED_DATA': 'Not created through JARVIS',
  'manifest.fromPabean.reason.MODE_MISMATCH': 'Wrong mode',
  'manifest.fromPabean.reason.KANTOR_MISMATCH': 'Different loading office',
  'manifest.fromPabean.reason.DUPLICATE_AJU': 'Selected twice',
  'manifest.fromPabean.reason.UNKNOWN': 'Cannot be used',
  'manifest.fromPabean.warning.VESSEL_MISMATCH':
    'Different vessel/voyage from the first PEB; the header uses the first PEB.',
  'manifest.fromPabean.warning.LOADING_PORT_MISMATCH': 'Different loading port from the first PEB.',
  'manifest.fromPabean.warning.NO_BL_ON_PEB':
    'The PEB has no B/L or AWB document; the house BL/AWB number was left empty.',
  'manifest.fromPabean.warning.GROSS_WEIGHT_MISSING':
    'The PEB has no gross weight (KGM); Bruto Total was left empty, fill it in the editor.',
  'manifest.fromPabean.rejected.toast': 'Some PEBs cannot be used. Check the rows marked in red.',
  'manifest.fromPabean.error.create': 'Could not create the manifest',
  'manifest.manualDraft.error.create': 'Could not create the manifest draft',
  'manifest.fromPabean.error.load': 'Could not load the PEB list',
  'manifest.fromPabean.masterBl.emptyTitle': 'No master BL yet',
  'manifest.fromPabean.masterBlStep.title': 'Upload the {doc} (optional)',
  'manifest.fromPabean.masterBlStep.body':
    'If you already have the {doc}, upload it now and it is extracted into the draft right after it is created. If not, skip — you can upload or type the {doc} in the draft at any time.',
  'manifest.fromPabean.masterBlStep.drop': 'Drag the {doc} PDF here or click to choose',
  'manifest.fromPabean.masterBlStep.hint': 'One PDF file, up to 20 MB',
  'manifest.fromPabean.masterBlStep.rejected': 'Only one PDF file of up to 20 MB.',
  'manifest.fromPabean.masterBlStep.remove': 'Remove file',
  'manifest.fromPabean.masterBlStep.skip': 'Skip',
  'manifest.fromPabean.masterBlStep.next': 'Next',
  'manifest.fromPabean.confirm.masterBlFile': '{name} — extracted after the draft is created',
  'manifest.fromPabean.confirm.creating': 'Creating the draft…',
  'manifest.fromPabean.confirm.extracting': 'Draft created. Extracting the master BL…',
  'manifest.fromPabean.confirm.masterBlFailed':
    'The draft was created, but the master BL could not be extracted: {reason}. Upload it again from the Master BL tab of the draft.',
  'manifest.fromPabean.masterBl.emptyBody':
    'You can fill in the master BL later; the draft is saved. Upload the master BL document or click Tambah Master BL.',
  // Manifest "Dari PIB (SPPB)" — inward draft from SPPB PIBs (next-jarvis#591)
  'manifest.fromPabean.page.inward': 'Inward',
  'manifest.fromPabean.col.sppb': 'SPPB date',
  'manifest.fromPabean.col.importer': 'Importer',
  'manifest.fromPabean.col.sender': 'Sender (country)',
  'manifest.fromPabean.col.bc11': 'BC 1.1 (number/pos)',
  'manifest.fromPabean.reason.NOT_PIB': 'Not a PIB (BC 2.0)',
  'manifest.fromPabean.reason.NOT_SPPB': 'No SPPB yet',
  'manifest.fromPabean.warning.DISCHARGE_PORT_MISMATCH': 'Different discharge port from the first PIB.',
  'manifest.fromPabean.warning.NO_BL_ON_PIB': 'The PIB has no B/L/AWB document; the house BL/AWB number is left empty.',
  'manifest.fromPabean.warning.BC11_REF_DROPPED': 'The original BC 1.1 reference is not stored on the draft —',
  'manifest.fromPabean.warning.NO_PIB_DOC_CODE': 'The PIB origin document was not filled in —',
  'manifest.fromPabean.inward.card.title': 'From PIB (SPPB)',
  'manifest.fromPabean.inward.card.subtitle': 'Pick PIBs that reached SPPB, with no upload or AI extraction.',
  'manifest.fromPabean.inward.preview.heading': 'Build a manifest from SPPB PIBs',
  'manifest.fromPabean.inward.preview.pick.title': 'Pick PIBs',
  'manifest.fromPabean.inward.preview.pick.body':
    'Tick the SPPB PIBs consolidated together. The order you tick them is the pos order on the manifest.',
  'manifest.fromPabean.inward.preview.create.body':
    'The header, house BL/AWB, containers and HS lines are filled from the PIB data. No upload, no AI extraction.',
  'manifest.fromPabean.inward.page.title': 'Create a manifest from SPPB PIBs',
  'manifest.fromPabean.inward.page.subtitle': 'Pick the PIBs consolidated together; each PIB becomes one house BL/AWB.',
  'manifest.fromPabean.inward.note.always': 'Only PIBs created through JARVIS that have reached SPPB are listed here.',
  'manifest.fromPabean.inward.note.excluded':
    '{n} other SPPB PIBs are not listed because they were not created through JARVIS — you can add their house BL/AWB from inside the draft with',
  'manifest.fromPabean.inward.note.susulan': 'Upload BL/AWB Susulan',
  'manifest.fromPabean.inward.note.susulanTip':
    'The "Upload BL/AWB Susulan" button is on the BL tab of the manifest draft. Upload the BL/AWB PDF there to add a house BL.',
  'manifest.fromPabean.inward.filter.search': 'Search aju no., registration no. or importer',
  'manifest.fromPabean.inward.status.inDraftTip':
    'Open the draft that already uses this PIB. The PIB can still be picked.',
  'manifest.fromPabean.inward.noBlTip': 'This PIB has no B/L/AWB document; fill it in on the draft',
  'manifest.fromPabean.inward.empty.title': 'No usable SPPB PIBs',
  'manifest.fromPabean.inward.bar.selected': '{n} PIBs selected',
  'manifest.fromPabean.inward.bar.max': 'At most {max} PIBs per manifest',
  'manifest.fromPabean.inward.confirm.title': 'Create a manifest from PIBs',
  'manifest.fromPabean.inward.confirm.kantor': 'Customs office',
  'manifest.fromPabean.inward.confirm.housesValue': '{n} (one per PIB)',
  'manifest.fromPabean.inward.confirm.firstPebNote': 'The manifest header follows the first selected PIB.',
  'manifest.fromPabean.inward.prewarn.vessel': 'Different vessel/voyage from the first PIB',
  'manifest.fromPabean.inward.prewarn.dischargePort': 'Different discharge port from the first PIB',
  'manifest.fromPabean.inward.prewarn.kantor': 'Different customs office from the first PIB',
  'manifest.fromPabean.inward.reason.NOT_FOUND': 'PIB not found',
  'manifest.fromPabean.inward.reason.KANTOR_MISMATCH': 'Different customs office',
  'manifest.fromPabean.inward.warning.VESSEL_MISMATCH':
    'Different vessel/voyage from the first PIB; the header uses the first PIB.',
  'manifest.fromPabean.inward.warning.GROSS_WEIGHT_MISSING':
    'The PIB has no gross weight (KGM); Bruto Total was left empty, fill it in the editor.',
  'manifest.fromPabean.inward.rejected.toast': 'Some PIBs cannot be used. Check the rows marked in red.',
  'manifest.fromPabean.inward.error.load': 'Failed to load PIBs',
  'pungutanform.readiness.preferentialMfn':
    'Item(s) {seri}: the preferential schedule in force gives no special rate for their HS (MFN), so BM uses the general rate.',
  'barangform.preferentialMfnTooltip': '{preference}: "{raw}" for this HS → MFN rate applied.',
  'barangform.inswCocokPreferensi': 'Matches INSW — {pref} preferential rate {value}% (MFN {mfn}%)',
  'barangform.inswPreferensiTidakDipakai':
    '{pref} preferential rate {value}% is available from the COO, but BM uses MFN {mfn}%',
  'barangform.inswGagal': 'Could not fetch the INSW tariff for this HS',
  'barangform.dataInswUmur': 'INSW data: {age}',
  'barangform.smartSync': 'Smart Sync',
  'barangform.noItemsToSync': 'No goods to sync',
  'barangform.gagalSimpanSebelumSync': 'Failed to save the goods before syncing',
  'barangform.smartSyncSukses': 'Smart Sync completed successfully',
  'barangform.smartSyncGagal': 'Smart Sync failed',
  'barangform.noValidHsSync': 'No valid HS codes found to sync',
  'barangform.justNow': 'just now',
  'barangform.hoursAgo': '{count} hours ago',
  'barangform.oneDayAgo': '1 day ago',
  'barangform.daysAgo': '{count} days ago',
  'barangform.smartSyncStatusLain': 'Smart Sync status: {status}',
  'barangform.smartSyncStatus.never': 'Smart Sync · Never run on this draft',
  'barangform.smartSyncStatus.stale': 'Smart Sync · Last run {relative} by {lastBy} · {count} goods changes since',
  'barangform.smartSyncStatus.fresh': 'Smart Sync · Last run {relative} by {lastBy}',
  'barangform.preferentialMfnFallbackPreference': 'The preferential schedule in force',
  'trq.status.trq':
    'This HS is a tariff-rate-quota (TRQ) line. Outside the quota the MFN rate applies; tick "in-quota" and enter the quota allocation number to use the in-quota rate.',
  'trq.status.trq.badge': 'TRQ · MFN',
  'trq.status.trq_in_quota': 'The TRQ in-quota rate is applied, based on the allocation number entered.',
  'trq.status.trq_in_quota.badge': 'TRQ in-quota',
  'trq.status.trq_no_ref': 'Claimed in-quota without a quota allocation number — BM stays MFN.',
  'trq.status.trq_no_ref.badge': 'TRQ · incomplete',
  'trq.status.trq_no_rate':
    'Claimed in-quota, but no TRQ rate for this HS and agreement is in the TRQ rate master — BM stays MFN.',
  'trq.status.trq_no_rate.badge': 'TRQ · no rate',
  'trq.status.trq_no_qty':
    'Claimed in-quota, but the quantity in the TRQ rate unit is unknown (fill netto or use the same unit) — BM stays MFN.',
  'trq.status.trq_no_qty.badge': 'TRQ · unit',
  'trq.blocked.NO_QUOTA_REF': 'Item {seri}: the TRQ in-quota claim has no quota allocation number, BM stays MFN.',
  'trq.blocked.NO_RATE': 'Item {seri}: no TRQ in-quota rate in the TRQ rate master, BM stays MFN.',
  'trq.blocked.NO_QUANTITY': 'Item {seri}: quantity in the TRQ rate unit is unknown, BM stays MFN.',
  'pungutanform.readiness.trq':
    "Item(s) {seri}: tariff-rate-quota (TRQ) line — BM uses MFN unless claimed in-quota in the item's Pungutan tab.",
  'pungutanform.readiness.trqInQuota': 'Item(s) {seri}: TRQ in-quota rate applied.',
  'trq.claim.title': 'Tariff-rate quota (TRQ)',
  'trq.claim.inQuota': 'Claim the in-quota rate (TRQ)',
  'trq.claim.quotaRef': 'Quota allocation number',
  'trq.claim.quotaRefPlaceholder': "Importer's quota allocation letter number",
  'trq.claim.quotaRefRequired': 'Quota allocation number is required',
  'trq.claim.save': 'Save claim',
  'trq.claim.saved': 'TRQ claim saved',
  'trq.claim.savedHint': "This item's BM has been refreshed.",
  'trq.claim.saveFailed': 'Failed to save the TRQ claim',
  'trq.tarif.specificLabel': 'Rate (Rp/{unit})',
  'trq.tarif.jumlahSatuan': 'Quantity',
  'trq.tarif.satuan': 'Unit',
  'pungutanform.readiness.specificNoQty':
    'Item(s) {seri}: BM is a specific rate (Rp per unit) but the quantity is 0 — fill netto or the quantity; BM is still Rp0.',
  // CEISA answered Generate with a message instead of pungutan (next-jarvis#779)
  'pungutanform.miss.ajuNotFound':
    'CEISA cannot find this AJU. It was probably deleted in the CEISA portal. Resend the draft from JARVIS if needed.',
  'pungutanform.miss.ceisaMessage': 'CEISA: {message}',
  'pungutanform.miss.lastCeisa': 'Last CEISA result',
  'pungutanform.miss.lastCeisaAt': 'Last CEISA result · {time} WIB',
  'pungutanform.estimate.button': 'Calculate JARVIS estimate',
  'pungutanform.estimate.toggle': 'JARVIS estimate',
  'pungutanform.estimate.badge': 'JARVIS estimate, not from CEISA',
  'pungutanform.estimate.failed': 'Failed to calculate the JARVIS estimate',
  'menu.tarifTrq': 'TRQ Rates',
  'trqmaster.title': 'TRQ in-quota rates',
  'trqmaster.subtitle':
    "In-quota rates for tariff-rate-quota (TRQ) lines, which INSW does not publish. Enter them from the regulation's annex (e.g. PMK 60 Tahun 2026); they apply only to items claimed in-quota with an allocation number.",
  'trqmaster.add': 'Add TRQ rate',
  'trqmaster.edit': 'Edit',
  'trqmaster.delete': 'Delete',
  'trqmaster.save': 'Save',
  'trqmaster.cancel': 'Cancel',
  'trqmaster.searchHs': 'Search HS…',
  'trqmaster.empty': 'No TRQ rates yet',
  'trqmaster.saved': 'TRQ rate saved',
  'trqmaster.saveFailed': 'Failed to save the TRQ rate',
  'trqmaster.loadFailed': 'Failed to load TRQ rates',
  'trqmaster.deleteFailed': 'Failed to delete the TRQ rate',
  'trqmaster.deleteConfirm': 'Delete the TRQ rate for HS {hs}?',
  'trqmaster.col.hs': 'HS Code',
  'trqmaster.col.preference': 'Agreement',
  'trqmaster.col.rate': 'In-quota rate',
  'trqmaster.col.validity': 'Valid',
  'trqmaster.col.regulation': 'Regulation',
  'trqmaster.preferenceHint': 'Agreement name as INSW prints it, e.g. IJEPA',
  'trqmaster.rateType': 'Rate type',
  'trqmaster.rateType.specific': 'Specific (Rp per unit)',
  'trqmaster.rateType.adValorem': 'Ad valorem (%)',
  'trqmaster.rateRp': 'Rate (Rp per unit)',
  'trqmaster.ratePct': 'Rate (%)',
  'trqmaster.unit': 'Unit',
  'trqmaster.validFrom': 'Valid from',
  'trqmaster.validTo': 'Valid until',
  'trqmaster.notes': 'Notes',
  'trqmaster.err.hs': 'HS must have 8 digits',
  'trqmaster.err.required': 'Required',
  'trqmaster.err.rate': 'Invalid rate',
  'trqmaster.err.pct': 'An ad valorem rate is at most 100%',
  'trqmaster.err.unit': 'A specific rate needs a unit',
  'trqmaster.err.validTo': 'End date is before start date',

  // ---- CEISA /document/check rejection (utils/ceisa-check-issues.ts) ----
  'ceisaCheck.rejected': 'CEISA rejected the document: {issues}',
  'ceisaSubmit.upstreamPpjkMismatch':
    "CEISA is having problems and rejected this submission. Your data is correct and doesn't need changes. Please try again in a few minutes.",
  'ceisaSubmit.accountPpjkMismatch':
    'The CEISA account used (NPWP {accountNpwp}) differs from the PPJK on the document (NPWP {ppjkNpwp}). Check the PPJK on the Entitas tab or ask your admin for the right CEISA account.',
  'ceisaCheck.sentence': '{subject} {problem}.',
  'ceisaCheck.sentenceOther': '{subject}: {text}.',
  'ceisaCheck.textOnly': '{text}.',
  'ceisaCheck.item': 'Data',
  'ceisaCheck.subjectGoods': '{field} of item no. {seris}',
  'ceisaCheck.subjectGoodsNested': '{field} ({array}) of item no. {seris}',
  'ceisaCheck.subjectArray': '{field} ({array} #{n})',
  'ceisaCheck.problem.decimals': 'can have at most {n} decimal places',
  'ceisaCheck.problem.integer': 'must be a whole number',
  'ceisaCheck.problem.multiple': 'must be a multiple of {n}',
  'ceisaCheck.problem.required': 'is required',
  'ceisaCheck.problem.maxLength': 'can be at most {n} characters',
  'ceisaCheck.problem.minLength': 'must be at least {n} characters',
  'ceisaCheck.problem.max': 'cannot be more than {n}',
  'ceisaCheck.problem.min': 'cannot be less than {n}',
  'ceisaCheck.problem.lessThan': 'must be less than {n}',
  'ceisaCheck.problem.greaterThan': 'must be greater than {n}',
  'ceisaCheck.problem.date': 'is not a valid date',
  'ceisaCheck.problem.format': 'has an invalid format',
  'ceisaCheck.problem.enum': 'has a value CEISA does not recognise',
  'ceisaCheck.problem.type': 'has the wrong kind of value',
  'ceisaCheck.field.alamatEntitas': 'Party address',
  'ceisaCheck.field.asuransi': 'Insurance',
  'ceisaCheck.field.bruto': 'Gross weight',
  'ceisaCheck.field.cif': 'CIF',
  'ceisaCheck.field.cifRupiah': 'CIF (IDR)',
  'ceisaCheck.field.fob': 'FOB',
  'ceisaCheck.field.freight': 'Freight',
  'ceisaCheck.field.hargaSatuan': 'Unit price',
  'ceisaCheck.field.hs': 'HS code',
  'ceisaCheck.field.jumlahKemasan': 'Package quantity',
  'ceisaCheck.field.jumlahSatuan': 'Quantity',
  'ceisaCheck.field.kodeDokumen': 'Document code',
  'ceisaCheck.field.kodeFasilitas': 'Facility code',
  'ceisaCheck.field.kodeJenisKemasan': 'Package type',
  'ceisaCheck.field.kodeNegaraAsal': 'Country of origin',
  'ceisaCheck.field.kodeSatuanBarang': 'Unit',
  'ceisaCheck.field.merk': 'Brand',
  'ceisaCheck.field.namaEntitas': 'Party name',
  'ceisaCheck.field.ndpbm': 'Exchange rate (NDPBM)',
  'ceisaCheck.field.netto': 'Net weight',
  'ceisaCheck.field.nilaiBarang': 'Goods value',
  'ceisaCheck.field.nomorAju': 'Aju number',
  'ceisaCheck.field.nomorBc11': 'BC 1.1 number',
  'ceisaCheck.field.nomorDokumen': 'Document number',
  'ceisaCheck.field.nomorIdentitas': 'ID number',
  'ceisaCheck.field.nomorKontainer': 'Container number',
  'ceisaCheck.field.posBc11': 'BC 1.1 item',
  'ceisaCheck.field.posTarif': 'HS code',
  'ceisaCheck.field.spesifikasiLain': 'Other specification',
  'ceisaCheck.field.subposBc11': 'BC 1.1 sub-item',
  'ceisaCheck.field.tanggalBc11': 'BC 1.1 date',
  'ceisaCheck.field.tanggalDokumen': 'Document date',
  'ceisaCheck.field.tarif': 'Tariff rate',
  'ceisaCheck.field.tipe': 'Type',
  'ceisaCheck.field.ukuran': 'Size',
  'ceisaCheck.field.uraian': 'Description',
  'ceisaCheck.field.volume': 'Volume',
  'ceisaCheck.array.barangDokumen': 'document',
  'ceisaCheck.array.barangTarif': 'tariff',
  'ceisaCheck.array.dokumen': 'document',
  'ceisaCheck.array.entitas': 'party',
  'ceisaCheck.array.kemasan': 'package',
  'ceisaCheck.array.kontainer': 'container',
  'ceisaCheck.array.pengangkut': 'carrier',

  // Dokumen tab selection mode + bulk actions (PIB, BC 2.3, PEB).
  'dokumenform.bulk.total': 'Total: {count}',
  'dokumenform.bulk.selected': '{count} selected',
  'dokumenform.bulk.selectAll': 'Select all documents',
  'dokumenform.bulk.selectRow': 'Select document {serial}',
  'dokumenform.bulk.clear': 'Clear selection',
  'dokumenform.bulk.edit': 'Edit',
  'dokumenform.bulk.editTooltip': 'Bulk edit the selected documents',
  'dokumenform.bulk.duplicate': 'Duplicate',
  'dokumenform.bulk.duplicateTooltip': 'Duplicate the selected documents',
  'dokumenform.bulk.attach': 'Attach',
  'dokumenform.bulk.attachTooltip': 'Attach the selected documents to goods',
  'dokumenform.bulk.delete': 'Delete',
  'dokumenform.bulk.deleteTooltip': 'Delete the selected documents',
  'dokumenform.bulk.cancel': 'Cancel',
  'dokumenform.bulk.apply': 'Apply',
  'dokumenform.bulk.successTitle': 'Done',
  'dokumenform.bulk.errorTitle': 'Failed',
  'dokumenform.bulk.noNumber': '(no number)',
  'dokumenform.bulk.editTitle': 'Bulk Edit Documents',
  'dokumenform.bulk.editCount': 'Changing {count} documents',
  'dokumenform.bulk.editHint':
    'Leave a field blank to keep it as it is. Document codes and numbers are not changed here.',
  'dokumenform.bulk.fieldDate': 'Document date',
  'dokumenform.bulk.fieldDatePlaceholder': 'Pick a date',
  'dokumenform.bulk.fieldFacility': 'Facility code',
  'dokumenform.bulk.fieldFacilityPlaceholder': 'Pick a facility',
  'dokumenform.bulk.fieldIjin': 'Permit code',
  'dokumenform.bulk.fieldIjinPlaceholder': 'Enter a permit code',
  'dokumenform.bulk.fieldStatus': 'Status',
  'dokumenform.bulk.statusUnchanged': 'Unchanged',
  'dokumenform.bulk.editSuccess': '{count} documents updated',
  'dokumenform.bulk.duplicateTitle': 'Duplicate Documents',
  'dokumenform.bulk.duplicateConfirm':
    'Duplicate {count} documents? The copies start without a number, which must be filled in.',
  'dokumenform.bulk.duplicateSuccess': "{count} documents duplicated. Fill in the new documents' numbers.",
  'dokumenform.bulk.emptyNomorExists':
    'There is still a {kode} document without a number. Fill it in before duplicating again.',
  'dokumenform.bulk.nomorRequired': 'Number is required',
  'dokumenform.bulk.attachTitle': 'Attach to Goods',
  'dokumenform.bulk.attachCount': 'Attaching {count} documents to the goods picked below',
  'dokumenform.bulk.modeAdd': 'Add to existing attachments',
  'dokumenform.bulk.modeReplace': 'Replace attachments',
  'dokumenform.bulk.replaceWarning': 'The existing attachments of {count} documents will be replaced.',
  'dokumenform.bulk.skippedList': 'Skipped, these cannot be attached to goods: {list}',
  'dokumenform.bulk.allSkipped': 'None of the selected documents can be attached to goods.',
  'dokumenform.bulk.selectAllBarang': 'Select all goods',
  'dokumenform.bulk.barangPicked': '{count} goods selected',
  'dokumenform.bulk.noBarang': 'This draft has no goods yet.',
  'dokumenform.bulk.attachSuccess': 'Goods attached to {count} documents',
  'dokumenform.bulk.deleteTitle': 'Delete {count} Documents',
  'dokumenform.bulk.deleteLinks': '{count} goods attachments will be removed.',
  'dokumenform.bulk.deleteRestorable': 'After deleting, the documents can still be brought back with Undo.',
  'dokumenform.bulk.blockMinOne': 'At least 1 document must remain.',
  'dokumenform.bulk.blockRequiredCode': 'The last {kode} document cannot be deleted.',
  'dokumenform.bulk.deleteSuccess': '{count} documents deleted',
  'dokumenform.bulk.undo': 'Undo',
  'dokumenform.bulk.undoSuccess': 'Documents restored',
  'dokumenform.bulk.unknownSerial': 'The document list has changed. Reload the page and try again.',
  'dokumenform.bulk.flushFailed':
    'Pending document changes could not be saved, so the bulk action was not run. Try again.',
  'dokumenform.bulk.genericError': 'The bulk action failed. Try again.',
  // ---- Spesifikasi Khusus (next-jarvis#778) ----
  'editbarang.spekKhusus.required':
    'CEISA requires Spesifikasi Khusus for this HS code (e.g. the CAS number). Without it, the item cannot be saved in the CEISA portal.',
  'editbarang.spekKhusus.navMissing': 'Spesifikasi Khusus not filled in',
  'editbarang.spekKhusus.switchTitle': 'Change category?',
  'editbarang.spekKhusus.switchMessage': 'The {category} data will be deleted. Continue?',
  'editbarang.spekKhusus.switchCancel': 'Cancel',
  'editbarang.spekKhusus.switchConfirm': 'Continue',
  'editbarang.spekKhusus.untickTitle': 'Remove Spesifikasi Khusus?',
  'editbarang.spekKhusus.untickMessage': "This item's Spesifikasi Khusus will be deleted when you save. Continue?",
  'editbarang.spekKhusus.flagStaffOnly': 'Only JARVIS staff can mark an HS code as Spek Khusus.',
  'submitsummary.spekKhusus.title': 'Spesifikasi Khusus not filled in',
  'submitsummary.spekKhusus.body':
    'CEISA requires Spesifikasi Khusus (e.g. the CAS number) for the HS codes of the items below. Open each item and fill in its Spesifikasi Khusus section.',
  'submitsummary.spekKhusus.line': 'Item {seri} · {hs} · {uraian}',
  'submitsummary.spekKhusus.open': 'Fill in Spesifikasi Khusus',
  'submitsummary.spekKhusus.ack':
    'I understand CEISA may reject this item or refuse to save it without Spesifikasi Khusus',
  'submitsummary.spekKhusus.blocked': 'Tick the Spesifikasi Khusus confirmation above first',
  'submitsummary.kemasanTotal.title': 'Package count does not match',
  'submitsummary.kemasanTotal.barang': 'Barang tab ({seri} items)',
  'submitsummary.kemasanTotal.kemasan': 'Kemasan tab',
  'submitsummary.kemasanTotal.selisih': 'Difference',
  'submitsummary.kemasanTotal.body':
    'Check the package count of each item on the Barang tab and the count on the Kemasan & Peti Kemas tab.',
  'submitsummary.kemasanTotal.ack': 'I have checked the package count and still want to submit',
  'submitsummary.kemasanTotal.blocked': 'Tick the package count confirmation above first',
  'submitsummary.smartSync.neverTitle': 'Smart Sync has not been run',
  'submitsummary.smartSync.neverBody':
    'Goods tariffs, lartas, units and packaging have not been rechecked against INSW. Optional — you can still submit.',
  'submitsummary.smartSync.staleTitle': 'Goods changed after Smart Sync',
  'submitsummary.smartSync.staleBody':
    'Smart Sync last ran {relative} by {lastBy}; {count} goods changes since. Optional — you can still submit.',
  'submitsummary.smartSync.open': 'Open Smart Sync →',

  // next-jarvis#854: every key that used to fall back to Indonesian, in id order.
  'auth.welcome': 'Welcome back! Sign in to access your account',
  'auth.email': 'Email address',
  'auth.emailPlaceholder': 'example@mail.com',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Your password',
  'auth.signIn': 'Sign in',
  'auth.or': 'or',
  'auth.cubeLogin': 'Sign in with a CUBEforall account',
  'auth.reviewerLogin': 'Sign in as Reviewer',
  'auth.cubeErrorTitle': 'CUBEforall sign-in failed',
  'auth.showcase.headline': 'Customs documents done in minutes, not hours.',
  'auth.showcase.ariaLabel': 'JARVIS features',
  'auth.showcase.play': 'Play',
  'auth.showcase.pause': 'Pause',
  'auth.showcase.segBrand': 'JARVIS',
  'auth.showcase.segExtract': 'AI extraction',
  'auth.showcase.segHs': 'HS & Lartas',
  'auth.showcase.segCeisa': 'CEISA',
  'auth.showcase.segRadar': 'Radar',
  'auth.showcase.segUpload': 'Upload',
  'auth.showcase.extractTitle': 'AI extraction',
  'auth.showcase.extractDesc': 'Invoices and packing lists are read, and every value gets a confidence score.',
  'auth.showcase.tabBarang': 'Goods',
  'auth.showcase.itemsDetected': '{n} items detected',
  'auth.showcase.reading': 'Reading document',
  'auth.showcase.draftReady': 'PIB draft ready for review',
  'auth.showcase.verified': 'Verified',
  'auth.showcase.sampleData': 'Sample data',
  'auth.showcase.tipVerified': 'Verified',
  'auth.showcase.tipCheck': 'Check',
  'auth.showcase.tipAutoVerified': 'Automatically verified against the source',
  'auth.showcase.tipClickReview': 'Click to review against the source',
  'auth.showcase.tipHsConfidence': 'HS code extraction confidence',
  'auth.showcase.hsTitle': 'HS code and Lartas validation',
  'auth.showcase.hsDesc':
    'HS codes are checked against INSW, and Lartas status and tariffs are calculated automatically.',
  'auth.showcase.hsCode': 'Code',
  'auth.showcase.hsNormalized': 'Normalized code',
  'auth.showcase.hsUraian': 'Description (ID)',
  'auth.showcase.hsInswYear': 'INSW year',
  'auth.showcase.no': 'No',
  'auth.showcase.tipNoLartas': 'No Lartas permit required',
  'auth.showcase.tipBm': 'Import duty, MFN rate',
  'auth.showcase.tipPpn': 'Value Added Tax',
  'auth.showcase.tipPph': 'Import PPh Article 22, with API',
  'auth.showcase.tipPostel': 'Postel certificate required',
  'auth.showcase.ceisaTitle': 'Submit to CEISA 4.0',
  'auth.showcase.ceisaDesc': 'One click to send, and the status history flows back into JARVIS.',
  'auth.showcase.sent': 'Sent',
  'auth.showcase.tipDraft': 'Draft saved in JARVIS',
  'auth.showcase.tipSubmitted': 'Sent to CEISA 4.0',
  'auth.showcase.tipUmum': 'Accepted, lane assignment in progress',
  'auth.showcase.tipSppb': 'Goods Release Approval Letter',
  'auth.showcase.radarTitle': 'Manifest radar',
  'auth.showcase.radarDesc': 'Inbound and outbound manifests are monitored before the vessel arrives.',
  'auth.showcase.vessel': 'Vessel',
  'auth.showcase.remaining': 'Remaining',
  'auth.showcase.uploadTitle': 'Upload up to 50 documents',
  'auth.showcase.uploadDesc': 'Document types are recognised and grouped automatically.',
  'auth.showcase.dropHint': 'Drag and drop documents',
  'auth.showcase.typesDetected': '{n} document types detected',

  'docpabean.errorLoad': 'Failed to load customs documents.',
  'docpabean.retry': 'Try again',
  'docpabean.allStatus': 'All statuses',
  'docpabean.sortPlaceholder': 'Sort',
  'docpabean.filterStatus': 'Filter status',
  'docpabean.filterBranch': 'Filter branch',
  'docpabean.branchMine': 'My branch',
  'docpabean.branchAll': 'All branches',
  'docpabean.sortNewest': 'Sort: newest',
  'docpabean.sortAjuAsc': 'AJU number (A-Z)',
  'docpabean.sortAjuDesc': 'AJU number (Z-A)',
  'docpabean.sortShipperAsc': 'Shipper name (A-Z)',
  'docpabean.sortShipperDesc': 'Shipper name (Z-A)',
  'docpabean.sortDateOldest': 'AJU submitted (oldest)',
  'docpabean.sortDateNewest': 'AJU submitted (newest)',
  'docpabean.sortItemLeast': 'Total items (fewest)',
  'docpabean.sortItemMost': 'Total items (most)',
  'docpabean.downloadUsage': 'Download usage report',
  'docpabean.downloadReport': 'Download report',
  'docpabean.startDate': 'Start date',
  'docpabean.endDate': 'End date',
  'docpabean.selectStartDate': 'Choose start date',
  'docpabean.selectEndDate': 'Choose end date',
  'docpabean.docType': 'Document type',
  'docpabean.all': 'All',
  'docpabean.cancel': 'Cancel',
  'docpabean.download': 'Download',
  'docpabean.errSelectDates': 'Choose a start date and an end date',
  'docpabean.successDownloaded': 'Usage report downloaded',
  'docpabean.errDownload': 'Failed to download the usage report',
  'docpabean.errorTitle': 'Error',
  'docpabean.remainingCredits': 'Credits left',
  'docpabean.errLoadBalance': 'Failed to load balance',
  'docpabean.viewSubscription': 'View subscription',
  'docpabean.usageThisMonth': 'Usage this month',
  'docpabean.downloadModalTitle': 'Download report',
  'docpabean.loadingOptions': 'Loading options...',
  'docpabean.filterHint': 'Filter the export history by company name and/or date range. Drafter name is optional.',
  'docpabean.drafterName': 'Drafter name (optional)',
  'docpabean.drafterPlaceholder': 'Search and choose a drafter...',
  'docpabean.noDrafters': 'No drafters found',
  'docpabean.companyName': 'Company name',
  'docpabean.companyPlaceholder': 'Search and choose a company...',
  'docpabean.noCompanies': 'No companies found',
  'docpabean.errSelectCompanyDates': 'Choose a company and/or date range (drafter name optional)',
  'docpabean.errDateRequiredCompany': 'Start and end dates are required for {company} (DD-MM-YYYY)',
  'docpabean.errEndBeforeStart': 'End date must be on or after the start date',
  'docpabean.successReportDownloaded': 'Report downloaded',
  'docpabean.errReportDownload': 'Failed to download the report',
  'docpabean.colNomorAju': 'AJU number',
  'docpabean.colShipper': 'Shipper name',
  'docpabean.colBuyer': 'Buyer name',
  'docpabean.colDate': 'AJU submitted',
  'docpabean.colRespon': 'Response',
  'docpabean.colStatus': 'Status',
  'docpabean.colType': 'Type',
  'docpabean.colJenisKategori': 'Type | Export category',
  'docpabean.colDrafter': 'Drafter',
  'docpabean.colTotalItem': 'Total items',
  'docpabean.colApproval': 'Approval',
  'docpabean.colActions': 'Actions',
  'docpabean.colVesselVoy': 'Vessel & Voy',
  'docpabean.colTglTibaEkspor': 'ETA / ETD date',
  'docpabean.incompleteTitle': 'Some data could not be loaded',
  'docpabean.incompleteBody': 'The {list} column(s) could not be loaded right now. Your document data has not changed.',
  'docpabean.incompleteReload': 'Reload',
  'docpabean.incompleteCell': 'Failed to load',
  'docpabean.incompleteCellTooltip': 'This data could not be loaded. Click Reload above.',
  'docpabean.incompleteFiles': 'Files',
  'docpabean.tooltipTglTiba': 'Estimated arrival date',
  'docpabean.tooltipTglEkspor': 'Export date',
  'docpabean.sortTglTibaEksporNearest': 'ETA/ETD date (nearest)',
  'docpabean.sortTglTibaEksporFarthest': 'ETA/ETD date (farthest)',
  'docpabean.cardVessel': 'Vessel',
  'docpabean.cardTibaEkspor': 'ETA/ETD',
  'docpabean.kolom.button': 'Columns',
  'docpabean.kolom.title': 'Show columns',
  'docpabean.kolom.alwaysShown': 'Nomor Aju and Actions are always shown.',
  'docpabean.kolom.display': 'Display',
  'docpabean.kolom.showLogos': 'Show company logo / initials',
  'docpabean.kolom.showFlags': 'Show country flag',
  'docpabean.kolom.reset': 'Reset to default',
  'docpabean.filterShipmentType': 'Shipment type',
  'docpabean.filterNamaPerusahaan': 'Company name',
  'docpabean.filterDrafter': 'Drafter name',
  'docpabean.filterMotType': 'MOT type',
  'docpabean.motSea': 'Sea transport',
  'docpabean.motAir': 'Air transport',
  'docpabean.filterCountry': 'Shipper/consignee country',
  'docpabean.statusHistory': 'Status history',
  'docpabean.latest': 'Latest',
  'docpabean.respon': 'Response',
  'docpabean.tooltipVerified': 'Complete: invoice + BL/AWB',
  'docpabean.tooltipView': 'View',
  'docpabean.tooltipViewEdit': 'View / Edit',
  'docpabean.tooltipEdit': 'Edit',
  'docpabean.tooltipCopy': 'Copy',
  'docpabean.tooltipUpload': 'Upload files',
  'docpabean.tooltipSyncRespon': 'Sync response',
  'docpabean.tooltipDelete': 'Delete',
  'docpabean.deleteConfirm': 'Remove document {nomor} from the list? Documents already sent to CEISA are not affected.',
  'docpabean.deleteCancel': 'Cancel',
  'docpabean.deleteFiledWarning':
    'This document is already registered in CEISA. Deleting only hides it from Jarvis — the document stays in CEISA.',
  'docpabean.showDeleted': 'Show deleted',
  'docpabean.deletedBadge': 'Deleted',
  'docpabean.tooltipRestore': 'Restore',
  'docpabean.restoreConfirm': 'Restore document {nomor} to the list?',
  'docpabean.restore': 'Restore',
  'docpabean.delete': 'Delete',
  'docpabean.loadingData': 'Loading data...',
  'docpabean.emptyFilter': 'No documents match the current filter.',
  'docpabean.page': 'Page',
  'docpabean.company': 'Company',
  'docpabean.proses': 'Process',
  'docpabean.totalItemLabel': 'Total items',
  'docpabean.country': 'Country',
  'docpabean.export': 'Export',
  'docpabean.import': 'Import',
  'docpabean.justNow': 'just now',
  'docpabean.ago': 'ago',
  'docpabean.approved': 'Approved',
  'docpabean.waiting': 'Pending',
  'docpabean.needRevision': 'Needs revision',
  'docpabean.rejected': 'Rejected',
  'docpabean.cancelled': 'Cancelled',
  'docpabean.scheduled': 'Scheduled',
  'docpabean.freightZero.title': 'Freight is 0 — check the cost components',
  'docpabean.freightZero.body':
    'Incoterm {incoterm} requires Freight to be entered as a separate cost component, because the transport cost is not included in the invoice price. Freight is still 0, so the declared customs value may be wrong.',
  'docpabean.freightZero.hint':
    'Enter the transport cost (Freight) under Cost component information, then save. Once Freight is greater than 0, the document can be sent to CEISA.',
  'docpabean.freightZero.cta': 'Open cost components',
  'docpabean.freightZero.cancel': 'Cancel',
  'docpabean.freightUpload.dropTitle': 'Upload a freight screenshot or PDF',
  'docpabean.freightUpload.dropHint':
    'Drag and drop an image or PDF from email or WhatsApp here, click to choose a file, or paste with {paste}',
  'docpabean.freightUpload.ofUploaded': 'Ocean Freight (OF) document already uploaded',
  'docpabean.freightUpload.ofUploadedFiles': 'The freight amount was read from {files} when the PIB was created.',
  'docpabean.freightUpload.ofUploadedHint': 'The freight amount was read from that document when the PIB was created.',
  'docpabean.freightUpload.ofUploadedOverride':
    'Upload a screenshot or PDF below only if the freight amount needs to be replaced.',
  'docpabean.freightUpload.reading': 'Reading file...',
  'docpabean.freightUpload.readingHint': 'This usually takes only a few seconds',
  'docpabean.freightUpload.detected': 'Freight detected: {currency} {amount}',
  'docpabean.freightUpload.detectedSub': 'Read automatically from the file ({pct}% confidence, {method})',
  'docpabean.freightUpload.detectedSubNoPct': 'Read automatically from the file ({method})',
  'docpabean.freightUpload.mismatchInline':
    'Freight detected: {currency} {amount}, different from the transaction currency ({txn})',
  'docpabean.freightUpload.use': 'Use this amount',
  'docpabean.freightUpload.useAs': 'Use as {currency}',
  'docpabean.freightUpload.review': 'Review conversion',
  'docpabean.freightUpload.retry': 'Try again',
  'docpabean.freightUpload.dismiss': 'Close',
  'docpabean.freightUpload.lowConfidence': 'Low confidence ({pct}%). Check this amount before using it.',
  'docpabean.freightUpload.notFound': 'No freight could be read from this file',
  'docpabean.freightUpload.notFoundHint':
    'Try another file that shows the freight amount, or enter it manually under Cost component information.',
  'docpabean.freightUpload.currencyUnknown':
    'The amount {amount} was read, but its currency could not be determined from the image.',
  'docpabean.freightUpload.invalidType': 'The file must be an image (JPEG/PNG/WebP) or a PDF.',
  'docpabean.freightUpload.tooLarge': 'Maximum file size is 10 MB.',
  'docpabean.freightUpload.failed': 'Failed to read the file: {message}',
  'docpabean.freightUpload.applyFailed': 'Failed to save freight: {message}',
  'docpabean.freightUpload.applied': 'Freight {currency} {amount} saved to Cost component information',
  'docpabean.freightUpload.appliedInline': 'Freight {value} applied',
  'docpabean.freightUpload.appliedHintField': 'Saved to Cost component information',
  'docpabean.freightUpload.appliedFrom.converted':
    'From {currency} {amount}, converted to {txn} at the NDPBM exchange rate',
  'docpabean.freightUpload.appliedFrom.original': 'The amount {amount} was entered as-is as {txn} (read as {currency})',
  'docpabean.freightUpload.appliedFrom.assumed':
    'The amount {amount} was treated as {txn}; the currency could not be read from the file',
  'docpabean.freightUpload.appliedHintRow': 'Filled in on this row. Click Save to keep it.',
  'docpabean.freightUpload.method.ocr': 'OCR',
  'docpabean.freightUpload.method.gemini': 'AI',
  'docpabean.freightUpload.method.pdf-text': 'PDF text',
  'docpabean.freightUpload.method.pdf-ocr': 'PDF page OCR',
  'docpabean.freightUpload.mismatch.title': 'Freight currency differs',
  'docpabean.freightUpload.mismatch.body':
    'Freight was detected in {detected} ({detected} {detectedAmount}). This transaction is in {txn}. We will convert {detected} → {txn} to ±{converted} {txn} using the NDPBM exchange rate. Use the converted amount?',
  'docpabean.freightUpload.mismatch.bodyNoRate':
    'Freight was detected in {detected} ({detected} {detectedAmount}), while this transaction is in {txn}.',
  'docpabean.freightUpload.mismatch.rate':
    'NDPBM rate {detected}: 1 {detected} = Rp {ndpbmSrc}\nNDPBM rate {txn}: 1 {txn} = Rp {ndpbmTxn}\nResult: 1 {detected} ≈ {rate} {txn}',
  'docpabean.freightUpload.mismatch.noRate':
    'The NDPBM exchange rate for the conversion is not available right now, so the converted amount cannot be calculated. You can use the original amount or enter it manually.',
  'docpabean.freightUpload.mismatch.valutaHint':
    'If the invoice really is in {detected}, change the currency on the Price card first, then upload the image again.',
  'docpabean.freightUpload.mismatch.useConverted': 'Use converted amount',
  'docpabean.freightUpload.mismatch.useOriginal': 'Enter {amount} as {txn}',
  'docpabean.freightUpload.mismatch.cancel': 'Cancel',

  'statushistory.title': 'Status History',
  'statushistory.loading': 'Loading...',
  'statushistory.document': 'Document',
  'statushistory.by': 'by',
  'statushistory.totalItems': 'Total Items',
  'statushistory.item': 'item',
  'statushistory.items': 'items',
  'statushistory.country': 'Country',
  'statushistory.file': 'File',
  'statushistory.totalTime': 'Total Time',
  'statushistory.noData': 'No data available',
  'statushistory.viewResponHistory': 'View Response History',
  'statushistory.errFetch': 'Failed to load status history',
  'statushistory.errGeneric': 'Error loading status history',

  'buataju.import': 'Import',
  'buataju.importDesc': 'Create customs documents for importing goods into Indonesia.',
  'buataju.export': 'Export',
  'buataju.exportDesc': 'Create customs documents for exporting goods from Indonesia.',
  'buataju.bc33Desc':
    'Export Notification for Goods Through or From a PLB — for exports through/from a Bonded Logistics Center.',
  'buataju.ppftzDesc':
    'Create FTZ (511) documents from the Invoice, Packing List and B/L with AI, or fill them in manually.',
  'buataju.bc16Desc': 'Entry of imported goods into a Bonded Logistics Center (PLB).',
  'buataju.bc23Desc': 'Entry of imported goods into a TPB from a customs area or TPS.',
  'buataju.bc25Desc': 'Release of imported goods from a TPB to TLDDP for home use.',
  'buataju.bc261Desc': 'Temporary release of goods from a TPB to TLDDP against a guarantee.',
  'buataju.bc262Desc': 'Re-entry into a TPB of goods previously released temporarily.',
  'buataju.bc27Desc': 'Transfer of goods between TPBs, to a KEK, or to a free zone.',
  'buataju.bc28Desc': 'Release of goods from a PLB for home use or temporary import.',
  'buataju.bc40Desc': 'Entry of goods originating from TLDDP into a Bonded Storage Area.',
  'buataju.bc41Desc': 'Release of TLDDP-origin goods from a TPB back to TLDDP.',
  'buataju.bcp3betDesc': 'Notification document for bonded exhibition activities (P3BET).',
  'buataju.popular': 'Popular',
  'buataju.limitedAccess': 'Limited Access',
  'buataju.comingSoon': 'Coming Soon',
  'buataju.new': 'New',
  'buataju.locked': 'Locked',
  'buataju.start': 'Start',
  'buataju.badge': 'Process Customs Documents with Ease',
  'buataju.title': 'Choose a Document Type',
  'buataju.subtitle': 'Get started by choosing the customs document type that fits your business needs.',
  'buataju.typesAvailable': 'types available',
  'buataju.tpb': 'TPB',
  'buataju.tpbDesc': 'Bonded Storage Area',
  'buataju.codeImport': 'Import',
  'buataju.codeExport': 'Export',
  'buataju.codeEkspor': 'Export',
  'buataju.codePpftz': 'PPFTZ',
  'buataju.codeTpb': 'TPB',

  'upload.back': 'Back',
  'upload.title': 'Upload documents',
  'upload.subtitle': 'Upload and group your customs documents.',
  'upload.backToWizard': 'Back to the 3-step wizard flow',
  'upload.useWizard': 'Use wizard',
  'upload.documents': 'Documents',
  'upload.processing': 'Processing...',
  'upload.grouped': 'Grouped',
  'upload.readyToProcess': 'Ready to process',
  'upload.successCount': '{n} succeeded',
  'upload.failedCount': '{n} failed',
  'upload.reset': 'Reset',
  'upload.continueReview': 'Continue to review',
  'upload.uploadDocs': 'Upload {n} documents',
  'upload.processDocs': 'Process documents',
  'upload.uploading': 'Uploading... {p}%',
  'upload.groupingDocs': 'Grouping documents by type...',
  'upload.resultsTitle': 'Document upload results',
  'upload.total': 'Total',
  'upload.success': 'Succeeded',
  'upload.failed': 'Failed',
  'upload.caution': 'Attention',
  'upload.cautionMsg':
    'Some documents failed to upload. You can try again or continue with the documents that uploaded successfully.',
  'upload.successDocs': 'Successful documents ({n})',
  'upload.failedDocs': 'Failed documents ({n})',
  'upload.docType': 'Type: {type}',
  'upload.noDocType': 'No document type',
  'upload.errorLabel': 'Error: {msg}',
  'upload.reUpload': 'Upload again',
  'upload.continue': 'Continue',
  'upload.errCeisaCombine': 'CEISA Excel cannot be combined',
  'upload.errCeisaCombineMsg':
    'A CEISA Excel file must be uploaded on its own and cannot be combined with other documents.',
  'upload.errNoFile': 'No files',
  'upload.errNoFileMsg': 'Please add a file first',
  'upload.errNoType': 'Document type not selected',
  'upload.errNoTypeMsg': '{n} file(s) have no document type yet',
  'upload.errEmptyFile': 'size 0 bytes (empty file)',
  'upload.errInvalidPdf': 'not a valid PDF (header "{magic}", size {size} bytes)',
  'upload.errInvalidFile': 'Invalid file',
  'upload.successUploaded': 'Upload successful',
  'upload.successUploadedMsg': 'All documents were uploaded successfully.',
  'upload.doneUploading': 'Upload complete',
  'upload.partialMsg': '{success} of {total} documents uploaded successfully.',
  'upload.errCeisaProcess':
    'Failed to process the CEISA Excel: {msg}. The file has been saved — please continue on the draft page.',
  'upload.errUpload': 'An error occurred while uploading documents: {msg}',
  'upload.errUploadFile': 'Failed to upload the file.',
  'upload.errNoBatch': 'Batch UUID not found. Please upload documents first.',
  'upload.uploadGagal': 'Upload failed: the server did not return valid data',
  'upload.ceisaFileNotFound': 'CEISA EXCEL file not found',
  'upload.emptyHeader': 'Files to upload ({n})',
  'upload.searchPlaceholder': 'Search files...',
  'upload.selectDocType': 'Select document type',
  'upload.alreadySelected': 'already selected',
  'upload.noMatch': 'No files match "{q}"',
  'upload.noFiles': 'No files uploaded yet',
  'upload.dragDrop': 'Drag & drop or',
  'upload.clickBrowse': 'click to browse',
  'upload.dropPdf': 'Drop PDF files here',
  'upload.dropPdfExcel': 'Drop PDF/Excel files here',
  'upload.dropPdfExcelImg': 'Drop PDF/Excel/photo (JPG/PNG) files here',
  'upload.maxFiles': 'Max. {n} files',
  'upload.enlarge': 'Enlarge',
  'upload.shrink': 'Shrink',
  'upload.fmtNotMatch': 'Unsupported format',
  'upload.fmtPdfOnly': 'Only PDF files are allowed',
  'upload.fmtPdfExcel': 'Only PDF and Excel files are allowed',
  'upload.fmtPdfExcelImg': 'Only PDF, Excel and photo (JPG/PNG) files are allowed',
  'upload.tooMany': 'Too many files',
  'upload.tooManyMsg': 'A maximum of {n} files can be uploaded',
  'upload.cantSelect': 'Cannot select',
  'upload.masterOnlyOne': 'Only 1 {name} is allowed',
  'upload.fileCount': '{n} file(s)',
  'upload.groupedHeader': 'Documents have been grouped',
  'upload.dragReorder': 'Drag to reorder',
  'upload.splitTitle': 'Split a PDF into several documents',
  'upload.splitHint': 'Select a PDF file to mark segments, or click "Auto split" to have it read automatically.',
  'upload.notPdf': 'This file is not a PDF',
  'upload.pages': '{n} page(s)',
  'upload.activeSeg': 'Active: Seg {n}',
  'upload.pageOf': 'Page {cur} / {total}',

  'pdf.zoomIn': 'Zoom in (Ctrl + scroll)',
  'pdf.zoomOut': 'Zoom out (Ctrl + scroll)',
  'pdf.zoomReset': 'Reset zoom',

  'upload.smartSplit': 'Auto split',
  'upload.smartSplitHint': 'Auto split — read the PDF content and split it per document',
  'upload.smartSplitWorking': 'Reading documents',
  'upload.smartSplitNeedsPages': 'Needs at least 2 pages',
  'upload.smartSplitResult': '{n} documents found · {method}',
  'upload.smartSplitViaAi': 'read by AI',
  'upload.smartSplitViaText': 'from PDF text',
  'upload.smartSplitSingle': 'Only one document in this file — nothing to split.',
  'upload.smartSplitFailed': 'Detection failed',
  'upload.smartSplitFailedMsg': 'Could not read the document. Mark the segments manually.',
  'upload.smartSplitAll': 'Detect all',
  'upload.smartSplitAllHint': 'Read all PDFs at once — document types and page boundaries',
  'upload.smartSplitAllProgress': 'Reading {done}/{total}',
  'upload.aiDetectQueued': 'Waiting',
  'upload.aiDetectFailed': 'Detection failed — try again',
  'upload.mismatchDetected': 'The content reads as {type} ({pct}%), not {declared}',
  'upload.mismatchUse': 'Use {type}',
  'upload.mismatchIgnore': 'Ignore',
  'upload.junkSuggest': "Doesn't look like a shipping document ({pct}%) — ignore it?",
  'upload.junkSkip': 'Ignore document',
  'upload.junkKeep': 'Process anyway',
  'upload.junkSkipped': 'Ignored',
  'upload.errAllJunk': 'No documents to process',
  'upload.errAllJunkMsg': 'All files are marked as Other documents (ignore). Change their type to process them.',
  'upload.siblingHint': 'Reads as {type} — may be a better fit',
  'upload.bundleDetected': 'Holds {n} documents ({types}) — split it first',
  'upload.bundleOpen': 'Open splitter',
  'upload.issuesTitle': 'Check document types',
  'upload.issuesIntro': "The content of {n} file(s) doesn't match the selected type. Continue as is?",
  'upload.issuesDeclared': 'selected',
  'upload.issuesDetected': 'reads as',
  'upload.issuesBundle': 'holds {types} — not split yet',
  'upload.issuesContinue': 'Continue',
  'upload.issuesReview': 'Check again',
  'upload.waitDetection': 'Reading documents {done}/{total} — wait until it finishes',
  'upload.waitDetectionHint': 'The button is enabled once all documents have been read',
  'upload.needsType': 'choose type',
  'upload.lowConfidence': 'needs checking · {pct}%',
  'upload.confidence': '{pct}% sure',
  'upload.loadingPreview': 'Loading preview...',
  'upload.previewFailed': 'Preview cannot be displayed',
  'upload.previewFailedMsg': 'The file can still be auto split and uploaded.',
  'upload.addSegment': 'Add segment',
  'upload.segmentHint': 'Click the button above, then select pages in the thumbnails.',
  'upload.selectPages': 'Select pages in the thumbnails...',
  'upload.noPages': 'No pages yet',
  'upload.pagesLabel': 'Pages: {pages}',
  'upload.docTypePlaceholder': 'Document type',
  'upload.removeOriginal': 'Remove original file',
  'upload.extractSegments': 'Extract {n} segments',
  'upload.activateSegmentFirst': 'Click a segment below to activate it first',
  'upload.pageFreed': 'Page {page} removed from Segment {seg}',
  'upload.pageFreedClickAgain': 'Page {page} removed from Segment {seg}. Click again to move it to the active segment.',
  'upload.fileLimitReached': 'File limit reached',
  'upload.fileLimitReachedMsg': 'Cannot add a segment: it would exceed the {n}-file limit',
  'upload.segMinPages': 'Each segment must have at least 1 page',
  'upload.segNeedType': 'All segments must have a document type',
  'upload.segAllJunk': 'All segments are marked as Other documents — nothing to extract',
  'upload.segJunkSuggest': 'Ignore?',
  'upload.exceedLimit': 'Exceeds the {n}-file limit (currently {cur}, would add {add})',
  'upload.validationFailed': 'Validation failed',
  'upload.extractSuccess': '{n} file(s) created from "{name}"',
  'upload.extractFailed': 'Failed to split the PDF',
  'upload.detecting': 'Detecting...',
  'upload.detected': 'Detected',
  'upload.detectedMulti': '{n} document types detected',
  'upload.detectedSingle': 'Detected: {type}',
  'upload.detectFailed': 'Detection failed',
  'upload.splitSuggestion': 'Split document',
  'upload.unclassifiedPages': '{n} page(s) not identified',

  'doctype.PL': '(PL) Packing List',
  'doctype.I': '(I) Invoice',
  'doctype.BL': '(BL) Bill of Lading',
  'doctype.MBL': '(MBL) Master Bill of Lading',
  'doctype.SI': '(SI) Shipping Instruction',
  'doctype.BR': '(BR) Booking Receipt',
  'doctype.COO': '(COO) Certificate of Origin',
  'doctype.ECOO': '(E-COO) Electronic Certificate of Origin',
  'doctype.AWB': '(AWB) Air Waybill',
  'doctype.MAWB': '(MAWB) Master Air Waybill',
  'doctype.LS': '(LS) Surveyor Report',
  'doctype.POSTEL': '(POSTEL) Postel',
  'doctype.PI': '(PI) Import Approval',
  'doctype.AKL': '(AKL) Medical Device Registration Number/Ministry of Health',
  'doctype.SKI': '(SKI) BPOM LOADING APPROVAL LETTER',
  'doctype.SKB': '(SKBPPN) Import PPN Exemption Letter (SKB)',
  'doctype.SKBPPH': '(SKBPPH) Import PPh Article 22 Exemption Letter (SKB)',
  'doctype.SKBPP23': '(SKBPP23) PP 23 Final PPh Exemption Letter (SKB)',
  'doctype.SNI': '(SNI) SNI',
  'doctype.VLEGAL': '(VLEGAL) V-LEGAL',
  'doctype.CITES': '(CITES) CITES',
  'doctype.HC': '(HC) Health Certificate',
  'doctype.SKEPTPB': '(SKEPTPB) SKEP-TPB',
  'doctype.PE': '(PE) Export Approval',
  'doctype.SKEM': '(SKEM) SKEM',
  'doctype.SNISPBDEPDAG': '(SNISPBDEPDAG) SNISPBDEPDAG',
  'doctype.PP': '(PP) Licensing Exemption RB3 / B3 Registration / KLH',
  'doctype.EXC-JRE': '(CIPL - JRE) CIPL - JRE',
  'doctype.EXC-ARJUNA': '(CIPL - ARJUNA) CIPL - ARJUNA',
  'doctype.EXC-OBOR': '(CIPL - OBOR) CIPL - OBOR',
  'doctype.EXC-BENING': '(CIPL - BENING) CIPL - BENING',
  'doctype.EXC-NADA': '(CIPL - NADA) CIPL - NADA',
  'doctype.EXC-MINEBEA': '(CIPL - MINEBEA) CIPL - MINEBEA',
  'doctype.EXC-WIDE-SUCCESS': '(CIPL - WIDE SUCCESS) CIPL - WIDE SUCCESS',
  'doctype.EXC-NICESO': '(CIPL - NICESO) CIPL - NICESO',
  'doctype.EXC-CEISA': '(EXCEL CEISA) Excel CEISA',
  'doctype.SKEP': '(SKEP) SKEP',
  'doctype.980': '(980) Import Declaration',
  'doctype.530': '(530) Insurance Policy',
  'doctype.OF': '(OF) Ocean Freight / Freight Charges',
  'doctype.JUNK': 'Other documents (ignore)',

  'headerform.labelPelabuhan': 'Port',
  'headerform.labelKantorPabean': 'Customs Office',
  'headerform.labelPIB': 'PIB',
  'headerform.labelJenisImpor': 'Import Type',
  'headerform.labelCaraBayar': 'Payment Method',
  'headerform.placeholderPelabuhan': 'Select port',
  'headerform.placeholderKantorPabean': 'Select customs office',
  'headerform.placeholderPIB': 'Select PIB type',
  'headerform.placeholderJenisImpor': 'Select import type',
  'headerform.placeholderCaraBayar': 'Select payment method',
  'headerform.pibOpt1': '1 - REGULAR',
  'headerform.pibOpt2': '2 - PERIODIC',
  'headerform.imporOpt1': '1 - FOR HOME USE',
  'headerform.imporOpt2': '2 - TEMPORARY',
  'headerform.imporOpt5': '5 - RUSH HANDLING',
  'headerform.imporOpt9': '9 - COMBINATION OF 1 AND 2',
  'headerform.bayarOpt1': '1 - REGULAR/CASH',
  'headerform.bayarOpt2': '2 - PERIODIC',
  'headerform.bayarOpt10': '10 - DEFERRED PAYMENT (OPEN ACCOUNT) IN INSTALLMENTS',
  'headerform.bayarOpt11': '11 - DEFERRED PAYMENT (OPEN ACCOUNT) IN CASH',
  'headerform.bayarOpt12': '12 - MADE DOMESTICALLY WITH CASH PAYMENT',
  'headerform.bayarOpt13': '13 - MADE DOMESTICALLY WITH PAYMENT BY TELEGRAPHIC TRANSFER (T/T)',
  'headerform.bayarOpt14': '14 - MADE WITHOUT PAYMENT',
  'headerform.bayarOpt15': '15 - ADVANCE PAYMENT',
  'headerform.bayarOpt16': '16 - SIGHT LETTER OF CREDIT',
  'headerform.bayarOpt17': '17 - COLLECTION (COLLECTION DRAFT)',

  'dokumenform.col.seri': 'Item no.',
  'dokumenform.col.jenis': 'Type',
  'dokumenform.col.ecooStatus': 'eCOO status',
  'dokumenform.col.nomor': 'Number',
  'dokumenform.col.tanggal': 'Date',
  'dokumenform.col.fasilitas': 'Facility',
  'dokumenform.col.kodeIjin': 'Permit code',
  'dokumenform.col.attached': 'Attached',
  'dokumenform.col.state': 'Status',
  'dokumenform.col.aksi': 'Actions',
  'dokumenform.action.attachToBarang': 'Attach to goods',
  'dokumenform.action.edit': 'Edit',
  'dokumenform.action.copy': 'Copy',
  'dokumenform.action.uploadReplace': 'Upload / Replace file',
  'dokumenform.action.uploadReplaceAria': 'Upload or replace file',
  'dokumenform.action.delete': 'Delete',
  'dokumenform.action.deleteLastBlocked': 'The last document cannot be deleted — CEISA requires at least 2 documents',
  'dokumenform.action.undo': 'Undo',
  'dokumenform.deleted.title': 'Deleted documents',
  'dokumenform.deleted.hint':
    'These documents will not appear in the Documents tab and are not sent to CEISA. Restore them if they were deleted by mistake.',
  'dokumenform.deleted.restore': 'Restore',
  'dokumenform.modal.attachTitle': 'Attach document to goods',
  'dokumenform.modal.replaceTitle': 'Replace the current selection?',
  'dokumenform.modal.uploadPdfTitle': 'Upload document PDF',
  'dokumenform.label.quickSelect': 'Quick select (range input)',
  'dokumenform.label.filterHsCode': 'Filter by HS code',
  'dokumenform.label.bulkSeriIjin': 'Bulk item no. in permit',
  'dokumenform.label.filePdf': 'PDF file',
  'dokumenform.label.tipeDokumen': 'Document type',
  'dokumenform.placeholder.rangeExample': 'Example: 1-2,3,5-8,10 (use item numbers, not indexes)',
  'dokumenform.placeholder.filterHsCode': 'Type an HS code to filter (e.g. 9403)',
  'dokumenform.placeholder.value': 'Value',
  'dokumenform.placeholder.pilihFilePdf': 'Choose a PDF file',
  'dokumenform.placeholder.url': 'https://... (House-BL / AWB / supporting document)',
  'dokumenform.button.batal': 'Cancel',
  'dokumenform.button.simpan': 'Save',
  'dokumenform.button.menyimpan': 'Saving...',
  'dokumenform.button.upload': 'Upload',
  'dokumenform.button.applyToSelected': 'Apply to selected ({n})',
  'dokumenform.button.clearSelection': 'Clear selection',
  'dokumenform.button.replaceSelection': 'Replace selection',
  'dokumenform.button.autoMatch': 'Auto-match',
  'dokumenform.button.autoMatchEcoo': 'Auto-match from E-COO',
  'dokumenform.button.validateEcoo': 'Validate eCOO',
  'dokumenform.button.autoSort': 'Sort automatically',
  'dokumenform.total': 'Total: {n}',
  'dokumenform.notify.success': 'Success',
  'dokumenform.notify.successTitle': 'Success',
  'dokumenform.notify.errorTitle': 'Error',
  'dokumenform.notify.failed': 'Failed',
  'dokumenform.notify.cannotUpload': 'Cannot upload yet',
  'dokumenform.notify.saveRowFirst': 'Save the document row before replacing the file.',
  'dokumenform.notify.formatNotSupported': 'Format not supported',
  'dokumenform.notify.onlyPdfExcel': 'Only PDF or Excel files (.xlsx/.xls/.csv) are allowed.',
  'dokumenform.notify.uploaded': '{name} uploaded',
  'dokumenform.notify.uploadFailed': 'Failed to upload the file',
  'dokumenform.notify.urlSaveFailed': 'Failed to save the document URL',
  'dokumenform.notify.documentAdded': 'Document added',
  'dokumenform.notify.documentUpdated': 'Document updated',
  'dokumenform.notify.documentAddFailed': 'Failed to save the new document',
  'dokumenform.notify.documentEditFailed': 'Failed to save the edited document',
  'dokumenform.notify.documentCopied': 'Document copied',
  'dokumenform.notify.documentCopyFailed': 'Failed to save the copied document',
  'dokumenform.notify.documentDeleted': 'Document deleted',
  'dokumenform.notify.documentDeleteFailed': 'Failed to save changes after deleting the document',
  'dokumenform.notify.cannotDeleteLastDocument':
    'At least one document must remain. CEISA requires at least 2 documents for submission.',
  'dokumenform.notify.documentRestored': 'Document restored',
  'dokumenform.notify.documentRestoreFailed': 'Failed to restore the document',
  'dokumenform.notify.stateChangedTo': 'Document status changed to {state}',
  'dokumenform.notify.stateUpdateFailed': 'Failed to update the document status',
  'dokumenform.notify.autoMatch': 'Auto-match',
  'dokumenform.notify.noAutoMatch': 'No confident match was found for this document. Please choose the goods manually.',
  'dokumenform.notify.processIdNotFound': 'Process ID not found',
  'dokumenform.notify.serialNotFound': 'Document item number not found',
  'dokumenform.notify.attachedToBarang': 'Document attached to {count} goods',
  'dokumenform.notify.attachedPartial':
    'Document attached to {count} of {requested} goods. {dropped} goods were rejected because they are already attached to another document with the same code.',
  'dokumenform.notify.attachFailed': 'Failed to save the goods attachments',
  'dokumenform.notify.pleaseSelectPdf': 'Please choose a PDF file first',
  'dokumenform.notify.pdfExtracted': 'Document extracted from the PDF',
  'dokumenform.notify.pdfExtractedWithEntitas': 'Document extracted from the PDF; the Entity tab was updated too',
  'dokumenform.notify.pdfUploadError': 'Something went wrong while uploading the PDF',
  'dokumenform.notify.orderUpdated': 'Document order updated',
  'dokumenform.notify.orderSaveFailed': 'Failed to save the document order',
  'dokumenform.notify.orderAlreadySorted': 'Documents are already in order',
  'dokumenform.notify.validationFailed': 'Validation failed',
  'dokumenform.notify.npwpRequired': 'Importer NPWP is required for eCOO validation',
  'dokumenform.notify.npwpInvalid': 'Importer NPWP is invalid',
  'dokumenform.notify.noDocsToValidate': 'No documents to validate',
  'dokumenform.notify.ecooInvalid': 'eCOO document is invalid',
  'dokumenform.notify.ajuRequired': 'AJU number (BL number) is required for eCOO validation',
  'dokumenform.notify.validationSuccess': 'Validation passed',
  'dokumenform.notify.ecooValidated': 'eCOO validated',
  'dokumenform.notify.ecooValidationFailed': 'eCOO validation failed',
  'dokumenform.notify.ecooError': 'Something went wrong during eCOO validation',
  'dokumenform.barang.selectPrompt': 'Choose the goods this document should be attached to:',
  'dokumenform.barang.findingEcoo': 'Finding suggested goods from the E-COO line items…',
  'dokumenform.barang.finding': 'Finding suggested goods for this document…',
  'dokumenform.barang.autoMatchShipment':
    'This shipment has only one goods item, so this document covers it. Check before saving.',
  'dokumenform.barang.noAutoMatchEcoo': 'No confident match with this E-COO line. Choose the goods manually.',
  'dokumenform.barang.noAutoMatch': 'No confident match for this document. Choose the goods manually.',
  'dokumenform.barang.colSeriBarang': 'Goods item no.',
  'dokumenform.barang.colHsCode': 'HS code',
  'dokumenform.barang.colNamaBarang': 'Goods name',
  'dokumenform.barang.colNoUrut': 'Item no. in permit',
  'dokumenform.barang.noItemsMatch': 'No items match HS code "{hs}"',
  'dokumenform.barang.noBarang': 'No goods available. Please add goods first.',
  'dokumenform.barang.loading': 'Loading goods...',
  'dokumenform.barang.showingCount': 'Showing {count} of {total} items',
  'dokumenform.barang.filterDescription': 'Filter goods by HS code',
  'dokumenform.barang.replacePrompt':
    'Auto-match will replace the {count} goods currently selected with the set suggested for this document. Nothing is saved until you click Save.',
  'dokumenform.barang.rangeDescription':
    'Enter goods item numbers separated by commas. Use a hyphen for a range (e.g. 1-5 means items 1,2,3,4,5)',
  'dokumenform.barang.unamed': 'UNNAMED',
  'dokumenform.barang.suggestedCoverage': 'Suggested · {label}',
  'dokumenform.barang.suggestedConfidence': 'Suggested · {confidence} · {percent}%',
  'dokumenform.barang.ecooItem': 'E-COO item: {desc}',
  'dokumenform.popover.autoMatch': 'Auto-match',
  'dokumenform.popover.loading': 'Loading…',
  'dokumenform.popover.noAutoMatchData': 'No auto-match data — attached manually',
  'dokumenform.popover.seri': 'Line {n}',
  'dokumenform.popover.wholeShipment': 'whole shipment',
  'dokumenform.popover.sameHsCode': 'same HS code ·',
  'dokumenform.popover.andMore': '…and {n} more',
  'dokumenform.popover.moreMatch': '{n} more goods match this document but are not attached',
  'dokumenform.file.downloadAria': 'Download {name}',
  'dokumenform.file.replaceTooltip': 'Replace file',
  'dokumenform.file.uploadTooltip': 'Upload file',
  'dokumenform.file.replaceAria': 'Replace file',
  'dokumenform.file.uploadAria': 'Upload file',
  'dokumenform.file.uploading': 'Uploading…',
  'dokumenform.file.replaceUploading': 'Replacing file…',
  'dokumenform.file.noUrlInResponse': 'The response does not contain the new file URL',
  'dokumenform.barang.statusSuggested': '{count} of {total} goods ticked automatically. Check before saving.',
  'dokumenform.barang.legend':
    'Green badge: matches a certificate line. Yellow badge: weaker match. No badge: not matched; tick it manually if the certificate covers it.',
  'dokumenform.barang.legendWithCount':
    'Green badge: matches a certificate line. Yellow badge: the certificate has as many lines as there are goods, so the rest are probably covered. Check before saving.',
  'dokumenform.barang.claimedNote':
    '{count} goods are already attached to another certificate and cannot be ticked here. Detach them there first if you want to move them.',
  'dokumenform.barang.showUnmatched': 'Show {count} unmatched goods',
  'dokumenform.barang.hideUnmatched': 'Hide {count} unmatched goods',
  'dokumenform.barang.suggestedHigh': 'Suggested {percent}%',
  'dokumenform.barang.suggestedMedium': 'Possible match {percent}%',
  'dokumenform.barang.suggestedCount': 'Suggested, same count',
  'dokumenform.barang.countTooltip':
    'This certificate has {n} lines, the same as the number of goods. This goods item did not match by text, but is probably covered.',
  'dokumenform.barang.suggestedHsCode': 'Suggested, same HS code',
  'dokumenform.barang.hsCodeTooltip': 'Same HS code as listed on the document: {hs}',
  'dokumenform.barang.claimedBadge': 'Already on line {seri}',
  'dokumenform.barang.claimedTooltip':
    'This goods item is already attached to document line {seri} with the same code. Detach it there first to move it here.',
  'dokumenform.button.selectAll': 'Select all ({n})',
  'dokumenform.button.deselectAll': 'Clear',
  'dokumenform.button.simpanCount': 'Save ({n} goods)',
  'dokumenform.barang.more': '+{n} more',
  'dokumenform.confidence.overall': 'Overall confidence',
  'dokumenform.confidence.documentNumber': 'Document number confidence',
  'dokumenform.confidence.documentDate': 'Document date confidence',

  'entitasform.entitas': 'Entity',
  'entitasform.nibWajibDiisi': 'NIB is required',
  'entitasform.errNibImportirWajib': 'Importer NIB is required',
  'entitasform.errNamaImportirWajib': 'Importer name is required',
  'entitasform.errJenisApiImportirWajib': 'Importer API type is required',
  'entitasform.errJenisIdentitasWajib': 'Identity type is required',
  'entitasform.errNpwpImportirWajib': 'Importer NPWP is required',
  'entitasform.errAlamatImportirWajib': 'Importer address is required',
  'entitasform.errStatusImportirWajib': 'Importer status is required',
  'entitasform.errFieldWajibDiisi': 'This field is required',
  'entitasform.successTitle': 'Success',
  'entitasform.successMessage': 'Entity data loaded successfully!',
  'entitasform.titlePemilikBarang': 'Goods Owner',
  'entitasform.titlePemusatan': 'Centralized Entity',
  'entitasform.titlePengirim': 'Shipper',
  'entitasform.titlePenjual': 'Seller',
  'entitasform.titlePpjk': 'PPJK',
  'entitasform.actionSalinImportir': 'Copy Importer',
  'entitasform.actionSalinDataPengirim': 'Copy Shipper Data',
  'entitasform.importir': 'Importer',
  'entitasform.fieldJenis': 'Type',
  'entitasform.fieldNpwp': '{title} NPWP',
  'entitasform.fieldNama': '{title} Name',
  'entitasform.fieldNegara': '{title} Country',
  'entitasform.fieldAlamat': '{title} Address',
  'entitasform.fieldStatus': 'Status',
  'entitasform.fieldApiNib': 'API/NIB',
  'entitasform.fieldNib': 'NIB',
  'entitasform.fieldAfiliasi': 'Affiliation',
  'entitasform.syncDariJarvis': 'Sync from Jarvis',
  'entitasform.pilihDataDariJarvis': 'Choose {title} Data from Jarvis',
  'entitasform.syncGagal': 'Sync Failed',
  'entitasform.tidakAdaDataJarvis': 'Jarvis has no data for this NPWP.',
  'entitasform.gagalSyncJarvis': 'Could not sync data from Jarvis.',
  'entitasform.npwpBelumLengkap': 'NPWP is incomplete',
  'entitasform.npwpHarus16Digit': 'NPWP must be 16 digits to sync from Jarvis.',
  'entitasform.diterapkan': 'Applied',
  'entitasform.dataDiterapkanSection': 'Jarvis data applied to the section.',
  'entitasform.dataDiterapkanImportir': 'Jarvis data applied to Importer.',
  'entitasform.gagalMenyimpanEntitas': 'Could not save Entity',
  'entitasform.dataHistoricalBelumTersimpan': 'Historical data has been applied but not saved yet.',
  'entitasform.disinkronDariRiwayat': 'Synced from document history',
  'entitasform.dataDariDokumenSebelumnya':
    'This data was taken from an earlier document. Check & adjust it before sending.',
  'entitasform.optMita': 'MITA',
  'entitasform.optAeo': 'AEO',
  'entitasform.optLainnya': 'OTHER',
  'entitasform.optApiU': 'API U',
  'entitasform.optApiP': 'API P',
  'entitasform.optPaspor': '2 - PASSPORT',
  'entitasform.optKtp': '3 - KTP (ID CARD)',
  'entitasform.optLainnyaIdentitas': '4 - OTHER',
  'entitasform.optNpwp15': '5 - NPWP 15 DIGITS',
  'entitasform.optNpwp16': '6 - NPWP 16 DIGITS',
  'entitasform.optAfl': 'AFL - Affiliated Company',
  'entitasform.optCtr': 'CTR - Financial/legally controlled',
  'entitasform.optFam': 'FAM - Family member',
  'entitasform.optTah': 'TAH - Not related',

  'kemasanform.seri': 'No.',
  'kemasanform.jumlah': 'Quantity',
  'kemasanform.jenis': 'Type',
  'kemasanform.merek': 'Marks',
  'kemasanform.aksi': 'Actions',
  'kemasanform.nomor': 'Number',
  'kemasanform.ukuran': 'Size',
  'kemasanform.tipe': 'Type',
  'kemasanform.kemasan': 'Packaging',
  'kemasanform.petiKemas': 'Containers',
  'kemasanform.tambahKemasan': 'Add Packaging',
  'kemasanform.tambahPetiKemas': 'Add Container',
  'kemasanform.totalPetiKemas': 'Total: {n}',
  'kemasanform.edit': 'Edit',
  'kemasanform.copy': 'Copy',
  'kemasanform.delete': 'Delete',
  'kemasanform.required': 'This field is required!',
  'kemasanform.jenisOptionEmpty': '4 - EMPTY',
  'kemasanform.jenisOptionLcl': '7 - LCL',
  'kemasanform.jenisOptionFcl': '8 - FCL',
  'kemasanform.tipeOptionGeneralDry': '1 - GENERAL / DRY CARGO',
  'kemasanform.tipeOptionTunnel': '2 - TUNNEL TYPE',
  'kemasanform.tipeOptionOpenTop': '3 - OPEN TOP STEEL',
  'kemasanform.tipeOptionFlatRack': '4 - FLAT RACK',
  'kemasanform.tipeOptionReefer': '5 - REEFER/REFRIGERATE',
  'kemasanform.tipeOptionBarge': '6 - BARGE CONTAINER',
  'kemasanform.tipeOptionBulk': '7 - BULK CONTAINER',
  'kemasanform.tipeOptionIsotank': '8 - ISOTANK',
  'kemasanform.tipeOptionLain': '99 - OTHERS',

  'pengangkutform.smartSync': 'Smart Sync with BC 1.1',
  'pengangkutform.syncing': 'Syncing...',
  'pengangkutform.kodeTutupPu': 'PU Closing Code',
  'pengangkutform.nomorBc11': 'BC 1.1 Number',
  'pengangkutform.tanggalTutupPu': 'PU Closing Date',
  'pengangkutform.nomorPos': 'Pos Number',
  'pengangkutform.nomorSubpos': 'Sub-pos Number',
  'pengangkutform.nomorSubsubpos': 'Sub-sub-pos Number',
  'pengangkutform.pengangkutan': 'Transport',
  'pengangkutform.caraPengangkutan': 'Mode of Transport',
  'pengangkutform.namaSaranaPengangkut': 'Means of Transport Name',
  'pengangkutform.nomorVoyFlightNoPol': 'Voy/Flight/Plate No.',
  'pengangkutform.bendera': 'Flag',
  'pengangkutform.perkiraanTanggalTiba': 'Estimated Arrival Date',
  'pengangkutform.cariBendera': 'Search Flag',
  'pengangkutform.pelabuhanTempatPenimbunan': 'Ports & Storage Location',
  'pengangkutform.pelabuhanMuat': 'Port of Loading',
  'pengangkutform.pelabuhanTransit': 'Transit Port',
  'pengangkutform.pelabuhanTujuan': 'Port of Destination',
  'pengangkutform.tempatPenimbunan': 'Storage location',
  'pengangkutform.noticeOfArrival': 'Notice of Arrival',
  'pengangkutform.loadingData': 'Loading data...',
  'pengangkutform.useThisValue': 'Use this value',
  'pengangkutform.uploading': 'Uploading...',
  'pengangkutform.maxFileSize': 'Maximum file size: 2MB',
  'pengangkutform.extractedInfo': '✓ Extracted Information',
  'pengangkutform.warehouse': 'Warehouse:',
  'pengangkutform.invoiceNumber': 'Invoice Number:',
  'pengangkutform.shipper': 'Shipper:',
  'pengangkutform.consignee': 'Consignee:',
  'pengangkutform.flagNameFromApi': 'Flag name from API',
  'pengangkutform.portOfLoadingFromApi': 'Port of loading from API',
  'pengangkutform.notifError': 'Error',
  'pengangkutform.notifSuccess': 'Success',
  'pengangkutform.notifWarning': 'Warning',
  'pengangkutform.notifFileTooLarge': 'File Too Large',
  'pengangkutform.notifUploadSuccessful': 'Upload Successful',
  'pengangkutform.notifPdfExtractionComplete': 'PDF Extraction Complete',
  'pengangkutform.notifUploadFailed': 'Upload Failed',
  'pengangkutform.notifDocumentNotFound': 'Document Not Found',
  'pengangkutform.notifIncompleteDocument': 'Incomplete Document',
  'pengangkutform.notifNoData': 'No Data',
  'pengangkutform.notifDemoNoCeisa': 'Not available on a demo account',
  'pengangkutform.msgDemoNoCeisa': 'Demo accounts are not connected to CEISA, so BC 1.1 data cannot be fetched. Please fill in the BC 1.1 number, Tanggal Tutup PU and Pos number manually. This works once the account is connected to CEISA.',
  'pengangkutform.notifApiError': 'API Error',
  'pengangkutform.msgEnterVesselNameFirst': 'Please enter the vessel name first',
  'pengangkutform.msgFlagFound': 'Flag found: {flag}',
  'pengangkutform.msgNoFlagInfo': 'No flag information for this vessel',
  'pengangkutform.msgNoAirlineFlagInfo': 'Airline not recognised, choose the flag manually',
  'pengangkutform.msgEnterAirlineFirst': 'Please enter the airline name or flight number first',
  'pengangkutform.msgFailedFetchFlag': "Could not fetch the vessel's flag information",
  'pengangkutform.msgFileTooLarge': 'File size must be under 2MB',
  'pengangkutform.msgBatchUuidNotFound': 'Batch UUID not found in the URL',
  'pengangkutform.msgUploadSuccessful': 'NOA file "{name}" uploaded successfully',
  'pengangkutform.msgPdfExtractionComplete': 'Notice of Arrival data extracted successfully',
  'pengangkutform.msgUploadFailed': 'Could not upload the NOA file',
  'pengangkutform.msgNoBlDocument': 'B/L (705) or AWB (740) document not found. Please add a B/L or AWB document first.',
  'pengangkutform.msgBlIncomplete': 'The B/L / AWB document must have a number and a date.',
  'pengangkutform.msgPopulatedFields': '{n} fields filled from the BC 1.1 Manifest',
  'pengangkutform.msgNoManifestData': 'No data in the BC 1.1 Manifest response',
  'pengangkutform.msgFailedRetrieveManifest': 'Could not retrieve manifest data',
  'pengangkutform.msgFailedCallManifest': 'Could not call the BC 1.1 Manifest API. Please try again.',
  'pengangkutform.caraOpt1': '1 - SEA',
  'pengangkutform.caraOpt2': '2 - RAIL',
  'pengangkutform.caraOpt3': '3 - ROAD',
  'pengangkutform.caraOpt4': '4 - AIR',
  'pengangkutform.caraOpt5': '5 - POST',
  'pengangkutform.caraOpt6': '6 - MULTIMODAL',
  'pengangkutform.caraOpt7': '7 - FIXED INSTALLATION / PIPELINE',
  'pengangkutform.caraOpt8': '8 - INLAND WATERWAY',
  'pengangkutform.caraOpt9': '9 - OTHER',

  'transaksiform.titleHarga': 'Price',
  'transaksiform.warningPastikanValuta': 'Please make sure the currency is correct',
  'transaksiform.labelValuta': 'Currency',
  'transaksiform.placeholderPilihValuta': 'Choose Currency',
  'transaksiform.labelNdpbm': 'NDPBM',
  'transaksiform.placeholderNdpbm': 'NDPBM',
  'transaksiform.labelJenisTransaksi': 'Transaction Type',
  'transaksiform.placeholderJenisTransaksi': 'Choose Transaction Type',
  'transaksiform.labelIncoterm': 'Incoterm',
  'transaksiform.placeholderIncoterm': 'Choose Incoterm',
  'transaksiform.labelHargaBarang': 'Goods Price',
  'transaksiform.placeholderHargaBarang': 'Goods Price',
  'transaksiform.labelNilaiPabeanRupiah': 'Customs Value in Rupiah',
  'transaksiform.placeholderNilaiPabeanRupiah': 'Customs Value in Rupiah',
  'transaksiform.informasiKomponenBiaya': 'Cost Component Information',
  'transaksiform.titleHargaLainnya': 'Other Charges',
  'transaksiform.biayaPenambahan': 'Additional costs',
  'transaksiform.biayaPengurang': 'Deductible costs',
  'transaksiform.freight': 'Freight',
  'transaksiform.labelAsuransi': 'Insurance',
  'transaksiform.placeholderAsuransi': 'Insurance',
  'transaksiform.nilaiAsuransi': 'Insurance Value',
  'transaksiform.labelVoluntaryDeclaration': 'Voluntary declaration',
  'transaksiform.placeholderVoluntaryDeclaration': 'Voluntary declaration',
  'transaksiform.titleBerat': 'Weight',
  'transaksiform.labelBeratKotor': 'Gross Weight (KGM)',
  'transaksiform.placeholderBeratKotor': 'Gross Weight (KGM)',
  'transaksiform.labelBeratBersih': 'Net Weight (KGM)',
  'transaksiform.placeholderBeratBersih': 'Net Weight (KGM)',
  'transaksiform.helperNettoDihitung':
    'Calculated from the total net weight of the goods. Use "Match gross weight" to adjust it, or fill in the net weight per item in the Goods tab. The Transaction tab stays yellow until the value is > 0.',
  'transaksiform.buttonSamakanKeBeratKotor': 'Match gross weight',
  'transaksiform.tooltipSamakanKeBeratKotor':
    "Adjust the first item's net weight so the total net weight equals the gross weight",
  'transaksiform.disabledSamakanBrutoKosong': 'Fill in the gross weight first',
  'transaksiform.disabledSamakanTidakAdaBarang': 'No goods to match',
  'transaksiform.modalSamakanTitle': 'Match net weight to gross weight',
  'transaksiform.modalSamakanBeratKotor': 'Gross weight',
  'transaksiform.modalSamakanTotalNetto': 'Current total net weight',
  'transaksiform.modalSamakanItem': 'Item to change',
  'transaksiform.modalSamakanNettoLama': 'Old net weight',
  'transaksiform.modalSamakanNettoBaru': 'New net weight',
  'transaksiform.modalSamakanConfirm': 'Match',
  'transaksiform.modalSamakanCancel': 'Cancel',
  'transaksiform.hintNettoTidakSamaBruto': 'Net weight differs from gross weight. Use the button above to match them.',
  'transaksiform.errSamakanFirstNegatif':
    "The other items' net weight already exceeds the gross weight. Reduce the net weight in the Goods tab first.",
  'transaksiform.errSamakanTidakAdaBarang': 'No goods to match',
  'transaksiform.errSamakanBrutoKosong': 'Gross weight must be greater than 0',

  'docpabean.tabs.mandatoryFilled': '{filled} / {total} required fields filled.',
  'docpabean.tabs.hargaMismatchTooltip':
    'Total price does not match: Goods tab {barang} {valuta} ({seri} lines), Transaction tab {harga} {valuta}. Difference {selisih} {valuta}. Open the Transaction tab to align them.',

  'transaksiform.hintHargaTidakSamaBarang':
    'The total value in the Goods tab ({barang} {valuta} across {seri} items) does not match the Goods Price here ({harga} {valuta}). Difference: {selisih} {valuta}.',
  'transaksiform.buttonSamakanHargaBarang': 'Match Goods tab total',
  'transaksiform.modalSamakanHargaTitle': 'Match Goods Price to the Goods total',
  'transaksiform.modalSamakanHargaSekarang': 'Current Goods Price',
  'transaksiform.modalSamakanHargaTotalBarang': 'Goods tab total value ({seri} items)',
  'transaksiform.modalSamakanHargaSelisih': 'Difference',
  'transaksiform.modalSamakanHargaPenjelasan':
    'Goods Price will be set to the total value from the Goods tab. Per-item prices are not changed.',
  'transaksiform.modalSamakanHargaCatatanBiaya':
    'Note: Freight {freight} {valuta} and Insurance {asuransi} {valuta} are entered separately. Make sure the Goods tab total does not already include them, so the customs value is not counted twice.',
  'transaksiform.modalSamakanHargaHapusBiaya':
    'Additional costs will be cleared because they are treated as already included in the Goods tab total: Freight {freight} {valuta}, Insurance {asuransi} {valuta}, Additional costs {biaya} {valuta}. Per-item freight and insurance are also set to 0; per-item prices do not change.',
  'transaksiform.hintBiayaDalamBarang':
    'The total value in the Goods tab ({barang} {valuta} across {seri} items) equals the Goods Price ({harga} {valuta}) plus additional costs ({biaya} {valuta}: freight, insurance, etc.). If those costs are already included in the invoice price, match the Goods Price so they are not counted twice.',
  'transaksiform.hargaSamakanApplied': 'Goods Price set to {amount} {valuta} from the Goods tab total',
  'transaksiform.errHargaSamakanGagal': 'Could not match the Goods Price. Try again.',
  'transaksiform.errNettoHarusLebihDari0':
    'Net Weight must be greater than 0 — fill in the net weight per item in the Goods tab',
  'transaksiform.errNettoLebihDariBruto': 'Net Weight cannot be greater than Gross Weight',
  'transaksiform.warningTitle': 'Warning',
  'transaksiform.errNdpbmRetrieve': 'Could not retrieve NDPBM value. Please enter manually.',
  'transaksiform.errorTitle': 'Error',
  'transaksiform.errNdpbmFetch': 'Error when fetching NDPBM',
  'transaksiform.confGrossWeight': 'Gross weight confidence',
  'transaksiform.confCurrency': 'Currency confidence',
  'transaksiform.confIncoterm': 'Incoterm confidence',
  'transaksiform.confHargaBarang': 'Goods price confidence',
  'transaksiform.confFreight': 'Freight confidence',
  'transaksiform.confInsurance': 'Insurance value confidence',
  'transaksiform.confNdpbm': 'Exchange rate confidence',
  'transaksiform.confCif': 'CIF value confidence',
  'transaksiform.confNetto': 'Net weight confidence',

  'barangform.notifError': 'Error',
  'barangform.notifSuccess': 'Success',
  'barangform.notifInfo': 'Info',
  'barangform.minOneBarang': 'Add at least one goods item to continue',
  'barangform.seriUraianKosong': 'Goods item [{seri}] has an empty description',
  'barangform.seriSatuanKosong': 'Goods item [{seri}] has an empty unit',
  'barangform.seriKodeSatuanKosong': 'Goods item [{seri}] has an empty unit code',
  'barangform.seriNegaraKosong': 'Goods item [{seri}] has an empty country',
  'barangform.seriHsKosong': 'Goods item [{seri}] has an empty HS code',
  'barangform.seriHs8Digit': 'Goods item [{seri}]: HS code must be 8 digits',
  'barangform.gagalMenghapusDokumen': 'Failed to delete the document',
  'barangform.noItemsSelected': 'No items selected',
  'barangform.updatedCount': '{count} items updated successfully',
  'barangform.bulkEditFailed': 'Bulk edit failed',
  'barangform.seriBarangRequired': 'Goods item no. is required',
  'barangform.dataBerhasilDiperbarui': 'Goods data updated successfully',
  'barangform.gagalMemperbaruiData': 'Failed to update goods data',
  'barangform.fetchHsDetailsFailed': 'Failed to fetch HS code details',
  'barangform.fetchHsDetailsError': 'Error fetching HS code details',
  'barangform.itemBerhasilDihapus': 'Item deleted successfully',
  'barangform.gagalMenghapusItem': 'Failed to delete the item',
  'barangform.tidakAdaItemDipilih': 'No items selected',
  'barangform.itemBerhasilDihapusCount': '{count} items deleted successfully',
  'barangform.itemBerhasilDisalin': 'Item copied successfully',
  'barangform.gagalMenyalinItem': 'Failed to copy the item',
  'barangform.loadItemEditFailed': 'Failed to load item for editing',
  'barangform.processIdNotFound': 'Process ID not found',
  'barangform.downloadSuccess': 'Download success!',
  'barangform.downloadFailed': 'Download failed!',
  'barangform.pilihFilePdf': 'Please select a PDF file first',
  'barangform.processIdTidakDitemukan': 'Process ID not found',
  'barangform.invoiceUploadSuccess': 'Invoice uploaded and is being processed',
  'barangform.uploadInvoiceError': 'An error occurred while uploading the invoice',
  'barangform.noItemsToCheck': 'No items to check',
  'barangform.noDuplicateDescriptions': 'No duplicate descriptions found',
  'barangform.foundDuplicates': 'Found {count} items with duplicate descriptions',
  'barangform.tidakAdaBarangSync': 'No goods to sync',
  'barangform.tidakAdaHsValid': 'No valid HS codes to sync',
  'barangform.syncProsesDimulai': 'Sync of {count} HS codes has started. Please wait until it finishes.',
  'barangform.gagalMemulaiSync': 'Failed to start sync: {msg}',
  'barangform.tidakAdaHsCodeSync': 'No HS codes to sync',
  'barangform.hsCodeSyncCount': '{count} HS codes synced successfully',
  'barangform.hsCodeSyncErrorSuffix': ', {count} errors',
  'barangform.gagalSyncTarifInsw': 'Failed to sync tariffs with INSW',
  'barangform.processIdTidakTersedia': 'Process ID is not available. Please reload the page.',
  'barangform.processIdTidakTersediaSingkat': 'Process ID is not available',
  'barangform.lartasStatusUpdated': 'LARTAS status updated for {count} items',
  'barangform.lartasAlreadyUpToDate': 'LARTAS status is already up to date',
  'barangform.gagalAmbilLartas': 'Failed to retrieve LARTAS data',
  'barangform.gagalSyncLartas': 'Failed to sync LARTAS data',
  'barangform.itemDariDatabaseSukses': 'Item added from the database successfully!',
  'barangform.gagalItemDatabase': 'Failed to add item from the database',
  'barangform.cifBerhasil': 'Proportional costs calculated successfully',
  'barangform.gagalHitungCif': 'Failed to calculate proportional costs',
  'barangform.fobBerhasil': 'FOB price applied successfully',
  'barangform.gagalTerapkanFob': 'Failed to apply the FOB price',
  'barangform.itemUpdatedApplied':
    'Item updated and changes applied to {count} items with same HS code or empty HS code',
  'barangform.itemUpdatedNoApply': 'Item updated. No other items had matching or empty HS codes to apply changes to.',
  'barangform.gagalSimpanServer': 'Failed to save changes to server. Please try again.',
  'barangform.itemAddedSukses': 'Item added successfully',
  'barangform.gagalSimpanItemBaru': 'Failed to save new item to server. Please try again.',
  'barangform.syncedTooltip': 'Data taken from a previous document',
  'barangform.syncedFromAjuLabel': 'Synced from Aju {aju}',
  'barangform.syncedFromDraftLabel': 'Synced from Draft {id}',
  'barangform.cekTarifInsw': 'Checking tariff against INSW...',
  'barangform.inswCocok': 'INSW tariff matches ({kind}: {value}%)',
  'barangform.inswBerbeda': 'INSW tariff differs — INSW {kind}: {value}%',
  'barangform.memuatDetailHs': 'Loading HS details...',
  'barangform.lihatDetailHs': 'View HS details',
  'barangform.hsPick': 'Pick an HS code from the transport document',
  'barangform.hsPickFailed': 'Failed to save the selected HS code',
  'barangform.lartas': 'Lartas',
  'barangform.non': 'Non',
  'barangform.unnamedItem': 'Unnamed Item',
  'barangform.hsCodeKosong': 'HS code is empty',
  'barangform.tidakAdaHsCodeDicari': 'No HS code to search for.',
  'barangform.prefTarif': '{pref} {year}: {nilai} vs BM {bm}%',
  'barangform.prefNoTarif': '{pref} — no rate for {year}',
  'barangform.skbPphBadge': 'PPh EXEMPT',
  'barangform.skbPphApplied': 'SKB PPh linked — PPh exempted (facility 5), rate {tarif}% still recorded.',
  'barangform.skbPphAppliedNoDoc':
    'PPh exempted (facility 5) without a linked SKB PPh document — make sure the SKB is in the Documents tab before submitting.',
  'barangform.skbPphPending':
    'SKB PPh linked, but the PPh exemption has not been applied to this goods item yet — open the Pungutan tab or run HS Tariff Sync.',
  'barangform.skbPpnBadge': 'PPN EXEMPT',
  'barangform.skbPpnApplied': 'SKB PPN linked — PPN exempted (facility 5), rate {tarif}% still recorded, PPN paid 0.',
  'barangform.skbPpnAppliedNoDoc':
    'PPN exempted (facility 5) without a linked SKB PPN document — make sure the SKB is in the Documents tab before submitting.',
  'barangform.skbPpnPending':
    'SKB PPN linked, but the PPN exemption has not been applied to this goods item yet — open the Pungutan tab or run HS Tariff Sync.',
  'barangform.editLabel': 'Edit',
  'barangform.copyLabel': 'Copy',
  'barangform.deleteLabel': 'Delete',
  'barangform.colSeri': 'No.',
  'barangform.colGroup': 'Group',
  'barangform.colHs': 'HS',
  'barangform.colLartas': 'Lartas',
  'barangform.lartasUnverified': 'NEEDS CHECK',
  'barangform.colUraian': 'Description',
  'barangform.uraianFull': 'Show the full description',
  'barangform.uraianCompact': 'Compact description',
  'barangform.colTotalNilai': 'Total Value',
  'barangform.colNw': 'NW',
  'barangform.colSatuan': 'Unit',
  'barangform.colKemasan': 'Packaging',
  'barangform.kemasanMismatchDetail':
    '{count} goods lines use packaging {codes}, while the Kemasan & Peti Kemas tab states {target}.',
  'barangform.kemasanMismatchApply': 'Change all to {target}',
  'barangform.kemasanMismatchApplying': 'Aligning...',
  'barangform.kemasanMismatchDismiss': 'Dismiss',
  'barangform.kemasanMismatchNoCode': 'no code',
  'barangform.kemasanMismatchDone': '{count} goods lines changed to packaging {target}.',
  'barangform.kemasanMismatchFailed': 'Failed to align goods packaging.',
  'barangform.kemasanTotalMismatchTitle': 'Package count does not match',
  'barangform.kemasanTotalMismatchDetail':
    'The goods lines add up to {barang} packages, but the Kemasan tab states {kemasan}. Difference {selisih}. Warning only — submit is not blocked.',
  'barangform.kemasanTotalMismatchOpen': 'Open the Kemasan tab',
  'barangform.hsShortSummary':
    '{codes} HS codes are still shorter than 8 digits on {rows} lines. CEISA only accepts 8-digit codes.',
  'barangform.hsShortRows': '{count} lines (item no. {seri})',
  'barangform.hsShortPick': 'Pick an 8-digit code ({count} options)',
  'barangform.hsShortModalTitle': 'Pick an 8-digit HS code for {heading}',
  'barangform.hsShortModalIntro':
    'The tariff book (BTKI) lists the following codes under {heading}. The code you pick will be applied to {count} lines at once (item no. {seri}).',
  'barangform.hsShortCatchAll': 'Other',
  'barangform.hsShortInactive': 'Inactive',
  'barangform.hsShortInactiveSome': 'Inactive = not in the latest INSW sync; it does not mean the code cannot be used.',
  'barangform.hsShortInactiveAll':
    'All codes under this heading were inactive in the latest INSW sync — our BTKI data (2022) may be outdated. Check before using.',
  'barangform.hsShortUserEdited': '{count} lines were edited manually (item no. {seri}) and will be overwritten too.',
  'barangform.hsShortCancel': 'Cancel',
  'barangform.hsShortConfirm': 'Apply to {count} lines',
  'barangform.hsShortDone': '{count} lines changed from {heading} to {code}.',
  'barangform.hsShortDoneSkipped':
    '{count} lines changed to {code}. {skipped} lines skipped because they had already changed.',
  'barangform.hsShortFailed': 'Failed to apply the HS code recommendation.',
  'barangform.hsUnknownSummary': '{codes} 8-digit HS codes on {rows} lines were not found in our BTKI/INSW list.',
  'barangform.hsUnknownPick': 'Pick a code under {prefix} ({count} options)',
  'barangform.hsUnknownModalTitle': 'HS code {heading} not found in BTKI',
  'barangform.hsUnknownModalIntro':
    'Code {heading} is not in our BTKI/INSW list. The tariff book lists the following codes under {prefix} — the first 6 digits are kept and only the last 2 digits are re-selected. The code you pick will be applied to {count} lines at once (item no. {seri}).',
  'barangform.satuanMismatchSummary':
    '{count} goods lines use a unit that is not allowed for their HS code. Goods units follow the rules in the HS Code Information.',
  'barangform.satuanMismatchRows': '{count} lines (item no. {seri}) use {used}, should be {allowed}',
  'barangform.satuanMismatchApply': 'Change to {target}',
  'barangform.satuanMismatchConverted': 'quantity converted too',
  'barangform.satuanMismatchKept': 'quantity unchanged, please double-check',
  'barangform.satuanMismatchApplyAll': 'Change all ({count} lines)',
  'barangform.satuanMismatchApplying': 'Changing...',
  'barangform.satuanMismatchDismiss': 'Dismiss',
  'barangform.satuanMismatchDone': '{count} goods lines changed to unit {targets}.',
  'barangform.satuanMismatchDoneSkipped':
    '{count} goods lines changed to unit {targets}. {skipped} lines skipped because they had already changed.',
  'barangform.satuanMismatchFailed': 'Failed to change the goods unit.',
  'barangform.colDok': 'Doc',
  'barangform.colPpn': 'PPN',
  'barangform.colPph': 'PPH',
  'barangform.colBm': 'BM',
  'barangform.colAction': 'Action',
  'barangform.colJenisDokumen': 'Document Type',
  'barangform.colKode': 'Code',
  'barangform.colNomorDokumen': 'Document Number',
  'barangform.colTanggal': 'Date',
  'barangform.colKodeFasilitas': 'Facility Code',
  'barangform.colNamaFasilitas': 'Facility Name',
  'barangform.colKodeIjin': 'Permit Code',
  'barangform.colSeriIzin': 'Permit Line',
  'barangform.hapusBarangTitle': 'Delete Goods',
  'barangform.tindakanTidakBisaDibatalkan': 'This action cannot be undone',
  'barangform.konfirmasiHapusBarang': 'Are you sure you want to delete the following goods item?',
  'barangform.konfirmasiHapusMany': 'Are you sure you want to delete the {count} selected goods items?',
  'barangform.labelSeri': 'Item No.:',
  'barangform.labelUraian': 'Description:',
  'barangform.labelHsCode': 'HS Code:',
  'barangform.cancel': 'Cancel',
  'barangform.deleting': 'Deleting...',
  'barangform.delete': 'Delete',
  'barangform.hapusCountTitle': 'Delete {count} Goods Items',
  'barangform.hapusCountItem': 'Delete {count} Items',
  'barangform.labelJumlahItem': 'Number of Items:',
  'barangform.jumlahItemCount': '{count} items',
  'barangform.labelSeriBarang': 'Goods Item No.:',
  'barangform.lagiSuffix': ', ... (+{count} more)',
  'barangform.hsCodeDetailsTitle': 'HS Code Details',
  'barangform.tabBasicInfo': 'Basic Info',
  'barangform.tabTariffRates': 'Tariff Rates',
  'barangform.tabPreferentialCount': 'Preferential Tariffs ({count})',
  'barangform.labelCode': 'Code:',
  'barangform.labelNormalizedCode': 'Normalized Code:',
  'barangform.labelIdDescription': 'ID Description:',
  'barangform.labelEnDescription': 'EN Description:',
  'barangform.labelInswYear': 'INSW Year:',
  'barangform.labelLartas': 'LARTAS:',
  'barangform.yes': 'YES',
  'barangform.no': 'NO',
  'barangform.labelPpnBm': 'PPN BM',
  'barangform.na': 'N/A',
  'barangform.placeholderSearchPrefTariffs': 'Search preferential tariffs...',
  'barangform.labelIssueDate': 'Issue Date:',
  'barangform.labelEffective': 'Effective:',
  'barangform.nowSuffix': ' (now)',
  'barangform.labelHistoricalRates': 'Historical Rates:',
  'barangform.loadingHsDetails': 'Loading HS code details...',
  'barangform.dokumenTerlampir': 'Attached Documents',
  'barangform.seriInfoLine': 'Item no. {seri}: {uraian}',
  'barangform.dokumenFallback': 'Document {kode}',
  'barangform.deleteAttachmentAria': 'Delete attachment',
  'barangform.tidakAdaDokumenTerlampir': 'No documents are attached to this goods item',
  'barangform.memuatDataBarang': 'Loading goods data...',
  'barangform.menyalinDataBarang': 'Copying goods data...',
  'barangform.tambahBarang': 'Add Goods',
  'barangform.editBarang': 'Edit Goods',
  'barangform.editMassalCount': 'Bulk Edit {count} Items',
  'barangform.bulkEditHint':
    'Choose the fields to change for all selected items. Leave blank to keep the existing values.',
  'barangform.bulkUraianLabel': 'Description',
  'barangform.uraianMode.replace': 'Replace',
  'barangform.uraianMode.prefix': 'Prefix',
  'barangform.uraianMode.suffix': 'Suffix',
  'barangform.bulkUraianHint.replace': 'The description of every selected item is replaced with this text.',
  'barangform.bulkUraianHint.prefix': "The text is added before each item's own description, separated by one space.",
  'barangform.bulkUraianHint.suffix': "The text is added after each item's own description, separated by one space.",
  'barangform.bulkUraianPlaceholder': 'e.g. SPARE PARTS',
  'barangform.bulkUraianPreview': 'Result preview (Seri {seri})',
  'barangform.bulkUraianEmpty': '(empty)',
  'barangform.hsCodeField': 'HS Code',
  'barangform.placeholderPilihHs': 'Select a new HS code for the selected items...',
  'barangform.nonLartasLabel': 'NON-LARTAS',
  'barangform.kodeSatuanField': 'Unit Code',
  'barangform.placeholderPilihSatuan': 'Select a new unit code for the selected items...',
  'barangform.kodeKemasanField': 'Packaging Code',
  'barangform.placeholderPilihKemasan': 'Select a new packaging code for the selected items...',
  'barangform.kodeNegaraField': 'Country Code',
  'barangform.placeholderPilihNegara': 'Select a new country code for the selected items...',
  'barangform.tarifPungutan': 'Rates (Pungutan)',
  'barangform.aturTarifHint': 'Set the PPN, PPH and BM rates for the selected items',
  'barangform.labelPpnPct': 'PPN (%)',
  'barangform.labelPphPct': 'PPH (%)',
  'barangform.labelBmPct': 'BM (%)',
  'barangform.fasilitasPpnField': 'PPN Facility',
  'barangform.fasilitasPphField': 'PPH Facility',
  'barangform.fasilitasBmField': 'BM Facility',
  'barangform.placeholderPilihFasilitas': 'Select facility...',
  'barangform.fasByr': '1 - BYR - PAID',
  'barangform.fasDtp': '2 - BORNE BY GOVERNMENT',
  'barangform.fasBbs': '5 - BBS - EXEMPTED',
  'barangform.fasTidakDipungut': '6 - NOT COLLECTED',
  'barangform.fasDilunasi': '7 - ALREADY SETTLED',
  'barangform.fasDitunda': '9 - DEFERRED',
  'barangform.terapkanPerubahan': 'Apply Changes',
  'barangform.resyncTarifTitle': 'Re-Sync Tariff Database',
  'barangform.tersisa': 'remaining',
  'barangform.syncingTarif': 'Syncing Tariffs...',
  'barangform.resyncDescription':
    'The system is downloading and updating tariff data from the INSW database for the HS codes in your goods table.',
  'barangform.harapTunggu': 'Please wait until the process finishes. Do not close this page.',
  'barangform.syncSelesai': 'Sync Complete!',
  'barangform.resyncSelesaiDesc':
    'Tariff data has been updated successfully. Click Smart Sync to apply the latest tariffs to the goods table.',
  'barangform.selesai': 'Done',
  'barangform.loadingBarangData': 'Loading goods data...',
  'barangform.totalCount': 'Total: {count}',
  'barangform.labelHsCodes': 'HS Codes:',
  'barangform.filteredCount': 'Filtered: {count}',
  'barangform.duplicatesCount': 'Duplicates: {count}',
  'barangform.withDocumentsCount': 'With Documents: {count}',
  'barangform.lartasCount': 'Lartas: {count}',
  'barangform.nonLartasCount': 'Non-Lartas: {count}',
  'barangform.selectedCount': 'Selected: {count}',
  'barangform.editMassal': 'Bulk Edit',
  'barangform.editBtn': 'Edit',
  'barangform.hapusMassal': 'Bulk Delete',
  'barangform.batalPilih': 'Clear Selection',
  'barangform.duplikat': 'Duplicate',
  'barangform.duplikatMassal': 'Bulk Duplicate',
  'barangform.duplikatTitle': 'Duplicate Goods',
  'barangform.duplikatSelected': '{count} lines selected',
  'barangform.duplikatCopiesLabel': 'Copies per line',
  'barangform.duplikatCopiesHint':
    'Each selected line is copied this many times and added to the end of the list (max {max}).',
  'barangform.duplikatCopiesInvalid': 'Enter a number from 1 – {max}',
  'barangform.duplikatAdded': '+{count} new lines',
  'barangform.duplikatTotal': 'Total: {from} → {to} goods items',
  'barangform.duplikatWillAdd': 'Will add:',
  'barangform.duplikatTotalsNote':
    "Totals in Header/Transaction are not updated automatically. Adjust each line's qty/value afterwards.",
  'barangform.duplikatConfirm': 'Duplicate {count}',
  'barangform.duplikatBerhasil': '{count} lines duplicated successfully (item no. {first}–{last})',
  'barangform.duplikatGagal': 'Failed to duplicate goods',
  'barangform.pilihHalamanIni': '{count} lines on this page selected.',
  'barangform.pilihSemuaN': 'Select all {count} goods items',
  'barangform.pilihBarangDulu': 'Tick the goods items first',
  'barangform.seriSelectPlaceholder': 'Select item no.: 1-5, 8',
  'barangform.seriSelectHelp': 'Type item numbers and press Enter to select lines. Example: 1-5, 8, 10-12',
  'barangform.seriSelectApply': 'Select items',
  'barangform.seriSelectInvalid': 'Invalid format: {tokens}. Example: 1-5, 8, 10-12',
  'barangform.seriSelectMissing': '{count} goods items selected. Item no. not found: {seris}',
  'barangform.seriSelectNone': 'Item no. not found: {seris}',
  'barangform.semuaDipilih': 'All {count} goods items selected.',
  'barangform.placeholderCari': 'Search by description or HS code...',
  'barangform.filterOptions': 'Filter Options',
  'barangform.filterHasDocument': 'Goods with Documents',
  'barangform.lartasStatus': 'Lartas Status',
  'barangform.filterLartas': 'Lartas Goods',
  'barangform.filterNonLartas': 'Non-Lartas Goods',
  'barangform.showingCount': 'Showing {count} items',
  'barangform.sortBySeri': 'Sort by Goods Item No.',
  'barangform.sortByHs': 'Sort by HS Code',
  'barangform.sortedBySeriMsg': 'Goods sorted by goods item no.',
  'barangform.sortedByHsMsg': 'Goods sorted by HS code',
  'barangform.legendBarang': 'Goods',
  'barangform.bulkUpdate': 'Bulk Update',
  'barangform.uploadInvoice': 'Upload Invoice',
  'barangform.legendTarif': 'Tariff',
  'barangform.detailTarif': 'Tariff Details',
  'barangform.hitungHargaProporsional': 'Calculate Proportional Price',
  'barangform.kembalikanHargaSemula': 'Restore Original Price',
  'barangform.labelFileInvoice': 'Invoice File (PDF)',
  'barangform.placeholderPilihFilePdf': 'Select a PDF file',
  'barangform.uploadExtract': 'Upload & Extract',
  'barangform.goTo': 'Go to',
  'barangform.go': 'Go',

  'pungutanform.title': 'Pungutan',
  'pungutanform.generate': 'Generate Pungutan',
  'pungutanform.total': 'Total Pungutan:',
  'pungutanform.colJenisPungutan': 'Levy Type',
  'pungutanform.colFasilitas': 'Facility',
  'pungutanform.colNilaiPungutan': 'Levy Amount (IDR)',
  'pungutanform.fasilitas.dibayar': 'Paid',
  'pungutanform.fasilitas.ditanggung': 'Government-borne',
  'pungutanform.fasilitas.ditunda': 'Deferred',
  'pungutanform.fasilitas.tidakDipungut': 'Not Collected',
  'pungutanform.fasilitas.dibebaskan': 'Exempted',
  'pungutanform.notif.errorTitle': 'Error',
  'pungutanform.notif.noProcessId': 'No Process ID available to calculate duties/levies',
  'pungutanform.notif.successTitle': 'Success',
  'pungutanform.notif.generated': 'duties/levies generated successfully',
  'pungutanform.notif.calculated': 'duties/levies calculated from goods & tariffs',
  'pungutanform.notif.infoTitle': 'Info',
  'pungutanform.notif.noData': 'No duty/levy data',
  'pungutanform.notif.failTitle': 'Failed',
  'pungutanform.notif.failGenerate': 'Could not generate duties/levies',
  'pungutanform.readiness.ready': 'Ready to calculate',
  'pungutanform.readiness.estimate': 'Estimate',
  'pungutanform.readiness.partial': 'Partly not calculated',
  'pungutanform.readiness.blocked': 'Cannot be calculated yet',
  'pungutanform.readiness.detail.ready':
    "Calculated locally from the draft's tariffs and exchange rate. Final values follow CEISA once the AJU is sent.",
  'pungutanform.readiness.detail.estimate':
    'Calculated locally with an estimated CIF (freight & insurance split proportionally). Final values follow CEISA once the AJU is sent.',
  'pungutanform.readiness.detail.blocked': 'Duties/levies cannot be calculated for this draft yet.',
  'pungutanform.readiness.detail.partialSuffix': '{count} items are not included in the calculation yet.',
  'pungutanform.readiness.reason.barangKosong': 'The draft has no goods data yet.',
  'pungutanform.readiness.reason.tarifBelumSinkron':
    'HS tariffs are not synced yet, so there is no BM/PPN/PPh rate to use.',
  'pungutanform.readiness.reason.kursBelumAda':
    'The exchange rate (NDPBM) is not filled in on the Transaction tab, so the goods value cannot be converted to rupiah yet.',
  'pungutanform.readiness.reason.nilaiBarangKosong':
    'The goods value is still 0, so there is nothing to calculate from.',
  'pungutanform.readiness.valuta': 'Currency',
  'pungutanform.readiness.ndpbm': 'NDPBM',
  'pungutanform.readiness.ndpbmFromCeisa': 'CEISA exchange rate — not saved on the Transaction tab yet',
  'pungutanform.readiness.tarifSource': 'Tariff source',
  'pungutanform.readiness.source.saved': 'saved tariffs',
  'pungutanform.readiness.source.hsTariffs': 'HS tariffs',
  'pungutanform.readiness.source.mixed': 'mixed',
  'pungutanform.readiness.source.none': '-',
  'pungutanform.readiness.missingCodes': 'HS codes without tariffs',
  'pungutanform.readiness.andMore': '(+{count} more)',
  'pungutanform.readiness.syncTarif': 'Sync HS Tariffs',
  'pungutanform.readiness.syncDone': 'HS tariff sync complete',
  'pungutanform.readiness.syncFailed': 'HS tariff sync failed',
  'pungutanform.readiness.unsavedTarif':
    "Tariffs for {count} items are calculated from HS tariffs & the document's facilities and are not saved on the items yet — they are saved automatically during sync (requires Master CEISA access).",
  'pungutanform.readiness.ambiguousPreferential':
    'The preferential rate (BM facility) for item(s) {seri} was not applied automatically because the preference data conflicts — BM uses the general rate (MFN); check the BM facility manually.',
  'pungutanform.readiness.pphExempt':
    'PPh for {count} items (item no. {seri}) is exempted because an SKB PPh / SKB PP 23 is linked — listed as a PPH facility 5 (Exempted) line.',
  'pungutanform.readiness.ppnExempt':
    'PPN for {count} items (item no. {seri}) is exempted because an SKB PPN is linked — listed as a PPN facility 5 (Exempted) line.',

  'pernyataanform.title': 'Statement',
  'pernyataanform.titleSync': 'Sync Statement',
  'pernyataanform.syncing': 'Syncing...',
  'pernyataanform.declarationHeader': 'I hereby declare that I:',
  'pernyataanform.statement1':
    'am responsible for the accuracy of the information declared in this document and for the validity of the supporting customs documents on which this document is based; and',
  'pernyataanform.statement2':
    'if I do not attend to witness the physical inspection within no later than 1 (one) day after the date of the goods-readiness notification, I authorise the TPS operator to witness it on my behalf, with the risks and costs being my responsibility.',
  'pernyataanform.signerInfo': 'Signatory Information',
  'pernyataanform.nama': 'Name',
  'pernyataanform.tanggal': 'Date',
  'pernyataanform.placeholderTanggal': 'date',
  'pernyataanform.tempat': 'Place',
  'pernyataanform.jabatan': 'Position',
  'pernyataanform.errorNamaTtd': 'Signatory name is required',
  'pernyataanform.errorTanggalTtd': 'Signing date is required',
  'pernyataanform.errorKotaTtd': 'Signing city is required',
  'pernyataanform.errorJabatanTtd': 'Signatory position is required',
  'pernyataanform.notifySuccessTitle': 'Success',
  'pernyataanform.notifySuccessMessage': 'Statement data synced successfully',
  'pernyataanform.notifyErrorTitle': 'Error',
  'pernyataanform.notifyErrorSyncMessage': 'Failed to sync Statement data',
  'pernyataanform.notifyErrorGeneralMessage': 'Error syncing Statement data',

  'subscription.trial.badge.active': 'Free trial',
  'subscription.trial.badge.ended': 'Trial ended',
  'subscription.trial.free': 'Free',
  'subscription.trial.endsOn': 'Trial ends',
  'subscription.trial.cost': 'Cost',
  'subscription.trial.running.title': 'Your free trial is running',
  'subscription.trial.running.daysLeft': '{n} days left.',
  'subscription.trial.running.endsToday': 'The trial ends today.',
  'subscription.trial.running.body': 'Once it ends, new submissions will be blocked until you subscribe.',
  'subscription.trial.running.cta': 'View subscription plans',
  'subscription.trial.header.daysLeft': 'Trial: {n} days left',
  'subscription.trial.header.endsToday': 'Trial: last day',
  'subscription.trial.header.ended': 'Trial ended',
  'subscription.trial.strip.soon': 'Your free trial ends in {n} days.',
  'subscription.trial.strip.today': 'Your free trial ends today.',
  'subscription.trial.strip.ended': 'Your free trial has ended.',
  'subscription.trial.strip.soonDetail': 'After that, new submissions are blocked until you subscribe.',
  'subscription.trial.strip.endedDetail': 'New submissions are blocked until you subscribe.',
  'subscription.trial.contactSales': 'Contact sales',
  'subscription.trial.contactSales.message':
    "Hi JARVIS Sales, our company's free trial is ending soon. I would like to subscribe to a JARVIS plan.",
  'subscription.trial.ended.title': 'Your free trial has ended',
  'subscription.trial.ended.body':
    'Your account is blocked from new submissions{since}. No invoice is due. Choose a subscription plan to continue the service. Remaining trial credits do not carry over to a paid plan.',
  'subscription.trial.ended.since': ' since {date}',
  'subscription.trial.ended.cta': 'Choose a subscription plan',
  'subscription.trial.picker.title': 'Continue with a paid plan',
  'subscription.trial.picker.subtitleRunning':
    "Your trial is still running. Subscribe now so the service isn't interrupted when the trial ends. Remaining trial credits do not carry over to a paid plan.",
  'subscription.trial.picker.subtitleEnded':
    'The trial has ended and your account is blocked. Choose a plan below to reactivate the service.',
  'subscription.invoice.trialBadge': 'Free trial',
  'subscription.invoice.free': 'Free',
  'subscription.page.title': 'Subscription',
  'subscription.page.subtitle': 'Manage your subscription plan and monthly invoices',
  'subscription.page.loadingSubscription': 'Loading subscription data...',
  'subscription.page.loadingPlans': 'Loading subscription plans...',
  'subscription.common.error': 'Something went wrong',
  'subscription.card.title': 'Subscription',
  'subscription.card.currentPeriod': 'Current period',
  'subscription.card.nextBilling': 'Next invoice',
  'subscription.card.pricePerMonth': 'Price per month',
  'subscription.card.quotaTitle': 'Monthly credit quota',
  'subscription.card.col.product': 'Product',
  'subscription.card.col.quotaPerPeriod': 'Quota per period',
  'subscription.card.col.used': 'Used',
  'subscription.card.col.balance': 'Current balance',
  'subscription.card.credits': 'credits',
  'subscription.card.usedOf': '{used}/{quota} used',
  'subscription.card.balanceError': 'Failed to load the credit balance',
  'subscription.card.override': 'Custom',
  'subscription.card.noQuota': 'This plan has no credit quota',
  'subscription.status.active': 'Active',
  'subscription.status.pending': 'Awaiting payment',
  'subscription.status.unpaid': 'Unpaid',
  'subscription.status.cancelled': 'Cancelled',
  'subscription.cancel.button': 'Cancel subscription',
  'subscription.cancel.confirm.title': 'Cancel subscription?',
  'subscription.cancel.confirm.body':
    'You can keep using your credits until {date}. Your card will not be charged again after the subscription ends.',
  'subscription.cancel.confirm.titleImmediate': 'Cancel subscription now?',
  'subscription.cancel.confirm.bodyImmediate':
    "This subscription is not active yet because the first invoice hasn't been paid, so it will be cancelled immediately. The invoice awaiting payment is cancelled too, nothing is charged and no credits are granted. You can subscribe again at any time.",
  'subscription.cancel.toast.periodEnd.title': 'Done',
  'subscription.cancel.toast.periodEnd.body':
    'The subscription will not be renewed. Credits can still be used until the end of the period.',
  'subscription.cancel.toast.immediate.title': 'Subscription cancelled',
  'subscription.cancel.toast.immediate.body': 'The invoice awaiting payment was cancelled. You were not charged.',
  'subscription.cancel.toast.error.title': 'Error',
  'subscription.cancel.toast.error.body': 'Failed to cancel the subscription. Please try again.',
  'subscription.cancel.confirm.back': 'Back',
  'subscription.cancel.confirm.confirm': 'Yes, cancel',
  'subscription.cancel.endsOn': 'Ends {date}',
  'subscription.cancel.cancelling.title': 'Auto-renewal stopped',
  'subscription.cancel.cancelling.body':
    'The subscription stays active until {date}. Your card will not be charged again. Resubscribe at any time.',
  'subscription.cancel.cancelling.cta': 'View plans',
  'subscription.cancel.picker.title': 'Resubscribe',
  'subscription.cancel.picker.subtitle': 'Choose a plan to continue the service.',
  'subscription.alert.unpaid.title': 'Account blocked - please make a payment',
  'subscription.alert.unpaid.body':
    'Your subscription is unpaid{since}. Your account is blocked until the invoice is settled. Please pay the outstanding invoice in the Invoices section below.',
  'subscription.alert.unpaid.since': ' since {date}',
  'subscription.alert.pending.title': 'Awaiting payment',
  'subscription.alert.pending.body':
    'Your subscription becomes active once the first invoice is paid. Please complete the payment in the Invoices section below.',
  'subscription.picker.title': 'Choose a subscription plan',
  'subscription.picker.subtitle': "You don't have a subscription yet. Choose a plan below to subscribe.",
  'subscription.picker.empty': 'No subscription plans are available right now.',
  'subscription.picker.perMonth': '/ month',
  'subscription.picker.periodDays': '{n}-day period',
  'subscription.picker.accountPrice': 'Special price for your account',
  'subscription.picker.includedCredits': 'Included credits:',
  'subscription.picker.creditLine': '{n} {product} credits',
  'subscription.picker.product': 'Product #{id}',
  'subscription.picker.subscribe': 'Subscribe',
  'subscription.invoices.title': 'Invoices',
  'subscription.invoices.col.type': 'Type',
  'subscription.invoices.col.period': 'Period',
  'subscription.invoices.col.amount': 'Amount',
  'subscription.invoices.col.status': 'Status',
  'subscription.invoices.col.action': 'Action',
  'subscription.invoices.type.initial': 'Initial invoice',
  'subscription.invoices.type.renewal': 'Renewal',
  'subscription.invoices.status.pending': 'Awaiting payment',
  'subscription.invoices.status.paid': 'Paid',
  'subscription.invoices.status.cancelled': 'Cancelled',
  'subscription.invoices.paidOn': 'Paid {date}',
  'subscription.invoices.priorAttempt': 'Earlier payment instructions exist',
  'subscription.invoices.continuePayment': 'Continue payment',
  'subscription.invoices.pay': 'Pay',
  'subscription.invoices.download': 'Download',
  'subscription.invoices.downloadError': 'Failed to download the invoice. Please try again.',
  'subscription.invoices.empty': 'No invoices yet.',
  'subscription.banner.unpaid.title': 'Subscription unpaid',
  'subscription.banner.unpaid.body': 'Your subscription is unpaid; the account is blocked from new submissions.',
  'subscription.banner.unpaid.cta': 'Pay now',
  'subscription.banner.trial.title': 'Trial period ended',
  'subscription.banner.trial.body': 'Your free trial has ended; the account is blocked from new submissions.',
  'subscription.banner.trial.cta': 'Choose a plan',
  'subscription.banner.pending.title': 'Invoice awaiting payment',
  'subscription.banner.pending.body': 'A subscription renewal invoice is awaiting payment.',
  'subscription.banner.pending.cta': 'Pay renewal',
  'subscription.pay.title': 'Payment for invoice #{id}',
  'subscription.pay.subtotal': 'Subtotal',
  'subscription.pay.fee': 'Payment service fee',
  'subscription.pay.feeNotice': 'The payment service fee is added on top of the subtotal and may differ by method.',
  'subscription.pay.total': 'Total payment:',
  'subscription.pay.method': 'Payment method',
  'subscription.pay.method.va': 'Virtual Account',
  'subscription.pay.method.qris': 'QRIS',
  'subscription.pay.method.card': 'Credit card',
  'subscription.pay.method.unknown': 'Unknown',
  'subscription.pay.prior.title': 'Earlier payment instructions available',
  'subscription.pay.prior.body':
    'You already started a payment with {method}{bank}. You can show those instructions again or create a new payment with another method.',
  'subscription.pay.prior.cta': 'Show earlier instructions',
  'subscription.pay.selectBank': 'Select bank',
  'subscription.pay.continue': 'Continue to payment',
  'subscription.pay.va.transferTo': 'Transfer to the Virtual Account number below:',
  'subscription.pay.va.note': 'After the transfer, the payment is processed automatically within 1-5 minutes.',
  'subscription.pay.copy': 'Copy',
  'subscription.pay.copied.title': 'Success',
  'subscription.pay.copied.body': 'Copied to clipboard',
  'subscription.pay.qris.title': 'Scan QRIS',
  'subscription.pay.qris.body': 'Scan the QR code below with your e-wallet app:',
  'subscription.pay.qris.unavailable': 'QR image not available',
  'subscription.pay.card.title': 'Credit card payment',
  'subscription.pay.card.open': 'Open payment page',
  'subscription.pay.card.unavailable': 'Payment link not available',
  'subscription.pay.waiting': 'Awaiting payment',
  'subscription.pay.polling': 'Status is checked automatically every 5 seconds',
  'subscription.pay.changeMethod': 'Change payment method',
  'subscription.pay.checkStatus': 'Check status',
  'subscription.pay.success.title': 'Payment successful',
  'subscription.pay.success.body': 'Your subscription invoice has been paid. Thank you!',
  'subscription.pay.success.notification': 'Your subscription invoice has been paid.',
  'subscription.pay.close': 'Close',

  'hsCodeInfo.title': 'HS Code Information',
  'hsCodeInfo.kodeHs': 'HS Code',
  'hsCodeInfo.tabTarif': 'Tariff Information',
  'hsCodeInfo.tabPreferensi': 'Preferential Tariffs',
  'hsCodeInfo.tabRegulasiImpor': 'Import Regulations',
  'hsCodeInfo.tabRegulasiEkspor': 'Export Regulations',
  'hsCodeInfo.lartasBorder': 'Import Regulations (Border Lartas)',
  'hsCodeInfo.tataNiagaPostBorder': 'Import Regulations (Post-Border Trade Rules)',
  'hsCodeInfo.regulasiImporUmum': 'Import Regulations (General)',
  'hsCodeInfo.lartasEkspor': 'Export Regulations (Export Lartas)',
  'hsCodeInfo.kolNamaIzin': 'Permit Name',
  'hsCodeInfo.kolKodeIzin': 'Permit Code',
  'hsCodeInfo.kolDeskripsi': 'Description',
  'hsCodeInfo.kolDasarHukum': 'Legal Basis',
  'hsCodeInfo.kolMasaBerlaku': 'Validity Period',
  'hsCodeInfo.kolKeterangan': 'Notes',
  'hsCodeInfo.kolDokumenPabean': 'Customs Document',
  'hsCodeInfo.kolUraianBarang': 'Goods Description',
  'hsCodeInfo.instansi': 'Agency',
  'hsCodeInfo.sekarang': 'Present',
  'hsCodeInfo.berlaku': 'In force',
  'hsCodeInfo.terbaru': 'Latest',
  'hsCodeInfo.legacy': 'Legacy',
  'hsCodeInfo.mfnTerbaru': 'Most Favored Nation (Latest)',
  'hsCodeInfo.mfn': 'Most Favored Nation',
  'hsCodeInfo.preferensiTerbaru': 'Preferential Tariff (Latest)',
  'hsCodeInfo.preferensi': 'Preferential Tariff',
  'hsCodeInfo.tarifPerTahun': 'Tariff by Year',
  'hsCodeInfo.lanjutan': 'Rate continues into the following years',
  'hsCodeInfo.sda': 'SDA (Natural Resources)',
  'hsCodeInfo.tidakDiaturLartasBorder': 'This HS code is not regulated under Border Lartas',
  'hsCodeInfo.tidakDiaturPostBorder': 'This HS code is not regulated under Post-Border Trade Rules',
  'hsCodeInfo.tidakDiaturImporUmum': 'This HS code is not regulated under General Import Regulations',
  'hsCodeInfo.tidakDiaturLartasEkspor': 'This HS code is not regulated under Export Lartas',
  'hsCodeInfo.regulasiBelumTersedia': 'No regulation data available for this code yet',
  'hsCodeInfo.tidakAdaTarif': 'No MFN tariff data available',
  'hsCodeInfo.tidakAdaPreferensi': 'No preferential tariff schemes for this code',
  'hsCodeInfo.tidakAdaData': 'No data for this HS code',
  'hsCodeInfo.tidakDitemukan': 'No data found for this HS code',
  'hsCodeInfo.kolNamaTarif': 'Tariff Name',
  'hsCodeInfo.kolTarif': 'Rate',
  'hsCodeInfo.kolRegulasi': 'Regulation',
  'hsCodeInfo.tabUmum': 'Goods Description',
  'hsCodeInfo.tabLainnya': 'Other Information',
  'hsCodeInfo.lartasYa': 'Lartas',
  'hsCodeInfo.lartasTidak': 'Non-Lartas',
  'hsCodeInfo.kodeNormal': 'Normalized Code',
  'hsCodeInfo.uraianId': 'Description (ID)',
  'hsCodeInfo.uraianEn': 'Description (EN)',
  'hsCodeInfo.tahunInsw': 'INSW Year',
  'hsCodeInfo.kodeSatuan': 'Unit Code',
  'hsCodeInfo.spesifikasi': 'Goods Specification',
  'hsCodeInfo.cariPreferensi': 'Search scheme or PMK number',
  'hsCodeInfo.dibandingMfn': 'Compared with MFN BM {rate}',
  'hsCodeInfo.hematBm': 'Save {n}% BM',
  'hsCodeInfo.tidakLebihMurah': 'Not cheaper than MFN',
  'hsCodeInfo.preferensiTidakCocok': 'No preferential scheme matches "{query}"',
  'hsCodeInfo.berlakuSeterusnya': 'In force indefinitely',
  'hsCodeInfo.kedaluwarsa': 'Expired',
  'hsCodeInfo.belumBerlaku': 'Not yet in force',
  'hsCodeInfo.bahasa': 'Indonesian',
  'hsCodeInfo.english': 'English',
  'hsCodeInfo.satuanBarang': 'Goods Unit',
  'hsCodeInfo.kolKodeSatuan': 'Unit Code',
  'hsCodeInfo.kolUraianSatuan': 'Unit Description',
  'hsCodeInfo.kolJenis': 'Type',
  'hsCodeInfo.gagalMuat': 'Could not load HS code details',

  // ---- Company stamp (Other services → Stamp) ----
  'stamp.upload.title': 'Upload your company stamp',
  'stamp.upload.subtitle': 'Everyone in your company uses this stamp when stamping documents.',
  'stamp.upload.drop': 'Drop the stamp image here or click to choose',
  'stamp.upload.formats': 'PNG or JPG, up to 2 MB',
  'stamp.upload.tip': 'Use a PNG with a transparent background so the document underneath stays visible',
  'stamp.upload.preview': 'Stamp preview',
  'stamp.upload.save': 'Save',
  'stamp.upload.cancel': 'Cancel',
  'stamp.upload.saved': 'Company stamp saved',
  'stamp.active.label': 'Company stamp',
  'stamp.active.uploadedBy': 'Uploaded by {email} · {date}',
  'stamp.replace.button': 'Replace stamp',
  'stamp.replace.title': 'Replace company stamp',
  'stamp.replace.note': 'The new stamp is used right away by everyone in your company.',
  'stamp.disabled.title': 'Your company stamp was disabled by the JARVIS team',
  'stamp.disabled.reason': 'Reason: {reason}',
  'stamp.disabled.body': "You can't stamp documents or upload a new stamp until the JARVIS team enables it again.",
  'stamp.disabled.contact': 'Contact support',
  'stamp.noPpjk.title': "Your account isn't linked to a PPJK yet",
  'stamp.noPpjk.body':
    'The company stamp is available once your account is linked to a PPJK. Contact your company admin.',
  'stamp.error.tooLarge': 'Maximum 2 MB',
  'stamp.error.type': 'PNG or JPG only',
  'stamp.error.invalidImage': "This stamp image can't be used",
  'stamp.error.impersonated': "The stamp can't be replaced during an impersonation; replace it from the CMS",
  'stamp.error.busy': 'The server is busy, try again in a moment',
  'stamp.error.generic': 'Something went wrong, try again',
  'stamp.error.load': "The company stamp couldn't be loaded",
  'stamp.error.retry': 'Try again',
  'stamp.viewer.hint': 'Click on the document to place the stamp, then drag it to move it.',
  'stamp.viewer.item': 'Stamp {n}',
  'stamp.viewer.remove': 'Remove',
  'stamp.viewer.x': 'X position',
  'stamp.viewer.y': 'Y position',
  'stamp.viewer.page': 'Page',
  'stamp.viewer.add': 'Add stamp',
  'stamp.viewer.reset': 'Reset positions',
  'stamp.viewer.download': 'Download stamped PDF',
  'stamp.viewer.downloadError': "Couldn't create the stamped PDF.",
  'stamp.viewer.newFile': 'Upload another file',

  // Bulk Update modal, "Nilai & Transaksi" section (next-jarvis#926).
  'bulkNilai.sectionTitle': 'Value & Transaction',
  'bulkNilai.sectionSubtitle': 'Tick "change" on the fields to replace; unticked fields are left as they are',
  'bulkNilai.ubah': 'CHANGE',
  'bulkNilai.spesifikasiLain': 'Other Specification',
  'bulkNilai.spesifikasiLainPlaceholder': 'e.g. BLACK, 220V',
  'bulkNilai.spesifikasiLainHint': 'Max {count} characters. Ticked but empty = other specification is cleared.',
  'bulkNilai.freeGoods': 'Free goods / samples (Metode 2 + CMA + Jenis Transaksi CMA)',
  'bulkNilai.freeGoodsHint': 'Same as ticking "Free of Charge Item" in the goods details, plus jenis transaksi CMA.',
  'bulkNilai.metode': 'Customs Valuation Method',
  'bulkNilai.metodePlaceholder': 'Choose a method',
  'bulkNilai.alasan': 'Reason',
  'bulkNilai.alasanPlaceholder': 'Choose a reason',
  'bulkNilai.alasanHint': 'Ticked but empty = reason is cleared.',
  'bulkNilai.alasanLocked': 'Metode 1 takes no reason, so the reason is cleared.',
  'bulkNilai.jenisTransaksi': 'Transaction Type',
  'bulkNilai.jenisTransaksiHelp': 'Replaces the transaction types on the selected goods',
  'bulkNilai.jenisTransaksiEmpty':
    'No rows yet. Applied like this, the transaction types on the selected goods are removed.',
  'bulkNilai.kodeJenisVd': 'Value Type',
  'bulkNilai.kodePlaceholder': 'Choose a transaction type',
  'bulkNilai.nilaiBarangVd': 'VD Value',
  'bulkNilai.addRow': 'Add Transaction Type',
  'bulkNilai.removeRow': 'Remove row',
  'bulkNilai.maxRows': 'At most {count} transaction types per line.',
  'bulkNilai.previewTitle': 'Change Preview',
  'bulkNilai.previewNone': 'No field ticked yet.',
  'bulkNilai.previewCount': '{count} lines',
  'bulkNilai.cleared': '(cleared)',
  'bulkNilai.summaryNone': 'Not changed.',
  'bulkNilai.err.noSeri': 'Fill in Seri Barang in section 1; these fields only apply to those lines.',
  'bulkNilai.err.spesifikasiTooLong': 'Other Specification takes at most {count} characters.',
  'bulkNilai.err.metodeRequired': 'Choose a valuation method.',
  'bulkNilai.err.metodeInvalid': 'Unknown valuation method.',
  'bulkNilai.err.alasanInvalid': 'Unknown reason.',
  'bulkNilai.err.tooManyRows': 'At most {count} transaction types per line.',
  'bulkNilai.err.kodeRequired': 'Choose a transaction type.',
  'bulkNilai.err.kodeInvalid': 'Unknown transaction type code.',
  'bulkNilai.err.kodeDuplicate': 'This transaction type is already in the list.',
  'bulkNilai.err.nilaiInvalid': 'VD value must be a number of 0 or more.',
  'bulkNilai.err.server': 'The server rejected this value.',
  'bulkNilai.err.checkTitle': 'Changes not applied',
  'bulkNilai.err.checkBody': 'Check the fields marked red in the Value & Transaction section.',
  'bulkNilai.err.rejectedBody':
    'The server rejected part of the input; nothing was changed. Check the fields marked red.',
};

export const TRANSLATIONS: Record<LanguageCode, TranslationDict> = { id, en, zh };

export const DEFAULT_LANGUAGE: LanguageCode = 'id';
